/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

export interface MainStemAPIPlatformControllersGlobalNotesCreateAPIRequest {
  content?: string
  context?: string
  /** @format int32 */
  documentID?: number
  documentType?: string
  isPrivate?: boolean
}

export interface MainStemAPIPlatformControllersGlobalNotesCreateAPIResponse {
  /** @format int32 */
  id?: number
  message?: string
  wasSuccessful?: boolean
}

export interface MainStemAPIPlatformControllersGlobalNotesDeleteAPIRequest {
  /** @format int32 */
  id?: number
}

export interface MainStemSDKModelsBaseResponse {
  message?: string
  wasSuccessful?: boolean
}

export interface MainStemAPIPlatformControllersGlobalNotesListAPIRequest {
  allowPrivate?: boolean
  /** @format int32 */
  documentID?: number
  documentType?: string
}

export interface MainStemAPIPlatformControllersGlobalNotesListAPIResponse {
  notes?: MainStemAPIPlatformControllersGlobalNotesListNoteDetail[]
  message?: string
  wasSuccessful?: boolean
}

export interface MainStemAPIPlatformControllersGlobalNotesListNoteDetail {
  content?: string
  context?: string
  createdBy?: MainStemSDKModelsUsersUserDetails
  /** @format date-time */
  dateCreated?: string
  /** @format int32 */
  id?: number
  isPrivate?: boolean
  isStarred?: boolean
  isDeleted?: boolean
}

export interface MainStemSDKModelsUsersUserDetails {
  id?: string
  userName?: string
  name?: string
  email?: string
}

export interface MainStemAPIPlatformControllersGlobalNotesUpdateAPIRequest {
  content?: string
  context?: string
  /** @format int32 */
  id?: number
  isPrivate?: boolean
  isStarred?: boolean
}

export interface MainStemAPIPlatformControllersPurchasingAccountDetailsAPIResponse {
  allowRequisitionBillToAddressChange: boolean
  filePDFLogoURL: string
  headerInformation: string
  logoHistory: MainStemAPIPlatformControllersPurchasingAccountDetailsAPIResponseFileDetail[]
  logoURL: string
  pdfLogoHistory: MainStemAPIPlatformControllersPurchasingAccountDetailsAPIResponseFileDetail[]
  privateSupplierNewOrderEmailNotificationCC: string
  privateSupplierNewOrderEmailNotificationTemplate: string
  rfqRequiresApproval: boolean
  termsAndConditions: string
  titleInvoice: string
  titlePurchaseOrder: string
  titleRequisition: string
  message?: string
  wasSuccessful?: boolean
}

export interface MainStemAPIPlatformControllersPurchasingAccountDetailsAPIResponseFileDetail {
  createdBy?: string
  /** @format date-time */
  dateCreated?: string
  /** @format int32 */
  id?: number
  logoURL?: string
}

export interface MainStemAPIPlatformControllersPurchasingAccountingInvoicesDueAPIResponse {
  invoices: MainStemAPIPlatformControllersPurchasingAccountingInvoicesDueAPIResponseInvoiceDetails[]
  message?: string
  wasSuccessful?: boolean
}

export interface MainStemAPIPlatformControllersPurchasingAccountingInvoicesDueAPIResponseInvoiceDetails {
  /** @format double */
  amountDue: number
  approval: MainStemAPIPlatformControllersPurchasingAccountingInvoicesDueAPIResponseInvoiceDetailsApprovalDetails
  /** @format date-time */
  dateDue: string
  /** @format date-time */
  dateInvoiced: string
  /** @format int32 */
  id: number
  location: MainStemAPIPlatformControllersPurchasingAccountingInvoicesDueAPIResponseInvoiceDetailsLocationDetails
  requisition: MainStemAPIPlatformControllersPurchasingAccountingInvoicesDueAPIResponseInvoiceDetailsRequisitionDetails
  supplier: MainStemAPIPlatformControllersPurchasingAccountingInvoicesDueAPIResponseInvoiceDetailsSupplierDetails
}

export interface MainStemAPIPlatformControllersPurchasingAccountingInvoicesDueAPIResponseInvoiceDetailsApprovalDetails {
  /** @format date-time */
  dateApproved: string
  userApprovedBy: string
}

export interface MainStemAPIPlatformControllersPurchasingAccountingInvoicesDueAPIResponseInvoiceDetailsLocationDetails {
  /** @format int32 */
  id: number
  name: string
}

export interface MainStemAPIPlatformControllersPurchasingAccountingInvoicesDueAPIResponseInvoiceDetailsRequisitionDetails {
  /** @format int32 */
  id: number
  /**
   * @format uuid
   * @example "00000000-0000-0000-0000-000000000000"
   */
  uuid: string
}

export interface MainStemAPIPlatformControllersPurchasingAccountingInvoicesDueAPIResponseInvoiceDetailsSupplierDetails {
  /** @format int32 */
  id: number
  name: string
}

export interface MainStemAPIPlatformControllersPurchasingAccountProfileAppearanceAPIRequest {
  theme?: string
  borders?: string
  spacing?: string
  fontSize?: string
}

export interface MainStemAPIPlatformControllersPurchasingAccountProfileAppearanceAPIResponse {
  message?: string
  wasSuccessful?: boolean
}

export interface MainStemAPIPlatformControllersPurchasingAccountProfileDetailsAPIResponse {
  user: MainStemAPIPlatformControllersPurchasingAccountProfileDetailsAPIResponseUserDetails
  secondaryLocations: MainStemAPIPlatformControllersPurchasingAccountProfileDetailsAPIResponseLocationDetails[]
  requisitions: MainStemAPIPlatformControllersPurchasingAccountProfileDetailsAPIResponseRequisitionDetails[]
  approvals: MainStemAPIPlatformControllersPurchasingAccountProfileDetailsAPIResponseApprovalDetails[]
  rfqs: MainStemAPIPlatformControllersPurchasingAccountProfileDetailsAPIResponseRFQDetails[]
  catalogs: MainStemAPIPlatformControllersPurchasingAccountProfileDetailsAPIResponseCatalogDetails[]
  permissions: MainStemAPIPlatformControllersPurchasingAccountProfileDetailsAPIResponsePermissionDetails[]
  message?: string
  wasSuccessful?: boolean
}

export interface MainStemAPIPlatformControllersPurchasingAccountProfileDetailsAPIResponseUserDetails {
  id: string
  name?: string
  /** @format date-time */
  dateCreated?: string
  profileImageURL?: string
  theme?: string
  borders?: string
  spacing?: string
  fontSize?: string
  primaryLocation: MainStemAPIPlatformControllersPurchasingAccountProfileDetailsAPIResponseLocationDetails
}

export interface MainStemAPIPlatformControllersPurchasingAccountProfileDetailsAPIResponseLocationDetails {
  /** @format int32 */
  id: number
  name?: string
  /** @format date-time */
  dateCreated: string
}

export interface MainStemAPIPlatformControllersPurchasingAccountProfileDetailsAPIResponseRequisitionDetails {
  /** @format int32 */
  id: number
  name?: string
  /** @format date-time */
  dateCreated: string
  uuid: string
}

export interface MainStemAPIPlatformControllersPurchasingAccountProfileDetailsAPIResponseApprovalDetails {
  /** @format int32 */
  id: number
  name?: string
  /** @format date-time */
  dateCreated: string
  uuid: string
}

export interface MainStemAPIPlatformControllersPurchasingAccountProfileDetailsAPIResponseRFQDetails {
  /** @format int32 */
  id: number
  name?: string
  /** @format date-time */
  dateCreated: string
}

export interface MainStemAPIPlatformControllersPurchasingAccountProfileDetailsAPIResponseCatalogDetails {
  /** @format int32 */
  id: number
  name?: string
}

export interface MainStemAPIPlatformControllersPurchasingAccountProfileDetailsAPIResponsePermissionDetails {
  /** @format int32 */
  id: number
  name?: string
  isActive: boolean
}

export interface MainStemAPIPlatformControllersPurchasingAccountProfileImageUploadAPIResponse {
  profileImageURL?: string
  message?: string
  wasSuccessful?: boolean
}

export interface MainStemAPIPlatformControllersPurchasingAccountProfilePasswordAPIRequest {
  password: string
}

export interface MainStemAPIPlatformControllersPurchasingAccountProfilePasswordAPIResponse {
  message?: string
  wasSuccessful?: boolean
}

export interface MainStemAPIPlatformControllersPurchasingAccountProfileUpdateAPIRequest {
  name: string
}

export interface MainStemAPIPlatformControllersPurchasingAccountProfileUpdateAPIResponse {
  message?: string
  wasSuccessful?: boolean
}

export interface MainStemAPIPlatformControllersPurchasingAccountUpdateAPIRequest {
  allowRequisitionBillToAddressChange: boolean
  headerInformation: string
  privateSupplierNewOrderEmailNotificationCC: string
  privateSupplierNewOrderEmailNotificationTemplate: string
  rfqRequiresApproval: boolean
  termsAndConditions: string
  titleInvoice: string
  titlePurchaseOrder: string
  titleRequisition: string
}

export interface MainStemAPIPlatformControllersPurchasingAccountUpdateAPIResponse {
  message?: string
  wasSuccessful?: boolean
}

export interface MainStemAPIPlatformControllersPurchasingAddressAutoCompleteAPIRequest {
  query: string
}

export interface MainStemAPIPlatformControllersPurchasingAddressAutoCompleteAPIResponse {
  addresses: MainStemAPIPlatformControllersPurchasingAddressAutoCompleteAPIResponseAddressDetails[]
  message?: string
  wasSuccessful?: boolean
}

export interface MainStemAPIPlatformControllersPurchasingAddressAutoCompleteAPIResponseAddressDetails {
  address1: string
  address2: string
  city: string
  state: string
  zip: string
  country: string
}

export interface MainStemAPIPlatformControllersPurchasingAddressSuggestAPIRequest {
  query: string
}

export interface MainStemAPIPlatformControllersPurchasingAddressSuggestAPIResponse {
  addresses: MainStemAPIPlatformControllersPurchasingAddressSuggestAPIResponseAddressDetails[]
  message?: string
  wasSuccessful?: boolean
}

export interface MainStemAPIPlatformControllersPurchasingAddressSuggestAPIResponseAddressDetails {
  address1: string
  address2: string
  city: string
  state: string
  zip: string
  country: string
}

export interface MainStemAPIPlatformControllersPurchasingAddressValidateAPIRequest {
  address: MainStemAPIPlatformControllersPurchasingAddressValidateAPIRequestAddressDetails
}

export interface MainStemAPIPlatformControllersPurchasingAddressValidateAPIRequestAddressDetails {
  address1: string
  address2: string
  city: string
  country: string
  state: string
  zip: string
}

export interface MainStemAPIPlatformControllersPurchasingAddressValidateAPIResponse {
  address?: MainStemAPIPlatformControllersPurchasingAddressValidateAPIResponseAddressDetails
  message?: string
  wasSuccessful?: boolean
}

export interface MainStemAPIPlatformControllersPurchasingAddressValidateAPIResponseAddressDetails {
  address1: string
  address2: string
  city: string
  country: string
  state: string
  zip: string
}

export interface MainStemAPIPlatformControllersPurchasingAIChatAPIRequest {
  message: string
}

export interface MainStemAPIPlatformControllersPurchasingAIChatAPIResponse {
  response: string
  message?: string
  wasSuccessful?: boolean
}

export interface MainStemAPIPlatformControllersPurchasingAIScrapeAPIRequest {
  url: string
}

export interface MainStemAPIPlatformControllersPurchasingAIScrapeAPIResponse {
  product: MainStemAPIPlatformControllersPurchasingAIScrapeAPIResponseProductDetails
  message?: string
  wasSuccessful?: boolean
}

export interface MainStemAPIPlatformControllersPurchasingAIScrapeAPIResponseProductDetails {
  imageURL?: string
  name?: string
  /** @format double */
  price?: number
  sku?: string
}

export interface MainStemAPIPlatformControllersPurchasingLocationsApprovalWorkflowAllowableUsersAPIRequest {
  /** @format int32 */
  id?: number
}

export interface MainStemAPIPlatformControllersPurchasingLocationsApprovalWorkflowAllowableUsersAPIResponse {
  users?: MainStemAPIPlatformControllersPurchasingLocationsApprovalWorkflowAllowableUsersUserDetails[]
  message?: string
  wasSuccessful?: boolean
}

export interface MainStemAPIPlatformControllersPurchasingLocationsApprovalWorkflowAllowableUsersUserDetails {
  id?: string
  userName?: string
}

export interface MainStemAPIPlatformControllersPurchasingLocationsApprovalWorkflowListAPIRequest {
  /** @format int32 */
  id?: number
}

export interface MainStemAPIPlatformControllersPurchasingLocationsApprovalWorkflowListAPIResponse {
  rulesetType?: 'Tier' | 'Workflow'
  steps?: MainStemAPIPlatformControllersPurchasingLocationsApprovalWorkflowListWorkflowStep[]
  superApprovers?: MainStemAPIPlatformControllersPurchasingLocationsApprovalWorkflowListUserDetails[]
  message?: string
  wasSuccessful?: boolean
}

export interface MainStemAPIPlatformControllersPurchasingLocationsApprovalWorkflowListWorkflowStep {
  /** @format int32 */
  id?: number
  /** @format double */
  maxAmount?: number
  maxAmountMessage?: string
  maxAmountValid?: boolean
  /** @format double */
  minAmount?: number
  minAmountMessage?: string
  minAmountValid?: boolean
  /** @format int32 */
  numberOfRequiredApprovers?: number
  /** @format int32 */
  rank?: number
  stepValid?: boolean
  title?: string
  users?: MainStemAPIPlatformControllersPurchasingLocationsApprovalWorkflowListUserDetails[]
  usersMessage?: string
  usersValid?: boolean
  validationMessage?: string
}

export interface MainStemAPIPlatformControllersPurchasingLocationsApprovalWorkflowListUserDetails {
  id?: string
  userName?: string
}

export interface MainStemAPIPlatformControllersPurchasingLocationsApprovalWorkflowSaveAPIRequest {
  /** @format int32 */
  locationId?: number
  rulesetType?: string
  steps?: MainStemAPIPlatformControllersPurchasingLocationsApprovalWorkflowListWorkflowStep[]
}

export interface MainStemAPIPlatformControllersPurchasingLocationsApprovalWorkflowValidateAPIRequest {
  /** @format int32 */
  locationId?: number
  steps?: MainStemAPIPlatformControllersPurchasingLocationsApprovalWorkflowListWorkflowStep[]
}

export interface MainStemAPIPlatformControllersPurchasingAuthCurrentUserAPIResponse {
  allowBeta: boolean
  accountSize: 'Fish' | 'Dolphin' | 'SmallWhale' | 'BigWhale'
  appURL: string
  allowPurchasingApp: boolean
  /** @format int32 */
  defaultCatalogID: number
  defaultLocation: MainStemAPIPlatformControllersPurchasingAuthCurrentUserAPIResponseDefaultLocationDetails
  friendlyName: string
  /** @format date-time */
  goLiveDate: string
  groupPermissions: MainStemAPIPlatformControllersPurchasingAuthCurrentUserAPIResponsePermissionDetails[]
  organization: MainStemAPIPlatformControllersPurchasingAuthCurrentUserAPIResponseOrganizationDetails
  permissionGroup: MainStemAPIPlatformControllersPurchasingAuthCurrentUserAPIResponsePermissionGroupDetail
  permissions: MainStemAPIPlatformControllersPurchasingAuthCurrentUserAPIResponsePermissionDetails[]
  programType: 'Archived' | 'PurchaseProPaid' | 'PurchaseProFree'
  profileImageURL?: string
  courierJWT?: string
  theme?: string
  borders?: string
  spacing?: string
  fontSize?: string
  username: string
  userPermissions: MainStemAPIPlatformControllersPurchasingAuthCurrentUserAPIResponsePermissionDetails[]
  uuid: string
  message?: string
  wasSuccessful?: boolean
}

export interface MainStemAPIPlatformControllersPurchasingAuthCurrentUserAPIResponseDefaultLocationDetails {
  defaultAddressShipTo: MainStemAPIPlatformControllersPurchasingAuthCurrentUserAPIResponseDefaultLocationDetailsAddressDetails
  /** @format int32 */
  id: number
  name: string
}

export interface MainStemAPIPlatformControllersPurchasingAuthCurrentUserAPIResponsePermissionDetails {
  group: string
  shortCode: string
  value: string
}

export interface MainStemAPIPlatformControllersPurchasingAuthCurrentUserAPIResponseOrganizationDetails {
  allowCannabis: boolean
  allowPunchOutInMainNav: boolean
  allowRequisitionBillToAddressChange: boolean
  /** @format double */
  available: number
  /** @format double */
  balance: number
  /** @format double */
  due: number
  /** @format int32 */
  id: number
  integrations: MainStemAPIPlatformControllersPurchasingAuthCurrentUserAPIResponseOrganizationDetailsIntegrationDetails
  /** @format double */
  limit: number
  logoURL: string
  name: string
  rfqRequiresApproval: boolean
  uuid: string
}

export interface MainStemAPIPlatformControllersPurchasingAuthCurrentUserAPIResponsePermissionGroupDetail {
  /** @format int32 */
  id: number
  name: string
}

export interface MainStemAPIPlatformControllersPurchasingAuthCurrentUserAPIResponseDefaultLocationDetailsAddressDetails {
  address1: string
  address2: string
  city: string
  state: string
  zip: string
  country: string
}

export interface MainStemAPIPlatformControllersPurchasingAuthCurrentUserAPIResponseOrganizationDetailsIntegrationDetails {
  dynamics: boolean
  powerBI: boolean
  quantumLeaf: boolean
  quickbooks: boolean
}

export interface MainStemAPIPlatformHelpersAuthorizationRequest {
  password?: string
  username?: string
}

export interface MainStemAPIPlatformHelpersAuthorizationResponse {
  appType?: string
  appURL?: string
  name?: string
  urlLogo?: string
  error?: string
  token?: string
  role?: string
  message?: string
  wasSuccessful?: boolean
}

export interface MainStemAPIPlatformControllersPurchasingAuthPassswordResetProcessAPIRequest {
  password?: string
  userID?: string
}

export interface MainStemAPIPlatformControllersPurchasingAuthPassswordResetProcessAPIResponse {
  errorMessage?: string
  username?: string
  message?: string
  wasSuccessful?: boolean
}

export interface MainStemAPIPlatformControllersPurchasingAuthPassswordResetRequestAPIRequest {
  username?: string
}

export interface MainStemAPIPlatformControllersPurchasingAuthPassswordResetValidateAPIRequest {
  userID?: string
}

export interface MainStemAPIPlatformControllersPurchasingAuthPassswordResetValidateAPIResponse {
  errorMessage?: string
  message?: string
  wasSuccessful?: boolean
}

export interface MainStemAPIPlatformControllersPurchasingBulkOrderApprovalUserCreateAPIRequest {
  id: string
}

export interface MainStemAPIPlatformControllersPurchasingBulkOrderApprovalUserCreateAPIResponse {
  message?: string
  wasSuccessful?: boolean
}

export interface MainStemAPIPlatformControllersPurchasingBulkOrderApprovalUserDeleteAPIRequest {
  id: string
}

export interface MainStemAPIPlatformControllersPurchasingBulkOrderApprovalUserDeleteAPIResponse {
  message?: string
  wasSuccessful?: boolean
}

export interface MainStemAPIPlatformControllersPurchasingBulkOrderApprovalUserListAPIResponse {
  users: MainStemAPIPlatformControllersPurchasingBulkOrderApprovalUserListAPIResponseUserDetails[]
  message?: string
  wasSuccessful?: boolean
}

export interface MainStemAPIPlatformControllersPurchasingBulkOrderApprovalUserListAPIResponseUserDetails {
  id: string
  username: string
}

export type MainStemAPIPlatformControllersPurchasingBulkOrderCreateAPIRequest = object

export interface MainStemAPIPlatformControllersPurchasingBulkOrderCreateAPIResponse {
  /** @format int32 */
  id: number
  message?: string
  wasSuccessful?: boolean
}

export interface MainStemAPIPlatformControllersPurchasingBulkOrderDetailsAPIRequest {
  /** @format int32 */
  id: number
}

export interface MainStemAPIPlatformControllersPurchasingBulkOrderDetailsAPIResponse {
  bulkOrder: MainStemAPIPlatformControllersPurchasingBulkOrderDetailsAPIResponseBulkOrderDetails
  message?: string
  wasSuccessful?: boolean
}

export interface MainStemAPIPlatformControllersPurchasingBulkOrderDetailsAPIResponseBulkOrderDetails {
  /** @format int32 */
  id: number
  /** @format date-time */
  dateCompleted?: string
  /** @format date-time */
  dateCreated: string
  status: 'Pending' | 'Released'
  userCreatedBy: MainStemAPIPlatformControllersPurchasingBulkOrderDetailsAPIResponseBulkOrderDetailsUserDetails
  uploads: MainStemAPIPlatformControllersPurchasingBulkOrderDetailsAPIResponseBulkOrderDetailsUploadDetails[]
  requisitions: MainStemAPIPlatformControllersPurchasingBulkOrderDetailsAPIResponseBulkOrderDetailsRequisitionDetails[]
  createdRequisitions: MainStemAPIPlatformControllersPurchasingOrdersListAPIResponseOrderDetails[]
}

export interface MainStemAPIPlatformControllersPurchasingBulkOrderDetailsAPIResponseBulkOrderDetailsUserDetails {
  id?: string
  username?: string
}

export interface MainStemAPIPlatformControllersPurchasingBulkOrderDetailsAPIResponseBulkOrderDetailsUploadDetails {
  /** @format int32 */
  id: number
  /** @format date-time */
  dateCompleted?: string
  /** @format date-time */
  dateCreated: string
  /** @format int32 */
  countRows: number
  /** @format int32 */
  countOrders: number
  /** @format int32 */
  countProducts: number
  /** @format int32 */
  countSuppliers: number
  status: 'Pending' | 'InProgress' | 'Completed' | 'Failed'
  fileUploaded?: MainStemAPIPlatformControllersPurchasingBulkOrderDetailsAPIResponseBulkOrderDetailsFileDetails
  fileResponse?: MainStemAPIPlatformControllersPurchasingBulkOrderDetailsAPIResponseBulkOrderDetailsFileDetails
}

export interface MainStemAPIPlatformControllersPurchasingBulkOrderDetailsAPIResponseBulkOrderDetailsRequisitionDetails {
  /** @format int32 */
  id: number
  location: MainStemAPIPlatformControllersPurchasingBulkOrderDetailsAPIResponseBulkOrderDetailsLocationDetails
  name?: string
  purchaseOrders: MainStemAPIPlatformControllersPurchasingBulkOrderDetailsAPIResponseBulkOrderDetailsPurchaseOrderDetails[]
}

export interface MainStemAPIPlatformControllersPurchasingOrdersListAPIResponseOrderDetails {
  approvalStatus?: 'SavedCart' | 'AwaitingApproval' | 'Approval' | 'ApprovalWithEdits' | 'Rejected'
  /** @format date-time */
  dateApproved?: string
  /** @format date-time */
  dateCreated?: string
  /** @format double */
  discount?: number
  /** @format int32 */
  id?: number
  isPrivateOrder?: boolean
  location?: MainStemAPIPlatformControllersPurchasingOrdersListAPIResponseOrderDetailsLocationDetails
  make?: string
  /** @format double */
  orderTotal?: number
  paymentStatus?: string
  /** @format double */
  salesTax?: number
  /** @format double */
  shipping?: number
  status?: string
  /** @format double */
  subTotal?: number
  suppliers?: MainStemAPIPlatformControllersPurchasingOrdersListAPIResponseOrderDetailsSupplierDetails[]
  userApprovedBy?: string
  userCreatedBy?: string
  userRelated?: boolean
  uuid?: string
}

export interface MainStemAPIPlatformControllersPurchasingBulkOrderDetailsAPIResponseBulkOrderDetailsFileDetails {
  fileName: string
  url: string
}

export interface MainStemAPIPlatformControllersPurchasingBulkOrderDetailsAPIResponseBulkOrderDetailsLocationDetails {
  origin: 'Existing' | 'New' | 'Created'
  /** @format int32 */
  id: number
  name?: string
  logoURL?: string
  address1?: string
  address2?: string
  city?: string
  state?: string
  zip?: string
  country?: string
  isCustomer: boolean
  isSupplier: boolean
}

export interface MainStemAPIPlatformControllersPurchasingBulkOrderDetailsAPIResponseBulkOrderDetailsPurchaseOrderDetails {
  /** @format int32 */
  id: number
  supplier: MainStemAPIPlatformControllersPurchasingBulkOrderDetailsAPIResponseBulkOrderDetailsSupplierDetails
  terms?: string
  lineItems: MainStemAPIPlatformControllersPurchasingBulkOrderDetailsAPIResponseBulkOrderDetailsLineItemDetails[]
}

export interface MainStemAPIPlatformControllersPurchasingOrdersListAPIResponseOrderDetailsLocationDetails {
  address1?: string
  address2?: string
  city?: string
  country?: string
  /** @format int32 */
  id?: number
  name?: string
  state?: string
  zip?: string
}

export interface MainStemAPIPlatformControllersPurchasingOrdersListAPIResponseOrderDetailsSupplierDetails {
  /** @format int32 */
  id?: number
  name?: string
}

export interface MainStemAPIPlatformControllersPurchasingBulkOrderDetailsAPIResponseBulkOrderDetailsSupplierDetails {
  origin: 'Existing' | 'New' | 'Created'
  /** @format int32 */
  id?: number
  name?: string
  email?: string
  logoURL?: string
  city?: string
  state?: string
  country?: string
  isPrivateSupplier: boolean
}

export interface MainStemAPIPlatformControllersPurchasingBulkOrderDetailsAPIResponseBulkOrderDetailsLineItemDetails {
  /** @format int32 */
  id: number
  product: MainStemAPIPlatformControllersPurchasingBulkOrderDetailsAPIResponseBulkOrderDetailsProductDetails
  /** @format double */
  quantity: number
  /** @format double */
  pricePerUnit: number
}

export interface MainStemAPIPlatformControllersPurchasingBulkOrderDetailsAPIResponseBulkOrderDetailsProductDetails {
  origin: 'Existing' | 'New' | 'Created'
  /** @format int32 */
  id?: number
  name?: string
  category?: string
  description?: string
  imageURL?: string
  skuInternal?: string
  skuManufacturer?: string
  unitOfMeasureLabel?: string
  unitOfMeasureValue?: string
}

export interface MainStemAPIPlatformControllersPurchasingBulkOrderDetails3WayMatchAPIRequest {
  /** @format int32 */
  id: number
}

export interface MainStemAPIPlatformControllersPurchasingBulkOrderDetails3WayMatchAPIResponse {
  summary: MainStemAPIPlatformControllersPurchasingBulkOrderDetails3WayMatchAPIResponseThreeWayMatchSummary
  lineItems: MainStemAPIPlatformControllersPurchasingBulkOrderDetails3WayMatchAPIResponseThreeWayMatchLineItem[]
  message?: string
  wasSuccessful?: boolean
}

export interface MainStemAPIPlatformControllersPurchasingBulkOrderDetails3WayMatchAPIResponseThreeWayMatchSummary {
  /** @format int32 */
  lineItemCount: number
  /** @format int32 */
  exceptionCount: number
  /** @format double */
  totalOrdered: number
  /** @format double */
  totalInvoiced: number
  /** @format double */
  totalReceived: number
}

export interface MainStemAPIPlatformControllersPurchasingBulkOrderDetails3WayMatchAPIResponseThreeWayMatchLineItem {
  /** @format int32 */
  id: number
  /** @format int32 */
  requisitionId: number
  requisitionName?: string
  /** @format int32 */
  productId?: number
  name?: string
  sku?: string
  /** @format double */
  qtyOrdered: number
  /** @format double */
  qtyInvoiced: number
  /** @format double */
  qtyReceived: number
  /** @format double */
  unitPriceOrdered: number
  /** @format double */
  unitPriceInvoiced: number
  status: 'Matched' | 'Exception'
}

export interface MainStemAPIPlatformControllersPurchasingBulkOrderListAPIResponse {
  bulkOrders: MainStemAPIPlatformControllersPurchasingBulkOrderListAPIResponseBulkOrderDetails[]
  message?: string
  wasSuccessful?: boolean
}

export interface MainStemAPIPlatformControllersPurchasingBulkOrderListAPIResponseBulkOrderDetails {
  /** @format int32 */
  id: number
  /** @format int32 */
  countUploads: number
  /** @format int32 */
  countRequisitions: number
  /** @format date-time */
  dateCompleted?: string
  /** @format date-time */
  dateCreated: string
  status: 'Pending' | 'Released'
}

export interface MainStemAPIPlatformControllersPurchasingBulkOrderReleaseAPIRequest {
  /** @format int32 */
  id: number
}

export interface MainStemAPIPlatformControllersPurchasingBulkOrderReleaseAPIResponse {
  message?: string
  wasSuccessful?: boolean
}

export interface MainStemAPIPlatformControllersPurchasingBulkOrderRequisitionClearAPIRequest {
  /** @format int32 */
  id: number
}

export interface MainStemAPIPlatformControllersPurchasingBulkOrderRequisitionClearAPIResponse {
  message?: string
  wasSuccessful?: boolean
}

export interface MainStemAPIPlatformControllersPurchasingBulkOrderRequisitionCreateAPIRequest {
  /** @format int32 */
  bulkOrderId: number
  /** @format int32 */
  customerLocationId: number
  name?: string
}

export interface MainStemAPIPlatformControllersPurchasingBulkOrderRequisitionCreateAPIResponse {
  /** @format int32 */
  id: number
  message?: string
  wasSuccessful?: boolean
}

export interface MainStemAPIPlatformControllersPurchasingBulkOrderRequisitionDeleteAPIRequest {
  /** @format int32 */
  id: number
}

export interface MainStemAPIPlatformControllersPurchasingBulkOrderRequisitionDeleteAPIResponse {
  message?: string
  wasSuccessful?: boolean
}

export interface MainStemAPIPlatformControllersPurchasingBulkOrderRequisitionPurchaseOrderCreateAPIRequest {
  /** @format int32 */
  bulkOrderRequisitionId: number
  /** @format int32 */
  supplierId?: number
  supplierName?: string
  supplierEmail?: string
  terms?: string
}

export interface MainStemAPIPlatformControllersPurchasingBulkOrderRequisitionPurchaseOrderCreateAPIResponse {
  /** @format int32 */
  id: number
  message?: string
  wasSuccessful?: boolean
}

export interface MainStemAPIPlatformControllersPurchasingBulkOrderRequisitionPurchaseOrderDeleteAPIRequest {
  /** @format int32 */
  id: number
}

export interface MainStemAPIPlatformControllersPurchasingBulkOrderRequisitionPurchaseOrderDeleteAPIResponse {
  message?: string
  wasSuccessful?: boolean
}

export interface MainStemAPIPlatformControllersPurchasingBulkOrderRequisitionPurchaseOrderLineItemCreateAPIRequest {
  /** @format int32 */
  bulkOrderPurchaseOrderId: number
  /** @format double */
  pricePerUnit: number
  /** @format int32 */
  productId?: number
  productCategory?: string
  productDescription?: string
  productName?: string
  /** @format double */
  quantity: number
}

export interface MainStemAPIPlatformControllersPurchasingBulkOrderRequisitionPurchaseOrderLineItemCreateAPIResponse {
  /** @format int32 */
  id: number
  message?: string
  wasSuccessful?: boolean
}

export interface MainStemAPIPlatformControllersPurchasingBulkOrderRequisitionPurchaseOrderLineItemDeleteAPIRequest {
  /** @format int32 */
  id: number
}

export interface MainStemAPIPlatformControllersPurchasingBulkOrderRequisitionPurchaseOrderLineItemDeleteAPIResponse {
  message?: string
  wasSuccessful?: boolean
}

export interface MainStemAPIPlatformControllersPurchasingBulkOrderRequisitionPurchaseOrderLineItemUpdateAPIRequest {
  /** @format int32 */
  id: number
  /** @format double */
  pricePerUnit: number
  /** @format int32 */
  productId?: number
  productCategory?: string
  productDescription?: string
  productName?: string
  /** @format double */
  quantity: number
}

export interface MainStemAPIPlatformControllersPurchasingBulkOrderRequisitionPurchaseOrderLineItemUpdateAPIResponse {
  message?: string
  wasSuccessful?: boolean
}

export interface MainStemAPIPlatformControllersPurchasingBulkOrderRequisitionPurchaseOrderUpdateAPIRequest {
  /** @format int32 */
  id: number
  /** @format int32 */
  supplierId?: number
  supplierName?: string
  supplierEmail?: string
  terms?: string
}

export interface MainStemAPIPlatformControllersPurchasingBulkOrderRequisitionPurchaseOrderUpdateAPIResponse {
  message?: string
  wasSuccessful?: boolean
}

export interface MainStemAPIPlatformControllersPurchasingBulkOrderRequisitionUpdateAPIRequest {
  /** @format int32 */
  id: number
  /** @format int32 */
  customerLocationId: number
  name?: string
}

export interface MainStemAPIPlatformControllersPurchasingBulkOrderRequisitionUpdateAPIResponse {
  message?: string
  wasSuccessful?: boolean
}

export interface MainStemAPIPlatformControllersPurchasingCannabisAPIRequest {
  /** @format date-time */
  dateEnd?: string
  /** @format date-time */
  dateStart?: string
}

export interface MainStemAPIPlatformControllersPurchasingCannabis3WayMatchListAPIResponse {
  matches?: MainStemAPIPlatformControllersPurchasingCannabis3WayMatchListAPIResponseMatchDetails[]
  message?: string
  wasSuccessful?: boolean
}

export interface MainStemAPIPlatformControllersPurchasingCannabis3WayMatchListAPIResponseMatchDetails {
  issue?: string
  /** @format double */
  invoiceTotal?: number
  invoiceStatus: 'NotStarted' | 'Pending' | 'Matched' | 'Mismatch'
  location: MainStemAPIPlatformControllersPurchasingCannabis3WayMatchListAPIResponseMatchDetailsLocationDetails
  /** @format int32 */
  orderId: number
  /**
   * @format uuid
   * @example "00000000-0000-0000-0000-000000000000"
   */
  orderUuid: string
  overallStatus: 'NotStarted' | 'InProgress' | 'FullyMatched' | 'Discrepancy'
  /** @format int32 */
  purchaseOrderId: number
  purchaseOrderStatus: 'NotStarted' | 'Pending' | 'Matched' | 'Mismatch'
  /** @format double */
  purchaseOrderTotal: number
  /** @format double */
  receivedTotal?: number
  receivedStatus: 'NotStarted' | 'Pending' | 'Matched' | 'Mismatch'
  supplier: MainStemAPIPlatformControllersPurchasingCannabis3WayMatchListAPIResponseMatchDetailsSupplierDetails
}

export interface MainStemAPIPlatformControllersPurchasingCannabis3WayMatchListAPIResponseMatchDetailsLocationDetails {
  /** @format int32 */
  id: number
  name: string
  region?:
    | 'PacificNorthwest'
    | 'Pacific'
    | 'MountainWest'
    | 'Southwest'
    | 'GreatPlains'
    | 'Midwest'
    | 'SouthCentral'
    | 'Southeast'
    | 'MidAtlantic'
    | 'Northeast'
  state?: string
}

export interface MainStemAPIPlatformControllersPurchasingCannabis3WayMatchListAPIResponseMatchDetailsSupplierDetails {
  /** @format int32 */
  id: number
  name: string
}

export interface MainStemAPIPlatformControllersPurchasingCannabisApprovalsListAPIResponse {
  approvals?: MainStemAPIPlatformControllersPurchasingCannabisApprovalsListAPIResponseApprovalDetails[]
  message?: string
  wasSuccessful?: boolean
}

export interface MainStemAPIPlatformControllersPurchasingCannabisApprovalsListAPIResponseApprovalDetails {
  /** @format date-time */
  dateOfDecision?: string
  /** @format date-time */
  dateNotified?: string
  /** @format date-time */
  dateSubmittedForApproval?: string
  decidedBy?: string
  /** @format int32 */
  id: number
  location: MainStemAPIPlatformControllersPurchasingCannabisApprovalsListAPIResponseApprovalDetailsLocationDetails
  purchaseOrders?: MainStemAPIPlatformControllersPurchasingCannabisApprovalsListAPIResponseApprovalDetailsPurchaseOrderSummary[]
  requisition: MainStemAPIPlatformControllersPurchasingCannabisApprovalsListAPIResponseApprovalDetailsRequisitionDetails
  /** @format int32 */
  sequence: number
  status: 'Pending' | 'Approved' | 'Rejected'
  submittedBy?: string
  /** @format double */
  total: number
}

export interface MainStemAPIPlatformControllersPurchasingCannabisApprovalsListAPIResponseApprovalDetailsLocationDetails {
  /** @format int32 */
  id: number
  name: string
  region?:
    | 'PacificNorthwest'
    | 'Pacific'
    | 'MountainWest'
    | 'Southwest'
    | 'GreatPlains'
    | 'Midwest'
    | 'SouthCentral'
    | 'Southeast'
    | 'MidAtlantic'
    | 'Northeast'
  state?: string
}

export interface MainStemAPIPlatformControllersPurchasingCannabisApprovalsListAPIResponseApprovalDetailsPurchaseOrderSummary {
  /** @format int32 */
  id: number
  /** @format int32 */
  supplierId: number
  supplierName: string
  /** @format double */
  total: number
}

export interface MainStemAPIPlatformControllersPurchasingCannabisApprovalsListAPIResponseApprovalDetailsRequisitionDetails {
  /** @format int32 */
  id: number
  name?: string
  /**
   * @format uuid
   * @example "00000000-0000-0000-0000-000000000000"
   */
  uuid: string
}

export interface MainStemAPIPlatformControllersPurchasingCannabisInvoicesListAPIResponse {
  invoices?: MainStemAPIPlatformControllersPurchasingCannabisInvoicesListAPIResponseInvoiceDetails[]
  message?: string
  wasSuccessful?: boolean
}

export interface MainStemAPIPlatformControllersPurchasingCannabisInvoicesListAPIResponseInvoiceDetails {
  /** @format date-time */
  datePromisedBy?: string
  /** @format int32 */
  id: number
  isPaid: boolean
  location: MainStemAPIPlatformControllersPurchasingCannabisInvoicesListAPIResponseInvoiceDetailsLocationDetails
  /** @format int32 */
  orderId: number
  /**
   * @format uuid
   * @example "00000000-0000-0000-0000-000000000000"
   */
  orderUuid: string
  overallStatus: 'NotStarted' | 'InProgress' | 'FullyMatched' | 'Discrepancy'
  paymentStatus?: string
  /** @format int32 */
  purchaseOrderId?: number
  /** @format double */
  purchaseOrderTotal?: number
  quickBooksBillId?: string
  supplier?: MainStemAPIPlatformControllersPurchasingCannabisInvoicesListAPIResponseInvoiceDetailsSupplierDetails
  syncedToAccounting: boolean
  /** @format double */
  total: number
  /**
   * @format uuid
   * @example "00000000-0000-0000-0000-000000000000"
   */
  uuid: string
}

export interface MainStemAPIPlatformControllersPurchasingCannabisInvoicesListAPIResponseInvoiceDetailsLocationDetails {
  /** @format int32 */
  id: number
  name: string
  region?:
    | 'PacificNorthwest'
    | 'Pacific'
    | 'MountainWest'
    | 'Southwest'
    | 'GreatPlains'
    | 'Midwest'
    | 'SouthCentral'
    | 'Southeast'
    | 'MidAtlantic'
    | 'Northeast'
  state?: string
}

export interface MainStemAPIPlatformControllersPurchasingCannabisInvoicesListAPIResponseInvoiceDetailsSupplierDetails {
  /** @format int32 */
  id: number
  name?: string
}

export interface MainStemAPIPlatformControllersPurchasingCannabisPurchaseOrdersListAPIResponse {
  purchaseOrders?: MainStemAPIPlatformControllersPurchasingCannabisPurchaseOrdersListAPIResponsePurchaseOrderDetails[]
  message?: string
  wasSuccessful?: boolean
}

export interface MainStemAPIPlatformControllersPurchasingCannabisPurchaseOrdersListAPIResponsePurchaseOrderDetails {
  /** @format date-time */
  dateRequisitionSubmittedForApproval: string
  /** @format int32 */
  id: number
  location: MainStemAPIPlatformControllersPurchasingCannabisPurchaseOrdersListAPIResponsePurchaseOrderDetailsLocationDetails
  order: MainStemAPIPlatformControllersPurchasingCannabisPurchaseOrdersListAPIResponsePurchaseOrderDetailsOrderDetails
  supplier: MainStemAPIPlatformControllersPurchasingCannabisPurchaseOrdersListAPIResponsePurchaseOrderDetailsSupplierDetails
  /** @format double */
  total: number
}

export interface MainStemAPIPlatformControllersPurchasingCannabisPurchaseOrdersListAPIResponsePurchaseOrderDetailsLocationDetails {
  /** @format int32 */
  id: number
  name: string
  region?:
    | 'PacificNorthwest'
    | 'Pacific'
    | 'MountainWest'
    | 'Southwest'
    | 'GreatPlains'
    | 'Midwest'
    | 'SouthCentral'
    | 'Southeast'
    | 'MidAtlantic'
    | 'Northeast'
  state?: string
}

export interface MainStemAPIPlatformControllersPurchasingCannabisPurchaseOrdersListAPIResponsePurchaseOrderDetailsOrderDetails {
  /** @format int32 */
  id: number
  /**
   * @format uuid
   * @example "00000000-0000-0000-0000-000000000000"
   */
  uuid: string
}

export interface MainStemAPIPlatformControllersPurchasingCannabisPurchaseOrdersListAPIResponsePurchaseOrderDetailsSupplierDetails {
  /** @format int32 */
  id: number
  name: string
}

export interface MainStemAPIPlatformControllersPurchasingCatalogCreateAPIRequest {
  name?: string
  baseRequest?: object
  /** @format int32 */
  customerID?: number
  /** @format int32 */
  businessPartnerId?: number
  businessPartners?: MainStemSDKDataModelsBusinessPartner[]
  /** @format int32 */
  locationID?: number
  isAdmin?: boolean
}

export interface MainStemSDKDataModelsBusinessPartner {
  address1?: string
  address2?: string
  allowCashPayments?: boolean
  allowDelivery?: boolean
  allowFullIntegrationSync?: boolean
  allowPayQwickPayments?: boolean
  allowSupplierInvoiceSplitting?: boolean
  anonymousDataOptOut?: boolean
  approvalRuleset?: 'Tier' | 'Workflow'
  approvalWorkflows?: MainStemSDKDataModelsLocationApprovalWorkflow[]
  authorizeNetCustomerID?: string
  avalaraID?: string
  billToAddress1?: string
  billToAddress2?: string
  billToAddressIsResidential?: boolean
  billToCity?: string
  billToCountry?: string
  billToName?: string
  billToState?: string
  billToZip?: string
  budgets?: MainStemSDKDataModelsLocationBudget[]
  businessPartnerGroups?: MainStemSDKDataModelsBusinessPartnerGroup[]
  businessPartnerIntegrationSettings?: MainStemSDKDataModelsIntegrationSetting[]
  canBuy?: boolean
  canSell?: boolean
  city?: string
  contacts?: MainStemSDKDataModelsContact[]
  country?: string
  /** @format date-time */
  dateCreated?: string
  /** @format int32 */
  daysToFulfill?: number
  defaultAddressIsResidential?: boolean
  defaultBillToAddress?: MainStemSDKDataModelsBusinessPartnerAddress
  /** @format int32 */
  defaultBillToAddressID?: number
  defaultPhysicalAddress?: MainStemSDKDataModelsBusinessPartnerAddress
  /** @format int32 */
  defaultPhysicalAddressID?: number
  /** @format double */
  defaultProfitMarginEnterprise?: number
  /** @format double */
  defaultProfitMarginPriceAgreements?: number
  /** @format double */
  defaultProfitMarginRetail?: number
  /** @format double */
  defaultProfitMarginVolumePricing?: number
  /** @format double */
  defaultProfitMarginWholesale?: number
  defaultShipToAddress?: MainStemSDKDataModelsBusinessPartnerAddress
  /** @format int32 */
  defaultShipToAddressID?: number
  departments?: MainStemSDKDataModelsDepartment[]
  description?: string
  doNotCall?: boolean
  email?: string
  enableSendInvoiceEmails?: boolean
  enableSendSupplierOrderEmails?: boolean
  federalBusinessNumber?: string
  /** @format double */
  freeShippingLimit?: number
  /** @format double */
  freeShippingPercent?: number
  freightContactEmail?: string
  freightContactFirstName?: string
  freightContactLastName?: string
  freightContactPhone?: string
  freightLiftGateRequired?: boolean
  freightNotes?: string
  freightShippingRequired?: boolean
  hasBandedShipping?: boolean
  headerImage?: MainStemSDKDataModelsFile
  /** @format int32 */
  headerImageID?: number
  /** @format int32 */
  id?: number
  integrationAPIKey?: string
  integrationType?: string
  integrationUrl?: string
  isCannabisSupplier?: boolean
  isDeleted?: boolean
  /** @format double */
  latitude?: number
  localBusinessNumber?: string
  logo?: MainStemSDKDataModelsFile
  /** @format int32 */
  logoFileID?: number
  logoPDF?: MainStemSDKDataModelsFile
  /** @format int32 */
  logoPDFID?: number
  /** @format double */
  longitude?: number
  mainStemCustomerLocationType?:
    | 'Unknown'
    | 'Cultivation'
    | 'Processing'
    | 'Retail'
    | 'Kitchen'
    | 'Lab'
    | 'Office'
    | 'Warehouse'
  manualOrderAcceptanceRequired?: boolean
  manualProcessingSiteURL?: string
  mapIcon?: MainStemSDKDataModelsFile
  /** @format int32 */
  mapIconID?: number
  /** @format double */
  minimumOrderAmount?: number
  name?: string
  notificationEmailNewOrder?: string
  notificationEmailReviewRequest?: string
  notificationEmails?: string
  notificationEmailsSupplierRFQ?: string
  notificationEmailShipmentUpdate?: string
  parentBusinessPartner?: MainStemSDKDataModelsBusinessPartner
  /** @format int32 */
  parentBusinessPartnerID?: number
  paymentAgreement?: 'DueUponReceipt' | 'PrePay' | 'Net15' | 'Net30' | 'Net45' | 'Net30_110' | 'Net30_210'
  payQwickEid?: string
  pdfFileLogo?: MainStemSDKDataModelsFile
  /** @format int32 */
  pdfFileLogoID?: number
  /** @format int32 */
  pdfLogoHeight?: number
  pdfHeaderInformation?: string
  pdfTermsAndConditions?: string
  pdfTitleInvoice?: string
  pdfTitlePurchaseOrder?: string
  pdfTitleRequisition?: string
  phone?: string
  phoneExtension?: string
  privateSupplierDomain?: string
  privateSupplierNewOrderEmailNotificationCC?: string
  privateSupplierOrganization?: MainStemSDKDataModelsOrganization
  /** @format int32 */
  privateSupplierOrganizationID?: number
  productFinancialDimensions?: MainStemSDKDataModelsLocationProductFinancialDimension[]
  quickbooks_ClientID?: string
  quickbooks_ClientSecret?: string
  quickBooksID?: string
  quickBooksVendorID?: string
  refundPolicy?: string
  requiresManualProcessing?: boolean
  requiresPrePayment?: boolean
  sendInvoiceEmailsAddresses?: string
  sendSupplierNotificationAcceptance?: boolean
  sendSupplierNotificationShipmentTracking?: boolean
  sendSupplierOrderEmailsAddresses?: string
  shipToAddress1?: string
  shipToAddress2?: string
  shipToAddressIsResidential?: boolean
  shipToAppointmentRequired?: boolean
  shipToCity?: string
  shipToCountry?: string
  shipToDriverAssistanceRequired?: boolean
  shipToEquipmentLength?: string
  shipToEquipmentType?: string
  shipToForkliftOnSite?: boolean
  shipToGatedFacility?: boolean
  shipToInsideDelivery?: boolean
  shipToName?: string
  shipToState?: string
  shipToZip?: string
  shortCodeIdentifier?: string
  socialMediaFacebook?: string
  socialMediaInstagram?: string
  socialMediaLinkedIn?: string
  socialMediaTwitter?: string
  socialMediaYouTube?: string
  squareFootage?: string
  state?: string
  supplierFreightShippingAccountNumber?: string
  supplierFreightShippingCarrier?: string
  /** @format double */
  supplierFreightShippingFreeMinimum?: number
  supplierInvoicingIsAutomated?: boolean
  supplierParcelShippingAccountNumber?: string
  supplierParcelShippingCarrier?: string
  /** @format double */
  supplierParcelShippingFreeMinimum?: number
  supplierPaymentTerms?: string
  /** @format double */
  supplierPaymentTermsCreditLimit?: number
  /** @format int32 */
  supplierPaymentTermsDays?: number
  /** @format int32 */
  supplierPaymentTermsDiscountDays?: number
  /** @format double */
  supplierPaymentTermsDiscountPercent?: number
  /** @format double */
  supplierPaymentTermsPercent?: number
  /** @format double */
  supplierPaymentTermsPrePaymentPercent?: number
  supplierReconciliationAIGuidance?: string
  supplierShipmentTrackingAIGuidance?: string
  supplierAIEmailSenders?: string
  supplierAIEmailModel?: string
  /** @format int32 */
  supplierShippingFreightWeightLimit?: number
  /** @format int32 */
  supplierShippingMaxBundleWeight?: number
  termsAndConditions?: string
  tier?: string
  usesDirectPay?: boolean
  usesPreferredShipping?: boolean
  /**
   * @format uuid
   * @example "00000000-0000-0000-0000-000000000000"
   */
  uuid?: string
  website?: string
  zip?: string
}

export interface MainStemSDKDataModelsLocationApprovalWorkflow {
  approvals?: MainStemSDKDataModelsOrderApprovals[]
  customerLocation?: MainStemSDKDataModelsBusinessPartner
  /** @format int32 */
  customerLocationID?: number
  /** @format int32 */
  id?: number
  isDeleted?: boolean
  /** @format double */
  maxAmount?: number
  /** @format double */
  minAmount?: number
  /** @format int32 */
  numberOfRequiredApprovers?: number
  users?: MainStemSDKDataModelsApplicationUser[]
}

export interface MainStemSDKDataModelsLocationBudget {
  /** @format double */
  budget?: number
  /** @format int32 */
  id?: number
  location?: MainStemSDKDataModelsBusinessPartner
  /** @format int32 */
  locationID?: number
  /** @format int32 */
  month?: number
  /** @format int32 */
  year?: number
}

export interface MainStemSDKDataModelsBusinessPartnerGroup {
  businessPartners?: MainStemSDKDataModelsBusinessPartner[]
  /** @format int32 */
  id?: number
  name?: string
  products?: MainStemSDKDataModelsProduct[]
  type?: 'None' | 'LocationType'
}

export interface MainStemSDKDataModelsIntegrationSetting {
  businessPartner?: MainStemSDKDataModelsBusinessPartner
  /** @format int32 */
  businessPartnerID?: number
  /** @format int32 */
  id?: number
  /**
   * @format uuid
   * @example "00000000-0000-0000-0000-000000000000"
   */
  uuid?: string
  integrationType?: string
  settings?: string
  status?: string
}

export interface MainStemSDKDataModelsContact {
  altEmail?: string
  altPhone?: string
  businessPartners?: MainStemSDKDataModelsBusinessPartner[]
  email?: string
  firstName?: string
  /** @format int32 */
  id?: number
  lastName?: string
  nickName?: string
  phone?: string
  phoneExtension?: string
  title?: string
}

export interface MainStemSDKDataModelsBusinessPartnerAddress {
  address1?: string
  address2?: string
  city?: string
  country?: string
  /** @format int32 */
  id?: number
  isDeleted?: boolean
  isResidential?: boolean
  /** @format double */
  latitude?: number
  /** @format double */
  longitude?: number
  name?: string
  owner?: MainStemSDKDataModelsBusinessPartner
  /** @format int32 */
  ownerBusinessPartnerID?: number
  shared?: boolean
  state?: string
  zip?: string
}

export interface MainStemSDKDataModelsDepartment {
  customerLocation?: MainStemSDKDataModelsBusinessPartner
  /** @format int32 */
  customerLocationID?: number
  /** @format int32 */
  id?: number
  name?: string
  users?: MainStemSDKDataModelsApplicationUser[]
  isDeleted?: boolean
}

export interface MainStemSDKDataModelsFile {
  altText?: string
  cloudFileType?:
    | 'csv'
    | 'txt'
    | 'html'
    | 'png'
    | 'jpg'
    | 'gif'
    | 'json'
    | 'pdf'
    | 'xls'
    | 'pbix'
    | 'jfif'
    | 'jpeg'
    | 'xlsx'
    | 'webp'
  /** @format date-time */
  dateCreated?: string
  /** @format int32 */
  documentID?: number
  documentIDString?: string
  documentType?: string
  fileExtension?: string
  fileLocation?: string
  fileName?: string
  /** @format int64 */
  fileSize?: number
  /** @format int32 */
  id?: number
  originalFileName?: string
  /**
   * @format uuid
   * @example "00000000-0000-0000-0000-000000000000"
   */
  userIDCreatedBy?: string
  /**
   * @format uuid
   * @example "00000000-0000-0000-0000-000000000000"
   */
  uuid?: string
}

export interface MainStemSDKDataModelsOrganization {
  accountSize?: 'Fish' | 'Dolphin' | 'SmallWhale' | 'BigWhale'
  aka?: string
  allowCannabis?: boolean
  allowPaymentMethodACH?: boolean
  allowCreditCards?: boolean
  allowPunchOutInMainNav?: boolean
  allowRequisitionBillToAddressChange?: boolean
  allowTermPayments?: boolean
  bulkOrders?: MainStemSDKDataModelsBulkOrder[]
  customerAIEmailModel?: string
  customerAIEmailSenders?: string
  customerRemittanceAIGuidance?: string
  customFields?: MainStemSDKDataModelsCustomerCustomField[]
  /** @format date-time */
  dateCreated?: string
  /** @format date-time */
  dateGoLive?: string
  /** @format date-time */
  dateTrialExpires?: string
  email?: string
  filePDFLogo?: MainStemSDKDataModelsFile
  /** @format int32 */
  filePDFLogoID?: number
  headerInformation?: string
  /** @format int32 */
  id?: number
  logo?: MainStemSDKDataModelsFile
  /** @format int32 */
  logoFileID?: number
  name?: string
  phone?: string
  pricingType?: 'Retail' | 'Wholesale' | 'Enterprise'
  privateSupplierNewOrderEmailNotificationCC?: string
  privateSupplierNewOrderEmailNotificationTemplate?: string
  programType?: 'Archived' | 'PurchaseProPaid' | 'PurchaseProFree'
  rfQs?: MainStemSDKDataModelsRFQ[]
  rfqRequiresApproval?: boolean
  rfqApprovalUsers?: MainStemSDKDataModelsRFQApprovalUser[]
  /** @format double */
  saaSFee?: number
  saaSFeeEnabled?: boolean
  /** @format int32 */
  termDays?: number
  termsAndConditions?: string
  /** @format double */
  termsCreditLimit?: number
  titleInvoice?: string
  titlePurchaseOrder?: string
  titleRequisition?: string
  /**
   * @format uuid
   * @example "00000000-0000-0000-0000-000000000000"
   */
  uuid?: string
  zohoCompanyID?: string
}

export interface MainStemSDKDataModelsLocationProductFinancialDimension {
  financialDimension?: MainStemSDKDataModelsFinancialDimension
  /** @format int32 */
  financialDimensionID: number
  /** @format int32 */
  id?: number
  isRequired?: boolean
  location?: MainStemSDKDataModelsBusinessPartner
  /** @format int32 */
  locationID: number
  showOnInvoicePDF?: boolean
  showOnOrderPDF?: boolean
}

export interface MainStemSDKDataModelsOrderApprovals {
  approvalType?: 'Pending' | 'Approved' | 'Rejected'
  approvalWorkflow?: MainStemSDKDataModelsLocationApprovalWorkflow
  /** @format int32 */
  approvalWorkflowID?: number
  /** @format date-time */
  dateNotified?: string
  /** @format date-time */
  dateOfDecision?: string
  /** @format int32 */
  id?: number
  order?: MainStemSDKDataModelsOrder
  /** @format int32 */
  orderID?: number
  /** @format int32 */
  sequence?: number
  userDecidedBy?: MainStemSDKDataModelsApplicationUser
  userIDDecidedBy?: string
}

export interface MainStemSDKDataModelsApplicationUser {
  allowBeta?: boolean
  appearanceBorders?: string
  appearanceFontSize?: string
  appearanceSpacing?: string
  appearanceTheme?: string
  approvals?: MainStemSDKDataModelsOrderApprovals[]
  businessPartner?: MainStemSDKDataModelsBusinessPartner
  /** @format int32 */
  businessPartnerID?: number
  copyUserOnApprovedOrders?: boolean
  copyUserOnCreatedOrders?: boolean
  /** @format date-time */
  dateCreated?: string
  defaultCatalog?: MainStemSDKDataModelsProductList
  /** @format int32 */
  defaultCatalogID?: number
  departments?: MainStemSDKDataModelsDepartment[]
  friendlyName?: string
  /** @format int32 */
  idInt?: number
  isDeleted?: boolean
  locationApprovalWorkflows?: MainStemSDKDataModelsLocationApprovalWorkflow[]
  mainStemUserType?: 'Blocked' | 'Admin' | 'Customer' | 'Supplier'
  /** @format date-time */
  passwordResetExpires?: string
  /**
   * @format uuid
   * @example "00000000-0000-0000-0000-000000000000"
   */
  passwordResetUUID?: string
  permissionGroup?: MainStemSDKDataModelsPermissionGroup
  /** @format int32 */
  permissionGroupID?: number
  permissions?: MainStemSDKDataModelsUserPermissions[]
  profileImage?: MainStemSDKDataModelsFile
  /** @format int32 */
  profileImageID?: number
  quickBooksID?: string
  title?: string
  type?: string
  email?: string
  emailConfirmed?: boolean
  passwordHash?: string
  securityStamp?: string
  phoneNumber?: string
  phoneNumberConfirmed?: boolean
  twoFactorEnabled?: boolean
  /** @format date-time */
  lockoutEndDateUtc?: string
  lockoutEnabled?: boolean
  /** @format int32 */
  accessFailedCount?: number
  roles?: MicrosoftAspNetIdentityEntityFrameworkIdentityUserRole[]
  claims?: MicrosoftAspNetIdentityEntityFrameworkIdentityUserClaim[]
  logins?: MicrosoftAspNetIdentityEntityFrameworkIdentityUserLogin[]
  id?: string
  userName?: string
}

export interface MainStemSDKDataModelsProduct {
  approvalStatus?: 'Rejected' | 'Pending' | 'Approved'
  attributeValues?: MainStemSDKDataModelsAttributeValue[]
  cannabisBatchNumber?: string
  /** @format double */
  customerRetailPrice?: number
  customsDescription?: string
  customsHarmonizedTariffCodes?: string
  /** @format date-time */
  dateCreated?: string
  /** @format date-time */
  dateEstimatedBackInStock?: string
  /** @format date-time */
  dateLastIndexed?: string
  /** @format date-time */
  dateLastUpdated?: string
  /** @format date-time */
  datePriceLastUpdated?: string
  /** @format int32 */
  daysToFulfill?: number
  /** @format double */
  defaultProfitMarginEnterprise?: number
  /** @format double */
  defaultProfitMarginPriceAgreements?: number
  /** @format double */
  defaultProfitMarginRetail?: number
  /** @format double */
  defaultProfitMarginVolumePricing?: number
  /** @format double */
  defaultProfitMarginWholesale?: number
  description?: string
  distributorID?: string
  dropShipBusinessPartner?: MainStemSDKDataModelsBusinessPartner
  /** @format int32 */
  dropShipBusinessPartnerID?: number
  dropShippedItem?: boolean
  externalId?: string
  externalSource?: string
  /** @format double */
  flatShippingCost?: number
  freeShipping?: boolean
  freightShippingRequired?: boolean
  hasMaximumPurchaseRequirement?: boolean
  hasMinimumPurchaseRequirement?: boolean
  hasVolumePricing?: boolean
  /** @format double */
  hazmatFee?: number
  /** @format double */
  height?: number
  /** @format int32 */
  id?: number
  isApproved?: boolean
  isCannabis?: boolean
  isClean?: boolean
  isCustomizable?: boolean
  isCustomProduct?: boolean
  isDeleted?: boolean
  isNonCancellable?: boolean
  isNonReturnable?: boolean
  isOutOfStock?: boolean
  isPunchOutGenerated?: boolean
  isShippable?: boolean
  /** @format double */
  length?: number
  mainImage?: MainStemSDKDataModelsFile
  /** @format int32 */
  mainImageID?: number
  productType?: MainStemSDKDataModelsProductType
  /** @format int32 */
  productTypeID?: number
  /** @format int32 */
  maximumPurchasableQuantity?: number
  /** @format int32 */
  minimumPurchasableQuantity?: number
  name?: string
  potentialImages?: string[]
  potentialImagesAsString?: string
  /** @format double */
  priceMSRP?: number
  /** @format double */
  pricePurchaseEnterprise?: number
  /** @format double */
  pricePurchaseRetail?: number
  /** @format double */
  pricePurchaseWholesale?: number
  /** @format double */
  priceSellEnterprise?: number
  /** @format double */
  priceSellRetail?: number
  /** @format double */
  priceSellWholesale?: number
  privateProductOrganization?: MainStemSDKDataModelsOrganization
  /** @format int32 */
  privateProductOrganizationID?: number
  productGroups?: MainStemSDKDataModelsProductGroup[]
  productImages?: MainStemSDKDataModelsFile[]
  quickBooksID?: string
  rfqLineItems?: MainStemSDKDataModelsRFQLineItem[]
  showInStore?: boolean
  skuInternal?: string
  skuManufacturer?: string
  smallText?: string
  /** @format int32 */
  soldInQuantitiesOf?: number
  supplierPartNumber?: string
  taxCode?: string
  type?: string
  upc?: string
  unitOfMeasureLabel?: string
  unitOfMeasureValue?: string
  variantID?: string
  /** @format double */
  weight?: number
  /** @format double */
  width?: number
}

export interface MainStemSDKDataModelsBulkOrder {
  customer?: MainStemSDKDataModelsOrganization
  /** @format int32 */
  customerID?: number
  /** @format date-time */
  dateCompleted?: string
  /** @format date-time */
  dateCreated?: string
  /** @format int32 */
  id?: number
  orders?: MainStemSDKDataModelsBulkOrderRequisition[]
  requisitions?: MainStemSDKDataModelsOrder[]
  status?: 'Pending' | 'Released'
  uploads?: MainStemSDKDataModelsBulkOrderUpload[]
  userCreatedByID?: string
  userCreatedBy?: MainStemSDKDataModelsApplicationUser
}

export interface MainStemSDKDataModelsCustomerCustomField {
  customer?: MainStemSDKDataModelsOrganization
  /** @format int32 */
  customerID?: number
  dataModel?:
    | 'User'
    | 'Location'
    | 'Supplier'
    | 'Order'
    | 'Invoice'
    | 'Shipment'
    | 'Product'
    | 'Department'
    | 'OrderSupplier'
  fieldType?: 'ShortText' | 'LongText' | 'Number' | 'Date' | 'Boolean' | 'Currency'
  /** @format int32 */
  id?: number
  isDeleted?: boolean
  name?: string
  showOnPDF?: boolean
  values?: MainStemSDKDataModelsCustomerCustomFieldValue[]
}

export interface MainStemSDKDataModelsRFQ {
  attachments?: MainStemSDKDataModelsRFQAttachment[]
  cancellationReason?: string
  comments?: MainStemSDKDataModelsRFQComment[]
  customer?: MainStemSDKDataModelsOrganization
  /** @format int32 */
  customerID?: number
  /** @format date-time */
  dateCreated?: string
  /** @format date-time */
  dateApproved?: string
  /** @format date-time */
  dateLastUpdated?: string
  /** @format date-time */
  dateSubmitted?: string
  description?: string
  /** @format int32 */
  id?: number
  lineItems?: MainStemSDKDataModelsRFQLineItem[]
  logs?: MainStemSDKDataModelsRFQLog[]
  rejectionReason?: string
  shipTo_Address?: string
  shipTo_City?: string
  shipTo_State?: string
  shipTo_Zip?: string
  shipTo_Country?: string
  status?:
    | 'Cancelled'
    | 'Rejected'
    | 'Draft'
    | 'PendingApproval'
    | 'Submitted'
    | 'InProgress'
    | 'Completed'
    | 'MainStemReview'
  /** @format double */
  targetValueCustomer?: number
  /** @format double */
  targetValueMainStem?: number
  title?: string
  userCancelledBy?: MainStemSDKDataModelsApplicationUser
  userCancelledByID?: string
  userCreatedBy?: MainStemSDKDataModelsApplicationUser
  userCreatedByID?: string
  userRejectedBy?: MainStemSDKDataModelsApplicationUser
  userRejectedByID?: string
}

export interface MainStemSDKDataModelsRFQApprovalUser {
  customer?: MainStemSDKDataModelsOrganization
  /** @format int32 */
  customerID?: number
  /** @format int32 */
  id?: number
  user?: MainStemSDKDataModelsApplicationUser
  userID?: string
}

export interface MainStemSDKDataModelsFinancialDimension {
  customer?: MainStemSDKDataModelsOrganization
  /** @format int32 */
  customerID?: number
  /** @format int32 */
  id?: number
  isDeleted?: boolean
  label?: string
  /** @format int32 */
  rankOrder?: number
  type?: 'Product' | 'Location' | 'Department' | 'InvoiceLineItemAllocation' | 'Invoice' | 'Supplier'
}

export interface MainStemSDKDataModelsOrder {
  /** @format double */
  actualShippingCost?: number
  approvals?: MainStemSDKDataModelsOrderApprovals[]
  approvalStatus?: 'SavedCart' | 'AwaitingApproval' | 'Approval' | 'ApprovalWithEdits' | 'Rejected'
  /** @format date-time */
  approvalStatusAsOfDate?: string
  bulkOrder?: MainStemSDKDataModelsBulkOrder
  /** @format int32 */
  bulkOrderID?: number
  billToAddress?: MainStemSDKDataModelsBusinessPartnerAddress
  billToAddress1?: string
  billToAddress2?: string
  /** @format int32 */
  billToAddressID?: number
  billToCity?: string
  billToCountry?: string
  billToName?: string
  billToState?: string
  billToZip?: string
  customerAccountSizeAtTimeOfApproval?: 'Fish' | 'Dolphin' | 'SmallWhale' | 'BigWhale'
  /** @format int32 */
  customerIntegrationSessionID?: number
  customerPricingTypeAtTimeOfApproval?: 'Retail' | 'Wholesale' | 'Enterprise'
  /** @format date-time */
  dateApproved?: string
  /** @format date-time */
  dateCreated?: string
  /** @format date-time */
  dateDue?: string
  /** @format date-time */
  dateOfLastAction?: string
  /** @format date-time */
  datePickedAndPacked?: string
  /** @format date-time */
  dateReceived?: string
  /** @format date-time */
  dateRequiredBy?: string
  /** @format date-time */
  dateShipped?: string
  /** @format date-time */
  dateSubmittedForApproval?: string
  /** @format double */
  discount?: number
  email?: string
  /** @format int32 */
  id?: number
  invoices?: MainStemSDKDataModelsFulfillmentMethod[]
  isDeleted?: boolean
  isSupplierSalesOrder?: boolean
  name?: string
  needsElf?: boolean
  orderGeneratedBy?: string
  orderStatus?:
    | 'Open'
    | 'Approved'
    | 'CantFulfill'
    | 'Cancelled'
    | 'Return'
    | 'Fulfillment'
    | 'Shipping'
    | 'Closed'
    | 'Complete'
  owner?: MainStemSDKDataModelsBusinessPartner
  /** @format int32 */
  ownerBusinessPartnerID?: number
  parentOrder?: MainStemSDKDataModelsOrder
  /** @format int32 */
  parentOrderID?: number
  paymentStatus?: string
  phase?: 'Requisition' | 'Submission' | 'Approval' | 'Processing' | 'Shipping' | 'Completed' | 'Cancelled' | 'Rejected'
  phone?: string
  purchaseOrders?: MainStemSDKDataModelsPurchaseOrder[]
  quickBooksID?: string
  requestedShippingType?: string
  requisitionReturnReason?: string
  requisitionStatus?: 'New' | 'PendingApproval' | 'Returned' | 'Approved' | 'Rejected' | 'Cancelled'
  salesPersonID?: string
  /** @format double */
  salesTax?: number
  /** @format date-time */
  salesTaxAsOfDate?: string
  savedPaymentMethod?: string
  /** @format double */
  shippingCost?: number
  shippingMethod?: string
  shippingNote?: string
  shipToAddress?: MainStemSDKDataModelsBusinessPartnerAddress
  shipToAddress1?: string
  shipToAddress2?: string
  /** @format int32 */
  shipToAddressID?: number
  shipToCity?: string
  shipToCountry?: string
  shipToName?: string
  shipToState?: string
  shipToZip?: string
  status?: string
  suppliers?: MainStemSDKDataModelsOrderSupplier[]
  /** @format int32 */
  termLedgerID?: number
  /** @format double */
  totalAtTimeOfApproval?: number
  /** @format double */
  totals_Fees?: number
  /** @format double */
  totals_Discount?: number
  /** @format double */
  totals_SubTotal?: number
  /** @format double */
  totals_Shipping?: number
  /** @format double */
  totals_SalesTax?: number
  /** @format double */
  totals_Total?: number
  /** @format double */
  price_SubTotal?: number
  /** @format double */
  price_Taxes?: number
  /** @format double */
  price_Shipping?: number
  /** @format double */
  price_Fees?: number
  /** @format double */
  price_Discounts?: number
  /** @format double */
  price_Total?: number
  /** @format double */
  cost_SubTotal?: number
  /** @format double */
  cost_Taxes?: number
  /** @format double */
  cost_Shipping?: number
  /** @format double */
  cost_Fees?: number
  /** @format double */
  cost_Discounts?: number
  /** @format double */
  cost_Total?: number
  type?: string
  userApprovedBy?: MainStemSDKDataModelsApplicationUser
  userCreatedBy?: MainStemSDKDataModelsApplicationUser
  userIDApprovedBy?: string
  userIDCreatedBy?: string
  userIDSubmittedForApproval?: string
  userSubmittedForApproval?: MainStemSDKDataModelsApplicationUser
  /**
   * @format uuid
   * @example "00000000-0000-0000-0000-000000000000"
   */
  uuid?: string
}

export interface MainStemSDKDataModelsProductList {
  /** @format int32 */
  id?: number
  isDeleted?: boolean
  isPrivate?: boolean
  name?: string
  productListItems?: MainStemSDKDataModelsProductListItem[]
  productListUsers?: MainStemSDKDataModelsProductListUser[]
}

export interface MainStemSDKDataModelsPermissionGroup {
  /** @format int32 */
  id?: number
  name?: string
  organization?: MainStemSDKDataModelsOrganization
  /** @format int32 */
  organizationID?: number
}

export interface MainStemSDKDataModelsUserPermissions {
  /** @format int32 */
  id?: number
  permission?: MainStemSDKDataModelsPermission
  /** @format int32 */
  permissionID?: number
  user?: MainStemSDKDataModelsApplicationUser
  userID?: string
  value?: string
}

export interface MicrosoftAspNetIdentityEntityFrameworkIdentityUserRole {
  userId?: string
  roleId?: string
}

export interface MicrosoftAspNetIdentityEntityFrameworkIdentityUserClaim {
  /** @format int32 */
  id?: number
  userId?: string
  claimType?: string
  claimValue?: string
}

export interface MicrosoftAspNetIdentityEntityFrameworkIdentityUserLogin {
  loginProvider?: string
  providerKey?: string
  userId?: string
}

export interface MainStemSDKDataModelsAttributeValue {
  attribute?: MainStemSDKDataModelsAttribute
  /** @format int32 */
  attributeID?: number
  /** @format int32 */
  id?: number
  products?: MainStemSDKDataModelsProduct[]
  value?: string
}

export interface MainStemSDKDataModelsProductType {
  aiGuidance?: string
  description?: string
  /** @format int32 */
  id?: number
  name?: string
  products?: MainStemSDKDataModelsProduct[]
  mainStemQuickBooksOnlineAccountCOGSID?: string
  mainStemQuickBooksOnlineAccountIncomeID?: string
}

export interface MainStemSDKDataModelsProductGroup {
  /** @format int32 */
  id?: number
  name?: string
  parentProductGroup?: MainStemSDKDataModelsProductGroup
  /** @format int32 */
  parentProductGroupID?: number
  products?: MainStemSDKDataModelsProduct[]
}

export interface MainStemSDKDataModelsRFQLineItem {
  approvalStatus?: 'Rejected' | 'Pending' | 'Approved'
  canBeSourcedFromAnySupplier?: boolean
  catalog?: MainStemSDKDataModelsProductList
  /** @format int32 */
  catalogID?: number
  /** @format date-time */
  dateApprovalDecisionMade?: string
  /** @format date-time */
  dateMaterialsRequiredInFacility?: string
  /** @format int32 */
  id?: number
  name?: string
  notes?: string
  openToAlternativeItems?: boolean
  product?: MainStemSDKDataModelsProduct
  /** @format int32 */
  productID?: number
  /** @format int32 */
  quantity?: number
  rejectedReason?: string
  rfq?: MainStemSDKDataModelsRFQ
  /** @format int32 */
  rfqid?: number
  supplierBids?: MainStemSDKDataModelsRFQLineItemSupplierBid[]
  supplierInvites?: MainStemSDKDataModelsRFQLineItemSupplierInvite[]
  /** @format double */
  targetPricePerUnitCustomer?: number
  /** @format double */
  targetValueCustomer?: number
  /** @format double */
  targetPricePerUnitMainStem?: number
  /** @format double */
  targetValueMainStem?: number
  urLs?: MainStemSDKDataModelsRFQLineItemURL[]
  userApprovalDecision?: MainStemSDKDataModelsApplicationUser
  userApprovalDecisionID?: string
}

export interface MainStemSDKDataModelsBulkOrderRequisition {
  /** @format int32 */
  bulkOrderID?: number
  bulkOrder?: MainStemSDKDataModelsBulkOrder
  /** @format int32 */
  bulkOrderUploadID?: number
  bulkOrderUpload?: MainStemSDKDataModelsBulkOrderUpload
  /** @format int32 */
  customerLocationID?: number
  customerLocation?: MainStemSDKDataModelsBusinessPartner
  /** @format date-time */
  dateCreated?: string
  /** @format int32 */
  id?: number
  name?: string
  purchaseOrders?: MainStemSDKDataModelsBulkOrderPurchaseOrder[]
}

export interface MainStemSDKDataModelsBulkOrderUpload {
  /** @format int32 */
  bulkOrderID?: number
  bulkOrder?: MainStemSDKDataModelsBulkOrder
  /** @format int32 */
  countProducts?: number
  /** @format int32 */
  countOrders?: number
  /** @format int32 */
  countRows?: number
  /** @format int32 */
  countSuppliers?: number
  /** @format int32 */
  id?: number
  /** @format date-time */
  dateCompleted?: string
  /** @format date-time */
  dateCreated?: string
  fileUploaded?: MainStemSDKDataModelsFile
  /** @format int32 */
  fileUploadedID?: number
  fileResponse?: MainStemSDKDataModelsFile
  /** @format int32 */
  fileResponseID?: number
  status?: 'Pending' | 'InProgress' | 'Completed' | 'Failed'
  userCreatedByID?: string
  userCreatedBy?: MainStemSDKDataModelsApplicationUser
}

export interface MainStemSDKDataModelsCustomerCustomFieldValue {
  customField?: MainStemSDKDataModelsCustomerCustomField
  /** @format int32 */
  customFieldID?: number
  /** @format int32 */
  documentID?: number
  documentIDString?: string
  /** @format int32 */
  id?: number
  isDeleted?: boolean
  value?: string
}

export interface MainStemSDKDataModelsRFQAttachment {
  /** @format date-time */
  dateCreated?: string
  description?: string
  file?: MainStemSDKDataModelsFile
  /** @format int32 */
  fileID?: number
  /** @format int32 */
  id?: number
  rfq?: MainStemSDKDataModelsRFQ
  /** @format int32 */
  rfqid?: number
  suppliers?: MainStemSDKDataModelsRFQAttachmentSupplier[]
  userCreatedBy?: MainStemSDKDataModelsApplicationUser
  userCreatedByID?: string
  viewableToCustomer?: boolean
  viewableToSupplier?: boolean
}

export interface MainStemSDKDataModelsRFQComment {
  comment?: string
  /** @format date-time */
  dateCreated?: string
  /** @format int32 */
  id?: number
  rfq?: MainStemSDKDataModelsRFQ
  /** @format int32 */
  rfqid?: number
  suppliers?: MainStemSDKDataModelsRFQCommentSupplier[]
  userCreatedBy?: MainStemSDKDataModelsApplicationUser
  userCreatedByID?: string
  viewableToCustomer?: boolean
  viewableToSupplier?: boolean
}

export interface MainStemSDKDataModelsRFQLog {
  content?: string
  /** @format date-time */
  dateCreated?: string
  /** @format int32 */
  id?: number
  rfq?: MainStemSDKDataModelsRFQ
  /** @format int32 */
  rfqid?: number
  subject?: string
  userCreatedBy?: MainStemSDKDataModelsApplicationUser
  userCreatedByID?: string
}

export interface MainStemSDKDataModelsFulfillmentMethod {
  avalaraEstimateRequest?: string
  avalaraEstimateResponse?: string
  avalaraCommitRequest?: string
  avalaraCommitResponse?: string
  acceptanceStatus?: 'Cancelled' | 'Pending' | 'Accepted' | 'Rejected'
  acknowledgedBy?: string
  acknowledgedByUser?: MainStemSDKDataModelsApplicationUser
  acknowledgedByUserId?: string
  acknowledgementType?: 'MainStemPixel' | 'SupplierCoreOrderDetails' | 'Integration'
  avalaraID?: string
  /** @format int32 */
  customerIntegrationSessionID?: number
  customerQuickBooksBillID?: string
  customerInvoiceTerms?: string
  /** @format date-time */
  dateAccepted?: string
  /** @format date-time */
  dateAcknowledged?: string
  /** @format date-time */
  dateDeliveryRangeEnd?: string
  /** @format date-time */
  dateDeliveryRangeStart?: string
  /** @format date-time */
  dateNotified?: string
  /** @format date-time */
  datePickedOn?: string
  /** @format date-time */
  datePromisedBy?: string
  /** @format date-time */
  dateReceived?: string
  /** @format date-time */
  dateReconciliationLastChecked?: string
  /** @format date-time */
  dateRejected?: string
  /** @format date-time */
  dateReleased?: string
  /** @format date-time */
  dateSalesTaxCalculated?: string
  /** @format date-time */
  dateShippedOn?: string
  /** @format double */
  discount?: number
  dropShipUniqueID?: string
  dropShipVendor?: MainStemSDKDataModelsBusinessPartner
  /** @format int32 */
  dropShipVendorID?: number
  /** @format double */
  fees?: number
  fulfillmentMethodLineItems?: MainStemSDKDataModelsFulfillmentMethodLineItem[]
  hasProblem?: boolean
  /** @format int32 */
  id?: number
  integrationType?: string
  invoiceStatus?: 'Cancelled' | 'Draft' | 'InProgress' | 'UnderReview' | 'Released' | 'ReadyForRelease'
  isFreightShipping?: boolean
  isLegacy?: boolean
  notes?: string
  okToPay_Customer?: boolean
  okToPay_MainStem?: boolean
  order?: MainStemSDKDataModelsOrder
  /** @format int32 */
  orderID?: number
  /** @format double */
  paymentProcessingFee?: number
  /** @format double */
  price_SubTotal?: number
  /** @format double */
  price_Taxes?: number
  /** @format double */
  price_Shipping?: number
  /** @format double */
  price_Fees?: number
  /** @format double */
  price_Discounts?: number
  /** @format double */
  price_Total?: number
  /** @format double */
  cost_SubTotal?: number
  /** @format double */
  cost_Taxes?: number
  /** @format double */
  cost_Shipping?: number
  /** @format double */
  cost_Fees?: number
  /** @format double */
  cost_Discounts?: number
  /** @format double */
  cost_Total?: number
  purchaseOrder?: MainStemSDKDataModelsPurchaseOrder
  /** @format int32 */
  purchaseOrderID?: number
  quickBooksID?: string
  quickBooksInvoiceState?: 'Open' | 'Partial' | 'Closed' | 'Ignore'
  quickBooksItemReceiptID?: string
  quickBooksPaymentIDs?: string
  quickBooksPaymentLinks?: string[]
  quickBooksPurchaseOrderID?: string
  reconciliationLastCheckedStatus?: string
  /** @format double */
  salesTax?: number
  salesTaxDescription?: string
  shipmentType?: string
  /** @format double */
  shippingCost?: number
  subType?: 'Shipment' | 'WillCall' | 'Delivery' | 'Freight'
  /** @format double */
  supplierSalesTax?: number
  /** @format double */
  supplierShippingCost?: number
  taxBreakdownJSON?: string
  type?: 'DirectToCustomer' | 'DropShip' | 'BackOrder'
  /**
   * @format uuid
   * @example "00000000-0000-0000-0000-000000000000"
   */
  uuid?: string
}

export interface MainStemSDKDataModelsPurchaseOrder {
  avalaraEstimateRequest?: string
  avalaraEstimateResponse?: string
  /** @format int32 */
  customerIntegrationSessionID?: number
  customerInvoiceTerms?: string
  /** @format date-time */
  dateCreated?: string
  /** @format date-time */
  dateReleased?: string
  /** @format date-time */
  dateSalesTaxCalculated?: string
  /** @format date-time */
  dateShippingCalculated?: string
  discounts?: MainStemSDKDataModelsPurchaseOrderDiscount[]
  fees?: MainStemSDKDataModelsPurchaseOrderFee[]
  freightCollect?: boolean
  fulfillmentMethods?: MainStemSDKDataModelsFulfillmentMethod[]
  /** @format int32 */
  id?: number
  lineItems?: MainStemSDKDataModelsPurchaseOrderLineItem[]
  order?: MainStemSDKDataModelsOrder
  /** @format int32 */
  orderID?: number
  /** @format double */
  price_SubTotal?: number
  /** @format double */
  price_Taxes?: number
  /** @format double */
  price_Shipping?: number
  /** @format double */
  price_Fees?: number
  /** @format double */
  price_Discounts?: number
  /** @format double */
  price_Total?: number
  /** @format double */
  cost_SubTotal?: number
  /** @format double */
  cost_Taxes?: number
  /** @format double */
  cost_Shipping?: number
  /** @format double */
  cost_Fees?: number
  /** @format double */
  cost_Discounts?: number
  /** @format double */
  cost_Total?: number
  /** @format double */
  salesTaxAmount?: number
  salesTaxDescription?: string
  /** @format double */
  shippingAmount?: number
  shippingCarrier?: string
  shippingDescription?: string
  shippingMethod?: string
  source?: string
  status?: 'Draft' | 'Released' | 'Cancelled'
  supplier?: MainStemSDKDataModelsBusinessPartner
  /** @format int32 */
  supplierID?: number
  /**
   * @format uuid
   * @example "00000000-0000-0000-0000-000000000000"
   */
  uuid?: string
}

export interface MainStemSDKDataModelsOrderSupplier {
  /** @format int32 */
  id?: number
  order?: MainStemSDKDataModelsOrder
  /** @format int32 */
  orderID?: number
  supplier?: MainStemSDKDataModelsBusinessPartner
  /** @format int32 */
  supplierID?: number
}

export interface MainStemSDKDataModelsProductListItem {
  /** @format int32 */
  id?: number
  product?: MainStemSDKDataModelsProduct
  /** @format int32 */
  productID?: number
  productList?: MainStemSDKDataModelsProductList
  /** @format int32 */
  productListID?: number
}

export interface MainStemSDKDataModelsProductListUser {
  /** @format int32 */
  id?: number
  productList?: MainStemSDKDataModelsProductList
  /** @format int32 */
  productListID?: number
  user?: MainStemSDKDataModelsApplicationUser
  userID?: string
}

export interface MainStemSDKDataModelsPermission {
  application?: 'Admin' | 'Purchasing' | 'Supplier' | 'Ecommerce'
  applicationAppliedTo?: string
  displayName?: string
  group?: string
  /** @format int32 */
  id?: number
  /** @format int32 */
  rank?: number
  shortCode?: string
  isDeleted?: boolean
}

export interface MainStemSDKDataModelsAttribute {
  /** @format int32 */
  id?: number
  isCannabisRelated?: boolean
  name?: string
}

export interface MainStemSDKDataModelsRFQLineItemSupplierBid {
  /** @format date-time */
  dateCreated?: string
  /** @format int32 */
  id?: number
  notes?: string
  productImage?: MainStemSDKDataModelsFile
  /** @format int32 */
  productImageID?: number
  products?: MainStemSDKDataModelsRFQLineItemSupplierBidProduct[]
  rfqLineItem?: MainStemSDKDataModelsRFQLineItem
  /** @format int32 */
  rfqLineItemID?: number
  sku?: string
  status?: 'CannotQuote' | 'New' | 'InProgress' | 'Complete'
  supplier?: MainStemSDKDataModelsBusinessPartner
  /** @format int32 */
  supplierID?: number
  /** @format double */
  targetPricePerUnitSupplier?: number
  /** @format double */
  targetValueSupplier?: number
}

export interface MainStemSDKDataModelsRFQLineItemSupplierInvite {
  /** @format date-time */
  dateCreated?: string
  /** @format int32 */
  id?: number
  rfqLineItem?: MainStemSDKDataModelsRFQLineItem
  /** @format int32 */
  rfqLineItemID?: number
  supplier?: MainStemSDKDataModelsBusinessPartner
  /** @format int32 */
  supplierID?: number
}

export interface MainStemSDKDataModelsRFQLineItemURL {
  /** @format date-time */
  dateCreated?: string
  description?: string
  /** @format int32 */
  id?: number
  rfqLineItem?: MainStemSDKDataModelsRFQLineItem
  /** @format int32 */
  rfqLineItemID?: number
  url?: string
  userCreatedBy?: MainStemSDKDataModelsApplicationUser
  userCreatedByID?: string
  viewableToCustomer?: boolean
  viewableToSupplier?: boolean
}

export interface MainStemSDKDataModelsBulkOrderPurchaseOrder {
  /** @format int32 */
  bulkOrderRequisitionID?: number
  bulkOrderRequisition?: MainStemSDKDataModelsBulkOrderRequisition
  /** @format date-time */
  dateCreated?: string
  /** @format int32 */
  id?: number
  lineItems?: MainStemSDKDataModelsBulkOrderPurchaseOrderLineItem[]
  /** @format int32 */
  newlyCreatedSupplierID?: number
  newlyCreatedSupplier?: MainStemSDKDataModelsBusinessPartner
  /** @format int32 */
  supplierID?: number
  supplier?: MainStemSDKDataModelsBusinessPartner
  supplierName?: string
  supplierEmail?: string
  terms?: string
}

export interface MainStemSDKDataModelsRFQAttachmentSupplier {
  /** @format int32 */
  id?: number
  rfqAttachment?: MainStemSDKDataModelsRFQAttachment
  /** @format int32 */
  rfqAttachmentID?: number
  supplier?: MainStemSDKDataModelsBusinessPartner
  /** @format int32 */
  supplierID?: number
}

export interface MainStemSDKDataModelsRFQCommentSupplier {
  /** @format int32 */
  id?: number
  rfqComment?: MainStemSDKDataModelsRFQComment
  /** @format int32 */
  rfqCommentID?: number
  supplier?: MainStemSDKDataModelsBusinessPartner
  /** @format int32 */
  supplierID?: number
}

export interface MainStemSDKDataModelsFulfillmentMethodLineItem {
  allocations?: MainStemSDKDataModelsInvoiceLineItemAllocation[]
  amazonLineItems?: MainStemSDKDataModelsFulfillmentMethodLineItemAmazonLineItem[]
  fulfillmentMethod?: MainStemSDKDataModelsFulfillmentMethod
  /** @format int32 */
  fulfillmentMethodID?: number
  hasBeenModified?: boolean
  /** @format int32 */
  id?: number
  isReconciled?: boolean
  orderLineItem?: MainStemSDKDataModelsOrderLineItem
  /** @format int32 */
  orderLineItemID?: number
  /** @format double */
  quantity?: number
  /** @format double */
  pricePerUnit?: number
  /** @format double */
  costPerUnit?: number
  /** @format double */
  priceSubTotal?: number
  /** @format double */
  costSubTotal?: number
  /** @format double */
  supplierPricePerItemActual?: number
  /** @format double */
  supplierPricePerItemExpected?: number
  /** @format double */
  taxAmount?: number
  taxJarJSON?: string
  /** @format double */
  taxRate?: number
  wasAdminCreated?: boolean
}

export interface MainStemSDKDataModelsPurchaseOrderDiscount {
  /** @format double */
  amount?: number
  /** @format date-time */
  dateCreated?: string
  /** @format int32 */
  id?: number
  notes?: string
  purchaseOrder?: MainStemSDKDataModelsPurchaseOrder
  /** @format int32 */
  purchaseOrderID?: number
  reason?: string
}

export interface MainStemSDKDataModelsPurchaseOrderFee {
  /** @format double */
  amount?: number
  /** @format date-time */
  dateCreated?: string
  /** @format int32 */
  id?: number
  notes?: string
  purchaseOrder?: MainStemSDKDataModelsPurchaseOrder
  /** @format int32 */
  purchaseOrderID?: number
  reason?: string
}

export interface MainStemSDKDataModelsPurchaseOrderLineItem {
  /** @format double */
  costPerItem?: number
  /** @format date-time */
  dateCreated?: string
  /** @format double */
  discountsPerItem?: number
  /** @format double */
  feesPerItem?: number
  /** @format int32 */
  id?: number
  /** @format double */
  pricePerItem?: number
  /** @format double */
  pricePerUnit?: number
  /** @format double */
  costPerUnit?: number
  /** @format double */
  priceSubTotal?: number
  /** @format double */
  costSubTotal?: number
  pricingType?: 'Retail' | 'Wholesale' | 'Enterprise'
  product?: MainStemSDKDataModelsProduct
  /** @format int32 */
  productID?: number
  purchaseOrder?: MainStemSDKDataModelsPurchaseOrder
  /** @format int32 */
  purchaseOrderID?: number
  /** @format double */
  quantity?: number
  /** @format double */
  salesTaxPerItem?: number
  /** @format double */
  shippingPerItem?: number
}

export interface MainStemSDKDataModelsRFQLineItemSupplierBidProduct {
  /** @format int32 */
  id?: number
  product?: MainStemSDKDataModelsProduct
  /** @format int32 */
  productID?: number
  rfqLineItemSupplierBid?: MainStemSDKDataModelsRFQLineItemSupplierBid
  /** @format int32 */
  rfqLineItemSupplierBidID?: number
}

export interface MainStemSDKDataModelsBulkOrderPurchaseOrderLineItem {
  /** @format int32 */
  bulkOrderPurchaseOrderID?: number
  bulkOrderPurchaseOrder?: MainStemSDKDataModelsBulkOrderPurchaseOrder
  /** @format int32 */
  bulkOrderUploadID?: number
  bulkOrderUpload?: MainStemSDKDataModelsBulkOrderUpload
  /** @format int32 */
  id?: number
  /** @format int32 */
  newlyCreatedProductID?: number
  newlyCreatedProduct?: MainStemSDKDataModelsProduct
  /** @format int32 */
  productID?: number
  product?: MainStemSDKDataModelsProduct
  productCategory?: string
  productDescription?: string
  productName?: string
  /** @format double */
  quantity?: number
  /** @format double */
  pricePerUnit?: number
}

export interface MainStemSDKDataModelsInvoiceLineItemAllocation {
  /** @format date-time */
  dateCreated?: string
  department?: MainStemSDKDataModelsDepartment
  /** @format int32 */
  departmentID?: number
  /** @format int32 */
  id?: number
  invoiceLineItem?: MainStemSDKDataModelsFulfillmentMethodLineItem
  /** @format int32 */
  invoiceLineItemID?: number
  isDeleted?: boolean
  /** @format int32 */
  quantity?: number
  userCreatedBy?: MainStemSDKDataModelsApplicationUser
  userCreatedByID?: string
}

export interface MainStemSDKDataModelsFulfillmentMethodLineItemAmazonLineItem {
  /** @format int32 */
  id?: number
  fulfillmentMethodLineItem?: MainStemSDKDataModelsFulfillmentMethodLineItem
  /** @format int32 */
  fulfillmentMethodLineItemID?: number
  amazonLineItemID?: string
}

export interface MainStemSDKDataModelsOrderLineItem {
  /** @format double */
  discountPerItem?: number
  distributorProductID?: string
  hasBeenModified?: boolean
  /** @format int32 */
  id?: number
  note?: string
  order?: MainStemSDKDataModelsOrder
  /** @format int32 */
  orderID?: number
  /** @format double */
  pricePerItem?: number
  /** @format double */
  pricePerUnit?: number
  /** @format double */
  costPerUnit?: number
  /** @format double */
  priceSubTotal?: number
  /** @format double */
  costSubTotal?: number
  pricePerItemReason?: string
  product?: MainStemSDKDataModelsProduct
  /** @format int32 */
  productID?: number
  /** @format double */
  quantity?: number
  /** @format double */
  supplierPricePerItem?: number
  wasAdminCreated?: boolean
}

export interface MainStemAPIPlatformControllersPurchasingCatalogCreateAPIResponse {
  /** @format int32 */
  id?: number
  message?: string
  wasSuccessful?: boolean
}

export interface MainStemAPIPlatformControllersPurchasingCatalogDeleteAPIRequest {
  /** @format int32 */
  catalogId?: number
}

export interface MainStemAPIPlatformControllersPurchasingCatalogDeleteAPIResponse {
  message?: string
  wasSuccessful?: boolean
}

export interface MainStemAPIPlatformControllersPurchasingCatalogDetailsAPIRequest {
  /** @format int32 */
  id: number
}

export interface MainStemAPIPlatformControllersPurchasingCatalogDetailsAPIResponse {
  catalog: MainStemAPIPlatformControllersPurchasingCatalogDetailsAPIResponseCatalogDetails
  message?: string
  wasSuccessful?: boolean
}

export interface MainStemAPIPlatformControllersPurchasingCatalogDetailsAPIResponseCatalogDetails {
  /** @format int32 */
  id: number
  isArchived: boolean
  isPrivate: boolean
  name: string
}

export interface MainStemAPIPlatformControllersPurchasingCatalogDuplicateAPIRequest {
  /** @format int32 */
  catalogId?: number
  name?: string
}

export interface MainStemAPIPlatformControllersPurchasingCatalogDuplicateAPIResponse {
  /** @format int32 */
  catalogId?: number
  message?: string
  wasSuccessful?: boolean
}

export interface MainStemAPIPlatformControllersPurchasingCatalogListAPIResponse {
  catalogs: MainStemAPIPlatformControllersPurchasingCatalogListAPIResponseCatalogDetails[]
  message?: string
  wasSuccessful?: boolean
}

export interface MainStemAPIPlatformControllersPurchasingCatalogListAPIResponseCatalogDetails {
  /** @format int32 */
  id: number
  isArchived: boolean
  isPrivate: boolean
  name: string
  /** @format int32 */
  productCount: number
  /** @format int32 */
  userCount: number
  userRelated: boolean
}

export interface MainStemAPIPlatformControllersPurchasingCatalogLocationsAddAPIRequest {
  locationIds?: number[]
  /** @format int32 */
  productListId?: number
}

export interface MainStemAPIPlatformControllersPurchasingCatalogLocationsAddAPIResponse {
  message?: string
  wasSuccessful?: boolean
}

export interface MainStemAPIPlatformControllersPurchasingCatalogLocationsListAPIRequest {
  /** @format int32 */
  catalogId?: number
}

export interface MainStemAPIPlatformControllersPurchasingCatalogLocationsListAPIResponse {
  locations?: MainStemAPIPlatformControllersPurchasingCatalogLocationsListAPIResponseLocationDetails[]
  message?: string
  wasSuccessful?: boolean
}

export interface MainStemAPIPlatformControllersPurchasingCatalogLocationsListAPIResponseLocationDetails {
  /** @format int32 */
  id?: number
  name?: string
}

export interface MainStemAPIPlatformControllersPurchasingCatalogLocationsRemoveAPIRequest {
  /** @format int32 */
  locationId?: number
  /** @format int32 */
  productListId?: number
}

export interface MainStemAPIPlatformControllersPurchasingCatalogLocationsRemoveAPIResponse {
  message?: string
  wasSuccessful?: boolean
}

export interface MainStemAPIPlatformControllersPurchasingCatalogProductsAddAPIRequest {
  catalogIds?: number[]
  productIds?: number[]
  baseRequest?: object
  /** @format int32 */
  customerID?: number
  /** @format int32 */
  businessPartnerId?: number
  businessPartners?: MainStemSDKDataModelsBusinessPartner[]
  /** @format int32 */
  locationID?: number
  isAdmin?: boolean
}

export interface MainStemAPIPlatformControllersPurchasingCatalogProductsAddAPIResponse {
  message?: string
  wasSuccessful?: boolean
}

export interface MainStemAPIPlatformControllersPurchasingCatalogProductsListAPIRequest {
  /** @format int32 */
  catalogId?: number
}

export interface MainStemAPIPlatformControllersPurchasingCatalogProductsListAPIResponse {
  products?: MainStemAPIPlatformControllersPurchasingCatalogProductsListAPIResponseProductDetails[]
  message?: string
  wasSuccessful?: boolean
}

export interface MainStemAPIPlatformControllersPurchasingCatalogProductsListAPIResponseProductDetails {
  /** @format int32 */
  id?: number
  imgURL?: string
  name?: string
}

export interface MainStemAPIPlatformControllersPurchasingCatalogProductsRemoveAPIRequest {
  /** @format int32 */
  productId?: number
  /** @format int32 */
  productListId?: number
}

export interface MainStemAPIPlatformControllersPurchasingCatalogProductsRemoveAPIResponse {
  message?: string
  wasSuccessful?: boolean
}

export interface MainStemAPIPlatformControllersPurchasingCatalogSuppliersListAPIRequest {
  /** @format int32 */
  catalogId?: number
}

export interface MainStemAPIPlatformControllersPurchasingCatalogSuppliersListAPIResponse {
  suppliers?: MainStemAPIPlatformControllersPurchasingCatalogSuppliersListAPIResponseSupplierDetails[]
  message?: string
  wasSuccessful?: boolean
}

export interface MainStemAPIPlatformControllersPurchasingCatalogSuppliersListAPIResponseSupplierDetails {
  /** @format int32 */
  id?: number
  image?: string
  inNetwork?: boolean
  name?: string
  usesDirectPay?: boolean
  usesPreferredShipping?: boolean
}

export interface MainStemAPIPlatformControllersPurchasingCatalogUpdateAPIRequest {
  /** @format int32 */
  id: number
  isPrivate: boolean
  name: string
}

export interface MainStemAPIPlatformControllersPurchasingCatalogUpdateAPIResponse {
  message?: string
  wasSuccessful?: boolean
}

export interface MainStemAPIPlatformControllersPurchasingCatalogUsersAddAPIRequest {
  /** @format int32 */
  catalogId: number
  userIds: string[]
}

export interface MainStemAPIPlatformControllersPurchasingCatalogUsersAddAPIResponse {
  message?: string
  wasSuccessful?: boolean
}

export interface MainStemAPIPlatformControllersPurchasingCatalogUsersListAPIRequest {
  /** @format int32 */
  catalogId: number
}

export interface MainStemAPIPlatformControllersPurchasingCatalogUsersListAPIResponse {
  users: MainStemAPIPlatformControllersPurchasingCatalogUsersListAPIResponseUserDetails[]
  message?: string
  wasSuccessful?: boolean
}

export interface MainStemAPIPlatformControllersPurchasingCatalogUsersListAPIResponseUserDetails {
  username: string
  uuid: string
}

export interface MainStemAPIPlatformControllersPurchasingCatalogUsersRemoveAPIRequest {
  /** @format int32 */
  productListId?: number
  userId?: string
}

export interface MainStemAPIPlatformControllersPurchasingCatalogUsersRemoveAPIResponse {
  message?: string
  wasSuccessful?: boolean
}

export interface MainStemAPIPlatformControllersPurchasingChangeLogListAPIRequest {
  documentId?: string
  documentType?: 'Requisition' | 'PurchaseOrder' | 'Invoice' | 'Shipment' | 'Payment'
}

export interface MainStemAPIPlatformControllersPurchasingChangeLogListAPIResponse {
  changeLogs?: MainStemSDKHelpersFactoriesChangeLogsModelsChangeLogRecord[]
  message?: string
  wasSuccessful?: boolean
}

export interface MainStemSDKHelpersFactoriesChangeLogsModelsChangeLogRecord {
  content?: string
  documentID?: string
  documentType?: 'Requisition' | 'PurchaseOrder' | 'Invoice' | 'Shipment' | 'Payment'
  env?: string
  eTag?: AzureETag
  partitionKey?: string
  reason?: string
  rowKey?: string
  /** @format date-time */
  timestamp?: string
  userIDCreatedBy?: string
}

export type AzureETag = object

export interface MainStemAPIPlatformControllersPurchasingContactSendMessageAPIRequest {
  comment?: string
  email?: string
  phone?: string
  reason?: string
}

export interface MainStemAPIPlatformControllersPurchasingCustomFieldCreateAPIRequest {
  dataModel?:
    | 'User'
    | 'Location'
    | 'Supplier'
    | 'Order'
    | 'Invoice'
    | 'Shipment'
    | 'Product'
    | 'Department'
    | 'OrderSupplier'
  name?: string
  showOnPDF?: boolean
  type?: 'ShortText' | 'LongText' | 'Number' | 'Date' | 'Boolean' | 'Currency'
}

export interface MainStemAPIPlatformControllersPurchasingCustomFieldCreateAPIResponse {
  message?: string
  wasSuccessful?: boolean
}

export interface MainStemAPIPlatformControllersPurchasingCustomFieldDeleteAPIRequest {
  /** @format int32 */
  id?: number
}

export interface MainStemAPIPlatformControllersPurchasingCustomFieldDeleteAPIResponse {
  message?: string
  wasSuccessful?: boolean
}

export interface MainStemAPIPlatformControllersPurchasingCustomFieldListAPIResponse {
  customFields?: MainStemAPIPlatformControllersPurchasingCustomFieldListAPIResponseCustomFieldDetails[]
  message?: string
  wasSuccessful?: boolean
}

export interface MainStemAPIPlatformControllersPurchasingCustomFieldListAPIResponseCustomFieldDetails {
  dataModel?:
    | 'User'
    | 'Location'
    | 'Supplier'
    | 'Order'
    | 'Invoice'
    | 'Shipment'
    | 'Product'
    | 'Department'
    | 'OrderSupplier'
  /** @format int32 */
  id?: number
  name?: string
  showOnPDF?: boolean
  type?: 'ShortText' | 'LongText' | 'Number' | 'Date' | 'Boolean' | 'Currency'
}

export interface MainStemAPIPlatformControllersPurchasingCustomFieldUpdateAPIRequest {
  /** @format int32 */
  id?: number
  name?: string
  showOnPDF?: boolean
}

export interface MainStemAPIPlatformControllersPurchasingCustomFieldUpdateAPIResponse {
  message?: string
  wasSuccessful?: boolean
}

export interface MainStemAPIPlatformControllersPurchasingCustomFieldValueAddAPIRequest {
  /** @format int32 */
  customFieldID?: number
  /** @format int32 */
  documentID?: number
  documentIDString?: string
  value?: string
}

export interface MainStemAPIPlatformControllersPurchasingCustomFieldValueAddAPIResponse {
  message?: string
  wasSuccessful?: boolean
}

export interface MainStemAPIPlatformControllersPurchasingCustomFieldValueListAPIRequest {
  dataModel?:
    | 'User'
    | 'Location'
    | 'Supplier'
    | 'Order'
    | 'Invoice'
    | 'Shipment'
    | 'Product'
    | 'Department'
    | 'OrderSupplier'
  /** @format int32 */
  documentId?: number
  documentIdString?: string
}

export interface MainStemAPIPlatformControllersPurchasingCustomFieldValueListAPIResponse {
  customFieldValues?: MainStemAPIPlatformControllersPurchasingCustomFieldValueListAPIResponseCustomFieldValueDetails[]
  message?: string
  wasSuccessful?: boolean
}

export interface MainStemAPIPlatformControllersPurchasingCustomFieldValueListAPIResponseCustomFieldValueDetails {
  field?: MainStemAPIPlatformControllersPurchasingCustomFieldValueListAPIResponseCustomFieldValueDetailsCustomFieldDetails
  /** @format int32 */
  id?: number
  value?: string
}

export interface MainStemAPIPlatformControllersPurchasingCustomFieldValueListAPIResponseCustomFieldValueDetailsCustomFieldDetails {
  /** @format int32 */
  id?: number
  name?: string
  type?: 'ShortText' | 'LongText' | 'Number' | 'Date' | 'Boolean' | 'Currency'
}

export interface MainStemAPIPlatformControllersPurchasingCustomFieldValueUpdateAPIRequest {
  /** @format int32 */
  customFieldValueId?: number
  value?: string
}

export interface MainStemAPIPlatformControllersPurchasingCustomFieldValueUpdateAPIResponse {
  message?: string
  wasSuccessful?: boolean
}

export interface MainStemAPIPlatformControllersPurchasingDashboardApprovalApprovalsByLocationDataAPIRequest {
  /** @format date-time */
  date?: string
}

export interface MainStemAPIPlatformControllersPurchasingDashboardApprovalApprovalsByLocationDataAPIResponse {
  data?: MainStemAPIPlatformControllersPurchasingDashboardApprovalApprovalsByLocationDataAPIResponseDataDetails[]
  message?: string
  wasSuccessful?: boolean
}

export interface MainStemAPIPlatformControllersPurchasingDashboardApprovalApprovalsByLocationDataAPIResponseDataDetails {
  /** @format int32 */
  count?: number
  location?: string
}

export interface MainStemAPIPlatformControllersPurchasingDashboardApprovalApprovalsByLocationOptionsAPIResponse {
  options?: MainStemAPIPlatformControllersPurchasingDashboardApprovalApprovalsByLocationOptionsAPIResponseOptionDetails[]
  message?: string
  wasSuccessful?: boolean
}

export interface MainStemAPIPlatformControllersPurchasingDashboardApprovalApprovalsByLocationOptionsAPIResponseOptionDetails {
  text?: string
  /** @format date-time */
  value?: string
}

export interface MainStemAPIPlatformControllersPurchasingDashboardApprovalOrdersMyApprovalAPIResponse {
  approvals?: MainStemAPIPlatformControllersPurchasingDashboardApprovalOrdersMyApprovalApprovalDetails[]
  message?: string
  wasSuccessful?: boolean
}

export interface MainStemAPIPlatformControllersPurchasingDashboardApprovalOrdersMyApprovalApprovalDetails {
  approvalLevel: MainStemAPIPlatformControllersPurchasingDashboardApprovalOrdersMyApprovalApprovalWorkflowDetails
  approvalStatus: 'Pending' | 'Approved' | 'Rejected'
  location: MainStemAPIPlatformControllersPurchasingDashboardApprovalOrdersMyApprovalLocation
  requisition: MainStemAPIPlatformControllersPurchasingDashboardApprovalOrdersMyApprovalApprovalDetailsRequisitionDetails
}

export interface MainStemAPIPlatformControllersPurchasingDashboardApprovalOrdersMyApprovalApprovalWorkflowDetails {
  /** @format int32 */
  id: number
  levelRange: string
  /** @format double */
  maxAmount: number
  /** @format double */
  minAmount: number
  users: MainStemAPIPlatformControllersPurchasingDashboardApprovalOrdersMyApprovalUserDetails[]
}

export interface MainStemAPIPlatformControllersPurchasingDashboardApprovalOrdersMyApprovalLocation {
  address1?: string
  address2?: string
  city?: string
  country?: string
  /** @format int32 */
  id?: number
  name?: string
  state?: string
  zip?: string
}

export interface MainStemAPIPlatformControllersPurchasingDashboardApprovalOrdersMyApprovalApprovalDetailsRequisitionDetails {
  /** @format date-time */
  dateSubmittedForApproval: string
  /** @format int32 */
  id: number
  name: string
  uuid: string
}

export interface MainStemAPIPlatformControllersPurchasingDashboardApprovalOrdersMyApprovalUserDetails {
  approvalType: 'Pending' | 'Approved' | 'Rejected'
  /** @format date-time */
  dateNotified: string
  /** @format date-time */
  dateOfDecision: string
  friendlyName: string
  id: string
  userName: string
}

export interface MainStemAPIPlatformControllersPurchasingDashboardApprovalOrdersOthersApprovalAPIResponse {
  approvals?: MainStemAPIPlatformControllersPurchasingDashboardApprovalOrdersOthersApprovalApprovalDetails[]
  message?: string
  wasSuccessful?: boolean
}

export interface MainStemAPIPlatformControllersPurchasingDashboardApprovalOrdersOthersApprovalApprovalDetails {
  approvalLevel?: MainStemAPIPlatformControllersPurchasingDashboardApprovalOrdersOthersApprovalApprovalWorkflowDetails
  approvalStatus?: 'Pending' | 'Approved' | 'Rejected'
  location?: MainStemAPIPlatformControllersPurchasingDashboardApprovalOrdersOthersApprovalLocation
  /** @format int32 */
  locationID?: number
  /** @format int32 */
  orderID?: number
  uuid?: string
}

export interface MainStemAPIPlatformControllersPurchasingDashboardApprovalOrdersOthersApprovalApprovalWorkflowDetails {
  /** @format int32 */
  id?: number
  levelRange?: string
  /** @format double */
  maxAmount?: number
  /** @format double */
  minAmount?: number
  users?: MainStemAPIPlatformControllersPurchasingDashboardApprovalOrdersOthersApprovalUserDetails[]
}

export interface MainStemAPIPlatformControllersPurchasingDashboardApprovalOrdersOthersApprovalLocation {
  address1?: string
  address2?: string
  city?: string
  country?: string
  /** @format int32 */
  id?: number
  name?: string
  state?: string
  zip?: string
}

export interface MainStemAPIPlatformControllersPurchasingDashboardApprovalOrdersOthersApprovalUserDetails {
  approvalType?: 'Pending' | 'Approved' | 'Rejected'
  /** @format date-time */
  dateNotified?: string
  /** @format date-time */
  dateOfDecision?: string
  friendlyName?: string
  id?: string
  userName?: string
}

export interface MainStemAPIPlatformControllersPurchasingDashboardApprovalTotalApprovalsDataAPIRequest {
  /** @format date-time */
  date?: string
}

export interface MainStemAPIPlatformControllersPurchasingDashboardApprovalTotalApprovalsDataAPIResponse {
  data?: MainStemAPIPlatformControllersPurchasingDashboardApprovalTotalApprovalsDataAPIResponseDataDetails[]
  message?: string
  wasSuccessful?: boolean
}

export interface MainStemAPIPlatformControllersPurchasingDashboardApprovalTotalApprovalsDataAPIResponseDataDetails {
  /** @format int32 */
  count?: number
  /** @format date-time */
  date?: string
}

export interface MainStemAPIPlatformControllersPurchasingDashboardApprovalTotalApprovalsOptionsAPIResponse {
  options?: MainStemAPIPlatformControllersPurchasingDashboardApprovalTotalApprovalsOptionsAPIResponseOptionDetails[]
  message?: string
  wasSuccessful?: boolean
}

export interface MainStemAPIPlatformControllersPurchasingDashboardApprovalTotalApprovalsOptionsAPIResponseOptionDetails {
  text?: string
  /** @format date-time */
  value?: string
}

export interface MainStemAPIPlatformControllersPurchasingDashboardBudgetsAPIRequest {
  /** @format int32 */
  month?: number
  /** @format int32 */
  year?: number
}

export interface MainStemAPIPlatformControllersPurchasingDashboardBudgetsAPIResponse {
  locations?: MainStemAPIPlatformControllersPurchasingDashboardBudgetsAPIResponseLocationBudgetDetails[]
  message?: string
  wasSuccessful?: boolean
}

export interface MainStemAPIPlatformControllersPurchasingDashboardBudgetsAPIResponseLocationBudgetDetails {
  /** @format double */
  budget?: number
  location?: MainStemAPIPlatformControllersPurchasingDashboardBudgetsAPIResponseLocationBudgetDetailsLocationDetails
  /** @format double */
  spend?: number
}

export interface MainStemAPIPlatformControllersPurchasingDashboardBudgetsAPIResponseLocationBudgetDetailsLocationDetails {
  address?: MainStemAPIPlatformControllersPurchasingDashboardBudgetsAPIResponseLocationBudgetDetailsLocationDetailsAddressDetails
  /** @format int32 */
  id?: number
  name?: string
}

export interface MainStemAPIPlatformControllersPurchasingDashboardBudgetsAPIResponseLocationBudgetDetailsLocationDetailsAddressDetails {
  address1?: string
  address2?: string
  city?: string
  country?: string
  state?: string
  zip?: string
}

export interface MainStemAPIPlatformControllersPurchasingDashboardFinanceOrderApprovalsAPIResponse {
  approvals?: MainStemAPIPlatformControllersPurchasingDashboardFinanceOrderApprovalsApprovalDetails[]
  message?: string
  wasSuccessful?: boolean
}

export interface MainStemAPIPlatformControllersPurchasingDashboardFinanceOrderApprovalsApprovalDetails {
  approvalLevel?: MainStemAPIPlatformControllersPurchasingDashboardFinanceOrderApprovalsApprovalWorkflowDetails
  approvalStatus?: 'Pending' | 'Approved' | 'Rejected'
  location?: MainStemAPIPlatformControllersPurchasingDashboardFinanceOrderApprovalsLocation
  /** @format int32 */
  locationID?: number
  /** @format int32 */
  orderID?: number
  userRelated?: boolean
  uuid?: string
}

export interface MainStemAPIPlatformControllersPurchasingDashboardFinanceOrderApprovalsApprovalWorkflowDetails {
  /** @format int32 */
  id?: number
  levelRange?: string
  /** @format double */
  maxAmount?: number
  /** @format double */
  minAmount?: number
  users?: MainStemAPIPlatformControllersPurchasingDashboardFinanceOrderApprovalsUserDetails[]
}

export interface MainStemAPIPlatformControllersPurchasingDashboardFinanceOrderApprovalsLocation {
  address1?: string
  address2?: string
  city?: string
  country?: string
  /** @format int32 */
  id?: number
  name?: string
  state?: string
  zip?: string
}

export interface MainStemAPIPlatformControllersPurchasingDashboardFinanceOrderApprovalsUserDetails {
  approvalType?: 'Pending' | 'Approved' | 'Rejected'
  /** @format date-time */
  dateNotified?: string
  /** @format date-time */
  dateOfDecision?: string
  friendlyName?: string
  id?: string
  userName?: string
}

export interface MainStemAPIPlatformControllersPurchasingDashboardFinanceOpenInvoicesAPIResponse {
  invoices?: MainStemAPIPlatformControllersPurchasingDashboardFinanceOpenInvoicesAPIResponseInvoiceDetails[]
  message?: string
  wasSuccessful?: boolean
}

export interface MainStemAPIPlatformControllersPurchasingDashboardFinanceOpenInvoicesAPIResponseInvoiceDetails {
  /** @format int32 */
  customerIntegrationSessionID?: number
  /** @format date-time */
  dateApproved?: string
  /** @format date-time */
  dateDue?: string
  /** @format date-time */
  dateShipped?: string
  /** @format double */
  discount?: number
  /** @format date-time */
  dueAsOf?: string
  hasTermsApplied?: boolean
  /** @format int32 */
  id?: number
  invoiceId?: string
  /** @format double */
  invoiceSubTotal?: number
  invoiceTermsIsDue?: boolean
  /** @format double */
  invoiceTotal?: number
  isPrivateSupplier?: boolean
  isPunchOut?: boolean
  location?: MainStemAPIPlatformControllersPurchasingDashboardFinanceOpenInvoicesAPIResponseInvoiceDetailsLocationDetails
  /** @format int32 */
  orderId?: number
  orderUUID?: string
  /** @format double */
  salesTax?: number
  /** @format double */
  shipping?: number
  status?: string
  supplier?: MainStemAPIPlatformControllersPurchasingDashboardFinanceOpenInvoicesAPIResponseInvoiceDetailsSupplierDetails
  /** @format int32 */
  supplierID?: number
  supplierName?: string
  /** @format int32 */
  termLedgerID?: number
  /** @format double */
  totalDue?: number
  /** @format double */
  totalPaid?: number
  /** @format double */
  totalReturned?: number
  userApprovedBy?: string
  userRelated?: boolean
}

export interface MainStemAPIPlatformControllersPurchasingDashboardFinanceOpenInvoicesAPIResponseInvoiceDetailsLocationDetails {
  address1?: string
  address2?: string
  city?: string
  country?: string
  /** @format int32 */
  id?: number
  name?: string
  state?: string
  zip?: string
}

export interface MainStemAPIPlatformControllersPurchasingDashboardFinanceOpenInvoicesAPIResponseInvoiceDetailsSupplierDetails {
  /** @format int32 */
  id: number
  name: string
}

export interface MainStemAPIPlatformControllersPurchasingDashboardFinanceOpenOrdersAPIResponse {
  orders?: MainStemAPIPlatformControllersPurchasingDashboardFinanceOpenOrdersAPIResponseOrderDetails[]
  message?: string
  wasSuccessful?: boolean
}

export interface MainStemAPIPlatformControllersPurchasingDashboardFinanceOpenOrdersAPIResponseOrderDetails {
  /** @format date-time */
  dateApproved?: string
  /** @format double */
  discount?: number
  hasTermsApplied?: boolean
  /** @format int32 */
  id?: number
  location?: MainStemAPIPlatformControllersPurchasingDashboardFinanceOpenOrdersAPIResponseOrderDetailsLocationDetails
  /** @format double */
  orderTotal?: number
  /** @format double */
  salesTax?: number
  /** @format double */
  shipping?: number
  status?: string
  /** @format double */
  subTotal?: number
  /** @format double */
  totalDue?: number
  /** @format double */
  totalPaid?: number
  /** @format double */
  totalReturned?: number
  userApprovedBy?: string
  userRelated?: boolean
  uuid?: string
}

export interface MainStemAPIPlatformControllersPurchasingDashboardFinanceOpenOrdersAPIResponseOrderDetailsLocationDetails {
  address1?: string
  address2?: string
  city?: string
  country?: string
  /** @format int32 */
  id?: number
  name?: string
  state?: string
  zip?: string
}

export interface MainStemAPIPlatformControllersPurchasingDashboardFinancePaymentsAPIResponse {
  payments?: MainStemAPIPlatformControllersPurchasingDashboardFinancePaymentsAPIResponsePaymentDetails[]
  message?: string
  wasSuccessful?: boolean
}

export interface MainStemAPIPlatformControllersPurchasingDashboardFinancePaymentsAPIResponsePaymentDetails {
  /** @format double */
  amount?: number
  /** @format date-time */
  dateCreated?: string
  /** @format int32 */
  id?: number
  location?: MainStemAPIPlatformControllersPurchasingDashboardFinancePaymentsAPIResponsePaymentDetailsLocationDetails
  orderID?: string
  orderUUID?: string
  status?: string
  type?: string
}

export interface MainStemAPIPlatformControllersPurchasingDashboardFinancePaymentsAPIResponsePaymentDetailsLocationDetails {
  /** @format int32 */
  id?: number
  name?: string
}

export interface MainStemAPIPlatformControllersPurchasingDashboardFinanceSalesByLocationDataAPIRequest {
  /** @format date-time */
  date?: string
}

export interface MainStemAPIPlatformControllersPurchasingDashboardFinanceSalesByLocationDataAPIResponse {
  data?: MainStemAPIPlatformControllersPurchasingDashboardFinanceSalesByLocationDataAPIResponseDataDetails[]
  message?: string
  wasSuccessful?: boolean
}

export interface MainStemAPIPlatformControllersPurchasingDashboardFinanceSalesByLocationDataAPIResponseDataDetails {
  /** @format double */
  amount?: number
  location?: string
}

export interface MainStemAPIPlatformControllersPurchasingDashboardFinanceSalesByLocationOptionsAPIResponse {
  options?: MainStemAPIPlatformControllersPurchasingDashboardFinanceSalesByLocationOptionsAPIResponseOptionDetails[]
  message?: string
  wasSuccessful?: boolean
}

export interface MainStemAPIPlatformControllersPurchasingDashboardFinanceSalesByLocationOptionsAPIResponseOptionDetails {
  text?: string
  /** @format date-time */
  value?: string
}

export interface MainStemAPIPlatformControllersPurchasingDashboardFinanceTermsLedgerAPIResponse {
  ledger?: MainStemAPIPlatformControllersPurchasingDashboardFinanceTermsLedgerAPIResponseTermLedger[]
  message?: string
  wasSuccessful?: boolean
}

export interface MainStemAPIPlatformControllersPurchasingDashboardFinanceTermsLedgerAPIResponseTermLedger {
  /** @format double */
  amount?: number
  /** @format date-time */
  date?: string
  description?: string
  visible?: boolean
  /** @format int32 */
  orderID?: number
  orderUUID?: string
  /** @format double */
  total?: number
}

export interface MainStemAPIPlatformControllersPurchasingDashboardFinanceTotalSalesDataAPIRequest {
  /** @format date-time */
  date?: string
}

export interface MainStemAPIPlatformControllersPurchasingDashboardFinanceTotalSalesDataAPIResponse {
  data?: MainStemAPIPlatformControllersPurchasingDashboardFinanceTotalSalesDataAPIResponseDataDetails[]
  message?: string
  wasSuccessful?: boolean
}

export interface MainStemAPIPlatformControllersPurchasingDashboardFinanceTotalSalesDataAPIResponseDataDetails {
  /** @format double */
  amount?: number
  /** @format date-time */
  date?: string
}

export interface MainStemAPIPlatformControllersPurchasingDashboardFinanceTotalSalesOptionsAPIResponse {
  options?: MainStemAPIPlatformControllersPurchasingDashboardFinanceTotalSalesOptionsAPIResponseOptionDetails[]
  message?: string
  wasSuccessful?: boolean
}

export interface MainStemAPIPlatformControllersPurchasingDashboardFinanceTotalSalesOptionsAPIResponseOptionDetails {
  text?: string
  /** @format date-time */
  value?: string
}

export interface MainStemAPIPlatformControllersPurchasingDashboardFinanceUsersAPIResponse {
  users?: MainStemAPIPlatformControllersPurchasingDashboardFinanceUsersAPIResponseUserDetails[]
  message?: string
  wasSuccessful?: boolean
}

export interface MainStemAPIPlatformControllersPurchasingDashboardFinanceUsersAPIResponseUserDetails {
  /** @format date-time */
  dateCreated?: string
  email?: string
  friendlyName?: string
  role?: string
  username?: string
  uuid?: string
  permissionGroup?: string
}

export interface MainStemAPIPlatformControllersPurchasingDashboardPurchasingGetMapDetailDeprecateAPIRequest {
  /** @format int32 */
  locationId?: number
  /** @format date-time */
  endDate?: string
  /** @format date-time */
  startDate?: string
}

export interface MainStemAPIPlatformControllersPurchasingDashboardPurchasingGetMapDetailDeprecateAPIResponse {
  address?: MainStemAPIPlatformControllersPurchasingDashboardPurchasingGetMapDetailDeprecateAPIResponseAddressDetails
  errorMessage?: string
  /** @format int32 */
  locationId?: number
  name?: string
  ordersAwaitingApproval?: MainStemAPIPlatformControllersPurchasingDashboardPurchasingGetMapDetailDeprecateOrdersAwaitingApproval[]
  ordersInTransit?: MainStemAPIPlatformControllersPurchasingDashboardPurchasingGetMapDetailDeprecateOrdersInTransit[]
  /** @format double */
  totalMonthlySpend?: number
  users?: MainStemAPIPlatformControllersPurchasingDashboardPurchasingGetMapDetailDeprecateUsersAtLocation[]
  message?: string
  wasSuccessful?: boolean
}

export interface MainStemAPIPlatformControllersPurchasingDashboardPurchasingGetMapDetailDeprecateAPIResponseAddressDetails {
  address1?: string
  address2?: string
  city?: string
  country?: string
  state?: string
  zip?: string
}

export interface MainStemAPIPlatformControllersPurchasingDashboardPurchasingGetMapDetailDeprecateOrdersAwaitingApproval {
  /** @format date-time */
  dateCreated?: string
  /** @format int32 */
  orderID?: number
  vendors?: MainStemAPIPlatformControllersPurchasingDashboardPurchasingGetMapDetailDeprecateLocation[]
}

export interface MainStemAPIPlatformControllersPurchasingDashboardPurchasingGetMapDetailDeprecateOrdersInTransit {
  /** @format date-time */
  dateApproved?: string
  /** @format date-time */
  dateCreated?: string
  /** @format date-time */
  dateShipped?: string
  /** @format int32 */
  fulfillmentID?: number
  /** @format int32 */
  orderID?: number
  vendor?: MainStemAPIPlatformControllersPurchasingDashboardPurchasingGetMapDetailDeprecateLocation
}

export interface MainStemAPIPlatformControllersPurchasingDashboardPurchasingGetMapDetailDeprecateUsersAtLocation {
  email?: string
  friendlyName?: string
  isPrimaryUser?: boolean
  userID?: string
  userName?: string
}

export interface MainStemAPIPlatformControllersPurchasingDashboardPurchasingGetMapDetailDeprecateLocation {
  address1?: string
  address2?: string
  city?: string
  country?: string
  /** @format int32 */
  locationID?: number
  locationName?: string
  state?: string
  zip?: string
}

export interface MainStemAPIPlatformControllersPurchasingLocationsDetailsInvoicesAwaitingShipmentAPIRequest {
  /** @format int32 */
  locationId?: number
}

export interface MainStemAPIPlatformControllersPurchasingLocationsDetailsInvoicesAwaitingShipmentAPIResponse {
  invoicesAwaitingShipment?: MainStemAPIPlatformControllersPurchasingLocationsDetailsInvoicesAwaitingShipmentInvoiceDetail[]
  message?: string
  wasSuccessful?: boolean
}

export interface MainStemAPIPlatformControllersPurchasingLocationsDetailsInvoicesAwaitingShipmentInvoiceDetail {
  /** @format date-time */
  dateApproved?: string
  /** @format date-time */
  dateCreated?: string
  /** @format date-time */
  dateShipped?: string
  /** @format int32 */
  fulfillmentID?: number
  location?: MainStemAPIPlatformControllersPurchasingLocationsDetailsInvoicesAwaitingShipmentLocation
  /** @format int32 */
  orderID?: number
  /** @format double */
  total?: number
  vendor?: MainStemAPIPlatformControllersPurchasingLocationsDetailsInvoicesAwaitingShipmentLocation
}

export interface MainStemAPIPlatformControllersPurchasingLocationsDetailsInvoicesAwaitingShipmentLocation {
  address1?: string
  address2?: string
  city?: string
  country?: string
  /** @format int32 */
  locationID?: number
  locationName?: string
  state?: string
  zip?: string
}

export interface MainStemAPIPlatformControllersPurchasingLocationsDetailsOrderApprovalsAPIRequest {
  /** @format int32 */
  locationId?: number
}

export interface MainStemAPIPlatformControllersPurchasingLocationsDetailsOrderApprovalsAPIResponse {
  ordersForApproval?: MainStemAPIPlatformControllersPurchasingLocationsDetailsOrderApprovalsOrderForApproval[]
  message?: string
  wasSuccessful?: boolean
}

export interface MainStemAPIPlatformControllersPurchasingLocationsDetailsOrderApprovalsOrderForApproval {
  actionRequiredCommunication?: MainStemSDKDataModelsOrderCommunication[]
  approvalStatus?: 'SavedCart' | 'AwaitingApproval' | 'Approval' | 'ApprovalWithEdits' | 'Rejected'
  /** @format date-time */
  approvalStatusAsOfDate?: string
  /** @format date-time */
  dateCreated?: string
  location?: MainStemAPIPlatformControllersPurchasingLocationsDetailsOrderApprovalsLocation
  /** @format int32 */
  orderID?: number
  /** @format int32 */
  totalNumberOfProducts?: number
  /** @format int32 */
  totalNumberOfVendors?: number
  /** @format double */
  totalOrderLineItemCost?: number
  userCreatedBy?: string
  userRelated?: boolean
  uuid?: string
}

export interface MainStemSDKDataModelsOrderCommunication {
  actionResolved?: boolean
  actionResolvedBy?: string
  businessPartner?: MainStemSDKDataModelsBusinessPartner
  /** @format int32 */
  businessPartnerID?: number
  comment?: string
  createdByUser?: MainStemSDKDataModelsApplicationUser
  /** @format date-time */
  dateCreated?: string
  /** @format date-time */
  dateModified?: string
  /** @format date-time */
  dateResolved?: string
  /** @format int32 */
  fulfillmentID?: number
  fulfillmentMethod?: MainStemSDKDataModelsFulfillmentMethod
  /** @format int32 */
  id?: number
  isDeleted?: boolean
  order?: MainStemSDKDataModelsOrder
  /** @format int32 */
  orderID?: number
  requiresAction?: boolean
  resolvedByUser?: MainStemSDKDataModelsApplicationUser
  userCreatedBy?: string
}

export interface MainStemAPIPlatformControllersPurchasingLocationsDetailsOrderApprovalsLocation {
  address1?: string
  address2?: string
  city?: string
  country?: string
  /** @format int32 */
  id?: number
  name?: string
  state?: string
  zip?: string
}

export type MainStemAPIPlatformControllersPurchasingDashboardPurchasingPurchaseOrdersAwaitingAcceptanceAPIRequest =
  object

export interface MainStemAPIPlatformControllersPurchasingDashboardPurchasingPurchaseOrdersAwaitingAcceptanceAPIResponse {
  errorMessage?: string
  purchaseOrders?: MainStemAPIPlatformControllersPurchasingDashboardPurchasingPurchaseOrdersAwaitingAcceptancePurchaseOrderForApproval[]
  message?: string
  wasSuccessful?: boolean
}

export interface MainStemAPIPlatformControllersPurchasingDashboardPurchasingPurchaseOrdersAwaitingAcceptancePurchaseOrderForApproval {
  acceptanceStatus?: 'Cancelled' | 'Pending' | 'Accepted' | 'Rejected'
  acknowledgedBy?: string
  acknowledgedByUserId?: string
  acknowledgementType?: 'MainStemPixel' | 'SupplierCoreOrderDetails' | 'Integration'
  approvalStatus?: 'SavedCart' | 'AwaitingApproval' | 'Approval' | 'ApprovalWithEdits' | 'Rejected'
  /** @format date-time */
  approvalStatusAsOfDate?: string
  /** @format date-time */
  dateAccepted?: string
  /** @format date-time */
  dateAcknowledged?: string
  /** @format date-time */
  dateCreated?: string
  /** @format int32 */
  fulfillmentID?: number
  location?: MainStemAPIPlatformControllersPurchasingDashboardPurchasingPurchaseOrdersAwaitingAcceptanceLocation
  /** @format int32 */
  orderID?: number
  /** @format int32 */
  supplierID?: number
  supplierLogoURL?: string
  supplierName?: string
  /** @format double */
  totalCost?: number
  /** @format double */
  totalNumberOfProducts?: number
  userCreatedBy?: string
  userRelated?: boolean
  uuid?: string
}

export interface MainStemAPIPlatformControllersPurchasingDashboardPurchasingPurchaseOrdersAwaitingAcceptanceLocation {
  address1?: string
  address2?: string
  city?: string
  country?: string
  /** @format int32 */
  id?: number
  name?: string
  state?: string
  zip?: string
}

export type MainStemAPIPlatformControllersPurchasingDashboardPurchasingPurchaseOrdersAwaitingAcknowledgementAPIRequest =
  object

export interface MainStemAPIPlatformControllersPurchasingDashboardPurchasingPurchaseOrdersAwaitingAcknowledgementAPIResponse {
  errorMessage?: string
  purchaseOrders?: MainStemAPIPlatformControllersPurchasingDashboardPurchasingPurchaseOrdersAwaitingAcknowledgementPurchaseOrderForApproval[]
  message?: string
  wasSuccessful?: boolean
}

export interface MainStemAPIPlatformControllersPurchasingDashboardPurchasingPurchaseOrdersAwaitingAcknowledgementPurchaseOrderForApproval {
  acceptanceStatus?: 'Cancelled' | 'Pending' | 'Accepted' | 'Rejected'
  acknowledgedBy?: string
  acknowledgedByUserId?: string
  acknowledgementType?: 'MainStemPixel' | 'SupplierCoreOrderDetails' | 'Integration'
  approvalStatus?: 'SavedCart' | 'AwaitingApproval' | 'Approval' | 'ApprovalWithEdits' | 'Rejected'
  /** @format date-time */
  approvalStatusAsOfDate?: string
  /** @format date-time */
  dateAccepted?: string
  /** @format date-time */
  dateAcknowledged?: string
  /** @format date-time */
  dateCreated?: string
  /** @format int32 */
  fulfillmentID?: number
  location?: MainStemAPIPlatformControllersPurchasingDashboardPurchasingPurchaseOrdersAwaitingAcknowledgementLocation
  /** @format int32 */
  orderID?: number
  /** @format int32 */
  supplierID?: number
  supplierLogoURL?: string
  supplierName?: string
  /** @format double */
  totalCost?: number
  /** @format double */
  totalNumberOfProducts?: number
  userCreatedBy?: string
  userRelated?: boolean
  uuid?: string
}

export interface MainStemAPIPlatformControllersPurchasingDashboardPurchasingPurchaseOrdersAwaitingAcknowledgementLocation {
  address1?: string
  address2?: string
  city?: string
  country?: string
  /** @format int32 */
  id?: number
  name?: string
  state?: string
  zip?: string
}

export interface MainStemAPIPlatformControllersPurchasingDashboardPurchasingOrderApprovalsAPIResponse {
  approvals?: MainStemAPIPlatformControllersPurchasingDashboardPurchasingOrderApprovalsApprovalDetails[]
  message?: string
  wasSuccessful?: boolean
}

export interface MainStemAPIPlatformControllersPurchasingDashboardPurchasingOrderApprovalsApprovalDetails {
  approvalLevel?: MainStemAPIPlatformControllersPurchasingDashboardPurchasingOrderApprovalsApprovalWorkflowDetails
  approvalStatus?: 'Pending' | 'Approved' | 'Rejected'
  location?: MainStemAPIPlatformControllersPurchasingDashboardPurchasingOrderApprovalsLocation
  /** @format int32 */
  locationID?: number
  /** @format int32 */
  orderID?: number
  userRelated?: boolean
  uuid?: string
}

export interface MainStemAPIPlatformControllersPurchasingDashboardPurchasingOrderApprovalsApprovalWorkflowDetails {
  /** @format int32 */
  id?: number
  levelRange?: string
  /** @format double */
  maxAmount?: number
  /** @format double */
  minAmount?: number
  users?: MainStemAPIPlatformControllersPurchasingDashboardPurchasingOrderApprovalsUserDetails[]
}

export interface MainStemAPIPlatformControllersPurchasingDashboardPurchasingOrderApprovalsLocation {
  address1?: string
  address2?: string
  city?: string
  country?: string
  /** @format int32 */
  id?: number
  name?: string
  state?: string
  zip?: string
}

export interface MainStemAPIPlatformControllersPurchasingDashboardPurchasingOrderApprovalsUserDetails {
  approvalType?: 'Pending' | 'Approved' | 'Rejected'
  /** @format date-time */
  dateNotified?: string
  /** @format date-time */
  dateOfDecision?: string
  friendlyName?: string
  id?: string
  userName?: string
}

export interface MainStemAPIPlatformControllersPurchasingDashboardPurchasingGetOrganizationSpendDeprecateAPIRequest {
  /** @format date-time */
  endDate?: string
  /** @format date-time */
  startDate?: string
}

export interface MainStemAPIPlatformControllersPurchasingDashboardPurchasingGetOrganizationSpendDeprecateAPIResponse {
  errorMessage?: string
  spendingByEntityLocations?: MainStemAPIPlatformControllersPurchasingDashboardPurchasingGetOrganizationSpendDeprecateTotalSalesByBusinessPartner[]
  spendingByUsers?: MainStemAPIPlatformControllersPurchasingDashboardPurchasingGetOrganizationSpendDeprecateDistinctOrdersByUsers[]
  spendingPerVendors?: MainStemAPIPlatformControllersPurchasingDashboardPurchasingGetOrganizationSpendDeprecatePurchasesByVendor[]
  message?: string
  wasSuccessful?: boolean
}

export interface MainStemAPIPlatformControllersPurchasingDashboardPurchasingGetOrganizationSpendDeprecateTotalSalesByBusinessPartner {
  distinctOrdersByUsers?: MainStemAPIPlatformControllersPurchasingDashboardPurchasingGetOrganizationSpendDeprecateDistinctOrdersByUsers[]
  /** @format int32 */
  ordersMade?: number
  /** @format double */
  totalOrderCost?: number
  /** @format double */
  totalProductCost?: number
  /** @format double */
  totalShippingCost?: number
  /** @format double */
  totalTaxCost?: number
  address1?: string
  address2?: string
  city?: string
  country?: string
  /** @format int32 */
  locationID?: number
  locationName?: string
  state?: string
  zip?: string
}

export interface MainStemAPIPlatformControllersPurchasingDashboardPurchasingGetOrganizationSpendDeprecateDistinctOrdersByUsers {
  invoices?: MainStemSDKModelsInvoicesInvoiceBalanceDetails[]
  /** @format int32 */
  ordersMade?: number
  /** @format double */
  totalOrderCost?: number
  /** @format double */
  totalProductCost?: number
  /** @format double */
  totalShippingCost?: number
  /** @format double */
  totalTaxCost?: number
  userID?: string
  userName?: string
  address1?: string
  address2?: string
  city?: string
  country?: string
  /** @format int32 */
  locationID?: number
  locationName?: string
  state?: string
  zip?: string
}

export interface MainStemAPIPlatformControllersPurchasingDashboardPurchasingGetOrganizationSpendDeprecatePurchasesByVendor {
  orderShippingCosts?: MainStemAPIPlatformControllersPurchasingDashboardPurchasingGetOrganizationSpendDeprecateOrderShippingCost[]
  orderTaxCosts?: MainStemAPIPlatformControllersPurchasingDashboardPurchasingGetOrganizationSpendDeprecateOrderTaxCost[]
  /** @format int32 */
  productCount?: number
  purchaseProducts?: MainStemAPIPlatformControllersPurchasingDashboardPurchasingGetOrganizationSpendDeprecatePurchaseProductDetail[]
  /** @format double */
  totalOrderCost?: number
  /** @format double */
  totalProductCost?: number
  /** @format double */
  totalShippingCost?: number
  /** @format double */
  totalTaxCost?: number
  /** @format int32 */
  vendorID?: number
  vendorName?: string
  address1?: string
  address2?: string
  city?: string
  country?: string
  /** @format int32 */
  locationID?: number
  locationName?: string
  state?: string
  zip?: string
}

export interface MainStemSDKModelsInvoicesInvoiceBalanceDetails {
  /** @format double */
  allFulfillmentTotals?: number
  /** @format int32 */
  supplierId?: number
  supplierName?: string
  /** @format date-time */
  dateShippedOn?: string
  /** @format double */
  discount?: number
  /** @format int32 */
  invoiceId?: number
  id?: string
  /** @format double */
  invoicePaymentsMade?: number
  /** @format double */
  subTotal?: number
  /** @format int32 */
  orderId?: number
  /** @format double */
  orderPaymentsMade?: number
  /** @format double */
  salesTax?: number
  /** @format double */
  shippingCost?: number
  termsApplied?: boolean
  /** @format double */
  total?: number
  userId?: string
  userName?: string
  isPrivate?: boolean
}

export interface MainStemAPIPlatformControllersPurchasingDashboardPurchasingGetOrganizationSpendDeprecateOrderShippingCost {
  /** @format int32 */
  fulfillmentMethodID?: number
  /** @format int32 */
  orderID?: number
  /** @format double */
  shippingCost?: number
}

export interface MainStemAPIPlatformControllersPurchasingDashboardPurchasingGetOrganizationSpendDeprecateOrderTaxCost {
  /** @format int32 */
  fulfillmentMethodID?: number
  /** @format int32 */
  orderID?: number
  /** @format double */
  taxCost?: number
}

export interface MainStemAPIPlatformControllersPurchasingDashboardPurchasingGetOrganizationSpendDeprecatePurchaseProductDetail {
  /** @format int32 */
  productID?: number
  /** @format int32 */
  quantity?: number
  /** @format double */
  totalCost?: number
}

export interface MainStemAPIPlatformControllersPurchasingDashboardPurchasingMapAPIResponse {
  errorMessage?: string
  locations?: MainStemAPIPlatformControllersPurchasingDashboardPurchasingMapLocation[]
  markers?: MainStemAPIPlatformControllersPurchasingDashboardPurchasingMapMarkerLocation[]
  message?: string
  wasSuccessful?: boolean
}

export interface MainStemAPIPlatformControllersPurchasingDashboardPurchasingMapLocation {
  address1?: string
  address2?: string
  city?: string
  country?: string
  /** @format int32 */
  id?: number
  /** @format double */
  latitude?: number
  /** @format double */
  longitude?: number
  name?: string
  state?: string
  zip?: string
}

export interface MainStemAPIPlatformControllersPurchasingDashboardPurchasingMapMarkerLocation {
  address?: MainStemAPIPlatformControllersPurchasingDashboardPurchasingMapAddressInfo
  /** @format int32 */
  id?: number
  /** @format double */
  lat?: number
  /** @format double */
  lon?: number
  name?: string
  popup?: object
}

export interface MainStemAPIPlatformControllersPurchasingDashboardPurchasingMapAddressInfo {
  address1?: string
  address2?: string
  city?: string
  country?: string
  state?: string
  zip?: string
}

export interface MainStemAPIPlatformControllersPurchasingDashboardPurchasingMapDetailAPIRequest {
  /** @format int32 */
  locationId?: number
  /** @format date-time */
  endDate?: string
  /** @format date-time */
  startDate?: string
}

export interface MainStemAPIPlatformControllersPurchasingDashboardPurchasingMapDetailAPIResponse {
  address?: MainStemAPIPlatformControllersPurchasingDashboardPurchasingMapDetailAPIResponseAddressDetails
  errorMessage?: string
  invoicesAwaitingShipment?: MainStemAPIPlatformControllersPurchasingDashboardPurchasingMapDetailInvoiceDetail[]
  invoicesToBeReceived?: MainStemAPIPlatformControllersPurchasingDashboardPurchasingMapDetailInvoiceDetail[]
  /** @format int32 */
  locationId?: number
  name?: string
  ordersApproved?: MainStemAPIPlatformControllersPurchasingDashboardPurchasingMapDetailOrderDetails[]
  ordersAwaitingApproval?: MainStemAPIPlatformControllersPurchasingDashboardPurchasingMapDetailOrdersAwaitingApproval[]
  /** @format int32 */
  totalApprovedOrders?: number
  /** @format double */
  totalMonthlySpend?: number
  users?: MainStemAPIPlatformControllersPurchasingDashboardPurchasingMapDetailUserDetails[]
  message?: string
  wasSuccessful?: boolean
}

export interface MainStemAPIPlatformControllersPurchasingDashboardPurchasingMapDetailAPIResponseAddressDetails {
  address1?: string
  address2?: string
  city?: string
  country?: string
  state?: string
  zip?: string
}

export interface MainStemAPIPlatformControllersPurchasingDashboardPurchasingMapDetailInvoiceDetail {
  /** @format date-time */
  dateApproved?: string
  /** @format date-time */
  dateCreated?: string
  /** @format date-time */
  dateShipped?: string
  /** @format int32 */
  fulfillmentID?: number
  location?: MainStemAPIPlatformControllersPurchasingDashboardPurchasingMapDetailLocation
  /** @format int32 */
  orderID?: number
  /** @format double */
  total?: number
  vendor?: MainStemAPIPlatformControllersPurchasingDashboardPurchasingMapDetailLocation
}

export interface MainStemAPIPlatformControllersPurchasingDashboardPurchasingMapDetailOrderDetails {
  /** @format date-time */
  dateApproved?: string
  /** @format date-time */
  dateCreated?: string
  /** @format int32 */
  id?: number
  status?: string
  userApprovedBy?: string
  userCreatedBy?: string
  /**
   * @format uuid
   * @example "00000000-0000-0000-0000-000000000000"
   */
  uuid?: string
}

export interface MainStemAPIPlatformControllersPurchasingDashboardPurchasingMapDetailOrdersAwaitingApproval {
  actionRequiredCommunication?: MainStemSDKDataModelsOrderCommunication[]
  approvalStatus?: 'SavedCart' | 'AwaitingApproval' | 'Approval' | 'ApprovalWithEdits' | 'Rejected'
  /** @format date-time */
  approvalStatusAsOfDate?: string
  /** @format date-time */
  dateCreated?: string
  location?: MainStemAPIPlatformControllersPurchasingDashboardPurchasingMapDetailLocation
  /** @format int32 */
  orderID?: number
  /** @format int32 */
  totalNumberOfProducts?: number
  /** @format int32 */
  totalNumberOfVendors?: number
  /** @format double */
  totalOrderLineItemCost?: number
  userCreatedBy?: string
  userRelated?: boolean
  uuid?: string
}

export interface MainStemAPIPlatformControllersPurchasingDashboardPurchasingMapDetailUserDetails {
  /** @format date-time */
  dateCreated?: string
  email?: string
  friendlyName?: string
  id?: string
  permissionGroup?: string
  role?: string
  username?: string
}

export interface MainStemAPIPlatformControllersPurchasingDashboardPurchasingMapDetailLocation {
  address1?: string
  address2?: string
  city?: string
  country?: string
  /** @format int32 */
  locationID?: number
  locationName?: string
  state?: string
  zip?: string
}

export interface MainStemAPIPlatformControllersPurchasingDashboardPurchasingOrganizationSpendAPIRequest {
  /** @format date-time */
  endDate?: string
  /** @format date-time */
  startDate?: string
}

export interface MainStemAPIPlatformControllersPurchasingDashboardPurchasingOrganizationSpendAPIResponse {
  errorMessage?: string
  spendingByEntityLocations?: MainStemAPIPlatformControllersPurchasingDashboardPurchasingOrganizationSpendTotalSalesByBusinessPartner[]
  spendingByUsers?: MainStemAPIPlatformControllersPurchasingDashboardPurchasingOrganizationSpendDistinctOrdersByUsers[]
  spendingPerVendors?: MainStemAPIPlatformControllersPurchasingDashboardPurchasingOrganizationSpendPurchasesByVendor[]
  message?: string
  wasSuccessful?: boolean
}

export interface MainStemAPIPlatformControllersPurchasingDashboardPurchasingOrganizationSpendTotalSalesByBusinessPartner {
  distinctOrdersByUsers?: MainStemAPIPlatformControllersPurchasingDashboardPurchasingOrganizationSpendDistinctOrdersByUsers[]
  /** @format int32 */
  ordersMade?: number
  /** @format double */
  totalOrderCost?: number
  /** @format double */
  totalProductCost?: number
  /** @format double */
  totalShippingCost?: number
  /** @format double */
  totalTaxCost?: number
  address1?: string
  address2?: string
  city?: string
  country?: string
  /** @format int32 */
  locationID?: number
  locationName?: string
  state?: string
  zip?: string
}

export interface MainStemAPIPlatformControllersPurchasingDashboardPurchasingOrganizationSpendDistinctOrdersByUsers {
  invoices?: MainStemSDKModelsInvoicesInvoiceBalanceDetails[]
  /** @format int32 */
  ordersMade?: number
  /** @format double */
  totalOrderCost?: number
  /** @format double */
  totalProductCost?: number
  /** @format double */
  totalShippingCost?: number
  /** @format double */
  totalTaxCost?: number
  userID?: string
  userName?: string
  address1?: string
  address2?: string
  city?: string
  country?: string
  /** @format int32 */
  locationID?: number
  locationName?: string
  state?: string
  zip?: string
}

export interface MainStemAPIPlatformControllersPurchasingDashboardPurchasingOrganizationSpendPurchasesByVendor {
  orderShippingCosts?: MainStemAPIPlatformControllersPurchasingDashboardPurchasingOrganizationSpendOrderShippingCost[]
  orderTaxCosts?: MainStemAPIPlatformControllersPurchasingDashboardPurchasingOrganizationSpendOrderTaxCost[]
  /** @format int32 */
  productCount?: number
  purchaseProducts?: MainStemAPIPlatformControllersPurchasingDashboardPurchasingOrganizationSpendPurchaseProductDetail[]
  /** @format double */
  totalOrderCost?: number
  /** @format double */
  totalProductCost?: number
  /** @format double */
  totalShippingCost?: number
  /** @format double */
  totalTaxCost?: number
  /** @format int32 */
  vendorID?: number
  vendorName?: string
  address1?: string
  address2?: string
  city?: string
  country?: string
  /** @format int32 */
  locationID?: number
  locationName?: string
  state?: string
  zip?: string
}

export interface MainStemAPIPlatformControllersPurchasingDashboardPurchasingOrganizationSpendOrderShippingCost {
  /** @format int32 */
  fulfillmentMethodID?: number
  /** @format int32 */
  orderID?: number
  /** @format double */
  shippingCost?: number
}

export interface MainStemAPIPlatformControllersPurchasingDashboardPurchasingOrganizationSpendOrderTaxCost {
  /** @format int32 */
  fulfillmentMethodID?: number
  /** @format int32 */
  orderID?: number
  /** @format double */
  taxCost?: number
}

export interface MainStemAPIPlatformControllersPurchasingDashboardPurchasingOrganizationSpendPurchaseProductDetail {
  /** @format int32 */
  productID?: number
  /** @format int32 */
  quantity?: number
  /** @format double */
  totalCost?: number
}

export type MainStemAPIPlatformControllersPurchasingDashboardPurchasingUsersAPIRequest = object

export interface MainStemAPIPlatformControllersPurchasingDashboardPurchasingUsersAPIResponse {
  errorMessage?: string
  ordersForApproval?: MainStemAPIPlatformControllersPurchasingDashboardPurchasingUsersOrderForApproval[]
  message?: string
  wasSuccessful?: boolean
}

export interface MainStemAPIPlatformControllersPurchasingDashboardPurchasingUsersOrderForApproval {
  actionRequiredCommunication?: MainStemSDKDataModelsOrderCommunication[]
  approvalStatus?: 'SavedCart' | 'AwaitingApproval' | 'Approval' | 'ApprovalWithEdits' | 'Rejected'
  /** @format date-time */
  approvalStatusAsOfDate?: string
  /** @format date-time */
  dateCreated?: string
  location?: MainStemAPIPlatformControllersPurchasingDashboardPurchasingUsersLocation
  /** @format int32 */
  orderID?: number
  /** @format double */
  totalNumberOfProducts?: number
  /** @format int32 */
  totalNumberOfVendors?: number
  /** @format double */
  totalOrderLineItemCost?: number
  userCreatedBy?: string
}

export interface MainStemAPIPlatformControllersPurchasingDashboardPurchasingUsersLocation {
  address1?: string
  address2?: string
  city?: string
  country?: string
  /** @format int32 */
  id?: number
  name?: string
  state?: string
  zip?: string
}

export interface MainStemAPIPlatformControllersPurchasingDepartmentCreateAPIRequest {
  /** @format int32 */
  locationId?: number
  name?: string
  financialDimensions?: MainStemAPIPlatformControllersPurchasingDepartmentCreateAPIRequestFinancialDimensionUpdate[]
}

export interface MainStemAPIPlatformControllersPurchasingDepartmentCreateAPIRequestFinancialDimensionUpdate {
  /** @format int32 */
  financialDimensionID?: number
  /** @format int32 */
  financialDimensionOptionID?: number
}

export interface MainStemAPIPlatformControllersPurchasingDepartmentCreateAPIResponse {
  /** @format int32 */
  id?: number
  message?: string
  wasSuccessful?: boolean
}

export interface MainStemAPIPlatformControllersPurchasingDepartmentDeleteAPIRequest {
  /** @format int32 */
  departmentId?: number
}

export interface MainStemAPIPlatformControllersPurchasingDepartmentDeleteAPIResponse {
  message?: string
  wasSuccessful?: boolean
}

export interface MainStemAPIPlatformControllersPurchasingDepartmentDetailsAPIRequest {
  /** @format int32 */
  id?: number
}

export interface MainStemAPIPlatformControllersPurchasingDepartmentDetailsAPIResponse {
  financialDimension?: MainStemAPIPlatformControllersPurchasingDepartmentDetailsAPIResponseFinancialDimensionDetail
  financialDimensions?: MainStemSDKHelpersFinancialDimensionsFactoryFinancialDimensionOptionSelectionDetail[]
  invoices?: MainStemAPIPlatformControllersPurchasingDepartmentDetailsAPIResponseInvoiceDetails[]
  isArchived?: boolean
  location?: MainStemAPIPlatformControllersPurchasingDepartmentDetailsAPIResponseLocationDetails
  name?: string
  receives?: MainStemAPIPlatformControllersPurchasingDepartmentDetailsAPIResponseReceiveDetails[]
  users?: MainStemAPIPlatformControllersPurchasingDepartmentDetailsAPIResponseUserDetails[]
  message?: string
  wasSuccessful?: boolean
}

export interface MainStemAPIPlatformControllersPurchasingDepartmentDetailsAPIResponseFinancialDimensionDetail {
  /** @format int32 */
  id?: number
  label?: string
  typeLabel?: string
  value?: string
}

export interface MainStemSDKHelpersFinancialDimensionsFactoryFinancialDimensionOptionSelectionDetail {
  /** @format int32 */
  financialDimensionID?: number
  financialDimensionLabel?: string
  /** @format int32 */
  financialDimensionOptionID?: number
  financialDimensionOptionLabel?: string
  financialDimensionOptionValue?: string
  /** @format int32 */
  financialDimensionRankOrder?: number
  type?: 'Product' | 'Location' | 'Department' | 'InvoiceLineItemAllocation' | 'Invoice' | 'Supplier'
}

export interface MainStemAPIPlatformControllersPurchasingDepartmentDetailsAPIResponseInvoiceDetails {
  /** @format date-time */
  dateCreated?: string
  /** @format int32 */
  departmentID?: number
  departmentName?: string
  /** @format int32 */
  id?: number
  order?: MainStemAPIPlatformControllersPurchasingDepartmentDetailsAPIResponseInvoiceDetailsOrderDetails
  /** @format int32 */
  productID?: number
  productName?: string
  /** @format int32 */
  quantity?: number
  /** @format int32 */
  supplierID?: number
  supplierName?: string
  userCreatedBy?: MainStemAPIPlatformControllersPurchasingDepartmentDetailsAPIResponseUserDetails
}

export interface MainStemAPIPlatformControllersPurchasingDepartmentDetailsAPIResponseLocationDetails {
  /** @format int32 */
  id?: number
  headerURL?: string
  image?: string
  logoURL?: string
  name?: string
}

export interface MainStemAPIPlatformControllersPurchasingDepartmentDetailsAPIResponseReceiveDetails {
  /** @format date-time */
  dateCreated?: string
  /** @format int32 */
  departmentID?: number
  departmentName?: string
  /** @format int32 */
  id?: number
  /** @format int32 */
  productID?: number
  productName?: string
  /** @format int32 */
  quantity?: number
  /** @format int32 */
  supplierID?: number
  supplierName?: string
  userCreatedBy?: MainStemAPIPlatformControllersPurchasingDepartmentDetailsAPIResponseUserDetails
  uuid?: string
}

export interface MainStemAPIPlatformControllersPurchasingDepartmentDetailsAPIResponseUserDetails {
  id?: string
  username?: string
}

export interface MainStemAPIPlatformControllersPurchasingDepartmentDetailsAPIResponseInvoiceDetailsOrderDetails {
  /** @format int32 */
  id?: number
  uuid?: string
}

export interface MainStemAPIPlatformControllersPurchasingDepartmentDuplicateAPIRequest {
  copyUsers?: boolean
  /** @format int32 */
  departmentId?: number
  name?: string
}

export interface MainStemAPIPlatformControllersPurchasingDepartmentDuplicateAPIResponse {
  /** @format int32 */
  departmentId?: number
  message?: string
  wasSuccessful?: boolean
}

export interface MainStemAPIPlatformControllersPurchasingDepartmentListAPIRequest {
  includeArchived?: boolean
  /** @format int32 */
  locationId?: number
}

export interface MainStemAPIPlatformControllersPurchasingDepartmentListAPIResponse {
  departments?: MainStemAPIPlatformControllersPurchasingDepartmentListAPIResponseDepartmentDetails[]
  locations?: MainStemAPIPlatformControllersPurchasingDepartmentListAPIResponseLocationNodeDetails[]
  message?: string
  wasSuccessful?: boolean
}

export interface MainStemAPIPlatformControllersPurchasingDepartmentListAPIResponseDepartmentDetails {
  /** @format int32 */
  id?: number
  isArchived?: boolean
  location?: MainStemAPIPlatformControllersPurchasingDepartmentListAPIResponseDepartmentDetailsLocationDetails
  name?: string
}

export interface MainStemAPIPlatformControllersPurchasingDepartmentListAPIResponseLocationNodeDetails {
  departments?: MainStemAPIPlatformControllersPurchasingDepartmentListAPIResponseLocationNodeDetailsDepartmentDetails[]
  /** @format int32 */
  id?: number
  name?: string
}

export interface MainStemAPIPlatformControllersPurchasingDepartmentListAPIResponseDepartmentDetailsLocationDetails {
  /** @format int32 */
  id?: number
  name?: string
}

export interface MainStemAPIPlatformControllersPurchasingDepartmentListAPIResponseLocationNodeDetailsDepartmentDetails {
  /** @format int32 */
  id?: number
  name?: string
  users?: MainStemAPIPlatformControllersPurchasingDepartmentListAPIResponseLocationNodeDetailsDepartmentDetailsUserDetails[]
}

export interface MainStemAPIPlatformControllersPurchasingDepartmentListAPIResponseLocationNodeDetailsDepartmentDetailsUserDetails {
  id?: string
  name?: string
  username?: string
}

export interface MainStemAPIPlatformControllersPurchasingDepartmentUpdateAPIRequest {
  /** @format int32 */
  id?: number
  name?: string
  financialDimensions?: MainStemAPIPlatformControllersPurchasingDepartmentUpdateAPIRequestFinancialDimensionUpdate[]
}

export interface MainStemAPIPlatformControllersPurchasingDepartmentUpdateAPIRequestFinancialDimensionUpdate {
  /** @format int32 */
  financialDimensionID?: number
  /** @format int32 */
  financialDimensionOptionID?: number
}

export interface MainStemAPIPlatformControllersPurchasingDepartmentUsersAddAPIRequest {
  /** @format int32 */
  departmentId?: number
  userIds?: string[]
}

export interface MainStemAPIPlatformControllersPurchasingDepartmentUsersRemoveAPIRequest {
  /** @format int32 */
  departmentId?: number
  userId?: string
}

export interface MainStemAPIPlatformControllersPurchasingEntityFilesListAPIRequest {
  /** @format int32 */
  id?: number
  uuid?: string
}

export interface MainStemAPIPlatformControllersPurchasingEntityFilesListAPIResponse {
  files?: MainStemAPIPlatformControllersPurchasingEntityFilesListAPIResponseFileDetails[]
  message?: string
  wasSuccessful?: boolean
}

export interface MainStemAPIPlatformControllersPurchasingEntityFilesListAPIResponseFileDetails {
  createdByUserName?: string
  createdByUserUUID?: string
  /** @format date-time */
  dateCreated?: string
  fileExtension?: string
  /** @format int32 */
  id?: number
  name?: string
  originalFileName?: string
  url?: string
}

export interface MainStemAPIPlatformControllersPurchasingEntityFilesUploadAPIResponse {
  error?: string
  fileDetail?: MainStemAPIPlatformControllersPurchasingEntityFilesUploadAPIResponseFileDetails
  message?: string
  wasSuccessful?: boolean
}

export interface MainStemAPIPlatformControllersPurchasingEntityFilesUploadAPIResponseFileDetails {
  /** @format date-time */
  dateCreated?: string
  /** @format int32 */
  id?: number
  name?: string
  url?: string
}

export interface MainStemAPIPlatformControllersPurchasingEntityLogsListAPIRequest {
  /** @format int32 */
  id?: number
  uuid?: string
}

export interface MainStemAPIPlatformControllersPurchasingEntityLogsListAPIResponse {
  logs?: MainStemAPIPlatformControllersPurchasingEntityLogsListAPIResponseChangeLogDetails[]
  message?: string
  wasSuccessful?: boolean
}

export interface MainStemAPIPlatformControllersPurchasingEntityLogsListAPIResponseChangeLogDetails {
  content?: string
  createdByUserName?: string
  createdByUserUUID?: string
  /** @format date-time */
  dateCreated?: string
  documentID?: string
  documentType?: string
  /** @format int32 */
  id?: number
  reason?: string
}

export interface MainStemAPIPlatformControllersPurchasingEntityNotesCreateAPIRequest {
  content?: string
  context?: string
  /** @format int32 */
  id?: number
  isPrivate?: boolean
  uuid?: string
}

export interface MainStemAPIPlatformControllersPurchasingEntityNotesCreateAPIResponse {
  /** @format int32 */
  id?: number
  message?: string
  wasSuccessful?: boolean
}

export interface MainStemAPIPlatformControllersPurchasingEntityNotesListAPIRequest {
  allowPrivate?: boolean
  /** @format int32 */
  id?: number
  uuid?: string
}

export interface MainStemAPIPlatformControllersPurchasingEntityNotesListAPIResponse {
  notes?: MainStemAPIPlatformControllersPurchasingEntityNotesListNoteDetail[]
  message?: string
  wasSuccessful?: boolean
}

export interface MainStemAPIPlatformControllersPurchasingEntityNotesListNoteDetail {
  content?: string
  context?: string
  createdBy?: MainStemSDKModelsUsersUserDetails
  /** @format date-time */
  dateCreated?: string
  /** @format int32 */
  id?: number
  isDeleted?: boolean
  isPrivate?: boolean
  isStarred?: boolean
}

export type MainStemAPIPlatformControllersPurchasingErrAPIRequest = object

export interface MainStemAPIPlatformControllersPurchasingFeedCreateAPIRequest {
  description?: string
  isPinned?: boolean
  title?: string
  url?: string
  userAssignedToId?: string
}

export interface MainStemAPIPlatformControllersPurchasingFeedCreateAPIResponse {
  /** @format int32 */
  id?: number
  message?: string
  wasSuccessful?: boolean
}

export interface MainStemAPIPlatformControllersPurchasingFeedDeleteAPIRequest {
  /** @format int32 */
  id?: number
}

export interface MainStemAPIPlatformControllersPurchasingFeedDeleteAPIResponse {
  message?: string
  wasSuccessful?: boolean
}

export interface MainStemAPIPlatformControllersPurchasingFeedDetailsAPIRequest {
  /** @format int32 */
  id?: number
}

export interface MainStemAPIPlatformControllersPurchasingFeedDetailsAPIResponse {
  feed?: MainStemAPIPlatformControllersPurchasingFeedDetailsAPIResponseFeedDetails
  message?: string
  wasSuccessful?: boolean
}

export interface MainStemAPIPlatformControllersPurchasingFeedDetailsAPIResponseFeedDetails {
  /** @format date-time */
  dateCreated?: string
  description?: string
  /** @format int32 */
  id?: number
  imageURL?: string
  isDeleted?: boolean
  isPinned?: boolean
  title?: string
  url?: string
  userAssignedTo?: MainStemAPIPlatformControllersPurchasingFeedDetailsAPIResponseFeedDetailsFeedStreamUserDetails
  userCreatedBy?: MainStemAPIPlatformControllersPurchasingFeedDetailsAPIResponseFeedDetailsFeedStreamUserDetails
}

export interface MainStemAPIPlatformControllersPurchasingFeedDetailsAPIResponseFeedDetailsFeedStreamUserDetails {
  id?: string
  imageURL?: string
  name?: string
}

export interface MainStemAPIPlatformControllersPurchasingFeedListAPIResponse {
  feeds?: MainStemAPIPlatformControllersPurchasingFeedListAPIResponseFeedDetails[]
  message?: string
  wasSuccessful?: boolean
}

export interface MainStemAPIPlatformControllersPurchasingFeedListAPIResponseFeedDetails {
  /** @format date-time */
  dateCreated?: string
  description?: string
  /** @format int32 */
  id?: number
  imageURL?: string
  isDeleted?: boolean
  isPinned?: boolean
  title?: string
  url?: string
  userAssignedTo?: MainStemAPIPlatformControllersPurchasingFeedListAPIResponseFeedDetailsFeedStreamUserDetails
  userCreatedBy?: MainStemAPIPlatformControllersPurchasingFeedListAPIResponseFeedDetailsFeedStreamUserDetails
}

export interface MainStemAPIPlatformControllersPurchasingFeedListAPIResponseFeedDetailsFeedStreamUserDetails {
  id?: string
  imageURL?: string
  name?: string
}

export interface MainStemAPIPlatformControllersPurchasingFeedStreamAPIResponse {
  feeds?: MainStemAPIPlatformControllersPurchasingFeedStreamAPIResponseFeedStreamDetails[]
  message?: string
  wasSuccessful?: boolean
}

export interface MainStemAPIPlatformControllersPurchasingFeedStreamAPIResponseFeedStreamDetails {
  description?: string
  /** @format int32 */
  id?: number
  imageURL?: string
  isPinned?: boolean
  title?: string
  url?: string
  userCreatedBy?: MainStemAPIPlatformControllersPurchasingFeedStreamAPIResponseFeedStreamDetailsFeedStreamUserDetails
}

export interface MainStemAPIPlatformControllersPurchasingFeedStreamAPIResponseFeedStreamDetailsFeedStreamUserDetails {
  id?: string
  imageURL?: string
  name?: string
}

export interface MainStemAPIPlatformControllersPurchasingFeedUpdateAPIRequest {
  description?: string
  /** @format int32 */
  id?: number
  isDeleted?: boolean
  isPinned?: boolean
  title?: string
  url?: string
  userAssignedToId?: string
}

export interface MainStemAPIPlatformControllersPurchasingFeedUpdateAPIResponse {
  message?: string
  wasSuccessful?: boolean
}

export interface MainStemAPIPlatformControllersPurchasingAccountFinancialDimensionCreateAPIRequest {
  type?: 'Product' | 'Location' | 'Department' | 'InvoiceLineItemAllocation' | 'Invoice' | 'Supplier'
  label?: string
  /** @format int32 */
  rankOrder?: number
}

export interface MainStemAPIPlatformControllersPurchasingAccountFinancialDimensionCreateAPIResponse {
  /** @format int32 */
  id?: number
  message?: string
  wasSuccessful?: boolean
}

export interface MainStemAPIPlatformControllersPurchasingAccountFinancialDimensionDepartmentCustomerDepartmentsAPIRequest {
  /** @format int32 */
  financialDimensionID?: number
}

export interface MainStemAPIPlatformControllersPurchasingAccountFinancialDimensionDepartmentCustomerDepartmentsAPIResponse {
  departments?: MainStemAPIPlatformControllersPurchasingAccountFinancialDimensionDepartmentCustomerDepartmentsAPIResponseDepartmentDetail[]
  message?: string
  wasSuccessful?: boolean
}

export interface MainStemAPIPlatformControllersPurchasingAccountFinancialDimensionDepartmentCustomerDepartmentsAPIResponseDepartmentDetail {
  /** @format int32 */
  id?: number
  name?: string
  /** @format int32 */
  locationID?: number
  locationName?: string
  /** @format int32 */
  financialDimensionOptionID?: number
  financialDimensionOptionLabel?: string
  financialDimensionOptionValue?: string
}

export interface MainStemAPIPlatformControllersPurchasingAccountFinancialDimensionInvoiceCustomerInvoicesAPIRequest {
  /** @format int32 */
  financialDimensionID?: number
}

export interface MainStemAPIPlatformControllersPurchasingAccountFinancialDimensionInvoiceCustomerInvoicesAPIResponse {
  invoices?: MainStemAPIPlatformControllersPurchasingAccountFinancialDimensionInvoiceCustomerInvoicesAPIResponseInvoiceDetail[]
  message?: string
  wasSuccessful?: boolean
}

export interface MainStemAPIPlatformControllersPurchasingAccountFinancialDimensionInvoiceCustomerInvoicesAPIResponseInvoiceDetail {
  /** @format int32 */
  financialDimensionOptionID?: number
  financialDimensionOptionLabel?: string
  financialDimensionOptionValue?: string
  /** @format int32 */
  id?: number
  imageURL?: string
  name?: string
  sku?: string
  /** @format int32 */
  supplierID?: number
  supplierName?: string
}

export interface MainStemAPIPlatformControllersPurchasingAccountFinancialDimensionLocationCustomerLocationsAPIRequest {
  /** @format int32 */
  financialDimensionID?: number
}

export interface MainStemAPIPlatformControllersPurchasingAccountFinancialDimensionLocationCustomerLocationsAPIResponse {
  locations?: MainStemAPIPlatformControllersPurchasingAccountFinancialDimensionLocationCustomerLocationsAPIResponseLocationDetail[]
  message?: string
  wasSuccessful?: boolean
}

export interface MainStemAPIPlatformControllersPurchasingAccountFinancialDimensionLocationCustomerLocationsAPIResponseLocationDetail {
  /** @format int32 */
  financialDimensionOptionID?: number
  financialDimensionOptionLabel?: string
  financialDimensionOptionValue?: string
  /** @format int32 */
  id?: number
  name?: string
}

export interface MainStemAPIPlatformControllersPurchasingAccountFinancialDimensionProductCustomerProductsAPIRequest {
  /** @format int32 */
  financialDimensionID?: number
}

export interface MainStemAPIPlatformControllersPurchasingAccountFinancialDimensionProductCustomerProductsAPIResponse {
  products?: MainStemAPIPlatformControllersPurchasingAccountFinancialDimensionProductCustomerProductsAPIResponseProductDetail[]
  message?: string
  wasSuccessful?: boolean
}

export interface MainStemAPIPlatformControllersPurchasingAccountFinancialDimensionProductCustomerProductsAPIResponseProductDetail {
  /** @format int32 */
  id?: number
  name?: string
  sku?: string
  /** @format int32 */
  supplierID?: number
  imageURL?: string
  supplierName?: string
  /** @format int32 */
  financialDimensionOptionID?: number
  financialDimensionOptionLabel?: string
  financialDimensionOptionValue?: string
}

export interface MainStemAPIPlatformControllersPurchasingAccountFinancialDimensionSupplierCustomerSuppliersAPIRequest {
  /** @format int32 */
  financialDimensionID?: number
}

export interface MainStemAPIPlatformControllersPurchasingAccountFinancialDimensionSupplierCustomerSuppliersAPIResponse {
  suppliers?: MainStemAPIPlatformControllersPurchasingAccountFinancialDimensionSupplierCustomerSuppliersAPIResponseSupplierDetail[]
  message?: string
  wasSuccessful?: boolean
}

export interface MainStemAPIPlatformControllersPurchasingAccountFinancialDimensionSupplierCustomerSuppliersAPIResponseSupplierDetail {
  /** @format int32 */
  financialDimensionOptionID?: number
  financialDimensionOptionLabel?: string
  financialDimensionOptionValue?: string
  /** @format int32 */
  id?: number
  name?: string
}

export interface MainStemAPIPlatformControllersPurchasingAccountFinancialDimensionDeleteAPIRequest {
  /** @format int32 */
  id?: number
}

export interface MainStemAPIPlatformControllersPurchasingAccountFinancialDimensionDeleteAPIResponse {
  /** @format int32 */
  id?: number
  message?: string
  wasSuccessful?: boolean
}

export interface MainStemAPIPlatformControllersPurchasingAccountFinancialDimensionGetByTypeAPIRequest {
  type?: 'Product' | 'Location' | 'Department' | 'InvoiceLineItemAllocation' | 'Invoice' | 'Supplier'
}

export interface MainStemAPIPlatformControllersPurchasingAccountFinancialDimensionGetByTypeAPIResponse {
  financialDimensions?: MainStemAPIPlatformControllersPurchasingAccountFinancialDimensionGetByTypeAPIResponseFinancialDimensionDetail[]
  message?: string
  wasSuccessful?: boolean
}

export interface MainStemAPIPlatformControllersPurchasingAccountFinancialDimensionGetByTypeAPIResponseFinancialDimensionDetail {
  /** @format int32 */
  id?: number
  type?: 'Product' | 'Location' | 'Department' | 'InvoiceLineItemAllocation' | 'Invoice' | 'Supplier'
  label?: string
  isDeleted?: boolean
}

export interface MainStemAPIPlatformControllersPurchasingAccountFinancialDimensionListByTypeAPIRequest {
  type?: 'Product' | 'Location' | 'Department' | 'InvoiceLineItemAllocation' | 'Invoice' | 'Supplier'
  types?: ('Product' | 'Location' | 'Department' | 'InvoiceLineItemAllocation' | 'Invoice' | 'Supplier')[]
}

export interface MainStemAPIPlatformControllersPurchasingAccountFinancialDimensionListByTypeAPIResponse {
  financialDimensions?: MainStemAPIPlatformControllersPurchasingAccountFinancialDimensionListByTypeAPIResponseFinancialDimensionDetail[]
  message?: string
  wasSuccessful?: boolean
}

export interface MainStemAPIPlatformControllersPurchasingAccountFinancialDimensionListByTypeAPIResponseFinancialDimensionDetail {
  /** @format int32 */
  id?: number
  type?: 'Product' | 'Location' | 'Department' | 'InvoiceLineItemAllocation' | 'Invoice' | 'Supplier'
  label?: string
  /** @format int32 */
  rankOrder?: number
  options?: MainStemAPIPlatformControllersPurchasingAccountFinancialDimensionListByTypeAPIResponseFinancialDimensionOptionDetail[]
}

export interface MainStemAPIPlatformControllersPurchasingAccountFinancialDimensionListByTypeAPIResponseFinancialDimensionOptionDetail {
  /** @format int32 */
  id?: number
  type?: 'Product' | 'Location' | 'Department' | 'InvoiceLineItemAllocation' | 'Invoice' | 'Supplier'
  value?: string
  label?: string
}

export interface MainStemAPIPlatformControllersPurchasingAccountFinancialDimensionOptionCreateAPIRequest {
  value?: string
  label?: string
  /** @format int32 */
  financialDimensionID?: number
}

export interface MainStemAPIPlatformControllersPurchasingAccountFinancialDimensionOptionCreateAPIResponse {
  /** @format int32 */
  id?: number
  message?: string
  wasSuccessful?: boolean
}

export interface MainStemAPIPlatformControllersPurchasingAccountFinancialDimensionOptionDeleteAPIRequest {
  /** @format int32 */
  id?: number
}

export interface MainStemAPIPlatformControllersPurchasingAccountFinancialDimensionOptionDeleteAPIResponse {
  message?: string
  wasSuccessful?: boolean
}

export interface MainStemAPIPlatformControllersPurchasingAccountFinancialDimensionOptionGetByTypeAPIRequest {
  type?: 'Product' | 'Location' | 'Department' | 'InvoiceLineItemAllocation' | 'Invoice' | 'Supplier'
  /** @format int32 */
  recordID?: number
}

export interface MainStemAPIPlatformControllersPurchasingAccountFinancialDimensionOptionGetByTypeAPIResponse {
  financialDimensions?: MainStemSDKHelpersFinancialDimensionsFactoryFinancialDimensionOptionSelectionDetail[]
  message?: string
  wasSuccessful?: boolean
}

export interface MainStemAPIPlatformControllersPurchasingAccountFinancialDimensionOptionListByIDAPIRequest {
  /** @format int32 */
  financialDimensionID?: number
}

export interface MainStemAPIPlatformControllersPurchasingAccountFinancialDimensionOptionListByIDAPIResponse {
  financialDimension?: MainStemAPIPlatformControllersPurchasingAccountFinancialDimensionOptionListByIDAPIResponseFinancialDimensionDetail
  message?: string
  wasSuccessful?: boolean
}

export interface MainStemAPIPlatformControllersPurchasingAccountFinancialDimensionOptionListByIDAPIResponseFinancialDimensionDetail {
  /** @format int32 */
  id?: number
  label?: string
  options?: MainStemAPIPlatformControllersPurchasingAccountFinancialDimensionOptionListByIDAPIResponseFinancialDimensionOptionDetail[]
  /** @format int32 */
  rankOrder?: number
  type?: 'Product' | 'Location' | 'Department' | 'InvoiceLineItemAllocation' | 'Invoice' | 'Supplier'
}

export interface MainStemAPIPlatformControllersPurchasingAccountFinancialDimensionOptionListByIDAPIResponseFinancialDimensionOptionDetail {
  /** @format int32 */
  id?: number
  label?: string
  type?: 'Product' | 'Location' | 'Department' | 'InvoiceLineItemAllocation' | 'Invoice' | 'Supplier'
  value?: string
}

export interface MainStemAPIPlatformControllersPurchasingAccountFinancialDimensionOptionSetByTypeAPIRequest {
  type?: 'Product' | 'Location' | 'Department' | 'InvoiceLineItemAllocation' | 'Invoice' | 'Supplier'
  /** @format int32 */
  recordID?: number
  /** @format int32 */
  financialDimensionOptionID?: number
}

export interface MainStemAPIPlatformControllersPurchasingAccountFinancialDimensionOptionSetByTypeAPIResponse {
  message?: string
  wasSuccessful?: boolean
}

export interface MainStemAPIPlatformControllersPurchasingAccountFinancialDimensionOptionUpdateAPIRequest {
  /** @format int32 */
  id?: number
  /** @format int32 */
  financialDimensionID?: number
  value?: string
  label?: string
}

export interface MainStemAPIPlatformControllersPurchasingAccountFinancialDimensionOptionUpdateAPIResponse {
  message?: string
  wasSuccessful?: boolean
}

export interface MainStemAPIPlatformControllersPurchasingAccountFinancialDimensionUpdateAPIRequest {
  /** @format int32 */
  id?: number
  type?: 'Product' | 'Location' | 'Department' | 'InvoiceLineItemAllocation' | 'Invoice' | 'Supplier'
  label?: string
  /** @format int32 */
  rankOrder?: number
}

export interface MainStemAPIPlatformControllersPurchasingAccountFinancialDimensionUpdateAPIResponse {
  message?: string
  wasSuccessful?: boolean
}

export interface MainStemAPIPlatformControllersPurchasingAccountFinancialDimensionDepartmentUpdateDepartmentsAPIRequest {
  /** @format int32 */
  financialDimensionID?: number
  updateRecords?: MainStemSDKHelpersFinancialDimensionsFactoryFinancialDimensionLinkUpdate[]
}

export interface MainStemSDKHelpersFinancialDimensionsFactoryFinancialDimensionLinkUpdate {
  /** @format int32 */
  financialDimensionOptionID?: number
  /** @format int32 */
  recordID?: number
}

export interface MainStemAPIPlatformControllersPurchasingAccountFinancialDimensionDepartmentUpdateDepartmentsAPIResponse {
  message?: string
  wasSuccessful?: boolean
}

export interface MainStemAPIPlatformControllersPurchasingAccountFinancialDimensionInvoiceUpdateInvoicesAPIRequest {
  updateRecords?: MainStemSDKHelpersFinancialDimensionsFactoryFinancialDimensionLinkUpdate[]
}

export interface MainStemAPIPlatformControllersPurchasingAccountFinancialDimensionInvoiceUpdateInvoicesAPIResponse {
  message?: string
  wasSuccessful?: boolean
}

export interface MainStemAPIPlatformControllersPurchasingAccountFinancialDimensionLocationUpdateLocationsAPIRequest {
  /** @format int32 */
  financialDimensionID?: number
  updateRecords?: MainStemSDKHelpersFinancialDimensionsFactoryFinancialDimensionLinkUpdate[]
}

export interface MainStemAPIPlatformControllersPurchasingAccountFinancialDimensionLocationUpdateLocationsAPIResponse {
  message?: string
  wasSuccessful?: boolean
}

export interface MainStemAPIPlatformControllersPurchasingAccountFinancialDimensionProductUpdateProductsAPIRequest {
  updateRecords?: MainStemSDKHelpersFinancialDimensionsFactoryFinancialDimensionLinkUpdate[]
}

export interface MainStemAPIPlatformControllersPurchasingAccountFinancialDimensionProductUpdateProductsAPIResponse {
  message?: string
  wasSuccessful?: boolean
}

export interface MainStemAPIPlatformControllersPurchasingAccountFinancialDimensionSupplierUpdateSuppliersAPIRequest {
  /** @format int32 */
  financialDimensionID?: number
  updateRecords?: MainStemSDKHelpersFinancialDimensionsFactoryFinancialDimensionLinkUpdate[]
}

export interface MainStemAPIPlatformControllersPurchasingAccountFinancialDimensionSupplierUpdateSuppliersAPIResponse {
  message?: string
  wasSuccessful?: boolean
}

export interface MainStemAPIPlatformControllersPurchasingIntegrationAmazonOrderLineItemCreateAPIRequest {
  amazonProduct: MainStemSDKIntegrationsAmazonModelsAmazonSearchProduct
  offer: MainStemAPIPlatformControllersPurchasingIntegrationAmazonOrderLineItemCreateAPIRequestOfferDetails
  /** @format int32 */
  orderId: number
  /** @format int32 */
  quantity: number
  searchDetails?: MainStemAPIPlatformControllersPurchasingIntegrationAmazonOrderLineItemCreateAPIRequestSearchDetails
}

export interface MainStemSDKIntegrationsAmazonModelsAmazonSearchProduct {
  asin?: string
  includedDataTypes?: MainStemSDKIntegrationsAmazonModelsAmazonSearchProductIncludedDataTypesDetails
  productDescription?: string
  title?: string
  taxonomies?: MainStemSDKIntegrationsAmazonModelsAmazonSearchProductTaxonomyDetails[]
}

export interface MainStemAPIPlatformControllersPurchasingIntegrationAmazonOrderLineItemCreateAPIRequestOfferDetails {
  /** @format double */
  cost: number
  id: string
  /** @format double */
  price: number
}

export interface MainStemAPIPlatformControllersPurchasingIntegrationAmazonOrderLineItemCreateAPIRequestSearchDetails {
  partitionKey?: string
  rowKey?: string
}

export interface MainStemSDKIntegrationsAmazonModelsAmazonSearchProductIncludedDataTypesDetails {
  images?: MainStemSDKIntegrationsAmazonModelsAmazonSearchProductIncludedDataTypesDetailsImageDetails[]
  offers?: MainStemSDKIntegrationsAmazonModelsAmazonSearchProductIncludedDataTypesDetailsOfferDetails[]
}

export interface MainStemSDKIntegrationsAmazonModelsAmazonSearchProductTaxonomyDetails {
  taxonomyCode?: string
  title?: string
  type?: string
}

export interface MainStemSDKIntegrationsAmazonModelsAmazonSearchProductIncludedDataTypesDetailsImageDetails {
  large?: MainStemSDKIntegrationsAmazonModelsAmazonSearchProductIncludedDataTypesDetailsImageDetailsImageSizeDetails
  medium?: MainStemSDKIntegrationsAmazonModelsAmazonSearchProductIncludedDataTypesDetailsImageDetailsImageSizeDetails
  small?: MainStemSDKIntegrationsAmazonModelsAmazonSearchProductIncludedDataTypesDetailsImageDetailsImageSizeDetails
  thumbnail?: MainStemSDKIntegrationsAmazonModelsAmazonSearchProductIncludedDataTypesDetailsImageDetailsImageSizeDetails
}

export interface MainStemSDKIntegrationsAmazonModelsAmazonSearchProductIncludedDataTypesDetailsOfferDetails {
  availability?: string
  price?: MainStemSDKIntegrationsAmazonModelsAmazonSearchProductIncludedDataTypesDetailsOfferDetailsPriceDetails
}

export interface MainStemSDKIntegrationsAmazonModelsAmazonSearchProductIncludedDataTypesDetailsImageDetailsImageSizeDetails {
  url?: string
}

export interface MainStemSDKIntegrationsAmazonModelsAmazonSearchProductIncludedDataTypesDetailsOfferDetailsPriceDetails {
  value?: MainStemSDKIntegrationsAmazonModelsAmazonSearchProductIncludedDataTypesDetailsOfferDetailsPriceDetailsPriceValueDetails
}

export interface MainStemSDKIntegrationsAmazonModelsAmazonSearchProductIncludedDataTypesDetailsOfferDetailsPriceDetailsPriceValueDetails {
  /** @format double */
  amount?: number
}

export interface MainStemAPIPlatformControllersPurchasingIntegrationAmazonOrderLineItemCreateAPIResponse {
  message?: string
  wasSuccessful?: boolean
}

export interface MainStemAPIPlatformControllersPurchasingIntegrationAmazonProductDetailsAPIRequest {
  asin?: string
}

export interface MainStemAPIPlatformControllersPurchasingIntegrationAmazonProductDetailsAPIResponse {
  /** @format int32 */
  catalogCount: number
  /** @format int32 */
  mainStemProductId: number
  product: MainStemAPIPlatformControllersPurchasingIntegrationAmazonProductDetailsAPIResponseAmazonProduct
  message?: string
  wasSuccessful?: boolean
}

export interface MainStemAPIPlatformControllersPurchasingIntegrationAmazonProductDetailsAPIResponseAmazonProduct {
  amazonProduct: MainStemSDKIntegrationsAmazonModelsAmazonSearchProduct
  asin: string
  description: string
  images: string[]
  offers: MainStemAPIPlatformControllersPurchasingIntegrationAmazonProductDetailsAPIResponseAmazonProductAmazonProductOffer[]
  technicalDetails: MainStemAPIPlatformControllersPurchasingIntegrationAmazonProductDetailsAPIResponseAmazonProductTechnicalDetail[]
  title: string
  variations: MainStemAPIPlatformControllersPurchasingIntegrationAmazonProductDetailsAPIResponseAmazonProductVariation[]
}

export interface MainStemAPIPlatformControllersPurchasingIntegrationAmazonProductDetailsAPIResponseAmazonProductAmazonProductOffer {
  blockedReason: string
  /** @format double */
  cost: number
  deliveryInformation: string
  hasWarning: boolean
  isBlocked: boolean
  /** @format double */
  listPrice: number
  merchant: MainStemAPIPlatformControllersPurchasingIntegrationAmazonProductDetailsAPIResponseAmazonProductAmazonProductOfferMerchantDetails
  offerId: string
  /** @format double */
  price: number
  productCondition: string
  warningReason: string
}

export interface MainStemAPIPlatformControllersPurchasingIntegrationAmazonProductDetailsAPIResponseAmazonProductTechnicalDetail {
  label: string
  value: string
}

export interface MainStemAPIPlatformControllersPurchasingIntegrationAmazonProductDetailsAPIResponseAmazonProductVariation {
  /** @format int32 */
  id: number
  label: string
  values: MainStemAPIPlatformControllersPurchasingIntegrationAmazonProductDetailsAPIResponseAmazonProductVariationVariationValue[]
}

export interface MainStemAPIPlatformControllersPurchasingIntegrationAmazonProductDetailsAPIResponseAmazonProductAmazonProductOfferMerchantDetails {
  certificates: string[]
  id: string
  name: string
}

export interface MainStemAPIPlatformControllersPurchasingIntegrationAmazonProductDetailsAPIResponseAmazonProductVariationVariationValue {
  asin: string
  enabled: boolean
  fullMatch: boolean
  /** @format int32 */
  id: number
  label: string
}

export interface MainStemAPIPlatformControllersPurchasingIntegrationAmazonProductImportAPIRequest {
  amazonProduct: MainStemSDKIntegrationsAmazonModelsAmazonSearchProduct
}

export interface MainStemAPIPlatformControllersPurchasingIntegrationAmazonProductImportAPIResponse {
  /** @format int32 */
  mainStemProductId: number
  message?: string
  wasSuccessful?: boolean
}

export interface MainStemAPIPlatformControllersPurchasingIntegrationAmazonShipmentTrackingAPIRequest {
  /** @format int32 */
  invoiceId: number
}

export interface MainStemAPIPlatformControllersPurchasingIntegrationAmazonShipmentTrackingAPIResponse {
  trackingDetails?: MainStemSDKIntegrationsAmazonShipmentTrackingResponse[]
  message?: string
  wasSuccessful?: boolean
}

export interface MainStemSDKIntegrationsAmazonShipmentTrackingResponse {
  amazonOrderId?: string
  amazonPackageId?: string
  amazonShipmentId?: string
  trackingDetails?: MainStemSDKIntegrationsAmazonShipmentTrackingModelsAmazonResponsePackageTrackingDetails
  message?: string
  wasSuccessful?: boolean
}

export interface MainStemSDKIntegrationsAmazonShipmentTrackingModelsAmazonResponsePackageTrackingDetails {
  trackingStatus?: string
  localizedDeliveryPromise?: string
  deliveryWindow?: MainStemSDKIntegrationsAmazonShipmentTrackingModelsAmazonResponseWindow
  carrierDetails?: MainStemSDKIntegrationsAmazonShipmentTrackingModelsAmazonResponseCarrierDetails
  packageTrackingEvents?: MainStemSDKIntegrationsAmazonShipmentTrackingModelsAmazonResponsePackageTrackingEvent[]
  packageMilestones?: MainStemSDKIntegrationsAmazonShipmentTrackingModelsAmazonResponsePackageMilestone[]
}

export interface MainStemSDKIntegrationsAmazonShipmentTrackingModelsAmazonResponseWindow {
  /** @format date-time */
  startDate?: string
  /** @format date-time */
  endDate?: string
}

export interface MainStemSDKIntegrationsAmazonShipmentTrackingModelsAmazonResponseCarrierDetails {
  localizedCarrierName?: string
  carrierTrackingId?: string
}

export interface MainStemSDKIntegrationsAmazonShipmentTrackingModelsAmazonResponsePackageTrackingEvent {
  localizedDescription?: string
  localizedEventDate?: string
  localizedEventTime?: string
  location?: MainStemSDKIntegrationsAmazonShipmentTrackingModelsAmazonResponseLocation
}

export interface MainStemSDKIntegrationsAmazonShipmentTrackingModelsAmazonResponsePackageMilestone {
  milestoneType?: string
  milestoneWindow?: MainStemSDKIntegrationsAmazonShipmentTrackingModelsAmazonResponseWindow
}

export interface MainStemSDKIntegrationsAmazonShipmentTrackingModelsAmazonResponseLocation {
  city?: string
  state?: string
  country?: string
}

export interface MainStemAPIPlatformControllersPurchasingIntegrationApexTradingListingsListAPIRequest {
  /** @format int32 */
  id?: number
}

export interface MainStemAPIPlatformControllersPurchasingIntegrationApexTradingListingsListAPIResponse {
  listings?: MainStemAPIPlatformControllersPurchasingIntegrationApexTradingListingsListAPIResponseListingDetails[]
  message?: string
  wasSuccessful?: boolean
}

export interface MainStemAPIPlatformControllersPurchasingIntegrationApexTradingListingsListAPIResponseListingDetails {
  /** @format int32 */
  id: number
  imageUrl?: string
  name?: string
  /** @format int32 */
  sellerId?: number
  sellerName?: string
  sku?: string
  units?: MainStemAPIPlatformControllersPurchasingIntegrationApexTradingListingsListAPIResponseUnitDetails[]
}

export interface MainStemAPIPlatformControllersPurchasingIntegrationApexTradingListingsListAPIResponseUnitDetails {
  isDefault?: boolean
  name?: string
  /** @format int32 */
  unitMeasurementId: number
}

export interface MainStemAPIPlatformControllersPurchasingIntegrationApexTradingLocationsListAPIRequest {
  /** @format int32 */
  id?: number
}

export interface MainStemAPIPlatformControllersPurchasingIntegrationApexTradingLocationsListAPIResponse {
  locations?: MainStemAPIPlatformControllersPurchasingIntegrationApexTradingLocationsListAPIResponseLocationDetails[]
  message?: string
  wasSuccessful?: boolean
}

export interface MainStemAPIPlatformControllersPurchasingIntegrationApexTradingLocationsListAPIResponseLocationDetails {
  /** @format int32 */
  locationId: number
  locationName?: string
  /** @format int32 */
  operationId?: number
  operationName?: string
}

export interface MainStemAPIPlatformControllersPurchasingIntegrationApexTradingLocationsRemoveAPIRequest {
  /** @format int32 */
  id?: number
  /** @format int32 */
  locationId?: number
}

export interface MainStemAPIPlatformControllersPurchasingIntegrationApexTradingLocationsRemoveAPIResponse {
  message?: string
  wasSuccessful?: boolean
}

export interface MainStemAPIPlatformControllersPurchasingIntegrationApexTradingLocationsSaveAPIRequest {
  /** @format int32 */
  id?: number
  /** @format int32 */
  locationId?: number
  /** @format int32 */
  operationId?: number
  operationName?: string
}

export interface MainStemAPIPlatformControllersPurchasingIntegrationApexTradingLocationsSaveAPIResponse {
  message?: string
  wasSuccessful?: boolean
}

export interface MainStemAPIPlatformControllersPurchasingIntegrationApexTradingOperationsListAPIRequest {
  /** @format int32 */
  id?: number
}

export interface MainStemAPIPlatformControllersPurchasingIntegrationApexTradingOperationsListAPIResponse {
  operations?: MainStemAPIPlatformControllersPurchasingIntegrationApexTradingOperationsListAPIResponseOperationDetails[]
  message?: string
  wasSuccessful?: boolean
}

export interface MainStemAPIPlatformControllersPurchasingIntegrationApexTradingOperationsListAPIResponseOperationDetails {
  /** @format int32 */
  id: number
  name?: string
  city?: string
  state?: string
  license?: string
  operationType?: string
  isDisabled: boolean
}

export interface MainStemAPIPlatformControllersPurchasingIntegrationApexTradingOrderLineItemCreateAPIRequest {
  /** @format int32 */
  batchId: number
  /** @format int32 */
  integrationSettingsId?: number
  /** @format int32 */
  orderId: number
  /** @format int32 */
  productId: number
  /** @format double */
  quantity: number
  /** @format int32 */
  unitMeasurementId?: number
}

export interface MainStemAPIPlatformControllersPurchasingIntegrationApexTradingOrderLineItemCreateAPIResponse {
  message?: string
  wasSuccessful?: boolean
}

export interface MainStemAPIPlatformControllersPurchasingIntegrationApexTradingPairAPIRequest {
  /** @format int32 */
  id?: number
  pairingCode?: string
}

export interface MainStemAPIPlatformControllersPurchasingIntegrationApexTradingPairAPIResponse {
  /** @format int32 */
  companyId?: number
  companyName?: string
  hasToken?: boolean
  tokenAlreadyIssued?: boolean
  message?: string
  wasSuccessful?: boolean
}

export interface MainStemAPIPlatformControllersPurchasingIntegrationApexTradingProductsListAPIRequest {
  /** @format int32 */
  id?: number
}

export interface MainStemAPIPlatformControllersPurchasingIntegrationApexTradingProductsListAPIResponse {
  products?: MainStemAPIPlatformControllersPurchasingIntegrationApexTradingProductsListAPIResponseProductDetails[]
  message?: string
  wasSuccessful?: boolean
}

export interface MainStemAPIPlatformControllersPurchasingIntegrationApexTradingProductsListAPIResponseProductDetails {
  /** @format int32 */
  apexProductId: number
  createdByIntegration?: boolean
  /** @format int32 */
  productId: number
  productImageUrl?: string
  productName?: string
  productUnit?: string
  /** @format int32 */
  supplierId?: number
  supplierName?: string
  /** @format int32 */
  unitMeasurementId: number
}

export interface MainStemAPIPlatformControllersPurchasingIntegrationApexTradingProductsRemoveAPIRequest {
  /** @format int32 */
  id?: number
  /** @format int32 */
  productId?: number
}

export interface MainStemAPIPlatformControllersPurchasingIntegrationApexTradingProductsRemoveAPIResponse {
  message?: string
  wasSuccessful?: boolean
}

export interface MainStemAPIPlatformControllersPurchasingIntegrationApexTradingProductsSaveAPIRequest {
  /** @format int32 */
  id?: number
  /** @format int32 */
  apexProductId?: number
  /** @format int32 */
  unitMeasurementId?: number
  /** @format int32 */
  productId?: number
}

export interface MainStemAPIPlatformControllersPurchasingIntegrationApexTradingProductsSaveAPIResponse {
  /** @format int32 */
  productId?: number
  productName?: string
  /** @format int32 */
  sellerId?: number
  sellerName?: string
  sellerWasMapped?: boolean
  /** @format int32 */
  supplierId?: number
  supplierName?: string
  message?: string
  wasSuccessful?: boolean
}

export interface MainStemAPIPlatformControllersPurchasingIntegrationApexTradingSellersListAPIRequest {
  /** @format int32 */
  id?: number
}

export interface MainStemAPIPlatformControllersPurchasingIntegrationApexTradingSellersListAPIResponse {
  sellers?: MainStemAPIPlatformControllersPurchasingIntegrationApexTradingSellersListAPIResponseSellerDetails[]
  message?: string
  wasSuccessful?: boolean
}

export interface MainStemAPIPlatformControllersPurchasingIntegrationApexTradingSellersListAPIResponseSellerDetails {
  /** @format int32 */
  id: number
  name?: string
  /** @format int32 */
  productCount: number
  /** @format int32 */
  supplierId?: number
  supplierName?: string
}

export interface MainStemAPIPlatformControllersPurchasingIntegrationApexTradingShipmentCheckAPIRequest {
  /** @format int32 */
  invoiceId?: number
}

export interface MainStemAPIPlatformControllersPurchasingIntegrationApexTradingShipmentCheckAPIResponse {
  /** @format date-time */
  dateShipped?: string
  orders?: MainStemAPIPlatformControllersPurchasingIntegrationApexTradingShipmentCheckAPIResponseOrderDetails[]
  shipped?: boolean
  message?: string
  wasSuccessful?: boolean
}

export interface MainStemAPIPlatformControllersPurchasingIntegrationApexTradingShipmentCheckAPIResponseOrderDetails {
  /** @format date-time */
  dateShipped?: string
  id: string
  invoiceNumber?: string
  isCancelled?: boolean
  isShipped?: boolean
  status?: string
}

export interface MainStemAPIPlatformControllersPurchasingIntegrationApexTradingSuppliersListAPIRequest {
  /** @format int32 */
  id?: number
}

export interface MainStemAPIPlatformControllersPurchasingIntegrationApexTradingSuppliersListAPIResponse {
  suppliers?: MainStemAPIPlatformControllersPurchasingIntegrationApexTradingSuppliersListAPIResponseSupplierDetails[]
  message?: string
  wasSuccessful?: boolean
}

export interface MainStemAPIPlatformControllersPurchasingIntegrationApexTradingSuppliersListAPIResponseSupplierDetails {
  /** @format int32 */
  sellerId?: number
  sellerName?: string
  /** @format int32 */
  supplierId: number
  supplierLogoUrl?: string
  supplierName?: string
}

export interface MainStemAPIPlatformControllersPurchasingIntegrationApexTradingSuppliersRemoveAPIRequest {
  /** @format int32 */
  id?: number
  /** @format int32 */
  supplierId?: number
}

export interface MainStemAPIPlatformControllersPurchasingIntegrationApexTradingSuppliersRemoveAPIResponse {
  message?: string
  wasSuccessful?: boolean
}

export interface MainStemAPIPlatformControllersPurchasingIntegrationApexTradingSuppliersSaveAPIRequest {
  /** @format int32 */
  id?: number
  /** @format int32 */
  sellerId?: number
  sellerName?: string
  /** @format int32 */
  supplierId?: number
}

export interface MainStemAPIPlatformControllersPurchasingIntegrationApexTradingSuppliersSaveAPIResponse {
  /** @format int32 */
  supplierId?: number
  supplierName?: string
  wasCreated?: boolean
  message?: string
  wasSuccessful?: boolean
}

export interface MainStemAPIPlatformControllersPurchasingIntegrationDutchieEmployeesDetailsAPIRequest {
  /** @format int32 */
  id?: number
  /** @format int32 */
  userId?: number
}

export interface MainStemAPIPlatformControllersPurchasingIntegrationDutchieEmployeesDetailsAPIResponse {
  employee?: MainStemAPIPlatformControllersPurchasingIntegrationDutchieModelsEmployeeDetails
  integrationName?: string
  message?: string
  wasSuccessful?: boolean
}

export interface MainStemAPIPlatformControllersPurchasingIntegrationDutchieModelsEmployeeDetails {
  /** @format int32 */
  id?: number
  /** @format int32 */
  userId?: number
  globalUserId?: string
  loginId?: string
  fullName?: string
  defaultLocation?: string
  status?: string
  stateId?: string
  /** @format date-time */
  mmjExpiration?: string
  environment?: string
  permissions?: MainStemAPIPlatformControllersPurchasingIntegrationDutchieModelsEmployeeDetailsPermission[]
  /** @format date-time */
  createdAt?: string
  /** @format date-time */
  updatedAt?: string
  /** @format date-time */
  lastSyncedAt?: string
}

export interface MainStemAPIPlatformControllersPurchasingIntegrationDutchieModelsEmployeeDetailsPermission {
  permissionsLocation?: string
  groups?: string
}

export interface MainStemAPIPlatformControllersPurchasingIntegrationDutchieEmployeesListAPIRequest {
  /** @format int32 */
  id?: number
}

export interface MainStemAPIPlatformControllersPurchasingIntegrationDutchieEmployeesListAPIResponse {
  employees?: MainStemAPIPlatformControllersPurchasingIntegrationDutchieModelsEmployeeDetails[]
  lastSync?: MainStemAPIPlatformControllersPurchasingIntegrationDutchieModelsSyncRunDetails
  message?: string
  wasSuccessful?: boolean
}

export interface MainStemAPIPlatformControllersPurchasingIntegrationDutchieModelsSyncRunDetails {
  /** @format int32 */
  id?: number
  syncType?: string
  triggeredBy?: string
  status?: string
  /** @format int32 */
  recordsSynced?: number
  errorMessage?: string
  /** @format int32 */
  statusCode?: number
  /** @format date-time */
  startedAt?: string
  /** @format date-time */
  finishedAt?: string
}

export interface MainStemAPIPlatformControllersPurchasingIntegrationDutchieEmployeesSyncAPIRequest {
  /** @format int32 */
  id?: number
}

export interface MainStemAPIPlatformControllersPurchasingIntegrationDutchieEmployeesSyncAPIResponse {
  /** @format int32 */
  employeesSynced?: number
  /** @format int32 */
  syncRunId?: number
  message?: string
  wasSuccessful?: boolean
}

export interface MainStemAPIPlatformControllersPurchasingIntegrationDutchieEndpointsListAPIRequest {
  /** @format int32 */
  id?: number
}

export interface MainStemAPIPlatformControllersPurchasingIntegrationDutchieEndpointsListAPIResponse {
  endpoints?: MainStemAPIPlatformControllersPurchasingIntegrationDutchieModelsEndpointAccessDetails[]
  message?: string
  wasSuccessful?: boolean
}

export interface MainStemAPIPlatformControllersPurchasingIntegrationDutchieModelsEndpointAccessDetails {
  endpoint?: string
  syncType?: string
  label?: string
  scope?: string
  status?: string
  /** @format int32 */
  statusCode?: number
  message?: string
  /** @format date-time */
  lastCheckedAt?: string
  /** @format date-time */
  lastSucceededAt?: string
}

export interface MainStemAPIPlatformControllersPurchasingIntegrationDutchieInventoryDetailsAPIRequest {
  /** @format int32 */
  id?: number
  /** @format int32 */
  inventoryId?: number
}

export interface MainStemAPIPlatformControllersPurchasingIntegrationDutchieInventoryDetailsAPIResponse {
  item?: MainStemAPIPlatformControllersPurchasingIntegrationDutchieModelsInventoryItemDetails
  integrationName?: string
  message?: string
  wasSuccessful?: boolean
}

export interface MainStemAPIPlatformControllersPurchasingIntegrationDutchieModelsInventoryItemDetails {
  /** @format int32 */
  id?: number
  /** @format int32 */
  inventoryId?: number
  /** @format int32 */
  productId?: number
  productName?: string
  sku?: string
  /** @format int32 */
  batchId?: number
  batchName?: string
  packageId?: string
  externalPackageId?: string
  packageStatus?: string
  /** @format double */
  quantityAvailable?: number
  quantityUnits?: string
  /** @format double */
  unitPrice?: number
  /** @format double */
  medUnitPrice?: number
  /** @format double */
  recUnitPrice?: number
  /** @format double */
  unitWeight?: number
  unitWeightUnit?: string
  /** @format double */
  flowerEquivalent?: number
  /** @format double */
  effectivePotencyMg?: number
  pricingTierName?: string
  category?: string
  /** @format int32 */
  categoryId?: number
  masterCategory?: string
  /** @format int32 */
  brandId?: number
  brandName?: string
  /** @format int32 */
  vendorId?: number
  vendorName?: string
  /** @format int32 */
  producerId?: number
  producerName?: string
  strain?: string
  /** @format int32 */
  strainId?: number
  strainType?: string
  size?: string
  isCannabis?: boolean
  medicalOnly?: boolean
  labTestStatus?: string
  labResultUrl?: string
  /** @format date-time */
  expirationDate?: string
  /** @format date-time */
  manufacturingDate?: string
  /** @format date-time */
  packagedDate?: string
  /** @format date-time */
  testedDate?: string
  /** @format date-time */
  lastModifiedDateUtc?: string
  environment?: string
  /** @format date-time */
  createdAt?: string
  /** @format date-time */
  updatedAt?: string
  /** @format date-time */
  lastSyncedAt?: string
}

export interface MainStemAPIPlatformControllersPurchasingIntegrationDutchieInventoryListAPIRequest {
  /** @format int32 */
  id?: number
  /** @format int32 */
  page?: number
  /** @format int32 */
  pageSize?: number
  filters?: Record<string, string>
  sortColumn?: string
  sortDirection?: string
}

export interface MainStemAPIPlatformControllersPurchasingIntegrationDutchieInventoryListAPIResponse {
  items?: MainStemAPIPlatformControllersPurchasingIntegrationDutchieModelsInventoryItemDetails[]
  /** @format int32 */
  total?: number
  /** @format int32 */
  totalFiltered?: number
  lastSync?: MainStemAPIPlatformControllersPurchasingIntegrationDutchieModelsSyncRunDetails
  message?: string
  wasSuccessful?: boolean
}

export interface MainStemAPIPlatformControllersPurchasingIntegrationDutchieInventorySyncAPIRequest {
  /** @format int32 */
  id?: number
}

export interface MainStemAPIPlatformControllersPurchasingIntegrationDutchieInventorySyncAPIResponse {
  /** @format int32 */
  itemsSynced?: number
  /** @format int32 */
  syncRunId?: number
  message?: string
  wasSuccessful?: boolean
}

export interface MainStemAPIPlatformControllersPurchasingIntegrationDutchieInventoryTransactionsListAPIRequest {
  /** @format int32 */
  id?: number
  /** @format date-time */
  startDate?: string
  /** @format date-time */
  endDate?: string
}

export interface MainStemAPIPlatformControllersPurchasingIntegrationDutchieInventoryTransactionsListAPIResponse {
  transactions?: MainStemAPIPlatformControllersPurchasingIntegrationDutchieModelsInventoryTransactionDetails[]
  /** @format int32 */
  total?: number
  truncated?: boolean
  lastSync?: MainStemAPIPlatformControllersPurchasingIntegrationDutchieModelsSyncRunDetails
  message?: string
  wasSuccessful?: boolean
}

export interface MainStemAPIPlatformControllersPurchasingIntegrationDutchieModelsInventoryTransactionDetails {
  /** @format int32 */
  id?: number
  /** @format int32 */
  inventoryTransactionId?: number
  /** @format int32 */
  inventoryId?: number
  /** @format int32 */
  productId?: number
  productName?: string
  sku?: string
  /** @format int32 */
  batchId?: number
  batchName?: string
  packageId?: string
  externalPackageId?: string
  transactionType?: string
  /** @format date-time */
  transactionDate?: string
  transactionBy?: string
  /** @format double */
  quantity?: number
  /** @format double */
  fromQuantity?: number
  /** @format double */
  toQuantity?: number
  unit?: string
  /** @format double */
  unitCost?: number
  reason?: string
  fromRoom?: string
  toRoom?: string
  fromLocation?: string
  toLocation?: string
  /** @format int32 */
  purchaseOrderId?: number
  /** @format int32 */
  receiveInventoryHistoryId?: number
  /** @format int32 */
  conversionTransactionId?: number
  /** @format int32 */
  mainStemInvoiceID?: number
  /** @format int32 */
  mainStemInvoiceLineItemID?: number
  environment?: string
  /** @format date-time */
  createdAt?: string
  /** @format date-time */
  updatedAt?: string
  /** @format date-time */
  lastSyncedAt?: string
}

export interface MainStemAPIPlatformControllersPurchasingIntegrationDutchieInventoryTransactionsSyncAPIRequest {
  /** @format int32 */
  id?: number
  /** @format date-time */
  startDate?: string
  /** @format date-time */
  endDate?: string
}

export interface MainStemAPIPlatformControllersPurchasingIntegrationDutchieInventoryTransactionsSyncAPIResponse {
  /** @format int32 */
  transactionsSynced?: number
  /** @format int32 */
  syncRunId?: number
  message?: string
  wasSuccessful?: boolean
}

export interface MainStemAPIPlatformControllersPurchasingIntegrationDutchieInvoiceLineItemsAssignAPIRequest {
  /** @format int32 */
  id?: number
  /** @format int32 */
  receiveInventoryHistoryId?: number
  /** @format int32 */
  invoiceId?: number
  /** @format int32 */
  productId?: number
  /** @format int32 */
  invoiceLineItemId?: number
}

export interface MainStemAPIPlatformControllersPurchasingIntegrationDutchieInvoiceLineItemsAssignAPIResponse {
  /** @format int32 */
  matchedLineCount?: number
  /** @format int32 */
  receivesWritten?: number
  usedAi?: boolean
  /** @format int32 */
  matchRunId?: number
  logText?: string
  message?: string
  wasSuccessful?: boolean
}

export interface MainStemAPIPlatformControllersPurchasingIntegrationDutchieInvoiceLineItemsListAPIRequest {
  /** @format int32 */
  id?: number
}

export interface MainStemAPIPlatformControllersPurchasingIntegrationDutchieInvoiceLineItemsListAPIResponse {
  receives?: MainStemSDKIntegrationsDutchieInvoiceLineItemsListResponseReceiveDetails[]
  unmatchedInvoices?: MainStemSDKIntegrationsDutchieInvoiceLineItemsListResponseInvoiceDetails[]
  invoices?: MainStemSDKIntegrationsDutchieInvoiceLineItemsListResponseInvoiceDetails[]
  matchRuns?: MainStemSDKIntegrationsDutchieInvoiceLineItemsListResponseMatchRunDetails[]
  /** @format int32 */
  matchedCount?: number
  /** @format int32 */
  unmatchedDutchieCount?: number
  /** @format int32 */
  ambiguousCount?: number
  /** @format int32 */
  excludedCount?: number
  /** @format int32 */
  unmatchedMainStemCount?: number
  message?: string
  wasSuccessful?: boolean
}

export interface MainStemSDKIntegrationsDutchieInvoiceLineItemsListResponseReceiveDetails {
  /** @format int32 */
  receiveInventoryHistoryId?: number
  title?: string
  dutchieStatus?: string
  vendorName?: string
  /** @format int32 */
  vendorId?: number
  /** @format int32 */
  mappedSupplierId?: number
  /** @format int32 */
  purchaseOrderId?: number
  /** @format date-time */
  deliveredOn?: string
  /** @format date-time */
  addedOn?: string
  deliveredBy?: string
  /** @format double */
  quantity?: number
  /** @format double */
  total?: number
  status?: string
  method?: string
  /** @format int32 */
  confidence?: number
  reason?: string
  invoices?: MainStemSDKIntegrationsDutchieInvoiceLineItemsListResponseReceiveInvoiceDetails[]
  mainStemInvoiceIDs?: number[]
  mainStemInvoiceReceivedIDs?: number[]
  mainStemInventoryReceivedIDs?: number[]
  /** @format int32 */
  matchRunId?: number
  /** @format date-time */
  matchedAt?: string
  lines?: MainStemSDKIntegrationsDutchieInvoiceLineItemsListResponseLineDetails[]
  /** @format int32 */
  lineCount?: number
  /** @format int32 */
  matchedLineCount?: number
  /** @format int32 */
  ambiguousLineCount?: number
  /** @format int32 */
  unmatchedLineCount?: number
}

export interface MainStemSDKIntegrationsDutchieInvoiceLineItemsListResponseInvoiceDetails {
  /** @format int32 */
  invoiceID?: number
  /** @format int32 */
  supplierID?: number
  supplierName?: string
  /** @format int32 */
  mappedVendorId?: number
  /** @format int32 */
  locationID?: number
  locationName?: string
  /** @format date-time */
  invoiceDate?: string
  invoiceStatus?: string
  /** @format double */
  total?: number
  /** @format double */
  quantity?: number
  /** @format double */
  remainingQuantity?: number
  matchedReceiveIds?: number[]
  lines?: MainStemSDKIntegrationsDutchieInvoiceLineItemsListResponseInvoiceLineDetails[]
}

export interface MainStemSDKIntegrationsDutchieInvoiceLineItemsListResponseMatchRunDetails {
  /** @format int32 */
  id?: number
  triggeredBy?: string
  scope?: string
  /** @format int32 */
  inventoryTransactionId?: number
  /** @format int32 */
  receiveInventoryHistoryId?: number
  status?: string
  /** @format int32 */
  matchedCount?: number
  /** @format int32 */
  unmatchedDutchieCount?: number
  /** @format int32 */
  unmatchedMainStemCount?: number
  usedAi?: boolean
  logText?: string
  errorMessage?: string
  /** @format date-time */
  startedAt?: string
  /** @format date-time */
  finishedAt?: string
}

export interface MainStemSDKIntegrationsDutchieInvoiceLineItemsListResponseReceiveInvoiceDetails {
  /** @format int32 */
  invoiceID?: number
  /** @format int32 */
  supplierID?: number
  supplierName?: string
  /** @format int32 */
  lineCount?: number
  /** @format double */
  quantity?: number
}

export interface MainStemSDKIntegrationsDutchieInvoiceLineItemsListResponseLineDetails {
  /** @format int32 */
  productId?: number
  productName?: string
  sku?: string
  inventoryTransactionIds?: number[]
  /** @format int32 */
  packageCount?: number
  /** @format double */
  quantity?: number
  /** @format double */
  unitCost?: number
  /** @format double */
  total?: number
  /** @format int32 */
  roomId?: number
  roomName?: string
  /** @format int32 */
  mappedMainStemProductId?: number
  status?: string
  method?: string
  /** @format int32 */
  confidence?: number
  reason?: string
  /** @format int32 */
  mainStemInvoiceID?: number
  /** @format int32 */
  mainStemSupplierID?: number
  mainStemSupplierName?: string
  /** @format int32 */
  mainStemInvoiceLineItemID?: number
  mainStemProductName?: string
  /** @format int32 */
  mainStemProductID?: number
  /** @format double */
  mainStemQuantity?: number
  /** @format double */
  mainStemPrice?: number
  /** @format int32 */
  mainStemInvoiceReceivedLineItemID?: number
  /** @format int32 */
  mainStemInventoryReceivedID?: number
  receivedInMainStem?: boolean
}

export interface MainStemSDKIntegrationsDutchieInvoiceLineItemsListResponseInvoiceLineDetails {
  /** @format int32 */
  lineItemID?: number
  /** @format int32 */
  productID?: number
  productName?: string
  sku?: string
  /** @format double */
  quantity?: number
  /** @format double */
  mappedQuantity?: number
  /** @format double */
  remainingQuantity?: number
  /** @format double */
  price?: number
}

export interface MainStemAPIPlatformControllersPurchasingIntegrationDutchieInvoiceLineItemsMatchAPIRequest {
  /** @format int32 */
  id?: number
  /** @format int32 */
  receiveInventoryHistoryId?: number
}

export interface MainStemAPIPlatformControllersPurchasingIntegrationDutchieInvoiceLineItemsMatchAPIResponse {
  /** @format int32 */
  matchedCount?: number
  /** @format int32 */
  matchedLineCount?: number
  /** @format int32 */
  unmatchedDutchieCount?: number
  /** @format int32 */
  unmatchedMainStemCount?: number
  /** @format int32 */
  receivesWritten?: number
  usedAi?: boolean
  /** @format int32 */
  matchRunId?: number
  logText?: string
  message?: string
  wasSuccessful?: boolean
}

export interface MainStemAPIPlatformControllersPurchasingIntegrationDutchieInvoiceLineItemsResetAPIRequest {
  /** @format int32 */
  id?: number
}

export interface MainStemAPIPlatformControllersPurchasingIntegrationDutchieInvoiceLineItemsResetAPIResponse {
  /** @format int32 */
  matchRunId?: number
  logText?: string
  message?: string
  wasSuccessful?: boolean
}

export interface MainStemAPIPlatformControllersPurchasingIntegrationDutchieInvoiceLineItemsUnmapAPIRequest {
  /** @format int32 */
  id?: number
  /** @format int32 */
  receiveInventoryHistoryId?: number
  /** @format int32 */
  productId?: number
}

export interface MainStemAPIPlatformControllersPurchasingIntegrationDutchieInvoiceLineItemsUnmapAPIResponse {
  message?: string
  wasSuccessful?: boolean
}

export interface MainStemAPIPlatformControllersPurchasingIntegrationDutchieInvoicesDetailsAPIRequest {
  /** @format int32 */
  id?: number
}

export interface MainStemAPIPlatformControllersPurchasingIntegrationDutchieInvoicesDetailsAPIResponse {
  hasDutchieIntegration?: boolean
  /** @format int32 */
  integrationSettingsId?: number
  integrationName?: string
  receives?: MainStemSDKIntegrationsDutchieInvoiceLineItemsListResponseReceiveDetails[]
  supplierMapped?: boolean
  /** @format int32 */
  productCount?: number
  /** @format int32 */
  productsMappedCount?: number
  message?: string
  wasSuccessful?: boolean
}

export interface MainStemAPIPlatformControllersPurchasingIntegrationDutchieLocationsLinkedAPIRequest {
  /** @format int32 */
  locationId?: number
}

export interface MainStemAPIPlatformControllersPurchasingIntegrationDutchieLocationsLinkedAPIResponse {
  integrations?: MainStemAPIPlatformControllersPurchasingIntegrationDutchieLocationsLinkedLinkedDutchieLocation[]
  message?: string
  wasSuccessful?: boolean
}

export interface MainStemAPIPlatformControllersPurchasingIntegrationDutchieLocationsLinkedLinkedDutchieLocation {
  /** @format int32 */
  integrationSettingsId?: number
  integrationName?: string
  activity?: MainStemSDKIntegrationsDutchiePostgresLocationActivity
}

export interface MainStemSDKIntegrationsDutchiePostgresLocationActivity {
  /** @format int32 */
  receiveCount?: number
  /** @format double */
  receivedCost?: number
  /** @format date-time */
  lastReceived?: string
  /** @format int32 */
  saleCount?: number
  /** @format double */
  salesRevenue?: number
  /** @format date-time */
  lastSale?: string
  /** @format double */
  quantityOnHand?: number
  /** @format double */
  inventoryValue?: number
  months?: MainStemSDKIntegrationsDutchiePostgresVendorProfileMonth[]
  receives?: MainStemSDKIntegrationsDutchiePostgresVendorProfileReceive[]
  receivesTruncated?: boolean
  sales?: MainStemSDKIntegrationsDutchiePostgresProductActivitySaleRow[]
  salesTruncated?: boolean
  topProducts?: MainStemSDKIntegrationsDutchiePostgresVendorProfileTopProduct[]
}

export interface MainStemSDKIntegrationsDutchiePostgresVendorProfileMonth {
  /** @format date-time */
  month?: string
  /** @format double */
  purchases?: number
  /** @format double */
  receiving?: number
  /** @format double */
  sales?: number
}

export interface MainStemSDKIntegrationsDutchiePostgresVendorProfileReceive {
  /** @format int32 */
  receiveInventoryHistoryId?: number
  title?: string
  status?: string
  /** @format date-time */
  deliveredOn?: string
  /** @format date-time */
  addedOn?: string
  /** @format int32 */
  purchaseOrderId?: number
  /** @format double */
  cost?: number
}

export interface MainStemSDKIntegrationsDutchiePostgresProductActivitySaleRow {
  /** @format int32 */
  transactionId?: number
  /** @format date-time */
  transactionDate?: string
  isVoid?: boolean
  isReturn?: boolean
  orderType?: string
  invoiceNumber?: string
  /** @format double */
  quantity?: number
  /** @format double */
  totalPrice?: number
  /** @format double */
  totalDiscount?: number
}

export interface MainStemSDKIntegrationsDutchiePostgresVendorProfileTopProduct {
  /** @format int32 */
  productId?: number
  productName?: string
  /** @format double */
  revenue?: number
  /** @format double */
  quantity?: number
}

export interface MainStemAPIPlatformControllersPurchasingIntegrationDutchieProductsActivityAPIRequest {
  /** @format int32 */
  id?: number
  /** @format int32 */
  productId?: number
}

export interface MainStemAPIPlatformControllersPurchasingIntegrationDutchieProductsActivityAPIResponse {
  integrationName?: string
  activity?: MainStemSDKIntegrationsDutchiePostgresProductActivityResult
  message?: string
  wasSuccessful?: boolean
}

export interface MainStemSDKIntegrationsDutchiePostgresProductActivityResult {
  /** @format double */
  quantityOnHand?: number
  quantityUnits?: string
  mixedUnits?: boolean
  /** @format double */
  allocatedQuantity?: number
  /** @format double */
  inventoryValue?: number
  inventoryValueComplete?: boolean
  /** @format int32 */
  packageCount?: number
  packages?: MainStemSDKIntegrationsDutchiePostgresProductActivityPackageRow[]
  /** @format int32 */
  purchaseOrderCount?: number
  /** @format double */
  purchaseQuantity?: number
  /** @format double */
  purchaseSpend?: number
  purchaseOrders?: MainStemSDKIntegrationsDutchiePostgresProductActivityPurchaseOrderRow[]
  /** @format int32 */
  receiveCount?: number
  /** @format double */
  receivedQuantity?: number
  /** @format double */
  receivedCost?: number
  receives?: MainStemSDKIntegrationsDutchiePostgresProductActivityReceiveRow[]
  /** @format int32 */
  transactionCount?: number
  /** @format int32 */
  saleCount?: number
  /** @format double */
  unitsSold?: number
  /** @format double */
  unitsReturned?: number
  /** @format double */
  salesRevenue?: number
  /** @format double */
  salesDiscount?: number
  /** @format double */
  salesCost?: number
  salesCostComplete?: boolean
  salesByWeek?: MainStemSDKIntegrationsDutchiePostgresProductActivityBucket[]
  sales?: MainStemSDKIntegrationsDutchiePostgresProductActivitySaleRow[]
  receivedByMonth?: MainStemSDKIntegrationsDutchiePostgresProductActivityBucket[]
  /** @format int32 */
  ledgerCount?: number
  ledger?: MainStemSDKIntegrationsDutchiePostgresProductActivityLedgerRow[]
  movementByType?: MainStemSDKIntegrationsDutchiePostgresProductActivityMovementRow[]
}

export interface MainStemSDKIntegrationsDutchiePostgresProductActivityPackageRow {
  /** @format int32 */
  inventoryId?: number
  packageId?: string
  batchName?: string
  packageStatus?: string
  /** @format double */
  quantityAvailable?: number
  quantityUnits?: string
  /** @format double */
  unitPrice?: number
  /** @format date-time */
  expirationDate?: string
  /** @format double */
  unitCost?: number
  /** @format double */
  allocatedQuantity?: number
  inInventory?: boolean
  inReportingInventory?: boolean
}

export interface MainStemSDKIntegrationsDutchiePostgresProductActivityPurchaseOrderRow {
  /** @format int32 */
  purchaseOrderId?: number
  /** @format int32 */
  purchaseOrderNumber?: number
  title?: string
  status?: string
  /** @format int32 */
  vendorId?: number
  vendorName?: string
  /** @format date-time */
  dateCreated?: string
  /** @format date-time */
  expectedArrivalDate?: string
  /** @format double */
  quantity?: number
  /** @format double */
  subtotal?: number
  /** @format double */
  tax?: number
}

export interface MainStemSDKIntegrationsDutchiePostgresProductActivityReceiveRow {
  /** @format int32 */
  receiveInventoryHistoryId?: number
  title?: string
  status?: string
  vendorName?: string
  /** @format int32 */
  purchaseOrderId?: number
  /** @format date-time */
  deliveredOn?: string
  /** @format date-time */
  addedOn?: string
  /** @format double */
  quantity?: number
  /** @format double */
  totalCost?: number
}

export interface MainStemSDKIntegrationsDutchiePostgresProductActivityBucket {
  bucket?: string
  /** @format double */
  quantity?: number
  /** @format double */
  amount?: number
}

export interface MainStemSDKIntegrationsDutchiePostgresProductActivityLedgerRow {
  /** @format int32 */
  inventoryTransactionId?: number
  /** @format int32 */
  inventoryId?: number
  transactionType?: string
  /** @format date-time */
  transactionDate?: string
  /** @format double */
  quantity?: number
  unit?: string
  packageId?: string
  fromRoom?: string
  toRoom?: string
  /** @format int32 */
  purchaseOrderId?: number
  /** @format int32 */
  receiveInventoryHistoryId?: number
  /** @format int32 */
  mainstemInvoiceId?: number
  reason?: string
}

export interface MainStemSDKIntegrationsDutchiePostgresProductActivityMovementRow {
  transactionType?: string
  /** @format int32 */
  count?: number
  /** @format double */
  quantity?: number
}

export interface MainStemAPIPlatformControllersPurchasingIntegrationDutchieProductsDetailsAPIRequest {
  /** @format int32 */
  id?: number
  /** @format int32 */
  productId?: number
}

export interface MainStemAPIPlatformControllersPurchasingIntegrationDutchieProductsDetailsAPIResponse {
  product?: MainStemAPIPlatformControllersPurchasingIntegrationDutchieModelsProductDetails
  integrationName?: string
  message?: string
  wasSuccessful?: boolean
}

export interface MainStemAPIPlatformControllersPurchasingIntegrationDutchieModelsProductDetails {
  /** @format int32 */
  id?: number
  /** @format int32 */
  productId?: number
  globalProductId?: string
  sku?: string
  productName?: string
  internalName?: string
  alternateName?: string
  description?: string
  category?: string
  /** @format int32 */
  categoryId?: number
  masterCategory?: string
  /** @format int32 */
  brandId?: number
  brandName?: string
  /** @format int32 */
  vendorId?: number
  vendorName?: string
  /** @format int32 */
  producerId?: number
  producerName?: string
  strain?: string
  /** @format int32 */
  strainId?: number
  strainType?: string
  size?: string
  unitType?: string
  defaultUnit?: string
  /** @format double */
  netWeight?: number
  netWeightUnit?: string
  /** @format double */
  price?: number
  /** @format double */
  medPrice?: number
  /** @format double */
  recPrice?: number
  /** @format double */
  unitCost?: number
  isActive?: boolean
  isCannabis?: boolean
  isMedicalOnly?: boolean
  isTaxable?: boolean
  isCoupon?: boolean
  isFinished?: boolean
  /** @format double */
  thcContent?: number
  thcContentUnit?: string
  /** @format double */
  cbdContent?: number
  cbdContentUnit?: string
  imageUrl?: string
  upc?: string
  externalId?: string
  externalCategory?: string
  regulatoryCategory?: string
  /** @format date-time */
  lastModifiedDateUtc?: string
  /** @format date-time */
  createdDate?: string
  environment?: string
  /** @format date-time */
  createdAt?: string
  /** @format date-time */
  updatedAt?: string
  /** @format date-time */
  lastSyncedAt?: string
  /** @format int32 */
  mainStemProductId?: number
  mainStemProductName?: string
}

export interface MainStemAPIPlatformControllersPurchasingIntegrationDutchieProductsLinkedAPIRequest {
  /** @format int32 */
  productId?: number
}

export interface MainStemAPIPlatformControllersPurchasingIntegrationDutchieProductsLinkedAPIResponse {
  integrations?: MainStemAPIPlatformControllersPurchasingIntegrationDutchieProductsLinkedLinkedDutchieProduct[]
  message?: string
  wasSuccessful?: boolean
}

export interface MainStemAPIPlatformControllersPurchasingIntegrationDutchieProductsLinkedLinkedDutchieProduct {
  /** @format int32 */
  integrationSettingsId?: number
  integrationName?: string
  /** @format int32 */
  dutchieProductId?: number
  dutchieProductName?: string
  reportingInventory?: MainStemAPIPlatformControllersPurchasingIntegrationDutchieModelsReportingInventoryItemDetails[]
  receives?: MainStemAPIPlatformControllersPurchasingIntegrationDutchieModelsInventoryTransactionDetails[]
  sales?: MainStemSDKIntegrationsDutchiePostgresProductActivitySaleRow[]
}

export interface MainStemAPIPlatformControllersPurchasingIntegrationDutchieModelsReportingInventoryItemDetails {
  /** @format double */
  unitCost?: number
  /** @format double */
  allocatedQuantity?: number
  /** @format double */
  recFlowerEquivalent?: number
  flowerEquivalentUnits?: string
  /** @format date-time */
  sampleDate?: string
  alternateName?: string
  potencyIndicator?: string
  packageNdc?: string
  /** @format int32 */
  id?: number
  /** @format int32 */
  inventoryId?: number
  /** @format int32 */
  productId?: number
  productName?: string
  sku?: string
  /** @format int32 */
  batchId?: number
  batchName?: string
  packageId?: string
  externalPackageId?: string
  packageStatus?: string
  /** @format double */
  quantityAvailable?: number
  quantityUnits?: string
  /** @format double */
  unitPrice?: number
  /** @format double */
  medUnitPrice?: number
  /** @format double */
  recUnitPrice?: number
  /** @format double */
  unitWeight?: number
  unitWeightUnit?: string
  /** @format double */
  flowerEquivalent?: number
  /** @format double */
  effectivePotencyMg?: number
  pricingTierName?: string
  category?: string
  /** @format int32 */
  categoryId?: number
  masterCategory?: string
  /** @format int32 */
  brandId?: number
  brandName?: string
  /** @format int32 */
  vendorId?: number
  vendorName?: string
  /** @format int32 */
  producerId?: number
  producerName?: string
  strain?: string
  /** @format int32 */
  strainId?: number
  strainType?: string
  size?: string
  isCannabis?: boolean
  medicalOnly?: boolean
  labTestStatus?: string
  labResultUrl?: string
  /** @format date-time */
  expirationDate?: string
  /** @format date-time */
  manufacturingDate?: string
  /** @format date-time */
  packagedDate?: string
  /** @format date-time */
  testedDate?: string
  /** @format date-time */
  lastModifiedDateUtc?: string
  environment?: string
  /** @format date-time */
  createdAt?: string
  /** @format date-time */
  updatedAt?: string
  /** @format date-time */
  lastSyncedAt?: string
}

export interface MainStemAPIPlatformControllersPurchasingIntegrationDutchieProductsListAPIRequest {
  /** @format int32 */
  id?: number
  /** @format int32 */
  page?: number
  /** @format int32 */
  pageSize?: number
  filters?: Record<string, string>
  sortColumn?: string
  sortDirection?: string
}

export interface MainStemAPIPlatformControllersPurchasingIntegrationDutchieProductsListAPIResponse {
  products?: MainStemAPIPlatformControllersPurchasingIntegrationDutchieModelsProductDetails[]
  /** @format int32 */
  total?: number
  /** @format int32 */
  totalFiltered?: number
  lastSync?: MainStemAPIPlatformControllersPurchasingIntegrationDutchieModelsSyncRunDetails
  message?: string
  wasSuccessful?: boolean
}

export interface MainStemAPIPlatformControllersPurchasingIntegrationDutchieProductsMapAPIRequest {
  /** @format int32 */
  id?: number
  /** @format int32 */
  productId?: number
  /** @format int32 */
  mainStemProductId?: number
}

export interface MainStemAPIPlatformControllersPurchasingIntegrationDutchieProductsMapAPIResponse {
  /** @format int32 */
  mainStemProductId?: number
  mainStemProductName?: string
  message?: string
  wasSuccessful?: boolean
}

export interface MainStemAPIPlatformControllersPurchasingIntegrationDutchieProductsSyncAPIRequest {
  /** @format int32 */
  id?: number
}

export interface MainStemAPIPlatformControllersPurchasingIntegrationDutchieProductsSyncAPIResponse {
  /** @format int32 */
  productsSynced?: number
  /** @format int32 */
  syncRunId?: number
  message?: string
  wasSuccessful?: boolean
}

export interface MainStemAPIPlatformControllersPurchasingIntegrationDutchiePurchaseOrdersDetailsAPIRequest {
  /** @format int32 */
  id?: number
  /** @format int32 */
  purchaseOrderId?: number
}

export interface MainStemAPIPlatformControllersPurchasingIntegrationDutchiePurchaseOrdersDetailsAPIResponse {
  purchaseOrder?: MainStemAPIPlatformControllersPurchasingIntegrationDutchieModelsPurchaseOrderDetails
  integrationName?: string
  message?: string
  wasSuccessful?: boolean
}

export interface MainStemAPIPlatformControllersPurchasingIntegrationDutchieModelsPurchaseOrderDetails {
  /** @format int32 */
  id?: number
  /** @format int32 */
  purchaseOrderId?: number
  /** @format int32 */
  purchaseOrderNumber?: number
  title?: string
  status?: string
  /** @format int32 */
  vendorId?: number
  vendorName?: string
  vendorContact?: string
  createdByUser?: string
  /** @format date-time */
  dateCreated?: string
  /** @format date-time */
  dateSubmitted?: string
  /** @format date-time */
  dateReceived?: string
  /** @format date-time */
  expectedArrivalDate?: string
  /** @format int32 */
  itemCount?: number
  shippingInformation?: string
  items?: MainStemAPIPlatformControllersPurchasingIntegrationDutchieModelsPurchaseOrderItemDetails[]
  environment?: string
  /** @format date-time */
  createdAt?: string
  /** @format date-time */
  updatedAt?: string
  /** @format date-time */
  lastSyncedAt?: string
}

export interface MainStemAPIPlatformControllersPurchasingIntegrationDutchieModelsPurchaseOrderItemDetails {
  /** @format int32 */
  id?: number
  /** @format int32 */
  purchaseOrderItemId?: number
  /** @format int32 */
  productId?: number
  productName?: string
  sku?: string
  vendorSku?: string
  /** @format int32 */
  quantity?: number
  /** @format int32 */
  unitId?: number
  unitName?: string
  unitNameAbbreviation?: string
  /** @format double */
  subtotal?: number
  /** @format double */
  tax?: number
}

export interface MainStemAPIPlatformControllersPurchasingIntegrationDutchiePurchaseOrdersListAPIRequest {
  /** @format int32 */
  id?: number
}

export interface MainStemAPIPlatformControllersPurchasingIntegrationDutchiePurchaseOrdersListAPIResponse {
  purchaseOrders?: MainStemAPIPlatformControllersPurchasingIntegrationDutchieModelsPurchaseOrderDetails[]
  lastSync?: MainStemAPIPlatformControllersPurchasingIntegrationDutchieModelsSyncRunDetails
  message?: string
  wasSuccessful?: boolean
}

export interface MainStemAPIPlatformControllersPurchasingIntegrationDutchiePurchaseOrdersSyncAPIRequest {
  /** @format int32 */
  id?: number
}

export interface MainStemAPIPlatformControllersPurchasingIntegrationDutchiePurchaseOrdersSyncAPIResponse {
  /** @format int32 */
  purchaseOrdersSynced?: number
  /** @format int32 */
  syncRunId?: number
  message?: string
  wasSuccessful?: boolean
}

export interface MainStemAPIPlatformControllersPurchasingIntegrationDutchieReceivedInventoryDetailsAPIRequest {
  /** @format int32 */
  id?: number
  /** @format int32 */
  receiveInventoryHistoryId?: number
}

export interface MainStemAPIPlatformControllersPurchasingIntegrationDutchieReceivedInventoryDetailsAPIResponse {
  receive?: MainStemAPIPlatformControllersPurchasingIntegrationDutchieModelsReceivedInventoryDetails
  integrationName?: string
  message?: string
  wasSuccessful?: boolean
}

export interface MainStemAPIPlatformControllersPurchasingIntegrationDutchieModelsReceivedInventoryDetails {
  /** @format int32 */
  id?: number
  /** @format int32 */
  receiveInventoryHistoryId?: number
  title?: string
  status?: string
  vendorName?: string
  /** @format int32 */
  purchaseOrderId?: number
  externalId?: string
  transactionId?: string
  /** @format date-time */
  addedOn?: string
  /** @format date-time */
  deliveredOn?: string
  deliveredBy?: string
  note?: string
  /** @format double */
  shippingCharge?: number
  /** @format double */
  totalCredit?: number
  failureMessage?: string
  items?: MainStemAPIPlatformControllersPurchasingIntegrationDutchieModelsReceivedInventoryItemDetails[]
  environment?: string
  /** @format date-time */
  createdAt?: string
  /** @format date-time */
  updatedAt?: string
  /** @format date-time */
  lastSyncedAt?: string
}

export interface MainStemAPIPlatformControllersPurchasingIntegrationDutchieModelsReceivedInventoryItemDetails {
  /** @format int32 */
  id?: number
  /** @format int32 */
  lineNumber?: number
  /** @format int32 */
  productId?: number
  productName?: string
  sku?: string
  /** @format int32 */
  batchId?: number
  batchName?: string
  packageId?: string
  externalPackageId?: string
  /** @format int32 */
  roomId?: number
  roomName?: string
  productType?: string
  /** @format double */
  quantity?: number
  unit?: string
  unitAbbreviation?: string
  /** @format double */
  unitCost?: number
  /** @format double */
  unitTax?: number
  /** @format double */
  totalCost?: number
}

export interface MainStemAPIPlatformControllersPurchasingIntegrationDutchieReceivedInventoryListAPIRequest {
  /** @format int32 */
  id?: number
  /** @format date-time */
  startDate?: string
  /** @format date-time */
  endDate?: string
}

export interface MainStemAPIPlatformControllersPurchasingIntegrationDutchieReceivedInventoryListAPIResponse {
  receives?: MainStemAPIPlatformControllersPurchasingIntegrationDutchieModelsReceivedInventoryDetails[]
  /** @format int32 */
  total?: number
  truncated?: boolean
  lastSync?: MainStemAPIPlatformControllersPurchasingIntegrationDutchieModelsSyncRunDetails
  message?: string
  wasSuccessful?: boolean
}

export interface MainStemAPIPlatformControllersPurchasingIntegrationDutchieReceivedInventorySyncAPIRequest {
  /** @format int32 */
  id?: number
  /** @format date-time */
  startDate?: string
  /** @format date-time */
  endDate?: string
}

export interface MainStemAPIPlatformControllersPurchasingIntegrationDutchieReceivedInventorySyncAPIResponse {
  /** @format int32 */
  receivesSynced?: number
  /** @format int32 */
  syncRunId?: number
  message?: string
  wasSuccessful?: boolean
}

export interface MainStemAPIPlatformControllersPurchasingIntegrationDutchieReportingInventoryDetailsAPIRequest {
  /** @format int32 */
  id?: number
  /** @format int32 */
  inventoryId?: number
}

export interface MainStemAPIPlatformControllersPurchasingIntegrationDutchieReportingInventoryDetailsAPIResponse {
  item?: MainStemAPIPlatformControllersPurchasingIntegrationDutchieModelsReportingInventoryItemDetails
  integrationName?: string
  message?: string
  wasSuccessful?: boolean
}

export interface MainStemAPIPlatformControllersPurchasingIntegrationDutchieReportingInventoryListAPIRequest {
  /** @format int32 */
  id?: number
  /** @format int32 */
  page?: number
  /** @format int32 */
  pageSize?: number
  filters?: Record<string, string>
  sortColumn?: string
  sortDirection?: string
}

export interface MainStemAPIPlatformControllersPurchasingIntegrationDutchieReportingInventoryListAPIResponse {
  items?: MainStemAPIPlatformControllersPurchasingIntegrationDutchieModelsReportingInventoryItemDetails[]
  /** @format int32 */
  total?: number
  /** @format int32 */
  totalFiltered?: number
  lastSync?: MainStemAPIPlatformControllersPurchasingIntegrationDutchieModelsSyncRunDetails
  message?: string
  wasSuccessful?: boolean
}

export interface MainStemAPIPlatformControllersPurchasingIntegrationDutchieReportingInventorySyncAPIRequest {
  /** @format int32 */
  id?: number
}

export interface MainStemAPIPlatformControllersPurchasingIntegrationDutchieReportingInventorySyncAPIResponse {
  /** @format int32 */
  itemsSynced?: number
  /** @format int32 */
  syncRunId?: number
  message?: string
  wasSuccessful?: boolean
}

export interface MainStemAPIPlatformControllersPurchasingIntegrationDutchieReportingProductsDetailsAPIRequest {
  /** @format int32 */
  id?: number
  /** @format int32 */
  productId?: number
}

export interface MainStemAPIPlatformControllersPurchasingIntegrationDutchieReportingProductsDetailsAPIResponse {
  product?: MainStemAPIPlatformControllersPurchasingIntegrationDutchieModelsProductDetails
  integrationName?: string
  message?: string
  wasSuccessful?: boolean
}

export interface MainStemAPIPlatformControllersPurchasingIntegrationDutchieReportingProductsListAPIRequest {
  /** @format int32 */
  id?: number
  /** @format int32 */
  page?: number
  /** @format int32 */
  pageSize?: number
  filters?: Record<string, string>
  sortColumn?: string
  sortDirection?: string
}

export interface MainStemAPIPlatformControllersPurchasingIntegrationDutchieReportingProductsListAPIResponse {
  products?: MainStemAPIPlatformControllersPurchasingIntegrationDutchieModelsProductDetails[]
  /** @format int32 */
  total?: number
  /** @format int32 */
  totalFiltered?: number
  lastSync?: MainStemAPIPlatformControllersPurchasingIntegrationDutchieModelsSyncRunDetails
  message?: string
  wasSuccessful?: boolean
}

export interface MainStemAPIPlatformControllersPurchasingIntegrationDutchieReportingProductsSyncAPIRequest {
  /** @format int32 */
  id?: number
}

export interface MainStemAPIPlatformControllersPurchasingIntegrationDutchieReportingProductsSyncAPIResponse {
  /** @format int32 */
  productsSynced?: number
  /** @format int32 */
  syncRunId?: number
  message?: string
  wasSuccessful?: boolean
}

export interface MainStemAPIPlatformControllersPurchasingIntegrationDutchieRoomsDetailsAPIRequest {
  /** @format int32 */
  id?: number
  /** @format int32 */
  roomId?: number
}

export interface MainStemAPIPlatformControllersPurchasingIntegrationDutchieRoomsDetailsAPIResponse {
  room?: MainStemAPIPlatformControllersPurchasingIntegrationDutchieModelsRoomDetails
  integrationName?: string
  message?: string
  wasSuccessful?: boolean
}

export interface MainStemAPIPlatformControllersPurchasingIntegrationDutchieModelsRoomDetails {
  /** @format int32 */
  id?: number
  /** @format int32 */
  roomId?: number
  globalRoomId?: string
  roomName?: string
  environment?: string
  isQuarantineRoom?: boolean
  isVaultRoom?: boolean
  isWaitingRoom?: boolean
  isSalesFloor?: boolean
  isPosRoom?: boolean
  isInventoryRoom?: boolean
  isPreOrderRoom?: boolean
  isEcommerceRoom?: boolean
  /** @format date-time */
  createdAt?: string
  /** @format date-time */
  updatedAt?: string
  /** @format date-time */
  lastSyncedAt?: string
}

export interface MainStemAPIPlatformControllersPurchasingIntegrationDutchieRoomsListAPIRequest {
  /** @format int32 */
  id?: number
}

export interface MainStemAPIPlatformControllersPurchasingIntegrationDutchieRoomsListAPIResponse {
  rooms?: MainStemAPIPlatformControllersPurchasingIntegrationDutchieModelsRoomDetails[]
  lastSync?: MainStemAPIPlatformControllersPurchasingIntegrationDutchieModelsSyncRunDetails
  message?: string
  wasSuccessful?: boolean
}

export interface MainStemAPIPlatformControllersPurchasingIntegrationDutchieRoomsSyncAPIRequest {
  /** @format int32 */
  id?: number
}

export interface MainStemAPIPlatformControllersPurchasingIntegrationDutchieRoomsSyncAPIResponse {
  /** @format int32 */
  roomsSynced?: number
  /** @format int32 */
  syncRunId?: number
  message?: string
  wasSuccessful?: boolean
}

export interface MainStemAPIPlatformControllersPurchasingIntegrationDutchieSuppliersLinkedAPIRequest {
  /** @format int32 */
  supplierId?: number
}

export interface MainStemAPIPlatformControllersPurchasingIntegrationDutchieSuppliersLinkedAPIResponse {
  integrations?: MainStemAPIPlatformControllersPurchasingIntegrationDutchieSuppliersLinkedLinkedDutchieSupplier[]
  message?: string
  wasSuccessful?: boolean
}

export interface MainStemAPIPlatformControllersPurchasingIntegrationDutchieSuppliersLinkedLinkedDutchieSupplier {
  /** @format int32 */
  integrationSettingsId?: number
  integrationName?: string
  /** @format int32 */
  dutchieVendorId?: number
  dutchieVendorName?: string
  activity?: MainStemSDKIntegrationsDutchiePostgresVendorProfileActivity
}

export interface MainStemSDKIntegrationsDutchiePostgresVendorProfileActivity {
  /** @format int32 */
  productCount?: number
  /** @format int32 */
  activeProductCount?: number
  /** @format int32 */
  inventoryPackageCount?: number
  /** @format double */
  quantityOnHand?: number
  /** @format double */
  inventoryValue?: number
  /** @format int32 */
  purchaseOrderCount?: number
  /** @format double */
  purchaseSpend?: number
  /** @format date-time */
  firstPurchase?: string
  /** @format date-time */
  lastPurchase?: string
  /** @format int32 */
  receiveCount?: number
  /** @format double */
  receivedCost?: number
  /** @format date-time */
  lastReceived?: string
  /** @format int32 */
  saleCount?: number
  /** @format double */
  salesRevenue?: number
  /** @format date-time */
  lastSale?: string
  months?: MainStemSDKIntegrationsDutchiePostgresVendorProfileMonth[]
  categories?: MainStemSDKIntegrationsDutchiePostgresVendorProfileLabelCount[]
  purchaseOrderStatuses?: MainStemSDKIntegrationsDutchiePostgresVendorProfileLabelCount[]
  products?: MainStemSDKIntegrationsDutchiePostgresVendorProfileProduct[]
  productsTruncated?: boolean
  purchaseOrders?: MainStemSDKIntegrationsDutchiePostgresVendorProfilePurchaseOrder[]
  purchaseOrdersTruncated?: boolean
  receives?: MainStemSDKIntegrationsDutchiePostgresVendorProfileReceive[]
  receivesTruncated?: boolean
  topProducts?: MainStemSDKIntegrationsDutchiePostgresVendorProfileTopProduct[]
}

export interface MainStemSDKIntegrationsDutchiePostgresVendorProfileLabelCount {
  label?: string
  /** @format int32 */
  count?: number
}

export interface MainStemSDKIntegrationsDutchiePostgresVendorProfileProduct {
  /** @format int32 */
  productId?: number
  productName?: string
  sku?: string
  category?: string
  /** @format double */
  price?: number
  isActive?: boolean
}

export interface MainStemSDKIntegrationsDutchiePostgresVendorProfilePurchaseOrder {
  /** @format int32 */
  purchaseOrderId?: number
  /** @format int32 */
  purchaseOrderNumber?: number
  title?: string
  status?: string
  /** @format date-time */
  dateCreated?: string
  /** @format date-time */
  dateReceived?: string
  /** @format double */
  spend?: number
}

export interface MainStemAPIPlatformControllersPurchasingIntegrationDutchieSyncRunsListAPIRequest {
  /** @format int32 */
  id?: number
  /** @format int32 */
  page?: number
  /** @format int32 */
  pageSize?: number
  filters?: Record<string, string>
  sortColumn?: string
  sortDirection?: string
}

export interface MainStemAPIPlatformControllersPurchasingIntegrationDutchieSyncRunsListAPIResponse {
  syncRuns?: MainStemAPIPlatformControllersPurchasingIntegrationDutchieModelsSyncRunDetails[]
  /** @format int32 */
  total?: number
  /** @format int32 */
  totalFiltered?: number
  message?: string
  wasSuccessful?: boolean
}

export interface MainStemAPIPlatformControllersPurchasingIntegrationDutchieTransactionsDetailsAPIRequest {
  /** @format int32 */
  id?: number
  /** @format int32 */
  transactionId?: number
}

export interface MainStemAPIPlatformControllersPurchasingIntegrationDutchieTransactionsDetailsAPIResponse {
  transaction?: MainStemAPIPlatformControllersPurchasingIntegrationDutchieModelsTransactionDetails
  integrationName?: string
  message?: string
  wasSuccessful?: boolean
}

export interface MainStemAPIPlatformControllersPurchasingIntegrationDutchieModelsTransactionDetails {
  /** @format int32 */
  id?: number
  /** @format int32 */
  transactionId?: number
  /** @format int32 */
  dutchieCustomerId?: number
  /** @format int32 */
  employeeId?: number
  /** @format date-time */
  transactionDate?: string
  /** @format date-time */
  transactionDateLocalTime?: string
  /** @format date-time */
  voidDate?: string
  isVoid?: boolean
  isReturn?: boolean
  isMedical?: boolean
  isTaxInclusive?: boolean
  wasPreOrdered?: boolean
  transactionType?: string
  orderType?: string
  orderSource?: string
  orderMethod?: string
  /** @format double */
  subtotal?: number
  /** @format double */
  totalDiscount?: number
  /** @format double */
  totalBeforeTax?: number
  /** @format double */
  tax?: number
  /** @format double */
  tipAmount?: number
  /** @format double */
  total?: number
  /** @format double */
  paid?: number
  /** @format double */
  changeDue?: number
  /** @format double */
  totalCredit?: number
  /** @format int32 */
  totalItems?: number
  terminalName?: string
  invoiceNumber?: string
  invoiceName?: string
  /** @format date-time */
  checkInDate?: string
  /** @format double */
  loyaltyEarned?: number
  /** @format double */
  loyaltySpent?: number
  /** @format double */
  cashPaid?: number
  /** @format double */
  debitPaid?: number
  /** @format double */
  electronicPaid?: number
  electronicPaymentMethod?: string
  /** @format double */
  checkPaid?: number
  /** @format double */
  creditPaid?: number
  /** @format double */
  giftPaid?: number
  /** @format double */
  mmapPaid?: number
  /** @format double */
  manualPaid?: number
  /** @format double */
  integratedPaid?: number
  /** @format double */
  prePaymentAmount?: number
  /** @format double */
  revenueFeesAndDonations?: number
  /** @format double */
  nonRevenueFeesAndDonations?: number
  /** @format int32 */
  returnOnTransactionId?: number
  /** @format int32 */
  adjustmentForTransactionId?: number
  /** @format int32 */
  customerTypeId?: number
  completedByUser?: string
  /** @format int32 */
  responsibleForSaleUserId?: number
  authCode?: string
  referenceId?: string
  globalId?: string
  /** @format date-time */
  lastModifiedDateUtc?: string
  items?: MainStemAPIPlatformControllersPurchasingIntegrationDutchieModelsTransactionItemDetails[]
  environment?: string
  /** @format date-time */
  createdAt?: string
  /** @format date-time */
  updatedAt?: string
  /** @format date-time */
  lastSyncedAt?: string
}

export interface MainStemAPIPlatformControllersPurchasingIntegrationDutchieModelsTransactionItemDetails {
  /** @format int32 */
  id?: number
  /** @format int32 */
  transactionItemId?: number
  /** @format int32 */
  productId?: number
  sku?: string
  vendorName?: string
  batchName?: string
  packageId?: string
  sourcePackageId?: string
  /** @format int32 */
  inventoryId?: number
  /** @format int32 */
  unitId?: number
  /** @format double */
  quantity?: number
  /** @format double */
  unitPrice?: number
  /** @format double */
  unitCost?: number
  /** @format double */
  totalPrice?: number
  /** @format double */
  totalDiscount?: number
  /** @format double */
  unitWeight?: number
  unitWeightUnit?: string
  /** @format double */
  flowerEquivalent?: number
  flowerEquivalentUnit?: string
  isReturned?: boolean
  /** @format date-time */
  returnDate?: string
  /** @format int32 */
  returnedByTransactionId?: number
  returnReason?: string
  isCoupon?: boolean
}

export interface MainStemAPIPlatformControllersPurchasingIntegrationDutchieTransactionsListAPIRequest {
  /** @format int32 */
  id?: number
  /** @format date-time */
  startDate?: string
  /** @format date-time */
  endDate?: string
}

export interface MainStemAPIPlatformControllersPurchasingIntegrationDutchieTransactionsListAPIResponse {
  transactions?: MainStemAPIPlatformControllersPurchasingIntegrationDutchieModelsTransactionDetails[]
  /** @format int32 */
  total?: number
  truncated?: boolean
  lastSync?: MainStemAPIPlatformControllersPurchasingIntegrationDutchieModelsSyncRunDetails
  message?: string
  wasSuccessful?: boolean
}

export interface MainStemAPIPlatformControllersPurchasingIntegrationDutchieTransactionsReportAPIRequest {
  /** @format int32 */
  id?: number
  /** @format date-time */
  startDate?: string
  /** @format date-time */
  endDate?: string
  terminalName?: string
  completedByUser?: string
  orderSource?: string
  orderType?: string
  orderMethod?: string
  vendorName?: string
  /** @format int32 */
  productId?: number
  productType?: string
  masterType?: string
}

export interface MainStemAPIPlatformControllersPurchasingIntegrationDutchieTransactionsReportAPIResponse {
  integrationName?: string
  lineScoped?: boolean
  summary?: MainStemSDKIntegrationsDutchiePostgresSalesReportSummary
  byDay?: MainStemSDKIntegrationsDutchiePostgresSalesReportBucket[]
  byVendor?: MainStemSDKIntegrationsDutchiePostgresSalesReportBucket[]
  byProduct?: MainStemSDKIntegrationsDutchiePostgresSalesReportBucket[]
  byType?: MainStemSDKIntegrationsDutchiePostgresSalesReportBucket[]
  byMasterType?: MainStemSDKIntegrationsDutchiePostgresSalesReportBucket[]
  byRegister?: MainStemSDKIntegrationsDutchiePostgresSalesReportBucket[]
  byPerson?: MainStemSDKIntegrationsDutchiePostgresSalesReportBucket[]
  bySource?: MainStemSDKIntegrationsDutchiePostgresSalesReportBucket[]
  byOrderType?: MainStemSDKIntegrationsDutchiePostgresSalesReportBucket[]
  byOrderMethod?: MainStemSDKIntegrationsDutchiePostgresSalesReportBucket[]
  message?: string
  wasSuccessful?: boolean
}

export interface MainStemSDKIntegrationsDutchiePostgresSalesReportSummary {
  /** @format int32 */
  transactions?: number
  /** @format int32 */
  voids?: number
  /** @format int32 */
  returns?: number
  /** @format double */
  revenue?: number
  /** @format double */
  subtotal?: number
  /** @format double */
  discount?: number
  /** @format double */
  tax?: number
  /** @format double */
  items?: number
  /** @format double */
  cash?: number
  /** @format double */
  debit?: number
  /** @format double */
  credit?: number
  /** @format double */
  electronic?: number
  /** @format double */
  check?: number
  /** @format double */
  gift?: number
  /** @format double */
  manual?: number
  /** @format double */
  integrated?: number
  /** @format double */
  mmap?: number
  /** @format double */
  medicalRevenue?: number
  /** @format double */
  recreationalRevenue?: number
  /** @format int32 */
  medicalTransactions?: number
  /** @format int32 */
  recreationalTransactions?: number
}

export interface MainStemSDKIntegrationsDutchiePostgresSalesReportBucket {
  label?: string
  /** @format int32 */
  entityId?: number
  /** @format double */
  revenue?: number
  /** @format int32 */
  transactions?: number
  /** @format double */
  quantity?: number
  /** @format double */
  discount?: number
}

export interface MainStemAPIPlatformControllersPurchasingIntegrationDutchieTransactionsSyncAPIRequest {
  /** @format int32 */
  id?: number
  /** @format date-time */
  startDate?: string
  /** @format date-time */
  endDate?: string
}

export interface MainStemAPIPlatformControllersPurchasingIntegrationDutchieTransactionsSyncAPIResponse {
  /** @format int32 */
  transactionsSynced?: number
  /** @format int32 */
  syncRunId?: number
  message?: string
  wasSuccessful?: boolean
}

export interface MainStemAPIPlatformControllersPurchasingIntegrationDutchieUnitsListAPIRequest {
  /** @format int32 */
  id?: number
}

export interface MainStemAPIPlatformControllersPurchasingIntegrationDutchieUnitsListAPIResponse {
  units?: MainStemAPIPlatformControllersPurchasingIntegrationDutchieModelsUnitDetails[]
  lastSync?: MainStemAPIPlatformControllersPurchasingIntegrationDutchieModelsSyncRunDetails
  message?: string
  wasSuccessful?: boolean
}

export interface MainStemAPIPlatformControllersPurchasingIntegrationDutchieModelsUnitDetails {
  /** @format int32 */
  id?: number
  /** @format int32 */
  unitId?: number
  unitName?: string
  abbreviation?: string
  /** @format int32 */
  unitTypeId?: number
  environment?: string
  /** @format date-time */
  createdAt?: string
  /** @format date-time */
  updatedAt?: string
  /** @format date-time */
  lastSyncedAt?: string
}

export interface MainStemAPIPlatformControllersPurchasingIntegrationDutchieUnitsSyncAPIRequest {
  /** @format int32 */
  id?: number
}

export interface MainStemAPIPlatformControllersPurchasingIntegrationDutchieUnitsSyncAPIResponse {
  /** @format int32 */
  unitsSynced?: number
  /** @format int32 */
  syncRunId?: number
  message?: string
  wasSuccessful?: boolean
}

export interface MainStemAPIPlatformControllersPurchasingIntegrationDutchieUnitTypesListAPIRequest {
  /** @format int32 */
  id?: number
}

export interface MainStemAPIPlatformControllersPurchasingIntegrationDutchieUnitTypesListAPIResponse {
  unitTypes?: MainStemAPIPlatformControllersPurchasingIntegrationDutchieModelsUnitTypeDetails[]
  lastSync?: MainStemAPIPlatformControllersPurchasingIntegrationDutchieModelsSyncRunDetails
  message?: string
  wasSuccessful?: boolean
}

export interface MainStemAPIPlatformControllersPurchasingIntegrationDutchieModelsUnitTypeDetails {
  /** @format int32 */
  id?: number
  /** @format int32 */
  unitTypeId?: number
  unitTypeName?: string
  unitTypeAbbreviation?: string
  environment?: string
  /** @format date-time */
  createdAt?: string
  /** @format date-time */
  updatedAt?: string
  /** @format date-time */
  lastSyncedAt?: string
}

export interface MainStemAPIPlatformControllersPurchasingIntegrationDutchieUnitTypesSyncAPIRequest {
  /** @format int32 */
  id?: number
}

export interface MainStemAPIPlatformControllersPurchasingIntegrationDutchieUnitTypesSyncAPIResponse {
  /** @format int32 */
  unitTypesSynced?: number
  /** @format int32 */
  syncRunId?: number
  message?: string
  wasSuccessful?: boolean
}

export interface MainStemAPIPlatformControllersPurchasingIntegrationDutchieVendorsDetailsAPIRequest {
  /** @format int32 */
  id?: number
  /** @format int32 */
  vendorId?: number
}

export interface MainStemAPIPlatformControllersPurchasingIntegrationDutchieVendorsDetailsAPIResponse {
  vendor?: MainStemAPIPlatformControllersPurchasingIntegrationDutchieModelsVendorDetails
  integrationName?: string
  mainStemSuppliers?: MainStemAPIPlatformControllersPurchasingIntegrationDutchieVendorsDetailsAPIResponseMappedSupplier[]
  activity?: MainStemSDKIntegrationsDutchiePostgresVendorProfileActivity
  message?: string
  wasSuccessful?: boolean
}

export interface MainStemAPIPlatformControllersPurchasingIntegrationDutchieModelsVendorDetails {
  /** @format int32 */
  id?: number
  /** @format int32 */
  vendorId?: number
  globalVendorId?: string
  vendorName?: string
  address?: string
  city?: string
  state?: string
  postalCode?: string
  licenseNumber?: string
  contactName?: string
  contactEmail?: string
  contactPhone?: string
  environment?: string
  /** @format date-time */
  createdAt?: string
  /** @format date-time */
  updatedAt?: string
  /** @format date-time */
  lastSyncedAt?: string
}

export interface MainStemAPIPlatformControllersPurchasingIntegrationDutchieVendorsDetailsAPIResponseMappedSupplier {
  /** @format int32 */
  id?: number
  name?: string
}

export interface MainStemAPIPlatformControllersPurchasingIntegrationDutchieVendorsListAPIRequest {
  /** @format int32 */
  id?: number
}

export interface MainStemAPIPlatformControllersPurchasingIntegrationDutchieVendorsListAPIResponse {
  vendors?: MainStemAPIPlatformControllersPurchasingIntegrationDutchieModelsVendorDetails[]
  lastSync?: MainStemAPIPlatformControllersPurchasingIntegrationDutchieModelsSyncRunDetails
  message?: string
  wasSuccessful?: boolean
}

export interface MainStemAPIPlatformControllersPurchasingIntegrationDutchieVendorsSyncAPIRequest {
  /** @format int32 */
  id?: number
}

export interface MainStemAPIPlatformControllersPurchasingIntegrationDutchieVendorsSyncAPIResponse {
  /** @format int32 */
  vendorsSynced?: number
  /** @format int32 */
  syncRunId?: number
  message?: string
  wasSuccessful?: boolean
}

export interface MainStemAPIPlatformControllersPurchasingIntegrationDutchieWhoAmIAPIRequest {
  /** @format int32 */
  id?: number
}

export interface MainStemAPIPlatformControllersPurchasingIntegrationDutchieWhoAmIAPIResponse {
  environment?: string
  whoAmI?: MainStemAPIPlatformControllersPurchasingIntegrationDutchieWhoAmIAPIResponseWhoAmIDetails
  message?: string
  wasSuccessful?: boolean
}

export interface MainStemAPIPlatformControllersPurchasingIntegrationDutchieWhoAmIAPIResponseWhoAmIDetails {
  /** @format int32 */
  locationId?: number
  /** @format int32 */
  lspId?: number
  locationName?: string
  lspName?: string
  address?: string
  address2?: string
  city?: string
  state?: string
  postalCode?: string
  licenseNumber?: string
  doingBusinessAs?: string
  shareCustomerProfiles?: boolean
  globalId?: string
  locationGlobalId?: string
  lspGlobalId?: string
  orgGlobalId?: string
  region?: string
  storageName?: string
  timeZone?: string
  regionId?: string
}

export interface MainStemAPIPlatformControllersPurchasingIntegrationDynamicsCompanyListAPIRequest {
  /** @format int32 */
  integrationSettingsID: number
}

export interface MainStemAPIPlatformControllersPurchasingIntegrationDynamicsCompanyListAPIResponse {
  companies: MainStemAPIPlatformControllersPurchasingIntegrationDynamicsCompanyListAPIResponseDynamicsCompany[]
  message?: string
  wasSuccessful?: boolean
}

export interface MainStemAPIPlatformControllersPurchasingIntegrationDynamicsCompanyListAPIResponseDynamicsCompany {
  dataAreaId: string
  name: string
}

export interface MainStemAPIPlatformControllersPurchasingIntegrationDynamicsInvoiceCreateAPIRequest {
  /** @format int32 */
  invoiceId: number
}

export interface MainStemAPIPlatformControllersPurchasingIntegrationDynamicsInvoiceCreateAPIResponse {
  message?: string
  wasSuccessful?: boolean
}

export interface MainStemAPIPlatformControllersPurchasingIntegrationDynamicsMainAccountListAPIRequest {
  /** @format int32 */
  integrationSettingsID: number
}

export interface MainStemAPIPlatformControllersPurchasingIntegrationDynamicsMainAccountListAPIResponse {
  mainAccounts: MainStemAPIPlatformControllersPurchasingIntegrationDynamicsMainAccountListAPIResponseDynamicsMainAccount[]
  message?: string
  wasSuccessful?: boolean
}

export interface MainStemAPIPlatformControllersPurchasingIntegrationDynamicsMainAccountListAPIResponseDynamicsMainAccount {
  mainAccountId: string
  name: string
}

export interface MainStemAPIPlatformControllersPurchasingIntegrationDynamicsProcurementProductCategoryListAPIRequest {
  /** @format int32 */
  integrationSettingsID?: number
}

export interface MainStemAPIPlatformControllersPurchasingIntegrationDynamicsProcurementProductCategoryListAPIResponse {
  procurementProductCategories?: MainStemAPIPlatformControllersPurchasingIntegrationDynamicsProcurementProductCategoryListAPIResponseDynamicsProcurementProductCategories[]
  message?: string
  wasSuccessful?: boolean
}

export interface MainStemAPIPlatformControllersPurchasingIntegrationDynamicsProcurementProductCategoryListAPIResponseDynamicsProcurementProductCategories {
  categoryName?: string
  parentCategoryName?: string
  categoryCode?: string
}

export interface MainStemAPIPlatformControllersPurchasingIntegrationDynamicsVendorGroupListAPIRequest {
  /** @format int32 */
  integrationSettingsID?: number
}

export interface MainStemAPIPlatformControllersPurchasingIntegrationDynamicsVendorGroupListAPIResponse {
  vendorGroups: MainStemAPIPlatformControllersPurchasingIntegrationDynamicsVendorGroupListAPIResponseDynamicsVendorGroup[]
  message?: string
  wasSuccessful?: boolean
}

export interface MainStemAPIPlatformControllersPurchasingIntegrationDynamicsVendorGroupListAPIResponseDynamicsVendorGroup {
  vendorGroupId: string
  description: string
}

export interface MainStemAPIPlatformControllersPurchasingIntegrationDynamicsVendorListAPIRequest {
  /** @format int32 */
  integrationSettingsID?: number
  vendorGroupCode?: string
}

export interface MainStemAPIPlatformControllersPurchasingIntegrationDynamicsVendorListAPIResponse {
  vendors: MainStemAPIPlatformControllersPurchasingIntegrationDynamicsVendorListAPIResponseDynamicsVendor[]
  message?: string
  wasSuccessful?: boolean
}

export interface MainStemAPIPlatformControllersPurchasingIntegrationDynamicsVendorListAPIResponseDynamicsVendor {
  vendorAccountNumber: string
  vendorOrganizationName: string
  vendorGroupId: string
  /** @format int32 */
  mainStemSupplierID?: number
}

export interface MainStemAPIPlatformControllersPurchasingIntegrationDynamicsVendorSyncAPIRequest {
  /** @format int32 */
  integrationSettingsID?: number
}

export interface MainStemAPIPlatformControllersPurchasingIntegrationDynamicsVendorSyncAPIResponse {
  message?: string
  wasSuccessful?: boolean
}

export interface MainStemAPIPlatformControllersPurchasingIntegrationExcelRequestAPIResponse {
  message?: string
  wasSuccessful?: boolean
}

export interface MainStemAPIPlatformControllersPurchasingIntegrationInvoicesListAPIRequest {
  /** @format int32 */
  integrationSettingsID: number
}

export interface MainStemAPIPlatformControllersPurchasingIntegrationInvoicesListAPIResponse {
  invoices: MainStemAPIPlatformControllersPurchasingIntegrationInvoicesListAPIResponseInvoiceDetails[]
  message?: string
  wasSuccessful?: boolean
}

export interface MainStemAPIPlatformControllersPurchasingIntegrationInvoicesListAPIResponseInvoiceDetails {
  /** @format int32 */
  invoiceID: number
  /** @format int32 */
  requisitionID: number
  /**
   * @format uuid
   * @example "00000000-0000-0000-0000-000000000000"
   */
  requisitionUUID: string
  dynamicsID: string
  dynamicsDataURL: string
}

export interface MainStemAPIPlatformControllersPurchasingIntegrationMetrcFacilitiesListAPIRequest {
  /** @format int32 */
  id?: number
}

export interface MainStemAPIPlatformControllersPurchasingIntegrationMetrcFacilitiesListAPIResponse {
  environment?: string
  state?: string
  apiUrl?: string
  facilities?: MainStemAPIPlatformControllersPurchasingIntegrationMetrcFacilitiesListAPIResponseFacilityDetails[]
  message?: string
  wasSuccessful?: boolean
}

export interface MainStemAPIPlatformControllersPurchasingIntegrationMetrcFacilitiesListAPIResponseFacilityDetails {
  /** @format int64 */
  facilityId?: number
  name?: string
  alias?: string
  displayName?: string
  email?: string
  isOwner?: boolean
  isManager?: boolean
  isFinancialContact?: boolean
  credentialedDate?: string
  isMedical?: boolean
  isRetail?: boolean
  isHemp?: boolean
  licenseNumber?: string
  employeeLicenseNumber?: string
  licenseType?: string
  licenseStartDate?: string
  licenseEndDate?: string
}

export interface MainStemAPIPlatformControllersPurchasingIntegrationMetrcLicensedAPIRequest {
  /** @format int32 */
  id?: number
  licenseNumber?: string
}

export interface MainStemAPIPlatformControllersPurchasingIntegrationMetrcLicensedTransfersAPIResponse {
  transfers?: MainStemAPIPlatformControllersPurchasingIntegrationMetrcLicensedTransfersAPIResponseTransferDetails[]
  environment?: string
  state?: string
  apiUrl?: string
  /** @format int32 */
  totalRecords?: number
  message?: string
  wasSuccessful?: boolean
}

export interface MainStemAPIPlatformControllersPurchasingIntegrationMetrcLicensedTransfersAPIResponseTransferDetails {
  /** @format int64 */
  id?: number
  manifestNumber?: string
  shipperFacilityLicenseNumber?: string
  shipperFacilityName?: string
  transporterFacilityLicenseNumber?: string
  transporterFacilityName?: string
  recipientFacilityLicenseNumber?: string
  recipientFacilityName?: string
  shipmentTypeName?: string
  shipmentTransactionType?: string
  /** @format int32 */
  deliveryCount?: number
  /** @format int32 */
  receivedDeliveryCount?: number
  /** @format int32 */
  packageCount?: number
  /** @format int32 */
  receivedPackageCount?: number
  isVoided?: boolean
  createdDateTime?: string
  createdByUserName?: string
  estimatedDepartureDateTime?: string
  estimatedArrivalDateTime?: string
  receivedDateTime?: string
  lastModified?: string
}

export interface MainStemAPIPlatformControllersPurchasingIntegrationMetrcLicensedReceiptsAPIResponse {
  receipts?: MainStemAPIPlatformControllersPurchasingIntegrationMetrcLicensedReceiptsAPIResponseReceiptDetails[]
  environment?: string
  state?: string
  apiUrl?: string
  /** @format int32 */
  totalRecords?: number
  message?: string
  wasSuccessful?: boolean
}

export interface MainStemAPIPlatformControllersPurchasingIntegrationMetrcLicensedReceiptsAPIResponseReceiptDetails {
  /** @format int64 */
  id?: number
  receiptNumber?: string
  externalReceiptNumber?: string
  salesDateTime?: string
  salesCustomerType?: string
  patientLicenseNumber?: string
  /** @format int32 */
  totalPackages?: number
  /** @format double */
  totalPrice?: number
  isFinal?: boolean
  recordedDateTime?: string
  recordedByUserName?: string
  lastModified?: string
}

export interface MainStemAPIPlatformControllersPurchasingIntegrationMetrcLicensedLocationsAPIResponse {
  locations?: MainStemAPIPlatformControllersPurchasingIntegrationMetrcLicensedLocationsAPIResponseLocationDetails[]
  environment?: string
  state?: string
  apiUrl?: string
  /** @format int32 */
  totalRecords?: number
  message?: string
  wasSuccessful?: boolean
}

export interface MainStemAPIPlatformControllersPurchasingIntegrationMetrcLicensedLocationsAPIResponseLocationDetails {
  /** @format int64 */
  id?: number
  name?: string
  /** @format int64 */
  locationTypeId?: number
  locationTypeName?: string
  forPlantBatches?: boolean
  forPlants?: boolean
  forHarvests?: boolean
  forPackages?: boolean
}

export interface MainStemAPIPlatformControllersPurchasingIntegrationMetrcLicensedEmployeesAPIResponse {
  employees?: MainStemAPIPlatformControllersPurchasingIntegrationMetrcLicensedEmployeesAPIResponseEmployeeDetails[]
  environment?: string
  state?: string
  apiUrl?: string
  /** @format int32 */
  totalRecords?: number
  message?: string
  wasSuccessful?: boolean
}

export interface MainStemAPIPlatformControllersPurchasingIntegrationMetrcLicensedEmployeesAPIResponseEmployeeDetails {
  fullName?: string
  licenseNumber?: string
  employeeLicenseNumber?: string
  licenseType?: string
  licenseStartDate?: string
  licenseEndDate?: string
  isIndustryAdmin?: boolean
  isOwner?: boolean
  isManager?: boolean
}

export interface MainStemAPIPlatformControllersPurchasingIntegrationParagonGetTokenAPIRequest {
  /** @format int32 */
  integrationId?: number
}

export interface MainStemAPIPlatformControllersPurchasingIntegrationParagonGetTokenAPIResponse {
  token?: string
  enabled?: boolean
  message?: string
  wasSuccessful?: boolean
}

export interface MainStemAPIPlatformControllersPurchasingIntegrationPowerBIDetailsAPIResponse {
  settings?: MainStemAPIPlatformControllersPurchasingIntegrationPowerBIDetailsAPIResponseIntegrationSettings
  message?: string
  wasSuccessful?: boolean
}

export interface MainStemAPIPlatformControllersPurchasingIntegrationPowerBIDetailsAPIResponseIntegrationSettings {
  fileURL?: string
}

export interface MainStemAPIPlatformControllersPurchasingIntegrationPowerBIRequestAPIResponse {
  message?: string
  wasSuccessful?: boolean
}

export interface MainStemAPIPlatformControllersPurchasingIntegrationQuantumLeafAllItemsAPIRequest {
  /** @format int32 */
  integrationSettingsID?: number
}

export interface MainStemAPIPlatformControllersPurchasingIntegrationQuantumLeafAllItemsAPIResponse {
  items?: MainStemAPIPlatformControllersPurchasingIntegrationQuantumLeafAllItemsVendorItemDetail[]
  message?: string
  wasSuccessful?: boolean
}

export interface MainStemAPIPlatformControllersPurchasingIntegrationQuantumLeafAllItemsVendorItemDetail {
  itemType?: 'Stock' | 'NonStock'
  label?: string
  value?: string
}

export interface MainStemAPIPlatformControllersPurchasingIntegrationQuantumLeafIntegrationLogsAPIRequest {
  /** @format int32 */
  integrationSettingsID?: number
}

export interface MainStemAPIPlatformControllersPurchasingIntegrationQuantumLeafIntegrationLogsAPIResponse {
  logs?: MainStemSDKModelsIntegrationsQuantumLeafQuantumLeafLogEntry[]
  message?: string
  wasSuccessful?: boolean
}

export interface MainStemSDKModelsIntegrationsQuantumLeafQuantumLeafLogEntry {
  /** @format int32 */
  customerID?: number
  /** @format int32 */
  locationID?: number
  /** @format int32 */
  invoiceID?: number
  /** @format int32 */
  productID?: number
  productType?: string
  action?:
    | 'Running'
    | 'Failure'
    | 'Successful'
    | 'CreateOrder'
    | 'UpdateOrder'
    | 'DeleteOrder'
    | 'CreateInvoice'
    | 'UpdateInvoice'
    | 'DeleteInvoice'
    | 'CreateProduct'
    | 'UpdateProduct'
    | 'DeleteProduct'
    | 'CreateShipment'
    | 'UpdateShipment'
    | 'DeleteShipment'
    | 'QueueOrder'
  productIDsAsString?: string
  productIDs?: number[]
  /** @format int32 */
  customerIntegrationSettingsID?: number
  request?: object
  response?: object
  partitionKey?: string
  rowKey?: string
  sessionId?: string
  message?: string
  /** @format date-time */
  timestamp?: string
  environment?: 'None' | 'Local' | 'Dev' | 'Demo' | 'Prod'
  userId?: string
  breadcrumb?: string
  level?: 'Debug' | 'Error' | 'Fatal' | 'Info' | 'Verbose' | 'Warning'
  data?: object
  stackTrace?: string
  note?: string
  error?: string
  status?: 'None' | 'Fail' | 'Partial' | 'Success'
}

export interface MainStemAPIPlatformControllersPurchasingIntegrationQuantumLeafLinkLocationProductAPIRequest {
  /** @format int32 */
  integrationSettingsID?: number
  itemID?: string
  itemType?: 'Stock' | 'NonStock'
  /** @format int32 */
  locationID?: number
  /** @format int32 */
  productID?: number
}

export interface MainStemAPIPlatformControllersPurchasingIntegrationQuantumLeafLinkProductAPIRequest {
  /** @format int32 */
  integrationSettingsID?: number
  itemID?: string
  itemType?: 'Stock' | 'NonStock'
  /** @format int32 */
  productID?: number
}

export interface MainStemAPIPlatformControllersPurchasingIntegrationQuantumLeafLinkSupplierAPIRequest {
  /** @format int32 */
  integrationSettingsID?: number
  /** @format int32 */
  supplierID?: number
  linkID?: string
}

export interface MainStemAPIPlatformControllersPurchasingIntegrationQuantumLeafNonStockItemsAPIRequest {
  /** @format int32 */
  integrationSettingsID?: number
}

export interface MainStemAPIPlatformControllersPurchasingIntegrationQuantumLeafNonStockItemsAPIResponse {
  items?: MainStemAPIPlatformControllersPurchasingIntegrationQuantumLeafNonStockItemsVendorItemDetail[]
  message?: string
  wasSuccessful?: boolean
}

export interface MainStemAPIPlatformControllersPurchasingIntegrationQuantumLeafNonStockItemsVendorItemDetail {
  label?: string
  value?: string
}

export interface MainStemAPIPlatformControllersPurchasingIntegrationQuantumLeafOrdersAPIRequest {
  /** @format int32 */
  integrationSettingsID?: number
}

export interface MainStemAPIPlatformControllersPurchasingIntegrationQuantumLeafOrdersAPIResponse {
  orders?: MainStemAPIPlatformControllersPurchasingIntegrationQuantumLeafOrdersAPIResponseOrderDetails[]
  message?: string
  wasSuccessful?: boolean
}

export interface MainStemAPIPlatformControllersPurchasingIntegrationQuantumLeafOrdersAPIResponseOrderDetails {
  id?: string
  /** @format int32 */
  orderID?: number
  /** @format int32 */
  invoiceID?: number
  externalID?: string
  externalURL?: string
  orderUUID?: string
  /** @format date-time */
  dateApproved?: string
  /** @format date-time */
  dateCreated?: string
  userCreatedBy?: string
  userApprovedBy?: string
  location?: MainStemAPIPlatformControllersPurchasingIntegrationQuantumLeafOrdersAPIResponseOrderDetailsLocationDetails
}

export interface MainStemAPIPlatformControllersPurchasingIntegrationQuantumLeafOrdersAPIResponseOrderDetailsLocationDetails {
  /** @format int32 */
  id?: number
  name?: string
  address1?: string
  address2?: string
  city?: string
  state?: string
  zip?: string
  country?: string
}

export interface MainStemAPIPlatformControllersPurchasingIntegrationQuantumLeafProductsAPIRequest {
  /** @format int32 */
  integrationSettingsID?: number
}

export interface MainStemAPIPlatformControllersPurchasingIntegrationQuantumLeafProductsAPIResponse {
  products?: MainStemAPIPlatformControllersPurchasingIntegrationQuantumLeafProductsProductDetail[]
  linkedProducts?: MainStemAPIPlatformControllersPurchasingIntegrationQuantumLeafProductsLinkedProductDetail[]
  message?: string
  wasSuccessful?: boolean
}

export interface MainStemAPIPlatformControllersPurchasingIntegrationQuantumLeafProductsProductDetail {
  /** @format int32 */
  id?: number
  name?: string
  skuInternal?: string
  itemID?: string
  /** @format int32 */
  supplierID?: number
  supplierName?: string
  isPrivate?: boolean
  image?: string
}

export interface MainStemAPIPlatformControllersPurchasingIntegrationQuantumLeafProductsLinkedProductDetail {
  /** @format int32 */
  productID?: number
  itemID?: string
}

export interface MainStemAPIPlatformControllersPurchasingIntegrationQuantumLeafVendorProductsAPIRequest {
  /** @format int32 */
  integrationSettingsID?: number
}

export interface MainStemAPIPlatformControllersPurchasingIntegrationQuantumLeafVendorProductsAPIResponse {
  products?: MainStemAPIPlatformControllersPurchasingIntegrationQuantumLeafVendorProductsVendorProductDetail[]
  message?: string
  wasSuccessful?: boolean
}

export interface MainStemAPIPlatformControllersPurchasingIntegrationQuantumLeafVendorProductsVendorProductDetail {
  label?: string
  value?: string
}

export interface MainStemAPIPlatformControllersPurchasingIntegrationQuantumLeafVendorsAPIRequest {
  /** @format int32 */
  integrationSettingsID?: number
}

export interface MainStemAPIPlatformControllersPurchasingIntegrationQuantumLeafVendorsAPIResponse {
  vendors?: MainStemAPIPlatformControllersPurchasingIntegrationQuantumLeafVendorsVendorDetails[]
  linkedSuppliers?: MainStemAPIPlatformControllersPurchasingIntegrationQuantumLeafVendorsLinkedSupplierDetail[]
  message?: string
  wasSuccessful?: boolean
}

export interface MainStemAPIPlatformControllersPurchasingIntegrationQuantumLeafVendorsVendorDetails {
  /** @format int32 */
  id?: number
  name?: string
  isPrivateSupplier?: boolean
  image?: string
  linkID?: string
}

export interface MainStemAPIPlatformControllersPurchasingIntegrationQuantumLeafVendorsLinkedSupplierDetail {
  /** @format int32 */
  supplierID?: number
  linkID?: string
}

export interface MainStemAPIPlatformControllersPurchasingIntegrationQuantumLeafVendorSuppliersAPIRequest {
  /** @format int32 */
  integrationSettingsID?: number
}

export interface MainStemAPIPlatformControllersPurchasingIntegrationQuantumLeafVendorSuppliersAPIResponse {
  suppliers?: MainStemAPIPlatformControllersPurchasingIntegrationQuantumLeafVendorSuppliersVendorSupplierDetail[]
  message?: string
  wasSuccessful?: boolean
}

export interface MainStemAPIPlatformControllersPurchasingIntegrationQuantumLeafVendorSuppliersVendorSupplierDetail {
  label?: string
  value?: string
}

export interface MainStemAPIPlatformControllersPurchasingIntegrationQuantumLeafWarehousesAPIRequest {
  /** @format int32 */
  integrationSettingsID?: number
}

export interface MainStemAPIPlatformControllersPurchasingIntegrationQuantumLeafWarehousesAPIResponse {
  warehouses?: MainStemAPIPlatformControllersPurchasingIntegrationQuantumLeafWarehousesWarehouseDetail[]
  message?: string
  wasSuccessful?: boolean
}

export interface MainStemAPIPlatformControllersPurchasingIntegrationQuantumLeafWarehousesWarehouseDetail {
  label?: string
  value?: string
}

export interface MainStemAPIPlatformControllersPurchasingIntegrationQuickBooksLoggerIntegrationLogsAPIRequest {
  /** @format int32 */
  integrationSettingsID?: number
}

export interface MainStemAPIPlatformControllersPurchasingIntegrationQuickBooksLoggerIntegrationLogsAPIResponse {
  logs?: MainStemSDKModelsLoggingQuickBooksQuickBooksLogEntry[]
  message?: string
  wasSuccessful?: boolean
}

export interface MainStemSDKModelsLoggingQuickBooksQuickBooksLogEntry {
  /** @format int32 */
  customerID?: number
  /** @format int32 */
  locationID?: number
  /** @format int32 */
  orderID?: number
  /** @format int32 */
  productID?: number
  productType?: string
  action?:
    | 'QueuedItemCreateEvent'
    | 'QueuedBillCreateEvent'
    | 'QueuedBillPaymentCreateEvent'
    | 'SyncInitiated'
    | 'ItemCreateEvent'
    | 'CreateBill'
    | 'CreateBillPayment'
    | 'SyncCompleted'
  productIDsAsString?: string
  productIDs?: number[]
  /** @format int32 */
  paymentTransactionID?: number
  /** @format int32 */
  invoicePaymentLinkID?: number
  /** @format int32 */
  customerIntegrationSettingsID?: number
  request?: object
  response?: object
  partitionKey?: string
  rowKey?: string
  sessionId?: string
  message?: string
  /** @format date-time */
  timestamp?: string
  environment?: 'None' | 'Local' | 'Dev' | 'Demo' | 'Prod'
  userId?: string
  breadcrumb?: string
  level?: 'Debug' | 'Error' | 'Fatal' | 'Info' | 'Verbose' | 'Warning'
  data?: object
  stackTrace?: string
  note?: string
  error?: string
  status?: 'None' | 'Fail' | 'Partial' | 'Success'
}

export interface MainStemAPIPlatformControllersPurchasingIntegrationQuickBooksLocationFinancialDimensionUpdateAPIRequest {
  /** @format int32 */
  settingsID: number
  /** @format int32 */
  locationID: number
  /** @format int32 */
  financialDimensionID: number
}

export interface MainStemAPIPlatformControllersPurchasingIntegrationQuickBooksLocationFinancialDimensionUpdateAPIResponse {
  message?: string
  wasSuccessful?: boolean
}

export interface MainStemAPIPlatformControllersPurchasingIntegrationQuickBooksLogsAPIRequest {
  /** @format int32 */
  integrationSettingId?: number
}

export interface MainStemAPIPlatformControllersPurchasingIntegrationQuickBooksLogsAPIResponse {
  logs?: MainStemAPIPlatformControllersPurchasingIntegrationQuickBooksLogsAPIResponseLogDetails[]
  message?: string
  wasSuccessful?: boolean
}

export interface MainStemAPIPlatformControllersPurchasingIntegrationQuickBooksLogsAPIResponseLogDetails {
  wasSuccessful?: boolean
  apiCallName?: string
  /** @format date-time */
  dateCreated?: string
  /** @format int32 */
  id?: number
  request?: string
  response?: string
}

export interface MainStemAPIPlatformControllersPurchasingIntegrationQuickBooksLoggerOrderLogsAPIRequest {
  /** @format int32 */
  orderID?: number
}

export interface MainStemAPIPlatformControllersPurchasingIntegrationQuickBooksLoggerOrderLogsAPIResponse {
  logs?: MainStemSDKModelsLoggingQuickBooksQuickBooksLogEntry[]
  message?: string
  wasSuccessful?: boolean
}

export interface MainStemAPIPlatformControllersPurchasingIntegrationQuickBooksOrdersAPIRequest {
  /** @format int32 */
  integrationSettingId?: number
}

export interface MainStemAPIPlatformControllersPurchasingIntegrationQuickBooksOrdersAPIResponse {
  orders?: MainStemAPIPlatformControllersPurchasingIntegrationQuickBooksOrdersAPIResponseOrderDetails[]
  message?: string
  wasSuccessful?: boolean
}

export interface MainStemAPIPlatformControllersPurchasingIntegrationQuickBooksOrdersAPIResponseOrderDetails {
  /** @format date-time */
  dateApproved?: string
  /** @format date-time */
  dateCreated?: string
  /** @format int32 */
  id?: number
  location?: MainStemAPIPlatformControllersPurchasingIntegrationQuickBooksOrdersAPIResponseOrderDetailsLocationDetails
  userApprovedBy?: string
  userCreatedBy?: string
  uuid?: string
}

export interface MainStemAPIPlatformControllersPurchasingIntegrationQuickBooksOrdersAPIResponseOrderDetailsLocationDetails {
  address1?: string
  address2?: string
  city?: string
  country?: string
  /** @format int32 */
  id?: number
  name?: string
  state?: string
  zip?: string
}

export interface MainStemAPIPlatformControllersPurchasingIntegrationQuickBooksProductTypesAPIRequest {
  /** @format int32 */
  integrationSettingId?: number
}

export interface MainStemAPIPlatformControllersPurchasingIntegrationQuickBooksProductTypesAPIResponse {
  productTypes?: MainStemAPIPlatformControllersPurchasingIntegrationQuickBooksProductTypesAPIResponseProductTypeDetails[]
  message?: string
  wasSuccessful?: boolean
}

export interface MainStemAPIPlatformControllersPurchasingIntegrationQuickBooksProductTypesAPIResponseProductTypeDetails {
  /** @format int32 */
  quickbooksAccountId?: number
  type?: string
}

export interface MainStemAPIPlatformControllersPurchasingIntegrationSettingsCreateAPIRequest {
  description?: string
  name?: string
  type?: string
  locationIds?: number[]
}

export interface MainStemAPIPlatformControllersPurchasingIntegrationSettingsCreateAPIResponse {
  error?: string
  /** @format int32 */
  id?: number
  message?: string
  wasSuccessful?: boolean
}

export interface MainStemAPIPlatformControllersPurchasingIntegrationSettingsDetailsAPIRequest {
  /** @format int32 */
  id?: number
}

export interface MainStemAPIPlatformControllersPurchasingIntegrationSettingsDetailsAPIResponse {
  description?: string
  enabled?: boolean
  /** @format date-time */
  lastUpdatedAt?: string
  locations?: MainStemAPIPlatformControllersPurchasingIntegrationSettingsDetailsAPIResponseIntegrationSettingLocation[]
  name?: string
  paymentMethods?: MainStemAPIPlatformControllersPurchasingIntegrationSettingsDetailsAPIResponseIntegrationSettingPaymentMethod[]
  locationProductFinancialDimensions: MainStemAPIPlatformControllersPurchasingIntegrationSettingsDetailsAPIResponseLocationProductFinancialDimension[]
  settings?: object
  message?: string
  wasSuccessful?: boolean
}

export interface MainStemAPIPlatformControllersPurchasingIntegrationSettingsDetailsAPIResponseIntegrationSettingLocation {
  /** @format int32 */
  id?: number
  name?: string
}

export interface MainStemAPIPlatformControllersPurchasingIntegrationSettingsDetailsAPIResponseIntegrationSettingPaymentMethod {
  /** @format int32 */
  id?: number
  last4OfAccount?: string
  location?: MainStemAPIPlatformControllersPurchasingIntegrationSettingsDetailsAPIResponseIntegrationSettingPaymentMethodLocationDetails
  type?: string
}

export interface MainStemAPIPlatformControllersPurchasingIntegrationSettingsDetailsAPIResponseLocationProductFinancialDimension {
  /** @format int32 */
  id: number
  financialDimension: MainStemAPIPlatformControllersPurchasingIntegrationSettingsDetailsAPIResponseLocationProductFinancialDimensionFinancialDimensionDetails
  /** @format int32 */
  locationID: number
}

export interface MainStemAPIPlatformControllersPurchasingIntegrationSettingsDetailsAPIResponseIntegrationSettingPaymentMethodLocationDetails {
  /** @format int32 */
  id?: number
  name?: string
}

export interface MainStemAPIPlatformControllersPurchasingIntegrationSettingsDetailsAPIResponseLocationProductFinancialDimensionFinancialDimensionDetails {
  /** @format int32 */
  id: number
  label: string
}

export interface MainStemAPIPlatformControllersPurchasingIntegrationSettingsListAPIRequest {
  type?: string
}

export interface MainStemAPIPlatformControllersPurchasingIntegrationSettingsListAPIResponse {
  settings?: MainStemAPIPlatformControllersPurchasingIntegrationSettingsListAPIResponseIntegrationSetting[]
  message?: string
  wasSuccessful?: boolean
}

export interface MainStemAPIPlatformControllersPurchasingIntegrationSettingsListAPIResponseIntegrationSetting {
  /** @format int32 */
  id?: number
  description?: string
  enabled?: boolean
  /** @format date-time */
  lastUpdatedAt?: string
  locations?: MainStemAPIPlatformControllersPurchasingIntegrationSettingsListAPIResponseIntegrationSettingIntegrationSettingLocation[]
  name?: string
}

export interface MainStemAPIPlatformControllersPurchasingIntegrationSettingsListAPIResponseIntegrationSettingIntegrationSettingLocation {
  /** @format int32 */
  id?: number
  name?: string
}

export interface MainStemAPIPlatformControllersPurchasingIntegrationSettingsLocationsAddAPIRequest {
  /** @format int32 */
  integrationId?: number
  /** @format int32 */
  locationId?: number
}

export interface MainStemAPIPlatformControllersPurchasingIntegrationSettingsLocationsAddAPIResponse {
  error?: string
  message?: string
  wasSuccessful?: boolean
}

export interface MainStemAPIPlatformControllersPurchasingIntegrationSettingsLocationsRemoveAPIRequest {
  /** @format int32 */
  integrationId?: number
  /** @format int32 */
  locationId?: number
}

export interface MainStemAPIPlatformControllersPurchasingIntegrationSettingsToggleAPIRequest {
  /** @format int32 */
  id?: number
  enabled?: boolean
  type?: string
}

export interface MainStemAPIPlatformControllersPurchasingIntegrationSettingsUpdateAPIRequest {
  /** @format int32 */
  id?: number
  description?: string
  type?: string
  name?: string
  settings?: object
  enabled?: boolean
}

export interface MainStemAPIPlatformControllersPurchasingIntegrationLogAPIRequest {
  type?: string
  /** @format int32 */
  customerSessionID?: number
}

export interface MainStemAPIPlatformControllersPurchasingIntegrationLogAPIResponse {
  logs?: MainStemAPIPlatformControllersPurchasingIntegrationLogAPIResponseLogDetails[]
  message?: string
  wasSuccessful?: boolean
}

export interface MainStemAPIPlatformControllersPurchasingIntegrationLogAPIResponseLogDetails {
  wasSuccessful?: boolean
  apiCallName?: string
  /** @format date-time */
  dateCreated?: string
  /** @format int32 */
  id?: number
  request?: string
  response?: string
}

export interface MainStemAPIPlatformControllersPurchasingOrdersDetailsIntegrationsQuantumLeafQueueOrderAPIRequest {
  orderUUID?: string
  invoiceUUID?: string
}

export interface MainStemAPIPlatformControllersPurchasingOrdersDetailsIntegrationsQuickbooksCreateBillAPIRequest {
  orderUUID?: string
  invoiceUUID?: string
  /** @format int32 */
  paymentID?: number
}

export interface MainStemSDKIntegrationsExternalQuickbooksCreateBillCreateQbBillResponse {
  message?: string
  wasSuccessful?: boolean
}

export interface MainStemAPIPlatformControllersPurchasingOrdersDetailsIntegrationsQuickbooksCreateBillPaymentAPIRequest {
  orderUUID?: string
  invoiceUUID?: string
  /** @format int32 */
  paymentID?: number
}

export interface MainStemSDKIntegrationsExternalQuickbooksCreateBillPaymentCreateQbBillPaymentResponse {
  message?: string
  wasSuccessful?: boolean
}

export interface MainStemAPIPlatformControllersPurchasingOrdersDetailsIntegrationsQuickbooksCreateBillPaymentsFromPaymentAPIRequest {
  orderUUID?: string
  /** @format int32 */
  paymentID?: number
  baseRequest?: object
  /** @format int32 */
  customerID?: number
  /** @format int32 */
  businessPartnerId?: number
  businessPartners?: MainStemSDKDataModelsBusinessPartner[]
  /** @format int32 */
  locationID?: number
  isAdmin?: boolean
}

export interface MainStemAPIPlatformControllersPurchasingOrdersDetailsIntegrationsQuickbooksCreateBillPaymentsFromPaymentAPIResponse {
  error?: string
  message?: string
  wasSuccessful?: boolean
}

export interface MainStemAPIPlatformControllersPurchasingIntegrationStaplesOrderLineItemCreateAPIRequest {
  /** @format int32 */
  orderId?: number
  /** @format int32 */
  quantity?: number
  searchDetails?: MainStemAPIPlatformControllersPurchasingIntegrationStaplesOrderLineItemCreateAPIRequestSearchDetails
  staplesProduct?: MainStemSDKIntegrationsStaplesModelsStaplesProduct
}

export interface MainStemAPIPlatformControllersPurchasingIntegrationStaplesOrderLineItemCreateAPIRequestSearchDetails {
  partitionKey?: string
  rowKey?: string
}

export interface MainStemSDKIntegrationsStaplesModelsStaplesProduct {
  /** @format int32 */
  availableQuantity?: number
  description?: MainStemSDKIntegrationsStaplesModelsStaplesProductDescriptionDetails
  image?: string
  isDiscontinued?: boolean
  isOutOfStock?: boolean
  itemAvailability?: MainStemSDKIntegrationsStaplesModelsStaplesProductItemAvailabilityDetails
  itemId?: string
  manufacturerId?: string
  /** @format double */
  priceValue?: number
  title?: string
}

export interface MainStemSDKIntegrationsStaplesModelsStaplesProductDescriptionDetails {
  bullets?: string[]
  headliner?: string[]
  paragraph?: string[]
  specification?: MainStemSDKIntegrationsStaplesModelsStaplesProductDescriptionDetailsSpecificationDetials[]
}

export interface MainStemSDKIntegrationsStaplesModelsStaplesProductItemAvailabilityDetails {
  /** @format int32 */
  maxLeadTime?: number
}

export interface MainStemSDKIntegrationsStaplesModelsStaplesProductDescriptionDetailsSpecificationDetials {
  name?: string
  value?: string
}

export interface MainStemAPIPlatformControllersPurchasingIntegrationStaplesOrderLineItemCreateAPIResponse {
  /**
   * @format uuid
   * @example "00000000-0000-0000-0000-000000000000"
   */
  orderUUID: string
  message?: string
  wasSuccessful?: boolean
}

export interface MainStemAPIPlatformControllersPurchasingIntegrationStaplesProductDetailsAPIRequest {
  itemId?: string
}

export interface MainStemAPIPlatformControllersPurchasingIntegrationStaplesProductDetailsAPIResponse {
  /** @format int32 */
  catalogCount: number
  /** @format int32 */
  mainStemProductId: number
  staplesProduct?: MainStemSDKIntegrationsStaplesModelsStaplesProduct
  message?: string
  wasSuccessful?: boolean
}

export interface MainStemAPIPlatformControllersPurchasingIntegrationStaplesProductImportAPIRequest {
  staplesProduct: MainStemSDKIntegrationsStaplesModelsStaplesProduct
}

export interface MainStemAPIPlatformControllersPurchasingIntegrationStaplesProductImportAPIResponse {
  /** @format int32 */
  mainStemProductId: number
  message?: string
  wasSuccessful?: boolean
}

export interface MainStemAPIPlatformControllersPurchasingInvoicesAllocationItemCreateAPIRequest {
  /** @format int32 */
  departmentId?: number
  /** @format int32 */
  invoiceLineItemId?: number
  /** @format int32 */
  quantity?: number
  financialDimensions?: MainStemAPIPlatformControllersPurchasingInvoicesAllocationItemCreateAPIRequestFinancialDimensionUpdate[]
}

export interface MainStemAPIPlatformControllersPurchasingInvoicesAllocationItemCreateAPIRequestFinancialDimensionUpdate {
  /** @format int32 */
  financialDimensionID?: number
  /** @format int32 */
  financialDimensionOptionID?: number
}

export interface MainStemAPIPlatformControllersPurchasingInvoicesAllocationItemDeleteAPIRequest {
  /** @format int32 */
  invoiceAllocationLineItemId?: number
}

export interface MainStemAPIPlatformControllersPurchasingInvoicesAllocationItemGetAPIRequest {
  /** @format int32 */
  invoiceLineItemId?: number
}

export interface MainStemAPIPlatformControllersPurchasingInvoicesAllocationItemGetAPIResponse {
  /** @format int32 */
  quantityUsed?: number
  /** @format double */
  quantityAvailable?: number
  /** @format int32 */
  currentQuantity?: number
  location?: MainStemAPIPlatformControllersPurchasingInvoicesAllocationItemGetAPIResponseLocationDetails
  allocation?: MainStemAPIPlatformControllersPurchasingInvoicesAllocationItemGetAPIResponseAllocationDetails
  message?: string
  wasSuccessful?: boolean
}

export interface MainStemAPIPlatformControllersPurchasingInvoicesAllocationItemGetAPIResponseLocationDetails {
  /** @format int32 */
  id?: number
  name?: string
}

export interface MainStemAPIPlatformControllersPurchasingInvoicesAllocationItemGetAPIResponseAllocationDetails {
  /** @format int32 */
  id?: number
  /** @format date-time */
  dateCreated?: string
  /** @format int32 */
  invoiceLineItemId?: number
  isDeleted?: boolean
  /** @format int32 */
  quantity?: number
  userCreatedByID?: string
  /** @format int32 */
  departmentID?: number
  financialDimensions?: MainStemSDKHelpersFinancialDimensionsFactoryFinancialDimensionOptionSelectionDetail[]
}

export interface MainStemAPIPlatformControllersPurchasingInvoicesAllocationItemListAPIRequest {
  /** @format int32 */
  invoiceLineItemId?: number
}

export interface MainStemAPIPlatformControllersPurchasingInvoicesAllocationItemListAPIResponse {
  /** @format int32 */
  quantityUsed?: number
  /** @format double */
  quantityAvailable?: number
  allocations?: MainStemAPIPlatformControllersPurchasingInvoicesAllocationItemListAPIResponseAllocationDetails[]
  message?: string
  wasSuccessful?: boolean
}

export interface MainStemAPIPlatformControllersPurchasingInvoicesAllocationItemListAPIResponseAllocationDetails {
  /** @format int32 */
  id?: number
  /** @format date-time */
  dateCreated?: string
  /** @format int32 */
  invoiceLineItemId?: number
  isDeleted?: boolean
  /** @format int32 */
  quantity?: number
  userCreatedByID?: string
  /** @format int32 */
  departmentID?: number
}

export interface MainStemAPIPlatformControllersPurchasingInvoicesAllocationItemUpdateAPIRequest {
  /** @format int32 */
  departmentId?: number
  /** @format int32 */
  invoiceLineItemId?: number
  /** @format int32 */
  quantity?: number
  financialDimensions?: MainStemAPIPlatformControllersPurchasingInvoicesAllocationItemUpdateAPIRequestFinancialDimensionUpdate[]
}

export interface MainStemAPIPlatformControllersPurchasingInvoicesAllocationItemUpdateAPIRequestFinancialDimensionUpdate {
  /** @format int32 */
  financialDimensionID?: number
  /** @format int32 */
  financialDimensionOptionID?: number
}

export interface MainStemAPIPlatformControllersPurchasingInvoiceProblemsCreateAPIRequest {
  content?: string
  subject?: string
  /** @format int32 */
  invoiceId?: number
  type?: string
}

export interface MainStemAPIPlatformControllersGlobalMessageCreateAPIResponse {
  /** @format int32 */
  id?: number
  message?: string
  wasSuccessful?: boolean
}

export interface MainStemAPIPlatformControllersPurchasingInvoiceProblemsDetailsAPIRequest {
  /** @format int32 */
  id?: number
}

export interface MainStemAPIPlatformControllersPurchasingInvoiceProblemsDetailsAPIResponse {
  problem?: MainStemAPIPlatformControllersPurchasingInvoiceProblemsDetailsAPIResponseInvoiceProblemDetail
  message?: string
  wasSuccessful?: boolean
}

export interface MainStemAPIPlatformControllersPurchasingInvoiceProblemsDetailsAPIResponseInvoiceProblemDetail {
  message?: string
  /** @format int32 */
  id?: number
  /** @format date-time */
  dateCreated?: string
  createdBy?: string
  createdByID?: string
  status?: string
  /** @format int32 */
  messageCount?: number
  /** @format int32 */
  unreadCount?: number
}

export interface MainStemAPIPlatformControllersPurchasingInvoiceProblemsListAPIRequest {
  invoiceIds?: number[]
}

export interface MainStemAPIPlatformControllersPurchasingInvoiceProblemsListAPIResponse {
  problems?: MainStemAPIPlatformControllersPurchasingInvoiceProblemsListAPIResponseInvoiceProblemDetail[]
  message?: string
  wasSuccessful?: boolean
}

export interface MainStemAPIPlatformControllersPurchasingInvoiceProblemsListAPIResponseInvoiceProblemDetail {
  message?: string
  /** @format int32 */
  messageCount?: number
  /** @format int32 */
  unreadCount?: number
  /** @format int32 */
  id?: number
  /** @format int32 */
  invoiceID?: number
  /** @format date-time */
  dateCreated?: string
  createdBy?: string
  createdByID?: string
  status?: string
  subject?: string
}

export interface MainStemAPIPlatformControllersPurchasingInvoiceProblemsListUnresolvedAPIRequest {
  invoiceIds?: number[]
}

export interface MainStemAPIPlatformControllersPurchasingInvoiceProblemsListUnresolvedAPIResponse {
  problems?: MainStemAPIPlatformControllersPurchasingInvoiceProblemsListUnresolvedAPIResponseInvoiceProblemDetail[]
  message?: string
  wasSuccessful?: boolean
}

export interface MainStemAPIPlatformControllersPurchasingInvoiceProblemsListUnresolvedAPIResponseInvoiceProblemDetail {
  message?: string
  createdBy?: string
  createdByID?: string
  /** @format int32 */
  createdByLocationID?: number
  createdByLocationName?: string
  /** @format date-time */
  dateCreated?: string
  /** @format int32 */
  id?: number
  /** @format int32 */
  invoiceID?: number
  /** @format int32 */
  locationID?: number
  locationName?: string
  /** @format int32 */
  messageCount?: number
  /** @format int32 */
  orderID?: number
  /**
   * @format uuid
   * @example "00000000-0000-0000-0000-000000000000"
   */
  orderUUID?: string
  status?: 'Open' | 'InProgress' | 'Resolved'
  type?: string
  /** @format int32 */
  unreadCount?: number
  userRelated?: boolean
}

export interface MainStemAPIPlatformControllersPurchasingInvoiceProblemsUpdateStatusAPIRequest {
  /** @format int32 */
  id?: number
  status?: string
}

export interface MainStemAPIPlatformControllersPurchasingInvoiceProblemsUpdateStatusAPIResponse {
  problem?: MainStemAPIPlatformControllersPurchasingInvoiceProblemsUpdateStatusAPIResponseInvoiceProblemDetail
  message?: string
  wasSuccessful?: boolean
}

export interface MainStemAPIPlatformControllersPurchasingInvoiceProblemsUpdateStatusAPIResponseInvoiceProblemDetail {
  message?: string
  /** @format int32 */
  id?: number
  /** @format date-time */
  dateCreated?: string
  createdBy?: string
  createdByID?: string
  status?: string
  /** @format int32 */
  messageCount?: number
  /** @format int32 */
  unreadCount?: number
}

export interface MainStemAPIPlatformControllersPurchasingReceivingUpdateAPIRequest {
  invoiceUUID: string
  /** @format date-time */
  dateReceivedPhysical: string
}

export interface MainStemAPIPlatformControllersPurchasingReceivingDetailsAPIRequest {
  invoiceUUID?: string
}

export interface MainStemAPIPlatformControllersPurchasingReceivingDetailsAPIResponse {
  invoice?: MainStemAPIPlatformControllersPurchasingReceivingDetailsInvoiceDetail
  receiveDetails?: MainStemAPIPlatformControllersPurchasingReceivingDetailsAPIResponseInvoiceDetails
  receivedInventoriesTransactions?: MainStemAPIPlatformControllersPurchasingReceivingDetailsReceivedInventory[]
  receiveItems?: MainStemAPIPlatformControllersPurchasingReceivingDetailsAPIResponseReceiveItems[]
  message?: string
  wasSuccessful?: boolean
}

export interface MainStemAPIPlatformControllersPurchasingReceivingDetailsInvoiceDetail {
  /** @format int32 */
  fulfillmentID?: number
  invoiceID?: string
  /** @format int32 */
  locationID?: number
  locationName?: string
  /** @format int32 */
  orderID?: number
  orderUUID?: string
  /** @format int32 */
  supplierID?: number
  supplierName?: string
}

export interface MainStemAPIPlatformControllersPurchasingReceivingDetailsAPIResponseInvoiceDetails {
  addressShipTo?: MainStemAPIPlatformControllersPurchasingReceivingDetailsAPIResponseShipToDetails
  /** @format date-time */
  dateCreated?: string
  /** @format date-time */
  dateReceivedPhysical?: string
  /** @format int32 */
  id?: number
  /** @format int32 */
  invoiceId?: number
  /** @format int32 */
  orderId?: number
  sources?: string[]
  userCreatedBy?: MainStemAPIPlatformControllersPurchasingReceivingDetailsAPIResponseUserDetails
  uuid?: string
}

export interface MainStemAPIPlatformControllersPurchasingReceivingDetailsReceivedInventory {
  /** @format date-time */
  dateCreated?: string
  /** @format int32 */
  id?: number
  lineItems?: MainStemAPIPlatformControllersPurchasingReceivingDetailsReceivedInventoryItemLine[]
  /** @format date-time */
  receivedPhysicalDate?: string
  source?: string
  userCreatedBy?: string
}

export interface MainStemAPIPlatformControllersPurchasingReceivingDetailsAPIResponseReceiveItems {
  department?: MainStemAPIPlatformControllersPurchasingReceivingDetailsAPIResponseDepartmentDetails
  /** @format int32 */
  departmentID?: number
  departmentName?: string
  /** @format double */
  invoicedQuantity?: number
  product?: MainStemAPIPlatformControllersPurchasingReceivingDetailsAPIResponseProductDetails
  /** @format int32 */
  productID?: number
  productName?: string
  productSku?: string
  /** @format int32 */
  quantity?: number
  /** @format int32 */
  quantityAllocated?: number
  supplerName?: string
  /** @format int32 */
  supplierID?: number
}

export interface MainStemAPIPlatformControllersPurchasingReceivingDetailsAPIResponseShipToDetails {
  address1?: string
  address2?: string
  city?: string
  country?: string
  name?: string
  state?: string
  zip?: string
}

export interface MainStemAPIPlatformControllersPurchasingReceivingDetailsAPIResponseUserDetails {
  id?: string
  username?: string
}

export interface MainStemAPIPlatformControllersPurchasingReceivingDetailsReceivedInventoryItemLine {
  /** @format int32 */
  departmentID?: number
  departmentName?: string
  /** @format int32 */
  id?: number
  /** @format double */
  invoicedQuantity?: number
  /** @format int32 */
  invoiceLineItemID?: number
  /** @format int32 */
  productID?: number
  productName?: string
  productSku?: string
  /** @format int32 */
  quantity?: number
  /** @format int32 */
  supplierID?: number
  supplierName?: string
}

export interface MainStemAPIPlatformControllersPurchasingReceivingDetailsAPIResponseDepartmentDetails {
  /** @format int32 */
  id?: number
  name?: string
}

export interface MainStemAPIPlatformControllersPurchasingReceivingDetailsAPIResponseProductDetails {
  /** @format int32 */
  id?: number
  name?: string
  sku?: string
}

export interface MainStemAPIPlatformControllersPurchasingReceivingInvoiceListAPIRequest {
  /** @format int32 */
  invoiceId?: number
}

export interface MainStemAPIPlatformControllersPurchasingReceivingInvoiceListAPIResponse {
  itemsToReceive?: MainStemAPIPlatformControllersPurchasingReceivingInvoiceListAPIResponseItemToReceive[]
  allocatedLineItems?: MainStemAPIPlatformControllersPurchasingReceivingInvoiceListAPIResponseAllocationItem[]
  receivedLineItems?: MainStemAPIPlatformControllersPurchasingReceivingInvoiceListAPIResponseReceivedItem[]
  invoice?: MainStemAPIPlatformControllersPurchasingReceivingInvoiceListInvoiceDetail
  message?: string
  wasSuccessful?: boolean
}

export interface MainStemAPIPlatformControllersPurchasingReceivingInvoiceListAPIResponseItemToReceive {
  /** @format int32 */
  index?: number
  /** @format int32 */
  invoiceLineItemID?: number
  product?: MainStemAPIPlatformControllersPurchasingReceivingInvoiceListAPIResponseProductDetails
  location?: MainStemAPIPlatformControllersPurchasingReceivingInvoiceListAPIResponseLocationDetails
  /** @format double */
  quantityOrdered?: number
  /** @format double */
  quantityAllocated?: number
  /** @format double */
  quantityReceived?: number
  /** @format double */
  quantityAlreadyReceived?: number
  /** @format double */
  quantityAvailable?: number
  /** @format int32 */
  departmentID?: number
  /** @format int32 */
  supplierID?: number
  supplierName?: string
}

export interface MainStemAPIPlatformControllersPurchasingReceivingInvoiceListAPIResponseAllocationItem {
  /** @format int32 */
  departmentID?: number
  /** @format int32 */
  invoiceLineItemID?: number
  /** @format double */
  quantityOrdered?: number
  /** @format double */
  quantityAllocated?: number
  /** @format double */
  quantityReceived?: number
  product?: MainStemAPIPlatformControllersPurchasingReceivingInvoiceListAPIResponseProductDetails
  location?: MainStemAPIPlatformControllersPurchasingReceivingInvoiceListAPIResponseLocationDetails
  /** @format int32 */
  supplierID?: number
  supplierName?: string
  /** @format int32 */
  totalAllocated?: number
}

export interface MainStemAPIPlatformControllersPurchasingReceivingInvoiceListAPIResponseReceivedItem {
  /** @format int32 */
  invoiceLineItemID?: number
  product?: MainStemAPIPlatformControllersPurchasingReceivingInvoiceListAPIResponseProductDetails
  location?: MainStemAPIPlatformControllersPurchasingReceivingInvoiceListAPIResponseLocationDetails
  /** @format double */
  quantityOrdered?: number
  /** @format double */
  quantityReceived?: number
  /** @format int32 */
  departmentID?: number
  /** @format int32 */
  supplierID?: number
  supplierName?: string
}

export interface MainStemAPIPlatformControllersPurchasingReceivingInvoiceListInvoiceDetail {
  /** @format int32 */
  orderID?: number
  /** @format int32 */
  fulfillmentID?: number
  invoiceID?: string
  /** @format int32 */
  locationID?: number
  locationName?: string
  supplierName?: string
  /** @format int32 */
  supplierID?: number
  orderUUID?: string
}

export interface MainStemAPIPlatformControllersPurchasingReceivingInvoiceListAPIResponseProductDetails {
  /** @format int32 */
  id?: number
  name?: string
  imageURL?: string
}

export interface MainStemAPIPlatformControllersPurchasingReceivingInvoiceListAPIResponseLocationDetails {
  /** @format int32 */
  id?: number
  name?: string
}

export interface MainStemAPIPlatformControllersPurchasingReceivingInvoiceUpdateAPIRequest {
  /** @format date-time */
  dateReceivedPhysical: string
  /** @format int32 */
  invoiceId: number
  receiveItems: MainStemAPIPlatformControllersPurchasingReceivingInvoiceUpdateAPIRequestReceiveItems[]
}

export interface MainStemAPIPlatformControllersPurchasingReceivingInvoiceUpdateAPIRequestReceiveItems {
  /** @format int32 */
  departmentID: number
  /** @format int32 */
  index?: number
  /** @format int32 */
  invoiceLineItemID?: number
  location?: MainStemAPIPlatformControllersPurchasingReceivingInvoiceUpdateAPIRequestLocationDetails
  product?: MainStemAPIPlatformControllersPurchasingReceivingInvoiceUpdateAPIRequestProductDetails
  /** @format int32 */
  quantityAllocated?: number
  /** @format int32 */
  quantityAvailable?: number
  /** @format int32 */
  quantityOrdered?: number
  /** @format int32 */
  quantityReceived?: number
  /** @format int32 */
  supplierID?: number
}

export interface MainStemAPIPlatformControllersPurchasingReceivingInvoiceUpdateAPIRequestLocationDetails {
  /** @format int32 */
  id: number
  name: string
}

export interface MainStemAPIPlatformControllersPurchasingReceivingInvoiceUpdateAPIRequestProductDetails {
  /** @format int32 */
  id: number
  name: string
}

export interface MainStemAPIPlatformControllersPurchasingReceivingItemListAPIRequest {
  /** @format int32 */
  invoiceLineItemId?: number
}

export interface MainStemAPIPlatformControllersPurchasingReceivingItemUpdateAPIRequest {
  /** @format date-time */
  dateReceivedPhysical?: string
  /** @format int32 */
  invoiceLineItemId?: number
  receiveItems?: MainStemAPIPlatformControllersPurchasingReceivingItemUpdateAPIRequestReceiveItems[]
}

export interface MainStemAPIPlatformControllersPurchasingReceivingItemUpdateAPIRequestReceiveItems {
  /** @format int32 */
  departmentID?: number
  /** @format int32 */
  index?: number
  /** @format int32 */
  invoiceLineItemID?: number
  location?: MainStemAPIPlatformControllersPurchasingReceivingItemUpdateAPIRequestLocationDetails
  product?: MainStemAPIPlatformControllersPurchasingReceivingItemUpdateAPIRequestProductDetails
  /** @format int32 */
  quantityAllocated?: number
  /** @format int32 */
  quantityAvailable?: number
  /** @format int32 */
  quantityOrdered?: number
  /** @format int32 */
  quantityReceived?: number
  /** @format int32 */
  supplierID?: number
}

export interface MainStemAPIPlatformControllersPurchasingReceivingItemUpdateAPIRequestLocationDetails {
  /** @format int32 */
  id?: number
  name?: string
}

export interface MainStemAPIPlatformControllersPurchasingReceivingItemUpdateAPIRequestProductDetails {
  /** @format int32 */
  id?: number
  name?: string
}

export interface MainStemAPIPlatformControllersPurchasingInvoicesAcceptAPIRequest {
  /** @format int32 */
  invoiceId?: number
}

export interface MainStemAPIPlatformControllersPurchasingInvoicesAcceptAPIResponse {
  message?: string
  wasSuccessful?: boolean
}

export interface MainStemAPIPlatformControllersPurchasingInvoicesCancelAPIRequest {
  /** @format int32 */
  invoiceId?: number
}

export interface MainStemAPIPlatformControllersPurchasingInvoicesCancelAPIResponse {
  message?: string
  wasSuccessful?: boolean
}

export interface MainStemAPIPlatformControllersPurchasingInvoicesCompleteAPIRequest {
  /** @format int32 */
  invoiceId?: number
}

export interface MainStemAPIPlatformControllersPurchasingInvoicesCompleteAPIResponse {
  message?: string
  wasSuccessful?: boolean
}

export interface MainStemAPIPlatformControllersPurchasingInvoicesDeclineAPIRequest {
  /** @format int32 */
  invoiceId?: number
}

export interface MainStemAPIPlatformControllersPurchasingInvoicesDeclineAPIResponse {
  message?: string
  wasSuccessful?: boolean
}

export interface MainStemAPIPlatformControllersPurchasingInvoicesDetailsAPIRequest {
  /** @format int32 */
  id: number
}

export interface MainStemAPIPlatformControllersPurchasingInvoicesDetailsAPIResponse {
  invoice?: MainStemAPIPlatformHelpersInvoicesResponseInvoiceDetails
  message?: string
  wasSuccessful?: boolean
}

export interface MainStemAPIPlatformHelpersInvoicesResponseInvoiceDetails {
  acceptanceStatus?: 'Cancelled' | 'Pending' | 'Accepted' | 'Rejected'
  acknowledgedBy?: string
  apexTradingConnection?: MainStemAPIPlatformHelpersInvoicesResponseInvoiceDetailsApexTradingConnectionDetails
  apexTradingOrders?: MainStemAPIPlatformHelpersInvoicesResponseInvoiceDetailsApexTradingOrderDetails[]
  /** @format date-time */
  dateAccepted?: string
  giftCardOrder?: MainStemAPIPlatformHelpersInvoicesResponseInvoiceDetailsGiftCardOrderDetails
  /** @format date-time */
  dateAcknowledged?: string
  /** @format date-time */
  dateNotified?: string
  /** @format date-time */
  datePromisedBy?: string
  /** @format date-time */
  dateReceived?: string
  /** @format date-time */
  dateReleased?: string
  /** @format date-time */
  dateShipped?: string
  /** @format double */
  discount?: number
  /** @format double */
  fees?: number
  hasProblem?: boolean
  /** @format int32 */
  id: number
  invoiceStatusDetail?: MainStemAPIPlatformHelpersInvoicesResponseInvoiceDetailsInvoiceStatusDetail
  invoiceStatus: 'Cancelled' | 'Draft' | 'InProgress' | 'UnderReview' | 'Released' | 'ReadyForRelease'
  isPrivateSupplier?: boolean
  inquiries?: MainStemAPIPlatformHelpersInvoicesResponseInvoiceDetailsInquiryDetails[]
  lineItems?: MainStemAPIPlatformHelpersInvoicesResponseInvoiceDetailsLineItemDetails[]
  location?: MainStemAPIPlatformHelpersInvoicesResponseInvoiceDetailsLocationDetails
  logoURL?: string
  /** @format int32 */
  purchaseOrderId?: number
  requisition?: MainStemAPIPlatformHelpersInvoicesResponseInvoiceDetailsRequisitionDetails
  /** @format double */
  salesTax?: number
  shipments?: MainStemAPIPlatformHelpersInvoicesResponseInvoiceDetailsShipmentDetails[]
  /** @format double */
  shipping?: number
  /** @format double */
  subTotal?: number
  supplier?: MainStemAPIPlatformHelpersInvoicesResponseInvoiceDetailsSupplierDetails
  taxBreakdownJSON?: string
  /** @format double */
  total?: number
  /**
   * @format uuid
   * @example "00000000-0000-0000-0000-000000000000"
   */
  uuid: string
  dynamicsId?: string
  dynamicsUrl?: string
  quantumLeafID?: string
  quantumLeafUrl?: string
  quickBooksID?: string
  quickBooksUrl?: string
}

export interface MainStemAPIPlatformHelpersInvoicesResponseInvoiceDetailsApexTradingConnectionDetails {
  /** @format int32 */
  integrationSettingsId: number
  integrationName?: string
  /** @format int32 */
  sellerId?: number
  sellerName?: string
}

export interface MainStemAPIPlatformHelpersInvoicesResponseInvoiceDetailsApexTradingOrderDetails {
  id: string
  invoiceNumber?: string
  url?: string
  uuid?: string
}

export interface MainStemAPIPlatformHelpersInvoicesResponseInvoiceDetailsGiftCardOrderDetails {
  id: string
}

export interface MainStemAPIPlatformHelpersInvoicesResponseInvoiceDetailsInvoiceStatusDetail {
  allowResendOfEmail?: boolean
  /** @format date-time */
  dateCreated?: string
  /** @format date-time */
  dateViewed?: string
  status?: string
}

export interface MainStemAPIPlatformHelpersInvoicesResponseInvoiceDetailsInquiryDetails {
  createdBy?: string
  /** @format date-time */
  dateCreated?: string
  /** @format int32 */
  id?: number
  status?: string
  subject?: string
}

export interface MainStemAPIPlatformHelpersInvoicesResponseInvoiceDetailsLineItemDetails {
  allocations?: MainStemAPIPlatformHelpersInvoicesResponseInvoiceDetailsLineItemDetailsAllocationDetails[]
  allocationsLeft?: boolean
  /** @format int32 */
  id?: number
  /** @format double */
  price?: number
  product?: MainStemAPIPlatformHelpersInvoicesResponseInvoiceDetailsLineItemDetailsProductDetails
  /** @format double */
  quantity?: number
  /** @format int32 */
  quantityAllocated?: number
  /** @format double */
  subTotal?: number
}

export interface MainStemAPIPlatformHelpersInvoicesResponseInvoiceDetailsLocationDetails {
  address1?: string
  address2?: string
  city?: string
  country?: string
  /** @format int32 */
  id: number
  name?: string
  state?: string
  zip?: string
}

export interface MainStemAPIPlatformHelpersInvoicesResponseInvoiceDetailsRequisitionDetails {
  /** @format date-time */
  dateApproved?: string
  /** @format int32 */
  id: number
  paymentStatus?: string
  /**
   * @format uuid
   * @example "00000000-0000-0000-0000-000000000000"
   */
  uuid: string
}

export interface MainStemAPIPlatformHelpersInvoicesResponseInvoiceDetailsShipmentDetails {
  carrier?: string
  carrierType?: string
  /** @format date-time */
  dateReceived?: string
  /** @format date-time */
  dateShippedOn?: string
  /** @format date-time */
  estimatedDeliveryDate?: string
  trackingNumber?: string
  /**
   * @format uuid
   * @example "00000000-0000-0000-0000-000000000000"
   */
  uuid?: string
}

export interface MainStemAPIPlatformHelpersInvoicesResponseInvoiceDetailsSupplierDetails {
  city?: string
  country?: string
  /** @format int32 */
  id: number
  isVerified?: boolean
  logoURL?: string
  name?: string
  state?: string
  usesDirectPay?: boolean
  usesPreferredShipping?: boolean
  zip?: string
}

export interface MainStemAPIPlatformHelpersInvoicesResponseInvoiceDetailsLineItemDetailsAllocationDetails {
  /** @format date-time */
  dateCreated?: string
  department?: MainStemAPIPlatformHelpersInvoicesResponseInvoiceDetailsLineItemDetailsAllocationDetailsDepartmentDetails
  /** @format int32 */
  id?: number
  /** @format int32 */
  quantity?: number
  userCreatedBy?: MainStemAPIPlatformHelpersInvoicesResponseInvoiceDetailsLineItemDetailsAllocationDetailsUserDetails
}

export interface MainStemAPIPlatformHelpersInvoicesResponseInvoiceDetailsLineItemDetailsProductDetails {
  /** @format int32 */
  id?: number
  imageURL?: string
  name?: string
  type?: string
}

export interface MainStemAPIPlatformHelpersInvoicesResponseInvoiceDetailsLineItemDetailsAllocationDetailsDepartmentDetails {
  /** @format int32 */
  id?: number
  name?: string
}

export interface MainStemAPIPlatformHelpersInvoicesResponseInvoiceDetailsLineItemDetailsAllocationDetailsUserDetails {
  id?: string
  username?: string
}

export interface MainStemAPIPlatformControllersPurchasingInvoicesFinancialDimensionsUpdateAPIRequest {
  financialDimensions?: MainStemAPIPlatformControllersPurchasingInvoicesFinancialDimensionsUpdateAPIRequestFinancialDimensionUpdate[]
  /** @format int32 */
  invoiceId?: number
}

export interface MainStemAPIPlatformControllersPurchasingInvoicesFinancialDimensionsUpdateAPIRequestFinancialDimensionUpdate {
  /** @format int32 */
  financialDimensionID?: number
  /** @format int32 */
  financialDimensionOptionID?: number
}

export interface MainStemAPIPlatformControllersPurchasingInvoicesLineItemsCreateAPIRequest {
  /** @format int32 */
  invoiceId: number
  /** @format int32 */
  productId: number
  /** @format int32 */
  quantity: number
  /** @format double */
  price?: number
}

export interface MainStemAPIPlatformControllersPurchasingInvoicesLineItemsCreateAPIResponse {
  /** @format int32 */
  invoiceLineItemId: number
  message?: string
  wasSuccessful?: boolean
}

export interface MainStemAPIPlatformControllersPurchasingInvoicesLineItemsDeleteAPIRequest {
  /** @format int32 */
  invoiceLineItemId: number
}

export interface MainStemAPIPlatformControllersPurchasingInvoicesLineItemsDeleteAPIResponse {
  message?: string
  wasSuccessful?: boolean
}

export interface MainStemAPIPlatformControllersPurchasingInvoicesLineItemsUpdateAPIRequest {
  /** @format int32 */
  id?: number
  /** @format double */
  price?: number
  /** @format int32 */
  quantity?: number
}

export interface MainStemAPIPlatformControllersPurchasingInvoicesLineItemsUpdateAPIResponse {
  message?: string
  wasSuccessful?: boolean
}

export interface MainStemAPIPlatformControllersPurchasingInvoicesListAPIRequest {
  exportResults?: boolean
  hasShipped?: boolean
  hasIntegration?: boolean
  includeCounts?: boolean
  /** @format int32 */
  invoiceId?: number
  /** @format int32 */
  invoiceOrRequisitionId?: number
  invoiceStatus?: 'Cancelled' | 'Draft' | 'InProgress' | 'UnderReview' | 'Released' | 'ReadyForRelease'
  isPrivate?: boolean
  /** @format int32 */
  locationId?: number
  locationName?: string
  /** @format int32 */
  page?: number
  /** @format int32 */
  pageSize?: number
  paymentComplete?: boolean
  paymentStatus?: string
  /** @format int32 */
  requisitionId?: number
  sortField?: string
  sortOrder?: string
  /** @format int32 */
  supplierId?: number
  supplierName?: string
}

export interface MainStemAPIPlatformControllersPurchasingInvoicesListAPIResponse {
  /** @format int32 */
  countPaid?: number
  /** @format int32 */
  countPendingPayment?: number
  /** @format int32 */
  countPendingShipment?: number
  /** @format int32 */
  countShipped?: number
  invoices?: MainStemAPIPlatformControllersPurchasingInvoicesListAPIResponseInvoiceDetails[]
  /** @format int32 */
  total?: number
  /** @format int32 */
  totalFiltered?: number
  message?: string
  wasSuccessful?: boolean
}

export interface MainStemAPIPlatformControllersPurchasingInvoicesListAPIResponseInvoiceDetails {
  /** @format date-time */
  dateReleased?: string
  /** @format date-time */
  dateShipped?: string
  hasIntegration: boolean
  /** @format int32 */
  id: number
  invoiceStatus: 'Cancelled' | 'Draft' | 'InProgress' | 'UnderReview' | 'Released' | 'ReadyForRelease'
  location: MainStemAPIPlatformControllersPurchasingInvoicesListAPIResponseInvoiceDetailsLocationDetails
  order: MainStemAPIPlatformControllersPurchasingInvoicesListAPIResponseInvoiceDetailsOrderDetails
  quantumLeafID?: string
  quantumLeafUrl?: string
  quickBooksID?: string
  quickBooksUrl?: string
  dynamicsUrl?: string
  dynamicsId?: string
  /** @format double */
  salesTax: number
  /** @format double */
  shipping: number
  /** @format double */
  subTotal: number
  supplier: MainStemAPIPlatformControllersPurchasingInvoicesListAPIResponseInvoiceDetailsSupplierDetails
  /** @format double */
  total: number
  uuid: string
}

export interface MainStemAPIPlatformControllersPurchasingInvoicesListAPIResponseInvoiceDetailsLocationDetails {
  address1?: string
  address2?: string
  city?: string
  country?: string
  /** @format int32 */
  id: number
  name?: string
  state?: string
  zip?: string
}

export interface MainStemAPIPlatformControllersPurchasingInvoicesListAPIResponseInvoiceDetailsOrderDetails {
  /** @format int32 */
  id: number
  paymentStatus?: string
  uuid: string
}

export interface MainStemAPIPlatformControllersPurchasingInvoicesListAPIResponseInvoiceDetailsSupplierDetails {
  /** @format int32 */
  id: number
  isPrivate: boolean
  name?: string
  usesDirectPay: boolean
  usesPreferredShipping: boolean
}

export interface MainStemAPIPlatformControllersPurchasingInvoicesNotifyAPIRequest {
  /** @format int32 */
  invoiceId?: number
}

export interface MainStemAPIPlatformControllersPurchasingInvoicesNotifyAPIResponse {
  message?: string
  wasSuccessful?: boolean
}

export interface MainStemAPIPlatformControllersPurchasingInvoicesReceivingListAPIRequest {
  /** @format int32 */
  invoiceId: number
}

export interface MainStemAPIPlatformControllersPurchasingInvoicesReceivingListAPIResponse {
  receiving: MainStemAPIPlatformControllersPurchasingInvoicesReceivingListAPIResponseReceivingDetails[]
  message?: string
  wasSuccessful?: boolean
}

export interface MainStemAPIPlatformControllersPurchasingInvoicesReceivingListAPIResponseReceivingDetails {
  /** @format date-time */
  datePromisedBy?: string
  /** @format date-time */
  dateShipped?: string
  /** @format int32 */
  id: number
  /** @format int32 */
  locationId?: number
  locationName?: string
  productImage?: string
  /** @format int32 */
  productId?: number
  productName?: string
  productType?: string
  /** @format double */
  quantity: number
  /** @format int32 */
  supplierId?: number
  supplierName?: string
  /** @format int32 */
  totalReceived: number
}

export interface MainStemAPIPlatformControllersPurchasingInvoicesReconciliationCreateAPIResponse {
  /** @format int32 */
  id?: number
  message?: string
  wasSuccessful?: boolean
}

export interface MainStemAPIPlatformControllersPurchasingInvoicesReconciliationDetailsAPIRequest {
  /** @format int32 */
  id: number
}

export interface MainStemAPIPlatformControllersPurchasingInvoicesReconciliationDetailsAPIResponse {
  reconciliation?: MainStemAPIPlatformControllersPurchasingInvoicesReconciliationDetailsAPIResponseReconciliationDetails
  message?: string
  wasSuccessful?: boolean
}

export interface MainStemAPIPlatformControllersPurchasingInvoicesReconciliationDetailsAPIResponseReconciliationDetails {
  aiModel: 'Lido' | 'GPT54Mini'
  changeLogs?: MainStemAPIPlatformControllersPurchasingInvoicesReconciliationDetailsAPIResponseReconciliationDetailsChangeLogDetails[]
  /** @format date-time */
  dateCompleted?: string
  /** @format date-time */
  dateCreated: string
  fileName?: string
  fileUrl?: string
  hasDiscrepancies: boolean
  /** @format int32 */
  id: number
  invoice?: MainStemAPIPlatformControllersPurchasingInvoicesReconciliationDetailsAPIResponseReconciliationDetailsInvoiceDetails
  lineItems?: MainStemAPIPlatformControllersPurchasingInvoicesReconciliationDetailsAPIResponseReconciliationDetailsLineItemDetails[]
  poNumber?: string
  /** @format double */
  salesTax?: number
  salesTaxMatches?: boolean
  /** @format double */
  shipping?: number
  shippingMatches?: boolean
  /** @format double */
  subTotal?: number
  subTotalMatches?: boolean
  supplierReconciliationAIGuidance?: string
  /** @format double */
  total?: number
  totalMatches?: boolean
  uploadStatus: 'Pending' | 'InProgress' | 'Completed' | 'Failed'
  userCreatedBy?: string
}

export interface MainStemAPIPlatformControllersPurchasingInvoicesReconciliationDetailsAPIResponseReconciliationDetailsChangeLogDetails {
  /** @format int32 */
  id: number
  content?: string
  createdByUserName?: string
  /** @format date-time */
  dateCreated: string
  reason?: string
}

export interface MainStemAPIPlatformControllersPurchasingInvoicesReconciliationDetailsAPIResponseReconciliationDetailsInvoiceDetails {
  /** @format int32 */
  id: number
  /** @format int32 */
  orderId: number
  /** @format int32 */
  lineItemCount: number
  /** @format double */
  salesTax?: number
  /** @format double */
  shipping?: number
  /** @format double */
  subTotal?: number
  /** @format double */
  total?: number
  /** @format int32 */
  unmatchedLineItemCount: number
  unmatchedInvoiceLineItems?: MainStemAPIPlatformControllersPurchasingInvoicesReconciliationDetailsAPIResponseReconciliationDetailsInvoiceLineItemDetails[]
}

export interface MainStemAPIPlatformControllersPurchasingInvoicesReconciliationDetailsAPIResponseReconciliationDetailsLineItemDetails {
  /** @format int32 */
  id: number
  invoiceLineItem?: MainStemAPIPlatformControllersPurchasingInvoicesReconciliationDetailsAPIResponseReconciliationDetailsInvoiceLineItemDetails
  matches: boolean
  name?: string
  /** @format double */
  price: number
  /** @format int32 */
  quantity: number
  /** @format double */
  total: number
}

export interface MainStemAPIPlatformControllersPurchasingInvoicesReconciliationDetailsAPIResponseReconciliationDetailsInvoiceLineItemDetails {
  /** @format int32 */
  id: number
  name?: string
  /** @format double */
  price: number
  /** @format double */
  quantity: number
  /** @format double */
  total: number
}

export interface MainStemAPIPlatformControllersPurchasingInvoicesReconciliationListAPIRequest {
  /** @format int32 */
  invoiceId: number
}

export interface MainStemAPIPlatformControllersPurchasingInvoicesReconciliationListAPIResponse {
  reconciliations: MainStemAPIPlatformControllersPurchasingInvoicesReconciliationListAPIResponseReconciliationDetails[]
  message?: string
  wasSuccessful?: boolean
}

export interface MainStemAPIPlatformControllersPurchasingInvoicesReconciliationListAPIResponseReconciliationDetails {
  aiModel: 'Lido' | 'GPT54Mini'
  /** @format int32 */
  countLineItems: number
  /** @format int32 */
  countLineItemsMatched: number
  /** @format date-time */
  dateCompleted?: string
  /** @format date-time */
  dateCreated: string
  fileName?: string
  /** @format int32 */
  id: number
  poNumber?: string
  /** @format double */
  salesTax?: number
  /** @format double */
  shipping?: number
  /** @format double */
  total?: number
  uploadStatus: 'Pending' | 'InProgress' | 'Completed' | 'Failed'
  userCreatedBy?: string
}

export interface MainStemAPIPlatformControllersPurchasingInvoicesReconciliationRematchAPIRequest {
  /** @format int32 */
  id: number
}

export interface MainStemAPIPlatformControllersPurchasingInvoicesReconciliationRematchAPIResponse {
  message?: string
  wasSuccessful?: boolean
}

export interface MainStemAPIPlatformControllersPurchasingInvoicesShipmentsCreateAPIRequest {
  carrier?: string
  /** @format int32 */
  invoiceId?: number
  method?: string
  trackingNumber?: string
}

export interface MainStemAPIPlatformControllersPurchasingInvoicesShipmentsCreateAPIResponse {
  message?: string
  wasSuccessful?: boolean
}

export interface MainStemAPIPlatformControllersPurchasingInvoicesShipmentsListAPIRequest {
  /** @format int32 */
  invoiceId?: number
}

export interface MainStemAPIPlatformControllersPurchasingInvoicesShipmentsListAPIResponse {
  shipments?: MainStemAPIPlatformControllersPurchasingInvoicesShipmentsListAPIResponseShipmentDetails[]
  message?: string
  wasSuccessful?: boolean
}

export interface MainStemAPIPlatformControllersPurchasingInvoicesShipmentsListAPIResponseShipmentDetails {
  carrier?: string
  /** @format int32 */
  id?: number
  method?: string
  trackingNumber?: string
  /**
   * @format uuid
   * @example "00000000-0000-0000-0000-000000000000"
   */
  uuid?: string
}

export interface MainStemAPIPlatformControllersPurchasingInvoicesUpdateAPIRequest {
  /** @format date-time */
  dateShipped?: string
  /** @format int32 */
  invoiceId?: number
}

export interface MainStemAPIPlatformControllersPurchasingInvoicesUpdateAPIResponse {
  message?: string
  wasSuccessful?: boolean
}

export interface MainStemAPIPlatformControllersPurchasingLocationsApprovalWorkflowSuperApproverAddAPIRequest {
  /** @format int32 */
  locationId?: number
  userId?: string
}

export interface MainStemAPIPlatformControllersPurchasingLocationsApprovalWorkflowSuperApproverAddAPIResponse {
  message?: string
  wasSuccessful?: boolean
}

export interface MainStemAPIPlatformControllersPurchasingLocationsApprovalWorkflowSuperApproverRemoveAPIRequest {
  /** @format int32 */
  locationId?: number
  userId?: string
}

export interface MainStemAPIPlatformControllersPurchasingLocationsApprovalWorkflowSuperApproverRemoveAPIResponse {
  message?: string
  wasSuccessful?: boolean
}

export interface MainStemAPIPlatformControllersPurchasingLocationBudgetCreateAPIRequest {
  /** @format double */
  budget?: number
  /** @format int32 */
  locationId?: number
  /** @format int32 */
  month?: number
  /** @format int32 */
  year?: number
}

export interface MainStemAPIPlatformControllersPurchasingLocationBudgetCreateAPIResponse {
  /** @format int32 */
  id?: number
  message?: string
  wasSuccessful?: boolean
}

export interface MainStemAPIPlatformControllersPurchasingLocationBudgetListAPIRequest {
  /** @format int32 */
  locationId?: number
}

export interface MainStemAPIPlatformControllersPurchasingLocationBudgetListAPIResponse {
  locationBudgets?: MainStemAPIPlatformControllersPurchasingLocationBudgetListAPIResponseLocationBudgetDetails[]
  message?: string
  wasSuccessful?: boolean
}

export interface MainStemAPIPlatformControllersPurchasingLocationBudgetListAPIResponseLocationBudgetDetails {
  /** @format double */
  budget?: number
  /** @format int32 */
  id?: number
  /** @format int32 */
  month?: number
  /** @format double */
  toDateMonth?: number
  /** @format double */
  toDateYear?: number
  /** @format int32 */
  year?: number
}

export interface MainStemAPIPlatformControllersPurchasingLocationBudgetUpdateAPIRequest {
  /** @format double */
  budget?: number
  /** @format int32 */
  id?: number
}

export interface MainStemAPIPlatformControllersPurchasingLocationBudgetUpdateAPIResponse {
  message?: string
  wasSuccessful?: boolean
}

export interface MainStemAPIPlatformControllersPurchasingLocationsDepartmentsListAPIRequest {
  /** @format int32 */
  locationId?: number
}

export interface MainStemAPIPlatformControllersPurchasingLocationsDepartmentsListAPIResponse {
  departments?: MainStemAPIPlatformControllersPurchasingLocationsDepartmentsListAPIResponseDepartmentDetails[]
  message?: string
  wasSuccessful?: boolean
}

export interface MainStemAPIPlatformControllersPurchasingLocationsDepartmentsListAPIResponseDepartmentDetails {
  /** @format int32 */
  id?: number
  name?: string
}

export interface MainStemAPIPlatformControllersPurchasingLocationsDetailsActivityLogAPIRequest {
  /** @format int32 */
  locationId?: number
}

export interface MainStemAPIPlatformControllersPurchasingLocationsDetailsActivityLogAPIResponse {
  activities?: MainStemAPIPlatformControllersPurchasingLocationsDetailsActivityLogAPIResponseActivityLogDetails[]
  message?: string
  wasSuccessful?: boolean
}

export interface MainStemAPIPlatformControllersPurchasingLocationsDetailsActivityLogAPIResponseActivityLogDetails {
  content?: string
  /** @format date-time */
  dateCreated?: string
  /** @format int32 */
  id?: number
  read?: boolean
  type?: string
  typeID?: string
}

export interface MainStemAPIPlatformControllersPurchasingLocationsDetailsAddressBookAPIRequest {
  /** @format int32 */
  locationId?: number
}

export interface MainStemAPIPlatformControllersPurchasingLocationsDetailsAddressBookAPIResponse {
  addresses?: MainStemAPIPlatformControllersPurchasingLocationsDetailsAddressBookAPIResponseAddressDetails[]
  message?: string
  wasSuccessful?: boolean
}

export interface MainStemAPIPlatformControllersPurchasingLocationsDetailsAddressBookAPIResponseAddressDetails {
  address1?: string
  address2?: string
  city?: string
  country?: string
  /** @format int32 */
  id?: number
  name?: string
  shared?: boolean
  state?: string
  zip?: string
}

export interface MainStemAPIPlatformControllersPurchasingLocationsDetailsOrdersAPIRequest {
  /** @format int32 */
  locationId?: number
}

export interface MainStemAPIPlatformControllersPurchasingLocationsDetailsOrdersAPIResponse {
  orders?: MainStemAPIPlatformControllersPurchasingLocationsDetailsOrdersAPIResponseOrderDetails[]
  message?: string
  wasSuccessful?: boolean
}

export interface MainStemAPIPlatformControllersPurchasingLocationsDetailsOrdersAPIResponseOrderDetails {
  /** @format date-time */
  dateApproved?: string
  /** @format date-time */
  dateCreated?: string
  /** @format int32 */
  id?: number
  name?: string
  status?: 'New' | 'PendingApproval' | 'Returned' | 'Approved' | 'Rejected' | 'Cancelled'
  userApprovedBy?: string
  userCreatedBy?: string
  /**
   * @format uuid
   * @example "00000000-0000-0000-0000-000000000000"
   */
  uuid?: string
}

export interface MainStemAPIPlatformControllersPurchasingLocationsDetailsProductFinancialDimensionCreateAPIRequest {
  /** @format int32 */
  financialDimensionId: number
  isRequired: boolean
  /** @format int32 */
  locationId: number
  showOnInvoicePDF: boolean
  showOnOrderPDF: boolean
}

export interface MainStemAPIPlatformControllersPurchasingLocationsDetailsProductFinancialDimensionCreateAPIResponse {
  message?: string
  wasSuccessful?: boolean
}

export interface MainStemAPIPlatformControllersPurchasingLocationsDetailsProductFinancialDimensionDeleteAPIRequest {
  /** @format int32 */
  id?: number
}

export interface MainStemAPIPlatformControllersPurchasingLocationsDetailsProductFinancialDimensionDeleteAPIResponse {
  message?: string
  wasSuccessful?: boolean
}

export interface MainStemAPIPlatformControllersPurchasingLocationsDetailsProductFinancialDimensionUpdateAPIRequest {
  /** @format int32 */
  id: number
  isRequired: boolean
  showOnInvoicePDF: boolean
  showOnOrderPDF: boolean
}

export interface MainStemAPIPlatformControllersPurchasingLocationsDetailsProductFinancialDimensionUpdateAPIResponse {
  message?: string
  wasSuccessful?: boolean
}

export interface MainStemAPIPlatformControllersPurchasingLocationsDetailsShipmentsAPIRequest {
  /** @format int32 */
  locationId?: number
}

export interface MainStemAPIPlatformControllersPurchasingLocationsDetailsShipmentsAPIResponse {
  shipments?: MainStemAPIPlatformControllersPurchasingLocationsDetailsShipmentsAPIResponseShipmentDetails[]
  message?: string
  wasSuccessful?: boolean
}

export interface MainStemAPIPlatformControllersPurchasingLocationsDetailsShipmentsAPIResponseShipmentDetails {
  carrier?: string
  carrierType?: string
  /** @format date-time */
  dateCreated?: string
  /** @format date-time */
  dateReceived?: string
  /** @format date-time */
  dateShippedOn?: string
  /** @format date-time */
  estimatedDeliveryDate?: string
  /** @format int32 */
  orderID?: number
  orderUUID?: string
  trackingNumber?: string
  uuid?: string
}

export interface MainStemAPIPlatformControllersPurchasingLocationsDetailsSupplierFinancialDimensionCreateAPIRequest {
  /** @format int32 */
  financialDimensionId?: number
  /** @format int32 */
  locationId?: number
  showOnInvoicePDF?: boolean
  showOnOrderPDF?: boolean
}

export interface MainStemAPIPlatformControllersPurchasingLocationsDetailsSupplierFinancialDimensionCreateAPIResponse {
  message?: string
  wasSuccessful?: boolean
}

export interface MainStemAPIPlatformControllersPurchasingLocationsDetailsSupplierFinancialDimensionDeleteAPIRequest {
  /** @format int32 */
  id?: number
}

export interface MainStemAPIPlatformControllersPurchasingLocationsDetailsSupplierFinancialDimensionDeleteAPIResponse {
  message?: string
  wasSuccessful?: boolean
}

export interface MainStemAPIPlatformControllersPurchasingLocationsDetailsSupplierFinancialDimensionUpdateAPIRequest {
  /** @format int32 */
  id?: number
  showOnInvoicePDF?: boolean
  showOnOrderPDF?: boolean
}

export interface MainStemAPIPlatformControllersPurchasingLocationsDetailsSupplierFinancialDimensionUpdateAPIResponse {
  message?: string
  wasSuccessful?: boolean
}

export interface MainStemAPIPlatformControllersPurchasingLocationsDetailsSupplyAuditReportsAPIRequest {
  /** @format int32 */
  locationId?: number
}

export interface MainStemAPIPlatformControllersPurchasingLocationsDetailsSupplyAuditReportsAPIResponse {
  supplyAuditReports?: MainStemAPIPlatformControllersPurchasingLocationsDetailsSupplyAuditReportsAPIResponseSupplyAuditReportDetails[]
  message?: string
  wasSuccessful?: boolean
}

export interface MainStemAPIPlatformControllersPurchasingLocationsDetailsSupplyAuditReportsAPIResponseSupplyAuditReportDetails {
  /** @format date-time */
  date?: string
  /** @format int32 */
  month?: number
  /** @format int32 */
  year?: number
}

export interface MainStemAPIPlatformControllersPurchasingLocationsDetailsUsersAPIRequest {
  /** @format int32 */
  locationId?: number
}

export interface MainStemAPIPlatformControllersPurchasingLocationsDetailsUsersAPIResponse {
  users?: MainStemAPIPlatformControllersPurchasingLocationsDetailsUsersAPIResponseUserDetails[]
  message?: string
  wasSuccessful?: boolean
}

export interface MainStemAPIPlatformControllersPurchasingLocationsDetailsUsersAPIResponseUserDetails {
  /** @format date-time */
  dateCreated?: string
  email?: string
  friendlyName?: string
  id?: string
  role?: string
  username?: string
  permissionGroup?: string
  isPrimary?: boolean
}

export interface MainStemAPIPlatformControllersPurchasingLocationsCreateAPIRequest {
  address1?: string
  address2?: string
  city?: string
  country?: string
  email?: string
  name?: string
  phone?: string
  state?: string
  tag?: string
  zip?: string
  financialDimensions?: MainStemAPIPlatformControllersPurchasingLocationsCreateAPIRequestFinancialDimensionUpdate[]
}

export interface MainStemAPIPlatformControllersPurchasingLocationsCreateAPIRequestFinancialDimensionUpdate {
  /** @format int32 */
  financialDimensionID?: number
  /** @format int32 */
  financialDimensionOptionID?: number
}

export interface MainStemAPIPlatformControllersPurchasingLocationsCreateAPIResponse {
  /** @format int32 */
  id?: number
  message?: string
  wasSuccessful?: boolean
}

export interface MainStemAPIPlatformControllersPurchasingLocationsDeleteAPIRequest {
  /** @format int32 */
  locationId?: number
}

export interface MainStemAPIPlatformControllersPurchasingLocationsDeleteAPIResponse {
  message?: string
  wasSuccessful?: boolean
}

export interface MainStemAPIPlatformControllersPurchasingLocationsDetailsAPIRequest {
  /** @format int32 */
  id?: number
}

export interface MainStemAPIPlatformControllersPurchasingLocationsDetailsAPIResponse {
  address1?: string
  address2?: string
  addressBillTo?: MainStemAPIPlatformControllersPurchasingLocationsDetailsAPIResponseAddressDetails
  addressPhysical?: MainStemAPIPlatformControllersPurchasingLocationsDetailsAPIResponseAddressDetails
  addressShipTo?: MainStemAPIPlatformControllersPurchasingLocationsDetailsAPIResponseAddressDetails
  city?: string
  country?: string
  email?: string
  enableSendInvoiceEmails?: boolean
  federalBusinessNumber?: string
  financialDimensions?: MainStemSDKHelpersFinancialDimensionsFactoryFinancialDimensionOptionSelectionDetail[]
  freightContactEmail?: string
  freightContactFirstName?: string
  freightContactLastName?: string
  freightContactPhone?: string
  freightLiftGateRequired?: boolean
  freightNotes?: string
  headerURL?: string
  /** @format int32 */
  id?: number
  integrations?: MainStemAPIPlatformControllersPurchasingLocationsDetailsAPIResponseIntegrationDetails
  isArchived?: boolean
  localBusinessNumber?: string
  logoURL?: string
  name?: string
  pdfFileLogoURL?: string
  pdfHeaderInformation?: string
  /** @format int32 */
  pdfLogoHeight?: number
  pdfTermsAndConditions?: string
  pdfTitleInvoice?: string
  pdfTitlePurchaseOrder?: string
  pdfTitleRequisition?: string
  phone?: string
  privateSupplierNewOrderEmailNotificationCC?: string
  productFinancialDimensions?: MainStemAPIPlatformControllersPurchasingLocationsDetailsAPIResponseProductFinancialDimensionDetails[]
  sendInvoiceEmailsAddresses?: string
  shippingAppointmentRequired?: boolean
  shippingDriverAssistanceRequired?: boolean
  shippingEquipmentLength?: string
  shippingEquipmentType?: string
  shippingForkliftOnSite?: boolean
  shippingGatedFacility?: boolean
  shippingInsideDelivery?: boolean
  state?: string
  supplierFinancialDimensions?: MainStemAPIPlatformControllersPurchasingLocationsDetailsAPIResponseSupplierFinancialDimensionDetails[]
  tags?: string[]
  uuid?: string
  zip?: string
  message?: string
  wasSuccessful?: boolean
}

export interface MainStemAPIPlatformControllersPurchasingLocationsDetailsAPIResponseAddressDetails {
  address1?: string
  address2?: string
  city?: string
  country?: string
  name?: string
  state?: string
  zip?: string
}

export interface MainStemAPIPlatformControllersPurchasingLocationsDetailsAPIResponseIntegrationDetails {
  quantumLeaf?: MainStemAPIPlatformControllersPurchasingLocationsDetailsAPIResponseIntegrationDetailsQuantumLeafDetails
}

export interface MainStemAPIPlatformControllersPurchasingLocationsDetailsAPIResponseProductFinancialDimensionDetails {
  financialDimension?: MainStemAPIPlatformControllersPurchasingLocationsDetailsAPIResponseProductFinancialDimensionDetailsFinancialDimensionDetails
  /** @format int32 */
  id?: number
  isRequired: boolean
  showOnInvoicePDF?: boolean
  showOnOrderPDF?: boolean
}

export interface MainStemAPIPlatformControllersPurchasingLocationsDetailsAPIResponseSupplierFinancialDimensionDetails {
  financialDimension?: MainStemAPIPlatformControllersPurchasingLocationsDetailsAPIResponseSupplierFinancialDimensionDetailsFinancialDimensionDetails
  /** @format int32 */
  id?: number
  showOnInvoicePDF?: boolean
  showOnOrderPDF?: boolean
}

export interface MainStemAPIPlatformControllersPurchasingLocationsDetailsAPIResponseIntegrationDetailsQuantumLeafDetails {
  /** @format int32 */
  defaultLocationSupplierFinancialDimensionId?: number
}

export interface MainStemAPIPlatformControllersPurchasingLocationsDetailsAPIResponseProductFinancialDimensionDetailsFinancialDimensionDetails {
  /** @format int32 */
  id?: number
  label?: string
}

export interface MainStemAPIPlatformControllersPurchasingLocationsDetailsAPIResponseSupplierFinancialDimensionDetailsFinancialDimensionDetails {
  /** @format int32 */
  id?: number
  label?: string
}

export interface MainStemAPIPlatformControllersPurchasingLocationsDetailsCatalogsAPIRequest {
  /** @format int32 */
  locationId?: number
}

export interface MainStemAPIPlatformControllersPurchasingLocationsDetailsCatalogsAPIResponse {
  productLists?: MainStemAPIPlatformControllersPurchasingLocationsDetailsCatalogsAPIResponseProductListDetails[]
  message?: string
  wasSuccessful?: boolean
}

export interface MainStemAPIPlatformControllersPurchasingLocationsDetailsCatalogsAPIResponseProductListDetails {
  /** @format int32 */
  id?: number
  name?: string
}

export interface MainStemAPIPlatformControllersPurchasingLocationsDetailsSalesTaxAPIRequest {
  /** @format int32 */
  locationId: number
}

export interface MainStemAPIPlatformControllersPurchasingLocationsDetailsSalesTaxAPIResponse {
  customer: AvalaraAvaTaxRestClientCustomerModel
  message?: string
  wasSuccessful?: boolean
}

export interface AvalaraAvaTaxRestClientCustomerModel {
  /** @format int32 */
  id?: number
  /** @format int32 */
  companyId?: number
  customerCode?: string
  alternateId?: string
  name?: string
  attnName?: string
  line1?: string
  line2?: string
  city?: string
  postalCode?: string
  phoneNumber?: string
  faxNumber?: string
  emailAddress?: string
  contactName?: string
  /** @format date-time */
  lastTransaction?: string
  /** @format date-time */
  createdDate?: string
  /** @format date-time */
  modifiedDate?: string
  country?: string
  region?: string
  isBill?: boolean
  isShip?: boolean
  taxpayerIdNumber?: string
  certificates?: AvalaraAvaTaxRestClientCertificateModel[]
  customFields?: AvalaraAvaTaxRestClientCustomFieldModel[]
  exposureZones?: AvalaraAvaTaxRestClientExposureZoneModel[]
  billTos?: AvalaraAvaTaxRestClientCustomerModel[]
  shipTos?: AvalaraAvaTaxRestClientCustomerModel[]
  attributes?: AvalaraAvaTaxRestClientCustomerAttributeModel[]
  activeCertificates?: AvalaraAvaTaxRestClientActiveCertificateModel[]
  histories?: AvalaraAvaTaxRestClientHistoryModel[]
  logs?: AvalaraAvaTaxRestClientCertificateLogModel[]
  shipToStates?: AvalaraAvaTaxRestClientStateModel[]
}

export interface AvalaraAvaTaxRestClientCertificateModel {
  /** @format int32 */
  id?: number
  /** @format int32 */
  companyId?: number
  /** @format date-time */
  signedDate?: string
  /** @format date-time */
  expirationDate?: string
  filename?: string
  documentExists?: boolean
  valid?: boolean
  verified?: boolean
  /** @format double */
  exemptPercentage?: number
  isSingleCertificate?: boolean
  exemptionNumber?: string
  validatedExemptionReason?: AvalaraAvaTaxRestClientExemptionReasonModel
  exemptionReason?: AvalaraAvaTaxRestClientExemptionReasonModel
  status?: string
  ecmStatus?: 'None' | 'Expired' | 'Invalid' | 'Valid' | 'PendingFuture'
  /** @format date-time */
  createdDate?: string
  /** @format date-time */
  modifiedDate?: string
  taxNumberType?: string
  businessNumberType?: string
  /** @format int32 */
  pageCount?: number
  customers?: AvalaraAvaTaxRestClientCustomerModel[]
  poNumbers?: AvalaraAvaTaxRestClientPoNumberModel[]
  exposureZone?: AvalaraAvaTaxRestClientExposureZoneModel
  exposureZoneName?: string
  jurisdictions?: AvalaraAvaTaxRestClientCertificateJurisdictionModel[]
  attributes?: AvalaraAvaTaxRestClientCertificateAttributeModel[]
  histories?: AvalaraAvaTaxRestClientHistoryModel[]
  jobs?: AvalaraAvaTaxRestClientCertificateJobModel[]
  logs?: AvalaraAvaTaxRestClientCertificateLogModel[]
  invalidReasons?: AvalaraAvaTaxRestClientCertificateInvalidReasonModel[]
  customFields?: AvalaraAvaTaxRestClientCustomFieldModel[]
  /** @format int32 */
  ecmsId?: number
  ecmsStatus?: string
  pdf?: string
  pages?: string[]
}

export interface AvalaraAvaTaxRestClientCustomFieldModel {
  /** @format int32 */
  id?: number
  name?: string
  type?: string
  possibleValues?: string
  usesDataEntry?: boolean
  requiredInDataEntry?: boolean
  value?: string
}

export interface AvalaraAvaTaxRestClientExposureZoneModel {
  /** @format int32 */
  id?: number
  /** @format int32 */
  companyId?: number
  name?: string
  tag?: string
  description?: string
  /** @format date-time */
  created?: string
  /** @format date-time */
  modified?: string
  region?: string
  country?: string
}

export interface AvalaraAvaTaxRestClientCustomerAttributeModel {
  /** @format int32 */
  id?: number
  name?: string
  description?: string
  isSystemCode?: boolean
  isNonDeliver?: boolean
  isChangeable?: boolean
}

export interface AvalaraAvaTaxRestClientActiveCertificateModel {
  /** @format int64 */
  id?: number
  /** @format date-time */
  created?: string
  /** @format date-time */
  modified?: string
  expectedTaxNumber?: string
  actualTaxNumber?: string
  exposureZone?: AvalaraAvaTaxRestClientExposureZoneModel
  expectedTaxCode?: AvalaraAvaTaxRestClientExemptionReasonModel
  actualTaxCode?: AvalaraAvaTaxRestClientExemptionReasonModel
  certificate?: AvalaraAvaTaxRestClientCertificateModel
}

export interface AvalaraAvaTaxRestClientHistoryModel {
  /** @format int32 */
  id?: number
  account?: string
  field?: string
  oldValue?: string
  newValue?: string
  /** @format date-time */
  created?: string
}

export interface AvalaraAvaTaxRestClientCertificateLogModel {
  /** @format int64 */
  id?: number
  /** @format int64 */
  certificateId?: number
  account?: string
  entry?: string
  /** @format date-time */
  created?: string
}

export interface AvalaraAvaTaxRestClientStateModel {
  /** @format int32 */
  id?: number
  name?: string
  initials?: string
  /** @format int32 */
  geoCode?: number
  country?: AvalaraAvaTaxRestClientCountryModel
}

export interface AvalaraAvaTaxRestClientExemptionReasonModel {
  /** @format int32 */
  id?: number
  name?: string
}

export interface AvalaraAvaTaxRestClientPoNumberModel {
  /** @format int32 */
  id?: number
  poNumber?: string
}

export interface AvalaraAvaTaxRestClientCertificateJurisdictionModel {
  /** @format int32 */
  id?: number
  type?: string
  name?: string
  code?: string
  isSalesTaxApplicable?: boolean
  taxTypeMappings?: AvalaraAvaTaxRestClientCertificateJurisdictionTaxMappingModel[]
}

export interface AvalaraAvaTaxRestClientCertificateAttributeModel {
  /** @format int32 */
  id?: number
  name?: string
  description?: string
  isSystemCode?: boolean
}

export interface AvalaraAvaTaxRestClientCertificateJobModel {
  isExplicit?: boolean
  isDirect?: boolean
  /** @format int32 */
  id?: number
  name?: string
  jobNumber?: string
  exposureZoneName?: string
  phases?: AvalaraAvaTaxRestClientJobPhaseModel[]
}

export interface AvalaraAvaTaxRestClientCertificateInvalidReasonModel {
  /** @format int32 */
  id?: number
  name?: string
  description?: string
  systemCode?: boolean
}

export interface AvalaraAvaTaxRestClientCountryModel {
  /** @format int32 */
  id?: number
  name?: string
  initials?: string
  abbreviation?: string
}

export interface AvalaraAvaTaxRestClientCertificateJurisdictionTaxMappingModel {
  /** @format int32 */
  id?: number
  /** @format int32 */
  taxTypeId?: number
  taxType?: string
  /** @format int32 */
  subTaxTypeId?: number
  subTaxType?: string
  /** @format int32 */
  sourceMappingId?: number
}

export interface AvalaraAvaTaxRestClientJobPhaseModel {
  /** @format int32 */
  id?: number
  name?: string
  /** @format int32 */
  jobId?: number
  phaseCode?: string
  /** @format date-time */
  createdDate?: string
  /** @format date-time */
  modifiedDate?: string
  tasks?: AvalaraAvaTaxRestClientJobTaskModel[]
}

export interface AvalaraAvaTaxRestClientJobTaskModel {
  /** @format int32 */
  id?: number
  /** @format int32 */
  phaseId?: number
  name?: string
  taskCode?: string
  /** @format date-time */
  createdDate?: string
  /** @format date-time */
  modifiedDate?: string
}

export interface MainStemAPIPlatformControllersPurchasingLocationsDuplicateAPIRequest {
  copyUsers?: boolean
  /** @format int32 */
  locationId?: number
  name?: string
}

export interface MainStemAPIPlatformControllersPurchasingLocationsDuplicateAPIResponse {
  /** @format int32 */
  locationId?: number
  message?: string
  wasSuccessful?: boolean
}

export interface MainStemAPIPlatformControllersPurchasingLocationsIntegrationsQuantumLeafUpdateAPIRequest {
  /** @format int32 */
  locationID?: number
  /** @format int32 */
  locationSupplierFinancialDimensionID?: number
}

export interface MainStemAPIPlatformControllersPurchasingLocationsIntegrationsQuantumLeafUpdateAPIResponse {
  message?: string
  wasSuccessful?: boolean
}

export interface MainStemAPIPlatformControllersPurchasingLocationsListAPIResponse {
  locations: MainStemAPIPlatformControllersPurchasingLocationsListAPIResponseLocationDetails[]
  message?: string
  wasSuccessful?: boolean
}

export interface MainStemAPIPlatformControllersPurchasingLocationsListAPIResponseLocationDetails {
  freightContact?: MainStemAPIPlatformControllersPurchasingLocationsListAPIResponseFreightContactDetails
  address1?: string
  address2?: string
  city?: string
  country?: string
  headerURL?: string
  /** @format int32 */
  id: number
  isArchived: boolean
  logoURL?: string
  name?: string
  state?: string
  tags?: string[]
  userRelated: boolean
  uuid?: string
  zip?: string
}

export interface MainStemAPIPlatformControllersPurchasingLocationsListAPIResponseFreightContactDetails {
  email?: string
  firstName?: string
  lastName?: string
  phone?: string
}

export interface MainStemAPIPlatformControllersPurchasingLocationsUpdateAPIRequest {
  address1?: string
  address2?: string
  city?: string
  country?: string
  email?: string
  enableSendInvoiceEmails?: boolean
  federalBusinessNumber?: string
  financialDimensions?: MainStemAPIPlatformControllersPurchasingLocationsUpdateAPIRequestFinancialDimensionUpdate[]
  freightContactEmail?: string
  freightContactFirstName?: string
  freightContactLastName?: string
  freightContactPhone?: string
  freightLiftGateRequired?: boolean
  freightNotes?: string
  /** @format int32 */
  id?: number
  localBusinessNumber?: string
  name?: string
  pdfHeaderInformation?: string
  /** @format int32 */
  pdfLogoHeight?: number
  pdfTermsAndConditions?: string
  pdfTitleInvoice?: string
  pdfTitlePurchaseOrder?: string
  pdfTitleRequisition?: string
  phone?: string
  privateSupplierNewOrderEmailNotificationCC?: string
  sendInvoiceEmailsAddresses?: string
  shippingAppointmentRequired?: boolean
  shippingDriverAssistanceRequired?: boolean
  shippingEquipmentLength?: string
  shippingEquipmentType?: string
  shippingForkliftOnSite?: boolean
  shippingGatedFacility?: boolean
  shippingInsideDelivery?: boolean
  state?: string
  tag?: string
  zip?: string
}

export interface MainStemAPIPlatformControllersPurchasingLocationsUpdateAPIRequestFinancialDimensionUpdate {
  /** @format int32 */
  financialDimensionID?: number
  /** @format int32 */
  financialDimensionOptionID?: number
}

export interface MainStemAPIPlatformControllersPurchasingLocationsUpdateAddressAPIRequest {
  addressType?: 'Physical' | 'Billing' | 'Shipping'
  /** @format int32 */
  locationId?: number
  /** @format int32 */
  addressId?: number
}

export interface MainStemAPIPlatformControllersPurchasingLocationSupplierFinancialDimensionListAPIResponse {
  locationSupplierFinancialDimensions?: MainStemAPIPlatformControllersPurchasingLocationSupplierFinancialDimensionListAPIResponseLocationSupplierFinancialDimensionDetails[]
  message?: string
  wasSuccessful?: boolean
}

export interface MainStemAPIPlatformControllersPurchasingLocationSupplierFinancialDimensionListAPIResponseLocationSupplierFinancialDimensionDetails {
  financialDimension?: MainStemAPIPlatformControllersPurchasingLocationSupplierFinancialDimensionListAPIResponseLocationSupplierFinancialDimensionDetailsFinancialDimensionDetails
  /** @format int32 */
  id?: number
  location?: MainStemAPIPlatformControllersPurchasingLocationSupplierFinancialDimensionListAPIResponseLocationSupplierFinancialDimensionDetailsLocationDetails
}

export interface MainStemAPIPlatformControllersPurchasingLocationSupplierFinancialDimensionListAPIResponseLocationSupplierFinancialDimensionDetailsFinancialDimensionDetails {
  /** @format int32 */
  id?: number
  label?: string
}

export interface MainStemAPIPlatformControllersPurchasingLocationSupplierFinancialDimensionListAPIResponseLocationSupplierFinancialDimensionDetailsLocationDetails {
  /** @format int32 */
  id?: number
  name?: string
}

export interface MainStemAPIPlatformControllersPurchasingMakePaymentsInvoiceAPIRequest {
  /** @format int32 */
  paymentMethodId?: number
  payments?: MainStemAPIPlatformControllersPurchasingMakePaymentsInvoiceAPIRequestPaymentDetails[]
}

export interface MainStemAPIPlatformControllersPurchasingMakePaymentsInvoiceAPIRequestPaymentDetails {
  accountNumber?: string
  /** @format double */
  amount?: number
  bankName?: string
  customerTaxId?: string
  /** @format int32 */
  fulfillmentId?: number
  invoiceId?: string
  isACH?: boolean
  /** @format int32 */
  paymentMethodId?: number
  routingNumber?: string
  type?: string
}

export interface MainStemAPIPlatformControllersPurchasingMakePaymentsInvoiceAPIResponse {
  invoices?: MainStemAPIPlatformControllersPurchasingMakePaymentsInvoiceAPIResponseInvoicePaymentDetail[]
  message?: string
  wasSuccessful?: boolean
}

export interface MainStemAPIPlatformControllersPurchasingMakePaymentsInvoiceAPIResponseInvoicePaymentDetail {
  wasSuccessful?: boolean
  /** @format double */
  amount?: number
  error?: string
  /** @format int32 */
  fulfillmentId?: number
  invoiceId?: string
  /** @format int32 */
  orderId?: number
  uuid?: string
  orderUUID?: string
  /** @format int32 */
  paymentTransactionID?: number
}

export interface MainStemAPIPlatformControllersPurchasingMakePaymentsOrderAPIRequest {
  /** @format int32 */
  paymentMethodId?: number
  payments?: MainStemAPIPlatformControllersPurchasingMakePaymentsOrderAPIRequestPaymentDetails[]
}

export interface MainStemAPIPlatformControllersPurchasingMakePaymentsOrderAPIRequestPaymentDetails {
  accountNumber?: string
  /** @format double */
  amount?: number
  bankName?: string
  customerTaxId?: string
  isACH?: boolean
  /** @format int32 */
  orderId?: number
  /** @format int32 */
  paymentMethodId?: number
  routingNumber?: string
  type?: string
}

export interface MainStemAPIPlatformControllersPurchasingMakePaymentsOrderAPIResponse {
  invoices?: MainStemAPIPlatformControllersPurchasingMakePaymentsOrderAPIResponseOrderPaymentDetail[]
  message?: string
  wasSuccessful?: boolean
}

export interface MainStemAPIPlatformControllersPurchasingMakePaymentsOrderAPIResponseOrderPaymentDetail {
  wasSuccessful?: boolean
  /** @format double */
  amount?: number
  error?: string
  uuid?: string
  /** @format int32 */
  orderId?: number
  /** @format int32 */
  paymentTransactionID?: number
}

export interface MainStemAPIPlatformControllersPurchasingOmniSearchAutoCompleteAPIRequest {
  query: string
}

export interface MainStemAPIPlatformControllersPurchasingOmniSearchAutoCompleteAPIResponse {
  catalogs: MainStemAPIPlatformControllersAdminOmniSearchOmniSearchNamedHit[]
  departments: MainStemAPIPlatformControllersAdminOmniSearchOmniSearchNamedHit[]
  invoices: MainStemAPIPlatformControllersAdminOmniSearchOmniSearchNamedHit[]
  locations: MainStemAPIPlatformControllersAdminOmniSearchOmniSearchNamedHit[]
  products: MainStemAPIPlatformControllersAdminOmniSearchOmniSearchProductHit[]
  requisitions: MainStemAPIPlatformControllersAdminOmniSearchOmniSearchNamedHit[]
  rfqs: MainStemAPIPlatformControllersAdminOmniSearchOmniSearchNamedHit[]
  shipments: MainStemAPIPlatformControllersAdminOmniSearchOmniSearchShipmentHit[]
  suppliers: MainStemAPIPlatformControllersAdminOmniSearchOmniSearchSupplierHit[]
  users: MainStemAPIPlatformControllersAdminOmniSearchOmniSearchUserHit[]
  message?: string
  wasSuccessful?: boolean
}

export interface MainStemAPIPlatformControllersAdminOmniSearchOmniSearchNamedHit {
  /** @format int32 */
  id: number
  name: string
  uuid?: string
  image?: string
}

export interface MainStemAPIPlatformControllersAdminOmniSearchOmniSearchProductHit {
  /** @format int32 */
  id: number
  name: string
  supplier?: MainStemAPIPlatformControllersAdminOmniSearchOmniSearchSupplierRef
  showInStore?: boolean
  image?: string
}

export interface MainStemAPIPlatformControllersAdminOmniSearchOmniSearchShipmentHit {
  /** @format int32 */
  id: number
  name: string
  uuid?: string
  trackingNumber?: string
  carrier?: string
}

export interface MainStemAPIPlatformControllersAdminOmniSearchOmniSearchSupplierHit {
  /** @format int32 */
  id: number
  name: string
  uuid?: string
  image?: string
  isPrivate: boolean
}

export interface MainStemAPIPlatformControllersAdminOmniSearchOmniSearchUserHit {
  /** @format int32 */
  id: number
  uuid?: string
  name: string
  username?: string
  image?: string
}

export interface MainStemAPIPlatformControllersAdminOmniSearchOmniSearchSupplierRef {
  /** @format int32 */
  id: number
  name: string
  isPrivate: boolean
}

export interface MainStemAPIPlatformControllersPurchasingOmniSearchSearchAPIRequest {
  query: string
}

export interface MainStemAPIPlatformControllersPurchasingOmniSearchSearchAPIResponse {
  catalogs: MainStemAPIPlatformControllersAdminOmniSearchOmniSearchNamedHit[]
  departments: MainStemAPIPlatformControllersAdminOmniSearchOmniSearchNamedHit[]
  invoices: MainStemAPIPlatformControllersAdminOmniSearchOmniSearchNamedHit[]
  locations: MainStemAPIPlatformControllersAdminOmniSearchOmniSearchNamedHit[]
  products: MainStemAPIPlatformControllersAdminOmniSearchOmniSearchProductHit[]
  requisitions: MainStemAPIPlatformControllersAdminOmniSearchOmniSearchNamedHit[]
  rfqs: MainStemAPIPlatformControllersAdminOmniSearchOmniSearchNamedHit[]
  shipments: MainStemAPIPlatformControllersAdminOmniSearchOmniSearchShipmentHit[]
  suppliers: MainStemAPIPlatformControllersAdminOmniSearchOmniSearchSupplierHit[]
  users: MainStemAPIPlatformControllersAdminOmniSearchOmniSearchUserHit[]
  message?: string
  wasSuccessful?: boolean
}

export interface MainStemAPIPlatformControllersPurchasingOrdersCommunicationPurchasingOrderCommunicationActionResolvedControllerAPIRequest {
  comment?: string
  createResolutionCommunication?: boolean
  /** @format int32 */
  id?: number
  requiresAction?: boolean
}

export interface MainStemAPIPlatformControllersPurchasingOrdersCommunicationPurchasingOrderCommunicationActionResolvedControllerAPIResponse {
  error?: string
  message?: string
  wasSuccessful?: boolean
}

export interface MainStemAPIPlatformControllersPurchasingOrdersCommunicationPurchasingOrderCommunicationCreateControllerAPIRequest {
  /** @format int32 */
  businessPartnerId?: number
  comment?: string
  /** @format int32 */
  fulfillmentMethodId?: number
  /** @format int32 */
  orderId?: number
  requiresAction?: boolean
}

export interface MainStemAPIPlatformControllersPurchasingOrdersCommunicationPurchasingOrderCommunicationCreateControllerAPIResponse {
  error?: string
  /** @format int32 */
  id?: number
  message?: string
  wasSuccessful?: boolean
}

export interface MainStemAPIPlatformControllersPurchasingOrdersCommunicationPurchasingOrderCommunicationForFulfillmentControllerAPIResponse {
  communications?: MainStemAPIPlatformControllersPurchasingOrdersCommunicationPurchasingOrderCommunicationForFulfillmentControllerOrderCommunicationData[]
  error?: string
  message?: string
  wasSuccessful?: boolean
}

export interface MainStemAPIPlatformControllersPurchasingOrdersCommunicationPurchasingOrderCommunicationForFulfillmentControllerOrderCommunicationData {
  actionResolved?: boolean
  actionResolvedByEmail?: string
  actionResolvedByFriendlyName?: string
  actionResolvedByID?: string
  /** @format int32 */
  businessPartnerID?: number
  businessPartnerName?: string
  comment?: string
  createdByUserEmail?: string
  createdByUserFriendlyName?: string
  /** @format date-time */
  dateCreated?: string
  /** @format date-time */
  dateModified?: string
  /** @format date-time */
  dateResolved?: string
  /** @format int32 */
  fulfillmentMethodID?: number
  fulfillmentMethodUUID?: string
  /** @format int32 */
  id?: number
  isDeleted?: boolean
  /** @format int32 */
  orderID?: number
  requiresAction?: boolean
  userCreatedByID?: string
}

export interface MainStemAPIPlatformControllersPurchasingOrdersCommunicationPurchasingOrderCommunicationForOrderControllerAPIResponse {
  communications?: MainStemAPIPlatformControllersPurchasingOrdersCommunicationPurchasingOrderCommunicationForOrderControllerOrderCommunicationTableData[]
  error?: string
  message?: string
  wasSuccessful?: boolean
}

export interface MainStemAPIPlatformControllersPurchasingOrdersCommunicationPurchasingOrderCommunicationForOrderControllerOrderCommunicationTableData {
  actionResolved?: boolean
  actionResolvedByEmail?: string
  actionResolvedByFriendlyName?: string
  actionResolvedByID?: string
  /** @format int32 */
  businessPartnerID?: number
  businessPartnerName?: string
  comment?: string
  createdByUserEmail?: string
  createdByUserFriendlyName?: string
  /** @format date-time */
  dateCreated?: string
  /** @format date-time */
  dateModified?: string
  /** @format date-time */
  dateResolved?: string
  /** @format int32 */
  fulfillmentMethodID?: number
  fulfillmentMethodUUID?: string
  /** @format int32 */
  id?: number
  isDeleted?: boolean
  /** @format int32 */
  orderID?: number
  requiresAction?: boolean
  userCreatedByID?: string
}

export interface MainStemAPIPlatformControllersPurchasingOrdersCommunicationPurchasingOrderCommunicationRemoveControllerAPIRequest {
  /** @format int32 */
  id?: number
}

export interface MainStemAPIPlatformControllersPurchasingOrdersCommunicationPurchasingOrderCommunicationRemoveControllerAPIResponse {
  error?: string
  message?: string
  wasSuccessful?: boolean
}

export interface MainStemAPIPlatformControllersPurchasingOrdersCommunicationPurchasingOrderCommunicationUpdateControllerAPIRequest {
  comment?: string
  /** @format int32 */
  id?: number
  requiresAction?: boolean
}

export interface MainStemAPIPlatformControllersPurchasingOrdersCommunicationPurchasingOrderCommunicationUpdateControllerAPIResponse {
  error?: string
  message?: string
  wasSuccessful?: boolean
}

export interface MainStemAPIPlatformControllersPurchasingOrdersDuplicateAPIRequest {
  orderUUID?: string
  baseRequest?: object
  /** @format int32 */
  customerID?: number
  /** @format int32 */
  businessPartnerId?: number
  businessPartners?: MainStemSDKDataModelsBusinessPartner[]
  /** @format int32 */
  locationID?: number
  isAdmin?: boolean
}

export interface MainStemAPIPlatformControllersPurchasingOrdersDuplicateAPIResponse {
  orderUUID?: string
  message?: string
  wasSuccessful?: boolean
}

export interface MainStemAPIPlatformControllersPurchasingOrderLineItemCreateAPIRequest {
  /** @format int32 */
  orderId: number
  /** @format int32 */
  productId: number
  /** @format int32 */
  quantity: number
}

export interface MainStemAPIPlatformControllersPurchasingOrderLineItemCreateAPIResponse {
  /**
   * @format uuid
   * @example "00000000-0000-0000-0000-000000000000"
   */
  orderUUID: string
  message?: string
  wasSuccessful?: boolean
}

export interface MainStemAPIPlatformControllersPurchasingOrderLineItemDeleteAPIRequest {
  /** @format int32 */
  orderLineItemId?: number
}

export interface MainStemAPIPlatformControllersPurchasingOrderLineItemUpdateAPIRequest {
  /** @format int32 */
  orderLineItemId?: number
  /** @format double */
  price?: number
  /** @format int32 */
  quantity?: number
}

export interface MainStemAPIPlatformControllersPurchasingOrdersApprovalApproveAPIRequest {
  orderUUID?: string
  /** @format int32 */
  workflowStepID?: number
}

export interface MainStemAPIPlatformControllersPurchasingOrdersApprovalApproveAPIResponse {
  message?: string
  wasSuccessful?: boolean
}

export interface MainStemAPIPlatformControllersPurchasingOrdersApprovalRejectAPIRequest {
  note?: string
  orderUUID?: string
  /** @format int32 */
  workflowStepID?: number
}

export interface MainStemAPIPlatformControllersPurchasingOrdersApprovalRejectAPIResponse {
  message?: string
  wasSuccessful?: boolean
}

export interface MainStemAPIPlatformControllersPurchasingOrdersApprovalRevertAPIRequest {
  orderUUID: string
  reason: string
}

export interface MainStemAPIPlatformControllersPurchasingOrdersApprovalRevertAPIResponse {
  message?: string
  wasSuccessful?: boolean
}

export interface MainStemAPIPlatformControllersPurchasingOrdersApprovalSubmitForApprovalAPIRequest {
  orderUUID?: string
}

export interface MainStemAPIPlatformControllersPurchasingOrdersApprovalSubmitForApprovalAPIResponse {
  message?: string
  wasSuccessful?: boolean
}

export interface MainStemAPIPlatformControllersPurchasingOrdersCancelAPIRequest {
  orderUUID?: string
}

export interface MainStemAPIPlatformControllersPurchasingOrdersCreateAPIRequest {
  /** @format int32 */
  billingAddressId?: number
  /** @format int32 */
  customerSessionID?: number
  /** @format date-time */
  dateRequiredBy?: string
  /** @format int32 */
  locationId?: number
  name?: string
  /** @format double */
  salesTax?: number
  /** @format int32 */
  shippingAddressId?: number
  /** @format double */
  shippingCost?: number
}

export interface MainStemAPIPlatformControllersPurchasingOrdersCreateAPIResponse {
  /** @format int32 */
  orderId?: number
  orderUUID?: string
  message?: string
  wasSuccessful?: boolean
}

export interface MainStemAPIPlatformControllersPurchasingOrdersDetailsAPIRequest {
  uuid?: string
}

export interface MainStemAPIPlatformControllersPurchasingOrdersDetailsAPIResponse {
  sessionDetails?: MainStemAPIPlatformControllersPurchasingOrdersDetailsAPIResponseSessionDetails
  acumaticaSettings?: MainStemAPIPlatformControllersPurchasingOrdersDetailsAPIResponseAcumaticaIntegrationSettings
  alerts?: MainStemAPIPlatformControllersPurchasingOrdersDetailsAPIResponseAlertDetails[]
  allocations?: MainStemAPIPlatformControllersPurchasingOrdersDetailsAPIResponseAllocationsDetails
  approvals?: MainStemAPIPlatformControllersPurchasingOrdersDetailsAPIResponseApprovalDetails
  approvalStatus?: 'SavedCart' | 'AwaitingApproval' | 'Approval' | 'ApprovalWithEdits' | 'Rejected'
  billTo: MainStemAPIPlatformControllersPurchasingOrdersDetailsAPIResponseBillToDetails
  budget?: MainStemAPIPlatformControllersPurchasingOrdersDetailsAPIResponseBudgetDetails
  /** @format int32 */
  customerSessionID?: number
  /** @format date-time */
  dateApproved?: string
  /** @format date-time */
  dateCreated?: string
  /** @format date-time */
  dateRequiredBy?: string
  /** @format date-time */
  dateSubmittedForApproval?: string
  /** @format double */
  discount?: number
  email?: string
  events?: MainStemAPIPlatformControllersPurchasingOrdersDetailsAPIResponseEventDetails[]
  fulfillmentMethods?: MainStemAPIPlatformControllersPurchasingOrdersDetailsAPIResponseFulfillmentVendorDetails[]
  /** @format int32 */
  id: number
  isPrivateOrder?: boolean
  lineItems?: MainStemAPIPlatformControllersPurchasingOrdersDetailsAPIResponseOrderLineItemDetails[]
  location?: MainStemAPIPlatformControllersPurchasingOrdersDetailsAPIResponseLocationDetails
  locationProductFinancialDimensions?: MainStemAPIPlatformControllersPurchasingOrdersDetailsAPIResponseLocationProductFinancialDimension[]
  locationSupplierFinancialDimensions?: MainStemAPIPlatformControllersPurchasingOrdersDetailsAPIResponseLocationSupplierFinancialDimension[]
  name?: string
  /** @format double */
  orderTotal?: number
  paymentStatus?: string
  phone?: string
  purchaseOrders?: MainStemAPIPlatformHelpersPurchaseOrdersResponsePurchaseOrderDetails[]
  dynamicsSettings?: MainStemAPIPlatformControllersPurchasingOrdersDetailsAPIResponseDynamicsIntegrationSettings
  quantumLeafSettings?: MainStemAPIPlatformControllersPurchasingOrdersDetailsAPIResponseQuantumLeafIntegrationSettings
  quickBooksSettings?: MainStemAPIPlatformControllersPurchasingOrdersDetailsAPIResponseQuickbooksIntegrationSettings
  receiving?: MainStemAPIPlatformControllersPurchasingOrdersDetailsAPIResponseReceivingDetails
  requiredLocationProductFinancialDimensionsMet: boolean
  requisitionStatus?: 'New' | 'PendingApproval' | 'Returned' | 'Approved' | 'Rejected' | 'Cancelled'
  requisitionReturnReason?: string
  /** @format double */
  salesTax?: number
  shipments?: MainStemAPIPlatformControllersPurchasingOrdersDetailsAPIResponseShipmentDetails
  /** @format double */
  shipping?: number
  shipTo: MainStemAPIPlatformControllersPurchasingOrdersDetailsAPIResponseShipToDetails
  status?: string
  /** @format double */
  subTotal?: number
  supplierFinancialDimensions?: MainStemAPIPlatformControllersPurchasingOrdersDetailsAPIResponseSupplierFinancialDimension[]
  suppliers?: MainStemAPIPlatformControllersPurchasingOrdersDetailsAPIResponseOrderSupplierDetails[]
  termsOrderDetail?: MainStemAPIPlatformControllersDEPRECATEAppTermsTermsOrderDetailsControllerAPIResponse
  totals: MainStemAPIPlatformControllersPurchasingOrdersDetailsAPIResponseTotalsDetails
  /** @format double */
  totalAtTimeOfApproval?: number
  userApprovedBy?: string
  userCreatedBy?: string
  userSubmittedBy?: string
  uuid?: string
  message?: string
  wasSuccessful?: boolean
}

export interface MainStemAPIPlatformControllersPurchasingOrdersDetailsAPIResponseSessionDetails {
  allowcXMlOrderProcessing?: boolean
  description?: string
  fileUrl?: string
  name?: string
}

export interface MainStemAPIPlatformControllersPurchasingOrdersDetailsAPIResponseAcumaticaIntegrationSettings {
  /** @format int32 */
  customerIntegrationID?: number
  enabled?: boolean
}

export interface MainStemAPIPlatformControllersPurchasingOrdersDetailsAPIResponseAlertDetails {
  action?: string
  content?: string
  type?: string
}

export interface MainStemAPIPlatformControllersPurchasingOrdersDetailsAPIResponseAllocationsDetails {
  completed?: MainStemAPIPlatformControllersPurchasingOrdersDetailsAPIResponseFulfillmentVendorDetailsLineItemDetailsAllocationDetails[]
  needed?: MainStemAPIPlatformControllersPurchasingOrdersDetailsAPIResponseAllocationNeededDetails[]
}

export interface MainStemAPIPlatformControllersPurchasingOrdersDetailsAPIResponseApprovalDetails {
  /** @format int32 */
  activeStepID?: number
  canApproveReject?: boolean
  isFutureSubmitter?: boolean
  isLastApprover?: boolean
  isSuperApprover?: boolean
}

export interface MainStemAPIPlatformControllersPurchasingOrdersDetailsAPIResponseBillToDetails {
  address1?: string
  address2?: string
  city?: string
  country?: string
  /** @format int32 */
  id?: number
  name?: string
  state?: string
  zip?: string
}

export interface MainStemAPIPlatformControllersPurchasingOrdersDetailsAPIResponseBudgetDetails {
  /** @format double */
  currentMTD?: number
  /** @format double */
  currentYTD?: number
  dateBudget?: MainStemAPIPlatformControllersPurchasingOrdersDetailsAPIResponseBudgetDetailsDateDetails
  dateFirstOfMonth?: MainStemAPIPlatformControllersPurchasingOrdersDetailsAPIResponseBudgetDetailsDateDetails
  dateFirstOfYear?: MainStemAPIPlatformControllersPurchasingOrdersDetailsAPIResponseBudgetDetailsDateDetails
  dateLastOfMonth?: MainStemAPIPlatformControllersPurchasingOrdersDetailsAPIResponseBudgetDetailsDateDetails
  dateLastOfYear?: MainStemAPIPlatformControllersPurchasingOrdersDetailsAPIResponseBudgetDetailsDateDetails
  /** @format double */
  totalMTD?: number
  /** @format double */
  totalYTD?: number
}

export interface MainStemAPIPlatformControllersPurchasingOrdersDetailsAPIResponseEventDetails {
  /** @format date-time */
  date?: string
  title?: string
}

export interface MainStemAPIPlatformControllersPurchasingOrdersDetailsAPIResponseFulfillmentVendorDetails {
  acceptanceRequiredEnabled?: boolean
  acceptanceStatus?: 'Cancelled' | 'Pending' | 'Accepted' | 'Rejected'
  acknowledgedBy?: string
  acknowledgedByUserId?: string
  acknowledgementType?: 'MainStemPixel' | 'SupplierCoreOrderDetails' | 'Integration'
  acumaticaIntegration?: MainStemAPIPlatformControllersPurchasingOrdersDetailsAPIResponseAcumaticaIntegration
  /** @format date-time */
  dateAccepted?: string
  /** @format date-time */
  dateAcknowledged?: string
  /** @format date-time */
  dateNotified?: string
  /** @format date-time */
  datePickedOn?: string
  /** @format date-time */
  datePromisedBy?: string
  /** @format date-time */
  dateReceived?: string
  /** @format date-time */
  dateRejected?: string
  /** @format date-time */
  dateShipped?: string
  /** @format date-time */
  dateShippedOn?: string
  /** @format double */
  discount?: number
  /** @format double */
  fees?: number
  /** @format int32 */
  id?: number
  invoiceProblems?: MainStemAPIPlatformControllersPurchasingInvoiceProblemsListAPIResponseInvoiceProblemDetail[]
  invoiceStatusDetail?: MainStemAPIPlatformControllersPurchasingOrdersDetailsAPIResponseFulfillmentVendorDetailsPrivateSupplierInvoiceStatusDetail
  isPrivateSupplier?: boolean
  lineItems?: MainStemAPIPlatformControllersPurchasingOrdersDetailsAPIResponseFulfillmentVendorDetailsLineItemDetails[]
  location?: MainStemAPIPlatformControllersPurchasingOrdersDetailsAPIResponseLocationDetails
  logoURL?: string
  name?: string
  orderCommunications?: MainStemAPIPlatformControllersPurchasingOrdersCommunicationPurchasingOrderCommunicationForFulfillmentControllerOrderCommunicationData[]
  quantumLeafIntegration?: MainStemAPIPlatformControllersPurchasingOrdersDetailsAPIResponseQuantumLeafIntegration
  quickBooksIntegration?: MainStemAPIPlatformControllersPurchasingOrdersDetailsAPIResponseQuickbooksIntegration
  /** @format double */
  salesTax?: number
  shipments?: MainStemAPIPlatformControllersPurchasingOrdersDetailsAPIResponseFulfillmentVendorDetailsShipmentDetails[]
  shipmentType?: string
  /** @format double */
  shipping?: number
  /** @format double */
  subTotal?: number
  supplier?: MainStemAPIPlatformControllersPurchasingOrdersDetailsAPIResponseFulfillmentVendorDetailsSupplierDetails
  taxBreakdownJSON?: string
  /** @format double */
  total?: number
  type?: string
  /**
   * @format uuid
   * @example "00000000-0000-0000-0000-000000000000"
   */
  uuid?: string
}

export interface MainStemAPIPlatformControllersPurchasingOrdersDetailsAPIResponseOrderLineItemDetails {
  hasBeenModified: boolean
  /** @format int32 */
  id: number
  /** @format double */
  price: number
  product: MainStemAPIPlatformControllersPurchasingOrdersDetailsAPIResponseOrderLineItemDetailsProductDetails
  /** @format double */
  quantity: number
  /** @format double */
  subTotal: number
  wasAdminCreated: boolean
}

export interface MainStemAPIPlatformControllersPurchasingOrdersDetailsAPIResponseLocationDetails {
  /** @format int32 */
  id?: number
  name?: string
}

export interface MainStemAPIPlatformControllersPurchasingOrdersDetailsAPIResponseLocationProductFinancialDimension {
  financialDimensions: MainStemAPIPlatformControllersPurchasingOrdersDetailsAPIResponseLocationProductFinancialDimensionFinancialDimensionDetails[]
  product: MainStemAPIPlatformControllersPurchasingOrdersDetailsAPIResponseLocationProductFinancialDimensionProductDetails
}

export interface MainStemAPIPlatformControllersPurchasingOrdersDetailsAPIResponseLocationSupplierFinancialDimension {
  financialDimensions: MainStemAPIPlatformControllersPurchasingOrdersDetailsAPIResponseLocationSupplierFinancialDimensionFinancialDimensionDetails[]
  supplier: MainStemAPIPlatformControllersPurchasingOrdersDetailsAPIResponseLocationSupplierFinancialDimensionSupplierDetails
}

export interface MainStemAPIPlatformHelpersPurchaseOrdersResponsePurchaseOrderDetails {
  alerts?: MainStemAPIPlatformHelpersPurchaseOrdersResponsePurchaseOrderDetailsPurchaseOrderAlertDetails[]
  /** @format date-time */
  dateCreated?: string
  /** @format date-time */
  dateSalesTaxCalculated?: string
  /** @format date-time */
  dateShippingCalculated?: string
  discounts?: MainStemAPIPlatformHelpersPurchaseOrdersResponsePurchaseOrderDetailsDiscountDetails[]
  fees?: MainStemAPIPlatformHelpersPurchaseOrdersResponsePurchaseOrderDetailsFeeDetails[]
  freightCollect?: boolean
  /** @format int32 */
  id?: number
  isPunchOutGenerated?: boolean
  lineItems?: MainStemAPIPlatformHelpersPurchaseOrdersResponsePurchaseOrderDetailsLineItemDetails[]
  /** @format int32 */
  orderSupplierId?: number
  requisition?: MainStemAPIPlatformHelpersPurchaseOrdersResponsePurchaseOrderDetailsRequisitionDetails
  salesTax?: MainStemSDKIntegrationsAvalaraTransactionEstimateResponseTaxReasonDetails[]
  shipments?: MainStemAPIPlatformHelpersPurchaseOrdersResponsePurchaseOrderDetailsPurchaseOrderShipmentDetails[]
  shippingDetails?: MainStemAPIPlatformHelpersPurchaseOrdersResponsePurchaseOrderDetailsShippingDetails
  supplier?: MainStemAPIPlatformHelpersPurchaseOrdersResponsePurchaseOrderDetailsSupplierDetails
  totals?: MainStemAPIPlatformHelpersPurchaseOrdersResponsePurchaseOrderDetailsPurchaseOrderTotalsDetails
}

export interface MainStemAPIPlatformControllersPurchasingOrdersDetailsAPIResponseDynamicsIntegrationSettings {
  invoices: MainStemAPIPlatformControllersPurchasingOrdersDetailsAPIResponseDynamicsIntegrationSettingsDynamicsInvoiceDetails[]
}

export interface MainStemAPIPlatformControllersPurchasingOrdersDetailsAPIResponseQuantumLeafIntegrationSettings {
  /** @format int32 */
  customerIntegrationID?: number
  enabled?: boolean
}

export interface MainStemAPIPlatformControllersPurchasingOrdersDetailsAPIResponseQuickbooksIntegrationSettings {
  accountType?: string
  /** @format int32 */
  customerIntegrationID?: number
  enabled?: boolean
}

export interface MainStemAPIPlatformControllersPurchasingOrdersDetailsAPIResponseReceivingDetails {
  completed?: MainStemAPIPlatformControllersPurchasingOrdersDetailsAPIResponseFulfillmentVendorDetailsLineItemDetailsReceivingDetails[]
  needed?: MainStemAPIPlatformControllersPurchasingOrdersDetailsAPIResponseReceivingNeededDetails[]
}

export interface MainStemAPIPlatformControllersPurchasingOrdersDetailsAPIResponseShipmentDetails {
  needed?: MainStemAPIPlatformControllersPurchasingOrdersDetailsAPIResponseShipmentNeededDetails[]
  shipped?: MainStemAPIPlatformControllersPurchasingShipmentsListAPIResponseShipmentDetails[]
}

export interface MainStemAPIPlatformControllersPurchasingOrdersDetailsAPIResponseShipToDetails {
  address1?: string
  address2?: string
  city?: string
  country?: string
  /** @format int32 */
  id?: number
  name?: string
  state?: string
  zip?: string
}

export interface MainStemAPIPlatformControllersPurchasingOrdersDetailsAPIResponseSupplierFinancialDimension {
  financialDimensions?: MainStemAPIPlatformControllersPurchasingOrdersDetailsAPIResponseSupplierFinancialDimensionFinancialDimensionDetails[]
  supplier?: MainStemAPIPlatformControllersPurchasingOrdersDetailsAPIResponseSupplierFinancialDimensionSupplierDetails
}

export interface MainStemAPIPlatformControllersPurchasingOrdersDetailsAPIResponseOrderSupplierDetails {
  /** @format int32 */
  id?: number
  supplier?: MainStemAPIPlatformControllersPurchasingOrdersDetailsAPIResponseOrderSupplierDetailsSupplierDetails
}

export interface MainStemAPIPlatformControllersDEPRECATEAppTermsTermsOrderDetailsControllerAPIResponse {
  invoiceCollectables?: MainStemAPIPlatformControllersDEPRECATEAppTermsTermsOrderDetailsControllerInvoiceCollectable[]
  additionalModifications?: MainStemAPIPlatformControllersDEPRECATEAppTermsTermsOrderDetailsControllerTermDetails[]
  allTermLedgers?: MainStemAPIPlatformControllersDEPRECATEAppTermsTermsOrderDetailsControllerTermDetails[]
  /** @format date-time */
  basedOnShippedDate?: string
  error?: string
  orderBalanceTerm?: MainStemAPIPlatformControllersDEPRECATEAppTermsTermsOrderDetailsControllerTermDetails
  organizationHasTerms?: boolean
  /** @format int32 */
  organizationID?: number
  /** @format date-time */
  paymentDateDue?: string
  /** @format double */
  paymentDue?: number
  /** @format double */
  paymentDueSoon?: number
  /** @format double */
  paymentsTotal?: number
  termPayments?: MainStemAPIPlatformControllersDEPRECATEAppTermsTermsOrderDetailsControllerTermDetails[]
  /** @format int32 */
  termsDays?: number
  message?: string
  wasSuccessful?: boolean
}

export interface MainStemAPIPlatformControllersPurchasingOrdersDetailsAPIResponseTotalsDetails {
  /** @format double */
  discount: number
  /** @format double */
  fees: number
  /** @format double */
  salesTax: number
  /** @format double */
  shipping: number
  /** @format double */
  subtotal: number
  /** @format double */
  total: number
}

export interface MainStemAPIPlatformControllersPurchasingOrdersDetailsAPIResponseFulfillmentVendorDetailsLineItemDetailsAllocationDetails {
  /** @format date-time */
  dateCreated?: string
  department?: MainStemAPIPlatformControllersPurchasingOrdersDetailsAPIResponseFulfillmentVendorDetailsLineItemDetailsAllocationDetailsDepartmentDetails
  /** @format int32 */
  id?: number
  /** @format int32 */
  quantity?: number
  userCreatedBy?: MainStemAPIPlatformControllersPurchasingOrdersDetailsAPIResponseFulfillmentVendorDetailsLineItemDetailsAllocationDetailsUserDetails
}

export interface MainStemAPIPlatformControllersPurchasingOrdersDetailsAPIResponseAllocationNeededDetails {
  allocationsLeft?: boolean
  /** @format int32 */
  id?: number
  /** @format double */
  price?: number
  product?: MainStemAPIPlatformControllersPurchasingOrdersDetailsAPIResponseFulfillmentVendorDetailsLineItemDetailsProductDetails
  /** @format double */
  quantity?: number
  /** @format int32 */
  quantityAllocated?: number
}

export interface MainStemAPIPlatformControllersPurchasingOrdersDetailsAPIResponseBudgetDetailsDateDetails {
  /** @format int32 */
  date?: number
  /** @format int32 */
  month?: number
  /** @format int32 */
  year?: number
}

export interface MainStemAPIPlatformControllersPurchasingOrdersDetailsAPIResponseAcumaticaIntegration {
  purchaseOrderID?: string
  purchaseOrderUrl?: string
  /** @format date-time */
  queuedAt?: string
  syncAllowable?: boolean
  /** @format int32 */
  customerIntegrationID?: number
  enabled?: boolean
}

export interface MainStemAPIPlatformControllersPurchasingOrdersDetailsAPIResponseFulfillmentVendorDetailsPrivateSupplierInvoiceStatusDetail {
  allowResendOfEmail?: boolean
  /** @format date-time */
  dateCreated?: string
  /** @format date-time */
  dateViewed?: string
  emailNotificationFileCopies?: MainStemAPIPlatformControllersPurchasingOrdersDetailsAPIResponseFulfillmentVendorDetailsPrivateSupplierNotificationFile[]
  /** @format int32 */
  id?: number
  status?: string
}

export interface MainStemAPIPlatformControllersPurchasingOrdersDetailsAPIResponseFulfillmentVendorDetailsLineItemDetails {
  allocations?: MainStemAPIPlatformControllersPurchasingOrdersDetailsAPIResponseFulfillmentVendorDetailsLineItemDetailsAllocationDetails[]
  allocationsLeft?: boolean
  /** @format int32 */
  id?: number
  /** @format double */
  price?: number
  product?: MainStemAPIPlatformControllersPurchasingOrdersDetailsAPIResponseFulfillmentVendorDetailsLineItemDetailsProductDetails
  /** @format double */
  quantity?: number
  /** @format int32 */
  quantityAllocated?: number
  /** @format double */
  subTotal?: number
}

export interface MainStemAPIPlatformControllersPurchasingOrdersDetailsAPIResponseQuantumLeafIntegration {
  purchaseOrderID?: string
  purchaseOrderUrl?: string
  /** @format date-time */
  queuedAt?: string
  syncAllowable?: boolean
  /** @format int32 */
  customerIntegrationID?: number
  enabled?: boolean
}

export interface MainStemAPIPlatformControllersPurchasingOrdersDetailsAPIResponseQuickbooksIntegration {
  billID?: string
  /** @format date-time */
  queuedAt?: string
  syncAllowable?: boolean
  accountType?: string
  /** @format int32 */
  customerIntegrationID?: number
  enabled?: boolean
}

export interface MainStemAPIPlatformControllersPurchasingOrdersDetailsAPIResponseFulfillmentVendorDetailsShipmentDetails {
  carrier?: string
  carrierType?: string
  /** @format date-time */
  dateReceived?: string
  /** @format date-time */
  dateShippedOn?: string
  /** @format date-time */
  estimatedDeliveryDate?: string
  trackingNumber?: string
  uuid?: string
}

export interface MainStemAPIPlatformControllersPurchasingOrdersDetailsAPIResponseFulfillmentVendorDetailsSupplierDetails {
  city?: string
  country?: string
  /** @format int32 */
  id?: number
  logoURL?: string
  name?: string
  state?: string
  usesDirectPay?: boolean
  usesPreferredShipping?: boolean
  zip?: string
}

export interface MainStemAPIPlatformControllersPurchasingOrdersDetailsAPIResponseOrderLineItemDetailsProductDetails {
  hasVolumePricing?: boolean
  /** @format int32 */
  id?: number
  imageURL?: string
  isPrivate?: boolean
  /** @format int32 */
  maximumOrderAmount?: number
  /** @format int32 */
  minimumOrderAmount?: number
  name?: string
  /** @format int32 */
  soldInQuantitiesOf?: number
  type?: string
  volumePricing?: MainStemAPIPlatformControllersPurchasingOrdersDetailsAPIResponseOrderLineItemDetailsProductDetailsVolumePricingDetails[]
  volumePricingPriceAgreement?: MainStemAPIPlatformControllersPurchasingOrdersDetailsAPIResponseOrderLineItemDetailsProductDetailsVolumePricingAgreementDetails[]
}

export interface MainStemAPIPlatformControllersPurchasingOrdersDetailsAPIResponseLocationProductFinancialDimensionFinancialDimensionDetails {
  financialDimensionOption: MainStemAPIPlatformControllersPurchasingOrdersDetailsAPIResponseLocationProductFinancialDimensionFinancialDimensionDetailsFinancialDimensionOptionDetails
  /** @format int32 */
  id: number
  isRequired: boolean
  name: string
}

export interface MainStemAPIPlatformControllersPurchasingOrdersDetailsAPIResponseLocationProductFinancialDimensionProductDetails {
  /** @format int32 */
  id: number
  image?: string
  name: string
  type: string
}

export interface MainStemAPIPlatformControllersPurchasingOrdersDetailsAPIResponseLocationSupplierFinancialDimensionFinancialDimensionDetails {
  financialDimensionOption: MainStemAPIPlatformControllersPurchasingOrdersDetailsAPIResponseLocationSupplierFinancialDimensionFinancialDimensionDetailsFinancialDimensionOptionDetails
  /** @format int32 */
  id: number
  /** @format int32 */
  locationSupplierFinancialDimensionID: number
  name: string
}

export interface MainStemAPIPlatformControllersPurchasingOrdersDetailsAPIResponseLocationSupplierFinancialDimensionSupplierDetails {
  /** @format int32 */
  id: number
  image?: string
  name: string
}

export interface MainStemAPIPlatformHelpersPurchaseOrdersResponsePurchaseOrderDetailsPurchaseOrderAlertDetails {
  content?: string
  title?: string
}

export interface MainStemAPIPlatformHelpersPurchaseOrdersResponsePurchaseOrderDetailsDiscountDetails {
  /** @format double */
  amount?: number
  /** @format date-time */
  dateCreated?: string
  /** @format int32 */
  id?: number
  notes?: string
  reason?: string
}

export interface MainStemAPIPlatformHelpersPurchaseOrdersResponsePurchaseOrderDetailsFeeDetails {
  /** @format double */
  amount?: number
  /** @format date-time */
  dateCreated?: string
  /** @format int32 */
  id?: number
  notes?: string
  reason?: string
}

export interface MainStemAPIPlatformHelpersPurchaseOrdersResponsePurchaseOrderDetailsLineItemDetails {
  /** @format double */
  costPerItem?: number
  /** @format double */
  discountsPerItem?: number
  /** @format double */
  feesPerItem?: number
  /** @format int32 */
  id?: number
  /** @format double */
  pricePerItem?: number
  product?: MainStemAPIPlatformHelpersPurchaseOrdersResponsePurchaseOrderDetailsLineItemDetailsProductDetails
  /** @format double */
  quantity?: number
  /** @format double */
  salesTaxPerItem?: number
  /** @format double */
  shippingPerItem?: number
  /** @format double */
  total?: number
  /** @format double */
  costTotal?: number
}

export interface MainStemAPIPlatformHelpersPurchaseOrdersResponsePurchaseOrderDetailsRequisitionDetails {
  /** @format date-time */
  dateApproved?: string
  /** @format int32 */
  id?: number
  /**
   * @format uuid
   * @example "00000000-0000-0000-0000-000000000000"
   */
  uuid?: string
}

export interface MainStemSDKIntegrationsAvalaraTransactionEstimateResponseTaxReasonDetails {
  /** @format double */
  amount?: number
  jurisdiction?: string
  name?: string
  /** @format double */
  rate?: number
}

export interface MainStemAPIPlatformHelpersPurchaseOrdersResponsePurchaseOrderDetailsPurchaseOrderShipmentDetails {
  carrier?: string
  carrierType?: string
  /** @format date-time */
  dateCreated?: string
  /** @format date-time */
  dateShippedOn?: string
  location?: MainStemAPIPlatformHelpersPurchaseOrdersResponsePurchaseOrderDetailsPurchaseOrderShipmentDetailsLocationDetails
  status?: string
  /**
   * @format uuid
   * @example "00000000-0000-0000-0000-000000000000"
   */
  uuid?: string
}

export interface MainStemAPIPlatformHelpersPurchaseOrdersResponsePurchaseOrderDetailsShippingDetails {
  carrier?: string
  frieghtCollect?: boolean
  log?: string[]
  method?: string
}

export interface MainStemAPIPlatformHelpersPurchaseOrdersResponsePurchaseOrderDetailsSupplierDetails {
  bandedShippingRates?: MainStemAPIPlatformHelpersPurchaseOrdersResponsePurchaseOrderDetailsSupplierDetailsBandedShippingRateDetails[]
  city?: string
  country?: string
  /** @format double */
  freeShippingLimit?: number
  freightShippingRequired?: boolean
  /** @format int32 */
  freightWeightLimit?: number
  hasBandedShipping?: boolean
  hasDirectPay?: boolean
  hasPreferredShipping?: boolean
  /** @format int32 */
  id?: number
  isVerified?: boolean
  logo?: string
  name?: string
  state?: string
}

export interface MainStemAPIPlatformHelpersPurchaseOrdersResponsePurchaseOrderDetailsPurchaseOrderTotalsDetails {
  /** @format double */
  discounts?: number
  /** @format double */
  fees?: number
  /** @format double */
  salesTax?: number
  /** @format double */
  shipping?: number
  /** @format double */
  subtotal?: number
  /** @format double */
  costSubtotal?: number
  /** @format double */
  total?: number
  /** @format double */
  weight?: number
}

export interface MainStemAPIPlatformControllersPurchasingOrdersDetailsAPIResponseDynamicsIntegrationSettingsDynamicsInvoiceDetails {
  dynamicsDataURL: string
  dynamicsID: string
  /** @format int32 */
  invoiceID: number
}

export interface MainStemAPIPlatformControllersPurchasingOrdersDetailsAPIResponseFulfillmentVendorDetailsLineItemDetailsReceivingDetails {
  /** @format date-time */
  dateApproved?: string
  /** @format date-time */
  datePromisedBy?: string
  /** @format date-time */
  dateShipped?: string
  /** @format int32 */
  fulfillmentID?: number
  invoiceID?: string
  /** @format int32 */
  invoiceLineItemID?: number
  /** @format int32 */
  locationID?: number
  locationName?: string
  /** @format int32 */
  orderID?: number
  /**
   * @format uuid
   * @example "00000000-0000-0000-0000-000000000000"
   */
  orderUUID?: string
  /** @format int32 */
  productID?: number
  productName?: string
  /** @format int32 */
  quantity?: number
  /** @format int32 */
  supplierID?: number
  supplierName?: string
  /** @format int32 */
  totalReceived?: number
  /**
   * @format uuid
   * @example "00000000-0000-0000-0000-000000000000"
   */
  uuid?: string
}

export interface MainStemAPIPlatformControllersPurchasingOrdersDetailsAPIResponseReceivingNeededDetails {
  /** @format date-time */
  dateApproved?: string
  /** @format date-time */
  datePromisedBy?: string
  /** @format date-time */
  dateShipped?: string
  /** @format int32 */
  fulfillmentID?: number
  invoiceID?: string
  /** @format int32 */
  invoiceLineItemID?: number
  /** @format int32 */
  locationID?: number
  locationName?: string
  /** @format int32 */
  orderID?: number
  /**
   * @format uuid
   * @example "00000000-0000-0000-0000-000000000000"
   */
  orderUUID?: string
  /** @format int32 */
  productID?: number
  productImage?: string
  productName?: string
  /** @format int32 */
  quantity?: number
  /** @format int32 */
  supplierID?: number
  supplierName?: string
  /** @format int32 */
  totalReceived?: number
  /**
   * @format uuid
   * @example "00000000-0000-0000-0000-000000000000"
   */
  uuid?: string
}

export interface MainStemAPIPlatformControllersPurchasingOrdersDetailsAPIResponseShipmentNeededDetails {
  /** @format int32 */
  id?: number
  /** @format double */
  price?: number
  product?: MainStemAPIPlatformControllersPurchasingOrdersDetailsAPIResponseFulfillmentVendorDetailsLineItemDetailsProductDetails
  /** @format double */
  quantity?: number
}

export interface MainStemAPIPlatformControllersPurchasingShipmentsListAPIResponseShipmentDetails {
  carrier?: string
  carrierType?: string
  /** @format date-time */
  dateCreated?: string
  /** @format date-time */
  dateReceived?: string
  /** @format date-time */
  dateShippedOn?: string
  /** @format date-time */
  estimatedDeliveryDate?: string
  /** @format int32 */
  id?: number
  location?: MainStemAPIPlatformControllersPurchasingShipmentsListAPIResponseShipmentDetailsLocationDetails
  /** @format int32 */
  orderID?: number
  orderUUID?: string
  status?: string
  supplier: MainStemAPIPlatformControllersPurchasingShipmentsListAPIResponseSupplierDetails
  trackingNumber?: string
  userRelated?: boolean
  uuid?: string
}

export interface MainStemAPIPlatformControllersPurchasingOrdersDetailsAPIResponseSupplierFinancialDimensionFinancialDimensionDetails {
  financialDimensionOption?: MainStemAPIPlatformControllersPurchasingOrdersDetailsAPIResponseSupplierFinancialDimensionFinancialDimensionDetailsFinancialDimensionOptionDetails
  /** @format int32 */
  id?: number
  name?: string
}

export interface MainStemAPIPlatformControllersPurchasingOrdersDetailsAPIResponseSupplierFinancialDimensionSupplierDetails {
  /** @format int32 */
  id?: number
  image?: string
  name?: string
}

export interface MainStemAPIPlatformControllersPurchasingOrdersDetailsAPIResponseOrderSupplierDetailsSupplierDetails {
  /** @format int32 */
  id?: number
  image?: string
  name?: string
}

export interface MainStemAPIPlatformControllersDEPRECATEAppTermsTermsOrderDetailsControllerInvoiceCollectable {
  /** @format double */
  amount?: number
  /** @format date-time */
  dateCollectable?: string
  /** @format date-time */
  earliestCollectable?: string
  isDue?: boolean
  /** @format date-time */
  shippedOn?: string
}

export interface MainStemAPIPlatformControllersDEPRECATEAppTermsTermsOrderDetailsControllerTermDetails {
  /** @format double */
  amount?: number
  /** @format date-time */
  dateCreated?: string
  /** @format int32 */
  id?: number
  note?: string
  /** @format int32 */
  orderID?: number
  reason?: string
}

export interface MainStemAPIPlatformControllersPurchasingOrdersDetailsAPIResponseFulfillmentVendorDetailsLineItemDetailsAllocationDetailsDepartmentDetails {
  /** @format int32 */
  id?: number
  name?: string
}

export interface MainStemAPIPlatformControllersPurchasingOrdersDetailsAPIResponseFulfillmentVendorDetailsLineItemDetailsAllocationDetailsUserDetails {
  id?: string
  username?: string
}

export interface MainStemAPIPlatformControllersPurchasingOrdersDetailsAPIResponseFulfillmentVendorDetailsLineItemDetailsProductDetails {
  /** @format int32 */
  id?: number
  imageURL?: string
  name?: string
  type?: string
}

export interface MainStemAPIPlatformControllersPurchasingOrdersDetailsAPIResponseFulfillmentVendorDetailsPrivateSupplierNotificationFile {
  /** @format date-time */
  dateCreated?: string
  /** @format int32 */
  fileID?: number
  fileLocation?: string
  fileType?: string
  fileUUID?: string
}

export interface MainStemAPIPlatformControllersPurchasingOrdersDetailsAPIResponseOrderLineItemDetailsProductDetailsVolumePricingDetails {
  /** @format double */
  price?: number
  /** @format int32 */
  quantityHigh?: number
  /** @format int32 */
  quantityLow?: number
}

export interface MainStemAPIPlatformControllersPurchasingOrdersDetailsAPIResponseOrderLineItemDetailsProductDetailsVolumePricingAgreementDetails {
  /** @format double */
  price?: number
  /** @format int32 */
  quantityHigh?: number
  /** @format int32 */
  quantityLow?: number
}

export interface MainStemAPIPlatformControllersPurchasingOrdersDetailsAPIResponseLocationProductFinancialDimensionFinancialDimensionDetailsFinancialDimensionOptionDetails {
  /** @format int32 */
  id: number
  label: string
  value: string
}

export interface MainStemAPIPlatformControllersPurchasingOrdersDetailsAPIResponseLocationSupplierFinancialDimensionFinancialDimensionDetailsFinancialDimensionOptionDetails {
  /** @format int32 */
  id: number
  label: string
  value: string
}

export interface MainStemAPIPlatformHelpersPurchaseOrdersResponsePurchaseOrderDetailsLineItemDetailsProductDetails {
  /** @format int32 */
  id?: number
  image?: string
  name?: string
  type?: string
}

export interface MainStemAPIPlatformHelpersPurchaseOrdersResponsePurchaseOrderDetailsPurchaseOrderShipmentDetailsLocationDetails {
  address?: MainStemAPIPlatformHelpersPurchaseOrdersResponsePurchaseOrderDetailsPurchaseOrderShipmentDetailsLocationDetailsAddressDetails
  /** @format int32 */
  id?: number
  name?: string
}

export interface MainStemAPIPlatformHelpersPurchaseOrdersResponsePurchaseOrderDetailsSupplierDetailsBandedShippingRateDetails {
  /** @format double */
  amount?: number
  /** @format double */
  orderTotalLowerLimit?: number
  /** @format double */
  orderTotalUpperLimit?: number
}

export interface MainStemAPIPlatformControllersPurchasingShipmentsListAPIResponseShipmentDetailsLocationDetails {
  address1?: string
  address2?: string
  city?: string
  country?: string
  /** @format int32 */
  id?: number
  name?: string
  state?: string
  zip?: string
}

export interface MainStemAPIPlatformControllersPurchasingShipmentsListAPIResponseSupplierDetails {
  /** @format int32 */
  id: number
  integrationType?: string
  name: string
}

export interface MainStemAPIPlatformControllersPurchasingOrdersDetailsAPIResponseSupplierFinancialDimensionFinancialDimensionDetailsFinancialDimensionOptionDetails {
  /** @format int32 */
  id?: number
  name?: string
}

export interface MainStemAPIPlatformHelpersPurchaseOrdersResponsePurchaseOrderDetailsPurchaseOrderShipmentDetailsLocationDetailsAddressDetails {
  address1?: string
  address2?: string
  city?: string
  country?: string
  state?: string
  zip?: string
}

export interface MainStemAPIPlatformControllersPurchasingOrdersDetailsIntegrationsDynamicsDetailsAPIRequest {
  /** @format int32 */
  orderId?: number
}

export interface MainStemAPIPlatformControllersPurchasingOrdersDetailsIntegrationsDynamicsDetailsAPIResponse {
  invoices: MainStemAPIPlatformControllersPurchasingOrdersDetailsIntegrationsDynamicsDetailsAPIResponseInvoiceDetails[]
  /** @format int32 */
  integrationSettingsID: number
  message?: string
  wasSuccessful?: boolean
}

export interface MainStemAPIPlatformControllersPurchasingOrdersDetailsIntegrationsDynamicsDetailsAPIResponseInvoiceDetails {
  /** @format int32 */
  invoiceID: number
  /** @format int32 */
  requisitionID: number
  dynamicsID: string
  dynamicsDataURL: string
}

export interface MainStemAPIPlatformControllersPurchasingOrdersDetailsIntegrationsDynamicsOverviewAPIRequest {
  /** @format int32 */
  orderId?: number
}

export interface MainStemAPIPlatformControllersPurchasingOrdersDetailsIntegrationsDynamicsOverviewAPIResponse {
  hasDynamicsIntegration?: boolean
  integration?: MainStemAPIPlatformControllersPurchasingOrdersDetailsIntegrationsDynamicsOverviewAPIResponseIntegrationDetails
  location?: MainStemAPIPlatformControllersPurchasingOrdersDetailsIntegrationsDynamicsOverviewAPIResponseLocationDetails
  products?: MainStemAPIPlatformControllersPurchasingOrdersDetailsIntegrationsDynamicsOverviewAPIResponseProductDetails[]
  invoices?: MainStemAPIPlatformControllersPurchasingOrdersDetailsIntegrationsDynamicsOverviewAPIResponseInvoiceDetails[]
  message?: string
  wasSuccessful?: boolean
}

export interface MainStemAPIPlatformControllersPurchasingOrdersDetailsIntegrationsDynamicsOverviewAPIResponseIntegrationDetails {
  /** @format int32 */
  id?: number
  name?: string
  isCompanyWide?: boolean
  vendorAccountSelected?: boolean
}

export interface MainStemAPIPlatformControllersPurchasingOrdersDetailsIntegrationsDynamicsOverviewAPIResponseLocationDetails {
  /** @format int32 */
  id?: number
  name?: string
  dynamicsCompanyId?: string
  productDimension?: MainStemAPIPlatformControllersPurchasingOrdersDetailsIntegrationsDynamicsOverviewAPIResponseProductDimensionDetails
}

export interface MainStemAPIPlatformControllersPurchasingOrdersDetailsIntegrationsDynamicsOverviewAPIResponseProductDetails {
  /** @format int32 */
  id?: number
  name?: string
  skuInternal?: string
  /** @format int32 */
  supplierId?: number
  supplierName?: string
  mainAccount?: string
}

export interface MainStemAPIPlatformControllersPurchasingOrdersDetailsIntegrationsDynamicsOverviewAPIResponseInvoiceDetails {
  /** @format int32 */
  id?: number
  uuid?: string
  /** @format int32 */
  supplierId?: number
  supplierName?: string
  /** @format date-time */
  dateShipped?: string
  dynamicsId?: string
  dynamicsDataUrl?: string
}

export interface MainStemAPIPlatformControllersPurchasingOrdersDetailsIntegrationsDynamicsOverviewAPIResponseProductDimensionDetails {
  /** @format int32 */
  locationProductFinancialDimensionId?: number
  /** @format int32 */
  financialDimensionId?: number
  label?: string
}

export interface MainStemAPIPlatformControllersPurchasingOrdersDetailsIntegrationsQuantumLeafDetailsAPIRequest {
  /** @format int32 */
  orderId?: number
}

export interface MainStemAPIPlatformControllersPurchasingOrdersDetailsIntegrationsQuantumLeafDetailsAPIResponse {
  locationProducts?: MainStemAPIPlatformControllersPurchasingOrdersDetailsIntegrationsQuantumLeafDetailsAPIResponseProductDetials[]
  logs?: MainStemSDKModelsIntegrationsQuantumLeafQuantumLeafLogEntry[]
  orders?: MainStemAPIPlatformControllersPurchasingOrdersDetailsIntegrationsQuantumLeafDetailsAPIResponseOrderDetails[]
  products?: MainStemAPIPlatformControllersPurchasingOrdersDetailsIntegrationsQuantumLeafDetailsAPIResponseProductDetials[]
  suppliers?: MainStemAPIPlatformControllersPurchasingOrdersDetailsIntegrationsQuantumLeafDetailsAPIResponseSupplierDetails[]
  /** @format int32 */
  defaultLocationSupplierFinancialDimensionID?: number
  quantumLeaf?: MainStemAPIPlatformControllersPurchasingOrdersDetailsIntegrationsQuantumLeafDetailsAPIResponseQuantumLeafDetails
  message?: string
  wasSuccessful?: boolean
}

export interface MainStemAPIPlatformControllersPurchasingOrdersDetailsIntegrationsQuantumLeafDetailsAPIResponseProductDetials {
  /** @format int32 */
  id?: number
  image?: string
  isPrivate?: boolean
  itemId?: string
  name?: string
  skuInternal?: string
  /** @format int32 */
  supplierId?: number
  supplierName?: string
}

export interface MainStemAPIPlatformControllersPurchasingOrdersDetailsIntegrationsQuantumLeafDetailsAPIResponseOrderDetails {
  /** @format int32 */
  id?: number
  quantumLeafId?: string
  quantumLeafUrl?: string
  supplier?: MainStemAPIPlatformControllersPurchasingOrdersDetailsIntegrationsQuantumLeafDetailsAPIResponseOrderDetailsSupplierDetails
  uuid?: string
}

export interface MainStemAPIPlatformControllersPurchasingOrdersDetailsIntegrationsQuantumLeafDetailsAPIResponseSupplierDetails {
  /** @format int32 */
  id?: number
  image?: string
  isPrivateSupplier?: boolean
  linkId?: string
  name?: string
}

export interface MainStemAPIPlatformControllersPurchasingOrdersDetailsIntegrationsQuantumLeafDetailsAPIResponseQuantumLeafDetails {
  /** @format int32 */
  integrationSettingsId?: number
  items?: MainStemAPIPlatformControllersPurchasingOrdersDetailsIntegrationsQuantumLeafDetailsAPIResponseQuantumLeafDetailsQuantumLeafItem[]
  vendors?: MainStemAPIPlatformControllersPurchasingOrdersDetailsIntegrationsQuantumLeafDetailsAPIResponseQuantumLeafDetailsQuantumLeafVendor[]
}

export interface MainStemAPIPlatformControllersPurchasingOrdersDetailsIntegrationsQuantumLeafDetailsAPIResponseOrderDetailsSupplierDetails {
  /** @format int32 */
  id?: number
  inNetwork?: boolean
  name?: string
}

export interface MainStemAPIPlatformControllersPurchasingOrdersDetailsIntegrationsQuantumLeafDetailsAPIResponseQuantumLeafDetailsQuantumLeafItem {
  itemType?: 'Stock' | 'NonStock'
  label?: string
  value?: string
}

export interface MainStemAPIPlatformControllersPurchasingOrdersDetailsIntegrationsQuantumLeafDetailsAPIResponseQuantumLeafDetailsQuantumLeafVendor {
  label?: string
  value?: string
}

export interface MainStemAPIPlatformControllersPurchasingOrdersDetailsIntegrationsQuantumLeafLogsAPIRequest {
  /** @format int32 */
  orderId?: number
}

export interface MainStemAPIPlatformControllersPurchasingOrdersDetailsIntegrationsQuantumLeafLogsAPIResponse {
  logs?: MainStemSDKModelsIntegrationsQuantumLeafQuantumLeafLogEntry[]
  message?: string
  wasSuccessful?: boolean
}

export interface MainStemAPIPlatformControllersPurchasingOrdersDetailsIntegrationsQuantumLeafOverviewAPIRequest {
  /** @format int32 */
  orderId?: number
}

export interface MainStemAPIPlatformControllersPurchasingOrdersDetailsIntegrationsQuantumLeafOverviewAPIResponse {
  hasQuantumLeafIntegration?: boolean
  integration?: MainStemAPIPlatformControllersPurchasingOrdersDetailsIntegrationsQuantumLeafOverviewAPIResponseIntegrationDetails
  location?: MainStemAPIPlatformControllersPurchasingOrdersDetailsIntegrationsQuantumLeafOverviewAPIResponseLocationDetails
  suppliers?: MainStemAPIPlatformControllersPurchasingOrdersDetailsIntegrationsQuantumLeafOverviewAPIResponseSupplierDetails[]
  products?: MainStemAPIPlatformControllersPurchasingOrdersDetailsIntegrationsQuantumLeafOverviewAPIResponseProductDetails[]
  invoices?: MainStemAPIPlatformControllersPurchasingOrdersDetailsIntegrationsQuantumLeafOverviewAPIResponseInvoiceDetails[]
  message?: string
  wasSuccessful?: boolean
}

export interface MainStemAPIPlatformControllersPurchasingOrdersDetailsIntegrationsQuantumLeafOverviewAPIResponseIntegrationDetails {
  /** @format int32 */
  id?: number
  name?: string
  isCompanyWide?: boolean
}

export interface MainStemAPIPlatformControllersPurchasingOrdersDetailsIntegrationsQuantumLeafOverviewAPIResponseLocationDetails {
  /** @format int32 */
  id?: number
  name?: string
  warehouseId?: string
  fallbackDimension?: MainStemAPIPlatformControllersPurchasingOrdersDetailsIntegrationsQuantumLeafOverviewAPIResponseFallbackDimensionDetails
}

export interface MainStemAPIPlatformControllersPurchasingOrdersDetailsIntegrationsQuantumLeafOverviewAPIResponseSupplierDetails {
  /** @format int32 */
  id?: number
  name?: string
  image?: string
  isPrivateSupplier?: boolean
  linkId?: string
  fallbackItem?: MainStemAPIPlatformControllersPurchasingOrdersDetailsIntegrationsQuantumLeafOverviewAPIResponseFallbackItemDetails
}

export interface MainStemAPIPlatformControllersPurchasingOrdersDetailsIntegrationsQuantumLeafOverviewAPIResponseProductDetails {
  /** @format int32 */
  id?: number
  name?: string
  image?: string
  skuInternal?: string
  isPrivate?: boolean
  /** @format int32 */
  supplierId?: number
  supplierName?: string
  itemId?: string
  readyToSync?: boolean
}

export interface MainStemAPIPlatformControllersPurchasingOrdersDetailsIntegrationsQuantumLeafOverviewAPIResponseInvoiceDetails {
  /** @format int32 */
  id?: number
  uuid?: string
  /** @format int32 */
  supplierId?: number
  supplierName?: string
  /** @format date-time */
  dateShipped?: string
  /** @format date-time */
  queuedAt?: string
  quantumLeafId?: string
  quantumLeafUrl?: string
}

export interface MainStemAPIPlatformControllersPurchasingOrdersDetailsIntegrationsQuantumLeafOverviewAPIResponseFallbackDimensionDetails {
  /** @format int32 */
  locationSupplierFinancialDimensionId?: number
  /** @format int32 */
  financialDimensionId?: number
  label?: string
}

export interface MainStemAPIPlatformControllersPurchasingOrdersDetailsIntegrationsQuantumLeafOverviewAPIResponseFallbackItemDetails {
  value?: string
  label?: string
}

export interface MainStemAPIPlatformControllersPurchasingOrdersDetailsIntegrationsQuickbooksDetailsAPIRequest {
  /** @format int32 */
  orderId?: number
}

export interface MainStemAPIPlatformControllersPurchasingOrdersDetailsIntegrationsQuickbooksDetailsAPIResponse {
  invoices?: MainStemAPIPlatformControllersPurchasingOrdersDetailsIntegrationsQuickbooksDetailsAPIResponseInvoiceDetails[]
  logs?: MainStemSDKModelsLoggingQuickBooksQuickBooksLogEntry[]
  paymentMethods?: MainStemAPIPlatformControllersPurchasingOrdersDetailsIntegrationsQuickbooksDetailsAPIResponsePaymentMethodDetails[]
  payments?: MainStemAPIPlatformControllersPurchasingOrdersDetailsIntegrationsQuickbooksDetailsAPIResponsePaymentDetails[]
  productCategories?: MainStemAPIPlatformControllersPurchasingOrdersDetailsIntegrationsQuickbooksDetailsAPIResponseProductCategoryDetails[]
  products?: MainStemAPIPlatformControllersPurchasingOrdersDetailsIntegrationsQuickbooksDetailsAPIResponseProductDetials[]
  quickBooks?: MainStemAPIPlatformControllersPurchasingOrdersDetailsIntegrationsQuickbooksDetailsAPIResponseQuickBooksDetails
  message?: string
  wasSuccessful?: boolean
}

export interface MainStemAPIPlatformControllersPurchasingOrdersDetailsIntegrationsQuickbooksDetailsAPIResponseInvoiceDetails {
  /** @format int32 */
  id?: number
  order?: MainStemAPIPlatformControllersPurchasingOrdersDetailsIntegrationsQuickbooksDetailsAPIResponseInvoiceDetailsOrderDetails
  quickBooksId?: string
  quickBooksUrl?: string
  supplier?: MainStemAPIPlatformControllersPurchasingOrdersDetailsIntegrationsQuickbooksDetailsAPIResponseInvoiceDetailsSupplierDetails
  uuid?: string
}

export interface MainStemAPIPlatformControllersPurchasingOrdersDetailsIntegrationsQuickbooksDetailsAPIResponsePaymentMethodDetails {
  /** @format int32 */
  id?: number
  last4OfAccount?: string
  quickBooksId?: string
  type?: string
}

export interface MainStemAPIPlatformControllersPurchasingOrdersDetailsIntegrationsQuickbooksDetailsAPIResponsePaymentDetails {
  /** @format int32 */
  id?: number
  quickBooksId?: string
  quickBooksUrl?: string
}

export interface MainStemAPIPlatformControllersPurchasingOrdersDetailsIntegrationsQuickbooksDetailsAPIResponseProductCategoryDetails {
  category?: string
  /** @format int32 */
  quickbooksAccountId?: number
}

export interface MainStemAPIPlatformControllersPurchasingOrdersDetailsIntegrationsQuickbooksDetailsAPIResponseProductDetials {
  /** @format int32 */
  financialDimensionOptionId?: number
  /** @format int32 */
  id?: number
  image?: string
  isPrivate?: boolean
  name?: string
  quickBooksId?: string
  skuInternal?: string
  /** @format int32 */
  supplierId?: number
  supplierImage?: string
  supplierName?: string
  type?: string
}

export interface MainStemAPIPlatformControllersPurchasingOrdersDetailsIntegrationsQuickbooksDetailsAPIResponseQuickBooksDetails {
  billPaySyncEnabled?: boolean
  integrationCategoryDetails?: MainStemAPIPlatformControllersPurchasingOrdersDetailsIntegrationsQuickbooksDetailsAPIResponseQuickBooksDetailsCategoryIntegrationDetails
  integrationProductDetails?: MainStemAPIPlatformControllersPurchasingOrdersDetailsIntegrationsQuickbooksDetailsAPIResponseQuickBooksDetailsProductIntegrationDetails
  /** @format int32 */
  integrationSettingsId?: number
  productIntegrationLevel?: 'Product' | 'Category'
  salesTaxQuickbooksAccountId?: string
  salesTaxQuickbooksClassId?: string
  shippingQuickbooksAccountId?: string
  shippingQuickbooksClassId?: string
  trackClassesEnabled?: boolean
  trackLocationsEnabled?: boolean
}

export interface MainStemAPIPlatformControllersPurchasingOrdersDetailsIntegrationsQuickbooksDetailsAPIResponseInvoiceDetailsOrderDetails {
  /** @format int32 */
  id?: number
  uuid?: string
}

export interface MainStemAPIPlatformControllersPurchasingOrdersDetailsIntegrationsQuickbooksDetailsAPIResponseInvoiceDetailsSupplierDetails {
  /** @format int32 */
  id?: number
  inNetwork?: boolean
  name?: string
}

export interface MainStemAPIPlatformControllersPurchasingOrdersDetailsIntegrationsQuickbooksDetailsAPIResponseQuickBooksDetailsCategoryIntegrationDetails {
  type?: 'Aggregate' | 'LineItem'
}

export interface MainStemAPIPlatformControllersPurchasingOrdersDetailsIntegrationsQuickbooksDetailsAPIResponseQuickBooksDetailsProductIntegrationDetails {
  defaultExpenseAccount?: string
  defaultItemType?: string
}

export interface MainStemAPIPlatformControllersPurchasingOrdersDetailsIntegrationsQuickbooksOverviewAPIRequest {
  /** @format int32 */
  orderId?: number
}

export interface MainStemAPIPlatformControllersPurchasingOrdersDetailsIntegrationsQuickbooksOverviewAPIResponse {
  hasQuickBooksIntegration?: boolean
  integration?: MainStemAPIPlatformControllersPurchasingOrdersDetailsIntegrationsQuickbooksOverviewAPIResponseIntegrationDetails
  location?: MainStemAPIPlatformControllersPurchasingOrdersDetailsIntegrationsQuickbooksOverviewAPIResponseLocationDetails
  products?: MainStemAPIPlatformControllersPurchasingOrdersDetailsIntegrationsQuickbooksOverviewAPIResponseProductDetails[]
  invoices?: MainStemAPIPlatformControllersPurchasingOrdersDetailsIntegrationsQuickbooksOverviewAPIResponseInvoiceDetails[]
  payments?: MainStemAPIPlatformControllersPurchasingOrdersDetailsIntegrationsQuickbooksOverviewAPIResponsePaymentDetails[]
  message?: string
  wasSuccessful?: boolean
}

export interface MainStemAPIPlatformControllersPurchasingOrdersDetailsIntegrationsQuickbooksOverviewAPIResponseIntegrationDetails {
  /** @format int32 */
  id?: number
  name?: string
  isCompanyWide?: boolean
  accountType?: string
  itemLevelSync?: boolean
  billPaySyncEnabled?: boolean
  locationsEnabled?: boolean
  vendorSelected?: boolean
  termsSelected?: boolean
}

export interface MainStemAPIPlatformControllersPurchasingOrdersDetailsIntegrationsQuickbooksOverviewAPIResponseLocationDetails {
  /** @format int32 */
  id?: number
  name?: string
  /** @format int32 */
  quickBooksLocationId?: number
}

export interface MainStemAPIPlatformControllersPurchasingOrdersDetailsIntegrationsQuickbooksOverviewAPIResponseProductDetails {
  /** @format int32 */
  id?: number
  name?: string
  skuInternal?: string
  type?: string
  /** @format int32 */
  supplierId?: number
  supplierName?: string
  quickBooksItemId?: string
  /** @format int32 */
  quickBooksAccountId?: number
  readyToSync?: boolean
}

export interface MainStemAPIPlatformControllersPurchasingOrdersDetailsIntegrationsQuickbooksOverviewAPIResponseInvoiceDetails {
  /** @format int32 */
  id?: number
  uuid?: string
  /** @format int32 */
  supplierId?: number
  supplierName?: string
  isPrivateSupplier?: boolean
  /** @format date-time */
  dateShipped?: string
  quickBooksId?: string
  quickBooksUrl?: string
}

export interface MainStemAPIPlatformControllersPurchasingOrdersDetailsIntegrationsQuickbooksOverviewAPIResponsePaymentDetails {
  /** @format int32 */
  id?: number
  /** @format int32 */
  invoiceId?: number
  /** @format double */
  amount?: number
  quickBooksId?: string
}

export interface MainStemAPIPlatformControllersPurchasingOrdersDetailsPaymentsAPIRequest {
  uuid?: string
}

export interface MainStemAPIPlatformControllersPurchasingOrdersDetailsPaymentsAPIResponse {
  payments?: MainStemAPIPlatformControllersPurchasingOrdersDetailsPaymentsAPIResponsePaymentDetails[]
  message?: string
  wasSuccessful?: boolean
}

export interface MainStemAPIPlatformControllersPurchasingOrdersDetailsPaymentsAPIResponsePaymentDetails {
  paymentType?: string
  /** @format double */
  amount?: number
  createdBy?: string
  /** @format date-time */
  dateCreated?: string
  last4?: string
  note?: string
  status?: string
  type?: string
  quickBooksBillID?: string
  quickBooksBillPaymentID?: string
  hasQuickBooksIntegration?: boolean
  /** @format int32 */
  id?: number
  paymentLinks?: MainStemAPIPlatformControllersPurchasingOrdersDetailsPaymentsAPIResponsePaymentLinkDetail[]
  quickBooksIntegrationEnabled?: boolean
}

export interface MainStemAPIPlatformControllersPurchasingOrdersDetailsPaymentsAPIResponsePaymentLinkDetail {
  /** @format int32 */
  fulfillmentMethodID?: number
  /** @format double */
  amount?: number
  quickBooksBillPaymentID?: string
  /** @format int32 */
  orderID?: number
  quickBooksBillID?: string
  syncAllowable?: boolean
  /** @format date-time */
  queuedAt?: string
  /** @format int32 */
  id?: number
  fulfillmentUUID?: string
  quickBooksAccountType?: string
  linkedInvoiceIsPrivate?: boolean
  quickBooksEnabled?: boolean
}

export interface MainStemAPIPlatformControllersPurchasingOrdersEmailLogsAPIRequest {
  orderUUID?: string
}

export interface MainStemAPIPlatformControllersPurchasingOrdersEmailLogsAPIResponse {
  logs?: MainStemSDKHelpersLoggingOrderEmailedVerificationEntry[]
  message?: string
  wasSuccessful?: boolean
}

export interface MainStemSDKHelpersLoggingOrderEmailedVerificationEntry {
  partitionKey?: string
  allEmailStatusesAsString?: string
  data?: string
  /** @format int32 */
  orderID?: number
  /** @format int32 */
  fulfillmentID?: number
  /** @format date-time */
  sentToMiddleWareAt?: string
  /** @format date-time */
  sentToQueueAt?: string
  queueMessageID?: string
  /** @format date-time */
  enteredQueueAt?: string
  subject?: string
  sentTo?: string
  /** @format date-time */
  emailProviderEventAt?: string
  emailProviderWasSuccessful?: boolean
  emailProviderMessage?: string
  emailProviderID?: string
  /** @format date-time */
  emailProviderDeliveredAt?: string
  sentMultipleEmails?: boolean
  groupID?: string
  rowKey?: string
  /** @format date-time */
  timestamp?: string
  eTag?: AzureETag
}

export interface MainStemAPIPlatformControllersPurchasingOrdersListAPIResponse {
  orders?: MainStemAPIPlatformControllersPurchasingOrdersListAPIResponseOrderDetails[]
  message?: string
  wasSuccessful?: boolean
}

export interface MainStemAPIPlatformControllersPurchasingOrdersPayAPIRequest {
  orderUUID?: string
  paymentMethods?: MainStemAPIPlatformHelpersPaymentsFactoryPaymentRequestPaymentDetails[]
}

export interface MainStemAPIPlatformHelpersPaymentsFactoryPaymentRequestPaymentDetails {
  accountNumber?: string
  /** @format double */
  amount?: number
  applyPaymentImmediately?: boolean
  bankName?: string
  customerTaxId?: string
  isACH?: boolean
  /** @format int32 */
  paymentMethodId?: number
  routingNumber?: string
  type?: string
}

export interface MainStemAPIPlatformControllersPurchasingOrdersResendPrivateSupplierEmailAPIRequest {
  invoiceUUID?: string
  orderUUID?: string
}

export interface MainStemAPIPlatformControllersPurchasingOrdersResendPrivateSupplierEmailAPIResponse {
  message?: string
  wasSuccessful?: boolean
}

export interface MainStemAPIPlatformControllersPurchasingOrdersRevertAPIRequest {
  orderUUID?: string
}

export interface MainStemAPIPlatformControllersPurchasingOrdersSubmitPaymentMethodsListAPIRequest {
  orderUUID?: string
}

export interface MainStemAPIPlatformControllersPurchasingOrdersSubmitPaymentMethodsListAPIResponse {
  accounts?: MainStemAPIPlatformControllersPurchasingOrdersSubmitPaymentMethodsListAPIResponseAccountDetails[]
  creditCards?: MainStemAPIPlatformControllersPurchasingOrdersSubmitPaymentMethodsListAPIResponseCreditCardDetails[]
  terms?: MainStemAPIPlatformControllersDEPRECATEAppOrganizationsGetTermsTotalAPIResponse
  message?: string
  wasSuccessful?: boolean
}

export interface MainStemAPIPlatformControllersPurchasingOrdersSubmitPaymentMethodsListAPIResponseAccountDetails {
  /** @format int32 */
  id?: number
  last4OfACH?: string
  nickname?: string
}

export interface MainStemAPIPlatformControllersPurchasingOrdersSubmitPaymentMethodsListAPIResponseCreditCardDetails {
  /** @format date-time */
  expirationDate?: string
  /** @format int32 */
  id?: number
  isDefault?: boolean
  issuer?: string
  last4OfCard?: string
}

export interface MainStemAPIPlatformControllersDEPRECATEAppOrganizationsGetTermsTotalAPIResponse {
  /** @format double */
  available?: number
  /** @format double */
  balance?: number
  /** @format double */
  creditLimit?: number
  /** @format int32 */
  days?: number
  /** @format double */
  due?: number
  error?: string
  message?: string
  wasSuccessful?: boolean
}

export interface MainStemAPIPlatformControllersPurchasingOrdersDetailsOrderTotalsOverviewAPIRequest {
  uuid?: string
}

export interface MainStemAPIPlatformControllersPurchasingOrdersDetailsOrderTotalsOverviewAPIResponse {
  combinedTotals?: MainStemAPIPlatformControllersPurchasingOrdersDetailsOrderTotalsOverviewTotalDetails
  invoicedLineItemsDetails?: MainStemAPIPlatformControllersPurchasingOrdersDetailsOrderTotalsOverviewLineItemTotals
  orderLineItemsDetails?: MainStemAPIPlatformControllersPurchasingOrdersDetailsOrderTotalsOverviewLineItemTotals
  privateTotals?: MainStemAPIPlatformControllersPurchasingOrdersDetailsOrderTotalsOverviewTotalDetails
  purchaseOrderTotals?: MainStemAPIPlatformControllersPurchasingOrdersDetailsOrderTotalsOverviewTotalDetails
  verifiedTotals?: MainStemAPIPlatformControllersPurchasingOrdersDetailsOrderTotalsOverviewTotalDetails
  /** @format double */
  allPaymentsMade?: number
  /** @format double */
  balance?: number
  error?: string
  message?: string
  wasSuccessful?: boolean
}

export interface MainStemAPIPlatformControllersPurchasingOrdersDetailsOrderTotalsOverviewTotalDetails {
  /** @format double */
  discounts?: number
  /** @format double */
  fees?: number
  /** @format double */
  salesTax?: number
  /** @format double */
  shipping?: number
  /** @format double */
  subTotal?: number
  /** @format double */
  total?: number
}

export interface MainStemAPIPlatformControllersPurchasingOrdersDetailsOrderTotalsOverviewLineItemTotals {
  /** @format double */
  privateSubTotal?: number
  /** @format double */
  subTotal?: number
  /** @format double */
  totalQuantity?: number
  /** @format int32 */
  uniqueLineItems?: number
  /** @format double */
  verifiedSubTotal?: number
}

export interface MainStemAPIPlatformControllersPurchasingOrdersUpdateAPIRequest {
  /** @format date-time */
  dateRequiredBy?: string
  email?: string
  orderUUID?: string
  phone?: string
}

export interface MainStemAPIPlatformControllersPurchasingOrdersUpdateAddressAPIRequest {
  orderUUID?: string
  /** @format int32 */
  id?: number
  type?: 'ShipTo' | 'BillTo'
  address1?: string
  address2?: string
  city?: string
  name?: string
  state?: string
  country?: string
  zip?: string
}

export interface MainStemAPIPlatformControllersPurchasingPaymentMethodsCreateACHAPIRequest {
  accountNumber?: string
  accountType?: string
  bankName?: string
  /** @format int32 */
  locationId?: number
  nameOnAccount?: string
  nickname?: string
  routingNumber?: string
}

export interface MainStemAPIPlatformControllersPurchasingPaymentMethodsCreateACHAPIResponse {
  /** @format int32 */
  id?: number
  message?: string
  wasSuccessful?: boolean
}

export interface MainStemAPIPlatformControllersPurchasingPaymentMethodsCreateCreditCardAPIRequest {
  cvc?: string
  /** @format int32 */
  expirationMonth?: number
  /** @format int32 */
  expirationYear?: number
  /** @format int32 */
  locationId?: number
  name?: string
  number?: string
}

export interface MainStemAPIPlatformControllersPurchasingPaymentMethodsCreateCreditCardAPIResponse {
  /** @format int32 */
  id?: number
  message?: string
  wasSuccessful?: boolean
}

export interface MainStemAPIPlatformControllersPurchasingPaymentMethodsListAPIResponse {
  achs?: MainStemAPIPlatformControllersPurchasingPaymentMethodsListAPIResponseAccountDetails[]
  allowedOptions?: MainStemAPIPlatformControllersGlobalPaymentMethodsListAllowablePaymentOptions
  creditCards?: MainStemAPIPlatformControllersPurchasingPaymentMethodsListAPIResponseCreditCardDetails[]
  message?: string
  wasSuccessful?: boolean
}

export interface MainStemAPIPlatformControllersPurchasingPaymentMethodsListAPIResponseAccountDetails {
  /** @format int32 */
  id?: number
  last4OfACH?: string
  location?: MainStemAPIPlatformControllersPurchasingPaymentMethodsListAPIResponseLocationDetails
  nickname?: string
}

export interface MainStemAPIPlatformControllersGlobalPaymentMethodsListAllowablePaymentOptions {
  ach?: boolean
  creditCard?: boolean
}

export interface MainStemAPIPlatformControllersPurchasingPaymentMethodsListAPIResponseCreditCardDetails {
  /** @format date-time */
  expirationDate?: string
  /** @format int32 */
  id?: number
  issuer?: string
  last4OfCard?: string
  location?: MainStemAPIPlatformControllersPurchasingPaymentMethodsListAPIResponseLocationDetails
}

export interface MainStemAPIPlatformControllersPurchasingPaymentMethodsListAPIResponseLocationDetails {
  address1?: string
  address2?: string
  city?: string
  country?: string
  /** @format int32 */
  id?: number
  name?: string
  state?: string
  zip?: string
}

export interface MainStemAPIPlatformControllersPurchasingPermissionGroupCreateAPIRequest {
  name?: string
}

export interface MainStemAPIPlatformControllersPurchasingPermissionGroupCreateAPIResponse {
  /** @format int32 */
  id?: number
  message?: string
  wasSuccessful?: boolean
}

export interface MainStemAPIPlatformControllersPurchasingPermissionGroupDeleteAPIRequest {
  /** @format int32 */
  id?: number
}

export interface MainStemAPIPlatformControllersPurchasingPermissionGroupDeleteAPIResponse {
  message?: string
  wasSuccessful?: boolean
}

export interface MainStemAPIPlatformControllersPurchasingPermissionGroupListAPIResponse {
  permissionGroups?: MainStemAPIPlatformControllersPurchasingPermissionGroupListAPIResponsePermissionGroupDetail[]
  message?: string
  wasSuccessful?: boolean
}

export interface MainStemAPIPlatformControllersPurchasingPermissionGroupListAPIResponsePermissionGroupDetail {
  /** @format int32 */
  id?: number
  name?: string
  permissionGroupValues?: MainStemAPIPlatformControllersPurchasingPermissionGroupListAPIResponsePermissionGroupValueDetail[]
  /** @format int32 */
  permissionsAssigned?: number
  /** @format int32 */
  totalPermissionsCount?: number
  /** @format int32 */
  usersAssigned?: number
  usersAssignedToGroup?: MainStemAPIPlatformControllersPurchasingPermissionGroupListAPIResponseAssignedUserDetail[]
}

export interface MainStemAPIPlatformControllersPurchasingPermissionGroupListAPIResponsePermissionGroupValueDetail {
  displayName?: string
  group?: string
  /** @format int32 */
  id?: number
  /** @format int32 */
  permissionId?: number
  shortCode?: string
  value?: string
}

export interface MainStemAPIPlatformControllersPurchasingPermissionGroupListAPIResponseAssignedUserDetail {
  /** @format date-time */
  dateCreated?: string
  email?: string
  friendlyName?: string
  role?: string
  title?: string
  username?: string
  userRelated?: boolean
  uuid?: string
}

export interface MainStemAPIPlatformControllersPurchasingPermissionGroupUpdateAPIRequest {
  /** @format int32 */
  id?: number
  name?: string
}

export interface MainStemAPIPlatformControllersPurchasingPermissionGroupUpdateAPIResponse {
  message?: string
  wasSuccessful?: boolean
}

export interface MainStemAPIPlatformControllersPurchasingPermissionGroupUsersAddAPIRequest {
  /** @format int32 */
  permissionGroupId?: number
  userId?: string
}

export interface MainStemAPIPlatformControllersPurchasingPermissionGroupUsersAddAPIResponse {
  message?: string
  wasSuccessful?: boolean
}

export interface MainStemAPIPlatformControllersPurchasingPermissionGroupUsersNotInGroupAPIRequest {
  /** @format int32 */
  permissionGroupId?: number
}

export interface MainStemAPIPlatformControllersPurchasingPermissionGroupUsersNotInGroupAPIResponse {
  usersNotInGroup?: MainStemAPIPlatformControllersPurchasingPermissionGroupUsersNotInGroupAvailableForAssignmentUserDetail[]
  message?: string
  wasSuccessful?: boolean
}

export interface MainStemAPIPlatformControllersPurchasingPermissionGroupUsersNotInGroupAvailableForAssignmentUserDetail {
  /** @format date-time */
  dateCreated?: string
  email?: string
  friendlyName?: string
  permissionGroup?: string
  role?: string
  title?: string
  username?: string
  userRelated?: boolean
  uuid?: string
}

export interface MainStemAPIPlatformControllersPurchasingPermissionGroupUsersRemoveAPIRequest {
  /** @format int32 */
  permissionGroupId?: number
  userId?: string
}

export interface MainStemAPIPlatformControllersPurchasingPermissionGroupUsersRemoveAPIResponse {
  message?: string
  wasSuccessful?: boolean
}

export interface MainStemAPIPlatformControllersPurchasingPermissionGroupValueCreateAPIRequest {
  /** @format int32 */
  permissionGroupId?: number
  /** @format int32 */
  permissionId?: number
  value?: string
}

export interface MainStemAPIPlatformControllersPurchasingPermissionGroupValueCreateAPIResponse {
  /** @format int32 */
  id?: number
  message?: string
  wasSuccessful?: boolean
}

export interface MainStemAPIPlatformControllersPurchasingPermissionGroupValueDeleteAPIRequest {
  /** @format int32 */
  id?: number
}

export interface MainStemAPIPlatformControllersPurchasingPermissionGroupValueDeleteAPIResponse {
  message?: string
  wasSuccessful?: boolean
}

export interface MainStemAPIPlatformControllersPurchasingPermissionGroupValueListAPIRequest {
  /** @format int32 */
  permissionGroupId?: number
}

export interface MainStemAPIPlatformControllersPurchasingPermissionGroupValueListAPIResponse {
  permissionGroupDetail?: MainStemAPIPlatformControllersPurchasingPermissionGroupValueListPermissionGroupDetail
  message?: string
  wasSuccessful?: boolean
}

export interface MainStemAPIPlatformControllersPurchasingPermissionGroupValueListPermissionGroupDetail {
  /** @format int32 */
  id?: number
  name?: string
  permissionGroupValues?: MainStemAPIPlatformControllersPurchasingPermissionGroupValueListPermissionGroupValueDetail[]
  /** @format int32 */
  totalPermissionsCount?: number
  usersAssigned?: MainStemAPIPlatformControllersPurchasingPermissionGroupValueListAssignedUserDetail[]
}

export interface MainStemAPIPlatformControllersPurchasingPermissionGroupValueListPermissionGroupValueDetail {
  displayName?: string
  group?: string
  /** @format int32 */
  id?: number
  /** @format int32 */
  permissionId?: number
  shortCode?: string
  value?: string
}

export interface MainStemAPIPlatformControllersPurchasingPermissionGroupValueListAssignedUserDetail {
  /** @format date-time */
  dateCreated?: string
  email?: string
  friendlyName?: string
  permissionGroup?: string
  role?: string
  title?: string
  username?: string
  userRelated?: boolean
  uuid?: string
}

export interface MainStemAPIPlatformControllersPurchasingPermissionGroupValueUpdateAPIRequest {
  /** @format int32 */
  id?: number
  /** @format int32 */
  permissionGroupId?: number
  /** @format int32 */
  permissionId?: number
  value?: string
}

export interface MainStemAPIPlatformControllersPurchasingPermissionGroupValueUpdateAPIResponse {
  message?: string
  wasSuccessful?: boolean
}

export interface MainStemAPIPlatformControllersPurchasingPermissionListAPIResponse {
  error?: string
  permissions?: MainStemAPIPlatformControllersPurchasingPermissionListPermissionDetail[]
  message?: string
  wasSuccessful?: boolean
}

export interface MainStemAPIPlatformControllersPurchasingPermissionListPermissionDetail {
  displayName?: string
  group?: string
  /** @format int32 */
  id?: number
  /** @format int32 */
  rank?: number
  shortCode?: string
}

export interface MainStemAPIPlatformControllersPurchasingPrivateProductAttributeValuesCreateAPIRequest {
  /** @format int32 */
  attributeValueId?: number
  /** @format int32 */
  productId?: number
}

export interface MainStemAPIPlatformControllersPurchasingPrivateProductAttributeValuesDeleteAPIRequest {
  /** @format int32 */
  attributeValueId?: number
  /** @format int32 */
  productId?: number
}

export interface MainStemAPIPlatformControllersPurchasingPrivateProductVolumePricingCreateAPIRequest {
  /** @format double */
  price?: number
  /** @format int32 */
  productId?: number
  /** @format int32 */
  quantityHigh?: number
  /** @format int32 */
  quantityLow?: number
}

export interface MainStemAPIPlatformControllersPurchasingPrivateProductVolumePricingDeleteAPIRequest {
  /** @format int32 */
  productVolumePricingId?: number
}

export interface MainStemAPIPlatformControllersPurchasingPrivateSuppliersArchiveAPIRequest {
  /** @format int32 */
  supplierId?: number
}

export interface MainStemAPIPlatformControllersPurchasingPrivateSuppliersCreateAPIRequest {
  name?: string
  email?: string
  phone?: string
  address1?: string
  address2?: string
  city?: string
  state?: string
  zip?: string
  country?: string
  /** @format double */
  minimumOrderAmount?: number
}

export interface MainStemAPIPlatformControllersPurchasingPrivateSuppliersCreateAPIResponse {
  /** @format int32 */
  id?: number
  message?: string
  wasSuccessful?: boolean
}

export interface MainStemAPIPlatformControllersPurchasingPrivateSuppliersDeleteAPIRequest {
  /** @format int32 */
  supplierId?: number
}

export interface MainStemAPIPlatformControllersPurchasingSuppliersUpdateAPIRequest {
  /** @format int32 */
  id?: number
  name?: string
  email?: string
  phone?: string
  address1?: string
  address2?: string
  city?: string
  state?: string
  zip?: string
  country?: string
  isCannabisSupplier?: boolean
  /** @format double */
  minimumOrderAmount?: number
  paymentTerms?: string
  /** @format double */
  paymentTermsCreditLimit?: number
  /** @format int32 */
  paymentTermsDays?: number
  /** @format int32 */
  paymentTermsDiscountDays?: number
  /** @format double */
  paymentTermsDiscountPercent?: number
  /** @format double */
  paymentTermsPercent?: number
  /** @format double */
  paymentTermsPrePaymentPercent?: number
  requiresPrePayment?: boolean
  supplierReconciliationAIGuidance?: string
}

export interface MainStemAPIPlatformControllersPurchasingPrivateSuppliersDuplicateAPIRequest {
  name?: string
  /** @format int32 */
  supplierId?: number
}

export interface MainStemAPIPlatformControllersPurchasingPrivateSuppliersDuplicateAPIResponse {
  /** @format int32 */
  supplierId?: number
  message?: string
  wasSuccessful?: boolean
}

export interface MainStemAPIPlatformControllersPurchasingProductsAllocationsListAPIRequest {
  /** @format int32 */
  productId?: number
}

export interface MainStemAPIPlatformControllersPurchasingProductsAllocationsListAPIResponse {
  allocations?: MainStemAPIPlatformControllersPurchasingProductsAllocationsListAPIResponseAllocationDetails[]
  message?: string
  wasSuccessful?: boolean
}

export interface MainStemAPIPlatformControllersPurchasingProductsAllocationsListAPIResponseAllocationDetails {
  /** @format date-time */
  dateCreated?: string
  department?: MainStemAPIPlatformControllersPurchasingProductsAllocationsListAPIResponseAllocationDetailsDepartmentDetails
  /** @format int32 */
  id?: number
  order?: MainStemAPIPlatformControllersPurchasingProductsAllocationsListAPIResponseAllocationDetailsOrderDetails
  /** @format int32 */
  quantity?: number
  user?: MainStemAPIPlatformControllersPurchasingProductsAllocationsListAPIResponseAllocationDetailsUserDetails
}

export interface MainStemAPIPlatformControllersPurchasingProductsAllocationsListAPIResponseAllocationDetailsDepartmentDetails {
  /** @format int32 */
  id?: number
  name?: string
}

export interface MainStemAPIPlatformControllersPurchasingProductsAllocationsListAPIResponseAllocationDetailsOrderDetails {
  /** @format int32 */
  id?: number
  uuid?: string
}

export interface MainStemAPIPlatformControllersPurchasingProductsAllocationsListAPIResponseAllocationDetailsUserDetails {
  id?: string
  username?: string
}

export interface MainStemAPIPlatformControllersPurchasingProductsArchiveAPIRequest {
  /** @format int32 */
  productId?: number
}

export interface MainStemAPIPlatformControllersPurchasingProductsArchiveAPIResponse {
  message?: string
  wasSuccessful?: boolean
}

export interface MainStemAPIPlatformControllersPurchasingProductsAttributesListAPIRequest {
  /** @format int32 */
  productId?: number
}

export interface MainStemAPIPlatformControllersPurchasingProductsAttributesListAPIResponse {
  attributes?: MainStemAPIPlatformControllersPurchasingProductsAttributesListAPIResponseAttributeDetails[]
  message?: string
  wasSuccessful?: boolean
}

export interface MainStemAPIPlatformControllersPurchasingProductsAttributesListAPIResponseAttributeDetails {
  name?: string
  value?: string
}

export interface MainStemAPIPlatformControllersPurchasingProductsCatalogsListAPIRequest {
  /** @format int32 */
  productId: number
}

export interface MainStemAPIPlatformControllersPurchasingProductsCatalogsListAPIResponse {
  catalogs: MainStemAPIPlatformControllersPurchasingProductsCatalogsListAPIResponseCatalogDetails[]
  message?: string
  wasSuccessful?: boolean
}

export interface MainStemAPIPlatformControllersPurchasingProductsCatalogsListAPIResponseCatalogDetails {
  /** @format int32 */
  id: number
  name: string
}

export interface MainStemAPIPlatformControllersPurchasingProductsCreateAPIRequest {
  /** @format int32 */
  customerSessionID?: number
  description?: string
  /** @format int32 */
  financialDimensionOptionID?: number
  financialDimensions?: MainStemAPIPlatformControllersPurchasingProductsCreateAPIRequestFinancialDimensionUpdate[]
  /** @format double */
  height?: number
  /** @format int32 */
  imgFileID?: number
  /** @format double */
  length?: number
  /** @format int32 */
  maximumPurchasableQuantity?: number
  /** @format int32 */
  minimumPurchasableQuantity?: number
  name?: string
  /** @format double */
  priceEnterprise?: number
  /** @format double */
  priceRetail?: number
  /** @format double */
  priceWholesale?: number
  sku?: string
  /** @format int32 */
  supplierId?: number
  type?: string
  unitOfMeasureLabel?: string
  unitOfMeasureValue?: string
  /** @format double */
  weight?: number
  /** @format double */
  width?: number
}

export interface MainStemAPIPlatformControllersPurchasingProductsCreateAPIRequestFinancialDimensionUpdate {
  /** @format int32 */
  financialDimensionID?: number
  /** @format int32 */
  financialDimensionOptionID?: number
}

export interface MainStemAPIPlatformControllersPurchasingProductsCreateAPIResponse {
  /** @format int32 */
  id?: number
  message?: string
  wasSuccessful?: boolean
}

export interface MainStemAPIPlatformControllersPurchasingProductsDetailsAPIRequest {
  /** @format int32 */
  id?: number
}

export interface MainStemAPIPlatformControllersPurchasingProductsDetailsAPIResponse {
  childProducts?: MainStemAPIPlatformControllersPurchasingProductsDetailsAPIResponseProductDetail[]
  alternativeOptions?: MainStemAPIPlatformControllersPurchasingProductsDetailsAPIResponseAlternativeOptionDetails
  /** @format int32 */
  daysToFulfill?: number
  description?: string
  financialDimensions?: MainStemSDKHelpersFinancialDimensionsFactoryFinancialDimensionOptionSelectionDetail[]
  hasVolumePricing?: boolean
  /** @format double */
  height?: number
  /** @format int32 */
  id?: number
  images?: string[]
  integrations?: MainStemAPIPlatformControllersPurchasingProductsDetailsAPIResponseIntegrationDetails
  isCannabis?: boolean
  isOutOfStock?: boolean
  isPrivate?: boolean
  itemMaster?: boolean
  /** @format double */
  length?: number
  mainImage?: string
  /** @format int32 */
  maximumOrderAmount?: number
  /** @format int32 */
  minimumOrderAmount?: number
  /** @format double */
  msrp?: number
  name?: string
  /** @format double */
  priceAgreement?: number
  /** @format double */
  priceCustomerRetail?: number
  /** @format double */
  priceEnterprise?: number
  /** @format double */
  priceRetail?: number
  /** @format double */
  priceToUse?: number
  /** @format double */
  priceWholesale?: number
  skuInternal?: string
  /** @format int32 */
  soldInQuantitiesOf?: number
  supplier?: MainStemAPIPlatformControllersPurchasingProductsDetailsAPIResponseSupplierDetails
  tags?: string[]
  /** @format double */
  totalSpend?: number
  type?: string
  unitOfMeasureLabel?: string
  unitOfMeasureValue?: string
  upc?: string
  volumePricing?: MainStemAPIPlatformControllersPurchasingProductsDetailsAPIResponseVolumePricingDetails[]
  volumePricingPriceAgreement?: MainStemAPIPlatformControllersPurchasingProductsDetailsAPIResponseVolumePricingDetails[]
  /** @format double */
  weight?: number
  /** @format double */
  width?: number
  message?: string
  wasSuccessful?: boolean
}

export interface MainStemAPIPlatformControllersPurchasingProductsDetailsAPIResponseProductDetail {
  description?: string
  /** @format int32 */
  id?: number
  images?: string[]
  isOutOfStock?: boolean
  isPrivate?: boolean
  /** @format int32 */
  maximumOrderAmount?: number
  /** @format int32 */
  minimumOrderAmount?: number
  /** @format double */
  msrp?: number
  name?: string
  /** @format double */
  priceCustomerRetail?: number
  /** @format double */
  priceEnterprise?: number
  /** @format double */
  priceRetail?: number
  /** @format double */
  priceWholesale?: number
  skuInternal?: string
  /** @format int32 */
  supplierID?: number
  supplierName?: string
  tags?: string[]
  type?: string
}

export interface MainStemAPIPlatformControllersPurchasingProductsDetailsAPIResponseAlternativeOptionDetails {
  /** @format double */
  priceHighest?: number
  /** @format double */
  priceLowest?: number
  /** @format int32 */
  totalOptions?: number
}

export interface MainStemAPIPlatformControllersPurchasingProductsDetailsAPIResponseIntegrationDetails {
  quantumLeaf?: MainStemAPIPlatformControllersPurchasingProductsDetailsAPIResponseIntegrationDetailsQuantumLeafDetails
}

export interface MainStemAPIPlatformControllersPurchasingProductsDetailsAPIResponseSupplierDetails {
  city?: string
  country?: string
  /** @format int32 */
  id?: number
  integrationType?: string
  isPrivate?: boolean
  logo?: string
  name?: string
  state?: string
  usesDirectPay?: boolean
  usesPreferredShipping?: boolean
}

export interface MainStemAPIPlatformControllersPurchasingProductsDetailsAPIResponseVolumePricingDetails {
  /** @format int32 */
  id?: number
  /** @format double */
  price?: number
  /** @format int32 */
  quantityHigh?: number
  /** @format int32 */
  quantityLow?: number
}

export interface MainStemAPIPlatformControllersPurchasingProductsDetailsAPIResponseIntegrationDetailsQuantumLeafDetails {
  locationProductItemMaps?: MainStemAPIPlatformControllersPurchasingProductsDetailsAPIResponseIntegrationDetailsQuantumLeafDetailsLocationProductItemMap[]
}

export interface MainStemAPIPlatformControllersPurchasingProductsDetailsAPIResponseIntegrationDetailsQuantumLeafDetailsLocationProductItemMap {
  itemId?: string
  location?: MainStemAPIPlatformControllersPurchasingProductsDetailsAPIResponseIntegrationDetailsQuantumLeafDetailsLocationProductItemMapLocationDetails
  /** @format int32 */
  settingsId?: number
}

export interface MainStemAPIPlatformControllersPurchasingProductsDetailsAPIResponseIntegrationDetailsQuantumLeafDetailsLocationProductItemMapLocationDetails {
  /** @format int32 */
  id?: number
  name?: string
}

export interface MainStemAPIPlatformControllersPurchasingProductsDuplicateAPIRequest {
  name?: string
  /** @format int32 */
  productId?: number
}

export interface MainStemAPIPlatformControllersPurchasingProductsDuplicateAPIResponse {
  /** @format int32 */
  productId?: number
  message?: string
  wasSuccessful?: boolean
}

export interface MainStemAPIPlatformControllersPurchasingProductsListAPIResponse {
  products?: MainStemAPIPlatformControllersPurchasingProductsListAPIResponseProductDetails[]
  message?: string
  wasSuccessful?: boolean
}

export interface MainStemAPIPlatformControllersPurchasingProductsListAPIResponseProductDetails {
  /** @format date-time */
  firstOrderedDate?: string
  /** @format int32 */
  id?: number
  imgURL?: string
  isDeleted?: boolean
  isPrivate?: boolean
  /** @format date-time */
  lastOrderedDate?: string
  name?: string
  skuInternal?: string
  skuManufacturer?: string
  /** @format int32 */
  totalOrders?: number
  /** @format int32 */
  totalQuantityOrdered?: number
  /** @format int32 */
  vendorID?: number
  vendorName?: string
}

export interface MainStemAPIPlatformControllersPurchasingProductsOrdersListAPIRequest {
  /** @format int32 */
  productId?: number
}

export interface MainStemAPIPlatformControllersPurchasingProductsOrdersListAPIResponse {
  orders?: MainStemAPIPlatformControllersPurchasingProductsOrdersListAPIResponseOrderDetails[]
  message?: string
  wasSuccessful?: boolean
}

export interface MainStemAPIPlatformControllersPurchasingProductsOrdersListAPIResponseOrderDetails {
  /** @format date-time */
  dateApproved?: string
  /** @format date-time */
  dateCreated?: string
  /** @format double */
  discount?: number
  /** @format int32 */
  id?: number
  location?: MainStemAPIPlatformControllersPurchasingProductsOrdersListAPIResponseOrderDetailsLocationDetails
  /** @format double */
  orderTotal?: number
  paymentStatus?: string
  /** @format double */
  salesTax?: number
  /** @format double */
  shipping?: number
  status?: 'New' | 'PendingApproval' | 'Returned' | 'Approved' | 'Rejected' | 'Cancelled'
  /** @format double */
  subTotal?: number
  userApprovedBy?: string
  userCreatedBy?: string
  uuid?: string
}

export interface MainStemAPIPlatformControllersPurchasingProductsOrdersListAPIResponseOrderDetailsLocationDetails {
  address1?: string
  address2?: string
  city?: string
  country?: string
  /** @format int32 */
  id?: number
  name?: string
  state?: string
  zip?: string
}

export interface MainStemAPIPlatformControllersPurchasingProductsReceivingListAPIRequest {
  /** @format int32 */
  productId?: number
}

export interface MainStemAPIPlatformControllersPurchasingProductsReceivingListAPIResponse {
  receiving?: MainStemAPIPlatformControllersPurchasingProductsReceivingListAPIResponseReceivingDetails[]
  message?: string
  wasSuccessful?: boolean
}

export interface MainStemAPIPlatformControllersPurchasingProductsReceivingListAPIResponseReceivingDetails {
  /** @format int32 */
  id?: number
}

export interface MainStemAPIPlatformControllersPurchasingProductsShipmentsListAPIRequest {
  /** @format int32 */
  productId?: number
}

export interface MainStemAPIPlatformControllersPurchasingProductsShipmentsListAPIResponse {
  shipments?: MainStemAPIPlatformControllersPurchasingProductsShipmentsListAPIResponseShipmentDetails[]
  message?: string
  wasSuccessful?: boolean
}

export interface MainStemAPIPlatformControllersPurchasingProductsShipmentsListAPIResponseShipmentDetails {
  carrier?: string
  carrierType?: string
  /** @format date-time */
  dateCreated?: string
  /** @format date-time */
  dateReceived?: string
  /** @format date-time */
  dateShippedOn?: string
  /** @format date-time */
  estimatedDeliveryDate?: string
  /** @format int32 */
  orderID?: number
  orderUUID?: string
  trackingNumber?: string
  uuid?: string
}

export interface MainStemAPIPlatformControllersPurchasingProductsUpdateAPIRequest {
  description?: string
  financialDimensions?: MainStemAPIPlatformControllersPurchasingProductsUpdateAPIRequestFinancialDimensionUpdate[]
  /** @format double */
  height?: number
  /** @format int32 */
  id?: number
  isCannabis?: boolean
  isOutOfStock?: boolean
  /** @format double */
  length?: number
  /** @format int32 */
  maximumPurchasableQuantity?: number
  /** @format int32 */
  minimumPurchasableQuantity?: number
  /** @format double */
  msrp?: number
  name?: string
  /** @format double */
  priceCustomerRetail?: number
  /** @format double */
  priceEnterprise?: number
  /** @format double */
  priceRetail?: number
  /** @format double */
  priceWholesale?: number
  sku?: string
  /** @format int32 */
  supplierId?: number
  type?: string
  unitOfMeasureLabel?: string
  unitOfMeasureValue?: string
  /** @format double */
  weight?: number
  /** @format double */
  width?: number
}

export interface MainStemAPIPlatformControllersPurchasingProductsUpdateAPIRequestFinancialDimensionUpdate {
  /** @format int32 */
  financialDimensionID?: number
  /** @format int32 */
  financialDimensionOptionID?: number
}

export interface MainStemAPIPlatformControllersPurchasingProductsUpdateAPIResponse {
  /** @format int32 */
  id?: number
  message?: string
  wasSuccessful?: boolean
}

export interface MainStemAPIPlatformControllersPurchasingPunchoutsRequestSessionAPIRequest {
  /** @format int32 */
  integrationSettingID?: number
  /** @format int32 */
  locationID?: number
  returnUrl?: string
}

export interface MainStemAPIPlatformControllersPurchasingPunchoutsRequestSessionAPIResponse {
  url?: string
  cXmlDocument?: string
  redirectUrl?: string
  message?: string
  wasSuccessful?: boolean
}

export interface MainStemAPIPlatformControllersPurchasingPunchoutsSettingsAddLocationsAPIRequest {
  locationIds?: number[]
  /** @format int32 */
  customerSettingsID?: number
}

export interface MainStemAPIPlatformControllersPurchasingPunchoutsSettingsCreatePunchoutAPIRequest {
  punchoutSupplierName?: string
  punchoutSupplierEmail?: string
  /** @format int32 */
  privateSupplierID?: number
  description?: string
  locationIds?: number[]
  senderIdentity?: string
  senderIdentityType?: string
  supplierIdentity?: string
  supplierIdentityType?: string
  sharedSecret?: string
  punchoutUrl?: string
  requiresNewWindow?: boolean
  cXmlOrderProcessingAllowed?: boolean
  cXmlUseSeparateDeliveryUrl?: boolean
  cXmlSeparateDeliveryUrl?: string
  defaultOrderProcessingEmail?: string
  orderEmailNote?: string
}

export interface MainStemAPIPlatformControllersPurchasingPunchoutsSettingsCreatePunchoutAPIResponse {
  /** @format int32 */
  id?: number
  message?: string
  wasSuccessful?: boolean
}

export interface MainStemAPIPlatformControllersPurchasingPunchoutsSettingsDetailsAPIRequest {
  /** @format int32 */
  id?: number
}

export interface MainStemAPIPlatformControllersPurchasingPunchoutsSettingsDetailsAPIResponse {
  assignedLocations?: MainStemAPIPlatformControllersPurchasingPunchoutsSettingsDetailsLocationDetails[]
  cXmlOrderProcessingAllowed?: boolean
  cXmlSeparateDeliveryUrl?: string
  cXmlUseSeparateDeliveryUrl?: boolean
  defaultOrderProcessingEmail?: string
  description?: string
  fileUrl?: string
  /** @format int32 */
  id?: number
  isActive?: boolean
  orderEmailNote?: string
  orders?: MainStemAPIPlatformControllersPurchasingPunchoutsSettingsDetailsAPIResponseOrderDetails[]
  /** @format int32 */
  privateSupplierID?: number
  punchoutSupplierName?: string
  punchoutUrl?: string
  requiresNewWindow?: boolean
  senderIdentity?: string
  senderIdentityType?: string
  sharedSecret?: string
  supplierIdentity?: string
  supplierIdentityType?: string
  message?: string
  wasSuccessful?: boolean
}

export interface MainStemAPIPlatformControllersPurchasingPunchoutsSettingsDetailsLocationDetails {
  /** @format int32 */
  id?: number
  name?: string
}

export interface MainStemAPIPlatformControllersPurchasingPunchoutsSettingsDetailsAPIResponseOrderDetails {
  approvalStatus?: 'SavedCart' | 'AwaitingApproval' | 'Approval' | 'ApprovalWithEdits' | 'Rejected'
  /** @format date-time */
  dateApproved?: string
  /** @format date-time */
  dateCreated?: string
  /** @format double */
  discount?: number
  /** @format int32 */
  id?: number
  location?: MainStemAPIPlatformControllersPurchasingPunchoutsSettingsDetailsAPIResponseOrderDetailsLocationDetails
  /** @format double */
  orderTotal?: number
  paymentStatus?: string
  /** @format double */
  salesTax?: number
  /** @format double */
  shipping?: number
  status?: string
  /** @format double */
  subTotal?: number
  userApprovedBy?: string
  userCreatedBy?: string
  userRelated?: boolean
  uuid?: string
}

export interface MainStemAPIPlatformControllersPurchasingPunchoutsSettingsDetailsAPIResponseOrderDetailsLocationDetails {
  address1?: string
  address2?: string
  city?: string
  country?: string
  /** @format int32 */
  id?: number
  name?: string
  state?: string
  zip?: string
}

export interface MainStemAPIPlatformControllersPurchasingPunchoutsSettingsListAPIResponse {
  list?: MainStemAPIPlatformControllersPurchasingPunchoutsSettingsListAPIResponsePunchoutDetail[]
  message?: string
  wasSuccessful?: boolean
}

export interface MainStemAPIPlatformControllersPurchasingPunchoutsSettingsListAPIResponsePunchoutDetail {
  description?: string
  /** @format int32 */
  id?: number
  isActive?: boolean
  punchoutSupplierName?: string
  /** @format int32 */
  privateSupplierID?: number
  fileUrl?: string
  senderIdentity?: string
  senderIdentityType?: string
  supplierIdentity?: string
  supplierIdentityType?: string
  sharedSecret?: string
  punchoutUrl?: string
  cXmlOrderProcessingAllowed?: boolean
  cXmlUseSeparateDeliveryUrl?: boolean
  cXmlSeparateDeliveryUrl?: string
  defaultOrderProcessingEmail?: string
  assignedLocations?: MainStemAPIPlatformControllersPurchasingPunchoutsSettingsListLocationDetails[]
  requiresNewWindow?: boolean
}

export interface MainStemAPIPlatformControllersPurchasingPunchoutsSettingsListLocationDetails {
  /** @format int32 */
  id?: number
  name?: string
}

export interface MainStemAPIPlatformControllersPurchasingPunchoutsSettingsRemoveLocationsAPIRequest {
  locationIds?: number[]
  /** @format int32 */
  customerSettingsID?: number
}

export interface MainStemAPIPlatformControllersPurchasingPunchoutsSettingsUpdateAPIRequest {
  description?: string
  /** @format int32 */
  id?: number
  locationIds?: number[]
  punchoutSupplierName?: string
  /** @format int32 */
  privateSupplierID?: number
  senderIdentity?: string
  senderIdentityType?: string
  supplierIdentity?: string
  supplierIdentityType?: string
  sharedSecret?: string
  punchoutUrl?: string
  cXmlOrderProcessingAllowed?: boolean
  cXmlUseSeparateDeliveryUrl?: boolean
  cXmlSeparateDeliveryUrl?: string
  defaultOrderProcessingEmail?: string
  orderEmailNote?: string
  requiresNewWindow?: boolean
}

export interface MainStemAPIPlatformControllersPurchasingPunchoutsOrderCompleteAPIRequest {
  buyersCookie?: string
}

export interface MainStemAPIPlatformControllersPurchasingPunchoutsOrderCompleteAPIResponse {
  orderUUID?: string
  message?: string
  wasSuccessful?: boolean
}

export interface MainStemAPIPlatformControllersPurchasingPurchaseOrdersDiscountsCreateAPIRequest {
  /** @format double */
  amount?: number
  notes?: string
  /** @format int32 */
  purchaseOrderId?: number
  reason?: string
}

export interface MainStemAPIPlatformControllersPurchasingPurchaseOrdersDiscountsCreateAPIResponse {
  /** @format int32 */
  id?: number
  message?: string
  wasSuccessful?: boolean
}

export interface MainStemAPIPlatformControllersPurchasingPurchaseOrdersFeesCreateAPIRequest {
  /** @format double */
  amount?: number
  notes?: string
  /** @format int32 */
  purchaseOrderId?: number
  reason?: string
}

export interface MainStemAPIPlatformControllersPurchasingPurchaseOrdersFeesCreateAPIResponse {
  /** @format int32 */
  id?: number
  message?: string
  wasSuccessful?: boolean
}

export interface MainStemAPIPlatformControllersPurchasingPurchaseOrdersFeesDeleteAPIRequest {
  /** @format int32 */
  purchaseOrderFeeId: number
}

export interface MainStemAPIPlatformControllersPurchasingPurchaseOrdersFeesDeleteAPIResponse {
  message?: string
  wasSuccessful?: boolean
}

export interface MainStemAPIPlatformControllersPurchasingPurchaseOrdersAllocationsDeleteAPIRequest {
  allocations?: MainStemAPIPlatformControllersPurchasingPurchaseOrdersAllocationsDeleteAPIRequestAllocationDetails[]
}

export interface MainStemAPIPlatformControllersPurchasingPurchaseOrdersAllocationsDeleteAPIRequestAllocationDetails {
  /** @format int32 */
  lineItemId?: number
  type?: 'Shipping' | 'Fees' | 'Discounts' | 'SalesTax'
}

export interface MainStemAPIPlatformControllersPurchasingPurchaseOrdersAllocationsDeleteAPIResponse {
  message?: string
  wasSuccessful?: boolean
}

export interface MainStemAPIPlatformControllersPurchasingPurchaseOrdersAllocationsEnableAPIRequest {
  allocations?: MainStemAPIPlatformControllersPurchasingPurchaseOrdersAllocationsEnableAPIRequestAllocationDetails[]
}

export interface MainStemAPIPlatformControllersPurchasingPurchaseOrdersAllocationsEnableAPIRequestAllocationDetails {
  /** @format int32 */
  lineItemId?: number
  type?: 'Shipping' | 'Fees' | 'Discounts' | 'SalesTax'
}

export interface MainStemAPIPlatformControllersPurchasingPurchaseOrdersAllocationsEnableAPIResponse {
  message?: string
  wasSuccessful?: boolean
}

export interface MainStemAPIPlatformControllersPurchasingPurchaseOrdersAllocationsUpdateAPIRequest {
  /** @format double */
  amount?: number
  /** @format int32 */
  lineItemId?: number
  type?: 'Shipping' | 'Fees' | 'Discounts' | 'SalesTax'
}

export interface MainStemAPIPlatformControllersPurchasingPurchaseOrdersAllocationsUpdateAPIResponse {
  message?: string
  wasSuccessful?: boolean
}

export interface MainStemAPIPlatformControllersPurchasingPurchaseOrdersDetailsAPIRequest {
  /** @format int32 */
  id: number
}

export interface MainStemAPIPlatformControllersPurchasingPurchaseOrdersDetailsAPIResponse {
  purchaseOrder?: MainStemAPIPlatformHelpersPurchaseOrdersResponsePurchaseOrderDetails
  message?: string
  wasSuccessful?: boolean
}

export interface MainStemAPIPlatformControllersPurchasingPurchaseOrdersListAPIResponse {
  purchaseOrders?: MainStemAPIPlatformControllersPurchasingPurchaseOrdersListAPIResponsePurchaseOrderDetails[]
  message?: string
  wasSuccessful?: boolean
}

export interface MainStemAPIPlatformControllersPurchasingPurchaseOrdersListAPIResponsePurchaseOrderDetails {
  /** @format date-time */
  dateCreated?: string
  /** @format int32 */
  id?: number
  location?: MainStemAPIPlatformControllersPurchasingPurchaseOrdersListAPIResponsePurchaseOrderDetailsLocationDetails
  order?: MainStemAPIPlatformControllersPurchasingPurchaseOrdersListAPIResponsePurchaseOrderDetailsOrderDetails
  /** @format double */
  salesTax?: number
  /** @format double */
  shipping?: number
  supplier?: MainStemAPIPlatformControllersPurchasingPurchaseOrdersListAPIResponsePurchaseOrderDetailsSupplierDetails
}

export interface MainStemAPIPlatformControllersPurchasingPurchaseOrdersListAPIResponsePurchaseOrderDetailsLocationDetails {
  address1?: string
  address2?: string
  city?: string
  country?: string
  /** @format int32 */
  id?: number
  name?: string
  state?: string
  zip?: string
}

export interface MainStemAPIPlatformControllersPurchasingPurchaseOrdersListAPIResponsePurchaseOrderDetailsOrderDetails {
  /** @format int32 */
  id?: number
  /**
   * @format uuid
   * @example "00000000-0000-0000-0000-000000000000"
   */
  uuid?: string
}

export interface MainStemAPIPlatformControllersPurchasingPurchaseOrdersListAPIResponsePurchaseOrderDetailsSupplierDetails {
  /** @format int32 */
  id?: number
  inNetwork?: boolean
  name?: string
}

export interface MainStemAPIPlatformControllersPurchasingPurchaseOrdersSalesTaxCalculateAPIRequest {
  /** @format int32 */
  purchaseOrderId?: number
}

export interface MainStemAPIPlatformControllersPurchasingPurchaseOrdersSalesTaxCalculateAPIResponse {
  message?: string
  wasSuccessful?: boolean
}

export interface MainStemAPIPlatformControllersPurchasingPurchaseOrdersSalesTaxUpdateAPIRequest {
  /** @format double */
  amount?: number
  /** @format int32 */
  purchaseOrderId?: number
}

export interface MainStemAPIPlatformControllersPurchasingPurchaseOrdersSalesTaxUpdateAPIResponse {
  message?: string
  wasSuccessful?: boolean
}

export interface MainStemAPIPlatformControllersPurchasingPurchaseOrdersShippingCalculateAPIRequest {
  /** @format int32 */
  purchaseOrderId?: number
}

export interface MainStemAPIPlatformControllersPurchasingPurchaseOrdersShippingCalculateAPIResponse {
  message?: string
  wasSuccessful?: boolean
}

export interface MainStemAPIPlatformControllersPurchasingPurchaseOrdersShippingUpdateAPIRequest {
  /** @format double */
  amount?: number
  carrier?: string
  method?: string
  /** @format int32 */
  purchaseOrderId?: number
}

export interface MainStemAPIPlatformControllersPurchasingPurchaseOrdersShippingUpdateAPIResponse {
  message?: string
  wasSuccessful?: boolean
}

export interface MainStemAPIPlatformControllersPurchasingIntegrationQuickBooksItemsCreateManyAPIRequest {
  /** @format int32 */
  integrationSettingID?: number
  productIDs?: number[]
}

export interface MainStemAPIPlatformControllersPurchasingIntegrationQuickBooksItemsCreateManyAPIResponse {
  errorResponses?: string[]
  message?: string
  wasSuccessful?: boolean
}

export interface MainStemAPIPlatformControllersPurchasingIntegrationQuickBooksCustomerProductsAPIRequest {
  /** @format int32 */
  integrationSettingID?: number
  baseRequest?: object
  /** @format int32 */
  customerID?: number
  /** @format int32 */
  businessPartnerId?: number
  businessPartners?: MainStemSDKDataModelsBusinessPartner[]
  /** @format int32 */
  locationID?: number
  isAdmin?: boolean
}

export interface MainStemAPIPlatformControllersPurchasingIntegrationQuickBooksCustomerProductsAPIResponse {
  products?: MainStemAPIPlatformControllersPurchasingIntegrationQuickBooksCustomerProductsAPIResponseProductDetail[]
  message?: string
  wasSuccessful?: boolean
}

export interface MainStemAPIPlatformControllersPurchasingIntegrationQuickBooksCustomerProductsAPIResponseProductDetail {
  /** @format int32 */
  id?: number
  name?: string
  skuInternal?: string
  itemID?: string
  /** @format int32 */
  supplierID?: number
  supplierName?: string
  isPrivate?: boolean
  image?: string
  inCreateQueue?: boolean
  /** @format date-time */
  queuedAt?: string
}

export interface MainStemAPIPlatformControllersPurchasingIntegrationQuickBooksItemsUpdateItemLinksAPIRequest {
  /** @format int32 */
  integrationSettingID?: number
  linkUpdates?: MainStemAPIPlatformControllersPurchasingIntegrationQuickBooksItemsUpdateItemLinksUpdateLinkDetail[]
}

export interface MainStemAPIPlatformControllersPurchasingIntegrationQuickBooksItemsUpdateItemLinksUpdateLinkDetail {
  /** @format int32 */
  productID?: number
  itemID?: string
}

export interface MainStemAPIPlatformControllersPurchasingIntegrationQuickBooksItemsUpdateItemLinksAPIResponse {
  itemId?: string
  message?: string
  wasSuccessful?: boolean
}

export interface MainStemAPIPlatformControllersPurchasingReceivingDashboardAPIResponse {
  needToReceiveInvoices?: MainStemAPIPlatformControllersPurchasingReceivingDashboardAPIResponseNeedToReceiveInvoiceDetails[]
  needToReceiveItems?: MainStemAPIPlatformControllersPurchasingReceivingDashboardAPIResponseNeedToReceiveItemDetails[]
  alreadyReceivedInvoices?: MainStemAPIPlatformControllersPurchasingReceivingDashboardAPIResponseAlreadyReceivedInvoiceDetails[]
  alreadyReceivedItems?: MainStemAPIPlatformControllersPurchasingReceivingDashboardAPIResponseAlreadyReceivedItemDetails[]
  message?: string
  wasSuccessful?: boolean
}

export interface MainStemAPIPlatformControllersPurchasingReceivingDashboardAPIResponseNeedToReceiveInvoiceDetails {
  /** @format date-time */
  dateApproved?: string
  /** @format date-time */
  datePromisedBy?: string
  /** @format date-time */
  dateShipped?: string
  /** @format int32 */
  fulfillmentID?: number
  invoiceID?: string
  /**
   * @format uuid
   * @example "00000000-0000-0000-0000-000000000000"
   */
  uuid?: string
  /** @format int32 */
  locationID?: number
  locationName?: string
  /** @format int32 */
  orderID?: number
  /**
   * @format uuid
   * @example "00000000-0000-0000-0000-000000000000"
   */
  orderUUID?: string
  /** @format int32 */
  quantity?: number
  /** @format int32 */
  supplierID?: number
  supplierName?: string
  /** @format int32 */
  totalReceived?: number
}

export interface MainStemAPIPlatformControllersPurchasingReceivingDashboardAPIResponseNeedToReceiveItemDetails {
  /** @format date-time */
  dateApproved?: string
  /** @format date-time */
  datePromisedBy?: string
  /** @format date-time */
  dateShipped?: string
  /** @format int32 */
  fulfillmentID?: number
  invoiceID?: string
  /**
   * @format uuid
   * @example "00000000-0000-0000-0000-000000000000"
   */
  uuid?: string
  /** @format int32 */
  invoiceLineItemID?: number
  /** @format int32 */
  locationID?: number
  locationName?: string
  /** @format int32 */
  orderID?: number
  /**
   * @format uuid
   * @example "00000000-0000-0000-0000-000000000000"
   */
  orderUUID?: string
  /** @format int32 */
  productID?: number
  productName?: string
  /** @format int32 */
  quantity?: number
  /** @format int32 */
  supplierID?: number
  supplierName?: string
  /** @format int32 */
  totalReceived?: number
}

export interface MainStemAPIPlatformControllersPurchasingReceivingDashboardAPIResponseAlreadyReceivedInvoiceDetails {
  /** @format date-time */
  dateApproved?: string
  /** @format date-time */
  datePromisedBy?: string
  /** @format date-time */
  dateShipped?: string
  /** @format int32 */
  fulfillmentID?: number
  invoiceID?: string
  /**
   * @format uuid
   * @example "00000000-0000-0000-0000-000000000000"
   */
  uuid?: string
  /** @format int32 */
  locationID?: number
  locationName?: string
  /** @format int32 */
  orderID?: number
  /**
   * @format uuid
   * @example "00000000-0000-0000-0000-000000000000"
   */
  orderUUID?: string
  /** @format int32 */
  quantity?: number
  /** @format int32 */
  supplierID?: number
  supplierName?: string
  /** @format int32 */
  totalReceived?: number
}

export interface MainStemAPIPlatformControllersPurchasingReceivingDashboardAPIResponseAlreadyReceivedItemDetails {
  /** @format date-time */
  dateApproved?: string
  /** @format date-time */
  datePromisedBy?: string
  /** @format date-time */
  dateShipped?: string
  /** @format int32 */
  fulfillmentID?: number
  invoiceID?: string
  /**
   * @format uuid
   * @example "00000000-0000-0000-0000-000000000000"
   */
  uuid?: string
  /** @format int32 */
  invoiceLineItemID?: number
  /** @format int32 */
  locationID?: number
  locationName?: string
  /** @format int32 */
  orderID?: number
  /**
   * @format uuid
   * @example "00000000-0000-0000-0000-000000000000"
   */
  orderUUID?: string
  /** @format int32 */
  productID?: number
  productName?: string
  /** @format int32 */
  quantity?: number
  /** @format int32 */
  supplierID?: number
  supplierName?: string
  /** @format int32 */
  totalReceived?: number
}

export interface MainStemAPIPlatformControllersPurchasingReportsAccrualsAPIRequest {
  /** @format date-time */
  dateEnd?: string
  /** @format date-time */
  dateStart?: string
}

export interface MainStemAPIPlatformControllersPurchasingReportsAccrualsAPIResponse {
  customFields?: MainStemAPIPlatformControllersPurchasingReportsAccrualsAPIResponseCustomFieldDetails[]
  lineItems?: MainStemAPIPlatformControllersPurchasingReportsAccrualsAPIResponseLineItemDetails[]
  message?: string
  wasSuccessful?: boolean
}

export interface MainStemAPIPlatformControllersPurchasingReportsAccrualsAPIResponseCustomFieldDetails {
  /** @format int32 */
  id?: number
  key?: string
  type?: string
  value?: string
}

export interface MainStemAPIPlatformControllersPurchasingReportsAccrualsAPIResponseLineItemDetails {
  customFields?: MainStemAPIPlatformControllersPurchasingReportsAccrualsAPIResponseCustomFieldDetails[]
  /** @format date-time */
  dateInvoiceShipped?: string
  /** @format date-time */
  dateOrderApproved?: string
  /** @format date-time */
  dateOrderCreated?: string
  /** @format date-time */
  dateOrderSubmitted?: string
  /** @format int32 */
  invoiceId?: number
  location?: MainStemAPIPlatformControllersPurchasingReportsAccrualsAPIResponseLineItemDetailsLocationDetails
  /** @format int32 */
  orderId?: number
  orderInvoiceId?: string
  orderType?: 'InNetwork' | 'Private' | 'PunchOut'
  /** @format double */
  perItemCost?: number
  product?: MainStemAPIPlatformControllersPurchasingReportsAccrualsAPIResponseLineItemDetailsProductDetails
  /** @format double */
  quantity?: number
  status?: 'New' | 'PendingApproval' | 'Returned' | 'Approved' | 'Rejected' | 'Cancelled'
  /** @format double */
  subTotal?: number
  supplier?: MainStemAPIPlatformControllersPurchasingReportsAccrualsAPIResponseLineItemDetailsSupplierDetails
  userApprovedBy?: string
  userCreatedBy?: string
  userSubmittedBy?: string
}

export interface MainStemAPIPlatformControllersPurchasingReportsAccrualsAPIResponseLineItemDetailsLocationDetails {
  /** @format int32 */
  id?: number
  name?: string
}

export interface MainStemAPIPlatformControllersPurchasingReportsAccrualsAPIResponseLineItemDetailsProductDetails {
  /** @format int32 */
  id?: number
  name?: string
  type?: string
}

export interface MainStemAPIPlatformControllersPurchasingReportsAccrualsAPIResponseLineItemDetailsSupplierDetails {
  /** @format int32 */
  id?: number
  name?: string
}

export interface MainStemAPIPlatformControllersPurchasingReportsLineItemAPIRequest {
  /** @format date-time */
  dateEnd?: string
  /** @format date-time */
  dateStart?: string
}

export interface MainStemAPIPlatformControllersPurchasingReportsLineItemAPIResponse {
  customFields?: MainStemAPIPlatformControllersPurchasingReportsLineItemAPIResponseCustomFieldDetails[]
  lineItems?: MainStemAPIPlatformControllersPurchasingReportsLineItemAPIResponseLineItemDetails[]
  message?: string
  wasSuccessful?: boolean
}

export interface MainStemAPIPlatformControllersPurchasingReportsLineItemAPIResponseCustomFieldDetails {
  /** @format int32 */
  id?: number
  key?: string
  label?: string
  type?: string
  value?: string
}

export interface MainStemAPIPlatformControllersPurchasingReportsLineItemAPIResponseLineItemDetails {
  customFields?: MainStemAPIPlatformControllersPurchasingReportsLineItemAPIResponseCustomFieldDetails[]
  /** @format date-time */
  dateInvoiceShipped?: string
  /** @format date-time */
  dateOrderApproved?: string
  /** @format date-time */
  dateOrderCreated?: string
  /** @format date-time */
  dateOrderRequiredBy?: string
  /** @format date-time */
  dateOrderSubmitted?: string
  /** @format int32 */
  invoiceId: number
  location?: MainStemAPIPlatformControllersPurchasingReportsLineItemAPIResponseLineItemDetailsLocationDetails
  /** @format int32 */
  orderId: number
  orderInvoiceId?: string
  orderType: 'InNetwork' | 'Private' | 'PunchOut'
  /** @format double */
  perItemCost: number
  product: MainStemAPIPlatformControllersPurchasingReportsLineItemAPIResponseLineItemDetailsProductDetails
  /** @format int32 */
  purchaseOrderId: number
  /** @format double */
  quantity: number
  status?: 'New' | 'PendingApproval' | 'Returned' | 'Approved' | 'Rejected' | 'Cancelled'
  /** @format double */
  subTotal: number
  supplier: MainStemAPIPlatformControllersPurchasingReportsLineItemAPIResponseLineItemDetailsSupplierDetails
  userApprovedBy?: string
  userCreatedBy?: string
  userSubmittedBy?: string
}

export interface MainStemAPIPlatformControllersPurchasingReportsLineItemAPIResponseLineItemDetailsLocationDetails {
  /** @format int32 */
  id: number
  name?: string
}

export interface MainStemAPIPlatformControllersPurchasingReportsLineItemAPIResponseLineItemDetailsProductDetails {
  /** @format int32 */
  id?: number
  name?: string
  type?: string
}

export interface MainStemAPIPlatformControllersPurchasingReportsLineItemAPIResponseLineItemDetailsSupplierDetails {
  /** @format int32 */
  id?: number
  name?: string
}

export interface MainStemAPIPlatformControllersPurchasingReportsOpenOrdersAPIResponse {
  orders?: MainStemAPIPlatformControllersPurchasingReportsOpenOrdersAPIResponseOrderDetails[]
  message?: string
  wasSuccessful?: boolean
}

export interface MainStemAPIPlatformControllersPurchasingReportsOpenOrdersAPIResponseOrderDetails {
  approvalStatus?: 'SavedCart' | 'AwaitingApproval' | 'Approval' | 'ApprovalWithEdits' | 'Rejected'
  /** @format date-time */
  dateApproved?: string
  /** @format date-time */
  dateCreated?: string
  /** @format double */
  discount?: number
  /** @format int32 */
  id?: number
  isPrivateOrder?: boolean
  location?: MainStemAPIPlatformControllersPurchasingReportsOpenOrdersAPIResponseOrderDetailsLocationDetails
  make?: string
  /** @format double */
  orderTotal?: number
  paymentStatus?: string
  /** @format double */
  salesTax?: number
  /** @format double */
  shipping?: number
  status?: 'New' | 'PendingApproval' | 'Returned' | 'Approved' | 'Rejected' | 'Cancelled'
  /** @format double */
  subTotal?: number
  userApprovedBy?: string
  userCreatedBy?: string
  userRelated?: boolean
  uuid?: string
}

export interface MainStemAPIPlatformControllersPurchasingReportsOpenOrdersAPIResponseOrderDetailsLocationDetails {
  address1?: string
  address2?: string
  city?: string
  country?: string
  /** @format int32 */
  id?: number
  name?: string
  state?: string
  zip?: string
}

export interface MainStemAPIPlatformControllersPurchasingReportsOrdersAPIRequest {
  /** @format date-time */
  dateEnd?: string
  /** @format date-time */
  dateStart?: string
}

export interface MainStemAPIPlatformControllersPurchasingReportsOrdersAPIResponse {
  orders?: MainStemAPIPlatformControllersPurchasingReportsOrdersAPIResponseOrderDetails[]
  message?: string
  wasSuccessful?: boolean
}

export interface MainStemAPIPlatformControllersPurchasingReportsOrdersAPIResponseOrderDetails {
  approvalStatus?: 'SavedCart' | 'AwaitingApproval' | 'Approval' | 'ApprovalWithEdits' | 'Rejected'
  /** @format date-time */
  dateApproved?: string
  /** @format date-time */
  dateCreated?: string
  /** @format double */
  discount?: number
  /** @format int32 */
  id?: number
  isPrivateOrder?: boolean
  location?: MainStemAPIPlatformControllersPurchasingReportsOrdersAPIResponseOrderDetailsLocationDetails
  make?: string
  /** @format double */
  orderTotal?: number
  paymentStatus?: string
  /** @format double */
  salesTax?: number
  /** @format double */
  shipping?: number
  status?: 'New' | 'PendingApproval' | 'Returned' | 'Approved' | 'Rejected' | 'Cancelled'
  /** @format double */
  subTotal?: number
  userApprovedBy?: string
  userCreatedBy?: string
  userRelated?: boolean
  uuid?: string
}

export interface MainStemAPIPlatformControllersPurchasingReportsOrdersAPIResponseOrderDetailsLocationDetails {
  address1?: string
  address2?: string
  city?: string
  country?: string
  /** @format int32 */
  id?: number
  name?: string
  state?: string
  zip?: string
}

export interface MainStemAPIPlatformControllersPurchasingReportsPunchOutsAPIResponse {
  orders?: MainStemAPIPlatformControllersPurchasingReportsPunchOutsAPIResponseOrderDetails[]
}

export interface MainStemAPIPlatformControllersPurchasingReportsPunchOutsAPIResponseOrderDetails {
  approvalStatus?: 'SavedCart' | 'AwaitingApproval' | 'Approval' | 'ApprovalWithEdits' | 'Rejected'
  /** @format date-time */
  dateApproved?: string
  /** @format date-time */
  dateCreated?: string
  /** @format double */
  discount?: number
  /** @format int32 */
  id?: number
  isPrivateOrder?: boolean
  location?: MainStemAPIPlatformControllersPurchasingReportsPunchOutsAPIResponseOrderDetailsLocationDetails
  make?: string
  /** @format double */
  orderTotal?: number
  paymentStatus?: string
  /** @format double */
  salesTax?: number
  /** @format double */
  shipping?: number
  status?: 'New' | 'PendingApproval' | 'Returned' | 'Approved' | 'Rejected' | 'Cancelled'
  /** @format double */
  subTotal?: number
  userApprovedBy?: string
  userCreatedBy?: string
  userRelated?: boolean
  uuid?: string
}

export interface MainStemAPIPlatformControllersPurchasingReportsPunchOutsAPIResponseOrderDetailsLocationDetails {
  address1?: string
  address2?: string
  city?: string
  country?: string
  /** @format int32 */
  id?: number
  name?: string
  state?: string
  zip?: string
}

export interface MainStemAPIPlatformControllersPurchasingRequisitionApproveDetailsAPIRequest {
  orderUUID?: string
}

export interface MainStemAPIPlatformControllersPurchasingRequisitionApproveDetailsAPIResponse {
  requisition?: MainStemAPIPlatformControllersPurchasingRequisitionApproveDetailsAPIResponseRequisitionDetails
  message?: string
  wasSuccessful?: boolean
}

export interface MainStemAPIPlatformControllersPurchasingRequisitionApproveDetailsAPIResponseRequisitionDetails {
  billTo?: MainStemAPIPlatformControllersPurchasingRequisitionApproveDetailsAPIResponseRequisitionDetailsAddressDetails
  email?: string
  /** @format int32 */
  id?: number
  location?: MainStemAPIPlatformControllersPurchasingRequisitionApproveDetailsAPIResponseRequisitionDetailsLocationDetails
  phone?: string
  purchaseOrders?: MainStemAPIPlatformHelpersPurchaseOrdersResponsePurchaseOrderDetails[]
  shipTo?: MainStemAPIPlatformControllersPurchasingRequisitionApproveDetailsAPIResponseRequisitionDetailsAddressDetails
  totals?: MainStemAPIPlatformControllersPurchasingRequisitionApproveDetailsAPIResponseRequisitionDetailsTotalDetails
}

export interface MainStemAPIPlatformControllersPurchasingRequisitionApproveDetailsAPIResponseRequisitionDetailsAddressDetails {
  address1?: string
  address2?: string
  city?: string
  country?: string
  name?: string
  state?: string
  zip?: string
}

export interface MainStemAPIPlatformControllersPurchasingRequisitionApproveDetailsAPIResponseRequisitionDetailsLocationDetails {
  address?: MainStemAPIPlatformControllersPurchasingRequisitionApproveDetailsAPIResponseRequisitionDetailsLocationDetailsAddressDetails
  header?: string
  /** @format int32 */
  id?: number
  name?: string
}

export interface MainStemAPIPlatformControllersPurchasingRequisitionApproveDetailsAPIResponseRequisitionDetailsTotalDetails {
  /** @format double */
  discounts?: number
  /** @format double */
  fees?: number
  /** @format double */
  salesTax?: number
  /** @format double */
  shipping?: number
  /** @format double */
  subtotal?: number
  /** @format double */
  total?: number
}

export interface MainStemAPIPlatformControllersPurchasingRequisitionApproveDetailsAPIResponseRequisitionDetailsLocationDetailsAddressDetails {
  address1?: string
  address2?: string
  city?: string
  country?: string
  state?: string
  zip?: string
}

export interface MainStemAPIPlatformControllersPurchasingRequisitionApproveSubmitAPIRequest {
  /** @format double */
  expectedTotal?: number
  notes?: string
  paymentMethod?: MainStemAPIPlatformControllersPurchasingRequisitionApproveSubmitAPIRequestPaymentMethodDetails
  requisition?: MainStemAPIPlatformControllersPurchasingRequisitionApproveSubmitAPIRequestRequisitionDetails
}

export interface MainStemAPIPlatformControllersPurchasingRequisitionApproveSubmitAPIRequestPaymentMethodDetails {
  /** @format int32 */
  paymentMethodId?: number
  type?: 'CreditCard' | 'ACH' | 'Terms'
}

export interface MainStemAPIPlatformControllersPurchasingRequisitionApproveSubmitAPIRequestRequisitionDetails {
  uuid?: string
}

export interface MainStemAPIPlatformControllersPurchasingRequisitionApproveSubmitAPIResponse {
  message?: string
  wasSuccessful?: boolean
}

export interface MainStemAPIPlatformControllersPurchasingRequisitionCopyAPIRequest {
  /** @format int32 */
  requisitionId: number
  /** @format int32 */
  locationId: number
}

export interface MainStemAPIPlatformControllersPurchasingRequisitionCopyAPIResponse {
  requisition: MainStemAPIPlatformControllersPurchasingRequisitionCopyAPIResponseRequisitionDetails
  message?: string
  wasSuccessful?: boolean
}

export interface MainStemAPIPlatformControllersPurchasingRequisitionCopyAPIResponseRequisitionDetails {
  /** @format int32 */
  id: number
  uuid: string
}

export interface MainStemAPIPlatformControllersPurchasingRequisitionListAPIRequest {
  filter?: MainStemAPIPlatformControllersPurchasingRequisitionListAPIRequestFilterDetail
  /** @format int32 */
  page?: number
  /** @format int32 */
  pageSize?: number
  sort?: MainStemAPIPlatformControllersPurchasingRequisitionListAPIRequestSortDetails
}

export interface MainStemAPIPlatformControllersPurchasingRequisitionListAPIRequestFilterDetail {
  id?: string
  location?: string
  name?: string
  onlyShowMyLocations?: boolean
  supplierName?: string
  onlyShowNonCancelled?: boolean
  status?: 'New' | 'PendingApproval' | 'Returned' | 'Approved' | 'Rejected' | 'Cancelled'
  userCreatedBy?: string
}

export interface MainStemAPIPlatformControllersPurchasingRequisitionListAPIRequestSortDetails {
  by?: 'CreatedBy' | 'ID' | 'Location' | 'Status' | 'Name'
  order?: 'Ascending' | 'Descending'
}

export interface MainStemAPIPlatformControllersPurchasingRequisitionListAPIResponse {
  requisitions?: MainStemAPIPlatformControllersPurchasingRequisitionListAPIResponseRequisitionDetails[]
  totals?: MainStemAPIPlatformControllersPurchasingRequisitionListAPIResponseTotalDetails
  message?: string
  wasSuccessful?: boolean
}

export interface MainStemAPIPlatformControllersPurchasingRequisitionListAPIResponseRequisitionDetails {
  approvalStatus?: 'SavedCart' | 'AwaitingApproval' | 'Approval' | 'ApprovalWithEdits' | 'Rejected'
  approvalUsers?: MainStemAPIPlatformControllersPurchasingRequisitionListAPIResponseRequisitionDetailsApprovalUserDetails[]
  /** @format date-time */
  dateApproved?: string
  /** @format date-time */
  dateCreated?: string
  /** @format date-time */
  dateRequiredBy?: string
  /** @format date-time */
  dateSubmittedForApproval?: string
  /** @format int32 */
  id?: number
  location?: MainStemAPIPlatformControllersPurchasingRequisitionListAPIResponseRequisitionDetailsLocationDetails
  name?: string
  paymentStatus?: string
  status?: 'New' | 'PendingApproval' | 'Returned' | 'Approved' | 'Rejected' | 'Cancelled'
  suppliers?: MainStemAPIPlatformControllersPurchasingRequisitionListAPIResponseRequisitionDetailsSupplierDetails[]
  /** @format double */
  total?: number
  userApprovedBy?: MainStemAPIPlatformControllersPurchasingRequisitionListAPIResponseRequisitionDetailsUserDetails
  userCreatedBy?: MainStemAPIPlatformControllersPurchasingRequisitionListAPIResponseRequisitionDetailsUserDetails
  uuid?: string
}

export interface MainStemAPIPlatformControllersPurchasingRequisitionListAPIResponseTotalDetails {
  /** @format int32 */
  new?: number
  /** @format int32 */
  approved?: number
  /** @format int32 */
  cancelled?: number
  /** @format int32 */
  pendingApproval?: number
  /** @format int32 */
  rejected?: number
  /** @format int32 */
  returned?: number
  /** @format int32 */
  total?: number
  /** @format int32 */
  totalFiltered?: number
}

export interface MainStemAPIPlatformControllersPurchasingRequisitionListAPIResponseRequisitionDetailsApprovalUserDetails {
  hasApproved?: boolean
  username?: string
}

export interface MainStemAPIPlatformControllersPurchasingRequisitionListAPIResponseRequisitionDetailsLocationDetails {
  address1?: string
  address2?: string
  city?: string
  country?: string
  /** @format int32 */
  id?: number
  name?: string
  state?: string
  zip?: string
}

export interface MainStemAPIPlatformControllersPurchasingRequisitionListAPIResponseRequisitionDetailsSupplierDetails {
  /** @format int32 */
  id?: number
  name?: string
}

export interface MainStemAPIPlatformControllersPurchasingRequisitionListAPIResponseRequisitionDetailsUserDetails {
  id?: string
  name?: string
}

export interface MainStemAPIPlatformControllersPurchasingRequisitionOpenAPIResponse {
  requisitions: MainStemAPIPlatformControllersPurchasingRequisitionOpenAPIResponseRequisitionDetails[]
  message?: string
  wasSuccessful?: boolean
}

export interface MainStemAPIPlatformControllersPurchasingRequisitionOpenAPIResponseRequisitionDetails {
  /** @format int32 */
  id: number
  name: string
  /**
   * @format uuid
   * @example "00000000-0000-0000-0000-000000000000"
   */
  uuid: string
}

export interface MainStemAPIPlatformControllersPurchasingRequisitionUpdateAPIRequest {
  /** @format date-time */
  dateRequiredBy?: string
  /** @format int32 */
  id: number
  name: string
}

export interface MainStemAPIPlatformControllersPurchasingRequisitionUpdateAPIResponse {
  message?: string
  wasSuccessful?: boolean
}

export interface MainStemAPIPlatformControllersPurchasingRFQApprovalsApproveAPIRequest {
  /** @format int32 */
  rfqId: number
  approvals: MainStemAPIPlatformControllersPurchasingRFQApprovalsApproveAPIRequestRFQLineItemApprovalDetails[]
}

export interface MainStemAPIPlatformControllersPurchasingRFQApprovalsApproveAPIRequestRFQLineItemApprovalDetails {
  /** @format int32 */
  catalogId?: number
  /** @format int32 */
  rfqLineItemId: number
  isApproved: boolean
  reason?: string
}

export interface MainStemAPIPlatformControllersPurchasingRFQApprovalsApproveAPIResponse {
  message?: string
  wasSuccessful?: boolean
}

export interface MainStemAPIPlatformControllersPurchasingRFQApprovalsUserListAPIResponse {
  users: MainStemAPIPlatformControllersPurchasingRFQApprovalsUserListAPIResponseUserDetails[]
  message?: string
  wasSuccessful?: boolean
}

export interface MainStemAPIPlatformControllersPurchasingRFQApprovalsUserListAPIResponseUserDetails {
  id: string
  username: string
}

export interface MainStemAPIPlatformControllersPurchasingRFQApprovalsUserAddAPIRequest {
  userId: string
}

export interface MainStemAPIPlatformControllersPurchasingRFQApprovalsUserAddAPIResponse {
  message?: string
  wasSuccessful?: boolean
}

export interface MainStemAPIPlatformControllersPurchasingRFQApprovalsUserRemoveAPIRequest {
  userId: string
}

export interface MainStemAPIPlatformControllersPurchasingRFQApprovalsUserRemoveAPIResponse {
  message?: string
  wasSuccessful?: boolean
}

export interface MainStemAPIPlatformControllersPurchasingRFQAttachmentDeleteAPIRequest {
  /** @format int32 */
  rfqAttachmentId: number
}

export interface MainStemAPIPlatformControllersPurchasingRFQAttachmentDeleteAPIResponse {
  message?: string
  wasSuccessful?: boolean
}

export interface MainStemAPIPlatformControllersPurchasingRFQAttachmentUploadAPIResponse {
  /** @format int32 */
  attachmentId?: number
  file?: MainStemAPIPlatformControllersPurchasingRFQAttachmentUploadAPIResponseFileDetails
  message?: string
  wasSuccessful?: boolean
}

export interface MainStemAPIPlatformControllersPurchasingRFQAttachmentUploadAPIResponseFileDetails {
  /** @format int32 */
  id: number
  name: string
  url: string
  /** @format date-time */
  dateCreated: string
}

export interface MainStemAPIPlatformControllersPurchasingRFQCommentCreateAPIRequest {
  /** @format int32 */
  rfqId: number
  comment: string
}

export interface MainStemAPIPlatformControllersPurchasingRFQCommentCreateAPIResponse {
  /** @format int32 */
  id?: number
  message?: string
  wasSuccessful?: boolean
}

export interface MainStemAPIPlatformControllersPurchasingRFQCommentDeleteAPIRequest {
  /** @format int32 */
  rfqCommentId: number
}

export interface MainStemAPIPlatformControllersPurchasingRFQCommentDeleteAPIResponse {
  message?: string
  wasSuccessful?: boolean
}

export interface MainStemAPIPlatformControllersPurchasingRFQCommentUpdateAPIRequest {
  /** @format int32 */
  rfqCommentId: number
  comment: string
}

export interface MainStemAPIPlatformControllersPurchasingRFQCommentUpdateAPIResponse {
  message?: string
  wasSuccessful?: boolean
}

export interface MainStemAPIPlatformControllersPurchasingRFQCreateAPIRequest {
  title: string
  description: string
  shipTo: MainStemAPIPlatformControllersPurchasingRFQCreateAPIRequestShipToDetails
}

export interface MainStemAPIPlatformControllersPurchasingRFQCreateAPIRequestShipToDetails {
  address: string
  city: string
  state: string
  zip: string
  country: string
}

export interface MainStemAPIPlatformControllersPurchasingRFQCreateAPIResponse {
  /** @format int32 */
  id?: number
  message?: string
  wasSuccessful?: boolean
}

export interface MainStemAPIPlatformControllersPurchasingRFQDetailsAPIRequest {
  /** @format int32 */
  rfqId: number
}

export interface MainStemAPIPlatformControllersPurchasingRFQDetailsAPIResponse {
  cancellationReason?: string
  /** @format date-time */
  dateCreated: string
  /** @format date-time */
  dateLastUpdated: string
  description: string
  /** @format int32 */
  id: number
  rejectionReason: string
  status:
    | 'Cancelled'
    | 'Rejected'
    | 'Draft'
    | 'PendingApproval'
    | 'Submitted'
    | 'InProgress'
    | 'Completed'
    | 'MainStemReview'
  shipToAddress: string
  shipToCity: string
  shipToState: string
  shipToZip: string
  shipToCountry: string
  /** @format double */
  targetValueCustomer?: number
  title: string
  userCreatedById: string
  userCreatedByName: string
  lineItems: MainStemAPIPlatformControllersPurchasingRFQDetailsAPIResponseRFQLineItemDetails[]
  comments: MainStemAPIPlatformControllersPurchasingRFQDetailsAPIResponseRFQCommentDetails[]
  attachments: MainStemAPIPlatformControllersPurchasingRFQDetailsAPIResponseRFQAttachmentDetails[]
  message?: string
  wasSuccessful?: boolean
}

export interface MainStemAPIPlatformControllersPurchasingRFQDetailsAPIResponseRFQLineItemDetails {
  approvalStatus: 'Rejected' | 'Pending' | 'Approved'
  catalog: MainStemAPIPlatformControllersPurchasingRFQDetailsAPIResponseRFQLineItemDetailsCatalogDetails
  canBeSourcedFromAnySupplier: boolean
  /** @format date-time */
  dateApprovalDecisionMade?: string
  /** @format date-time */
  dateRequiredBy?: string
  /** @format int32 */
  id: number
  name?: string
  /** @format int32 */
  quantity: number
  notes?: string
  openToAlternativeItems: boolean
  products: MainStemAPIPlatformControllersPurchasingRFQDetailsAPIResponseRFQLineItemDetailsProductDetails[]
  rejectedReason?: string
  /** @format double */
  targetValueCustomer?: number
  /** @format double */
  targetPricePerUnitCustomer?: number
  urls: MainStemAPIPlatformControllersPurchasingRFQDetailsAPIResponseRFQURLDetails[]
  userApprovalDecision: MainStemAPIPlatformControllersPurchasingRFQDetailsAPIResponseRFQLineItemDetailsUserDetails
}

export interface MainStemAPIPlatformControllersPurchasingRFQDetailsAPIResponseRFQCommentDetails {
  /** @format int32 */
  id: number
  comment: string
  viewableToCustomer: boolean
  viewableToSupplier: boolean
  userCreatedById: string
  userCreatedByName: string
  /** @format date-time */
  dateCreated: string
}

export interface MainStemAPIPlatformControllersPurchasingRFQDetailsAPIResponseRFQAttachmentDetails {
  file: MainStemAPIPlatformControllersPurchasingRFQDetailsAPIResponseRFQAttachmentDetailsFileDetails
  /** @format int32 */
  id: number
  description: string
  userCreatedById: string
  userCreatedByName: string
  /** @format date-time */
  dateCreated: string
}

export interface MainStemAPIPlatformControllersPurchasingRFQDetailsAPIResponseRFQLineItemDetailsCatalogDetails {
  /** @format int32 */
  id: number
  name: string
}

export interface MainStemAPIPlatformControllersPurchasingRFQDetailsAPIResponseRFQLineItemDetailsProductDetails {
  /** @format int32 */
  id: number
  image?: string
  name: string
  /** @format double */
  price?: number
  sku?: string
  supplier: MainStemAPIPlatformControllersPurchasingRFQDetailsAPIResponseRFQLineItemDetailsSupplierDetails
}

export interface MainStemAPIPlatformControllersPurchasingRFQDetailsAPIResponseRFQURLDetails {
  /** @format int32 */
  id: number
  url: string
  description: string
  userCreatedById: string
  userCreatedByName: string
  /** @format date-time */
  dateCreated: string
}

export interface MainStemAPIPlatformControllersPurchasingRFQDetailsAPIResponseRFQLineItemDetailsUserDetails {
  id: string
  username: string
}

export interface MainStemAPIPlatformControllersPurchasingRFQDetailsAPIResponseRFQAttachmentDetailsFileDetails {
  extension: string
  /** @format int32 */
  id: number
  name: string
  /** @format int64 */
  size: number
  url: string
}

export interface MainStemAPIPlatformControllersPurchasingRFQDetailsAPIResponseRFQLineItemDetailsSupplierDetails {
  /** @format int32 */
  id: number
  name: string
}

export interface MainStemAPIPlatformControllersPurchasingRFQLineItemsCreateAPIRequest {
  canBeSourcedFromAnySupplier: boolean
  /** @format date-time */
  dateMaterialsRequiredInFacility?: string
  name: string
  notes?: string
  openToAlternativeItems: boolean
  /** @format int32 */
  quantity: number
  /** @format int32 */
  rfqId: number
  /** @format double */
  targetPricePerUnitCustomer?: number
}

export interface MainStemAPIPlatformControllersPurchasingRFQLineItemsCreateAPIResponse {
  /** @format int32 */
  id?: number
  message?: string
  wasSuccessful?: boolean
}

export interface MainStemAPIPlatformControllersPurchasingRFQLineItemsDeleteAPIRequest {
  /** @format int32 */
  rfqLineItemId: number
}

export interface MainStemAPIPlatformControllersPurchasingRFQLineItemsDeleteAPIResponse {
  message?: string
  wasSuccessful?: boolean
}

export interface MainStemAPIPlatformControllersPurchasingRFQLineItemsURLCreateAPIRequest {
  description?: string
  /** @format int32 */
  rfqLineItemId: number
  url: string
}

export interface MainStemAPIPlatformControllersPurchasingRFQLineItemsURLCreateAPIResponse {
  /** @format int32 */
  id?: number
  message?: string
  wasSuccessful?: boolean
}

export interface MainStemAPIPlatformControllersPurchasingRFQLineItemsURLDeleteAPIRequest {
  /** @format int32 */
  rfqUrlId: number
}

export interface MainStemAPIPlatformControllersPurchasingRFQLineItemsURLDeleteAPIResponse {
  message?: string
  wasSuccessful?: boolean
}

export interface MainStemAPIPlatformControllersPurchasingRFQLineItemsURLUpdateAPIRequest {
  /** @format int32 */
  id: number
  url?: string
  description?: string
}

export interface MainStemAPIPlatformControllersPurchasingRFQLineItemsURLUpdateAPIResponse {
  message?: string
  wasSuccessful?: boolean
}

export interface MainStemAPIPlatformControllersPurchasingRFQLineItemsUpdateAPIRequest {
  canBeSourcedFromAnySupplier: boolean
  /** @format date-time */
  dateMaterialsRequiredInFacility?: string
  /** @format int32 */
  id: number
  name?: string
  notes?: string
  openToAlternativeItems: boolean
  /** @format int32 */
  quantity: number
  /** @format double */
  targetPricePerUnitCustomer?: number
}

export interface MainStemAPIPlatformControllersPurchasingRFQLineItemsUpdateAPIResponse {
  message?: string
  wasSuccessful?: boolean
}

export type MainStemAPIPlatformControllersPurchasingRFQListAPIRequest = object

export interface MainStemAPIPlatformControllersPurchasingRFQListAPIResponse {
  rfqs: MainStemAPIPlatformControllersPurchasingRFQListAPIResponseRFQDetails[]
  message?: string
  wasSuccessful?: boolean
}

export interface MainStemAPIPlatformControllersPurchasingRFQListAPIResponseRFQDetails {
  /** @format date-time */
  dateCreated: string
  /** @format int32 */
  id: number
  shipTo: MainStemAPIPlatformControllersPurchasingRFQListAPIResponseRFQDetailsShipToDetails
  status:
    | 'Cancelled'
    | 'Rejected'
    | 'Draft'
    | 'PendingApproval'
    | 'Submitted'
    | 'InProgress'
    | 'Completed'
    | 'MainStemReview'
  /** @format double */
  targetValueCustomer?: number
  title: string
  userCreatedBy: MainStemAPIPlatformControllersPurchasingRFQListAPIResponseRFQDetailsUserDetails
}

export interface MainStemAPIPlatformControllersPurchasingRFQListAPIResponseRFQDetailsShipToDetails {
  address: string
  city: string
  country: string
  state: string
  zip: string
}

export interface MainStemAPIPlatformControllersPurchasingRFQListAPIResponseRFQDetailsUserDetails {
  id: string
  username: string
}

export interface MainStemAPIPlatformControllersPurchasingRFQSupplierInviteAPIRequest {
  /** @format int32 */
  rfqLineItemId: number
  supplierIds: number[]
}

export interface MainStemAPIPlatformControllersPurchasingRFQSupplierInviteAPIResponse {
  message?: string
  wasSuccessful?: boolean
}

export interface MainStemAPIPlatformControllersPurchasingRFQUpdateAPIRequest {
  /** @format int32 */
  id: number
  title: string
  description?: string
  shipToAddress: string
  shipToCity: string
  shipToState: string
  shipToZip: string
  shipToCountry: string
  status:
    | 'Cancelled'
    | 'Rejected'
    | 'Draft'
    | 'PendingApproval'
    | 'Submitted'
    | 'InProgress'
    | 'Completed'
    | 'MainStemReview'
}

export interface MainStemAPIPlatformControllersPurchasingRFQUpdateAPIResponse {
  message?: string
  wasSuccessful?: boolean
}

export interface MainStemAPIPlatformControllersPurchasingRTVCreateAPIRequest {
  lineItems: MainStemAPIPlatformControllersPurchasingRTVCreateAPIRequestLineItemDetails[]
  note?: string
  /** @format int32 */
  orderId: number
  /** @format int32 */
  supplierId: number
}

export interface MainStemAPIPlatformControllersPurchasingRTVCreateAPIRequestLineItemDetails {
  note?: string
  /** @format int32 */
  orderLineItemId: number
  /** @format double */
  quantity: number
}

export interface MainStemAPIPlatformControllersPurchasingRTVCreateAPIResponse {
  /** @format int32 */
  id?: number
  message?: string
  wasSuccessful?: boolean
}

export interface MainStemAPIPlatformControllersPurchasingRTVDetailsAPIRequest {
  /** @format int32 */
  id: number
}

export interface MainStemAPIPlatformControllersPurchasingRTVDetailsAPIResponse {
  rtv?: MainStemAPIPlatformControllersPurchasingRTVDetailsAPIResponseRTVDetails
  message?: string
  wasSuccessful?: boolean
}

export interface MainStemAPIPlatformControllersPurchasingRTVDetailsAPIResponseRTVDetails {
  /** @format double */
  creditReceived?: number
  /** @format date-time */
  dateCreated: string
  /** @format date-time */
  dateCreditReceived?: string
  /** @format date-time */
  dateLastUpdated: string
  files: MainStemAPIPlatformControllersPurchasingRTVDetailsAPIResponseRTVDetailsFileDetails[]
  /** @format int32 */
  id: number
  lineItems: MainStemAPIPlatformControllersPurchasingRTVDetailsAPIResponseRTVDetailsLineItemDetails[]
  location: MainStemAPIPlatformControllersPurchasingRTVDetailsAPIResponseRTVDetailsBusinessPartnerDetails
  notes: MainStemAPIPlatformControllersPurchasingRTVDetailsAPIResponseRTVDetailsNoteDetails[]
  order: MainStemAPIPlatformControllersPurchasingRTVDetailsAPIResponseRTVDetailsOrderDetails
  shipmentTrackings: MainStemAPIPlatformControllersPurchasingRTVDetailsAPIResponseRTVDetailsShipmentTrackingDetails[]
  status: 'Cancelled' | 'Open' | 'InProgress' | 'Completed'
  supplier: MainStemAPIPlatformControllersPurchasingRTVDetailsAPIResponseRTVDetailsBusinessPartnerDetails
  uuid: string
}

export interface MainStemAPIPlatformControllersPurchasingRTVDetailsAPIResponseRTVDetailsFileDetails {
  /** @format date-time */
  dateCreated: string
  fileName?: string
  /** @format int32 */
  id: number
  type: 'General' | 'ReturnLabel'
  url?: string
  userCreatedBy?: MainStemAPIPlatformControllersPurchasingRTVDetailsAPIResponseRTVDetailsUserDetails
}

export interface MainStemAPIPlatformControllersPurchasingRTVDetailsAPIResponseRTVDetailsLineItemDetails {
  /** @format int32 */
  id: number
  note?: string
  /** @format int32 */
  orderLineItemId: number
  /** @format double */
  pricePerItem?: number
  product?: MainStemAPIPlatformControllersPurchasingRTVDetailsAPIResponseRTVDetailsProductDetails
  /** @format double */
  quantity: number
}

export interface MainStemAPIPlatformControllersPurchasingRTVDetailsAPIResponseRTVDetailsBusinessPartnerDetails {
  /** @format int32 */
  id: number
  name?: string
}

export interface MainStemAPIPlatformControllersPurchasingRTVDetailsAPIResponseRTVDetailsNoteDetails {
  content: string
  /** @format date-time */
  dateCreated: string
  /** @format int32 */
  id: number
  userCreatedBy?: MainStemAPIPlatformControllersPurchasingRTVDetailsAPIResponseRTVDetailsUserDetails
}

export interface MainStemAPIPlatformControllersPurchasingRTVDetailsAPIResponseRTVDetailsOrderDetails {
  /** @format date-time */
  dateCreated?: string
  /** @format int32 */
  id: number
  uuid?: string
}

export interface MainStemAPIPlatformControllersPurchasingRTVDetailsAPIResponseRTVDetailsShipmentTrackingDetails {
  carrierName?: string
  /** @format date-time */
  dateCreated: string
  /** @format date-time */
  dateDelivered?: string
  /** @format date-time */
  dateShipped?: string
  /** @format int32 */
  id: number
  trackingNumber?: string
  trackingUrl?: string
}

export interface MainStemAPIPlatformControllersPurchasingRTVDetailsAPIResponseRTVDetailsUserDetails {
  id: string
  username: string
}

export interface MainStemAPIPlatformControllersPurchasingRTVDetailsAPIResponseRTVDetailsProductDetails {
  /** @format int32 */
  id: number
  imageUrl?: string
  name?: string
}

export interface MainStemAPIPlatformControllersPurchasingRTVFileUploadAPIResponse {
  file?: MainStemAPIPlatformControllersPurchasingRTVFileUploadAPIResponseFileDetails
  message?: string
  wasSuccessful?: boolean
}

export interface MainStemAPIPlatformControllersPurchasingRTVFileUploadAPIResponseFileDetails {
  /** @format date-time */
  dateCreated: string
  fileName?: string
  /** @format int32 */
  id: number
  url?: string
}

export interface MainStemAPIPlatformControllersPurchasingRTVListAPIResponse {
  rtvs: MainStemAPIPlatformControllersPurchasingRTVListAPIResponseRTVDetails[]
  message?: string
  wasSuccessful?: boolean
}

export interface MainStemAPIPlatformControllersPurchasingRTVListAPIResponseRTVDetails {
  /** @format double */
  creditReceived?: number
  /** @format date-time */
  dateCreated: string
  /** @format date-time */
  dateLastUpdated: string
  /** @format int32 */
  id: number
  /** @format int32 */
  lineItemCount: number
  location: MainStemAPIPlatformControllersPurchasingRTVListAPIResponseRTVDetailsBusinessPartnerDetails
  /** @format int32 */
  orderId: number
  orderUuid: string
  status: 'Cancelled' | 'Open' | 'InProgress' | 'Completed'
  supplier: MainStemAPIPlatformControllersPurchasingRTVListAPIResponseRTVDetailsBusinessPartnerDetails
}

export interface MainStemAPIPlatformControllersPurchasingRTVListAPIResponseRTVDetailsBusinessPartnerDetails {
  /** @format int32 */
  id: number
  name: string
}

export interface MainStemAPIPlatformControllersPurchasingRTVNoteCreateAPIRequest {
  content: string
  /** @format int32 */
  rtvId: number
}

export interface MainStemAPIPlatformControllersPurchasingRTVNoteCreateAPIResponse {
  /** @format int32 */
  id?: number
  message?: string
  wasSuccessful?: boolean
}

export interface MainStemAPIPlatformControllersPurchasingRTVOrderInfoAPIRequest {
  /** @format int32 */
  orderId: number
}

export interface MainStemAPIPlatformControllersPurchasingRTVOrderInfoAPIResponse {
  lineItems: MainStemAPIPlatformControllersPurchasingRTVOrderInfoAPIResponseLineItemDetails[]
  order?: MainStemAPIPlatformControllersPurchasingRTVOrderInfoAPIResponseOrderDetails
  suppliers: MainStemAPIPlatformControllersPurchasingRTVOrderInfoAPIResponseSupplierDetails[]
  message?: string
  wasSuccessful?: boolean
}

export interface MainStemAPIPlatformControllersPurchasingRTVOrderInfoAPIResponseLineItemDetails {
  /** @format int32 */
  id: number
  /** @format double */
  pricePerItem: number
  product?: MainStemAPIPlatformControllersPurchasingRTVOrderInfoAPIResponseLineItemDetailsProductDetails
  /** @format double */
  quantity: number
  /** @format double */
  quantityAlreadyReturned: number
}

export interface MainStemAPIPlatformControllersPurchasingRTVOrderInfoAPIResponseOrderDetails {
  /** @format date-time */
  dateCreated: string
  /** @format int32 */
  id: number
  uuid: string
}

export interface MainStemAPIPlatformControllersPurchasingRTVOrderInfoAPIResponseSupplierDetails {
  /** @format int32 */
  id: number
  name?: string
}

export interface MainStemAPIPlatformControllersPurchasingRTVOrderInfoAPIResponseLineItemDetailsProductDetails {
  /** @format int32 */
  id: number
  imageUrl?: string
  name?: string
  /** @format int32 */
  supplierId?: number
}

export interface MainStemAPIPlatformControllersPurchasingSearchAPIRequest {
  query?: string
}

export interface MainStemAPIPlatformControllersPurchasingSearchAPIResponse {
  locations?: MainStemAPIPlatformControllersPurchasingSearchAPIResponseLocationDetails[]
  orders?: MainStemAPIPlatformControllersPurchasingSearchAPIResponseOrderDetails[]
  productLists?: MainStemAPIPlatformControllersPurchasingSearchAPIResponseProductListDetails[]
  products?: MainStemAPIPlatformControllersPurchasingSearchAPIResponseProductDetails[]
  shipments?: MainStemAPIPlatformControllersPurchasingSearchAPIResponseShipmentDetails[]
  users?: MainStemAPIPlatformControllersPurchasingSearchAPIResponseUserDetails[]
  vendors?: MainStemAPIPlatformControllersPurchasingSearchAPIResponseVendorDetails[]
  message?: string
  wasSuccessful?: boolean
}

export interface MainStemAPIPlatformControllersPurchasingSearchAPIResponseLocationDetails {
  address1?: string
  address2?: string
  city?: string
  country?: string
  headerURL?: string
  /** @format int32 */
  id?: number
  logoURL?: string
  name?: string
  state?: string
  uuid?: string
  zip?: string
}

export interface MainStemAPIPlatformControllersPurchasingSearchAPIResponseOrderDetails {
  /** @format date-time */
  dateApproved?: string
  /** @format date-time */
  dateCreated?: string
  /** @format double */
  discount?: number
  /** @format int32 */
  id?: number
  location?: MainStemAPIPlatformControllersPurchasingSearchAPIResponseOrderDetailsLocationDetails
  /** @format double */
  orderTotal?: number
  paymentStatus?: string
  /** @format double */
  salesTax?: number
  /** @format double */
  shipping?: number
  status?: string
  /** @format double */
  subTotal?: number
  userApprovedBy?: string
  userCreatedBy?: string
  uuid?: string
}

export interface MainStemAPIPlatformControllersPurchasingSearchAPIResponseProductListDetails {
  /** @format int32 */
  id?: number
  isPrivate?: boolean
  isShared?: boolean
  name?: string
  /** @format int32 */
  productCount?: number
  /** @format int32 */
  userCount?: number
}

export interface MainStemAPIPlatformControllersPurchasingSearchAPIResponseProductDetails {
  /** @format int32 */
  id?: number
}

export interface MainStemAPIPlatformControllersPurchasingSearchAPIResponseShipmentDetails {
  /** @format int32 */
  id?: number
}

export interface MainStemAPIPlatformControllersPurchasingSearchAPIResponseUserDetails {
  /** @format date-time */
  dateCreated?: string
  email?: string
  friendlyName?: string
  role?: string
  username?: string
  uuid?: string
}

export interface MainStemAPIPlatformControllersPurchasingSearchAPIResponseVendorDetails {
  /** @format date-time */
  firstOrderedDate?: string
  /** @format int32 */
  id?: number
  /** @format date-time */
  lastOrderedDate?: string
  name?: string
  /** @format int32 */
  totalOrders?: number
  /** @format int32 */
  totalQuantityOrdered?: number
}

export interface MainStemAPIPlatformControllersPurchasingSearchAPIResponseOrderDetailsLocationDetails {
  address1?: string
  address2?: string
  city?: string
  country?: string
  /** @format int32 */
  id?: number
  name?: string
  state?: string
  zip?: string
}

export interface MainStemAPIPlatformControllersPurchasingShipmentsDetailsAPIRequest {
  shipmentId?: string
}

export interface MainStemAPIPlatformControllersPurchasingShipmentsDetailsAPIResponse {
  /** @format date-time */
  datePacked?: string
  /** @format date-time */
  dateShipped?: string
  invoice: MainStemAPIPlatformControllersPurchasingShipmentsDetailsInvoiceDetails
  lineItems?: MainStemAPIPlatformControllersPurchasingShipmentsDetailsLineItemDetails[]
  order?: MainStemAPIPlatformControllersPurchasingShipmentsDetailsOrderDetails
  shipment?: MainStemAPIPlatformControllersPurchasingShipmentsDetailsShipmentDetails
  trackingInformation?: ShipEngineSDKModelGetTrackingLogResponseBody
  message?: string
  wasSuccessful?: boolean
}

export interface MainStemAPIPlatformControllersPurchasingShipmentsDetailsInvoiceDetails {
  /** @format int32 */
  id: number
}

export interface MainStemAPIPlatformControllersPurchasingShipmentsDetailsLineItemDetails {
  product?: MainStemAPIPlatformControllersPurchasingShipmentsDetailsProductDetails
  /** @format double */
  quantity?: number
}

export interface MainStemAPIPlatformControllersPurchasingShipmentsDetailsOrderDetails {
  /** @format date-time */
  dateCreated: string
  /** @format int32 */
  id: number
  supplier: MainStemAPIPlatformControllersPurchasingShipmentsDetailsSupplierDetails
  /**
   * @format uuid
   * @example "00000000-0000-0000-0000-000000000000"
   */
  uuid: string
}

export interface MainStemAPIPlatformControllersPurchasingShipmentsDetailsShipmentDetails {
  carrier?: string
  carrierLink?: string
  carrierType?: string
  destination?: MainStemAPIPlatformControllersPurchasingShipmentsDetailsAddressDetails
  /** @format double */
  height?: number
  /** @format double */
  length?: number
  origin?: MainStemAPIPlatformControllersPurchasingShipmentsDetailsAddressDetails
  trackingNumber?: string
  /** @format double */
  weight?: number
  /** @format double */
  width?: number
}

export interface ShipEngineSDKModelGetTrackingLogResponseBody {
  carrierCode?: string
  carrierDetailCode?: string
  /** @format int32 */
  carrierId?: number
  carrierStatusCode?: string
  events?: ShipEngineSDKModelTrackEvent[]
  statusCode?: ShipEngineSDKModelStatusCode
  trackingNumber?: string
  trackingUrl?: string
  /** @format date-time */
  actualDeliveryDate?: string
  carrierStatusDescription?: string
  /** @format date-time */
  estimatedDeliveryDate?: string
  exceptionDescription?: string
  /** @format date-time */
  shipDate?: string
  statusDescription?: string
  statusDetailCode?: ShipEngineSDKModelStatusDetailCode
  statusDetailDescription?: string
}

export interface MainStemAPIPlatformControllersPurchasingShipmentsDetailsProductDetails {
  /** @format int32 */
  id?: number
  imageURL?: string
  name?: string
}

export interface MainStemAPIPlatformControllersPurchasingShipmentsDetailsSupplierDetails {
  /** @format int32 */
  id: number
  integrationType?: string
  name: string
}

export interface MainStemAPIPlatformControllersPurchasingShipmentsDetailsAddressDetails {
  address1?: string
  address2?: string
  city?: string
  state?: string
  zip?: string
}

export interface ShipEngineSDKModelTrackEvent {
  carrierDetailCode?: string
  carrierStatusCode?: string
  carrierStatusDescription?: string
  cityLocality?: string
  /** @format date-time */
  occurredAt?: string
  postalCode?: string
  stateProvince?: string
  statusCode?: ShipEngineSDKModelStatusCode
  statusDescription?: string
  /** @format date-time */
  carrierOccurredAt?: string
  companyName?: string
  countryCode?: string
  description?: string
  eventCode?: string
  /** @format double */
  latitude?: number
  /** @format double */
  longitude?: number
  proofOfDeliveryUrl?: string
  signer?: string
  statusDetailCode?: ShipEngineSDKModelStatusDetailCode
  statusDetailDescription?: string
}

export type ShipEngineSDKModelStatusCode = object

export type ShipEngineSDKModelStatusDetailCode = object

export interface MainStemAPIPlatformControllersPurchasingShipmentsListAPIResponse {
  shipments?: MainStemAPIPlatformControllersPurchasingShipmentsListAPIResponseShipmentDetails[]
  shipmentTotals?: MainStemAPIPlatformControllersPurchasingShipmentsListAPIResponseShipmentTotals[]
  message?: string
  wasSuccessful?: boolean
}

export interface MainStemAPIPlatformControllersPurchasingShipmentsListAPIResponseShipmentTotals {
  status?: string
  /** @format int32 */
  total?: number
}

export interface MainStemAPIPlatformControllersPurchasingShopCatalogListAPIResponse {
  catalogs: MainStemAPIPlatformControllersPurchasingShopCatalogListAPIResponseCatalogDetails[]
  message?: string
  wasSuccessful?: boolean
}

export interface MainStemAPIPlatformControllersPurchasingShopCatalogListAPIResponseCatalogDetails {
  /** @format int32 */
  id: number
  name: string
}

export interface MainStemAPIPlatformControllersPurchasingShopMarketplaceAmazonSearchAPIRequest {
  /** @format int32 */
  pageNumber?: number
  query?: string
}

export interface MainStemAPIPlatformControllersPurchasingShopMarketplaceAmazonSearchAPIResponse {
  json?: string
  products?: MainStemAPIPlatformControllersPurchasingShopMarketplaceAmazonSearchAPIResponseProductDetails[]
  searchDetails?: MainStemAPIPlatformControllersPurchasingShopMarketplaceAmazonSearchAPIResponseSearchDetails
  /** @format int32 */
  totalCount?: number
  message?: string
  wasSuccessful?: boolean
}

export interface MainStemAPIPlatformControllersPurchasingShopMarketplaceAmazonSearchAPIResponseProductDetails {
  amazonProduct?: MainStemSDKIntegrationsAmazonModelsAmazonSearchProduct
  asin?: string
  /** @format double */
  cost?: number
  /** @format int32 */
  daysToFulfill?: number
  description?: string
  /** @format double */
  height?: number
  image?: string
  isOutOfStock?: boolean
  /** @format double */
  length?: number
  name?: string
  /** @format double */
  price?: number
  showInStore?: boolean
  skuInternal?: string
  skuManufacturer?: string
  /** @format double */
  weight?: number
  /** @format double */
  width?: number
}

export interface MainStemAPIPlatformControllersPurchasingShopMarketplaceAmazonSearchAPIResponseSearchDetails {
  partitionKey?: string
  rowKey?: string
}

export type MainStemAPIPlatformControllersPurchasingShopMarketplaceApexTradingConnectionsAPIRequest = object

export interface MainStemAPIPlatformControllersPurchasingShopMarketplaceApexTradingConnectionsAPIResponse {
  connections?: MainStemAPIPlatformControllersPurchasingShopMarketplaceApexTradingConnectionsAPIResponseConnectionDetails[]
  message?: string
  wasSuccessful?: boolean
}

export interface MainStemAPIPlatformControllersPurchasingShopMarketplaceApexTradingConnectionsAPIResponseConnectionDetails {
  /** @format int32 */
  id?: number
  name?: string
  /** @format int32 */
  companyId?: number
  companyName?: string
  locations?: MainStemAPIPlatformControllersPurchasingShopMarketplaceApexTradingConnectionsAPIResponseLocationDetails[]
}

export interface MainStemAPIPlatformControllersPurchasingShopMarketplaceApexTradingConnectionsAPIResponseLocationDetails {
  /** @format int32 */
  id?: number
  name?: string
}

export interface MainStemAPIPlatformControllersPurchasingShopMarketplaceApexTradingDetailsAPIRequest {
  /** @format int32 */
  productId?: number
  /** @format int32 */
  integrationSettingsId?: number
}

export interface MainStemAPIPlatformControllersPurchasingShopMarketplaceApexTradingDetailsAPIResponse {
  product?: MainStemAPIPlatformControllersPurchasingShopMarketplaceApexTradingSearchAPIResponseProductDetails
  message?: string
  wasSuccessful?: boolean
}

export interface MainStemAPIPlatformControllersPurchasingShopMarketplaceApexTradingSearchAPIResponseProductDetails {
  /** @format double */
  availableQty?: number
  batches?: MainStemAPIPlatformControllersPurchasingShopMarketplaceApexTradingSearchAPIResponseBatchDetails[]
  brand?: string
  cannabinoid?: string
  category?: string
  company?: string
  companyLogo?: string
  cultivar?: string
  cultivarType?: string
  /** @format date-time */
  dateCreated?: string
  /** @format date-time */
  dateLastUpdated?: string
  description?: string
  descriptionHtml?: string
  dryingMethod?: string
  featured?: boolean
  featuredCallout?: string
  growEnvironment?: string
  growMedium?: string
  /** @format int32 */
  id: number
  image?: string
  images?: string[]
  isOutOfStock?: boolean
  listing?: MainStemSDKIntegrationsApexTradingSearchModelsProduct
  name?: string
  /** @format double */
  price?: number
  productType?: string
  sku?: string
  trimMethod?: string
  unit?: string
}

export interface MainStemAPIPlatformControllersPurchasingShopMarketplaceApexTradingSearchAPIResponseBatchDetails {
  cannabinoids?: MainStemAPIPlatformControllersPurchasingShopMarketplaceApexTradingSearchAPIResponseLabResult[]
  /** @format date-time */
  harvestDate?: string
  /** @format int32 */
  id?: number
  industry?: string
  location?: string
  lotNumber?: string
  name?: string
  operation?: string
  potency?: string
  /** @format double */
  price?: number
  pricingVariants?: MainStemAPIPlatformControllersPurchasingShopMarketplaceApexTradingSearchAPIResponsePricingVariantDetails[]
  /** @format double */
  quantity?: number
  terpenes?: MainStemAPIPlatformControllersPurchasingShopMarketplaceApexTradingSearchAPIResponseLabResult[]
}

export interface MainStemSDKIntegrationsApexTradingSearchModelsProduct {
  /** @format int32 */
  id?: number
  uuid?: string
  /** @format int32 */
  company_id?: number
  name?: string
  product_sku?: string
  description?: string
  featured?: boolean
  featured_callout?: string
  /** @format double */
  available_qty?: number
  listing_price?: string
  /** @format date-time */
  created_at?: string
  /** @format date-time */
  updated_at?: string
  company?: MainStemSDKIntegrationsApexTradingSearchModelsCompanyResource
  brand?: MainStemSDKIntegrationsApexTradingSearchModelsNamedResource
  category?: MainStemSDKIntegrationsApexTradingSearchModelsCategoryResource
  product_type?: MainStemSDKIntegrationsApexTradingSearchModelsProductTypeResource
  cultivar?: MainStemSDKIntegrationsApexTradingSearchModelsCultivarResource
  cultivar_type?: MainStemSDKIntegrationsApexTradingSearchModelsNamedResource
  predominate_cannabinoid?: MainStemSDKIntegrationsApexTradingSearchModelsCannabinoidResource
  unit_measurement?: MainStemSDKIntegrationsApexTradingSearchModelsUnitResource
  grow_environment?: MainStemSDKIntegrationsApexTradingSearchModelsNamedResource
  grow_medium?: MainStemSDKIntegrationsApexTradingSearchModelsNamedResource
  trim_method?: MainStemSDKIntegrationsApexTradingSearchModelsNamedResource
  drying_method?: MainStemSDKIntegrationsApexTradingSearchModelsNamedResource
  images?: MainStemSDKIntegrationsApexTradingSearchModelsImageResource[]
  batches?: MainStemSDKIntegrationsApexTradingSearchModelsBatch[]
}

export interface MainStemAPIPlatformControllersPurchasingShopMarketplaceApexTradingSearchAPIResponseLabResult {
  abbreviation?: string
  measurement?: string
  name?: string
  unit?: string
}

export interface MainStemAPIPlatformControllersPurchasingShopMarketplaceApexTradingSearchAPIResponsePricingVariantDetails {
  /** @format double */
  baseUnitMultiple?: number
  decimalsAllowed?: boolean
  isDefault?: boolean
  name?: string
  /** @format double */
  price?: number
  /** @format int32 */
  unitMeasurementId: number
  unitAlias?: string
}

export interface MainStemSDKIntegrationsApexTradingSearchModelsCompanyResource {
  /** @format int32 */
  id?: number
  uuid?: string
  name?: string
  logo?: string
}

export interface MainStemSDKIntegrationsApexTradingSearchModelsNamedResource {
  /** @format int32 */
  id?: number
  name?: string
}

export interface MainStemSDKIntegrationsApexTradingSearchModelsCategoryResource {
  /** @format int32 */
  id?: number
  name?: string
  short_display_name?: string
  long_display_name?: string
}

export interface MainStemSDKIntegrationsApexTradingSearchModelsProductTypeResource {
  /** @format int32 */
  id?: number
  name?: string
  /** @format int32 */
  product_category_id?: number
  /** @format int32 */
  company_id?: number
}

export interface MainStemSDKIntegrationsApexTradingSearchModelsCultivarResource {
  /** @format int32 */
  id?: number
  name?: string
  /** @format int32 */
  company_id?: number
}

export interface MainStemSDKIntegrationsApexTradingSearchModelsCannabinoidResource {
  /** @format int32 */
  id?: number
  name?: string
  abbreviation?: string
}

export interface MainStemSDKIntegrationsApexTradingSearchModelsUnitResource {
  /** @format int32 */
  id?: number
  name?: string
  alias?: string
}

export interface MainStemSDKIntegrationsApexTradingSearchModelsImageResource {
  /** @format int32 */
  id?: number
  /** @format int32 */
  sort_order?: number
  link?: string
  /** @format date-time */
  created_at?: string
}

export interface MainStemSDKIntegrationsApexTradingSearchModelsBatch {
  /** @format int32 */
  id?: number
  uuid?: string
  name?: string
  /** @format int32 */
  product_id?: number
  /** @format double */
  quantity?: number
  unlimited_quantity?: boolean
  hold?: boolean
  back_order?: boolean
  listing_price?: string
  predominate_canabinoid_min_or_only?: string
  predominate_canabinoid_max?: string
  predominate_canabinoid_unit?: string
  /** @format date-time */
  harvest_date?: string
  /** @format date-time */
  best_by_date?: string
  /** @format date-time */
  production_date?: string
  /** @format date-time */
  test_date?: string
  lot_number?: string
  description?: string
  operation?: MainStemSDKIntegrationsApexTradingSearchModelsBatchOperation
  cannabinoids?: MainStemSDKIntegrationsApexTradingSearchModelsBatchCannabinoid[]
  terpenes?: MainStemSDKIntegrationsApexTradingSearchModelsBatchTerpene[]
  pricing_variants?: MainStemSDKIntegrationsApexTradingSearchModelsPricingVariant[]
}

export interface MainStemSDKIntegrationsApexTradingSearchModelsBatchOperation {
  /** @format int32 */
  id?: number
  name?: string
  city?: string
  industry?: string
  state_license?: string
  state?: MainStemSDKIntegrationsApexTradingSearchModelsStateResource
}

export interface MainStemSDKIntegrationsApexTradingSearchModelsBatchCannabinoid {
  /** @format int32 */
  id?: number
  name?: string
  abbreviation?: string
  display_name?: string
  measurement?: string
  measurement_type?: string
}

export interface MainStemSDKIntegrationsApexTradingSearchModelsBatchTerpene {
  /** @format int32 */
  id?: number
  name?: string
  display_name?: string
  measurement?: string
  measurement_type?: string
}

export interface MainStemSDKIntegrationsApexTradingSearchModelsPricingVariant {
  is_sample?: boolean
  /** @format double */
  unit_price?: number
  /** @format int32 */
  unit_measurement_id?: number
  unit_measurement_name?: string
  unit_measurment_alias?: string
  /** @format int32 */
  base_unit_measurement_id?: number
  base_unit_measurement_name?: string
  /** @format double */
  base_unit_multiple?: number
  decimals_allowed?: boolean
}

export interface MainStemSDKIntegrationsApexTradingSearchModelsStateResource {
  /** @format int32 */
  id?: number
  text?: string
  value?: string
}

export interface MainStemAPIPlatformControllersPurchasingShopMarketplaceApexTradingSearchAPIRequest {
  query?: string
  /** @format int32 */
  integrationSettingsId?: number
}

export interface MainStemAPIPlatformControllersPurchasingShopMarketplaceApexTradingSearchAPIResponse {
  products?: MainStemAPIPlatformControllersPurchasingShopMarketplaceApexTradingSearchAPIResponseProductDetails[]
  /** @format int32 */
  totalCount?: number
  message?: string
  wasSuccessful?: boolean
}

export interface MainStemAPIPlatformControllersPurchasingShopMarketplaceCannabisExpertsDetailsAPIRequest {
  productId?: string
}

export interface MainStemAPIPlatformControllersPurchasingShopMarketplaceCannabisExpertsDetailsAPIResponse {
  product?: MainStemAPIPlatformControllersPurchasingShopMarketplaceCannabisExpertsSearchAPIResponseProductDetails
  message?: string
  wasSuccessful?: boolean
}

export interface MainStemAPIPlatformControllersPurchasingShopMarketplaceCannabisExpertsSearchAPIResponseProductDetails {
  availability?: string
  condition?: string
  currency?: string
  /** @format date-time */
  dateCreated?: string
  /** @format date-time */
  dateUpdated?: string
  description?: string
  equipmentType?: string
  facilityType?: string
  id: string
  image?: string
  images: string[]
  location?: string
  name?: string
  /** @format double */
  price?: number
  shipping?: string
  sku?: string
  state?: string
  summary?: string
  videoUrl?: string
}

export interface MainStemAPIPlatformControllersPurchasingShopMarketplaceCannabisExpertsRFICreateAPIRequest {
  productId?: string
  message?: string
}

export interface MainStemAPIPlatformControllersPurchasingShopMarketplaceCannabisExpertsRFICreateAPIResponse {
  /** @format int32 */
  id?: number
  message?: string
  wasSuccessful?: boolean
}

export interface MainStemAPIPlatformControllersPurchasingShopMarketplaceCannabisExpertsSearchAPIRequest {
  query?: string
  equipmentType?: string
  facilityType?: string
  condition?: string
  state?: string
  sort?: string
  /** @format int32 */
  pageNumber?: number
  /** @format int32 */
  pageSize?: number
}

export interface MainStemAPIPlatformControllersPurchasingShopMarketplaceCannabisExpertsSearchAPIResponse {
  products?: MainStemAPIPlatformControllersPurchasingShopMarketplaceCannabisExpertsSearchAPIResponseProductDetails[]
  /** @format int32 */
  totalCount: number
  conditions: string[]
  equipmentTypes: string[]
  facilityTypes: string[]
  states: string[]
  message?: string
  wasSuccessful?: boolean
}

export interface MainStemAPIPlatformControllersPurchasingShopMarketplaceGiftCardsDetailsAPIRequest {
  productId: string
}

export interface MainStemAPIPlatformControllersPurchasingShopMarketplaceGiftCardsDetailsAPIResponse {
  product?: MainStemAPIPlatformControllersPurchasingShopMarketplaceGiftCardsSearchAPIResponseProductDetails
  message?: string
  wasSuccessful?: boolean
}

export interface MainStemAPIPlatformControllersPurchasingShopMarketplaceGiftCardsSearchAPIResponseProductDetails {
  currencyCode?: string
  deliveryTypes?: string[]
  denominationType?: string
  denominations?: number[]
  description?: string
  disclaimer?: string
  faceplates?: MainStemAPIPlatformControllersPurchasingShopMarketplaceGiftCardsSearchAPIResponseFaceplate[]
  id: string
  image?: string
  /** @format double */
  maxDenomination?: number
  /** @format double */
  minDenomination?: number
  name?: string
  productType?: string
  redemptionNote?: string
  summary?: string
  terms?: string
}

export interface MainStemAPIPlatformControllersPurchasingShopMarketplaceGiftCardsSearchAPIResponseFaceplate {
  image?: string
  name?: string
}

export interface MainStemAPIPlatformControllersPurchasingShopMarketplaceGiftCardsSearchAPIRequest {
  query?: string
  productType?: string
  /** @format int32 */
  pageNumber?: number
  /** @format int32 */
  pageSize?: number
}

export interface MainStemAPIPlatformControllersPurchasingShopMarketplaceGiftCardsSearchAPIResponse {
  products?: MainStemAPIPlatformControllersPurchasingShopMarketplaceGiftCardsSearchAPIResponseProductDetails[]
  /** @format int32 */
  totalCount?: number
  message?: string
  wasSuccessful?: boolean
}

export interface MainStemAPIPlatformControllersPurchasingShopMarketplaceMainStemSearchAPIRequest {
  attributes?: MainStemAPIPlatformControllersPurchasingShopMarketplaceMainStemSearchAPIRequestAttributeDetails[]
  /** @format int32 */
  catalogId?: number
  /** @format int32 */
  highestPrice?: number
  inStock?: boolean
  isCannabis?: boolean
  loose?: boolean
  /** @format int32 */
  lowestPrice?: number
  onlyParents?: boolean
  onlyPrivate?: boolean
  onlyVolumeDiscounts?: boolean
  /** @format int32 */
  pageNumber?: number
  /** @format int32 */
  pageSize?: number
  query?: string
}

export interface MainStemAPIPlatformControllersPurchasingShopMarketplaceMainStemSearchAPIRequestAttributeDetails {
  attribute?: string
  values?: string[]
}

export interface MainStemAPIPlatformControllersPurchasingShopMarketplaceMainStemSearchAPIResponse {
  attributes?: MainStemSDKProvidersAlgoliaModelsSearchProviderResponseAttributeDetails[]
  products?: MainStemAPIPlatformControllersPurchasingShopMarketplaceMainStemSearchAPIResponseProductDetails[]
  supplier?: MainStemAPIPlatformControllersPurchasingShopMarketplaceMainStemSearchAPIResponseSupplierDetails
  /** @format double */
  time?: number
  /** @format int32 */
  total?: number
  /** @format int32 */
  totalStrict?: number
  message?: string
  wasSuccessful?: boolean
}

export interface MainStemSDKProvidersAlgoliaModelsSearchProviderResponseAttributeDetails {
  name?: string
  values?: MainStemSDKProvidersAlgoliaModelsSearchProviderResponseAttributeDetailsAttributeValueDetails[]
}

export interface MainStemAPIPlatformControllersPurchasingShopMarketplaceMainStemSearchAPIResponseProductDetails {
  /** @format int32 */
  daysToFulfill?: number
  hasVolumePricing?: boolean
  /** @format double */
  highestPrice?: number
  /** @format int32 */
  id: number
  image?: string
  isOutOfStock?: boolean
  isPrivate?: boolean
  /** @format double */
  lowestPrice?: number
  name?: string
  /** @format int32 */
  numberOfSuppliers?: number
  /** @format double */
  priceSellEnterprise?: number
  type?: string
}

export interface MainStemAPIPlatformControllersPurchasingShopMarketplaceMainStemSearchAPIResponseSupplierDetails {
  address?: MainStemAPIPlatformControllersPurchasingShopMarketplaceMainStemSearchAPIResponseSupplierDetailsAddressDetails
  description?: string
  email?: string
  hasDirectPay?: boolean
  hasPreferredShipping?: boolean
  header?: string
  /** @format int32 */
  id?: number
  isVerified?: boolean
  logo?: string
  name?: string
  phone?: string
  website?: string
}

export interface MainStemSDKProvidersAlgoliaModelsSearchProviderResponseAttributeDetailsAttributeValueDetails {
  /** @format int64 */
  count?: number
  name?: string
}

export interface MainStemAPIPlatformControllersPurchasingShopMarketplaceMainStemSearchAPIResponseSupplierDetailsAddressDetails {
  address1?: string
  address2?: string
  city?: string
  country?: string
  state?: string
  zip?: string
}

export interface MainStemAPIPlatformControllersPurchasingShopMarketplaceStaplesSearchAPIRequest {
  /** @format int32 */
  pageNumber?: number
  query?: string
}

export interface MainStemAPIPlatformControllersPurchasingShopMarketplaceStaplesSearchAPIResponse {
  json?: string
  products?: MainStemAPIPlatformControllersPurchasingShopMarketplaceStaplesSearchAPIResponseProductDetails[]
  searchDetails?: MainStemAPIPlatformControllersPurchasingShopMarketplaceStaplesSearchAPIResponseSearchDetails
  /** @format int32 */
  totalCount?: number
  message?: string
  wasSuccessful?: boolean
}

export interface MainStemAPIPlatformControllersPurchasingShopMarketplaceStaplesSearchAPIResponseProductDetails {
  /** @format double */
  cost?: number
  /** @format int32 */
  daysToFulfill?: number
  description?: string
  /** @format double */
  height?: number
  image?: string
  isOutOfStock?: boolean
  itemId?: string
  /** @format double */
  length?: number
  name?: string
  /** @format double */
  price?: number
  showInStore?: boolean
  skuInternal?: string
  skuManufacturer?: string
  staplesProduct?: MainStemSDKIntegrationsStaplesModelsStaplesProduct
  /** @format double */
  weight?: number
  /** @format double */
  width?: number
}

export interface MainStemAPIPlatformControllersPurchasingShopMarketplaceStaplesSearchAPIResponseSearchDetails {
  partitionKey?: string
  rowKey?: string
}

export interface MainStemAPIPlatformControllersPurchasingShopProductDetailsAPIRequest {
  /** @format int32 */
  productId?: number
}

export interface MainStemAPIPlatformControllersPurchasingShopProductDetailsAPIResponse {
  mainProduct: MainStemAPIPlatformControllersPurchasingShopProductDetailsAPIResponseProductDetails
  priceToUse: string
  products: MainStemAPIPlatformControllersPurchasingShopProductDetailsAPIResponseProductDetails[]
  message?: string
  wasSuccessful?: boolean
}

export interface MainStemAPIPlatformControllersPurchasingShopProductDetailsAPIResponseProductDetails {
  catalogs: MainStemAPIPlatformControllersPurchasingShopProductDetailsAPIResponseProductDetailsCatalogDetails[]
  cleanURL?: string
  /** @format int32 */
  daysToFulfill?: number
  description?: string
  hasVolumePricing?: boolean
  /** @format int32 */
  id: number
  image?: string
  isOutOfStock?: boolean
  isPaidAd?: boolean
  isPrivate?: boolean
  isPunchOut?: boolean
  isPurchasable?: boolean
  /** @format int32 */
  max?: number
  /** @format int32 */
  min?: number
  name?: string
  /** @format double */
  priceCustom?: number
  /** @format double */
  priceEnterprise?: number
  /** @format double */
  priceRetail?: number
  /** @format double */
  priceWholesale?: number
  pricing?: MainStemSDKHelpersProductPricingResult
  shipsFrom?: string
  skuInternal?: string
  skuManufacturer?: string
  smallText?: string
  /** @format int32 */
  soldInQuantitiesOf?: number
  supplier?: MainStemAPIPlatformControllersPurchasingShopProductDetailsAPIResponseProductDetailsSupplierDetails
  type?: string
  unitOfMeasureLabel?: string
  unitOfMeasureValue?: string
  volumePricing: MainStemAPIPlatformControllersPurchasingShopProductDetailsAPIResponseProductDetailsVolumePricingDetails[]
  volumePricingPriceAgreement: MainStemAPIPlatformControllersPurchasingShopProductDetailsAPIResponseProductDetailsVolumePricingAgreementDetails[]
}

export interface MainStemAPIPlatformControllersPurchasingShopProductDetailsAPIResponseProductDetailsCatalogDetails {
  /** @format int32 */
  id: number
  name: string
}

export interface MainStemSDKHelpersProductPricingResult {
  /** @format double */
  agreementPrice?: number
  /** @format double */
  enterprisePrice?: number
  hasVolumePricing?: boolean
  /** @format double */
  highestPrice?: number
  /** @format double */
  lowestPrice?: number
  /** @format double */
  pricePerUnit?: number
  /** @format double */
  priceToUse?: number
  /** @format double */
  retailPrice?: number
  /** @format int32 */
  unitsPer?: number
  /** @format double */
  volumePrice?: number
  /** @format double */
  wholesalePrice?: number
}

export interface MainStemAPIPlatformControllersPurchasingShopProductDetailsAPIResponseProductDetailsSupplierDetails {
  integrationType?: string
  logo?: string
  name: string
  usesDirectPay: boolean
  usesPreferredShipping: boolean
}

export interface MainStemAPIPlatformControllersPurchasingShopProductDetailsAPIResponseProductDetailsVolumePricingDetails {
  /** @format double */
  price: number
  /** @format int32 */
  quantityHigh?: number
  /** @format int32 */
  quantityLow: number
}

export interface MainStemAPIPlatformControllersPurchasingShopProductDetailsAPIResponseProductDetailsVolumePricingAgreementDetails {
  /** @format double */
  price: number
  /** @format int32 */
  quantityHigh?: number
  /** @format int32 */
  quantityLow: number
}

export interface MainStemAPIPlatformControllersPurchasingSuppliersDetailsAPIRequest {
  /** @format int32 */
  vendorId?: number
}

export interface MainStemAPIPlatformControllersPurchasingSuppliersDetailsAPIResponse {
  address1?: string
  address2?: string
  addresses?: MainStemAPIPlatformControllersPurchasingSuppliersDetailsAPIResponseAddressCollections
  chartDetails?: MainStemAPIPlatformControllersPurchasingSuppliersDetailsAPIResponseChartDataDetails
  city?: string
  contacts?: MainStemAPIPlatformControllersPurchasingSuppliersDetailsAPIResponseContactDetails[]
  country?: string
  /** @format date-time */
  dateFirstOrder?: string
  /** @format date-time */
  dateLastOrder?: string
  description?: string
  email?: string
  frieghtSettings?: MainStemAPIPlatformControllersPurchasingSuppliersDetailsAPIResponseFreightSettingsDetails
  headerURL?: string
  /** @format int32 */
  id?: number
  isCannabisSupplier?: boolean
  isPrivateSupplier?: boolean
  logoURL?: string
  name?: string
  paymentTerms?: string
  /** @format double */
  paymentTermsCreditLimit?: number
  /** @format int32 */
  paymentTermsDays?: number
  /** @format int32 */
  paymentTermsDiscountDays?: number
  /** @format double */
  paymentTermsDiscountPercent?: number
  /** @format double */
  paymentTermsPercent?: number
  /** @format double */
  paymentTermsPrePaymentPercent?: number
  requiresPrePayment?: boolean
  supplierReconciliationAIGuidance?: string
  phone?: string
  refundPolicy?: string
  shipmentSettings?: MainStemAPIPlatformControllersPurchasingSuppliersDetailsAPIResponseShipmentSettingsDetails
  socialMedia?: MainStemAPIPlatformControllersPurchasingSuppliersDetailsAPIResponseSocialMediaLinks
  state?: string
  /** @format double */
  totalSpend?: number
  usesDirectPay?: boolean
  usesPreferredShipping?: boolean
  website?: string
  zip?: string
  message?: string
  wasSuccessful?: boolean
}

export interface MainStemAPIPlatformControllersPurchasingSuppliersDetailsAPIResponseAddressCollections {
  billing?: MainStemAPIPlatformControllersPurchasingSuppliersDetailsAPIResponseAddressDetails
  physical?: MainStemAPIPlatformControllersPurchasingSuppliersDetailsAPIResponseAddressDetails
}

export interface MainStemAPIPlatformControllersPurchasingSuppliersDetailsAPIResponseChartDataDetails {
  lastMonthSales?: MainStemAPIPlatformControllersPurchasingSuppliersDetailsAPIResponseChartDataDetailsChartDetails
  thisMonthSales?: MainStemAPIPlatformControllersPurchasingSuppliersDetailsAPIResponseChartDataDetailsChartDetails
}

export interface MainStemAPIPlatformControllersPurchasingSuppliersDetailsAPIResponseContactDetails {
  email?: string
  firstName?: string
  isPrimary?: boolean
  lastName?: string
  phone?: string
  phoneExtension?: string
  position?: string
}

export interface MainStemAPIPlatformControllersPurchasingSuppliersDetailsAPIResponseFreightSettingsDetails {
  carrier?: string
  /** @format double */
  freeShippingMinimum?: number
  required?: boolean
  /** @format int32 */
  trigger?: number
}

export interface MainStemAPIPlatformControllersPurchasingSuppliersDetailsAPIResponseShipmentSettingsDetails {
  /** @format int32 */
  bundle?: number
  carrier?: string
  /** @format double */
  freeShippingMinimum?: number
}

export interface MainStemAPIPlatformControllersPurchasingSuppliersDetailsAPIResponseSocialMediaLinks {
  facebook?: string
  instagram?: string
  linkedIn?: string
  twitter?: string
}

export interface MainStemAPIPlatformControllersPurchasingSuppliersDetailsAPIResponseAddressDetails {
  address1?: string
  address2?: string
  city?: string
  country?: string
  state?: string
  zip?: string
}

export interface MainStemAPIPlatformControllersPurchasingSuppliersDetailsAPIResponseChartDataDetailsChartDetails {
  label?: string
  /** @format double */
  value?: number
}

export interface MainStemAPIPlatformControllersPurchasingSuppliersDetailsCatalogsAPIRequest {
  /** @format int32 */
  supplierId?: number
}

export interface MainStemAPIPlatformControllersPurchasingSuppliersDetailsCatalogsAPIResponse {
  catalogs?: MainStemAPIPlatformControllersPurchasingSuppliersDetailsCatalogsAPIResponseCatalogDetails[]
  message?: string
  wasSuccessful?: boolean
}

export interface MainStemAPIPlatformControllersPurchasingSuppliersDetailsCatalogsAPIResponseCatalogDetails {
  /** @format int32 */
  id?: number
  name?: string
}

export interface MainStemAPIPlatformControllersPurchasingSuppliersDetailsOrdersAPIRequest {
  /** @format int32 */
  supplierId?: number
}

export interface MainStemAPIPlatformControllersPurchasingSuppliersDetailsOrdersAPIResponse {
  orders?: MainStemAPIPlatformControllersPurchasingSuppliersDetailsOrdersAPIResponseOrderDetails[]
  message?: string
  wasSuccessful?: boolean
}

export interface MainStemAPIPlatformControllersPurchasingSuppliersDetailsOrdersAPIResponseOrderDetails {
  /** @format date-time */
  dateApproved?: string
  /** @format date-time */
  dateCreated?: string
  /** @format double */
  discount?: number
  /** @format int32 */
  id?: number
  location?: MainStemAPIPlatformControllersPurchasingSuppliersDetailsOrdersAPIResponseOrderDetailsLocationDetails
  /** @format double */
  orderTotal?: number
  paymentStatus?: string
  /** @format double */
  salesTax?: number
  /** @format double */
  shipping?: number
  status?: 'New' | 'PendingApproval' | 'Returned' | 'Approved' | 'Rejected' | 'Cancelled'
  /** @format double */
  subTotal?: number
  userApprovedBy?: string
  userCreatedBy?: string
  uuid?: string
}

export interface MainStemAPIPlatformControllersPurchasingSuppliersDetailsOrdersAPIResponseOrderDetailsLocationDetails {
  address1?: string
  address2?: string
  city?: string
  country?: string
  /** @format int32 */
  id?: number
  name?: string
  state?: string
  zip?: string
}

export interface MainStemAPIPlatformControllersPurchasingSuppliersDetailsProductsAPIRequest {
  /** @format int32 */
  supplierId?: number
}

export interface MainStemAPIPlatformControllersPurchasingSuppliersDetailsProductsAPIResponse {
  products?: MainStemAPIPlatformControllersPurchasingSuppliersDetailsProductsAPIResponseProductDetails[]
  message?: string
  wasSuccessful?: boolean
}

export interface MainStemAPIPlatformControllersPurchasingSuppliersDetailsProductsAPIResponseProductDetails {
  /** @format date-time */
  firstOrderedDate?: string
  /** @format int32 */
  id?: number
  /** @format date-time */
  lastOrderedDate?: string
  name?: string
  /** @format int32 */
  totalOrders?: number
  /** @format int32 */
  totalQuantityOrdered?: number
  type?: string
}

export interface MainStemAPIPlatformControllersPurchasingSuppliersDetailsProductsYouMayLikeAPIRequest {
  /** @format int32 */
  vendorId?: number
}

export interface MainStemAPIPlatformControllersPurchasingSuppliersDetailsProductsYouMayLikeAPIResponse {
  products?: MainStemAPIPlatformControllersPurchasingSuppliersDetailsProductsYouMayLikeAPIResponseProductDetails[]
  message?: string
  wasSuccessful?: boolean
}

export interface MainStemAPIPlatformControllersPurchasingSuppliersDetailsProductsYouMayLikeAPIResponseProductDetails {
  /** @format int32 */
  id?: number
  name?: string
  productImageURL?: string
  type?: string
}

export interface MainStemAPIPlatformControllersPurchasingSuppliersDetailsShipmentsAPIRequest {
  /** @format int32 */
  supplierId?: number
}

export interface MainStemAPIPlatformControllersPurchasingSuppliersDetailsShipmentsAPIResponse {
  shipments?: MainStemAPIPlatformControllersPurchasingSuppliersDetailsShipmentsAPIResponseShipmentDetails[]
  message?: string
  wasSuccessful?: boolean
}

export interface MainStemAPIPlatformControllersPurchasingSuppliersDetailsShipmentsAPIResponseShipmentDetails {
  carrier?: string
  carrierType?: string
  /** @format date-time */
  dateCreated?: string
  /** @format date-time */
  dateReceived?: string
  /** @format date-time */
  dateShippedOn?: string
  /** @format date-time */
  estimatedDeliveryDate?: string
  /** @format int32 */
  orderID?: number
  orderUUID?: string
  trackingNumber?: string
  uuid?: string
}

export interface MainStemAPIPlatformControllersPurchasingSuppliersListAPIRequest {
  isPrivate?: boolean
}

export interface MainStemAPIPlatformControllersPurchasingSuppliersListAPIResponse {
  suppliers?: MainStemAPIPlatformControllersPurchasingSuppliersListAPIResponseSupplierDetails[]
  message?: string
  wasSuccessful?: boolean
}

export interface MainStemAPIPlatformControllersPurchasingSuppliersListAPIResponseSupplierDetails {
  /** @format date-time */
  firstOrderedDate?: string
  /** @format int32 */
  id?: number
  imgURL?: string
  isPrivateSupplier?: boolean
  isArchived?: boolean
  /** @format date-time */
  lastOrderedDate?: string
  name?: string
  /** @format int32 */
  totalOrders?: number
  /** @format int32 */
  totalProducts?: number
  /** @format int32 */
  totalQuantityOrdered?: number
  userRelated?: boolean
  usesDirectPay?: boolean
  usesPreferredShipping?: boolean
}

export interface MainStemAPIPlatformControllersPurchasingThreeWayMatchesCreateAPIRequest {
  /** @format int32 */
  invoiceId?: number
  /** @format int32 */
  purchaseOrderId?: number
}

export interface MainStemAPIPlatformControllersPurchasingThreeWayMatchesCreateAPIResponse {
  created?: boolean
  match?: MainStemAPIPlatformControllersPurchasingThreeWayMatchesMatchDetails
  message?: string
  wasSuccessful?: boolean
}

export interface MainStemAPIPlatformControllersPurchasingThreeWayMatchesMatchDetails {
  createdBy?: string
  /** @format date-time */
  dateCreated?: string
  /** @format date-time */
  dateLastChecked?: string
  documents?: MainStemAPIPlatformControllersPurchasingThreeWayMatchesMatchDetailsDocumentDetails[]
  /** @format int32 */
  id?: number
  /** @format double */
  invoicedQuantity?: number
  invoiceStatus?: 'NotStarted' | 'Pending' | 'Matched' | 'Mismatch'
  /** @format double */
  invoiceTotal?: number
  issue?: string
  lines?: MainStemAPIPlatformControllersPurchasingThreeWayMatchesMatchDetailsLineDetails[]
  /** @format double */
  orderedQuantity?: number
  overallStatus?: 'NotStarted' | 'InProgress' | 'FullyMatched' | 'Discrepancy'
  /** @format int32 */
  purchaseOrderId?: number
  purchaseOrderStatus?: 'NotStarted' | 'Pending' | 'Matched' | 'Mismatch'
  /** @format double */
  purchaseOrderTotal?: number
  /** @format double */
  receivedQuantity?: number
  receivedStatus?: 'NotStarted' | 'Pending' | 'Matched' | 'Mismatch'
  /** @format double */
  receivedTotal?: number
  requisitionUuid?: string
}

export interface MainStemAPIPlatformControllersPurchasingThreeWayMatchesMatchDetailsDocumentDetails {
  /** @format int32 */
  documentId?: number
  kind?: 'PurchaseOrder' | 'Invoice' | 'Receiving'
  /** @format double */
  quantity?: number
  /** @format int32 */
  relatedDocumentId?: number
  /** @format double */
  total?: number
  uuid?: string
}

export interface MainStemAPIPlatformControllersPurchasingThreeWayMatchesMatchDetailsLineDetails {
  issue?: string
  name?: string
  /** @format int32 */
  productId?: number
  /** @format double */
  quantityInvoiced?: number
  /** @format double */
  quantityOrdered?: number
  /** @format double */
  quantityReceived?: number
  sku?: string
  status?: 'Pending' | 'Matched' | 'Mismatch'
  /** @format double */
  unitPriceInvoiced?: number
  /** @format double */
  unitPriceOrdered?: number
}

export interface MainStemAPIPlatformControllersPurchasingThreeWayMatchesDetailsAPIRequest {
  /** @format int32 */
  invoiceId?: number
  /** @format int32 */
  purchaseOrderId?: number
}

export interface MainStemAPIPlatformControllersPurchasingThreeWayMatchesDetailsAPIResponse {
  match?: MainStemAPIPlatformControllersPurchasingThreeWayMatchesMatchDetails
  message?: string
  wasSuccessful?: boolean
}

export interface MainStemAPIPlatformControllersPurchasingThreeWayMatchesRecheckAPIRequest {
  /** @format int32 */
  id?: number
  /** @format int32 */
  invoiceId?: number
  /** @format int32 */
  purchaseOrderId?: number
}

export interface MainStemAPIPlatformControllersPurchasingThreeWayMatchesRecheckAPIResponse {
  match?: MainStemAPIPlatformControllersPurchasingThreeWayMatchesMatchDetails
  message?: string
  wasSuccessful?: boolean
}

export interface MainStemAPIPlatformControllersPurchasingUserPermissionsCreateAPIRequest {
  /** @format int32 */
  permissionId?: number
  userId?: string
  value?: string
}

export interface MainStemAPIPlatformControllersPurchasingUserPermissionsCreateAPIResponse {
  displayName?: string
  group?: string
  /** @format int32 */
  id?: number
  shortCode?: string
  message?: string
  wasSuccessful?: boolean
}

export interface MainStemAPIPlatformControllersPurchasingUserPermissionsDeleteAPIRequest {
  /** @format int32 */
  id?: number
  userId?: string
}

export interface MainStemAPIPlatformControllersPurchasingUserPermissionsUpdateAPIRequest {
  /** @format int32 */
  id?: number
  value?: string
}

export interface MainStemAPIPlatformControllersPurchasingUserPermissionsUpdateAPIResponse {
  displayName?: string
  group?: string
  /** @format int32 */
  id?: number
  shortCode?: string
  message?: string
  wasSuccessful?: boolean
}

export interface MainStemAPIPlatformControllersPurchasingUsersCatalogsListAPIRequest {
  userId?: string
}

export interface MainStemAPIPlatformControllersPurchasingUsersCatalogsListAPIResponse {
  catalogs: MainStemAPIPlatformControllersPurchasingUsersCatalogsListAPIResponseCatalogDetails[]
  message?: string
  wasSuccessful?: boolean
}

export interface MainStemAPIPlatformControllersPurchasingUsersCatalogsListAPIResponseCatalogDetails {
  /** @format int32 */
  id: number
  isPrivate: boolean
  name: string
}

export interface MainStemAPIPlatformControllersPurchasingUsersCreateAPIRequest {
  email?: string
  friendlyName?: string
  /** @format int32 */
  locationId?: number
  password?: string
  /** @format int32 */
  permissionGroupId?: number
  title?: string
  type?: string
}

export interface MainStemAPIPlatformControllersPurchasingUsersCreateAPIResponse {
  error?: string
  userId?: string
  message?: string
  wasSuccessful?: boolean
}

export interface MainStemAPIPlatformControllersPurchasingUsersDeleteAPIRequest {
  userId?: string
}

export interface MainStemAPIPlatformControllersPurchasingUsersDeleteAPIResponse {
  message?: string
  wasSuccessful?: boolean
}

export interface MainStemAPIPlatformControllersPurchasingUsersDetailsAPIRequest {
  uuid?: string
}

export interface MainStemAPIPlatformControllersPurchasingUsersDetailsAPIResponse {
  activityLogs?: MainStemAPIPlatformControllersPurchasingUsersDetailsAPIResponseActivityLog[]
  copyUserOnApprovedOrders?: boolean
  copyUserOnCreatedOrders?: boolean
  /** @format date-time */
  dateCreated?: string
  defaultCatalog?: MainStemAPIPlatformControllersPurchasingUsersDetailsAPIResponseCatalogDetails
  defaultLocation?: MainStemAPIPlatformControllersPurchasingUsersDetailsAPIResponseLocationDetails
  departments?: MainStemAPIPlatformControllersPurchasingUsersDetailsAPIResponseDepartmentDetails[]
  email?: string
  friendlyName?: string
  groupPermissions?: MainStemAPIPlatformControllersPurchasingUsersDetailsAPIResponsePermissionDetails[]
  isBlocked?: boolean
  permissionGroup?: MainStemAPIPlatformControllersPurchasingUsersDetailsAPIResponsePermissionGroupDetail
  permissions?: MainStemAPIPlatformControllersPurchasingUsersDetailsAPIResponsePermissionDetails[]
  role?: string
  secondaryLocations?: MainStemAPIPlatformControllersPurchasingUsersDetailsAPIResponseLocationDetails[]
  title?: string
  type?: string
  username?: string
  userPermissions?: MainStemAPIPlatformControllersPurchasingUsersDetailsAPIResponsePermissionDetails[]
  uuid?: string
  message?: string
  wasSuccessful?: boolean
}

export interface MainStemAPIPlatformControllersPurchasingUsersDetailsAPIResponseActivityLog {
  content?: string
  /** @format date-time */
  dateCreated?: string
  /** @format int32 */
  documentID?: number
  documentType?: string
  /** @format int32 */
  id?: number
  reason?: string
}

export interface MainStemAPIPlatformControllersPurchasingUsersDetailsAPIResponseCatalogDetails {
  /** @format int32 */
  id?: number
  name?: string
}

export interface MainStemAPIPlatformControllersPurchasingUsersDetailsAPIResponseLocationDetails {
  address1?: string
  address2?: string
  city?: string
  country?: string
  headerURL?: string
  /** @format int32 */
  id?: number
  logoURL?: string
  name?: string
  state?: string
  uuid?: string
  zip?: string
}

export interface MainStemAPIPlatformControllersPurchasingUsersDetailsAPIResponseDepartmentDetails {
  /** @format int32 */
  id?: number
  location?: MainStemAPIPlatformControllersPurchasingUsersDetailsAPIResponseDepartmentDetailsLocationDetails
  name?: string
}

export interface MainStemAPIPlatformControllersPurchasingUsersDetailsAPIResponsePermissionDetails {
  group?: string
  shortCode?: string
  value?: string
}

export interface MainStemAPIPlatformControllersPurchasingUsersDetailsAPIResponsePermissionGroupDetail {
  /** @format int32 */
  id?: number
  name?: string
}

export interface MainStemAPIPlatformControllersPurchasingUsersDetailsAPIResponseDepartmentDetailsLocationDetails {
  /** @format int32 */
  id?: number
  name?: string
}

export interface MainStemAPIPlatformControllersPurchasingUsersDetailsOrdersAPIRequest {
  uuid?: string
}

export interface MainStemAPIPlatformControllersPurchasingUsersDetailsOrdersAPIResponse {
  orders?: MainStemAPIPlatformControllersPurchasingUsersDetailsOrdersAPIResponseOrderDetails[]
  message?: string
  wasSuccessful?: boolean
}

export interface MainStemAPIPlatformControllersPurchasingUsersDetailsOrdersAPIResponseOrderDetails {
  /** @format date-time */
  dateApproved?: string
  /** @format date-time */
  dateCreated?: string
  /** @format double */
  discount?: number
  /** @format int32 */
  id?: number
  location?: MainStemAPIPlatformControllersPurchasingUsersDetailsOrdersAPIResponseOrderDetailsLocationDetails
  /** @format double */
  orderTotal?: number
  paymentStatus?: string
  /** @format double */
  salesTax?: number
  /** @format double */
  shipping?: number
  status?: 'New' | 'PendingApproval' | 'Returned' | 'Approved' | 'Rejected' | 'Cancelled'
  /** @format double */
  subTotal?: number
  userApprovedBy?: string
  userCreatedBy?: string
  uuid?: string
}

export interface MainStemAPIPlatformControllersPurchasingUsersDetailsOrdersAPIResponseOrderDetailsLocationDetails {
  address1?: string
  address2?: string
  city?: string
  country?: string
  /** @format int32 */
  id?: number
  name?: string
  state?: string
  zip?: string
}

export interface MainStemAPIPlatformControllersPurchasingUsersDetailsProductsAPIRequest {
  uuid?: string
}

export interface MainStemAPIPlatformControllersPurchasingUsersDetailsProductsAPIResponse {
  products?: MainStemAPIPlatformControllersPurchasingUsersDetailsProductsAPIResponseProductDetails[]
  message?: string
  wasSuccessful?: boolean
}

export interface MainStemAPIPlatformControllersPurchasingUsersDetailsProductsAPIResponseProductDetails {
  /** @format int32 */
  id?: number
  name?: string
  type?: string
  vendor?: MainStemAPIPlatformControllersPurchasingUsersDetailsProductsAPIResponseProductDetailsVendorDetails
}

export interface MainStemAPIPlatformControllersPurchasingUsersDetailsProductsAPIResponseProductDetailsVendorDetails {
  /** @format int32 */
  id?: number
  name?: string
}

export interface MainStemAPIPlatformControllersPurchasingUsersDetailsResetPasswordAPIRequest {
  password?: string
  userId?: string
}

export interface MainStemAPIPlatformControllersPurchasingUsersDetailsResetPasswordAPIResponse {
  message?: string
  wasSuccessful?: boolean
}

export interface MainStemAPIPlatformControllersPurchasingUsersDetailsVendorsAPIRequest {
  uuid?: string
}

export interface MainStemAPIPlatformControllersPurchasingUsersDetailsVendorsAPIResponse {
  vendors?: MainStemAPIPlatformControllersPurchasingUsersDetailsVendorsAPIResponseVendorDetails[]
  message?: string
  wasSuccessful?: boolean
}

export interface MainStemAPIPlatformControllersPurchasingUsersDetailsVendorsAPIResponseVendorDetails {
  /** @format date-time */
  firstOrderedDate?: string
  /** @format int32 */
  id?: number
  /** @format date-time */
  lastOrderedDate?: string
  name?: string
  /** @format int32 */
  totalOrders?: number
  /** @format int32 */
  totalQuantityOrdered?: number
}

export interface MainStemAPIPlatformControllersPurchasingUsersDuplicateAPIRequest {
  copyLocations?: boolean
  password?: string
  userId?: string
  username?: string
}

export interface MainStemAPIPlatformControllersPurchasingUsersDuplicateAPIResponse {
  userId?: string
  message?: string
  wasSuccessful?: boolean
}

export interface MainStemAPIPlatformControllersPurchasingUsersListAPIResponse {
  users?: MainStemAPIPlatformControllersPurchasingUsersListAPIResponseUserDetails[]
  message?: string
  wasSuccessful?: boolean
}

export interface MainStemAPIPlatformControllersPurchasingUsersListAPIResponseUserDetails {
  /** @format date-time */
  dateCreated?: string
  email?: string
  friendlyName?: string
  permissionGroup?: string
  title?: string
  username?: string
  userRelated?: boolean
  uuid?: string
  isBlocked?: boolean
}

export interface MainStemAPIPlatformControllersPurchasingUsersLocationsAddAPIRequest {
  locationIds?: number[]
  userId?: string
}

export interface MainStemAPIPlatformControllersPurchasingUsersLocationsAddAPIResponse {
  message?: string
  wasSuccessful?: boolean
}

export interface MainStemAPIPlatformControllersPurchasingUsersLocationsRemoveAPIRequest {
  /** @format int32 */
  locationId?: number
  userId?: string
}

export interface MainStemAPIPlatformControllersPurchasingUsersLocationsSetDefaultAPIRequest {
  /** @format int32 */
  locationId?: number
  userId?: string
}

export interface MainStemAPIPlatformControllersPurchasingUsersUpdateAPIRequest {
  copyUserOnApprovedOrders?: boolean
  copyUserOnCreatedOrders?: boolean
  /** @format int32 */
  defaultCatalogId?: number
  email?: string
  friendlyName?: string
  /** @format int32 */
  permissionGroupId?: number
  title?: string
  type?: string
  userId?: string
  username?: string
}

export interface MainStemAPIPlatformControllersPurchasingUsersUpdateAPIResponse {
  message?: string
  wasSuccessful?: boolean
}

import axios, { AxiosInstance, AxiosRequestConfig, AxiosResponse, ResponseType } from 'axios'

export type QueryParamsType = Record<string | number, any>

export interface FullRequestParams extends Omit<AxiosRequestConfig, 'data' | 'params' | 'url' | 'responseType'> {
  /** set parameter to `true` for call `securityWorker` for this request */
  secure?: boolean
  /** request path */
  path: string
  /** content type of request body */
  type?: ContentType
  /** query params */
  query?: QueryParamsType
  /** format of response (i.e. response.json() -> format: "json") */
  format?: ResponseType
  /** request body */
  body?: unknown
}

export type RequestParams = Omit<FullRequestParams, 'body' | 'method' | 'query' | 'path'>

export interface ApiConfig<SecurityDataType = unknown> extends Omit<AxiosRequestConfig, 'data' | 'cancelToken'> {
  securityWorker?: (
    securityData: SecurityDataType | null
  ) => Promise<AxiosRequestConfig | void> | AxiosRequestConfig | void
  secure?: boolean
  format?: ResponseType
}

export enum ContentType {
  Json = 'application/json',
  FormData = 'multipart/form-data',
  UrlEncoded = 'application/x-www-form-urlencoded'
}

export class HttpClient<SecurityDataType = unknown> {
  public instance: AxiosInstance
  private securityData: SecurityDataType | null = null
  private securityWorker?: ApiConfig<SecurityDataType>['securityWorker']
  private secure?: boolean
  private format?: ResponseType

  constructor({ securityWorker, secure, format, ...axiosConfig }: ApiConfig<SecurityDataType> = {}) {
    const enterpriseToken = window.localStorage.getItem('mainstem_user_token')
    const sessionURL = window.localStorage.getItem('logrocket_session_url')
    const affiliateProgramUUID = import.meta.env.VITE_REACT_APP_PURCHASE_PRO_AFFILIATE_ID
    this.instance = axios.create({
      ...axiosConfig,
      baseURL: axiosConfig.baseURL || 'https://dev-api.mainstem.io',
      headers: {
        Authorization: `Bearer ${enterpriseToken || ''}`,
        'X-AffiliateProgramUUID': affiliateProgramUUID,
        'X-SessionURL': sessionURL,
        'X-Platform': 'Purchase Pro'
      }
    })
    this.secure = secure
    this.format = format
    this.securityWorker = securityWorker
  }

  public setSecurityData = (data: SecurityDataType | null) => {
    this.securityData = data
  }

  private mergeRequestParams(params1: AxiosRequestConfig, params2?: AxiosRequestConfig): AxiosRequestConfig {
    return {
      ...this.instance.defaults,
      ...params1,
      ...(params2 || {}),
      headers: {
        ...(this.instance.defaults.headers || {}),
        ...(params1.headers || {}),
        ...((params2 && params2.headers) || {})
      }
    }
  }

  private createFormData(input: Record<string, unknown>): FormData {
    return Object.keys(input || {}).reduce((formData, key) => {
      const property = input[key]
      formData.append(
        key,
        property instanceof Blob
          ? property
          : typeof property === 'object' && property !== null
            ? JSON.stringify(property)
            : `${property}`
      )
      return formData
    }, new FormData())
  }

  public request = async <T = any, _E = any>({
    secure,
    path,
    type,
    query,
    format,
    body,
    ...params
  }: FullRequestParams): Promise<AxiosResponse<T>> => {
    const secureParams =
      ((typeof secure === 'boolean' ? secure : this.secure) &&
        this.securityWorker &&
        (await this.securityWorker(this.securityData))) ||
      {}
    const requestParams = this.mergeRequestParams(params, secureParams)
    const responseFormat = (format && this.format) || void 0

    if (type === ContentType.FormData && body && body !== null && typeof body === 'object') {
      requestParams.headers.common = { Accept: '*/*' }
      requestParams.headers.post = {}
      requestParams.headers.put = {}

      body = this.createFormData(body as Record<string, unknown>)
    }

    const enterpriseToken = window.localStorage.getItem('mainstem_user_token')
    const sessionURL = window.localStorage.getItem('logrocket_session_url')
    const affiliateProgramUUID = import.meta.env.VITE_REACT_APP_PURCHASE_PRO_AFFILIATE_ID

    return this.instance.request({
      ...requestParams,
      headers: {
        ...(type && type !== ContentType.FormData ? { 'Content-Type': type } : {}),
        ...(requestParams.headers || {}),
        Authorization: `Bearer ${enterpriseToken || ''}`,
        'X-AffiliateProgramUUID': affiliateProgramUUID,
        'X-SessionURL': sessionURL,
        'X-Platform': 'Purchase Pro'
      },
      params: query,
      responseType: responseFormat,
      data: body,
      url: path
    })
  }
}

/**
 * @title MainStem Purchase Pro™ API V1
 * @version purchasing
 * @baseUrl https://dev-api.mainstem.io
 */
export class Api<SecurityDataType extends unknown> extends HttpClient<SecurityDataType> {
  api = {
    /**
     * No description
     *
     * @tags GlobalNotesCreate
     * @name OrderManagementOrderNotesCreate
     * @request POST:/api/purchasing/order-management/order-notes/create
     */
    orderManagementOrderNotesCreate: (
      apiRequest: MainStemAPIPlatformControllersGlobalNotesCreateAPIRequest,
      params: RequestParams = {}
    ) =>
      this.request<MainStemAPIPlatformControllersGlobalNotesCreateAPIResponse, any>({
        path: `/api/purchasing/order-management/order-notes/create`,
        method: 'POST',
        body: apiRequest,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags GlobalNotesDelete
     * @name OrderManagementOrderNotesDelete
     * @request POST:/api/purchasing/order-management/order-notes/delete
     */
    orderManagementOrderNotesDelete: (
      apiRequest: MainStemAPIPlatformControllersGlobalNotesDeleteAPIRequest,
      params: RequestParams = {}
    ) =>
      this.request<MainStemSDKModelsBaseResponse, any>({
        path: `/api/purchasing/order-management/order-notes/delete`,
        method: 'POST',
        body: apiRequest,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags GlobalNotesList
     * @name OrderManagementOrderNotesList
     * @request POST:/api/purchasing/order-management/order-notes/list
     */
    orderManagementOrderNotesList: (
      apiRequest: MainStemAPIPlatformControllersGlobalNotesListAPIRequest,
      params: RequestParams = {}
    ) =>
      this.request<MainStemAPIPlatformControllersGlobalNotesListAPIResponse, any>({
        path: `/api/purchasing/order-management/order-notes/list`,
        method: 'POST',
        body: apiRequest,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags GlobalNotesUpdate
     * @name OrderManagementOrderNotesUpdate
     * @request POST:/api/purchasing/order-management/order-notes/update
     */
    orderManagementOrderNotesUpdate: (
      request: MainStemAPIPlatformControllersGlobalNotesUpdateAPIRequest,
      params: RequestParams = {}
    ) =>
      this.request<MainStemSDKModelsBaseResponse, any>({
        path: `/api/purchasing/order-management/order-notes/update`,
        method: 'POST',
        body: request,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags PurchasingAccountDetails
     * @name AccountDetails
     * @request POST:/api/purchasing/account/details
     */
    accountDetails: (params: RequestParams = {}) =>
      this.request<MainStemAPIPlatformControllersPurchasingAccountDetailsAPIResponse, any>({
        path: `/api/purchasing/account/details`,
        method: 'POST',
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags PurchasingAccountingInvoicesDue
     * @name AccountingInvoicesDue
     * @request POST:/api/purchasing/accounting/invoices/due
     */
    accountingInvoicesDue: (params: RequestParams = {}) =>
      this.request<MainStemAPIPlatformControllersPurchasingAccountingInvoicesDueAPIResponse, any>({
        path: `/api/purchasing/accounting/invoices/due`,
        method: 'POST',
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags PurchasingAccountProfileAppearance
     * @name AccountProfileAppearance
     * @request POST:/api/purchasing/account/profile/appearance
     */
    accountProfileAppearance: (
      apiRequest: MainStemAPIPlatformControllersPurchasingAccountProfileAppearanceAPIRequest,
      params: RequestParams = {}
    ) =>
      this.request<MainStemAPIPlatformControllersPurchasingAccountProfileAppearanceAPIResponse, any>({
        path: `/api/purchasing/account/profile/appearance`,
        method: 'POST',
        body: apiRequest,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags PurchasingAccountProfileDetails
     * @name AccountProfileDetails
     * @request POST:/api/purchasing/account/profile/details
     */
    accountProfileDetails: (params: RequestParams = {}) =>
      this.request<MainStemAPIPlatformControllersPurchasingAccountProfileDetailsAPIResponse, any>({
        path: `/api/purchasing/account/profile/details`,
        method: 'POST',
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags PurchasingAccountProfileImageUpload
     * @name AccountProfileImageUpload
     * @request POST:/api/purchasing/account/profile/image/upload
     */
    accountProfileImageUpload: (params: RequestParams = {}) =>
      this.request<MainStemAPIPlatformControllersPurchasingAccountProfileImageUploadAPIResponse, any>({
        path: `/api/purchasing/account/profile/image/upload`,
        method: 'POST',
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags PurchasingAccountProfilePassword
     * @name AccountProfilePassword
     * @request POST:/api/purchasing/account/profile/password
     */
    accountProfilePassword: (
      apiRequest: MainStemAPIPlatformControllersPurchasingAccountProfilePasswordAPIRequest,
      params: RequestParams = {}
    ) =>
      this.request<MainStemAPIPlatformControllersPurchasingAccountProfilePasswordAPIResponse, any>({
        path: `/api/purchasing/account/profile/password`,
        method: 'POST',
        body: apiRequest,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags PurchasingAccountProfileUpdate
     * @name AccountProfileUpdate
     * @request POST:/api/purchasing/account/profile/update
     */
    accountProfileUpdate: (
      apiRequest: MainStemAPIPlatformControllersPurchasingAccountProfileUpdateAPIRequest,
      params: RequestParams = {}
    ) =>
      this.request<MainStemAPIPlatformControllersPurchasingAccountProfileUpdateAPIResponse, any>({
        path: `/api/purchasing/account/profile/update`,
        method: 'POST',
        body: apiRequest,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags PurchasingAccountUpdate
     * @name AccountUpdate
     * @request POST:/api/purchasing/account/update
     */
    accountUpdate: (
      apiRequest: MainStemAPIPlatformControllersPurchasingAccountUpdateAPIRequest,
      params: RequestParams = {}
    ) =>
      this.request<MainStemAPIPlatformControllersPurchasingAccountUpdateAPIResponse, any>({
        path: `/api/purchasing/account/update`,
        method: 'POST',
        body: apiRequest,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags PurchasingAddressAutoComplete
     * @name AddressAutoComplete
     * @request POST:/api/purchasing/address/auto-complete
     */
    addressAutoComplete: (
      apiRequest: MainStemAPIPlatformControllersPurchasingAddressAutoCompleteAPIRequest,
      params: RequestParams = {}
    ) =>
      this.request<MainStemAPIPlatformControllersPurchasingAddressAutoCompleteAPIResponse, any>({
        path: `/api/purchasing/address/auto-complete`,
        method: 'POST',
        body: apiRequest,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags PurchasingAddressSuggest
     * @name AddressSuggest
     * @request POST:/api/purchasing/address/suggest
     */
    addressSuggest: (
      apiRequest: MainStemAPIPlatformControllersPurchasingAddressSuggestAPIRequest,
      params: RequestParams = {}
    ) =>
      this.request<MainStemAPIPlatformControllersPurchasingAddressSuggestAPIResponse, any>({
        path: `/api/purchasing/address/suggest`,
        method: 'POST',
        body: apiRequest,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags PurchasingAddressValidate
     * @name AddressValidate
     * @request POST:/api/purchasing/address/validate
     */
    addressValidate: (
      apiRequest: MainStemAPIPlatformControllersPurchasingAddressValidateAPIRequest,
      params: RequestParams = {}
    ) =>
      this.request<MainStemAPIPlatformControllersPurchasingAddressValidateAPIResponse, any>({
        path: `/api/purchasing/address/validate`,
        method: 'POST',
        body: apiRequest,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags PurchasingAIChat
     * @name AiChat
     * @request POST:/api/purchasing/ai/chat
     */
    aiChat: (apiRequest: MainStemAPIPlatformControllersPurchasingAIChatAPIRequest, params: RequestParams = {}) =>
      this.request<MainStemAPIPlatformControllersPurchasingAIChatAPIResponse, any>({
        path: `/api/purchasing/ai/chat`,
        method: 'POST',
        body: apiRequest,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags PurchasingAIScrape
     * @name AiScrape
     * @request POST:/api/purchasing/ai/scrape
     */
    aiScrape: (apiRequest: MainStemAPIPlatformControllersPurchasingAIScrapeAPIRequest, params: RequestParams = {}) =>
      this.request<MainStemAPIPlatformControllersPurchasingAIScrapeAPIResponse, any>({
        path: `/api/purchasing/ai/scrape`,
        method: 'POST',
        body: apiRequest,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags PurchasingApprovalWorkflowAllowableUsers
     * @name LocationsApprovalWorkflowAllowableUsers
     * @request POST:/api/purchasing/locations/approval-workflow/allowable-users
     */
    locationsApprovalWorkflowAllowableUsers: (
      apiRequest: MainStemAPIPlatformControllersPurchasingLocationsApprovalWorkflowAllowableUsersAPIRequest,
      params: RequestParams = {}
    ) =>
      this.request<MainStemAPIPlatformControllersPurchasingLocationsApprovalWorkflowAllowableUsersAPIResponse, any>({
        path: `/api/purchasing/locations/approval-workflow/allowable-users`,
        method: 'POST',
        body: apiRequest,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags PurchasingApprovalWorkflowList
     * @name LocationsApprovalWorkflow
     * @request POST:/api/purchasing/locations/approval-workflow
     */
    locationsApprovalWorkflow: (
      apiRequest: MainStemAPIPlatformControllersPurchasingLocationsApprovalWorkflowListAPIRequest,
      params: RequestParams = {}
    ) =>
      this.request<MainStemAPIPlatformControllersPurchasingLocationsApprovalWorkflowListAPIResponse, any>({
        path: `/api/purchasing/locations/approval-workflow`,
        method: 'POST',
        body: apiRequest,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags PurchasingApprovalWorkflowSave
     * @name LocationsApprovalWorkflowSave
     * @request POST:/api/purchasing/locations/approval-workflow/save
     */
    locationsApprovalWorkflowSave: (
      apiRequest: MainStemAPIPlatformControllersPurchasingLocationsApprovalWorkflowSaveAPIRequest,
      params: RequestParams = {}
    ) =>
      this.request<MainStemAPIPlatformControllersPurchasingLocationsApprovalWorkflowListAPIResponse, any>({
        path: `/api/purchasing/locations/approval-workflow/save`,
        method: 'POST',
        body: apiRequest,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags PurchasingApprovalWorkflowValidate
     * @name LocationsApprovalWorkflowValidate
     * @request POST:/api/purchasing/locations/approval-workflow/validate
     */
    locationsApprovalWorkflowValidate: (
      apiRequest: MainStemAPIPlatformControllersPurchasingLocationsApprovalWorkflowValidateAPIRequest,
      params: RequestParams = {}
    ) =>
      this.request<MainStemAPIPlatformControllersPurchasingLocationsApprovalWorkflowListAPIResponse, any>({
        path: `/api/purchasing/locations/approval-workflow/validate`,
        method: 'POST',
        body: apiRequest,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags PurchasingAuthCurrentUser
     * @name AuthCurrentUser
     * @request GET:/api/purchasing/auth/current-user
     */
    authCurrentUser: (params: RequestParams = {}) =>
      this.request<MainStemAPIPlatformControllersPurchasingAuthCurrentUserAPIResponse, any>({
        path: `/api/purchasing/auth/current-user`,
        method: 'GET',
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags PurchasingAuthLogin
     * @name AuthLogin
     * @request POST:/api/purchasing/auth/login
     */
    authLogin: (apiRequest: MainStemAPIPlatformHelpersAuthorizationRequest, params: RequestParams = {}) =>
      this.request<MainStemAPIPlatformHelpersAuthorizationResponse, any>({
        path: `/api/purchasing/auth/login`,
        method: 'POST',
        body: apiRequest,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags PurchasingAuthPasswordResetProcess
     * @name AuthPasswordResetProcess
     * @request POST:/api/purchasing/auth/password-reset/process
     */
    authPasswordResetProcess: (
      APIRequest: MainStemAPIPlatformControllersPurchasingAuthPassswordResetProcessAPIRequest,
      params: RequestParams = {}
    ) =>
      this.request<MainStemAPIPlatformControllersPurchasingAuthPassswordResetProcessAPIResponse, any>({
        path: `/api/purchasing/auth/password-reset/process`,
        method: 'POST',
        body: APIRequest,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags PurchasingAuthPasswordResetRequest
     * @name AuthPasswordResetRequest
     * @request POST:/api/purchasing/auth/password-reset/request
     */
    authPasswordResetRequest: (
      APIRequest: MainStemAPIPlatformControllersPurchasingAuthPassswordResetRequestAPIRequest,
      params: RequestParams = {}
    ) =>
      this.request<MainStemSDKModelsBaseResponse, any>({
        path: `/api/purchasing/auth/password-reset/request`,
        method: 'POST',
        body: APIRequest,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags PurchasingAuthPasswordResetValidate
     * @name AuthPasswordResetValidate
     * @request POST:/api/purchasing/auth/password-reset/validate
     */
    authPasswordResetValidate: (
      APIRequest: MainStemAPIPlatformControllersPurchasingAuthPassswordResetValidateAPIRequest,
      params: RequestParams = {}
    ) =>
      this.request<MainStemAPIPlatformControllersPurchasingAuthPassswordResetValidateAPIResponse, any>({
        path: `/api/purchasing/auth/password-reset/validate`,
        method: 'POST',
        body: APIRequest,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags PurchasingBulkOrderApprovalUserCreate
     * @name BulkOrderApprovalUserCreate
     * @request POST:/api/purchasing/bulk-order/approval/user/create
     */
    bulkOrderApprovalUserCreate: (
      apiRequest: MainStemAPIPlatformControllersPurchasingBulkOrderApprovalUserCreateAPIRequest,
      params: RequestParams = {}
    ) =>
      this.request<MainStemAPIPlatformControllersPurchasingBulkOrderApprovalUserCreateAPIResponse, any>({
        path: `/api/purchasing/bulk-order/approval/user/create`,
        method: 'POST',
        body: apiRequest,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags PurchasingBulkOrderApprovalUserDelete
     * @name BulkOrderApprovalUserDelete
     * @request POST:/api/purchasing/bulk-order/approval/user/delete
     */
    bulkOrderApprovalUserDelete: (
      apiRequest: MainStemAPIPlatformControllersPurchasingBulkOrderApprovalUserDeleteAPIRequest,
      params: RequestParams = {}
    ) =>
      this.request<MainStemAPIPlatformControllersPurchasingBulkOrderApprovalUserDeleteAPIResponse, any>({
        path: `/api/purchasing/bulk-order/approval/user/delete`,
        method: 'POST',
        body: apiRequest,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags PurchasingBulkOrderApprovalUserList
     * @name BulkOrderApprovalUserList
     * @request POST:/api/purchasing/bulk-order/approval/user/list
     */
    bulkOrderApprovalUserList: (params: RequestParams = {}) =>
      this.request<MainStemAPIPlatformControllersPurchasingBulkOrderApprovalUserListAPIResponse, any>({
        path: `/api/purchasing/bulk-order/approval/user/list`,
        method: 'POST',
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags PurchasingBulkOrderCreate
     * @name BulkOrderCreate
     * @request POST:/api/purchasing/bulk-order/create
     */
    bulkOrderCreate: (
      apiRequest: MainStemAPIPlatformControllersPurchasingBulkOrderCreateAPIRequest,
      params: RequestParams = {}
    ) =>
      this.request<MainStemAPIPlatformControllersPurchasingBulkOrderCreateAPIResponse, any>({
        path: `/api/purchasing/bulk-order/create`,
        method: 'POST',
        body: apiRequest,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags PurchasingBulkOrderDetails
     * @name BulkOrderDetails
     * @request POST:/api/purchasing/bulk-order/details
     */
    bulkOrderDetails: (
      apiRequest: MainStemAPIPlatformControllersPurchasingBulkOrderDetailsAPIRequest,
      params: RequestParams = {}
    ) =>
      this.request<MainStemAPIPlatformControllersPurchasingBulkOrderDetailsAPIResponse, any>({
        path: `/api/purchasing/bulk-order/details`,
        method: 'POST',
        body: apiRequest,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags PurchasingBulkOrderDetails3WayMatch
     * @name BulkOrderDetailsThreeWayMatch
     * @request POST:/api/purchasing/bulk-order/details/three-way-match
     */
    bulkOrderDetailsThreeWayMatch: (
      apiRequest: MainStemAPIPlatformControllersPurchasingBulkOrderDetails3WayMatchAPIRequest,
      params: RequestParams = {}
    ) =>
      this.request<MainStemAPIPlatformControllersPurchasingBulkOrderDetails3WayMatchAPIResponse, any>({
        path: `/api/purchasing/bulk-order/details/three-way-match`,
        method: 'POST',
        body: apiRequest,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags PurchasingBulkOrderList
     * @name BulkOrderList
     * @request POST:/api/purchasing/bulk-order/list
     */
    bulkOrderList: (params: RequestParams = {}) =>
      this.request<MainStemAPIPlatformControllersPurchasingBulkOrderListAPIResponse, any>({
        path: `/api/purchasing/bulk-order/list`,
        method: 'POST',
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags PurchasingBulkOrderRelease
     * @name BulkOrderRelease
     * @request POST:/api/purchasing/bulk-order/release
     */
    bulkOrderRelease: (
      apiRequest: MainStemAPIPlatformControllersPurchasingBulkOrderReleaseAPIRequest,
      params: RequestParams = {}
    ) =>
      this.request<MainStemAPIPlatformControllersPurchasingBulkOrderReleaseAPIResponse, any>({
        path: `/api/purchasing/bulk-order/release`,
        method: 'POST',
        body: apiRequest,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags PurchasingBulkOrderRequisitionClear
     * @name BulkOrderRequisitionClear
     * @request POST:/api/purchasing/bulk-order/requisition/clear
     */
    bulkOrderRequisitionClear: (
      apiRequest: MainStemAPIPlatformControllersPurchasingBulkOrderRequisitionClearAPIRequest,
      params: RequestParams = {}
    ) =>
      this.request<MainStemAPIPlatformControllersPurchasingBulkOrderRequisitionClearAPIResponse, any>({
        path: `/api/purchasing/bulk-order/requisition/clear`,
        method: 'POST',
        body: apiRequest,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags PurchasingBulkOrderRequisitionCreate
     * @name BulkOrderRequisitionCreate
     * @request POST:/api/purchasing/bulk-order/requisition/create
     */
    bulkOrderRequisitionCreate: (
      apiRequest: MainStemAPIPlatformControllersPurchasingBulkOrderRequisitionCreateAPIRequest,
      params: RequestParams = {}
    ) =>
      this.request<MainStemAPIPlatformControllersPurchasingBulkOrderRequisitionCreateAPIResponse, any>({
        path: `/api/purchasing/bulk-order/requisition/create`,
        method: 'POST',
        body: apiRequest,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags PurchasingBulkOrderRequisitionDelete
     * @name BulkOrderRequisitionDelete
     * @request POST:/api/purchasing/bulk-order/requisition/delete
     */
    bulkOrderRequisitionDelete: (
      apiRequest: MainStemAPIPlatformControllersPurchasingBulkOrderRequisitionDeleteAPIRequest,
      params: RequestParams = {}
    ) =>
      this.request<MainStemAPIPlatformControllersPurchasingBulkOrderRequisitionDeleteAPIResponse, any>({
        path: `/api/purchasing/bulk-order/requisition/delete`,
        method: 'POST',
        body: apiRequest,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags PurchasingBulkOrderRequisitionPurchaseOrderCreate
     * @name BulkOrderRequisitionPurchaseOrderCreate
     * @request POST:/api/purchasing/bulk-order/requisition/purchase-order/create
     */
    bulkOrderRequisitionPurchaseOrderCreate: (
      apiRequest: MainStemAPIPlatformControllersPurchasingBulkOrderRequisitionPurchaseOrderCreateAPIRequest,
      params: RequestParams = {}
    ) =>
      this.request<MainStemAPIPlatformControllersPurchasingBulkOrderRequisitionPurchaseOrderCreateAPIResponse, any>({
        path: `/api/purchasing/bulk-order/requisition/purchase-order/create`,
        method: 'POST',
        body: apiRequest,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags PurchasingBulkOrderRequisitionPurchaseOrderDelete
     * @name BulkOrderRequisitionPurchaseOrderDelete
     * @request POST:/api/purchasing/bulk-order/requisition/purchase-order/delete
     */
    bulkOrderRequisitionPurchaseOrderDelete: (
      apiRequest: MainStemAPIPlatformControllersPurchasingBulkOrderRequisitionPurchaseOrderDeleteAPIRequest,
      params: RequestParams = {}
    ) =>
      this.request<MainStemAPIPlatformControllersPurchasingBulkOrderRequisitionPurchaseOrderDeleteAPIResponse, any>({
        path: `/api/purchasing/bulk-order/requisition/purchase-order/delete`,
        method: 'POST',
        body: apiRequest,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags PurchasingBulkOrderRequisitionPurchaseOrderLineItemCreate
     * @name BulkOrderRequisitionPurchaseOrderLineItemCreate
     * @request POST:/api/purchasing/bulk-order/requisition/purchase-order/line-item/create
     */
    bulkOrderRequisitionPurchaseOrderLineItemCreate: (
      apiRequest: MainStemAPIPlatformControllersPurchasingBulkOrderRequisitionPurchaseOrderLineItemCreateAPIRequest,
      params: RequestParams = {}
    ) =>
      this.request<
        MainStemAPIPlatformControllersPurchasingBulkOrderRequisitionPurchaseOrderLineItemCreateAPIResponse,
        any
      >({
        path: `/api/purchasing/bulk-order/requisition/purchase-order/line-item/create`,
        method: 'POST',
        body: apiRequest,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags PurchasingBulkOrderRequisitionPurchaseOrderLineItemDelete
     * @name BulkOrderRequisitionPurchaseOrderLineItemDelete
     * @request POST:/api/purchasing/bulk-order/requisition/purchase-order/line-item/delete
     */
    bulkOrderRequisitionPurchaseOrderLineItemDelete: (
      apiRequest: MainStemAPIPlatformControllersPurchasingBulkOrderRequisitionPurchaseOrderLineItemDeleteAPIRequest,
      params: RequestParams = {}
    ) =>
      this.request<
        MainStemAPIPlatformControllersPurchasingBulkOrderRequisitionPurchaseOrderLineItemDeleteAPIResponse,
        any
      >({
        path: `/api/purchasing/bulk-order/requisition/purchase-order/line-item/delete`,
        method: 'POST',
        body: apiRequest,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags PurchasingBulkOrderRequisitionPurchaseOrderLineItemUpdate
     * @name BulkOrderRequisitionPurchaseOrderLineItemUpdate
     * @request POST:/api/purchasing/bulk-order/requisition/purchase-order/line-item/update
     */
    bulkOrderRequisitionPurchaseOrderLineItemUpdate: (
      apiRequest: MainStemAPIPlatformControllersPurchasingBulkOrderRequisitionPurchaseOrderLineItemUpdateAPIRequest,
      params: RequestParams = {}
    ) =>
      this.request<
        MainStemAPIPlatformControllersPurchasingBulkOrderRequisitionPurchaseOrderLineItemUpdateAPIResponse,
        any
      >({
        path: `/api/purchasing/bulk-order/requisition/purchase-order/line-item/update`,
        method: 'POST',
        body: apiRequest,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags PurchasingBulkOrderRequisitionPurchaseOrderUpdate
     * @name BulkOrderRequisitionPurchaseOrderUpdate
     * @request POST:/api/purchasing/bulk-order/requisition/purchase-order/update
     */
    bulkOrderRequisitionPurchaseOrderUpdate: (
      apiRequest: MainStemAPIPlatformControllersPurchasingBulkOrderRequisitionPurchaseOrderUpdateAPIRequest,
      params: RequestParams = {}
    ) =>
      this.request<MainStemAPIPlatformControllersPurchasingBulkOrderRequisitionPurchaseOrderUpdateAPIResponse, any>({
        path: `/api/purchasing/bulk-order/requisition/purchase-order/update`,
        method: 'POST',
        body: apiRequest,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags PurchasingBulkOrderRequisitionUpdate
     * @name BulkOrderRequisitionUpdate
     * @request POST:/api/purchasing/bulk-order/requisition/update
     */
    bulkOrderRequisitionUpdate: (
      apiRequest: MainStemAPIPlatformControllersPurchasingBulkOrderRequisitionUpdateAPIRequest,
      params: RequestParams = {}
    ) =>
      this.request<MainStemAPIPlatformControllersPurchasingBulkOrderRequisitionUpdateAPIResponse, any>({
        path: `/api/purchasing/bulk-order/requisition/update`,
        method: 'POST',
        body: apiRequest,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags PurchasingBulkOrderUpload
     * @name BulkOrderUpload
     * @request POST:/api/purchasing/bulk-order/upload
     */
    bulkOrderUpload: (
      query: {
        /** @format int32 */
        bulkOrderId: number
      },
      params: RequestParams = {}
    ) =>
      this.request<MainStemAPIPlatformControllersPurchasingBulkOrderCreateAPIRequest, any>({
        path: `/api/purchasing/bulk-order/upload`,
        method: 'POST',
        query: query,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags PurchasingCannabis3WayMatchList
     * @name CannabisThreeWayMatchList
     * @request POST:/api/purchasing/cannabis/three-way-match/list
     */
    cannabisThreeWayMatchList: (
      apiRequest: MainStemAPIPlatformControllersPurchasingCannabisAPIRequest,
      params: RequestParams = {}
    ) =>
      this.request<MainStemAPIPlatformControllersPurchasingCannabis3WayMatchListAPIResponse, any>({
        path: `/api/purchasing/cannabis/three-way-match/list`,
        method: 'POST',
        body: apiRequest,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags PurchasingCannabisApprovalsList
     * @name CannabisApprovalsList
     * @request POST:/api/purchasing/cannabis/approvals/list
     */
    cannabisApprovalsList: (
      apiRequest: MainStemAPIPlatformControllersPurchasingCannabisAPIRequest,
      params: RequestParams = {}
    ) =>
      this.request<MainStemAPIPlatformControllersPurchasingCannabisApprovalsListAPIResponse, any>({
        path: `/api/purchasing/cannabis/approvals/list`,
        method: 'POST',
        body: apiRequest,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags PurchasingCannabisInvoicesList
     * @name CannabisInvoicesList
     * @request POST:/api/purchasing/cannabis/invoices/list
     */
    cannabisInvoicesList: (
      apiRequest: MainStemAPIPlatformControllersPurchasingCannabisAPIRequest,
      params: RequestParams = {}
    ) =>
      this.request<MainStemAPIPlatformControllersPurchasingCannabisInvoicesListAPIResponse, any>({
        path: `/api/purchasing/cannabis/invoices/list`,
        method: 'POST',
        body: apiRequest,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags PurchasingCannabisPurchaseOrdersList
     * @name CannabisPurchaseOrdersList
     * @request POST:/api/purchasing/cannabis/purchase-orders/list
     */
    cannabisPurchaseOrdersList: (
      apiRequest: MainStemAPIPlatformControllersPurchasingCannabisAPIRequest,
      params: RequestParams = {}
    ) =>
      this.request<MainStemAPIPlatformControllersPurchasingCannabisPurchaseOrdersListAPIResponse, any>({
        path: `/api/purchasing/cannabis/purchase-orders/list`,
        method: 'POST',
        body: apiRequest,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags PurchasingCatalogCreate
     * @name ProductListsCreate
     * @request POST:/api/purchasing/productLists/create
     */
    productListsCreate: (
      apiRequest: MainStemAPIPlatformControllersPurchasingCatalogCreateAPIRequest,
      params: RequestParams = {}
    ) =>
      this.request<MainStemAPIPlatformControllersPurchasingCatalogCreateAPIResponse, any>({
        path: `/api/purchasing/productLists/create`,
        method: 'POST',
        body: apiRequest,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags PurchasingCatalogCreate
     * @name CatalogCreate
     * @request POST:/api/purchasing/catalog/create
     */
    catalogCreate: (
      apiRequest: MainStemAPIPlatformControllersPurchasingCatalogCreateAPIRequest,
      params: RequestParams = {}
    ) =>
      this.request<MainStemAPIPlatformControllersPurchasingCatalogCreateAPIResponse, any>({
        path: `/api/purchasing/catalog/create`,
        method: 'POST',
        body: apiRequest,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags PurchasingCatalogDelete
     * @name CatalogDelete
     * @request POST:/api/purchasing/catalog/delete
     */
    catalogDelete: (
      apiRequest: MainStemAPIPlatformControllersPurchasingCatalogDeleteAPIRequest,
      params: RequestParams = {}
    ) =>
      this.request<MainStemAPIPlatformControllersPurchasingCatalogDeleteAPIResponse, any>({
        path: `/api/purchasing/catalog/delete`,
        method: 'POST',
        body: apiRequest,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags PurchasingCatalogDetails
     * @name CatalogDetails
     * @request POST:/api/purchasing/catalog/details
     */
    catalogDetails: (
      apiRequest: MainStemAPIPlatformControllersPurchasingCatalogDetailsAPIRequest,
      params: RequestParams = {}
    ) =>
      this.request<MainStemAPIPlatformControllersPurchasingCatalogDetailsAPIResponse, any>({
        path: `/api/purchasing/catalog/details`,
        method: 'POST',
        body: apiRequest,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags PurchasingCatalogDuplicate
     * @name CatalogDuplicate
     * @request POST:/api/purchasing/catalog/duplicate
     */
    catalogDuplicate: (
      apiRequest: MainStemAPIPlatformControllersPurchasingCatalogDuplicateAPIRequest,
      params: RequestParams = {}
    ) =>
      this.request<MainStemAPIPlatformControllersPurchasingCatalogDuplicateAPIResponse, any>({
        path: `/api/purchasing/catalog/duplicate`,
        method: 'POST',
        body: apiRequest,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags PurchasingCatalogList
     * @name CatalogList
     * @request GET:/api/purchasing/catalog/list
     */
    catalogList: (
      query?: {
        includeArchived?: boolean
      },
      params: RequestParams = {}
    ) =>
      this.request<MainStemAPIPlatformControllersPurchasingCatalogListAPIResponse, any>({
        path: `/api/purchasing/catalog/list`,
        method: 'GET',
        query: query,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags PurchasingCatalogList
     * @name ProductListsList
     * @request GET:/api/purchasing/productLists/list
     */
    productListsList: (
      query?: {
        includeArchived?: boolean
      },
      params: RequestParams = {}
    ) =>
      this.request<MainStemAPIPlatformControllersPurchasingCatalogListAPIResponse, any>({
        path: `/api/purchasing/productLists/list`,
        method: 'GET',
        query: query,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags PurchasingCatalogLocationsAdd
     * @name CatalogLocationsAdd
     * @request POST:/api/purchasing/catalog/locations/add
     */
    catalogLocationsAdd: (
      apiRequest: MainStemAPIPlatformControllersPurchasingCatalogLocationsAddAPIRequest,
      params: RequestParams = {}
    ) =>
      this.request<MainStemAPIPlatformControllersPurchasingCatalogLocationsAddAPIResponse, any>({
        path: `/api/purchasing/catalog/locations/add`,
        method: 'POST',
        body: apiRequest,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags PurchasingCatalogLocationsAdd
     * @name ProductListsDetailsLocationsAdd
     * @request POST:/api/purchasing/productLists/details/locations/add
     */
    productListsDetailsLocationsAdd: (
      apiRequest: MainStemAPIPlatformControllersPurchasingCatalogLocationsAddAPIRequest,
      params: RequestParams = {}
    ) =>
      this.request<MainStemAPIPlatformControllersPurchasingCatalogLocationsAddAPIResponse, any>({
        path: `/api/purchasing/productLists/details/locations/add`,
        method: 'POST',
        body: apiRequest,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags PurchasingCatalogLocationsList
     * @name CatalogLocationsList
     * @request POST:/api/purchasing/catalog/locations/list
     */
    catalogLocationsList: (
      apiRequest: MainStemAPIPlatformControllersPurchasingCatalogLocationsListAPIRequest,
      params: RequestParams = {}
    ) =>
      this.request<MainStemAPIPlatformControllersPurchasingCatalogLocationsListAPIResponse, any>({
        path: `/api/purchasing/catalog/locations/list`,
        method: 'POST',
        body: apiRequest,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags PurchasingCatalogLocationsRemove
     * @name CatalogLocationsRemove
     * @request POST:/api/purchasing/catalog/locations/remove
     */
    catalogLocationsRemove: (
      apiRequest: MainStemAPIPlatformControllersPurchasingCatalogLocationsRemoveAPIRequest,
      params: RequestParams = {}
    ) =>
      this.request<MainStemAPIPlatformControllersPurchasingCatalogLocationsRemoveAPIResponse, any>({
        path: `/api/purchasing/catalog/locations/remove`,
        method: 'POST',
        body: apiRequest,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags PurchasingCatalogLocationsRemove
     * @name ProductListsDetailsLocationsRemove
     * @request POST:/api/purchasing/productLists/details/locations/remove
     */
    productListsDetailsLocationsRemove: (
      apiRequest: MainStemAPIPlatformControllersPurchasingCatalogLocationsRemoveAPIRequest,
      params: RequestParams = {}
    ) =>
      this.request<MainStemAPIPlatformControllersPurchasingCatalogLocationsRemoveAPIResponse, any>({
        path: `/api/purchasing/productLists/details/locations/remove`,
        method: 'POST',
        body: apiRequest,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags PurchasingCatalogProductsAdd
     * @name CatalogProductsAdd
     * @request POST:/api/purchasing/catalog/products/add
     */
    catalogProductsAdd: (
      apiRequest: MainStemAPIPlatformControllersPurchasingCatalogProductsAddAPIRequest,
      params: RequestParams = {}
    ) =>
      this.request<MainStemAPIPlatformControllersPurchasingCatalogProductsAddAPIResponse, any>({
        path: `/api/purchasing/catalog/products/add`,
        method: 'POST',
        body: apiRequest,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags PurchasingCatalogProductsAdd
     * @name ProductListsDetailsProductsAdd
     * @request POST:/api/purchasing/productLists/details/products/add
     */
    productListsDetailsProductsAdd: (
      apiRequest: MainStemAPIPlatformControllersPurchasingCatalogProductsAddAPIRequest,
      params: RequestParams = {}
    ) =>
      this.request<MainStemAPIPlatformControllersPurchasingCatalogProductsAddAPIResponse, any>({
        path: `/api/purchasing/productLists/details/products/add`,
        method: 'POST',
        body: apiRequest,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags PurchasingCatalogProductsList
     * @name CatalogProductsList
     * @request POST:/api/purchasing/catalog/products/list
     */
    catalogProductsList: (
      apiRequest: MainStemAPIPlatformControllersPurchasingCatalogProductsListAPIRequest,
      params: RequestParams = {}
    ) =>
      this.request<MainStemAPIPlatformControllersPurchasingCatalogProductsListAPIResponse, any>({
        path: `/api/purchasing/catalog/products/list`,
        method: 'POST',
        body: apiRequest,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags PurchasingCatalogProductsRemove
     * @name CatalogProductsRemove
     * @request POST:/api/purchasing/catalog/products/remove
     */
    catalogProductsRemove: (
      apiRequest: MainStemAPIPlatformControllersPurchasingCatalogProductsRemoveAPIRequest,
      params: RequestParams = {}
    ) =>
      this.request<MainStemAPIPlatformControllersPurchasingCatalogProductsRemoveAPIResponse, any>({
        path: `/api/purchasing/catalog/products/remove`,
        method: 'POST',
        body: apiRequest,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags PurchasingCatalogProductsRemove
     * @name ProductListsDetailsProductsRemove
     * @request POST:/api/purchasing/productLists/details/products/remove
     */
    productListsDetailsProductsRemove: (
      apiRequest: MainStemAPIPlatformControllersPurchasingCatalogProductsRemoveAPIRequest,
      params: RequestParams = {}
    ) =>
      this.request<MainStemAPIPlatformControllersPurchasingCatalogProductsRemoveAPIResponse, any>({
        path: `/api/purchasing/productLists/details/products/remove`,
        method: 'POST',
        body: apiRequest,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags PurchasingCatalogSuppliersList
     * @name CatalogSuppliersList
     * @request POST:/api/purchasing/catalog/suppliers/list
     */
    catalogSuppliersList: (
      apiRequest: MainStemAPIPlatformControllersPurchasingCatalogSuppliersListAPIRequest,
      params: RequestParams = {}
    ) =>
      this.request<MainStemAPIPlatformControllersPurchasingCatalogSuppliersListAPIResponse, any>({
        path: `/api/purchasing/catalog/suppliers/list`,
        method: 'POST',
        body: apiRequest,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags PurchasingCatalogUpdate
     * @name CatalogUpdate
     * @request POST:/api/purchasing/catalog/update
     */
    catalogUpdate: (
      apiRequest: MainStemAPIPlatformControllersPurchasingCatalogUpdateAPIRequest,
      params: RequestParams = {}
    ) =>
      this.request<MainStemAPIPlatformControllersPurchasingCatalogUpdateAPIResponse, any>({
        path: `/api/purchasing/catalog/update`,
        method: 'POST',
        body: apiRequest,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags PurchasingCatalogUsersAdd
     * @name CatalogUsersAdd
     * @request POST:/api/purchasing/catalog/users/add
     */
    catalogUsersAdd: (
      apiRequest: MainStemAPIPlatformControllersPurchasingCatalogUsersAddAPIRequest,
      params: RequestParams = {}
    ) =>
      this.request<MainStemAPIPlatformControllersPurchasingCatalogUsersAddAPIResponse, any>({
        path: `/api/purchasing/catalog/users/add`,
        method: 'POST',
        body: apiRequest,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags PurchasingCatalogUsersList
     * @name CatalogUsersList
     * @request POST:/api/purchasing/catalog/users/list
     */
    catalogUsersList: (
      apiRequest: MainStemAPIPlatformControllersPurchasingCatalogUsersListAPIRequest,
      params: RequestParams = {}
    ) =>
      this.request<MainStemAPIPlatformControllersPurchasingCatalogUsersListAPIResponse, any>({
        path: `/api/purchasing/catalog/users/list`,
        method: 'POST',
        body: apiRequest,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags PurchasingCatalogUsersRemove
     * @name CatalogUsersRemove
     * @request POST:/api/purchasing/catalog/users/remove
     */
    catalogUsersRemove: (
      apiRequest: MainStemAPIPlatformControllersPurchasingCatalogUsersRemoveAPIRequest,
      params: RequestParams = {}
    ) =>
      this.request<MainStemAPIPlatformControllersPurchasingCatalogUsersRemoveAPIResponse, any>({
        path: `/api/purchasing/catalog/users/remove`,
        method: 'POST',
        body: apiRequest,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags PurchasingChangeLogList
     * @name ChangeLogList
     * @request POST:/api/purchasing/change-log/list
     */
    changeLogList: (
      APIRequest: MainStemAPIPlatformControllersPurchasingChangeLogListAPIRequest,
      params: RequestParams = {}
    ) =>
      this.request<MainStemAPIPlatformControllersPurchasingChangeLogListAPIResponse, any>({
        path: `/api/purchasing/change-log/list`,
        method: 'POST',
        body: APIRequest,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags PurchasingContactSendMessage
     * @name ContactSendMessage
     * @request POST:/api/purchasing/contact/send-message
     */
    contactSendMessage: (
      apiRequest: MainStemAPIPlatformControllersPurchasingContactSendMessageAPIRequest,
      params: RequestParams = {}
    ) =>
      this.request<MainStemSDKModelsBaseResponse, any>({
        path: `/api/purchasing/contact/send-message`,
        method: 'POST',
        body: apiRequest,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags PurchasingCustomFieldCreate
     * @name CustomFieldCreate
     * @request POST:/api/purchasing/custom-field/create
     */
    customFieldCreate: (
      apiRequest: MainStemAPIPlatformControllersPurchasingCustomFieldCreateAPIRequest,
      params: RequestParams = {}
    ) =>
      this.request<MainStemAPIPlatformControllersPurchasingCustomFieldCreateAPIResponse, any>({
        path: `/api/purchasing/custom-field/create`,
        method: 'POST',
        body: apiRequest,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags PurchasingCustomFieldDelete
     * @name CustomFieldDelete
     * @request POST:/api/purchasing/custom-field/delete
     */
    customFieldDelete: (
      apiRequest: MainStemAPIPlatformControllersPurchasingCustomFieldDeleteAPIRequest,
      params: RequestParams = {}
    ) =>
      this.request<MainStemAPIPlatformControllersPurchasingCustomFieldDeleteAPIResponse, any>({
        path: `/api/purchasing/custom-field/delete`,
        method: 'POST',
        body: apiRequest,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags PurchasingCustomFieldList
     * @name CustomFieldList
     * @request POST:/api/purchasing/custom-field/list
     */
    customFieldList: (params: RequestParams = {}) =>
      this.request<MainStemAPIPlatformControllersPurchasingCustomFieldListAPIResponse, any>({
        path: `/api/purchasing/custom-field/list`,
        method: 'POST',
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags PurchasingCustomFieldUpdate
     * @name CustomFieldUpdate
     * @request POST:/api/purchasing/custom-field/update
     */
    customFieldUpdate: (
      apiRequest: MainStemAPIPlatformControllersPurchasingCustomFieldUpdateAPIRequest,
      params: RequestParams = {}
    ) =>
      this.request<MainStemAPIPlatformControllersPurchasingCustomFieldUpdateAPIResponse, any>({
        path: `/api/purchasing/custom-field/update`,
        method: 'POST',
        body: apiRequest,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags PurchasingCustomFieldValueAdd
     * @name CustomFieldValueAdd
     * @request POST:/api/purchasing/custom-field/value/add
     */
    customFieldValueAdd: (
      apiRequest: MainStemAPIPlatformControllersPurchasingCustomFieldValueAddAPIRequest,
      params: RequestParams = {}
    ) =>
      this.request<MainStemAPIPlatformControllersPurchasingCustomFieldValueAddAPIResponse, any>({
        path: `/api/purchasing/custom-field/value/add`,
        method: 'POST',
        body: apiRequest,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags PurchasingCustomFieldValueList
     * @name CustomFieldValueList
     * @request POST:/api/purchasing/custom-field/value/list
     */
    customFieldValueList: (
      apiRequest: MainStemAPIPlatformControllersPurchasingCustomFieldValueListAPIRequest,
      params: RequestParams = {}
    ) =>
      this.request<MainStemAPIPlatformControllersPurchasingCustomFieldValueListAPIResponse, any>({
        path: `/api/purchasing/custom-field/value/list`,
        method: 'POST',
        body: apiRequest,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags PurchasingCustomFieldValueUpdate
     * @name CustomFieldValueUpdate
     * @request POST:/api/purchasing/custom-field/value/update
     */
    customFieldValueUpdate: (
      apiRequest: MainStemAPIPlatformControllersPurchasingCustomFieldValueUpdateAPIRequest,
      params: RequestParams = {}
    ) =>
      this.request<MainStemAPIPlatformControllersPurchasingCustomFieldValueUpdateAPIResponse, any>({
        path: `/api/purchasing/custom-field/value/update`,
        method: 'POST',
        body: apiRequest,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags PurchasingDashboardApprovalApprovalsByLocationData
     * @name DashboardApprovalApprovalsByLocationData
     * @request GET:/api/purchasing/dashboard/approval/approvalsByLocation/data
     */
    dashboardApprovalApprovalsByLocationData: (
      query?: {
        /** @format date-time */
        apiRequestDate?: string
      },
      params: RequestParams = {}
    ) =>
      this.request<MainStemAPIPlatformControllersPurchasingDashboardApprovalApprovalsByLocationDataAPIResponse, any>({
        path: `/api/purchasing/dashboard/approval/approvalsByLocation/data`,
        method: 'GET',
        query: query,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags PurchasingDashboardApprovalApprovalsByLocationOptions
     * @name DashboardApprovalApprovalsByLocationOptions
     * @request GET:/api/purchasing/dashboard/approval/approvalsByLocation/options
     */
    dashboardApprovalApprovalsByLocationOptions: (params: RequestParams = {}) =>
      this.request<MainStemAPIPlatformControllersPurchasingDashboardApprovalApprovalsByLocationOptionsAPIResponse, any>(
        {
          path: `/api/purchasing/dashboard/approval/approvalsByLocation/options`,
          method: 'GET',
          format: 'json',
          ...params
        }
      ),

    /**
     * No description
     *
     * @tags PurchasingDashboardApprovalOrdersMyApproval
     * @name DashboardApprovalOrdersNeedingMyApproval
     * @request POST:/api/purchasing/dashboard/approval/orders-needing-my-approval
     */
    dashboardApprovalOrdersNeedingMyApproval: (params: RequestParams = {}) =>
      this.request<MainStemAPIPlatformControllersPurchasingDashboardApprovalOrdersMyApprovalAPIResponse, any>({
        path: `/api/purchasing/dashboard/approval/orders-needing-my-approval`,
        method: 'POST',
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags PurchasingDashboardApprovalOrdersOthersApproval
     * @name DashboardApprovalOrdersNeedingOthersApproval
     * @request GET:/api/purchasing/dashboard/approval/orders-needing-others-approval
     */
    dashboardApprovalOrdersNeedingOthersApproval: (params: RequestParams = {}) =>
      this.request<MainStemAPIPlatformControllersPurchasingDashboardApprovalOrdersOthersApprovalAPIResponse, any>({
        path: `/api/purchasing/dashboard/approval/orders-needing-others-approval`,
        method: 'GET',
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags PurchasingDashboardApprovalTotalApprovalsData
     * @name DashboardApprovalTotalApprovalsData
     * @request GET:/api/purchasing/dashboard/approval/totalApprovals/data
     */
    dashboardApprovalTotalApprovalsData: (
      query?: {
        /** @format date-time */
        apiRequestDate?: string
      },
      params: RequestParams = {}
    ) =>
      this.request<MainStemAPIPlatformControllersPurchasingDashboardApprovalTotalApprovalsDataAPIResponse, any>({
        path: `/api/purchasing/dashboard/approval/totalApprovals/data`,
        method: 'GET',
        query: query,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags PurchasingDashboardApprovalTotalApprovalsOptions
     * @name DashboardApprovalTotalApprovalsOptions
     * @request GET:/api/purchasing/dashboard/approval/totalApprovals/options
     */
    dashboardApprovalTotalApprovalsOptions: (params: RequestParams = {}) =>
      this.request<MainStemAPIPlatformControllersPurchasingDashboardApprovalTotalApprovalsOptionsAPIResponse, any>({
        path: `/api/purchasing/dashboard/approval/totalApprovals/options`,
        method: 'GET',
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags PurchasingDashboardBudgets
     * @name DashboardBudgets
     * @request POST:/api/purchasing/dashboard/budgets
     */
    dashboardBudgets: (
      apiRequest: MainStemAPIPlatformControllersPurchasingDashboardBudgetsAPIRequest,
      params: RequestParams = {}
    ) =>
      this.request<MainStemAPIPlatformControllersPurchasingDashboardBudgetsAPIResponse, any>({
        path: `/api/purchasing/dashboard/budgets`,
        method: 'POST',
        body: apiRequest,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags PurchasingDashboardFinanceApprovals
     * @name DashboardFinanceOrderApproval
     * @request GET:/api/purchasing/dashboard/finance/orderApproval
     */
    dashboardFinanceOrderApproval: (params: RequestParams = {}) =>
      this.request<MainStemAPIPlatformControllersPurchasingDashboardFinanceOrderApprovalsAPIResponse, any>({
        path: `/api/purchasing/dashboard/finance/orderApproval`,
        method: 'GET',
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags PurchasingDashboardFinanceOpenInvoices
     * @name DashboardFinanceOpenInvoices
     * @request GET:/api/purchasing/dashboard/finance/openInvoices
     */
    dashboardFinanceOpenInvoices: (params: RequestParams = {}) =>
      this.request<MainStemAPIPlatformControllersPurchasingDashboardFinanceOpenInvoicesAPIResponse, any>({
        path: `/api/purchasing/dashboard/finance/openInvoices`,
        method: 'GET',
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags PurchasingDashboardFinanceOpenOrders
     * @name DashboardFinanceOpenOrders
     * @request GET:/api/purchasing/dashboard/finance/openOrders
     */
    dashboardFinanceOpenOrders: (params: RequestParams = {}) =>
      this.request<MainStemAPIPlatformControllersPurchasingDashboardFinanceOpenOrdersAPIResponse, any>({
        path: `/api/purchasing/dashboard/finance/openOrders`,
        method: 'GET',
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags PurchasingDashboardFinancePayments
     * @name DashboardFinancePayments
     * @request GET:/api/purchasing/dashboard/finance/payments
     */
    dashboardFinancePayments: (params: RequestParams = {}) =>
      this.request<MainStemAPIPlatformControllersPurchasingDashboardFinancePaymentsAPIResponse, any>({
        path: `/api/purchasing/dashboard/finance/payments`,
        method: 'GET',
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags PurchasingDashboardFinanceSalesByLocationData
     * @name DashboardFinanceSalesByLocationData
     * @request GET:/api/purchasing/dashboard/finance/salesByLocation/data
     */
    dashboardFinanceSalesByLocationData: (
      query?: {
        /** @format date-time */
        apiRequestDate?: string
      },
      params: RequestParams = {}
    ) =>
      this.request<MainStemAPIPlatformControllersPurchasingDashboardFinanceSalesByLocationDataAPIResponse, any>({
        path: `/api/purchasing/dashboard/finance/salesByLocation/data`,
        method: 'GET',
        query: query,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags PurchasingDashboardFinanceSalesByLocationOptions
     * @name DashboardFinanceSalesByLocationOptions
     * @request GET:/api/purchasing/dashboard/finance/salesByLocation/options
     */
    dashboardFinanceSalesByLocationOptions: (params: RequestParams = {}) =>
      this.request<MainStemAPIPlatformControllersPurchasingDashboardFinanceSalesByLocationOptionsAPIResponse, any>({
        path: `/api/purchasing/dashboard/finance/salesByLocation/options`,
        method: 'GET',
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags PurchasingDashboardFinanceTermsLedger
     * @name DashboardFinanceTermsLedger
     * @request GET:/api/purchasing/dashboard/finance/termsLedger
     */
    dashboardFinanceTermsLedger: (params: RequestParams = {}) =>
      this.request<MainStemAPIPlatformControllersPurchasingDashboardFinanceTermsLedgerAPIResponse, any>({
        path: `/api/purchasing/dashboard/finance/termsLedger`,
        method: 'GET',
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags PurchasingDashboardFinanceTotalSalesData
     * @name DashboardFinanceTotalSalesData
     * @request GET:/api/purchasing/dashboard/finance/totalSales/data
     */
    dashboardFinanceTotalSalesData: (
      query?: {
        /** @format date-time */
        apiRequestDate?: string
      },
      params: RequestParams = {}
    ) =>
      this.request<MainStemAPIPlatformControllersPurchasingDashboardFinanceTotalSalesDataAPIResponse, any>({
        path: `/api/purchasing/dashboard/finance/totalSales/data`,
        method: 'GET',
        query: query,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags PurchasingDashboardFinanceTotalSalesOptions
     * @name DashboardFinanceTotalSalesOptions
     * @request GET:/api/purchasing/dashboard/finance/totalSales/options
     */
    dashboardFinanceTotalSalesOptions: (params: RequestParams = {}) =>
      this.request<MainStemAPIPlatformControllersPurchasingDashboardFinanceTotalSalesOptionsAPIResponse, any>({
        path: `/api/purchasing/dashboard/finance/totalSales/options`,
        method: 'GET',
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags PurchasingDashboardFinanceUsers
     * @name DashboardFinanceUsers
     * @request GET:/api/purchasing/dashboard/finance/users
     */
    dashboardFinanceUsers: (params: RequestParams = {}) =>
      this.request<MainStemAPIPlatformControllersPurchasingDashboardFinanceUsersAPIResponse, any>({
        path: `/api/purchasing/dashboard/finance/users`,
        method: 'GET',
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags PurchasingDashboardGetPurchasingMapDetail
     * @name DashboardPurchasingMapDetail
     * @request GET:/api/purchasing/dashboard/purchasing/mapDetail
     */
    dashboardPurchasingMapDetail: (
      query?: {
        /** @format int32 */
        apiRequestLocationId?: number
        /** @format date-time */
        apiRequestEndDate?: string
        /** @format date-time */
        apiRequestStartDate?: string
      },
      params: RequestParams = {}
    ) =>
      this.request<MainStemAPIPlatformControllersPurchasingDashboardPurchasingGetMapDetailDeprecateAPIResponse, any>({
        path: `/api/purchasing/dashboard/purchasing/mapDetail`,
        method: 'GET',
        query: query,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags PurchasingDashboardLocationInvoicesAwaitingShipment
     * @name LocationsDetailsInvoicesAwaitingShipment
     * @request POST:/api/purchasing/locations/details/invoicesAwaitingShipment
     */
    locationsDetailsInvoicesAwaitingShipment: (
      apiRequest: MainStemAPIPlatformControllersPurchasingLocationsDetailsInvoicesAwaitingShipmentAPIRequest,
      params: RequestParams = {}
    ) =>
      this.request<MainStemAPIPlatformControllersPurchasingLocationsDetailsInvoicesAwaitingShipmentAPIResponse, any>({
        path: `/api/purchasing/locations/details/invoicesAwaitingShipment`,
        method: 'POST',
        body: apiRequest,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags PurchasingDashboardLocationOrderApproval
     * @name LocationsDetailsOrderApproval
     * @request POST:/api/purchasing/locations/details/orderApproval
     */
    locationsDetailsOrderApproval: (
      apiRequest: MainStemAPIPlatformControllersPurchasingLocationsDetailsOrderApprovalsAPIRequest,
      params: RequestParams = {}
    ) =>
      this.request<MainStemAPIPlatformControllersPurchasingLocationsDetailsOrderApprovalsAPIResponse, any>({
        path: `/api/purchasing/locations/details/orderApproval`,
        method: 'POST',
        body: apiRequest,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags PurchasingDashboardOrdersAwaitingAcceptance
     * @name DashboardPurchasingPurchaseOrdersAwaitingAcceptance
     * @request POST:/api/purchasing/dashboard/purchasing/purchaseOrdersAwaitingAcceptance
     */
    dashboardPurchasingPurchaseOrdersAwaitingAcceptance: (
      apiRequest: MainStemAPIPlatformControllersPurchasingDashboardPurchasingPurchaseOrdersAwaitingAcceptanceAPIRequest,
      params: RequestParams = {}
    ) =>
      this.request<
        MainStemAPIPlatformControllersPurchasingDashboardPurchasingPurchaseOrdersAwaitingAcceptanceAPIResponse,
        any
      >({
        path: `/api/purchasing/dashboard/purchasing/purchaseOrdersAwaitingAcceptance`,
        method: 'POST',
        body: apiRequest,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags PurchasingDashboardOrdersAwaitingAcknowledgement
     * @name DashboardPurchasingPurchaseOrdersAwaitingAcknowledgement
     * @request POST:/api/purchasing/dashboard/purchasing/purchaseOrdersAwaitingAcknowledgement
     */
    dashboardPurchasingPurchaseOrdersAwaitingAcknowledgement: (
      apiRequest: MainStemAPIPlatformControllersPurchasingDashboardPurchasingPurchaseOrdersAwaitingAcknowledgementAPIRequest,
      params: RequestParams = {}
    ) =>
      this.request<
        MainStemAPIPlatformControllersPurchasingDashboardPurchasingPurchaseOrdersAwaitingAcknowledgementAPIResponse,
        any
      >({
        path: `/api/purchasing/dashboard/purchasing/purchaseOrdersAwaitingAcknowledgement`,
        method: 'POST',
        body: apiRequest,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags PurchasingDashboardPurchasingApprovals
     * @name DashboardPurchasingOrderApproval
     * @request GET:/api/purchasing/dashboard/purchasing/orderApproval
     */
    dashboardPurchasingOrderApproval: (params: RequestParams = {}) =>
      this.request<MainStemAPIPlatformControllersPurchasingDashboardPurchasingOrderApprovalsAPIResponse, any>({
        path: `/api/purchasing/dashboard/purchasing/orderApproval`,
        method: 'GET',
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags PurchasingDashboardPurchasingGetOrganizationSpend
     * @name DashboardPurchasingOrganizationSpend
     * @request GET:/api/purchasing/dashboard/purchasing/organizationSpend
     */
    dashboardPurchasingOrganizationSpend: (
      query?: {
        /** @format date-time */
        apiRequestEndDate?: string
        /** @format date-time */
        apiRequestStartDate?: string
      },
      params: RequestParams = {}
    ) =>
      this.request<
        MainStemAPIPlatformControllersPurchasingDashboardPurchasingGetOrganizationSpendDeprecateAPIResponse,
        any
      >({
        path: `/api/purchasing/dashboard/purchasing/organizationSpend`,
        method: 'GET',
        query: query,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags PurchasingDashboardPurchasingMap
     * @name DashboardPurchasingMapData
     * @request GET:/api/purchasing/dashboard/purchasing/mapData
     */
    dashboardPurchasingMapData: (params: RequestParams = {}) =>
      this.request<MainStemAPIPlatformControllersPurchasingDashboardPurchasingMapAPIResponse, any>({
        path: `/api/purchasing/dashboard/purchasing/mapData`,
        method: 'GET',
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags PurchasingDashboardPurchasingMapDetail
     * @name DashboardPurchasingMapDetailTimeSlice
     * @request POST:/api/purchasing/dashboard/purchasing/mapDetailTimeSlice
     */
    dashboardPurchasingMapDetailTimeSlice: (
      apiRequest: MainStemAPIPlatformControllersPurchasingDashboardPurchasingMapDetailAPIRequest,
      params: RequestParams = {}
    ) =>
      this.request<MainStemAPIPlatformControllersPurchasingDashboardPurchasingMapDetailAPIResponse, any>({
        path: `/api/purchasing/dashboard/purchasing/mapDetailTimeSlice`,
        method: 'POST',
        body: apiRequest,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags PurchasingDashboardPurchasingOrganizationSpend
     * @name DashboardPurchasingSpendTimeSlice
     * @request POST:/api/purchasing/dashboard/purchasing/spendTimeSlice
     */
    dashboardPurchasingSpendTimeSlice: (
      apiRequest: MainStemAPIPlatformControllersPurchasingDashboardPurchasingOrganizationSpendAPIRequest,
      params: RequestParams = {}
    ) =>
      this.request<MainStemAPIPlatformControllersPurchasingDashboardPurchasingOrganizationSpendAPIResponse, any>({
        path: `/api/purchasing/dashboard/purchasing/spendTimeSlice`,
        method: 'POST',
        body: apiRequest,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags PurchasingDashboardPurchasingUsers
     * @name DashboardPurchasingUsers
     * @request GET:/api/purchasing/dashboard/purchasing/users
     */
    dashboardPurchasingUsers: (params: RequestParams = {}) =>
      this.request<MainStemAPIPlatformControllersPurchasingDashboardPurchasingUsersAPIResponse, any>({
        path: `/api/purchasing/dashboard/purchasing/users`,
        method: 'GET',
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags PurchasingDepartmentCreate
     * @name DepartmentsCreate
     * @request POST:/api/purchasing/departments/create
     */
    departmentsCreate: (
      apiRequest: MainStemAPIPlatformControllersPurchasingDepartmentCreateAPIRequest,
      params: RequestParams = {}
    ) =>
      this.request<MainStemAPIPlatformControllersPurchasingDepartmentCreateAPIResponse, any>({
        path: `/api/purchasing/departments/create`,
        method: 'POST',
        body: apiRequest,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags PurchasingDepartmentDelete
     * @name DepartmentsDelete
     * @request POST:/api/purchasing/departments/delete
     */
    departmentsDelete: (
      apiRequest: MainStemAPIPlatformControllersPurchasingDepartmentDeleteAPIRequest,
      params: RequestParams = {}
    ) =>
      this.request<MainStemAPIPlatformControllersPurchasingDepartmentDeleteAPIResponse, any>({
        path: `/api/purchasing/departments/delete`,
        method: 'POST',
        body: apiRequest,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags PurchasingDepartmentDetails
     * @name DepartmentsDetails
     * @request POST:/api/purchasing/departments/details
     */
    departmentsDetails: (
      apiRequest: MainStemAPIPlatformControllersPurchasingDepartmentDetailsAPIRequest,
      params: RequestParams = {}
    ) =>
      this.request<MainStemAPIPlatformControllersPurchasingDepartmentDetailsAPIResponse, any>({
        path: `/api/purchasing/departments/details`,
        method: 'POST',
        body: apiRequest,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags PurchasingDepartmentDuplicate
     * @name DepartmentsDuplicate
     * @request POST:/api/purchasing/departments/duplicate
     */
    departmentsDuplicate: (
      apiRequest: MainStemAPIPlatformControllersPurchasingDepartmentDuplicateAPIRequest,
      params: RequestParams = {}
    ) =>
      this.request<MainStemAPIPlatformControllersPurchasingDepartmentDuplicateAPIResponse, any>({
        path: `/api/purchasing/departments/duplicate`,
        method: 'POST',
        body: apiRequest,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags PurchasingDepartmentList
     * @name DepartmentsList
     * @request POST:/api/purchasing/departments/list
     */
    departmentsList: (
      apiRequest: MainStemAPIPlatformControllersPurchasingDepartmentListAPIRequest,
      params: RequestParams = {}
    ) =>
      this.request<MainStemAPIPlatformControllersPurchasingDepartmentListAPIResponse, any>({
        path: `/api/purchasing/departments/list`,
        method: 'POST',
        body: apiRequest,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags PurchasingDepartmentUpdate
     * @name DepartmentsUpdate
     * @request POST:/api/purchasing/departments/update
     */
    departmentsUpdate: (
      apiRequest: MainStemAPIPlatformControllersPurchasingDepartmentUpdateAPIRequest,
      params: RequestParams = {}
    ) =>
      this.request<MainStemSDKModelsBaseResponse, any>({
        path: `/api/purchasing/departments/update`,
        method: 'POST',
        body: apiRequest,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags PurchasingDepartmentUserAdd
     * @name DepartmentsUserAdd
     * @request POST:/api/purchasing/departments/user/add
     */
    departmentsUserAdd: (
      apiRequest: MainStemAPIPlatformControllersPurchasingDepartmentUsersAddAPIRequest,
      params: RequestParams = {}
    ) =>
      this.request<MainStemSDKModelsBaseResponse, any>({
        path: `/api/purchasing/departments/user/add`,
        method: 'POST',
        body: apiRequest,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags PurchasingDepartmentUserRemove
     * @name DepartmentsUserRemove
     * @request POST:/api/purchasing/departments/user/remove
     */
    departmentsUserRemove: (
      apiRequest: MainStemAPIPlatformControllersPurchasingDepartmentUsersRemoveAPIRequest,
      params: RequestParams = {}
    ) =>
      this.request<MainStemSDKModelsBaseResponse, any>({
        path: `/api/purchasing/departments/user/remove`,
        method: 'POST',
        body: apiRequest,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags PurchasingEntityFilesList
     * @name DepartmentsFilesList
     * @request POST:/api/purchasing/departments/files/list
     */
    departmentsFilesList: (
      apiRequest: MainStemAPIPlatformControllersPurchasingEntityFilesListAPIRequest,
      params: RequestParams = {}
    ) =>
      this.request<MainStemAPIPlatformControllersPurchasingEntityFilesListAPIResponse, any>({
        path: `/api/purchasing/departments/files/list`,
        method: 'POST',
        body: apiRequest,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags PurchasingEntityFilesList
     * @name LocationsFilesList
     * @request POST:/api/purchasing/locations/files/list
     */
    locationsFilesList: (
      apiRequest: MainStemAPIPlatformControllersPurchasingEntityFilesListAPIRequest,
      params: RequestParams = {}
    ) =>
      this.request<MainStemAPIPlatformControllersPurchasingEntityFilesListAPIResponse, any>({
        path: `/api/purchasing/locations/files/list`,
        method: 'POST',
        body: apiRequest,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags PurchasingEntityFilesList
     * @name CatalogsFilesList
     * @request POST:/api/purchasing/catalogs/files/list
     */
    catalogsFilesList: (
      apiRequest: MainStemAPIPlatformControllersPurchasingEntityFilesListAPIRequest,
      params: RequestParams = {}
    ) =>
      this.request<MainStemAPIPlatformControllersPurchasingEntityFilesListAPIResponse, any>({
        path: `/api/purchasing/catalogs/files/list`,
        method: 'POST',
        body: apiRequest,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags PurchasingEntityFilesList
     * @name UsersFilesList
     * @request POST:/api/purchasing/users/files/list
     */
    usersFilesList: (
      apiRequest: MainStemAPIPlatformControllersPurchasingEntityFilesListAPIRequest,
      params: RequestParams = {}
    ) =>
      this.request<MainStemAPIPlatformControllersPurchasingEntityFilesListAPIResponse, any>({
        path: `/api/purchasing/users/files/list`,
        method: 'POST',
        body: apiRequest,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags PurchasingEntityFilesList
     * @name ProductsFilesList
     * @request POST:/api/purchasing/products/files/list
     */
    productsFilesList: (
      apiRequest: MainStemAPIPlatformControllersPurchasingEntityFilesListAPIRequest,
      params: RequestParams = {}
    ) =>
      this.request<MainStemAPIPlatformControllersPurchasingEntityFilesListAPIResponse, any>({
        path: `/api/purchasing/products/files/list`,
        method: 'POST',
        body: apiRequest,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags PurchasingEntityFilesList
     * @name SuppliersFilesList
     * @request POST:/api/purchasing/suppliers/files/list
     */
    suppliersFilesList: (
      apiRequest: MainStemAPIPlatformControllersPurchasingEntityFilesListAPIRequest,
      params: RequestParams = {}
    ) =>
      this.request<MainStemAPIPlatformControllersPurchasingEntityFilesListAPIResponse, any>({
        path: `/api/purchasing/suppliers/files/list`,
        method: 'POST',
        body: apiRequest,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags PurchasingEntityFilesList
     * @name RequisitionsFilesList
     * @request POST:/api/purchasing/requisitions/files/list
     */
    requisitionsFilesList: (
      apiRequest: MainStemAPIPlatformControllersPurchasingEntityFilesListAPIRequest,
      params: RequestParams = {}
    ) =>
      this.request<MainStemAPIPlatformControllersPurchasingEntityFilesListAPIResponse, any>({
        path: `/api/purchasing/requisitions/files/list`,
        method: 'POST',
        body: apiRequest,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags PurchasingEntityFilesList
     * @name PurchaseOrdersFilesList
     * @request POST:/api/purchasing/purchase-orders/files/list
     */
    purchaseOrdersFilesList: (
      apiRequest: MainStemAPIPlatformControllersPurchasingEntityFilesListAPIRequest,
      params: RequestParams = {}
    ) =>
      this.request<MainStemAPIPlatformControllersPurchasingEntityFilesListAPIResponse, any>({
        path: `/api/purchasing/purchase-orders/files/list`,
        method: 'POST',
        body: apiRequest,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags PurchasingEntityFilesList
     * @name InvoicesFilesList
     * @request POST:/api/purchasing/invoices/files/list
     */
    invoicesFilesList: (
      apiRequest: MainStemAPIPlatformControllersPurchasingEntityFilesListAPIRequest,
      params: RequestParams = {}
    ) =>
      this.request<MainStemAPIPlatformControllersPurchasingEntityFilesListAPIResponse, any>({
        path: `/api/purchasing/invoices/files/list`,
        method: 'POST',
        body: apiRequest,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags PurchasingEntityFilesUpload
     * @name DepartmentsFilesUpload
     * @request POST:/api/purchasing/departments/files/upload
     */
    departmentsFilesUpload: (
      query: {
        /** @format int32 */
        id: number
        uuid: string
      },
      params: RequestParams = {}
    ) =>
      this.request<MainStemAPIPlatformControllersPurchasingEntityFilesUploadAPIResponse, any>({
        path: `/api/purchasing/departments/files/upload`,
        method: 'POST',
        query: query,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags PurchasingEntityFilesUpload
     * @name LocationsFilesUpload
     * @request POST:/api/purchasing/locations/files/upload
     */
    locationsFilesUpload: (
      query: {
        /** @format int32 */
        id: number
        uuid: string
      },
      params: RequestParams = {}
    ) =>
      this.request<MainStemAPIPlatformControllersPurchasingEntityFilesUploadAPIResponse, any>({
        path: `/api/purchasing/locations/files/upload`,
        method: 'POST',
        query: query,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags PurchasingEntityFilesUpload
     * @name CatalogsFilesUpload
     * @request POST:/api/purchasing/catalogs/files/upload
     */
    catalogsFilesUpload: (
      query: {
        /** @format int32 */
        id: number
        uuid: string
      },
      params: RequestParams = {}
    ) =>
      this.request<MainStemAPIPlatformControllersPurchasingEntityFilesUploadAPIResponse, any>({
        path: `/api/purchasing/catalogs/files/upload`,
        method: 'POST',
        query: query,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags PurchasingEntityFilesUpload
     * @name UsersFilesUpload
     * @request POST:/api/purchasing/users/files/upload
     */
    usersFilesUpload: (
      query: {
        /** @format int32 */
        id: number
        uuid: string
      },
      params: RequestParams = {}
    ) =>
      this.request<MainStemAPIPlatformControllersPurchasingEntityFilesUploadAPIResponse, any>({
        path: `/api/purchasing/users/files/upload`,
        method: 'POST',
        query: query,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags PurchasingEntityFilesUpload
     * @name ProductsFilesUpload
     * @request POST:/api/purchasing/products/files/upload
     */
    productsFilesUpload: (
      query: {
        /** @format int32 */
        id: number
        uuid: string
      },
      params: RequestParams = {}
    ) =>
      this.request<MainStemAPIPlatformControllersPurchasingEntityFilesUploadAPIResponse, any>({
        path: `/api/purchasing/products/files/upload`,
        method: 'POST',
        query: query,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags PurchasingEntityFilesUpload
     * @name SuppliersFilesUpload
     * @request POST:/api/purchasing/suppliers/files/upload
     */
    suppliersFilesUpload: (
      query: {
        /** @format int32 */
        id: number
        uuid: string
      },
      params: RequestParams = {}
    ) =>
      this.request<MainStemAPIPlatformControllersPurchasingEntityFilesUploadAPIResponse, any>({
        path: `/api/purchasing/suppliers/files/upload`,
        method: 'POST',
        query: query,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags PurchasingEntityFilesUpload
     * @name RequisitionsFilesUpload
     * @request POST:/api/purchasing/requisitions/files/upload
     */
    requisitionsFilesUpload: (
      query: {
        /** @format int32 */
        id: number
        uuid: string
      },
      params: RequestParams = {}
    ) =>
      this.request<MainStemAPIPlatformControllersPurchasingEntityFilesUploadAPIResponse, any>({
        path: `/api/purchasing/requisitions/files/upload`,
        method: 'POST',
        query: query,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags PurchasingEntityFilesUpload
     * @name PurchaseOrdersFilesUpload
     * @request POST:/api/purchasing/purchase-orders/files/upload
     */
    purchaseOrdersFilesUpload: (
      query: {
        /** @format int32 */
        id: number
        uuid: string
      },
      params: RequestParams = {}
    ) =>
      this.request<MainStemAPIPlatformControllersPurchasingEntityFilesUploadAPIResponse, any>({
        path: `/api/purchasing/purchase-orders/files/upload`,
        method: 'POST',
        query: query,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags PurchasingEntityFilesUpload
     * @name InvoicesFilesUpload
     * @request POST:/api/purchasing/invoices/files/upload
     */
    invoicesFilesUpload: (
      query: {
        /** @format int32 */
        id: number
        uuid: string
      },
      params: RequestParams = {}
    ) =>
      this.request<MainStemAPIPlatformControllersPurchasingEntityFilesUploadAPIResponse, any>({
        path: `/api/purchasing/invoices/files/upload`,
        method: 'POST',
        query: query,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags PurchasingEntityLogsList
     * @name DepartmentsLogsList
     * @request POST:/api/purchasing/departments/logs/list
     */
    departmentsLogsList: (
      apiRequest: MainStemAPIPlatformControllersPurchasingEntityLogsListAPIRequest,
      params: RequestParams = {}
    ) =>
      this.request<MainStemAPIPlatformControllersPurchasingEntityLogsListAPIResponse, any>({
        path: `/api/purchasing/departments/logs/list`,
        method: 'POST',
        body: apiRequest,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags PurchasingEntityLogsList
     * @name LocationsLogsList
     * @request POST:/api/purchasing/locations/logs/list
     */
    locationsLogsList: (
      apiRequest: MainStemAPIPlatformControllersPurchasingEntityLogsListAPIRequest,
      params: RequestParams = {}
    ) =>
      this.request<MainStemAPIPlatformControllersPurchasingEntityLogsListAPIResponse, any>({
        path: `/api/purchasing/locations/logs/list`,
        method: 'POST',
        body: apiRequest,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags PurchasingEntityLogsList
     * @name CatalogsLogsList
     * @request POST:/api/purchasing/catalogs/logs/list
     */
    catalogsLogsList: (
      apiRequest: MainStemAPIPlatformControllersPurchasingEntityLogsListAPIRequest,
      params: RequestParams = {}
    ) =>
      this.request<MainStemAPIPlatformControllersPurchasingEntityLogsListAPIResponse, any>({
        path: `/api/purchasing/catalogs/logs/list`,
        method: 'POST',
        body: apiRequest,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags PurchasingEntityLogsList
     * @name UsersLogsList
     * @request POST:/api/purchasing/users/logs/list
     */
    usersLogsList: (
      apiRequest: MainStemAPIPlatformControllersPurchasingEntityLogsListAPIRequest,
      params: RequestParams = {}
    ) =>
      this.request<MainStemAPIPlatformControllersPurchasingEntityLogsListAPIResponse, any>({
        path: `/api/purchasing/users/logs/list`,
        method: 'POST',
        body: apiRequest,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags PurchasingEntityLogsList
     * @name ProductsLogsList
     * @request POST:/api/purchasing/products/logs/list
     */
    productsLogsList: (
      apiRequest: MainStemAPIPlatformControllersPurchasingEntityLogsListAPIRequest,
      params: RequestParams = {}
    ) =>
      this.request<MainStemAPIPlatformControllersPurchasingEntityLogsListAPIResponse, any>({
        path: `/api/purchasing/products/logs/list`,
        method: 'POST',
        body: apiRequest,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags PurchasingEntityLogsList
     * @name SuppliersLogsList
     * @request POST:/api/purchasing/suppliers/logs/list
     */
    suppliersLogsList: (
      apiRequest: MainStemAPIPlatformControllersPurchasingEntityLogsListAPIRequest,
      params: RequestParams = {}
    ) =>
      this.request<MainStemAPIPlatformControllersPurchasingEntityLogsListAPIResponse, any>({
        path: `/api/purchasing/suppliers/logs/list`,
        method: 'POST',
        body: apiRequest,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags PurchasingEntityLogsList
     * @name RequisitionsLogsList
     * @request POST:/api/purchasing/requisitions/logs/list
     */
    requisitionsLogsList: (
      apiRequest: MainStemAPIPlatformControllersPurchasingEntityLogsListAPIRequest,
      params: RequestParams = {}
    ) =>
      this.request<MainStemAPIPlatformControllersPurchasingEntityLogsListAPIResponse, any>({
        path: `/api/purchasing/requisitions/logs/list`,
        method: 'POST',
        body: apiRequest,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags PurchasingEntityLogsList
     * @name PurchaseOrdersLogsList
     * @request POST:/api/purchasing/purchase-orders/logs/list
     */
    purchaseOrdersLogsList: (
      apiRequest: MainStemAPIPlatformControllersPurchasingEntityLogsListAPIRequest,
      params: RequestParams = {}
    ) =>
      this.request<MainStemAPIPlatformControllersPurchasingEntityLogsListAPIResponse, any>({
        path: `/api/purchasing/purchase-orders/logs/list`,
        method: 'POST',
        body: apiRequest,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags PurchasingEntityLogsList
     * @name InvoicesLogsList
     * @request POST:/api/purchasing/invoices/logs/list
     */
    invoicesLogsList: (
      apiRequest: MainStemAPIPlatformControllersPurchasingEntityLogsListAPIRequest,
      params: RequestParams = {}
    ) =>
      this.request<MainStemAPIPlatformControllersPurchasingEntityLogsListAPIResponse, any>({
        path: `/api/purchasing/invoices/logs/list`,
        method: 'POST',
        body: apiRequest,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags PurchasingEntityNotesCreate
     * @name DepartmentsNotesCreate
     * @request POST:/api/purchasing/departments/notes/create
     */
    departmentsNotesCreate: (
      apiRequest: MainStemAPIPlatformControllersPurchasingEntityNotesCreateAPIRequest,
      params: RequestParams = {}
    ) =>
      this.request<MainStemAPIPlatformControllersPurchasingEntityNotesCreateAPIResponse, any>({
        path: `/api/purchasing/departments/notes/create`,
        method: 'POST',
        body: apiRequest,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags PurchasingEntityNotesCreate
     * @name LocationsNotesCreate
     * @request POST:/api/purchasing/locations/notes/create
     */
    locationsNotesCreate: (
      apiRequest: MainStemAPIPlatformControllersPurchasingEntityNotesCreateAPIRequest,
      params: RequestParams = {}
    ) =>
      this.request<MainStemAPIPlatformControllersPurchasingEntityNotesCreateAPIResponse, any>({
        path: `/api/purchasing/locations/notes/create`,
        method: 'POST',
        body: apiRequest,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags PurchasingEntityNotesCreate
     * @name CatalogsNotesCreate
     * @request POST:/api/purchasing/catalogs/notes/create
     */
    catalogsNotesCreate: (
      apiRequest: MainStemAPIPlatformControllersPurchasingEntityNotesCreateAPIRequest,
      params: RequestParams = {}
    ) =>
      this.request<MainStemAPIPlatformControllersPurchasingEntityNotesCreateAPIResponse, any>({
        path: `/api/purchasing/catalogs/notes/create`,
        method: 'POST',
        body: apiRequest,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags PurchasingEntityNotesCreate
     * @name UsersNotesCreate
     * @request POST:/api/purchasing/users/notes/create
     */
    usersNotesCreate: (
      apiRequest: MainStemAPIPlatformControllersPurchasingEntityNotesCreateAPIRequest,
      params: RequestParams = {}
    ) =>
      this.request<MainStemAPIPlatformControllersPurchasingEntityNotesCreateAPIResponse, any>({
        path: `/api/purchasing/users/notes/create`,
        method: 'POST',
        body: apiRequest,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags PurchasingEntityNotesCreate
     * @name ProductsNotesCreate
     * @request POST:/api/purchasing/products/notes/create
     */
    productsNotesCreate: (
      apiRequest: MainStemAPIPlatformControllersPurchasingEntityNotesCreateAPIRequest,
      params: RequestParams = {}
    ) =>
      this.request<MainStemAPIPlatformControllersPurchasingEntityNotesCreateAPIResponse, any>({
        path: `/api/purchasing/products/notes/create`,
        method: 'POST',
        body: apiRequest,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags PurchasingEntityNotesCreate
     * @name SuppliersNotesCreate
     * @request POST:/api/purchasing/suppliers/notes/create
     */
    suppliersNotesCreate: (
      apiRequest: MainStemAPIPlatformControllersPurchasingEntityNotesCreateAPIRequest,
      params: RequestParams = {}
    ) =>
      this.request<MainStemAPIPlatformControllersPurchasingEntityNotesCreateAPIResponse, any>({
        path: `/api/purchasing/suppliers/notes/create`,
        method: 'POST',
        body: apiRequest,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags PurchasingEntityNotesCreate
     * @name RequisitionsNotesCreate
     * @request POST:/api/purchasing/requisitions/notes/create
     */
    requisitionsNotesCreate: (
      apiRequest: MainStemAPIPlatformControllersPurchasingEntityNotesCreateAPIRequest,
      params: RequestParams = {}
    ) =>
      this.request<MainStemAPIPlatformControllersPurchasingEntityNotesCreateAPIResponse, any>({
        path: `/api/purchasing/requisitions/notes/create`,
        method: 'POST',
        body: apiRequest,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags PurchasingEntityNotesCreate
     * @name PurchaseOrdersNotesCreate
     * @request POST:/api/purchasing/purchase-orders/notes/create
     */
    purchaseOrdersNotesCreate: (
      apiRequest: MainStemAPIPlatformControllersPurchasingEntityNotesCreateAPIRequest,
      params: RequestParams = {}
    ) =>
      this.request<MainStemAPIPlatformControllersPurchasingEntityNotesCreateAPIResponse, any>({
        path: `/api/purchasing/purchase-orders/notes/create`,
        method: 'POST',
        body: apiRequest,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags PurchasingEntityNotesCreate
     * @name InvoicesNotesCreate
     * @request POST:/api/purchasing/invoices/notes/create
     */
    invoicesNotesCreate: (
      apiRequest: MainStemAPIPlatformControllersPurchasingEntityNotesCreateAPIRequest,
      params: RequestParams = {}
    ) =>
      this.request<MainStemAPIPlatformControllersPurchasingEntityNotesCreateAPIResponse, any>({
        path: `/api/purchasing/invoices/notes/create`,
        method: 'POST',
        body: apiRequest,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags PurchasingEntityNotesList
     * @name DepartmentsNotesList
     * @request POST:/api/purchasing/departments/notes/list
     */
    departmentsNotesList: (
      apiRequest: MainStemAPIPlatformControllersPurchasingEntityNotesListAPIRequest,
      params: RequestParams = {}
    ) =>
      this.request<MainStemAPIPlatformControllersPurchasingEntityNotesListAPIResponse, any>({
        path: `/api/purchasing/departments/notes/list`,
        method: 'POST',
        body: apiRequest,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags PurchasingEntityNotesList
     * @name LocationsNotesList
     * @request POST:/api/purchasing/locations/notes/list
     */
    locationsNotesList: (
      apiRequest: MainStemAPIPlatformControllersPurchasingEntityNotesListAPIRequest,
      params: RequestParams = {}
    ) =>
      this.request<MainStemAPIPlatformControllersPurchasingEntityNotesListAPIResponse, any>({
        path: `/api/purchasing/locations/notes/list`,
        method: 'POST',
        body: apiRequest,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags PurchasingEntityNotesList
     * @name CatalogsNotesList
     * @request POST:/api/purchasing/catalogs/notes/list
     */
    catalogsNotesList: (
      apiRequest: MainStemAPIPlatformControllersPurchasingEntityNotesListAPIRequest,
      params: RequestParams = {}
    ) =>
      this.request<MainStemAPIPlatformControllersPurchasingEntityNotesListAPIResponse, any>({
        path: `/api/purchasing/catalogs/notes/list`,
        method: 'POST',
        body: apiRequest,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags PurchasingEntityNotesList
     * @name UsersNotesList
     * @request POST:/api/purchasing/users/notes/list
     */
    usersNotesList: (
      apiRequest: MainStemAPIPlatformControllersPurchasingEntityNotesListAPIRequest,
      params: RequestParams = {}
    ) =>
      this.request<MainStemAPIPlatformControllersPurchasingEntityNotesListAPIResponse, any>({
        path: `/api/purchasing/users/notes/list`,
        method: 'POST',
        body: apiRequest,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags PurchasingEntityNotesList
     * @name ProductsNotesList
     * @request POST:/api/purchasing/products/notes/list
     */
    productsNotesList: (
      apiRequest: MainStemAPIPlatformControllersPurchasingEntityNotesListAPIRequest,
      params: RequestParams = {}
    ) =>
      this.request<MainStemAPIPlatformControllersPurchasingEntityNotesListAPIResponse, any>({
        path: `/api/purchasing/products/notes/list`,
        method: 'POST',
        body: apiRequest,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags PurchasingEntityNotesList
     * @name SuppliersNotesList
     * @request POST:/api/purchasing/suppliers/notes/list
     */
    suppliersNotesList: (
      apiRequest: MainStemAPIPlatformControllersPurchasingEntityNotesListAPIRequest,
      params: RequestParams = {}
    ) =>
      this.request<MainStemAPIPlatformControllersPurchasingEntityNotesListAPIResponse, any>({
        path: `/api/purchasing/suppliers/notes/list`,
        method: 'POST',
        body: apiRequest,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags PurchasingEntityNotesList
     * @name RequisitionsNotesList
     * @request POST:/api/purchasing/requisitions/notes/list
     */
    requisitionsNotesList: (
      apiRequest: MainStemAPIPlatformControllersPurchasingEntityNotesListAPIRequest,
      params: RequestParams = {}
    ) =>
      this.request<MainStemAPIPlatformControllersPurchasingEntityNotesListAPIResponse, any>({
        path: `/api/purchasing/requisitions/notes/list`,
        method: 'POST',
        body: apiRequest,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags PurchasingEntityNotesList
     * @name PurchaseOrdersNotesList
     * @request POST:/api/purchasing/purchase-orders/notes/list
     */
    purchaseOrdersNotesList: (
      apiRequest: MainStemAPIPlatformControllersPurchasingEntityNotesListAPIRequest,
      params: RequestParams = {}
    ) =>
      this.request<MainStemAPIPlatformControllersPurchasingEntityNotesListAPIResponse, any>({
        path: `/api/purchasing/purchase-orders/notes/list`,
        method: 'POST',
        body: apiRequest,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags PurchasingEntityNotesList
     * @name InvoicesNotesList
     * @request POST:/api/purchasing/invoices/notes/list
     */
    invoicesNotesList: (
      apiRequest: MainStemAPIPlatformControllersPurchasingEntityNotesListAPIRequest,
      params: RequestParams = {}
    ) =>
      this.request<MainStemAPIPlatformControllersPurchasingEntityNotesListAPIResponse, any>({
        path: `/api/purchasing/invoices/notes/list`,
        method: 'POST',
        body: apiRequest,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags PurchasingErr
     * @name Err
     * @request POST:/api/purchasing/err
     */
    err: (apiRequest: MainStemAPIPlatformControllersPurchasingErrAPIRequest, params: RequestParams = {}) =>
      this.request<MainStemSDKModelsBaseResponse, any>({
        path: `/api/purchasing/err`,
        method: 'POST',
        body: apiRequest,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags PurchasingFeedCreate
     * @name FeedCreate
     * @request POST:/api/purchasing/feed/create
     */
    feedCreate: (
      apiRequest: MainStemAPIPlatformControllersPurchasingFeedCreateAPIRequest,
      params: RequestParams = {}
    ) =>
      this.request<MainStemAPIPlatformControllersPurchasingFeedCreateAPIResponse, any>({
        path: `/api/purchasing/feed/create`,
        method: 'POST',
        body: apiRequest,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags PurchasingFeedDelete
     * @name FeedDelete
     * @request POST:/api/purchasing/feed/delete
     */
    feedDelete: (
      apiRequest: MainStemAPIPlatformControllersPurchasingFeedDeleteAPIRequest,
      params: RequestParams = {}
    ) =>
      this.request<MainStemAPIPlatformControllersPurchasingFeedDeleteAPIResponse, any>({
        path: `/api/purchasing/feed/delete`,
        method: 'POST',
        body: apiRequest,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags PurchasingFeedDetails
     * @name FeedDetails
     * @request POST:/api/purchasing/feed/details
     */
    feedDetails: (
      apiRequest: MainStemAPIPlatformControllersPurchasingFeedDetailsAPIRequest,
      params: RequestParams = {}
    ) =>
      this.request<MainStemAPIPlatformControllersPurchasingFeedDetailsAPIResponse, any>({
        path: `/api/purchasing/feed/details`,
        method: 'POST',
        body: apiRequest,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags PurchasingFeedList
     * @name FeedList
     * @request POST:/api/purchasing/feed/list
     */
    feedList: (params: RequestParams = {}) =>
      this.request<MainStemAPIPlatformControllersPurchasingFeedListAPIResponse, any>({
        path: `/api/purchasing/feed/list`,
        method: 'POST',
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags PurchasingFeedStream
     * @name FeedStream
     * @request POST:/api/purchasing/feed/stream
     */
    feedStream: (params: RequestParams = {}) =>
      this.request<MainStemAPIPlatformControllersPurchasingFeedStreamAPIResponse, any>({
        path: `/api/purchasing/feed/stream`,
        method: 'POST',
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags PurchasingFeedUpdate
     * @name FeedUpdate
     * @request POST:/api/purchasing/feed/update
     */
    feedUpdate: (
      apiRequest: MainStemAPIPlatformControllersPurchasingFeedUpdateAPIRequest,
      params: RequestParams = {}
    ) =>
      this.request<MainStemAPIPlatformControllersPurchasingFeedUpdateAPIResponse, any>({
        path: `/api/purchasing/feed/update`,
        method: 'POST',
        body: apiRequest,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags PurchasingFinancialDimensionCreate
     * @name AccountFinancialDimensionCreate
     * @request POST:/api/purchasing/account/financialDimension/create
     */
    accountFinancialDimensionCreate: (
      apiRequest: MainStemAPIPlatformControllersPurchasingAccountFinancialDimensionCreateAPIRequest,
      params: RequestParams = {}
    ) =>
      this.request<MainStemAPIPlatformControllersPurchasingAccountFinancialDimensionCreateAPIResponse, any>({
        path: `/api/purchasing/account/financialDimension/create`,
        method: 'POST',
        body: apiRequest,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags PurchasingFinancialDimensionCustomerDepartments
     * @name AccountFinancialDimensionDepartmentsCustomerDepartments
     * @request POST:/api/purchasing/account/financialDimensionDepartments/customerDepartments
     */
    accountFinancialDimensionDepartmentsCustomerDepartments: (
      apiRequest: MainStemAPIPlatformControllersPurchasingAccountFinancialDimensionDepartmentCustomerDepartmentsAPIRequest,
      params: RequestParams = {}
    ) =>
      this.request<
        MainStemAPIPlatformControllersPurchasingAccountFinancialDimensionDepartmentCustomerDepartmentsAPIResponse,
        any
      >({
        path: `/api/purchasing/account/financialDimensionDepartments/customerDepartments`,
        method: 'POST',
        body: apiRequest,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags PurchasingFinancialDimensionCustomerInvoices
     * @name AccountFinancialDimensionInvoiceCustomerInvoices
     * @request POST:/api/purchasing/account/financialDimensionInvoice/customerInvoices
     */
    accountFinancialDimensionInvoiceCustomerInvoices: (
      apiRequest: MainStemAPIPlatformControllersPurchasingAccountFinancialDimensionInvoiceCustomerInvoicesAPIRequest,
      params: RequestParams = {}
    ) =>
      this.request<
        MainStemAPIPlatformControllersPurchasingAccountFinancialDimensionInvoiceCustomerInvoicesAPIResponse,
        any
      >({
        path: `/api/purchasing/account/financialDimensionInvoice/customerInvoices`,
        method: 'POST',
        body: apiRequest,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags PurchasingFinancialDimensionCustomerLocations
     * @name AccountFinancialDimensionLocationCustomerLocations
     * @request POST:/api/purchasing/account/financialDimensionLocation/customerLocations
     */
    accountFinancialDimensionLocationCustomerLocations: (
      apiRequest: MainStemAPIPlatformControllersPurchasingAccountFinancialDimensionLocationCustomerLocationsAPIRequest,
      params: RequestParams = {}
    ) =>
      this.request<
        MainStemAPIPlatformControllersPurchasingAccountFinancialDimensionLocationCustomerLocationsAPIResponse,
        any
      >({
        path: `/api/purchasing/account/financialDimensionLocation/customerLocations`,
        method: 'POST',
        body: apiRequest,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags PurchasingFinancialDimensionCustomerProducts
     * @name AccountFinancialDimensionProductCustomerProducts
     * @request POST:/api/purchasing/account/financialDimensionProduct/customerProducts
     */
    accountFinancialDimensionProductCustomerProducts: (
      apiRequest: MainStemAPIPlatformControllersPurchasingAccountFinancialDimensionProductCustomerProductsAPIRequest,
      params: RequestParams = {}
    ) =>
      this.request<
        MainStemAPIPlatformControllersPurchasingAccountFinancialDimensionProductCustomerProductsAPIResponse,
        any
      >({
        path: `/api/purchasing/account/financialDimensionProduct/customerProducts`,
        method: 'POST',
        body: apiRequest,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags PurchasingFinancialDimensionCustomerSuppliers
     * @name AccountFinancialDimensionLocationCustomerSuppliers
     * @request POST:/api/purchasing/account/financialDimensionLocation/customerSuppliers
     */
    accountFinancialDimensionLocationCustomerSuppliers: (
      apiRequest: MainStemAPIPlatformControllersPurchasingAccountFinancialDimensionSupplierCustomerSuppliersAPIRequest,
      params: RequestParams = {}
    ) =>
      this.request<
        MainStemAPIPlatformControllersPurchasingAccountFinancialDimensionSupplierCustomerSuppliersAPIResponse,
        any
      >({
        path: `/api/purchasing/account/financialDimensionLocation/customerSuppliers`,
        method: 'POST',
        body: apiRequest,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags PurchasingFinancialDimensionDelete
     * @name AccountFinancialDimensionDelete
     * @request POST:/api/purchasing/account/financialDimension/delete
     */
    accountFinancialDimensionDelete: (
      apiRequest: MainStemAPIPlatformControllersPurchasingAccountFinancialDimensionDeleteAPIRequest,
      params: RequestParams = {}
    ) =>
      this.request<MainStemAPIPlatformControllersPurchasingAccountFinancialDimensionDeleteAPIResponse, any>({
        path: `/api/purchasing/account/financialDimension/delete`,
        method: 'POST',
        body: apiRequest,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags PurchasingFinancialDimensionGetByType
     * @name AccountFinancialDimensionGetByType
     * @request POST:/api/purchasing/account/financialDimension/getByType
     */
    accountFinancialDimensionGetByType: (
      apiRequest: MainStemAPIPlatformControllersPurchasingAccountFinancialDimensionGetByTypeAPIRequest,
      params: RequestParams = {}
    ) =>
      this.request<MainStemAPIPlatformControllersPurchasingAccountFinancialDimensionGetByTypeAPIResponse, any>({
        path: `/api/purchasing/account/financialDimension/getByType`,
        method: 'POST',
        body: apiRequest,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags PurchasingFinancialDimensionList
     * @name AccountFinancialDimensionListByType
     * @request POST:/api/purchasing/account/financialDimension/listByType
     */
    accountFinancialDimensionListByType: (
      apiRequest: MainStemAPIPlatformControllersPurchasingAccountFinancialDimensionListByTypeAPIRequest,
      params: RequestParams = {}
    ) =>
      this.request<MainStemAPIPlatformControllersPurchasingAccountFinancialDimensionListByTypeAPIResponse, any>({
        path: `/api/purchasing/account/financialDimension/listByType`,
        method: 'POST',
        body: apiRequest,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags PurchasingFinancialDimensionOptionCreate
     * @name AccountFinancialDimensionOptionCreate
     * @request POST:/api/purchasing/account/financialDimensionOption/create
     */
    accountFinancialDimensionOptionCreate: (
      apiRequest: MainStemAPIPlatformControllersPurchasingAccountFinancialDimensionOptionCreateAPIRequest,
      params: RequestParams = {}
    ) =>
      this.request<MainStemAPIPlatformControllersPurchasingAccountFinancialDimensionOptionCreateAPIResponse, any>({
        path: `/api/purchasing/account/financialDimensionOption/create`,
        method: 'POST',
        body: apiRequest,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags PurchasingFinancialDimensionOptionDelete
     * @name AccountFinancialDimensionOptionDelete
     * @request POST:/api/purchasing/account/financialDimensionOption/delete
     */
    accountFinancialDimensionOptionDelete: (
      apiRequest: MainStemAPIPlatformControllersPurchasingAccountFinancialDimensionOptionDeleteAPIRequest,
      params: RequestParams = {}
    ) =>
      this.request<MainStemAPIPlatformControllersPurchasingAccountFinancialDimensionOptionDeleteAPIResponse, any>({
        path: `/api/purchasing/account/financialDimensionOption/delete`,
        method: 'POST',
        body: apiRequest,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags PurchasingFinancialDimensionOptionGetByType
     * @name AccountFinancialDimensionOptionGetByType
     * @request POST:/api/purchasing/account/FinancialDimensionOption/getByType
     */
    accountFinancialDimensionOptionGetByType: (
      apiRequest: MainStemAPIPlatformControllersPurchasingAccountFinancialDimensionOptionGetByTypeAPIRequest,
      params: RequestParams = {}
    ) =>
      this.request<MainStemAPIPlatformControllersPurchasingAccountFinancialDimensionOptionGetByTypeAPIResponse, any>({
        path: `/api/purchasing/account/FinancialDimensionOption/getByType`,
        method: 'POST',
        body: apiRequest,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags PurchasingFinancialDimensionOptionList
     * @name AccountFinancialDimensionOptionListById
     * @request POST:/api/purchasing/account/FinancialDimensionOption/listByID
     */
    accountFinancialDimensionOptionListById: (
      apiRequest: MainStemAPIPlatformControllersPurchasingAccountFinancialDimensionOptionListByIDAPIRequest,
      params: RequestParams = {}
    ) =>
      this.request<MainStemAPIPlatformControllersPurchasingAccountFinancialDimensionOptionListByIDAPIResponse, any>({
        path: `/api/purchasing/account/FinancialDimensionOption/listByID`,
        method: 'POST',
        body: apiRequest,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags PurchasingFinancialDimensionOptionSetByType
     * @name AccountFinancialDimensionOptionSetByType
     * @request POST:/api/purchasing/account/FinancialDimensionOption/setByType
     */
    accountFinancialDimensionOptionSetByType: (
      apiRequest: MainStemAPIPlatformControllersPurchasingAccountFinancialDimensionOptionSetByTypeAPIRequest,
      params: RequestParams = {}
    ) =>
      this.request<MainStemAPIPlatformControllersPurchasingAccountFinancialDimensionOptionSetByTypeAPIResponse, any>({
        path: `/api/purchasing/account/FinancialDimensionOption/setByType`,
        method: 'POST',
        body: apiRequest,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags PurchasingFinancialDimensionOptionUpdate
     * @name AccountFinancialDimensionOptionUpdate
     * @request POST:/api/purchasing/account/financialDimensionOption/update
     */
    accountFinancialDimensionOptionUpdate: (
      apiRequest: MainStemAPIPlatformControllersPurchasingAccountFinancialDimensionOptionUpdateAPIRequest,
      params: RequestParams = {}
    ) =>
      this.request<MainStemAPIPlatformControllersPurchasingAccountFinancialDimensionOptionUpdateAPIResponse, any>({
        path: `/api/purchasing/account/financialDimensionOption/update`,
        method: 'POST',
        body: apiRequest,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags PurchasingFinancialDimensionUpdate
     * @name AccountFinancialDimensionUpdate
     * @request POST:/api/purchasing/account/financialDimension/update
     */
    accountFinancialDimensionUpdate: (
      apiRequest: MainStemAPIPlatformControllersPurchasingAccountFinancialDimensionUpdateAPIRequest,
      params: RequestParams = {}
    ) =>
      this.request<MainStemAPIPlatformControllersPurchasingAccountFinancialDimensionUpdateAPIResponse, any>({
        path: `/api/purchasing/account/financialDimension/update`,
        method: 'POST',
        body: apiRequest,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags PurchasingFinancialDimensionUpdateDepartments
     * @name AccountFinancialDimensionDepartmentsUpdateDepartments
     * @request POST:/api/purchasing/account/financialDimensionDepartments/updateDepartments
     */
    accountFinancialDimensionDepartmentsUpdateDepartments: (
      apiRequest: MainStemAPIPlatformControllersPurchasingAccountFinancialDimensionDepartmentUpdateDepartmentsAPIRequest,
      params: RequestParams = {}
    ) =>
      this.request<
        MainStemAPIPlatformControllersPurchasingAccountFinancialDimensionDepartmentUpdateDepartmentsAPIResponse,
        any
      >({
        path: `/api/purchasing/account/financialDimensionDepartments/updateDepartments`,
        method: 'POST',
        body: apiRequest,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags PurchasingFinancialDimensionUpdateInvoices
     * @name AccountFinancialDimensionInvoiceUpdateInvoices
     * @request POST:/api/purchasing/account/financialDimensionInvoice/updateInvoices
     */
    accountFinancialDimensionInvoiceUpdateInvoices: (
      apiRequest: MainStemAPIPlatformControllersPurchasingAccountFinancialDimensionInvoiceUpdateInvoicesAPIRequest,
      params: RequestParams = {}
    ) =>
      this.request<
        MainStemAPIPlatformControllersPurchasingAccountFinancialDimensionInvoiceUpdateInvoicesAPIResponse,
        any
      >({
        path: `/api/purchasing/account/financialDimensionInvoice/updateInvoices`,
        method: 'POST',
        body: apiRequest,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags PurchasingFinancialDimensionUpdateLocations
     * @name AccountFinancialDimensionLocationUpdateLocations
     * @request POST:/api/purchasing/account/financialDimensionLocation/updateLocations
     */
    accountFinancialDimensionLocationUpdateLocations: (
      apiRequest: MainStemAPIPlatformControllersPurchasingAccountFinancialDimensionLocationUpdateLocationsAPIRequest,
      params: RequestParams = {}
    ) =>
      this.request<
        MainStemAPIPlatformControllersPurchasingAccountFinancialDimensionLocationUpdateLocationsAPIResponse,
        any
      >({
        path: `/api/purchasing/account/financialDimensionLocation/updateLocations`,
        method: 'POST',
        body: apiRequest,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags PurchasingFinancialDimensionUpdateProducts
     * @name AccountFinancialDimensionProductUpdateProducts
     * @request POST:/api/purchasing/account/financialDimensionProduct/updateProducts
     */
    accountFinancialDimensionProductUpdateProducts: (
      apiRequest: MainStemAPIPlatformControllersPurchasingAccountFinancialDimensionProductUpdateProductsAPIRequest,
      params: RequestParams = {}
    ) =>
      this.request<
        MainStemAPIPlatformControllersPurchasingAccountFinancialDimensionProductUpdateProductsAPIResponse,
        any
      >({
        path: `/api/purchasing/account/financialDimensionProduct/updateProducts`,
        method: 'POST',
        body: apiRequest,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags PurchasingFinancialDimensionUpdateSuppliers
     * @name AccountFinancialDimensionLocationUpdateSuppliers
     * @request POST:/api/purchasing/account/financialDimensionLocation/updateSuppliers
     */
    accountFinancialDimensionLocationUpdateSuppliers: (
      apiRequest: MainStemAPIPlatformControllersPurchasingAccountFinancialDimensionSupplierUpdateSuppliersAPIRequest,
      params: RequestParams = {}
    ) =>
      this.request<
        MainStemAPIPlatformControllersPurchasingAccountFinancialDimensionSupplierUpdateSuppliersAPIResponse,
        any
      >({
        path: `/api/purchasing/account/financialDimensionLocation/updateSuppliers`,
        method: 'POST',
        body: apiRequest,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags PurchasingIntegrationAmazonOrderLineItemCreate
     * @name IntegrationsAmazonOrderLineItemCreate
     * @request POST:/api/purchasing/integrations/amazon/order-line-item/create
     */
    integrationsAmazonOrderLineItemCreate: (
      apiRequest: MainStemAPIPlatformControllersPurchasingIntegrationAmazonOrderLineItemCreateAPIRequest,
      params: RequestParams = {}
    ) =>
      this.request<MainStemAPIPlatformControllersPurchasingIntegrationAmazonOrderLineItemCreateAPIResponse, any>({
        path: `/api/purchasing/integrations/amazon/order-line-item/create`,
        method: 'POST',
        body: apiRequest,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags PurchasingIntegrationAmazonProductDetails
     * @name IntegrationsAmazonProductDetails
     * @request POST:/api/purchasing/integrations/amazon/product/details
     */
    integrationsAmazonProductDetails: (
      APIRequest: MainStemAPIPlatformControllersPurchasingIntegrationAmazonProductDetailsAPIRequest,
      params: RequestParams = {}
    ) =>
      this.request<MainStemAPIPlatformControllersPurchasingIntegrationAmazonProductDetailsAPIResponse, any>({
        path: `/api/purchasing/integrations/amazon/product/details`,
        method: 'POST',
        body: APIRequest,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags PurchasingIntegrationAmazonProductImport
     * @name IntegrationsAmazonProductImport
     * @request POST:/api/purchasing/integrations/amazon/product/import
     */
    integrationsAmazonProductImport: (
      APIRequest: MainStemAPIPlatformControllersPurchasingIntegrationAmazonProductImportAPIRequest,
      params: RequestParams = {}
    ) =>
      this.request<MainStemAPIPlatformControllersPurchasingIntegrationAmazonProductImportAPIResponse, any>({
        path: `/api/purchasing/integrations/amazon/product/import`,
        method: 'POST',
        body: APIRequest,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags PurchasingIntegrationAmazonShipmentTracking
     * @name IntegrationsAmazonShipmentTracking
     * @request POST:/api/purchasing/integrations/amazon/shipment/tracking
     */
    integrationsAmazonShipmentTracking: (
      apiRequest: MainStemAPIPlatformControllersPurchasingIntegrationAmazonShipmentTrackingAPIRequest,
      params: RequestParams = {}
    ) =>
      this.request<MainStemAPIPlatformControllersPurchasingIntegrationAmazonShipmentTrackingAPIResponse, any>({
        path: `/api/purchasing/integrations/amazon/shipment/tracking`,
        method: 'POST',
        body: apiRequest,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags PurchasingIntegrationApexTradingListingsList
     * @name IntegrationsApexTradingListingsList
     * @request POST:/api/purchasing/integrations/apex-trading/listings/list
     */
    integrationsApexTradingListingsList: (
      APIRequest: MainStemAPIPlatformControllersPurchasingIntegrationApexTradingListingsListAPIRequest,
      params: RequestParams = {}
    ) =>
      this.request<MainStemAPIPlatformControllersPurchasingIntegrationApexTradingListingsListAPIResponse, any>({
        path: `/api/purchasing/integrations/apex-trading/listings/list`,
        method: 'POST',
        body: APIRequest,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags PurchasingIntegrationApexTradingLocationsList
     * @name IntegrationsApexTradingLocationsList
     * @request POST:/api/purchasing/integrations/apex-trading/locations/list
     */
    integrationsApexTradingLocationsList: (
      APIRequest: MainStemAPIPlatformControllersPurchasingIntegrationApexTradingLocationsListAPIRequest,
      params: RequestParams = {}
    ) =>
      this.request<MainStemAPIPlatformControllersPurchasingIntegrationApexTradingLocationsListAPIResponse, any>({
        path: `/api/purchasing/integrations/apex-trading/locations/list`,
        method: 'POST',
        body: APIRequest,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags PurchasingIntegrationApexTradingLocationsRemove
     * @name IntegrationsApexTradingLocationsRemove
     * @request POST:/api/purchasing/integrations/apex-trading/locations/remove
     */
    integrationsApexTradingLocationsRemove: (
      APIRequest: MainStemAPIPlatformControllersPurchasingIntegrationApexTradingLocationsRemoveAPIRequest,
      params: RequestParams = {}
    ) =>
      this.request<MainStemAPIPlatformControllersPurchasingIntegrationApexTradingLocationsRemoveAPIResponse, any>({
        path: `/api/purchasing/integrations/apex-trading/locations/remove`,
        method: 'POST',
        body: APIRequest,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags PurchasingIntegrationApexTradingLocationsSave
     * @name IntegrationsApexTradingLocationsSave
     * @request POST:/api/purchasing/integrations/apex-trading/locations/save
     */
    integrationsApexTradingLocationsSave: (
      APIRequest: MainStemAPIPlatformControllersPurchasingIntegrationApexTradingLocationsSaveAPIRequest,
      params: RequestParams = {}
    ) =>
      this.request<MainStemAPIPlatformControllersPurchasingIntegrationApexTradingLocationsSaveAPIResponse, any>({
        path: `/api/purchasing/integrations/apex-trading/locations/save`,
        method: 'POST',
        body: APIRequest,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags PurchasingIntegrationApexTradingOperationsList
     * @name IntegrationsApexTradingOperationsList
     * @request POST:/api/purchasing/integrations/apex-trading/operations/list
     */
    integrationsApexTradingOperationsList: (
      APIRequest: MainStemAPIPlatformControllersPurchasingIntegrationApexTradingOperationsListAPIRequest,
      params: RequestParams = {}
    ) =>
      this.request<MainStemAPIPlatformControllersPurchasingIntegrationApexTradingOperationsListAPIResponse, any>({
        path: `/api/purchasing/integrations/apex-trading/operations/list`,
        method: 'POST',
        body: APIRequest,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags PurchasingIntegrationApexTradingOrderLineItemCreate
     * @name IntegrationsApexTradingOrderLineItemCreate
     * @request POST:/api/purchasing/integrations/apex-trading/order-line-item/create
     */
    integrationsApexTradingOrderLineItemCreate: (
      apiRequest: MainStemAPIPlatformControllersPurchasingIntegrationApexTradingOrderLineItemCreateAPIRequest,
      params: RequestParams = {}
    ) =>
      this.request<MainStemAPIPlatformControllersPurchasingIntegrationApexTradingOrderLineItemCreateAPIResponse, any>({
        path: `/api/purchasing/integrations/apex-trading/order-line-item/create`,
        method: 'POST',
        body: apiRequest,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags PurchasingIntegrationApexTradingPair
     * @name IntegrationsApexTradingPair
     * @request POST:/api/purchasing/integrations/apex-trading/pair
     */
    integrationsApexTradingPair: (
      APIRequest: MainStemAPIPlatformControllersPurchasingIntegrationApexTradingPairAPIRequest,
      params: RequestParams = {}
    ) =>
      this.request<MainStemAPIPlatformControllersPurchasingIntegrationApexTradingPairAPIResponse, any>({
        path: `/api/purchasing/integrations/apex-trading/pair`,
        method: 'POST',
        body: APIRequest,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags PurchasingIntegrationApexTradingProductsList
     * @name IntegrationsApexTradingProductsList
     * @request POST:/api/purchasing/integrations/apex-trading/products/list
     */
    integrationsApexTradingProductsList: (
      APIRequest: MainStemAPIPlatformControllersPurchasingIntegrationApexTradingProductsListAPIRequest,
      params: RequestParams = {}
    ) =>
      this.request<MainStemAPIPlatformControllersPurchasingIntegrationApexTradingProductsListAPIResponse, any>({
        path: `/api/purchasing/integrations/apex-trading/products/list`,
        method: 'POST',
        body: APIRequest,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags PurchasingIntegrationApexTradingProductsRemove
     * @name IntegrationsApexTradingProductsRemove
     * @request POST:/api/purchasing/integrations/apex-trading/products/remove
     */
    integrationsApexTradingProductsRemove: (
      APIRequest: MainStemAPIPlatformControllersPurchasingIntegrationApexTradingProductsRemoveAPIRequest,
      params: RequestParams = {}
    ) =>
      this.request<MainStemAPIPlatformControllersPurchasingIntegrationApexTradingProductsRemoveAPIResponse, any>({
        path: `/api/purchasing/integrations/apex-trading/products/remove`,
        method: 'POST',
        body: APIRequest,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags PurchasingIntegrationApexTradingProductsSave
     * @name IntegrationsApexTradingProductsSave
     * @request POST:/api/purchasing/integrations/apex-trading/products/save
     */
    integrationsApexTradingProductsSave: (
      APIRequest: MainStemAPIPlatformControllersPurchasingIntegrationApexTradingProductsSaveAPIRequest,
      params: RequestParams = {}
    ) =>
      this.request<MainStemAPIPlatformControllersPurchasingIntegrationApexTradingProductsSaveAPIResponse, any>({
        path: `/api/purchasing/integrations/apex-trading/products/save`,
        method: 'POST',
        body: APIRequest,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags PurchasingIntegrationApexTradingSellersList
     * @name IntegrationsApexTradingSellersList
     * @request POST:/api/purchasing/integrations/apex-trading/sellers/list
     */
    integrationsApexTradingSellersList: (
      APIRequest: MainStemAPIPlatformControllersPurchasingIntegrationApexTradingSellersListAPIRequest,
      params: RequestParams = {}
    ) =>
      this.request<MainStemAPIPlatformControllersPurchasingIntegrationApexTradingSellersListAPIResponse, any>({
        path: `/api/purchasing/integrations/apex-trading/sellers/list`,
        method: 'POST',
        body: APIRequest,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags PurchasingIntegrationApexTradingShipmentCheck
     * @name IntegrationsApexTradingShipmentCheck
     * @request POST:/api/purchasing/integrations/apex-trading/shipment/check
     */
    integrationsApexTradingShipmentCheck: (
      APIRequest: MainStemAPIPlatformControllersPurchasingIntegrationApexTradingShipmentCheckAPIRequest,
      params: RequestParams = {}
    ) =>
      this.request<MainStemAPIPlatformControllersPurchasingIntegrationApexTradingShipmentCheckAPIResponse, any>({
        path: `/api/purchasing/integrations/apex-trading/shipment/check`,
        method: 'POST',
        body: APIRequest,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags PurchasingIntegrationApexTradingSuppliersList
     * @name IntegrationsApexTradingSuppliersList
     * @request POST:/api/purchasing/integrations/apex-trading/suppliers/list
     */
    integrationsApexTradingSuppliersList: (
      APIRequest: MainStemAPIPlatformControllersPurchasingIntegrationApexTradingSuppliersListAPIRequest,
      params: RequestParams = {}
    ) =>
      this.request<MainStemAPIPlatformControllersPurchasingIntegrationApexTradingSuppliersListAPIResponse, any>({
        path: `/api/purchasing/integrations/apex-trading/suppliers/list`,
        method: 'POST',
        body: APIRequest,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags PurchasingIntegrationApexTradingSuppliersRemove
     * @name IntegrationsApexTradingSuppliersRemove
     * @request POST:/api/purchasing/integrations/apex-trading/suppliers/remove
     */
    integrationsApexTradingSuppliersRemove: (
      APIRequest: MainStemAPIPlatformControllersPurchasingIntegrationApexTradingSuppliersRemoveAPIRequest,
      params: RequestParams = {}
    ) =>
      this.request<MainStemAPIPlatformControllersPurchasingIntegrationApexTradingSuppliersRemoveAPIResponse, any>({
        path: `/api/purchasing/integrations/apex-trading/suppliers/remove`,
        method: 'POST',
        body: APIRequest,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags PurchasingIntegrationApexTradingSuppliersSave
     * @name IntegrationsApexTradingSuppliersSave
     * @request POST:/api/purchasing/integrations/apex-trading/suppliers/save
     */
    integrationsApexTradingSuppliersSave: (
      APIRequest: MainStemAPIPlatformControllersPurchasingIntegrationApexTradingSuppliersSaveAPIRequest,
      params: RequestParams = {}
    ) =>
      this.request<MainStemAPIPlatformControllersPurchasingIntegrationApexTradingSuppliersSaveAPIResponse, any>({
        path: `/api/purchasing/integrations/apex-trading/suppliers/save`,
        method: 'POST',
        body: APIRequest,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags PurchasingIntegrationDutchieEmployeesDetails
     * @name IntegrationsDutchieEmployeesDetails
     * @request POST:/api/purchasing/integrations/dutchie/employees/details
     */
    integrationsDutchieEmployeesDetails: (
      apiRequest: MainStemAPIPlatformControllersPurchasingIntegrationDutchieEmployeesDetailsAPIRequest,
      params: RequestParams = {}
    ) =>
      this.request<MainStemAPIPlatformControllersPurchasingIntegrationDutchieEmployeesDetailsAPIResponse, any>({
        path: `/api/purchasing/integrations/dutchie/employees/details`,
        method: 'POST',
        body: apiRequest,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags PurchasingIntegrationDutchieEmployeesList
     * @name IntegrationsDutchieEmployeesList
     * @request POST:/api/purchasing/integrations/dutchie/employees/list
     */
    integrationsDutchieEmployeesList: (
      apiRequest: MainStemAPIPlatformControllersPurchasingIntegrationDutchieEmployeesListAPIRequest,
      params: RequestParams = {}
    ) =>
      this.request<MainStemAPIPlatformControllersPurchasingIntegrationDutchieEmployeesListAPIResponse, any>({
        path: `/api/purchasing/integrations/dutchie/employees/list`,
        method: 'POST',
        body: apiRequest,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags PurchasingIntegrationDutchieEmployeesSync
     * @name IntegrationsDutchieEmployeesSync
     * @request POST:/api/purchasing/integrations/dutchie/employees/sync
     */
    integrationsDutchieEmployeesSync: (
      apiRequest: MainStemAPIPlatformControllersPurchasingIntegrationDutchieEmployeesSyncAPIRequest,
      params: RequestParams = {}
    ) =>
      this.request<MainStemAPIPlatformControllersPurchasingIntegrationDutchieEmployeesSyncAPIResponse, any>({
        path: `/api/purchasing/integrations/dutchie/employees/sync`,
        method: 'POST',
        body: apiRequest,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags PurchasingIntegrationDutchieEndpointsList
     * @name IntegrationsDutchieEndpointsList
     * @request POST:/api/purchasing/integrations/dutchie/endpoints/list
     */
    integrationsDutchieEndpointsList: (
      apiRequest: MainStemAPIPlatformControllersPurchasingIntegrationDutchieEndpointsListAPIRequest,
      params: RequestParams = {}
    ) =>
      this.request<MainStemAPIPlatformControllersPurchasingIntegrationDutchieEndpointsListAPIResponse, any>({
        path: `/api/purchasing/integrations/dutchie/endpoints/list`,
        method: 'POST',
        body: apiRequest,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags PurchasingIntegrationDutchieInventoryDetails
     * @name IntegrationsDutchieInventoryDetails
     * @request POST:/api/purchasing/integrations/dutchie/inventory/details
     */
    integrationsDutchieInventoryDetails: (
      apiRequest: MainStemAPIPlatformControllersPurchasingIntegrationDutchieInventoryDetailsAPIRequest,
      params: RequestParams = {}
    ) =>
      this.request<MainStemAPIPlatformControllersPurchasingIntegrationDutchieInventoryDetailsAPIResponse, any>({
        path: `/api/purchasing/integrations/dutchie/inventory/details`,
        method: 'POST',
        body: apiRequest,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags PurchasingIntegrationDutchieInventoryList
     * @name IntegrationsDutchieInventoryList
     * @request POST:/api/purchasing/integrations/dutchie/inventory/list
     */
    integrationsDutchieInventoryList: (
      apiRequest: MainStemAPIPlatformControllersPurchasingIntegrationDutchieInventoryListAPIRequest,
      params: RequestParams = {}
    ) =>
      this.request<MainStemAPIPlatformControllersPurchasingIntegrationDutchieInventoryListAPIResponse, any>({
        path: `/api/purchasing/integrations/dutchie/inventory/list`,
        method: 'POST',
        body: apiRequest,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags PurchasingIntegrationDutchieInventorySync
     * @name IntegrationsDutchieInventorySync
     * @request POST:/api/purchasing/integrations/dutchie/inventory/sync
     */
    integrationsDutchieInventorySync: (
      apiRequest: MainStemAPIPlatformControllersPurchasingIntegrationDutchieInventorySyncAPIRequest,
      params: RequestParams = {}
    ) =>
      this.request<MainStemAPIPlatformControllersPurchasingIntegrationDutchieInventorySyncAPIResponse, any>({
        path: `/api/purchasing/integrations/dutchie/inventory/sync`,
        method: 'POST',
        body: apiRequest,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags PurchasingIntegrationDutchieInventoryTransactionsList
     * @name IntegrationsDutchieInventoryTransactionsList
     * @request POST:/api/purchasing/integrations/dutchie/inventory-transactions/list
     */
    integrationsDutchieInventoryTransactionsList: (
      apiRequest: MainStemAPIPlatformControllersPurchasingIntegrationDutchieInventoryTransactionsListAPIRequest,
      params: RequestParams = {}
    ) =>
      this.request<MainStemAPIPlatformControllersPurchasingIntegrationDutchieInventoryTransactionsListAPIResponse, any>(
        {
          path: `/api/purchasing/integrations/dutchie/inventory-transactions/list`,
          method: 'POST',
          body: apiRequest,
          type: ContentType.Json,
          format: 'json',
          ...params
        }
      ),

    /**
     * No description
     *
     * @tags PurchasingIntegrationDutchieInventoryTransactionsSync
     * @name IntegrationsDutchieInventoryTransactionsSync
     * @request POST:/api/purchasing/integrations/dutchie/inventory-transactions/sync
     */
    integrationsDutchieInventoryTransactionsSync: (
      apiRequest: MainStemAPIPlatformControllersPurchasingIntegrationDutchieInventoryTransactionsSyncAPIRequest,
      params: RequestParams = {}
    ) =>
      this.request<MainStemAPIPlatformControllersPurchasingIntegrationDutchieInventoryTransactionsSyncAPIResponse, any>(
        {
          path: `/api/purchasing/integrations/dutchie/inventory-transactions/sync`,
          method: 'POST',
          body: apiRequest,
          type: ContentType.Json,
          format: 'json',
          ...params
        }
      ),

    /**
     * No description
     *
     * @tags PurchasingIntegrationDutchieInvoiceLineItemsAssign
     * @name IntegrationsDutchieInvoiceLineItemsAssign
     * @request POST:/api/purchasing/integrations/dutchie/invoice-line-items/assign
     */
    integrationsDutchieInvoiceLineItemsAssign: (
      apiRequest: MainStemAPIPlatformControllersPurchasingIntegrationDutchieInvoiceLineItemsAssignAPIRequest,
      params: RequestParams = {}
    ) =>
      this.request<MainStemAPIPlatformControllersPurchasingIntegrationDutchieInvoiceLineItemsAssignAPIResponse, any>({
        path: `/api/purchasing/integrations/dutchie/invoice-line-items/assign`,
        method: 'POST',
        body: apiRequest,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags PurchasingIntegrationDutchieInvoiceLineItemsList
     * @name IntegrationsDutchieInvoiceLineItemsList
     * @request POST:/api/purchasing/integrations/dutchie/invoice-line-items/list
     */
    integrationsDutchieInvoiceLineItemsList: (
      apiRequest: MainStemAPIPlatformControllersPurchasingIntegrationDutchieInvoiceLineItemsListAPIRequest,
      params: RequestParams = {}
    ) =>
      this.request<MainStemAPIPlatformControllersPurchasingIntegrationDutchieInvoiceLineItemsListAPIResponse, any>({
        path: `/api/purchasing/integrations/dutchie/invoice-line-items/list`,
        method: 'POST',
        body: apiRequest,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags PurchasingIntegrationDutchieInvoiceLineItemsMatch
     * @name IntegrationsDutchieInvoiceLineItemsMatch
     * @request POST:/api/purchasing/integrations/dutchie/invoice-line-items/match
     */
    integrationsDutchieInvoiceLineItemsMatch: (
      apiRequest: MainStemAPIPlatformControllersPurchasingIntegrationDutchieInvoiceLineItemsMatchAPIRequest,
      params: RequestParams = {}
    ) =>
      this.request<MainStemAPIPlatformControllersPurchasingIntegrationDutchieInvoiceLineItemsMatchAPIResponse, any>({
        path: `/api/purchasing/integrations/dutchie/invoice-line-items/match`,
        method: 'POST',
        body: apiRequest,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags PurchasingIntegrationDutchieInvoiceLineItemsReset
     * @name IntegrationsDutchieInvoiceLineItemsReset
     * @request POST:/api/purchasing/integrations/dutchie/invoice-line-items/reset
     */
    integrationsDutchieInvoiceLineItemsReset: (
      apiRequest: MainStemAPIPlatformControllersPurchasingIntegrationDutchieInvoiceLineItemsResetAPIRequest,
      params: RequestParams = {}
    ) =>
      this.request<MainStemAPIPlatformControllersPurchasingIntegrationDutchieInvoiceLineItemsResetAPIResponse, any>({
        path: `/api/purchasing/integrations/dutchie/invoice-line-items/reset`,
        method: 'POST',
        body: apiRequest,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags PurchasingIntegrationDutchieInvoiceLineItemsUnmap
     * @name IntegrationsDutchieInvoiceLineItemsUnmap
     * @request POST:/api/purchasing/integrations/dutchie/invoice-line-items/unmap
     */
    integrationsDutchieInvoiceLineItemsUnmap: (
      apiRequest: MainStemAPIPlatformControllersPurchasingIntegrationDutchieInvoiceLineItemsUnmapAPIRequest,
      params: RequestParams = {}
    ) =>
      this.request<MainStemAPIPlatformControllersPurchasingIntegrationDutchieInvoiceLineItemsUnmapAPIResponse, any>({
        path: `/api/purchasing/integrations/dutchie/invoice-line-items/unmap`,
        method: 'POST',
        body: apiRequest,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags PurchasingIntegrationDutchieInvoicesDetails
     * @name IntegrationsDutchieInvoicesDetails
     * @request POST:/api/purchasing/integrations/dutchie/invoices/details
     */
    integrationsDutchieInvoicesDetails: (
      apiRequest: MainStemAPIPlatformControllersPurchasingIntegrationDutchieInvoicesDetailsAPIRequest,
      params: RequestParams = {}
    ) =>
      this.request<MainStemAPIPlatformControllersPurchasingIntegrationDutchieInvoicesDetailsAPIResponse, any>({
        path: `/api/purchasing/integrations/dutchie/invoices/details`,
        method: 'POST',
        body: apiRequest,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags PurchasingIntegrationDutchieLocationsLinked
     * @name IntegrationsDutchieLocationsLinked
     * @request POST:/api/purchasing/integrations/dutchie/locations/linked
     */
    integrationsDutchieLocationsLinked: (
      apiRequest: MainStemAPIPlatformControllersPurchasingIntegrationDutchieLocationsLinkedAPIRequest,
      params: RequestParams = {}
    ) =>
      this.request<MainStemAPIPlatformControllersPurchasingIntegrationDutchieLocationsLinkedAPIResponse, any>({
        path: `/api/purchasing/integrations/dutchie/locations/linked`,
        method: 'POST',
        body: apiRequest,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags PurchasingIntegrationDutchieProductsActivity
     * @name IntegrationsDutchieProductsActivity
     * @request POST:/api/purchasing/integrations/dutchie/products/activity
     */
    integrationsDutchieProductsActivity: (
      apiRequest: MainStemAPIPlatformControllersPurchasingIntegrationDutchieProductsActivityAPIRequest,
      params: RequestParams = {}
    ) =>
      this.request<MainStemAPIPlatformControllersPurchasingIntegrationDutchieProductsActivityAPIResponse, any>({
        path: `/api/purchasing/integrations/dutchie/products/activity`,
        method: 'POST',
        body: apiRequest,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags PurchasingIntegrationDutchieProductsDetails
     * @name IntegrationsDutchieProductsDetails
     * @request POST:/api/purchasing/integrations/dutchie/products/details
     */
    integrationsDutchieProductsDetails: (
      apiRequest: MainStemAPIPlatformControllersPurchasingIntegrationDutchieProductsDetailsAPIRequest,
      params: RequestParams = {}
    ) =>
      this.request<MainStemAPIPlatformControllersPurchasingIntegrationDutchieProductsDetailsAPIResponse, any>({
        path: `/api/purchasing/integrations/dutchie/products/details`,
        method: 'POST',
        body: apiRequest,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags PurchasingIntegrationDutchieProductsLinked
     * @name IntegrationsDutchieProductsLinked
     * @request POST:/api/purchasing/integrations/dutchie/products/linked
     */
    integrationsDutchieProductsLinked: (
      apiRequest: MainStemAPIPlatformControllersPurchasingIntegrationDutchieProductsLinkedAPIRequest,
      params: RequestParams = {}
    ) =>
      this.request<MainStemAPIPlatformControllersPurchasingIntegrationDutchieProductsLinkedAPIResponse, any>({
        path: `/api/purchasing/integrations/dutchie/products/linked`,
        method: 'POST',
        body: apiRequest,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags PurchasingIntegrationDutchieProductsList
     * @name IntegrationsDutchieProductsList
     * @request POST:/api/purchasing/integrations/dutchie/products/list
     */
    integrationsDutchieProductsList: (
      apiRequest: MainStemAPIPlatformControllersPurchasingIntegrationDutchieProductsListAPIRequest,
      params: RequestParams = {}
    ) =>
      this.request<MainStemAPIPlatformControllersPurchasingIntegrationDutchieProductsListAPIResponse, any>({
        path: `/api/purchasing/integrations/dutchie/products/list`,
        method: 'POST',
        body: apiRequest,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags PurchasingIntegrationDutchieProductsMap
     * @name IntegrationsDutchieProductsMap
     * @request POST:/api/purchasing/integrations/dutchie/products/map
     */
    integrationsDutchieProductsMap: (
      apiRequest: MainStemAPIPlatformControllersPurchasingIntegrationDutchieProductsMapAPIRequest,
      params: RequestParams = {}
    ) =>
      this.request<MainStemAPIPlatformControllersPurchasingIntegrationDutchieProductsMapAPIResponse, any>({
        path: `/api/purchasing/integrations/dutchie/products/map`,
        method: 'POST',
        body: apiRequest,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags PurchasingIntegrationDutchieProductsSync
     * @name IntegrationsDutchieProductsSync
     * @request POST:/api/purchasing/integrations/dutchie/products/sync
     */
    integrationsDutchieProductsSync: (
      apiRequest: MainStemAPIPlatformControllersPurchasingIntegrationDutchieProductsSyncAPIRequest,
      params: RequestParams = {}
    ) =>
      this.request<MainStemAPIPlatformControllersPurchasingIntegrationDutchieProductsSyncAPIResponse, any>({
        path: `/api/purchasing/integrations/dutchie/products/sync`,
        method: 'POST',
        body: apiRequest,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags PurchasingIntegrationDutchiePurchaseOrdersDetails
     * @name IntegrationsDutchiePurchaseOrdersDetails
     * @request POST:/api/purchasing/integrations/dutchie/purchase-orders/details
     */
    integrationsDutchiePurchaseOrdersDetails: (
      apiRequest: MainStemAPIPlatformControllersPurchasingIntegrationDutchiePurchaseOrdersDetailsAPIRequest,
      params: RequestParams = {}
    ) =>
      this.request<MainStemAPIPlatformControllersPurchasingIntegrationDutchiePurchaseOrdersDetailsAPIResponse, any>({
        path: `/api/purchasing/integrations/dutchie/purchase-orders/details`,
        method: 'POST',
        body: apiRequest,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags PurchasingIntegrationDutchiePurchaseOrdersList
     * @name IntegrationsDutchiePurchaseOrdersList
     * @request POST:/api/purchasing/integrations/dutchie/purchase-orders/list
     */
    integrationsDutchiePurchaseOrdersList: (
      apiRequest: MainStemAPIPlatformControllersPurchasingIntegrationDutchiePurchaseOrdersListAPIRequest,
      params: RequestParams = {}
    ) =>
      this.request<MainStemAPIPlatformControllersPurchasingIntegrationDutchiePurchaseOrdersListAPIResponse, any>({
        path: `/api/purchasing/integrations/dutchie/purchase-orders/list`,
        method: 'POST',
        body: apiRequest,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags PurchasingIntegrationDutchiePurchaseOrdersSync
     * @name IntegrationsDutchiePurchaseOrdersSync
     * @request POST:/api/purchasing/integrations/dutchie/purchase-orders/sync
     */
    integrationsDutchiePurchaseOrdersSync: (
      apiRequest: MainStemAPIPlatformControllersPurchasingIntegrationDutchiePurchaseOrdersSyncAPIRequest,
      params: RequestParams = {}
    ) =>
      this.request<MainStemAPIPlatformControllersPurchasingIntegrationDutchiePurchaseOrdersSyncAPIResponse, any>({
        path: `/api/purchasing/integrations/dutchie/purchase-orders/sync`,
        method: 'POST',
        body: apiRequest,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags PurchasingIntegrationDutchieReceivedInventoryDetails
     * @name IntegrationsDutchieReceivedInventoryDetails
     * @request POST:/api/purchasing/integrations/dutchie/received-inventory/details
     */
    integrationsDutchieReceivedInventoryDetails: (
      apiRequest: MainStemAPIPlatformControllersPurchasingIntegrationDutchieReceivedInventoryDetailsAPIRequest,
      params: RequestParams = {}
    ) =>
      this.request<MainStemAPIPlatformControllersPurchasingIntegrationDutchieReceivedInventoryDetailsAPIResponse, any>({
        path: `/api/purchasing/integrations/dutchie/received-inventory/details`,
        method: 'POST',
        body: apiRequest,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags PurchasingIntegrationDutchieReceivedInventoryList
     * @name IntegrationsDutchieReceivedInventoryList
     * @request POST:/api/purchasing/integrations/dutchie/received-inventory/list
     */
    integrationsDutchieReceivedInventoryList: (
      apiRequest: MainStemAPIPlatformControllersPurchasingIntegrationDutchieReceivedInventoryListAPIRequest,
      params: RequestParams = {}
    ) =>
      this.request<MainStemAPIPlatformControllersPurchasingIntegrationDutchieReceivedInventoryListAPIResponse, any>({
        path: `/api/purchasing/integrations/dutchie/received-inventory/list`,
        method: 'POST',
        body: apiRequest,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags PurchasingIntegrationDutchieReceivedInventorySync
     * @name IntegrationsDutchieReceivedInventorySync
     * @request POST:/api/purchasing/integrations/dutchie/received-inventory/sync
     */
    integrationsDutchieReceivedInventorySync: (
      apiRequest: MainStemAPIPlatformControllersPurchasingIntegrationDutchieReceivedInventorySyncAPIRequest,
      params: RequestParams = {}
    ) =>
      this.request<MainStemAPIPlatformControllersPurchasingIntegrationDutchieReceivedInventorySyncAPIResponse, any>({
        path: `/api/purchasing/integrations/dutchie/received-inventory/sync`,
        method: 'POST',
        body: apiRequest,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags PurchasingIntegrationDutchieReportingInventoryDetails
     * @name IntegrationsDutchieReportingInventoryDetails
     * @request POST:/api/purchasing/integrations/dutchie/reporting-inventory/details
     */
    integrationsDutchieReportingInventoryDetails: (
      apiRequest: MainStemAPIPlatformControllersPurchasingIntegrationDutchieReportingInventoryDetailsAPIRequest,
      params: RequestParams = {}
    ) =>
      this.request<MainStemAPIPlatformControllersPurchasingIntegrationDutchieReportingInventoryDetailsAPIResponse, any>(
        {
          path: `/api/purchasing/integrations/dutchie/reporting-inventory/details`,
          method: 'POST',
          body: apiRequest,
          type: ContentType.Json,
          format: 'json',
          ...params
        }
      ),

    /**
     * No description
     *
     * @tags PurchasingIntegrationDutchieReportingInventoryList
     * @name IntegrationsDutchieReportingInventoryList
     * @request POST:/api/purchasing/integrations/dutchie/reporting-inventory/list
     */
    integrationsDutchieReportingInventoryList: (
      apiRequest: MainStemAPIPlatformControllersPurchasingIntegrationDutchieReportingInventoryListAPIRequest,
      params: RequestParams = {}
    ) =>
      this.request<MainStemAPIPlatformControllersPurchasingIntegrationDutchieReportingInventoryListAPIResponse, any>({
        path: `/api/purchasing/integrations/dutchie/reporting-inventory/list`,
        method: 'POST',
        body: apiRequest,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags PurchasingIntegrationDutchieReportingInventorySync
     * @name IntegrationsDutchieReportingInventorySync
     * @request POST:/api/purchasing/integrations/dutchie/reporting-inventory/sync
     */
    integrationsDutchieReportingInventorySync: (
      apiRequest: MainStemAPIPlatformControllersPurchasingIntegrationDutchieReportingInventorySyncAPIRequest,
      params: RequestParams = {}
    ) =>
      this.request<MainStemAPIPlatformControllersPurchasingIntegrationDutchieReportingInventorySyncAPIResponse, any>({
        path: `/api/purchasing/integrations/dutchie/reporting-inventory/sync`,
        method: 'POST',
        body: apiRequest,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags PurchasingIntegrationDutchieReportingProductsDetails
     * @name IntegrationsDutchieReportingProductsDetails
     * @request POST:/api/purchasing/integrations/dutchie/reporting-products/details
     */
    integrationsDutchieReportingProductsDetails: (
      apiRequest: MainStemAPIPlatformControllersPurchasingIntegrationDutchieReportingProductsDetailsAPIRequest,
      params: RequestParams = {}
    ) =>
      this.request<MainStemAPIPlatformControllersPurchasingIntegrationDutchieReportingProductsDetailsAPIResponse, any>({
        path: `/api/purchasing/integrations/dutchie/reporting-products/details`,
        method: 'POST',
        body: apiRequest,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags PurchasingIntegrationDutchieReportingProductsList
     * @name IntegrationsDutchieReportingProductsList
     * @request POST:/api/purchasing/integrations/dutchie/reporting-products/list
     */
    integrationsDutchieReportingProductsList: (
      apiRequest: MainStemAPIPlatformControllersPurchasingIntegrationDutchieReportingProductsListAPIRequest,
      params: RequestParams = {}
    ) =>
      this.request<MainStemAPIPlatformControllersPurchasingIntegrationDutchieReportingProductsListAPIResponse, any>({
        path: `/api/purchasing/integrations/dutchie/reporting-products/list`,
        method: 'POST',
        body: apiRequest,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags PurchasingIntegrationDutchieReportingProductsSync
     * @name IntegrationsDutchieReportingProductsSync
     * @request POST:/api/purchasing/integrations/dutchie/reporting-products/sync
     */
    integrationsDutchieReportingProductsSync: (
      apiRequest: MainStemAPIPlatformControllersPurchasingIntegrationDutchieReportingProductsSyncAPIRequest,
      params: RequestParams = {}
    ) =>
      this.request<MainStemAPIPlatformControllersPurchasingIntegrationDutchieReportingProductsSyncAPIResponse, any>({
        path: `/api/purchasing/integrations/dutchie/reporting-products/sync`,
        method: 'POST',
        body: apiRequest,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags PurchasingIntegrationDutchieRoomsDetails
     * @name IntegrationsDutchieRoomsDetails
     * @request POST:/api/purchasing/integrations/dutchie/rooms/details
     */
    integrationsDutchieRoomsDetails: (
      apiRequest: MainStemAPIPlatformControllersPurchasingIntegrationDutchieRoomsDetailsAPIRequest,
      params: RequestParams = {}
    ) =>
      this.request<MainStemAPIPlatformControllersPurchasingIntegrationDutchieRoomsDetailsAPIResponse, any>({
        path: `/api/purchasing/integrations/dutchie/rooms/details`,
        method: 'POST',
        body: apiRequest,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags PurchasingIntegrationDutchieRoomsList
     * @name IntegrationsDutchieRoomsList
     * @request POST:/api/purchasing/integrations/dutchie/rooms/list
     */
    integrationsDutchieRoomsList: (
      apiRequest: MainStemAPIPlatformControllersPurchasingIntegrationDutchieRoomsListAPIRequest,
      params: RequestParams = {}
    ) =>
      this.request<MainStemAPIPlatformControllersPurchasingIntegrationDutchieRoomsListAPIResponse, any>({
        path: `/api/purchasing/integrations/dutchie/rooms/list`,
        method: 'POST',
        body: apiRequest,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags PurchasingIntegrationDutchieRoomsSync
     * @name IntegrationsDutchieRoomsSync
     * @request POST:/api/purchasing/integrations/dutchie/rooms/sync
     */
    integrationsDutchieRoomsSync: (
      apiRequest: MainStemAPIPlatformControllersPurchasingIntegrationDutchieRoomsSyncAPIRequest,
      params: RequestParams = {}
    ) =>
      this.request<MainStemAPIPlatformControllersPurchasingIntegrationDutchieRoomsSyncAPIResponse, any>({
        path: `/api/purchasing/integrations/dutchie/rooms/sync`,
        method: 'POST',
        body: apiRequest,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags PurchasingIntegrationDutchieSuppliersLinked
     * @name IntegrationsDutchieSuppliersLinked
     * @request POST:/api/purchasing/integrations/dutchie/suppliers/linked
     */
    integrationsDutchieSuppliersLinked: (
      apiRequest: MainStemAPIPlatformControllersPurchasingIntegrationDutchieSuppliersLinkedAPIRequest,
      params: RequestParams = {}
    ) =>
      this.request<MainStemAPIPlatformControllersPurchasingIntegrationDutchieSuppliersLinkedAPIResponse, any>({
        path: `/api/purchasing/integrations/dutchie/suppliers/linked`,
        method: 'POST',
        body: apiRequest,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags PurchasingIntegrationDutchieSyncRunsList
     * @name IntegrationsDutchieSyncRunsList
     * @request POST:/api/purchasing/integrations/dutchie/sync-runs/list
     */
    integrationsDutchieSyncRunsList: (
      apiRequest: MainStemAPIPlatformControllersPurchasingIntegrationDutchieSyncRunsListAPIRequest,
      params: RequestParams = {}
    ) =>
      this.request<MainStemAPIPlatformControllersPurchasingIntegrationDutchieSyncRunsListAPIResponse, any>({
        path: `/api/purchasing/integrations/dutchie/sync-runs/list`,
        method: 'POST',
        body: apiRequest,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags PurchasingIntegrationDutchieTransactionsDetails
     * @name IntegrationsDutchieTransactionsDetails
     * @request POST:/api/purchasing/integrations/dutchie/transactions/details
     */
    integrationsDutchieTransactionsDetails: (
      apiRequest: MainStemAPIPlatformControllersPurchasingIntegrationDutchieTransactionsDetailsAPIRequest,
      params: RequestParams = {}
    ) =>
      this.request<MainStemAPIPlatformControllersPurchasingIntegrationDutchieTransactionsDetailsAPIResponse, any>({
        path: `/api/purchasing/integrations/dutchie/transactions/details`,
        method: 'POST',
        body: apiRequest,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags PurchasingIntegrationDutchieTransactionsList
     * @name IntegrationsDutchieTransactionsList
     * @request POST:/api/purchasing/integrations/dutchie/transactions/list
     */
    integrationsDutchieTransactionsList: (
      apiRequest: MainStemAPIPlatformControllersPurchasingIntegrationDutchieTransactionsListAPIRequest,
      params: RequestParams = {}
    ) =>
      this.request<MainStemAPIPlatformControllersPurchasingIntegrationDutchieTransactionsListAPIResponse, any>({
        path: `/api/purchasing/integrations/dutchie/transactions/list`,
        method: 'POST',
        body: apiRequest,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags PurchasingIntegrationDutchieTransactionsReport
     * @name IntegrationsDutchieTransactionsReport
     * @request POST:/api/purchasing/integrations/dutchie/transactions/report
     */
    integrationsDutchieTransactionsReport: (
      apiRequest: MainStemAPIPlatformControllersPurchasingIntegrationDutchieTransactionsReportAPIRequest,
      params: RequestParams = {}
    ) =>
      this.request<MainStemAPIPlatformControllersPurchasingIntegrationDutchieTransactionsReportAPIResponse, any>({
        path: `/api/purchasing/integrations/dutchie/transactions/report`,
        method: 'POST',
        body: apiRequest,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags PurchasingIntegrationDutchieTransactionsSync
     * @name IntegrationsDutchieTransactionsSync
     * @request POST:/api/purchasing/integrations/dutchie/transactions/sync
     */
    integrationsDutchieTransactionsSync: (
      apiRequest: MainStemAPIPlatformControllersPurchasingIntegrationDutchieTransactionsSyncAPIRequest,
      params: RequestParams = {}
    ) =>
      this.request<MainStemAPIPlatformControllersPurchasingIntegrationDutchieTransactionsSyncAPIResponse, any>({
        path: `/api/purchasing/integrations/dutchie/transactions/sync`,
        method: 'POST',
        body: apiRequest,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags PurchasingIntegrationDutchieUnitsList
     * @name IntegrationsDutchieUnitsList
     * @request POST:/api/purchasing/integrations/dutchie/units/list
     */
    integrationsDutchieUnitsList: (
      apiRequest: MainStemAPIPlatformControllersPurchasingIntegrationDutchieUnitsListAPIRequest,
      params: RequestParams = {}
    ) =>
      this.request<MainStemAPIPlatformControllersPurchasingIntegrationDutchieUnitsListAPIResponse, any>({
        path: `/api/purchasing/integrations/dutchie/units/list`,
        method: 'POST',
        body: apiRequest,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags PurchasingIntegrationDutchieUnitsSync
     * @name IntegrationsDutchieUnitsSync
     * @request POST:/api/purchasing/integrations/dutchie/units/sync
     */
    integrationsDutchieUnitsSync: (
      apiRequest: MainStemAPIPlatformControllersPurchasingIntegrationDutchieUnitsSyncAPIRequest,
      params: RequestParams = {}
    ) =>
      this.request<MainStemAPIPlatformControllersPurchasingIntegrationDutchieUnitsSyncAPIResponse, any>({
        path: `/api/purchasing/integrations/dutchie/units/sync`,
        method: 'POST',
        body: apiRequest,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags PurchasingIntegrationDutchieUnitTypesList
     * @name IntegrationsDutchieUnitTypesList
     * @request POST:/api/purchasing/integrations/dutchie/unit-types/list
     */
    integrationsDutchieUnitTypesList: (
      apiRequest: MainStemAPIPlatformControllersPurchasingIntegrationDutchieUnitTypesListAPIRequest,
      params: RequestParams = {}
    ) =>
      this.request<MainStemAPIPlatformControllersPurchasingIntegrationDutchieUnitTypesListAPIResponse, any>({
        path: `/api/purchasing/integrations/dutchie/unit-types/list`,
        method: 'POST',
        body: apiRequest,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags PurchasingIntegrationDutchieUnitTypesSync
     * @name IntegrationsDutchieUnitTypesSync
     * @request POST:/api/purchasing/integrations/dutchie/unit-types/sync
     */
    integrationsDutchieUnitTypesSync: (
      apiRequest: MainStemAPIPlatformControllersPurchasingIntegrationDutchieUnitTypesSyncAPIRequest,
      params: RequestParams = {}
    ) =>
      this.request<MainStemAPIPlatformControllersPurchasingIntegrationDutchieUnitTypesSyncAPIResponse, any>({
        path: `/api/purchasing/integrations/dutchie/unit-types/sync`,
        method: 'POST',
        body: apiRequest,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags PurchasingIntegrationDutchieVendorsDetails
     * @name IntegrationsDutchieVendorsDetails
     * @request POST:/api/purchasing/integrations/dutchie/vendors/details
     */
    integrationsDutchieVendorsDetails: (
      apiRequest: MainStemAPIPlatformControllersPurchasingIntegrationDutchieVendorsDetailsAPIRequest,
      params: RequestParams = {}
    ) =>
      this.request<MainStemAPIPlatformControllersPurchasingIntegrationDutchieVendorsDetailsAPIResponse, any>({
        path: `/api/purchasing/integrations/dutchie/vendors/details`,
        method: 'POST',
        body: apiRequest,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags PurchasingIntegrationDutchieVendorsList
     * @name IntegrationsDutchieVendorsList
     * @request POST:/api/purchasing/integrations/dutchie/vendors/list
     */
    integrationsDutchieVendorsList: (
      apiRequest: MainStemAPIPlatformControllersPurchasingIntegrationDutchieVendorsListAPIRequest,
      params: RequestParams = {}
    ) =>
      this.request<MainStemAPIPlatformControllersPurchasingIntegrationDutchieVendorsListAPIResponse, any>({
        path: `/api/purchasing/integrations/dutchie/vendors/list`,
        method: 'POST',
        body: apiRequest,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags PurchasingIntegrationDutchieVendorsSync
     * @name IntegrationsDutchieVendorsSync
     * @request POST:/api/purchasing/integrations/dutchie/vendors/sync
     */
    integrationsDutchieVendorsSync: (
      apiRequest: MainStemAPIPlatformControllersPurchasingIntegrationDutchieVendorsSyncAPIRequest,
      params: RequestParams = {}
    ) =>
      this.request<MainStemAPIPlatformControllersPurchasingIntegrationDutchieVendorsSyncAPIResponse, any>({
        path: `/api/purchasing/integrations/dutchie/vendors/sync`,
        method: 'POST',
        body: apiRequest,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags PurchasingIntegrationDutchieWhoAmI
     * @name IntegrationsDutchieWhoami
     * @request POST:/api/purchasing/integrations/dutchie/whoami
     */
    integrationsDutchieWhoami: (
      apiRequest: MainStemAPIPlatformControllersPurchasingIntegrationDutchieWhoAmIAPIRequest,
      params: RequestParams = {}
    ) =>
      this.request<MainStemAPIPlatformControllersPurchasingIntegrationDutchieWhoAmIAPIResponse, any>({
        path: `/api/purchasing/integrations/dutchie/whoami`,
        method: 'POST',
        body: apiRequest,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags PurchasingIntegrationDynamicsCompanyList
     * @name IntegrationsDynamicsCompanyList
     * @request POST:/api/purchasing/integrations/dynamics/company/list
     */
    integrationsDynamicsCompanyList: (
      APIRequest: MainStemAPIPlatformControllersPurchasingIntegrationDynamicsCompanyListAPIRequest,
      params: RequestParams = {}
    ) =>
      this.request<MainStemAPIPlatformControllersPurchasingIntegrationDynamicsCompanyListAPIResponse, any>({
        path: `/api/purchasing/integrations/dynamics/company/list`,
        method: 'POST',
        body: APIRequest,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags PurchasingIntegrationDynamicsInvoiceCreate
     * @name IntegrationsDynamicsInvoiceCreate
     * @request POST:/api/purchasing/integrations/dynamics/invoice/create
     */
    integrationsDynamicsInvoiceCreate: (
      apiRequest: MainStemAPIPlatformControllersPurchasingIntegrationDynamicsInvoiceCreateAPIRequest,
      params: RequestParams = {}
    ) =>
      this.request<MainStemAPIPlatformControllersPurchasingIntegrationDynamicsInvoiceCreateAPIResponse, any>({
        path: `/api/purchasing/integrations/dynamics/invoice/create`,
        method: 'POST',
        body: apiRequest,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags PurchasingIntegrationDynamicsMainAccountList
     * @name IntegrationsDynamicsMainAccountList
     * @request POST:/api/purchasing/integrations/dynamics/main-account/list
     */
    integrationsDynamicsMainAccountList: (
      APIRequest: MainStemAPIPlatformControllersPurchasingIntegrationDynamicsMainAccountListAPIRequest,
      params: RequestParams = {}
    ) =>
      this.request<MainStemAPIPlatformControllersPurchasingIntegrationDynamicsMainAccountListAPIResponse, any>({
        path: `/api/purchasing/integrations/dynamics/main-account/list`,
        method: 'POST',
        body: APIRequest,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags PurchasingIntegrationDynamicsProcurementProductCategoryList
     * @name IntegrationsDynamicsProcurementProductCategoryList
     * @request POST:/api/purchasing/integrations/dynamics/procurement-product-category/list
     */
    integrationsDynamicsProcurementProductCategoryList: (
      APIRequest: MainStemAPIPlatformControllersPurchasingIntegrationDynamicsProcurementProductCategoryListAPIRequest,
      params: RequestParams = {}
    ) =>
      this.request<
        MainStemAPIPlatformControllersPurchasingIntegrationDynamicsProcurementProductCategoryListAPIResponse,
        any
      >({
        path: `/api/purchasing/integrations/dynamics/procurement-product-category/list`,
        method: 'POST',
        body: APIRequest,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags PurchasingIntegrationDynamicsVendorGroupList
     * @name IntegrationsDynamicsVendorGroupList
     * @request POST:/api/purchasing/integrations/dynamics/vendor/group/list
     */
    integrationsDynamicsVendorGroupList: (
      APIRequest: MainStemAPIPlatformControllersPurchasingIntegrationDynamicsVendorGroupListAPIRequest,
      params: RequestParams = {}
    ) =>
      this.request<MainStemAPIPlatformControllersPurchasingIntegrationDynamicsVendorGroupListAPIResponse, any>({
        path: `/api/purchasing/integrations/dynamics/vendor/group/list`,
        method: 'POST',
        body: APIRequest,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags PurchasingIntegrationDynamicsVendorList
     * @name IntegrationsDynamicsVendorList
     * @request POST:/api/purchasing/integrations/dynamics/vendor/list
     */
    integrationsDynamicsVendorList: (
      APIRequest: MainStemAPIPlatformControllersPurchasingIntegrationDynamicsVendorListAPIRequest,
      params: RequestParams = {}
    ) =>
      this.request<MainStemAPIPlatformControllersPurchasingIntegrationDynamicsVendorListAPIResponse, any>({
        path: `/api/purchasing/integrations/dynamics/vendor/list`,
        method: 'POST',
        body: APIRequest,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags PurchasingIntegrationDynamicsVendorSync
     * @name IntegrationsDynamicsVendorSync
     * @request POST:/api/purchasing/integrations/dynamics/vendor/sync
     */
    integrationsDynamicsVendorSync: (
      APIRequest: MainStemAPIPlatformControllersPurchasingIntegrationDynamicsVendorSyncAPIRequest,
      params: RequestParams = {}
    ) =>
      this.request<MainStemAPIPlatformControllersPurchasingIntegrationDynamicsVendorSyncAPIResponse, any>({
        path: `/api/purchasing/integrations/dynamics/vendor/sync`,
        method: 'POST',
        body: APIRequest,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags PurchasingIntegrationExcelRequest
     * @name IntegrationExcelRequest
     * @request POST:/api/purchasing/integration/excel/request
     */
    integrationExcelRequest: (params: RequestParams = {}) =>
      this.request<MainStemAPIPlatformControllersPurchasingIntegrationExcelRequestAPIResponse, any>({
        path: `/api/purchasing/integration/excel/request`,
        method: 'POST',
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags PurchasingIntegrationInvoicesList
     * @name IntegrationsInvoicesList
     * @request POST:/api/purchasing/integrations/invoices/list
     */
    integrationsInvoicesList: (
      APIRequest: MainStemAPIPlatformControllersPurchasingIntegrationInvoicesListAPIRequest,
      params: RequestParams = {}
    ) =>
      this.request<MainStemAPIPlatformControllersPurchasingIntegrationInvoicesListAPIResponse, any>({
        path: `/api/purchasing/integrations/invoices/list`,
        method: 'POST',
        body: APIRequest,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags PurchasingIntegrationMetrcFacilitiesList
     * @name IntegrationsMetrcFacilitiesList
     * @request POST:/api/purchasing/integrations/metrc/facilities/list
     */
    integrationsMetrcFacilitiesList: (
      apiRequest: MainStemAPIPlatformControllersPurchasingIntegrationMetrcFacilitiesListAPIRequest,
      params: RequestParams = {}
    ) =>
      this.request<MainStemAPIPlatformControllersPurchasingIntegrationMetrcFacilitiesListAPIResponse, any>({
        path: `/api/purchasing/integrations/metrc/facilities/list`,
        method: 'POST',
        body: apiRequest,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags PurchasingIntegrationMetrcLicensed
     * @name IntegrationsMetrcTransfersIncomingList
     * @request POST:/api/purchasing/integrations/metrc/transfers/incoming/list
     */
    integrationsMetrcTransfersIncomingList: (
      apiRequest: MainStemAPIPlatformControllersPurchasingIntegrationMetrcLicensedAPIRequest,
      params: RequestParams = {}
    ) =>
      this.request<MainStemAPIPlatformControllersPurchasingIntegrationMetrcLicensedTransfersAPIResponse, any>({
        path: `/api/purchasing/integrations/metrc/transfers/incoming/list`,
        method: 'POST',
        body: apiRequest,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags PurchasingIntegrationMetrcLicensed
     * @name IntegrationsMetrcSalesReceiptsActiveList
     * @request POST:/api/purchasing/integrations/metrc/sales/receipts/active/list
     */
    integrationsMetrcSalesReceiptsActiveList: (
      apiRequest: MainStemAPIPlatformControllersPurchasingIntegrationMetrcLicensedAPIRequest,
      params: RequestParams = {}
    ) =>
      this.request<MainStemAPIPlatformControllersPurchasingIntegrationMetrcLicensedReceiptsAPIResponse, any>({
        path: `/api/purchasing/integrations/metrc/sales/receipts/active/list`,
        method: 'POST',
        body: apiRequest,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags PurchasingIntegrationMetrcLicensed
     * @name IntegrationsMetrcLocationsActiveList
     * @request POST:/api/purchasing/integrations/metrc/locations/active/list
     */
    integrationsMetrcLocationsActiveList: (
      apiRequest: MainStemAPIPlatformControllersPurchasingIntegrationMetrcLicensedAPIRequest,
      params: RequestParams = {}
    ) =>
      this.request<MainStemAPIPlatformControllersPurchasingIntegrationMetrcLicensedLocationsAPIResponse, any>({
        path: `/api/purchasing/integrations/metrc/locations/active/list`,
        method: 'POST',
        body: apiRequest,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags PurchasingIntegrationMetrcLicensed
     * @name IntegrationsMetrcEmployeesList
     * @request POST:/api/purchasing/integrations/metrc/employees/list
     */
    integrationsMetrcEmployeesList: (
      apiRequest: MainStemAPIPlatformControllersPurchasingIntegrationMetrcLicensedAPIRequest,
      params: RequestParams = {}
    ) =>
      this.request<MainStemAPIPlatformControllersPurchasingIntegrationMetrcLicensedEmployeesAPIResponse, any>({
        path: `/api/purchasing/integrations/metrc/employees/list`,
        method: 'POST',
        body: apiRequest,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags PurchasingIntegrationParagonGetToken
     * @name IntegrationsParagonGetToken
     * @request POST:/api/purchasing/integrations/paragon/get-token
     */
    integrationsParagonGetToken: (
      apiRequest: MainStemAPIPlatformControllersPurchasingIntegrationParagonGetTokenAPIRequest,
      params: RequestParams = {}
    ) =>
      this.request<MainStemAPIPlatformControllersPurchasingIntegrationParagonGetTokenAPIResponse, any>({
        path: `/api/purchasing/integrations/paragon/get-token`,
        method: 'POST',
        body: apiRequest,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags PurchasingIntegrationPowerBIDetails
     * @name IntegrationPowerBiDetails
     * @request POST:/api/purchasing/integration/power-bi/details
     */
    integrationPowerBiDetails: (params: RequestParams = {}) =>
      this.request<MainStemAPIPlatformControllersPurchasingIntegrationPowerBIDetailsAPIResponse, any>({
        path: `/api/purchasing/integration/power-bi/details`,
        method: 'POST',
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags PurchasingIntegrationPowerBIRequest
     * @name IntegrationPowerBiRequest
     * @request POST:/api/purchasing/integration/power-bi/request
     */
    integrationPowerBiRequest: (params: RequestParams = {}) =>
      this.request<MainStemAPIPlatformControllersPurchasingIntegrationPowerBIRequestAPIResponse, any>({
        path: `/api/purchasing/integration/power-bi/request`,
        method: 'POST',
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags PurchasingIntegrationQuantumLeafAllItems
     * @name IntegrationsQuantumLeafAllItems
     * @request POST:/api/purchasing/integrations/quantum-leaf/all-items
     */
    integrationsQuantumLeafAllItems: (
      apiRequest: MainStemAPIPlatformControllersPurchasingIntegrationQuantumLeafAllItemsAPIRequest,
      params: RequestParams = {}
    ) =>
      this.request<MainStemAPIPlatformControllersPurchasingIntegrationQuantumLeafAllItemsAPIResponse, any>({
        path: `/api/purchasing/integrations/quantum-leaf/all-items`,
        method: 'POST',
        body: apiRequest,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags PurchasingIntegrationQuantumLeafIntegrationSettingsLogs
     * @name IntegrationsQuantumLeafLogs
     * @request POST:/api/purchasing/integrations/quantum-leaf/logs
     */
    integrationsQuantumLeafLogs: (
      apiRequest: MainStemAPIPlatformControllersPurchasingIntegrationQuantumLeafIntegrationLogsAPIRequest,
      params: RequestParams = {}
    ) =>
      this.request<MainStemAPIPlatformControllersPurchasingIntegrationQuantumLeafIntegrationLogsAPIResponse, any>({
        path: `/api/purchasing/integrations/quantum-leaf/logs`,
        method: 'POST',
        body: apiRequest,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags PurchasingIntegrationQuantumLeafLinkLocationProduct
     * @name IntegrationsQuantumLeafLinkLocationProduct
     * @request POST:/api/purchasing/integrations/quantum-leaf/link-location-product
     */
    integrationsQuantumLeafLinkLocationProduct: (
      apiRequest: MainStemAPIPlatformControllersPurchasingIntegrationQuantumLeafLinkLocationProductAPIRequest,
      params: RequestParams = {}
    ) =>
      this.request<MainStemSDKModelsBaseResponse, any>({
        path: `/api/purchasing/integrations/quantum-leaf/link-location-product`,
        method: 'POST',
        body: apiRequest,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags PurchasingIntegrationQuantumLeafLinkProduct
     * @name IntegrationsQuantumLeafLinkProduct
     * @request POST:/api/purchasing/integrations/quantum-leaf/link-product
     */
    integrationsQuantumLeafLinkProduct: (
      apiRequest: MainStemAPIPlatformControllersPurchasingIntegrationQuantumLeafLinkProductAPIRequest,
      params: RequestParams = {}
    ) =>
      this.request<MainStemSDKModelsBaseResponse, any>({
        path: `/api/purchasing/integrations/quantum-leaf/link-product`,
        method: 'POST',
        body: apiRequest,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags PurchasingIntegrationQuantumLeafLinkSupplier
     * @name IntegrationsQuantumLeafLinkSupplier
     * @request POST:/api/purchasing/integrations/quantum-leaf/link-supplier
     */
    integrationsQuantumLeafLinkSupplier: (
      apiRequest: MainStemAPIPlatformControllersPurchasingIntegrationQuantumLeafLinkSupplierAPIRequest,
      params: RequestParams = {}
    ) =>
      this.request<MainStemSDKModelsBaseResponse, any>({
        path: `/api/purchasing/integrations/quantum-leaf/link-supplier`,
        method: 'POST',
        body: apiRequest,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags PurchasingIntegrationQuantumLeafNonStockItems
     * @name IntegrationsQuantumLeafNonStockItems
     * @request POST:/api/purchasing/integrations/quantum-leaf/non-stock-items
     */
    integrationsQuantumLeafNonStockItems: (
      apiRequest: MainStemAPIPlatformControllersPurchasingIntegrationQuantumLeafNonStockItemsAPIRequest,
      params: RequestParams = {}
    ) =>
      this.request<MainStemAPIPlatformControllersPurchasingIntegrationQuantumLeafNonStockItemsAPIResponse, any>({
        path: `/api/purchasing/integrations/quantum-leaf/non-stock-items`,
        method: 'POST',
        body: apiRequest,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags PurchasingIntegrationQuantumLeafOrders
     * @name IntegrationsQuantumLeafOrders
     * @request POST:/api/purchasing/integrations/quantum-leaf/orders
     */
    integrationsQuantumLeafOrders: (
      apiRequest: MainStemAPIPlatformControllersPurchasingIntegrationQuantumLeafOrdersAPIRequest,
      params: RequestParams = {}
    ) =>
      this.request<MainStemAPIPlatformControllersPurchasingIntegrationQuantumLeafOrdersAPIResponse, any>({
        path: `/api/purchasing/integrations/quantum-leaf/orders`,
        method: 'POST',
        body: apiRequest,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags PurchasingIntegrationQuantumLeafProducts
     * @name IntegrationsQuantumLeafProducts
     * @request POST:/api/purchasing/integrations/quantum-leaf/products
     */
    integrationsQuantumLeafProducts: (
      apiRequest: MainStemAPIPlatformControllersPurchasingIntegrationQuantumLeafProductsAPIRequest,
      params: RequestParams = {}
    ) =>
      this.request<MainStemAPIPlatformControllersPurchasingIntegrationQuantumLeafProductsAPIResponse, any>({
        path: `/api/purchasing/integrations/quantum-leaf/products`,
        method: 'POST',
        body: apiRequest,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags PurchasingIntegrationQuantumLeafVendorProducts
     * @name IntegrationsQuantumLeafVendorProducts
     * @request POST:/api/purchasing/integrations/quantum-leaf/vendor-products
     */
    integrationsQuantumLeafVendorProducts: (
      apiRequest: MainStemAPIPlatformControllersPurchasingIntegrationQuantumLeafVendorProductsAPIRequest,
      params: RequestParams = {}
    ) =>
      this.request<MainStemAPIPlatformControllersPurchasingIntegrationQuantumLeafVendorProductsAPIResponse, any>({
        path: `/api/purchasing/integrations/quantum-leaf/vendor-products`,
        method: 'POST',
        body: apiRequest,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags PurchasingIntegrationQuantumLeafVendors
     * @name IntegrationsQuantumLeafVendors
     * @request POST:/api/purchasing/integrations/quantum-leaf/vendors
     */
    integrationsQuantumLeafVendors: (
      apiRequest: MainStemAPIPlatformControllersPurchasingIntegrationQuantumLeafVendorsAPIRequest,
      params: RequestParams = {}
    ) =>
      this.request<MainStemAPIPlatformControllersPurchasingIntegrationQuantumLeafVendorsAPIResponse, any>({
        path: `/api/purchasing/integrations/quantum-leaf/vendors`,
        method: 'POST',
        body: apiRequest,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags PurchasingIntegrationQuantumLeafVendorSuppliers
     * @name IntegrationsQuantumLeafVendorSuppliers
     * @request POST:/api/purchasing/integrations/quantum-leaf/vendor-suppliers
     */
    integrationsQuantumLeafVendorSuppliers: (
      apiRequest: MainStemAPIPlatformControllersPurchasingIntegrationQuantumLeafVendorSuppliersAPIRequest,
      params: RequestParams = {}
    ) =>
      this.request<MainStemAPIPlatformControllersPurchasingIntegrationQuantumLeafVendorSuppliersAPIResponse, any>({
        path: `/api/purchasing/integrations/quantum-leaf/vendor-suppliers`,
        method: 'POST',
        body: apiRequest,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags PurchasingIntegrationQuantumLeafWarehouses
     * @name IntegrationsQuantumLeafWarehouses
     * @request POST:/api/purchasing/integrations/quantum-leaf/warehouses
     */
    integrationsQuantumLeafWarehouses: (
      apiRequest: MainStemAPIPlatformControllersPurchasingIntegrationQuantumLeafWarehousesAPIRequest,
      params: RequestParams = {}
    ) =>
      this.request<MainStemAPIPlatformControllersPurchasingIntegrationQuantumLeafWarehousesAPIResponse, any>({
        path: `/api/purchasing/integrations/quantum-leaf/warehouses`,
        method: 'POST',
        body: apiRequest,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags PurchasingIntegrationQuickBooksIntegrationSettingsLogs
     * @name IntegrationsQuickbooksLogsIntegrationSettings
     * @request POST:/api/purchasing/integrations/quickbooks/logs/integrationSettings
     */
    integrationsQuickbooksLogsIntegrationSettings: (
      apiRequest: MainStemAPIPlatformControllersPurchasingIntegrationQuickBooksLoggerIntegrationLogsAPIRequest,
      params: RequestParams = {}
    ) =>
      this.request<MainStemAPIPlatformControllersPurchasingIntegrationQuickBooksLoggerIntegrationLogsAPIResponse, any>({
        path: `/api/purchasing/integrations/quickbooks/logs/integrationSettings`,
        method: 'POST',
        body: apiRequest,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags PurchasingIntegrationQuickBooksLocationFinancialDimensionUpdate
     * @name IntegrationsQuickbooksLocationFinancialDimensionUpdate
     * @request POST:/api/purchasing/integrations/quickbooks/location/financial-dimension/update
     */
    integrationsQuickbooksLocationFinancialDimensionUpdate: (
      APIRequest: MainStemAPIPlatformControllersPurchasingIntegrationQuickBooksLocationFinancialDimensionUpdateAPIRequest,
      params: RequestParams = {}
    ) =>
      this.request<
        MainStemAPIPlatformControllersPurchasingIntegrationQuickBooksLocationFinancialDimensionUpdateAPIResponse,
        any
      >({
        path: `/api/purchasing/integrations/quickbooks/location/financial-dimension/update`,
        method: 'POST',
        body: APIRequest,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags PurchasingIntegrationQuickBooksLogs
     * @name IntegrationsQuickbooksLogs
     * @request POST:/api/purchasing/integrations/quickbooks/logs
     */
    integrationsQuickbooksLogs: (
      apiRequest: MainStemAPIPlatformControllersPurchasingIntegrationQuickBooksLogsAPIRequest,
      params: RequestParams = {}
    ) =>
      this.request<MainStemAPIPlatformControllersPurchasingIntegrationQuickBooksLogsAPIResponse, any>({
        path: `/api/purchasing/integrations/quickbooks/logs`,
        method: 'POST',
        body: apiRequest,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags PurchasingIntegrationQuickBooksOrderLogs
     * @name IntegrationsQuickbooksLogsOrder
     * @request POST:/api/purchasing/integrations/quickbooks/logs/order
     */
    integrationsQuickbooksLogsOrder: (
      apiRequest: MainStemAPIPlatformControllersPurchasingIntegrationQuickBooksLoggerOrderLogsAPIRequest,
      params: RequestParams = {}
    ) =>
      this.request<MainStemAPIPlatformControllersPurchasingIntegrationQuickBooksLoggerOrderLogsAPIResponse, any>({
        path: `/api/purchasing/integrations/quickbooks/logs/order`,
        method: 'POST',
        body: apiRequest,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags PurchasingIntegrationQuickBooksOrders
     * @name IntegrationsQuickbooksOrders
     * @request POST:/api/purchasing/integrations/quickbooks/orders
     */
    integrationsQuickbooksOrders: (
      apiRequest: MainStemAPIPlatformControllersPurchasingIntegrationQuickBooksOrdersAPIRequest,
      params: RequestParams = {}
    ) =>
      this.request<MainStemAPIPlatformControllersPurchasingIntegrationQuickBooksOrdersAPIResponse, any>({
        path: `/api/purchasing/integrations/quickbooks/orders`,
        method: 'POST',
        body: apiRequest,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags PurchasingIntegrationQuickBooksProductTypes
     * @name IntegrationsQuickbooksProductTypes
     * @request POST:/api/purchasing/integrations/quickbooks/productTypes
     */
    integrationsQuickbooksProductTypes: (
      apiRequest: MainStemAPIPlatformControllersPurchasingIntegrationQuickBooksProductTypesAPIRequest,
      params: RequestParams = {}
    ) =>
      this.request<MainStemAPIPlatformControllersPurchasingIntegrationQuickBooksProductTypesAPIResponse, any>({
        path: `/api/purchasing/integrations/quickbooks/productTypes`,
        method: 'POST',
        body: apiRequest,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags PurchasingIntegrationSettingsCreate
     * @name IntegrationsSettingsCreate
     * @request POST:/api/purchasing/integrations/settings/create
     */
    integrationsSettingsCreate: (
      apiRequest: MainStemAPIPlatformControllersPurchasingIntegrationSettingsCreateAPIRequest,
      params: RequestParams = {}
    ) =>
      this.request<MainStemAPIPlatformControllersPurchasingIntegrationSettingsCreateAPIResponse, any>({
        path: `/api/purchasing/integrations/settings/create`,
        method: 'POST',
        body: apiRequest,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags PurchasingIntegrationSettingsDetails
     * @name IntegrationsSettingsDetails
     * @request POST:/api/purchasing/integrations/settings/details
     */
    integrationsSettingsDetails: (
      apiRequest: MainStemAPIPlatformControllersPurchasingIntegrationSettingsDetailsAPIRequest,
      params: RequestParams = {}
    ) =>
      this.request<MainStemAPIPlatformControllersPurchasingIntegrationSettingsDetailsAPIResponse, any>({
        path: `/api/purchasing/integrations/settings/details`,
        method: 'POST',
        body: apiRequest,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags PurchasingIntegrationSettingsList
     * @name IntegrationsSettingsList
     * @request POST:/api/purchasing/integrations/settings/list
     */
    integrationsSettingsList: (
      apiRequest: MainStemAPIPlatformControllersPurchasingIntegrationSettingsListAPIRequest,
      params: RequestParams = {}
    ) =>
      this.request<MainStemAPIPlatformControllersPurchasingIntegrationSettingsListAPIResponse, any>({
        path: `/api/purchasing/integrations/settings/list`,
        method: 'POST',
        body: apiRequest,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags PurchasingIntegrationSettingsLocationsAdd
     * @name IntegrationsSettingsLocationsAdd
     * @request POST:/api/purchasing/integrations/settings/locations/add
     */
    integrationsSettingsLocationsAdd: (
      apiRequest: MainStemAPIPlatformControllersPurchasingIntegrationSettingsLocationsAddAPIRequest,
      params: RequestParams = {}
    ) =>
      this.request<MainStemAPIPlatformControllersPurchasingIntegrationSettingsLocationsAddAPIResponse, any>({
        path: `/api/purchasing/integrations/settings/locations/add`,
        method: 'POST',
        body: apiRequest,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags PurchasingIntegrationSettingsLocationsRemove
     * @name IntegrationsSettingsLocationsRemove
     * @request POST:/api/purchasing/integrations/settings/locations/remove
     */
    integrationsSettingsLocationsRemove: (
      apiRequest: MainStemAPIPlatformControllersPurchasingIntegrationSettingsLocationsRemoveAPIRequest,
      params: RequestParams = {}
    ) =>
      this.request<MainStemSDKModelsBaseResponse, any>({
        path: `/api/purchasing/integrations/settings/locations/remove`,
        method: 'POST',
        body: apiRequest,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags PurchasingIntegrationSettingsToggle
     * @name IntegrationsSettingsToggle
     * @request POST:/api/purchasing/integrations/settings/toggle
     */
    integrationsSettingsToggle: (
      apiRequest: MainStemAPIPlatformControllersPurchasingIntegrationSettingsToggleAPIRequest,
      params: RequestParams = {}
    ) =>
      this.request<MainStemSDKModelsBaseResponse, any>({
        path: `/api/purchasing/integrations/settings/toggle`,
        method: 'POST',
        body: apiRequest,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags PurchasingIntegrationSettingsUpdate
     * @name IntegrationsSettingsUpdate
     * @request POST:/api/purchasing/integrations/settings/update
     */
    integrationsSettingsUpdate: (
      apiRequest: MainStemAPIPlatformControllersPurchasingIntegrationSettingsUpdateAPIRequest,
      params: RequestParams = {}
    ) =>
      this.request<MainStemSDKModelsBaseResponse, any>({
        path: `/api/purchasing/integrations/settings/update`,
        method: 'POST',
        body: apiRequest,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags PurchasingIntegrationsLog
     * @name IntegrationsLog
     * @request POST:/api/purchasing/integrations/log
     */
    integrationsLog: (
      apiRequest: MainStemAPIPlatformControllersPurchasingIntegrationLogAPIRequest,
      params: RequestParams = {}
    ) =>
      this.request<MainStemAPIPlatformControllersPurchasingIntegrationLogAPIResponse, any>({
        path: `/api/purchasing/integrations/log`,
        method: 'POST',
        body: apiRequest,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags PurchasingIntegrationsQuantumLeafQueueOrder
     * @name OrdersDetailsIntegrationsQuantumLeafQueueOrder
     * @request POST:/api/purchasing/orders/details/integrations/quantum-leaf/queue-order
     */
    ordersDetailsIntegrationsQuantumLeafQueueOrder: (
      apiRequest: MainStemAPIPlatformControllersPurchasingOrdersDetailsIntegrationsQuantumLeafQueueOrderAPIRequest,
      params: RequestParams = {}
    ) =>
      this.request<MainStemSDKModelsBaseResponse, any>({
        path: `/api/purchasing/orders/details/integrations/quantum-leaf/queue-order`,
        method: 'POST',
        body: apiRequest,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags PurchasingIntegrationsQuickbooksCreateBill
     * @name OrdersDetailsIntegrationsQuickbooksCreateBill
     * @request POST:/api/purchasing/orders/details/integrations/quickbooks/createBill
     */
    ordersDetailsIntegrationsQuickbooksCreateBill: (
      apiRequest: MainStemAPIPlatformControllersPurchasingOrdersDetailsIntegrationsQuickbooksCreateBillAPIRequest,
      params: RequestParams = {}
    ) =>
      this.request<MainStemSDKIntegrationsExternalQuickbooksCreateBillCreateQbBillResponse, any>({
        path: `/api/purchasing/orders/details/integrations/quickbooks/createBill`,
        method: 'POST',
        body: apiRequest,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags PurchasingIntegrationsQuickbooksCreateBillPayment
     * @name OrdersDetailsIntegrationsQuickbooksCreateBillPayment
     * @request POST:/api/purchasing/orders/details/integrations/quickbooks/createBillPayment
     */
    ordersDetailsIntegrationsQuickbooksCreateBillPayment: (
      apiRequest: MainStemAPIPlatformControllersPurchasingOrdersDetailsIntegrationsQuickbooksCreateBillPaymentAPIRequest,
      params: RequestParams = {}
    ) =>
      this.request<MainStemSDKIntegrationsExternalQuickbooksCreateBillPaymentCreateQbBillPaymentResponse, any>({
        path: `/api/purchasing/orders/details/integrations/quickbooks/createBillPayment`,
        method: 'POST',
        body: apiRequest,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags PurchasingIntegrationsQuickbooksCreateBillPaymentsFromPayment
     * @name OrdersDetailsIntegrationsQuickbooksCreateBillPaymentFromPayment
     * @request POST:/api/purchasing/orders/details/integrations/quickbooks/createBillPaymentFromPayment
     */
    ordersDetailsIntegrationsQuickbooksCreateBillPaymentFromPayment: (
      apiRequest: MainStemAPIPlatformControllersPurchasingOrdersDetailsIntegrationsQuickbooksCreateBillPaymentsFromPaymentAPIRequest,
      params: RequestParams = {}
    ) =>
      this.request<
        MainStemAPIPlatformControllersPurchasingOrdersDetailsIntegrationsQuickbooksCreateBillPaymentsFromPaymentAPIResponse,
        any
      >({
        path: `/api/purchasing/orders/details/integrations/quickbooks/createBillPaymentFromPayment`,
        method: 'POST',
        body: apiRequest,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags PurchasingIntegrationStaplesOrderLineItemCreate
     * @name IntegrationsStaplesOrderLineItemCreate
     * @request POST:/api/purchasing/integrations/staples/order-line-item/create
     */
    integrationsStaplesOrderLineItemCreate: (
      apiRequest: MainStemAPIPlatformControllersPurchasingIntegrationStaplesOrderLineItemCreateAPIRequest,
      params: RequestParams = {}
    ) =>
      this.request<MainStemAPIPlatformControllersPurchasingIntegrationStaplesOrderLineItemCreateAPIResponse, any>({
        path: `/api/purchasing/integrations/staples/order-line-item/create`,
        method: 'POST',
        body: apiRequest,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags PurchasingIntegrationStaplesProductDetails
     * @name IntegrationsStaplesProductDetails
     * @request POST:/api/purchasing/integrations/staples/product/details
     */
    integrationsStaplesProductDetails: (
      apiRequest: MainStemAPIPlatformControllersPurchasingIntegrationStaplesProductDetailsAPIRequest,
      params: RequestParams = {}
    ) =>
      this.request<MainStemAPIPlatformControllersPurchasingIntegrationStaplesProductDetailsAPIResponse, any>({
        path: `/api/purchasing/integrations/staples/product/details`,
        method: 'POST',
        body: apiRequest,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags PurchasingIntegrationStaplesProductImport
     * @name IntegrationsStaplesProductImport
     * @request POST:/api/purchasing/integrations/staples/product/import
     */
    integrationsStaplesProductImport: (
      apiRequest: MainStemAPIPlatformControllersPurchasingIntegrationStaplesProductImportAPIRequest,
      params: RequestParams = {}
    ) =>
      this.request<MainStemAPIPlatformControllersPurchasingIntegrationStaplesProductImportAPIResponse, any>({
        path: `/api/purchasing/integrations/staples/product/import`,
        method: 'POST',
        body: apiRequest,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags PurchasingInvoiceAllocationCreate
     * @name InvoicesAllocationItemCreate
     * @request POST:/api/purchasing/invoices/allocation/item/create
     */
    invoicesAllocationItemCreate: (
      apiRequest: MainStemAPIPlatformControllersPurchasingInvoicesAllocationItemCreateAPIRequest,
      params: RequestParams = {}
    ) =>
      this.request<MainStemSDKModelsBaseResponse, any>({
        path: `/api/purchasing/invoices/allocation/item/create`,
        method: 'POST',
        body: apiRequest,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags PurchasingInvoiceAllocationDelete
     * @name InvoicesAllocationItemDelete
     * @request POST:/api/purchasing/invoices/allocation/item/delete
     */
    invoicesAllocationItemDelete: (
      apiRequest: MainStemAPIPlatformControllersPurchasingInvoicesAllocationItemDeleteAPIRequest,
      params: RequestParams = {}
    ) =>
      this.request<MainStemSDKModelsBaseResponse, any>({
        path: `/api/purchasing/invoices/allocation/item/delete`,
        method: 'POST',
        body: apiRequest,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags PurchasingInvoiceAllocationGet
     * @name InvoicesAllocationItemGet
     * @request POST:/api/purchasing/invoices/allocation/item/get
     */
    invoicesAllocationItemGet: (
      apiRequest: MainStemAPIPlatformControllersPurchasingInvoicesAllocationItemGetAPIRequest,
      params: RequestParams = {}
    ) =>
      this.request<MainStemAPIPlatformControllersPurchasingInvoicesAllocationItemGetAPIResponse, any>({
        path: `/api/purchasing/invoices/allocation/item/get`,
        method: 'POST',
        body: apiRequest,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags PurchasingInvoiceAllocationList
     * @name InvoicesAllocationItemList
     * @request POST:/api/purchasing/invoices/allocation/item/list
     */
    invoicesAllocationItemList: (
      apiRequest: MainStemAPIPlatformControllersPurchasingInvoicesAllocationItemListAPIRequest,
      params: RequestParams = {}
    ) =>
      this.request<MainStemAPIPlatformControllersPurchasingInvoicesAllocationItemListAPIResponse, any>({
        path: `/api/purchasing/invoices/allocation/item/list`,
        method: 'POST',
        body: apiRequest,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags PurchasingInvoiceAllocationUpdate
     * @name InvoicesAllocationItemUpdate
     * @request POST:/api/purchasing/invoices/allocation/item/update
     */
    invoicesAllocationItemUpdate: (
      apiRequest: MainStemAPIPlatformControllersPurchasingInvoicesAllocationItemUpdateAPIRequest,
      params: RequestParams = {}
    ) =>
      this.request<MainStemSDKModelsBaseResponse, any>({
        path: `/api/purchasing/invoices/allocation/item/update`,
        method: 'POST',
        body: apiRequest,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags PurchasingInvoiceProblemsCreate
     * @name InvoiceProblemCreate
     * @request POST:/api/purchasing/invoice-problem/create
     */
    invoiceProblemCreate: (
      apiRequest: MainStemAPIPlatformControllersPurchasingInvoiceProblemsCreateAPIRequest,
      params: RequestParams = {}
    ) =>
      this.request<MainStemAPIPlatformControllersGlobalMessageCreateAPIResponse, any>({
        path: `/api/purchasing/invoice-problem/create`,
        method: 'POST',
        body: apiRequest,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags PurchasingInvoiceProblemsDetails
     * @name InvoiceProblemDetails
     * @request POST:/api/purchasing/invoice-problem/details
     */
    invoiceProblemDetails: (
      apiRequest: MainStemAPIPlatformControllersPurchasingInvoiceProblemsDetailsAPIRequest,
      params: RequestParams = {}
    ) =>
      this.request<MainStemAPIPlatformControllersPurchasingInvoiceProblemsDetailsAPIResponse, any>({
        path: `/api/purchasing/invoice-problem/details`,
        method: 'POST',
        body: apiRequest,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags PurchasingInvoiceProblemsList
     * @name InvoiceProblemList
     * @request POST:/api/purchasing/invoice-problem/list
     */
    invoiceProblemList: (
      apiRequest: MainStemAPIPlatformControllersPurchasingInvoiceProblemsListAPIRequest,
      params: RequestParams = {}
    ) =>
      this.request<MainStemAPIPlatformControllersPurchasingInvoiceProblemsListAPIResponse, any>({
        path: `/api/purchasing/invoice-problem/list`,
        method: 'POST',
        body: apiRequest,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags PurchasingInvoiceProblemsListUnresolved
     * @name InvoiceProblemListUnresolved
     * @request POST:/api/purchasing/invoice-problem/listUnresolved
     */
    invoiceProblemListUnresolved: (
      apiRequest: MainStemAPIPlatformControllersPurchasingInvoiceProblemsListUnresolvedAPIRequest,
      params: RequestParams = {}
    ) =>
      this.request<MainStemAPIPlatformControllersPurchasingInvoiceProblemsListUnresolvedAPIResponse, any>({
        path: `/api/purchasing/invoice-problem/listUnresolved`,
        method: 'POST',
        body: apiRequest,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags PurchasingInvoiceProblemsUpdateStatus
     * @name InvoiceProblemUpdateStatus
     * @request POST:/api/purchasing/invoice-problem/updateStatus
     */
    invoiceProblemUpdateStatus: (
      apiRequest: MainStemAPIPlatformControllersPurchasingInvoiceProblemsUpdateStatusAPIRequest,
      params: RequestParams = {}
    ) =>
      this.request<MainStemAPIPlatformControllersPurchasingInvoiceProblemsUpdateStatusAPIResponse, any>({
        path: `/api/purchasing/invoice-problem/updateStatus`,
        method: 'POST',
        body: apiRequest,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags PurchasingInvoiceReceivingDetailsUpdate
     * @name ReceivingUpdate
     * @request POST:/api/purchasing/receiving/update
     */
    receivingUpdate: (
      APIRequest: MainStemAPIPlatformControllersPurchasingReceivingUpdateAPIRequest,
      params: RequestParams = {}
    ) =>
      this.request<MainStemSDKModelsBaseResponse, any>({
        path: `/api/purchasing/receiving/update`,
        method: 'POST',
        body: APIRequest,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags PurchasingInvoiceReceivingInvoiceDetails
     * @name ReceivingDetails
     * @request POST:/api/purchasing/receiving/details
     */
    receivingDetails: (
      apiRequest: MainStemAPIPlatformControllersPurchasingReceivingDetailsAPIRequest,
      params: RequestParams = {}
    ) =>
      this.request<MainStemAPIPlatformControllersPurchasingReceivingDetailsAPIResponse, any>({
        path: `/api/purchasing/receiving/details`,
        method: 'POST',
        body: apiRequest,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags PurchasingInvoiceReceivingInvoiceList
     * @name ReceivingInvoiceList
     * @request POST:/api/purchasing/receiving/invoice/list
     */
    receivingInvoiceList: (
      apiRequest: MainStemAPIPlatformControllersPurchasingReceivingInvoiceListAPIRequest,
      params: RequestParams = {}
    ) =>
      this.request<MainStemAPIPlatformControllersPurchasingReceivingInvoiceListAPIResponse, any>({
        path: `/api/purchasing/receiving/invoice/list`,
        method: 'POST',
        body: apiRequest,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags PurchasingInvoiceReceivingInvoiceUpdate
     * @name ReceivingInvoiceUpdate
     * @request POST:/api/purchasing/receiving/invoice/update
     */
    receivingInvoiceUpdate: (
      apiRequest: MainStemAPIPlatformControllersPurchasingReceivingInvoiceUpdateAPIRequest,
      params: RequestParams = {}
    ) =>
      this.request<MainStemSDKModelsBaseResponse, any>({
        path: `/api/purchasing/receiving/invoice/update`,
        method: 'POST',
        body: apiRequest,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags PurchasingInvoiceReceivingItemList
     * @name ReceivingItemList
     * @request POST:/api/purchasing/receiving/item/list
     */
    receivingItemList: (
      apiRequest: MainStemAPIPlatformControllersPurchasingReceivingItemListAPIRequest,
      params: RequestParams = {}
    ) =>
      this.request<MainStemAPIPlatformControllersPurchasingReceivingInvoiceListAPIResponse, any>({
        path: `/api/purchasing/receiving/item/list`,
        method: 'POST',
        body: apiRequest,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags PurchasingInvoiceReceivingItemUpdate
     * @name ReceivingItemUpdate
     * @request POST:/api/purchasing/receiving/item/update
     */
    receivingItemUpdate: (
      apiRequest: MainStemAPIPlatformControllersPurchasingReceivingItemUpdateAPIRequest,
      params: RequestParams = {}
    ) =>
      this.request<MainStemSDKModelsBaseResponse, any>({
        path: `/api/purchasing/receiving/item/update`,
        method: 'POST',
        body: apiRequest,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags PurchasingInvoicesAccept
     * @name InvoicesAccept
     * @request POST:/api/purchasing/invoices/accept
     */
    invoicesAccept: (
      APIRequest: MainStemAPIPlatformControllersPurchasingInvoicesAcceptAPIRequest,
      params: RequestParams = {}
    ) =>
      this.request<MainStemAPIPlatformControllersPurchasingInvoicesAcceptAPIResponse, any>({
        path: `/api/purchasing/invoices/accept`,
        method: 'POST',
        body: APIRequest,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags PurchasingInvoicesCancel
     * @name InvoicesCancel
     * @request POST:/api/purchasing/invoices/cancel
     */
    invoicesCancel: (
      APIRequest: MainStemAPIPlatformControllersPurchasingInvoicesCancelAPIRequest,
      params: RequestParams = {}
    ) =>
      this.request<MainStemAPIPlatformControllersPurchasingInvoicesCancelAPIResponse, any>({
        path: `/api/purchasing/invoices/cancel`,
        method: 'POST',
        body: APIRequest,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags PurchasingInvoicesComplete
     * @name InvoicesComplete
     * @request POST:/api/purchasing/invoices/complete
     */
    invoicesComplete: (
      APIRequest: MainStemAPIPlatformControllersPurchasingInvoicesCompleteAPIRequest,
      params: RequestParams = {}
    ) =>
      this.request<MainStemAPIPlatformControllersPurchasingInvoicesCompleteAPIResponse, any>({
        path: `/api/purchasing/invoices/complete`,
        method: 'POST',
        body: APIRequest,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags PurchasingInvoicesDecline
     * @name InvoicesDecline
     * @request POST:/api/purchasing/invoices/decline
     */
    invoicesDecline: (
      APIRequest: MainStemAPIPlatformControllersPurchasingInvoicesDeclineAPIRequest,
      params: RequestParams = {}
    ) =>
      this.request<MainStemAPIPlatformControllersPurchasingInvoicesDeclineAPIResponse, any>({
        path: `/api/purchasing/invoices/decline`,
        method: 'POST',
        body: APIRequest,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags PurchasingInvoicesDetails
     * @name InvoicesDetails
     * @request POST:/api/purchasing/invoices/details
     */
    invoicesDetails: (
      apiRequest: MainStemAPIPlatformControllersPurchasingInvoicesDetailsAPIRequest,
      params: RequestParams = {}
    ) =>
      this.request<MainStemAPIPlatformControllersPurchasingInvoicesDetailsAPIResponse, any>({
        path: `/api/purchasing/invoices/details`,
        method: 'POST',
        body: apiRequest,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags PurchasingInvoicesFinancialDimensionsUpdate
     * @name InvoicesFinancialDimensionsUpdate
     * @request POST:/api/purchasing/invoices/financial-dimensions/update
     */
    invoicesFinancialDimensionsUpdate: (
      apiRequest: MainStemAPIPlatformControllersPurchasingInvoicesFinancialDimensionsUpdateAPIRequest,
      params: RequestParams = {}
    ) =>
      this.request<MainStemSDKModelsBaseResponse, any>({
        path: `/api/purchasing/invoices/financial-dimensions/update`,
        method: 'POST',
        body: apiRequest,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags PurchasingInvoicesLineItemCreate
     * @name InvoicesLineItemsCreate
     * @request POST:/api/purchasing/invoices/line-items/create
     */
    invoicesLineItemsCreate: (
      apiRequest: MainStemAPIPlatformControllersPurchasingInvoicesLineItemsCreateAPIRequest,
      params: RequestParams = {}
    ) =>
      this.request<MainStemAPIPlatformControllersPurchasingInvoicesLineItemsCreateAPIResponse, any>({
        path: `/api/purchasing/invoices/line-items/create`,
        method: 'POST',
        body: apiRequest,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags PurchasingInvoicesLineItemDelete
     * @name InvoicesLineItemsDelete
     * @request POST:/api/purchasing/invoices/line-items/delete
     */
    invoicesLineItemsDelete: (
      apiRequest: MainStemAPIPlatformControllersPurchasingInvoicesLineItemsDeleteAPIRequest,
      params: RequestParams = {}
    ) =>
      this.request<MainStemAPIPlatformControllersPurchasingInvoicesLineItemsDeleteAPIResponse, any>({
        path: `/api/purchasing/invoices/line-items/delete`,
        method: 'POST',
        body: apiRequest,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags PurchasingInvoicesLineItemUpdate
     * @name InvoicesLineItemsUpdate
     * @request POST:/api/purchasing/invoices/line-items/update
     */
    invoicesLineItemsUpdate: (
      APIRequest: MainStemAPIPlatformControllersPurchasingInvoicesLineItemsUpdateAPIRequest,
      params: RequestParams = {}
    ) =>
      this.request<MainStemAPIPlatformControllersPurchasingInvoicesLineItemsUpdateAPIResponse, any>({
        path: `/api/purchasing/invoices/line-items/update`,
        method: 'POST',
        body: APIRequest,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags PurchasingInvoicesList
     * @name InvoicesList
     * @request POST:/api/purchasing/invoices/list
     */
    invoicesList: (
      apiRequest: MainStemAPIPlatformControllersPurchasingInvoicesListAPIRequest,
      params: RequestParams = {}
    ) =>
      this.request<MainStemAPIPlatformControllersPurchasingInvoicesListAPIResponse, any>({
        path: `/api/purchasing/invoices/list`,
        method: 'POST',
        body: apiRequest,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags PurchasingInvoicesNotify
     * @name InvoicesNotify
     * @request POST:/api/purchasing/invoices/notify
     */
    invoicesNotify: (
      APIRequest: MainStemAPIPlatformControllersPurchasingInvoicesNotifyAPIRequest,
      params: RequestParams = {}
    ) =>
      this.request<MainStemAPIPlatformControllersPurchasingInvoicesNotifyAPIResponse, any>({
        path: `/api/purchasing/invoices/notify`,
        method: 'POST',
        body: APIRequest,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags PurchasingInvoicesReceivingList
     * @name InvoicesReceivingList
     * @request POST:/api/purchasing/invoices/receiving/list
     */
    invoicesReceivingList: (
      apiRequest: MainStemAPIPlatformControllersPurchasingInvoicesReceivingListAPIRequest,
      params: RequestParams = {}
    ) =>
      this.request<MainStemAPIPlatformControllersPurchasingInvoicesReceivingListAPIResponse, any>({
        path: `/api/purchasing/invoices/receiving/list`,
        method: 'POST',
        body: apiRequest,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags PurchasingInvoicesReconciliationCreate
     * @name InvoicesReconciliationCreate
     * @request POST:/api/purchasing/invoices/reconciliation/create
     */
    invoicesReconciliationCreate: (
      query: {
        /** @format int32 */
        invoiceId: number
        aiModel?: 'Lido' | 'GPT54Mini'
      },
      params: RequestParams = {}
    ) =>
      this.request<MainStemAPIPlatformControllersPurchasingInvoicesReconciliationCreateAPIResponse, any>({
        path: `/api/purchasing/invoices/reconciliation/create`,
        method: 'POST',
        query: query,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags PurchasingInvoicesReconciliationDetails
     * @name InvoicesReconciliationDetails
     * @request POST:/api/purchasing/invoices/reconciliation/details
     */
    invoicesReconciliationDetails: (
      apiRequest: MainStemAPIPlatformControllersPurchasingInvoicesReconciliationDetailsAPIRequest,
      params: RequestParams = {}
    ) =>
      this.request<MainStemAPIPlatformControllersPurchasingInvoicesReconciliationDetailsAPIResponse, any>({
        path: `/api/purchasing/invoices/reconciliation/details`,
        method: 'POST',
        body: apiRequest,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags PurchasingInvoicesReconciliationList
     * @name InvoicesReconciliationList
     * @request POST:/api/purchasing/invoices/reconciliation/list
     */
    invoicesReconciliationList: (
      apiRequest: MainStemAPIPlatformControllersPurchasingInvoicesReconciliationListAPIRequest,
      params: RequestParams = {}
    ) =>
      this.request<MainStemAPIPlatformControllersPurchasingInvoicesReconciliationListAPIResponse, any>({
        path: `/api/purchasing/invoices/reconciliation/list`,
        method: 'POST',
        body: apiRequest,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags PurchasingInvoicesReconciliationRematch
     * @name InvoicesReconciliationRematch
     * @request POST:/api/purchasing/invoices/reconciliation/rematch
     */
    invoicesReconciliationRematch: (
      apiRequest: MainStemAPIPlatformControllersPurchasingInvoicesReconciliationRematchAPIRequest,
      params: RequestParams = {}
    ) =>
      this.request<MainStemAPIPlatformControllersPurchasingInvoicesReconciliationRematchAPIResponse, any>({
        path: `/api/purchasing/invoices/reconciliation/rematch`,
        method: 'POST',
        body: apiRequest,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags PurchasingInvoicesShipmentsCreate
     * @name InvoicesShipmentsCreate
     * @request POST:/api/purchasing/invoices/shipments/create
     */
    invoicesShipmentsCreate: (
      APIRequest: MainStemAPIPlatformControllersPurchasingInvoicesShipmentsCreateAPIRequest,
      params: RequestParams = {}
    ) =>
      this.request<MainStemAPIPlatformControllersPurchasingInvoicesShipmentsCreateAPIResponse, any>({
        path: `/api/purchasing/invoices/shipments/create`,
        method: 'POST',
        body: APIRequest,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags PurchasingInvoicesShipmentsList
     * @name InvoicesShipmentsList
     * @request POST:/api/purchasing/invoices/shipments/list
     */
    invoicesShipmentsList: (
      APIRequest: MainStemAPIPlatformControllersPurchasingInvoicesShipmentsListAPIRequest,
      params: RequestParams = {}
    ) =>
      this.request<MainStemAPIPlatformControllersPurchasingInvoicesShipmentsListAPIResponse, any>({
        path: `/api/purchasing/invoices/shipments/list`,
        method: 'POST',
        body: APIRequest,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags PurchasingInvoicesUpdate
     * @name InvoicesUpdate
     * @request POST:/api/purchasing/invoices/update
     */
    invoicesUpdate: (
      APIRequest: MainStemAPIPlatformControllersPurchasingInvoicesUpdateAPIRequest,
      params: RequestParams = {}
    ) =>
      this.request<MainStemAPIPlatformControllersPurchasingInvoicesUpdateAPIResponse, any>({
        path: `/api/purchasing/invoices/update`,
        method: 'POST',
        body: APIRequest,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags PurchasingLocationApprovalWorkflowSuperApproverAdd
     * @name LocationsApprovalWorkflowSuperApproverAdd
     * @request POST:/api/purchasing/locations/approval-workflow/super-approver/add
     */
    locationsApprovalWorkflowSuperApproverAdd: (
      apiRequest: MainStemAPIPlatformControllersPurchasingLocationsApprovalWorkflowSuperApproverAddAPIRequest,
      params: RequestParams = {}
    ) =>
      this.request<MainStemAPIPlatformControllersPurchasingLocationsApprovalWorkflowSuperApproverAddAPIResponse, any>({
        path: `/api/purchasing/locations/approval-workflow/super-approver/add`,
        method: 'POST',
        body: apiRequest,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags PurchasingLocationApprovalWorkflowSuperApproverRemove
     * @name LocationsApprovalWorkflowSuperApproverRemove
     * @request POST:/api/purchasing/locations/approval-workflow/super-approver/remove
     */
    locationsApprovalWorkflowSuperApproverRemove: (
      apiRequest: MainStemAPIPlatformControllersPurchasingLocationsApprovalWorkflowSuperApproverRemoveAPIRequest,
      params: RequestParams = {}
    ) =>
      this.request<
        MainStemAPIPlatformControllersPurchasingLocationsApprovalWorkflowSuperApproverRemoveAPIResponse,
        any
      >({
        path: `/api/purchasing/locations/approval-workflow/super-approver/remove`,
        method: 'POST',
        body: apiRequest,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags PurchasingLocationBudgetCreate
     * @name LocationBudgetCreate
     * @request POST:/api/purchasing/location-budget/create
     */
    locationBudgetCreate: (
      apiRequest: MainStemAPIPlatformControllersPurchasingLocationBudgetCreateAPIRequest,
      params: RequestParams = {}
    ) =>
      this.request<MainStemAPIPlatformControllersPurchasingLocationBudgetCreateAPIResponse, any>({
        path: `/api/purchasing/location-budget/create`,
        method: 'POST',
        body: apiRequest,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags PurchasingLocationBudgetList
     * @name LocationBudgetList
     * @request POST:/api/purchasing/location-budget/list
     */
    locationBudgetList: (
      apiRequest: MainStemAPIPlatformControllersPurchasingLocationBudgetListAPIRequest,
      params: RequestParams = {}
    ) =>
      this.request<MainStemAPIPlatformControllersPurchasingLocationBudgetListAPIResponse, any>({
        path: `/api/purchasing/location-budget/list`,
        method: 'POST',
        body: apiRequest,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags PurchasingLocationBudgetUpdate
     * @name LocationBudgetUpdate
     * @request POST:/api/purchasing/location-budget/update
     */
    locationBudgetUpdate: (
      apiRequest: MainStemAPIPlatformControllersPurchasingLocationBudgetUpdateAPIRequest,
      params: RequestParams = {}
    ) =>
      this.request<MainStemAPIPlatformControllersPurchasingLocationBudgetUpdateAPIResponse, any>({
        path: `/api/purchasing/location-budget/update`,
        method: 'POST',
        body: apiRequest,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags PurchasingLocationDepartmentsList
     * @name LocationsDepartmentsList
     * @request POST:/api/purchasing/locations/departments/list
     */
    locationsDepartmentsList: (
      apiRequest: MainStemAPIPlatformControllersPurchasingLocationsDepartmentsListAPIRequest,
      params: RequestParams = {}
    ) =>
      this.request<MainStemAPIPlatformControllersPurchasingLocationsDepartmentsListAPIResponse, any>({
        path: `/api/purchasing/locations/departments/list`,
        method: 'POST',
        body: apiRequest,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags PurchasingLocationDetailsActivityLog
     * @name LocationsDetailsActivityLog
     * @request POST:/api/purchasing/locations/details/activityLog
     */
    locationsDetailsActivityLog: (
      apiRequest: MainStemAPIPlatformControllersPurchasingLocationsDetailsActivityLogAPIRequest,
      params: RequestParams = {}
    ) =>
      this.request<MainStemAPIPlatformControllersPurchasingLocationsDetailsActivityLogAPIResponse, any>({
        path: `/api/purchasing/locations/details/activityLog`,
        method: 'POST',
        body: apiRequest,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags PurchasingLocationDetailsAddressBook
     * @name LocationsDetailsAddressBook
     * @request POST:/api/purchasing/locations/details/address-book
     */
    locationsDetailsAddressBook: (
      apiRequest: MainStemAPIPlatformControllersPurchasingLocationsDetailsAddressBookAPIRequest,
      params: RequestParams = {}
    ) =>
      this.request<MainStemAPIPlatformControllersPurchasingLocationsDetailsAddressBookAPIResponse, any>({
        path: `/api/purchasing/locations/details/address-book`,
        method: 'POST',
        body: apiRequest,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags PurchasingLocationDetailsOrders
     * @name LocationsDetailsOrders
     * @request POST:/api/purchasing/locations/details/orders
     */
    locationsDetailsOrders: (
      apiRequest: MainStemAPIPlatformControllersPurchasingLocationsDetailsOrdersAPIRequest,
      params: RequestParams = {}
    ) =>
      this.request<MainStemAPIPlatformControllersPurchasingLocationsDetailsOrdersAPIResponse, any>({
        path: `/api/purchasing/locations/details/orders`,
        method: 'POST',
        body: apiRequest,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags PurchasingLocationDetailsProductFinancialDimensionCreate
     * @name LocationDetailsProductFinancialDimensionCreate
     * @request POST:/api/purchasing/location/details/product-financial-dimension/create
     */
    locationDetailsProductFinancialDimensionCreate: (
      apiRequest: MainStemAPIPlatformControllersPurchasingLocationsDetailsProductFinancialDimensionCreateAPIRequest,
      params: RequestParams = {}
    ) =>
      this.request<
        MainStemAPIPlatformControllersPurchasingLocationsDetailsProductFinancialDimensionCreateAPIResponse,
        any
      >({
        path: `/api/purchasing/location/details/product-financial-dimension/create`,
        method: 'POST',
        body: apiRequest,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags PurchasingLocationDetailsProductFinancialDimensionDelete
     * @name LocationDetailsProductFinancialDimensionDelete
     * @request POST:/api/purchasing/location/details/product-financial-dimension/delete
     */
    locationDetailsProductFinancialDimensionDelete: (
      apiRequest: MainStemAPIPlatformControllersPurchasingLocationsDetailsProductFinancialDimensionDeleteAPIRequest,
      params: RequestParams = {}
    ) =>
      this.request<
        MainStemAPIPlatformControllersPurchasingLocationsDetailsProductFinancialDimensionDeleteAPIResponse,
        any
      >({
        path: `/api/purchasing/location/details/product-financial-dimension/delete`,
        method: 'POST',
        body: apiRequest,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags PurchasingLocationDetailsProductFinancialDimensionUpdate
     * @name LocationDetailsProductFinancialDimensionUpdate
     * @request POST:/api/purchasing/location/details/product-financial-dimension/update
     */
    locationDetailsProductFinancialDimensionUpdate: (
      apiRequest: MainStemAPIPlatformControllersPurchasingLocationsDetailsProductFinancialDimensionUpdateAPIRequest,
      params: RequestParams = {}
    ) =>
      this.request<
        MainStemAPIPlatformControllersPurchasingLocationsDetailsProductFinancialDimensionUpdateAPIResponse,
        any
      >({
        path: `/api/purchasing/location/details/product-financial-dimension/update`,
        method: 'POST',
        body: apiRequest,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags PurchasingLocationDetailsShipments
     * @name LocationsDetailsShipments
     * @request POST:/api/purchasing/locations/details/shipments
     */
    locationsDetailsShipments: (
      apiRequest: MainStemAPIPlatformControllersPurchasingLocationsDetailsShipmentsAPIRequest,
      params: RequestParams = {}
    ) =>
      this.request<MainStemAPIPlatformControllersPurchasingLocationsDetailsShipmentsAPIResponse, any>({
        path: `/api/purchasing/locations/details/shipments`,
        method: 'POST',
        body: apiRequest,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags PurchasingLocationDetailsSupplierFinancialDimensionCreate
     * @name LocationDetailsSupplierFinancialDimensionCreate
     * @request POST:/api/purchasing/location/details/supplier-financial-dimension/create
     */
    locationDetailsSupplierFinancialDimensionCreate: (
      apiRequest: MainStemAPIPlatformControllersPurchasingLocationsDetailsSupplierFinancialDimensionCreateAPIRequest,
      params: RequestParams = {}
    ) =>
      this.request<
        MainStemAPIPlatformControllersPurchasingLocationsDetailsSupplierFinancialDimensionCreateAPIResponse,
        any
      >({
        path: `/api/purchasing/location/details/supplier-financial-dimension/create`,
        method: 'POST',
        body: apiRequest,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags PurchasingLocationDetailsSupplierFinancialDimensionDelete
     * @name LocationDetailsSupplierFinancialDimensionDelete
     * @request POST:/api/purchasing/location/details/supplier-financial-dimension/delete
     */
    locationDetailsSupplierFinancialDimensionDelete: (
      apiRequest: MainStemAPIPlatformControllersPurchasingLocationsDetailsSupplierFinancialDimensionDeleteAPIRequest,
      params: RequestParams = {}
    ) =>
      this.request<
        MainStemAPIPlatformControllersPurchasingLocationsDetailsSupplierFinancialDimensionDeleteAPIResponse,
        any
      >({
        path: `/api/purchasing/location/details/supplier-financial-dimension/delete`,
        method: 'POST',
        body: apiRequest,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags PurchasingLocationDetailsSupplierFinancialDimensionUpdate
     * @name LocationDetailsSupplierFinancialDimensionUpdate
     * @request POST:/api/purchasing/location/details/supplier-financial-dimension/update
     */
    locationDetailsSupplierFinancialDimensionUpdate: (
      apiRequest: MainStemAPIPlatformControllersPurchasingLocationsDetailsSupplierFinancialDimensionUpdateAPIRequest,
      params: RequestParams = {}
    ) =>
      this.request<
        MainStemAPIPlatformControllersPurchasingLocationsDetailsSupplierFinancialDimensionUpdateAPIResponse,
        any
      >({
        path: `/api/purchasing/location/details/supplier-financial-dimension/update`,
        method: 'POST',
        body: apiRequest,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags PurchasingLocationDetailsSupplyAuditReports
     * @name LocationsDetailsSupplyAuditReports
     * @request POST:/api/purchasing/locations/details/supplyAuditReports
     */
    locationsDetailsSupplyAuditReports: (
      apiRequest: MainStemAPIPlatformControllersPurchasingLocationsDetailsSupplyAuditReportsAPIRequest,
      params: RequestParams = {}
    ) =>
      this.request<MainStemAPIPlatformControllersPurchasingLocationsDetailsSupplyAuditReportsAPIResponse, any>({
        path: `/api/purchasing/locations/details/supplyAuditReports`,
        method: 'POST',
        body: apiRequest,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags PurchasingLocationDetailsUsers
     * @name LocationsDetailsUsers
     * @request POST:/api/purchasing/locations/details/users
     */
    locationsDetailsUsers: (
      apiRequest: MainStemAPIPlatformControllersPurchasingLocationsDetailsUsersAPIRequest,
      params: RequestParams = {}
    ) =>
      this.request<MainStemAPIPlatformControllersPurchasingLocationsDetailsUsersAPIResponse, any>({
        path: `/api/purchasing/locations/details/users`,
        method: 'POST',
        body: apiRequest,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags PurchasingLocationsCreate
     * @name LocationsCreate
     * @request POST:/api/purchasing/locations/create
     */
    locationsCreate: (
      apiRequest: MainStemAPIPlatformControllersPurchasingLocationsCreateAPIRequest,
      params: RequestParams = {}
    ) =>
      this.request<MainStemAPIPlatformControllersPurchasingLocationsCreateAPIResponse, any>({
        path: `/api/purchasing/locations/create`,
        method: 'POST',
        body: apiRequest,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags PurchasingLocationsDelete
     * @name LocationsDelete
     * @request POST:/api/purchasing/locations/delete
     */
    locationsDelete: (
      apiRequest: MainStemAPIPlatformControllersPurchasingLocationsDeleteAPIRequest,
      params: RequestParams = {}
    ) =>
      this.request<MainStemAPIPlatformControllersPurchasingLocationsDeleteAPIResponse, any>({
        path: `/api/purchasing/locations/delete`,
        method: 'POST',
        body: apiRequest,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags PurchasingLocationsDetails
     * @name LocationsDetails
     * @request POST:/api/purchasing/locations/details
     */
    locationsDetails: (
      apiRequest: MainStemAPIPlatformControllersPurchasingLocationsDetailsAPIRequest,
      params: RequestParams = {}
    ) =>
      this.request<MainStemAPIPlatformControllersPurchasingLocationsDetailsAPIResponse, any>({
        path: `/api/purchasing/locations/details`,
        method: 'POST',
        body: apiRequest,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags PurchasingLocationsDetailsCatalogs
     * @name LocationsDetailsCatalogs
     * @request POST:/api/purchasing/locations/details/catalogs
     */
    locationsDetailsCatalogs: (
      apiRequest: MainStemAPIPlatformControllersPurchasingLocationsDetailsCatalogsAPIRequest,
      params: RequestParams = {}
    ) =>
      this.request<MainStemAPIPlatformControllersPurchasingLocationsDetailsCatalogsAPIResponse, any>({
        path: `/api/purchasing/locations/details/catalogs`,
        method: 'POST',
        body: apiRequest,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags PurchasingLocationsDetailsSalesTax
     * @name LocationsDetailsSalesTax
     * @request POST:/api/purchasing/locations/details/sales-tax
     */
    locationsDetailsSalesTax: (
      Request: MainStemAPIPlatformControllersPurchasingLocationsDetailsSalesTaxAPIRequest,
      params: RequestParams = {}
    ) =>
      this.request<MainStemAPIPlatformControllersPurchasingLocationsDetailsSalesTaxAPIResponse, any>({
        path: `/api/purchasing/locations/details/sales-tax`,
        method: 'POST',
        body: Request,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags PurchasingLocationsDuplicate
     * @name LocationsDuplicate
     * @request POST:/api/purchasing/locations/duplicate
     */
    locationsDuplicate: (
      apiRequest: MainStemAPIPlatformControllersPurchasingLocationsDuplicateAPIRequest,
      params: RequestParams = {}
    ) =>
      this.request<MainStemAPIPlatformControllersPurchasingLocationsDuplicateAPIResponse, any>({
        path: `/api/purchasing/locations/duplicate`,
        method: 'POST',
        body: apiRequest,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags PurchasingLocationsIntegrationQuantumLeafUpdate
     * @name LocationsIntegrationsQuantumLeafUpdate
     * @request POST:/api/purchasing/locations/integrations/quantum-leaf/update
     */
    locationsIntegrationsQuantumLeafUpdate: (
      apiRequest: MainStemAPIPlatformControllersPurchasingLocationsIntegrationsQuantumLeafUpdateAPIRequest,
      params: RequestParams = {}
    ) =>
      this.request<MainStemAPIPlatformControllersPurchasingLocationsIntegrationsQuantumLeafUpdateAPIResponse, any>({
        path: `/api/purchasing/locations/integrations/quantum-leaf/update`,
        method: 'POST',
        body: apiRequest,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags PurchasingLocationsList
     * @name LocationsList
     * @request GET:/api/purchasing/locations/list
     */
    locationsList: (
      query?: {
        includeArchived?: boolean
      },
      params: RequestParams = {}
    ) =>
      this.request<MainStemAPIPlatformControllersPurchasingLocationsListAPIResponse, any>({
        path: `/api/purchasing/locations/list`,
        method: 'GET',
        query: query,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags PurchasingLocationsUpdate
     * @name LocationsUpdate
     * @request POST:/api/purchasing/locations/update
     */
    locationsUpdate: (
      apiRequest: MainStemAPIPlatformControllersPurchasingLocationsUpdateAPIRequest,
      params: RequestParams = {}
    ) =>
      this.request<MainStemSDKModelsBaseResponse, any>({
        path: `/api/purchasing/locations/update`,
        method: 'POST',
        body: apiRequest,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags PurchasingLocationsUpdateAddress
     * @name LocationsUpdateAddress
     * @request POST:/api/purchasing/locations/update/address
     */
    locationsUpdateAddress: (
      apiRequest: MainStemAPIPlatformControllersPurchasingLocationsUpdateAddressAPIRequest,
      params: RequestParams = {}
    ) =>
      this.request<MainStemSDKModelsBaseResponse, any>({
        path: `/api/purchasing/locations/update/address`,
        method: 'POST',
        body: apiRequest,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags PurchasingLocationsUpdateHeader
     * @name LocationsUpdateHeader
     * @request POST:/api/purchasing/locations/updateHeader
     */
    locationsUpdateHeader: (
      query: {
        /** @format int32 */
        id: number
      },
      params: RequestParams = {}
    ) =>
      this.request<MainStemAPIPlatformControllersPurchasingBulkOrderCreateAPIRequest, any>({
        path: `/api/purchasing/locations/updateHeader`,
        method: 'POST',
        query: query,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags PurchasingLocationsUpdateLogo
     * @name LocationsUpdateLogo
     * @request POST:/api/purchasing/locations/updateLogo
     */
    locationsUpdateLogo: (
      query: {
        /** @format int32 */
        id: number
      },
      params: RequestParams = {}
    ) =>
      this.request<MainStemAPIPlatformControllersPurchasingBulkOrderCreateAPIRequest, any>({
        path: `/api/purchasing/locations/updateLogo`,
        method: 'POST',
        query: query,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags PurchasingLocationsUpdatePDF
     * @name LocationsUpdatePdf
     * @request POST:/api/purchasing/locations/update/pdf
     */
    locationsUpdatePdf: (
      query: {
        /** @format int32 */
        id: number
      },
      params: RequestParams = {}
    ) =>
      this.request<MainStemAPIPlatformControllersPurchasingBulkOrderCreateAPIRequest, any>({
        path: `/api/purchasing/locations/update/pdf`,
        method: 'POST',
        query: query,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags PurchasingLocationSupplierFinancialDimensionList
     * @name LocationSupplierFinancialDimensionList
     * @request POST:/api/purchasing/location-supplier-financial-dimension/list
     */
    locationSupplierFinancialDimensionList: (params: RequestParams = {}) =>
      this.request<MainStemAPIPlatformControllersPurchasingLocationSupplierFinancialDimensionListAPIResponse, any>({
        path: `/api/purchasing/location-supplier-financial-dimension/list`,
        method: 'POST',
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags PurchasingMakeInvoicePayments
     * @name MakePaymentsInvoice
     * @request POST:/api/purchasing/makePayments/invoice
     */
    makePaymentsInvoice: (
      apiRequest: MainStemAPIPlatformControllersPurchasingMakePaymentsInvoiceAPIRequest,
      params: RequestParams = {}
    ) =>
      this.request<MainStemAPIPlatformControllersPurchasingMakePaymentsInvoiceAPIResponse, any>({
        path: `/api/purchasing/makePayments/invoice`,
        method: 'POST',
        body: apiRequest,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags PurchasingMakeOrderPayments
     * @name MakePaymentsOrder
     * @request POST:/api/purchasing/makePayments/order
     */
    makePaymentsOrder: (
      apiRequest: MainStemAPIPlatformControllersPurchasingMakePaymentsOrderAPIRequest,
      params: RequestParams = {}
    ) =>
      this.request<MainStemAPIPlatformControllersPurchasingMakePaymentsOrderAPIResponse, any>({
        path: `/api/purchasing/makePayments/order`,
        method: 'POST',
        body: apiRequest,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags PurchasingOmniSearchAutoComplete
     * @name OmniSearchAutoComplete
     * @request POST:/api/purchasing/omni-search/auto-complete
     */
    omniSearchAutoComplete: (
      apiRequest: MainStemAPIPlatformControllersPurchasingOmniSearchAutoCompleteAPIRequest,
      params: RequestParams = {}
    ) =>
      this.request<MainStemAPIPlatformControllersPurchasingOmniSearchAutoCompleteAPIResponse, any>({
        path: `/api/purchasing/omni-search/auto-complete`,
        method: 'POST',
        body: apiRequest,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags PurchasingOmniSearchSearch
     * @name OmniSearchSearch
     * @request POST:/api/purchasing/omni-search/search
     */
    omniSearchSearch: (
      apiRequest: MainStemAPIPlatformControllersPurchasingOmniSearchSearchAPIRequest,
      params: RequestParams = {}
    ) =>
      this.request<MainStemAPIPlatformControllersPurchasingOmniSearchSearchAPIResponse, any>({
        path: `/api/purchasing/omni-search/search`,
        method: 'POST',
        body: apiRequest,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags PurchasingOrderCommunicationActionResolved
     * @name OrdersCommunicationsActionResolved
     * @request POST:/api/purchasing/orders/communications/actionResolved
     */
    ordersCommunicationsActionResolved: (
      apiRequest: MainStemAPIPlatformControllersPurchasingOrdersCommunicationPurchasingOrderCommunicationActionResolvedControllerAPIRequest,
      params: RequestParams = {}
    ) =>
      this.request<
        MainStemAPIPlatformControllersPurchasingOrdersCommunicationPurchasingOrderCommunicationActionResolvedControllerAPIResponse,
        any
      >({
        path: `/api/purchasing/orders/communications/actionResolved`,
        method: 'POST',
        body: apiRequest,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags PurchasingOrderCommunicationCreate
     * @name OrdersCommunicationsCreate
     * @request POST:/api/purchasing/orders/communications/create
     */
    ordersCommunicationsCreate: (
      apiRequest: MainStemAPIPlatformControllersPurchasingOrdersCommunicationPurchasingOrderCommunicationCreateControllerAPIRequest,
      params: RequestParams = {}
    ) =>
      this.request<
        MainStemAPIPlatformControllersPurchasingOrdersCommunicationPurchasingOrderCommunicationCreateControllerAPIResponse,
        any
      >({
        path: `/api/purchasing/orders/communications/create`,
        method: 'POST',
        body: apiRequest,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags PurchasingOrderCommunicationForFulfillment
     * @name OrdersCommunicationsFulfillment
     * @request GET:/api/purchasing/orders/communications/fulfillment
     */
    ordersCommunicationsFulfillment: (
      query: {
        fulfillmentMethodIds: number[]
      },
      params: RequestParams = {}
    ) =>
      this.request<
        MainStemAPIPlatformControllersPurchasingOrdersCommunicationPurchasingOrderCommunicationForFulfillmentControllerAPIResponse,
        any
      >({
        path: `/api/purchasing/orders/communications/fulfillment`,
        method: 'GET',
        query: query,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags PurchasingOrderCommunicationForOrder
     * @name OrdersCommunicationsOrder
     * @request GET:/api/purchasing/orders/communications/order
     */
    ordersCommunicationsOrder: (
      query: {
        /** @format int32 */
        orderID: number
      },
      params: RequestParams = {}
    ) =>
      this.request<
        MainStemAPIPlatformControllersPurchasingOrdersCommunicationPurchasingOrderCommunicationForOrderControllerAPIResponse,
        any
      >({
        path: `/api/purchasing/orders/communications/order`,
        method: 'GET',
        query: query,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags PurchasingOrderCommunicationRemove
     * @name OrdersCommunicationsRemove
     * @request POST:/api/purchasing/orders/communications/remove
     */
    ordersCommunicationsRemove: (
      apiRequest: MainStemAPIPlatformControllersPurchasingOrdersCommunicationPurchasingOrderCommunicationRemoveControllerAPIRequest,
      params: RequestParams = {}
    ) =>
      this.request<
        MainStemAPIPlatformControllersPurchasingOrdersCommunicationPurchasingOrderCommunicationRemoveControllerAPIResponse,
        any
      >({
        path: `/api/purchasing/orders/communications/remove`,
        method: 'POST',
        body: apiRequest,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags PurchasingOrderCommunicationUpdate
     * @name OrdersCommunicationsUpdate
     * @request POST:/api/purchasing/orders/communications/update
     */
    ordersCommunicationsUpdate: (
      apiRequest: MainStemAPIPlatformControllersPurchasingOrdersCommunicationPurchasingOrderCommunicationUpdateControllerAPIRequest,
      params: RequestParams = {}
    ) =>
      this.request<
        MainStemAPIPlatformControllersPurchasingOrdersCommunicationPurchasingOrderCommunicationUpdateControllerAPIResponse,
        any
      >({
        path: `/api/purchasing/orders/communications/update`,
        method: 'POST',
        body: apiRequest,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags PurchasingOrderDuplicate
     * @name OrdersDuplicate
     * @request POST:/api/purchasing/orders/duplicate
     */
    ordersDuplicate: (
      APIRequest: MainStemAPIPlatformControllersPurchasingOrdersDuplicateAPIRequest,
      params: RequestParams = {}
    ) =>
      this.request<MainStemAPIPlatformControllersPurchasingOrdersDuplicateAPIResponse, any>({
        path: `/api/purchasing/orders/duplicate`,
        method: 'POST',
        body: APIRequest,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags PurchasingOrderLineItemCreate
     * @name OrderLineItemCreate
     * @request POST:/api/purchasing/order-line-item/create
     */
    orderLineItemCreate: (
      apiRequest: MainStemAPIPlatformControllersPurchasingOrderLineItemCreateAPIRequest,
      params: RequestParams = {}
    ) =>
      this.request<MainStemAPIPlatformControllersPurchasingOrderLineItemCreateAPIResponse, any>({
        path: `/api/purchasing/order-line-item/create`,
        method: 'POST',
        body: apiRequest,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags PurchasingOrderLineItemDelete
     * @name OrderLineItemDelete
     * @request POST:/api/purchasing/order-line-item/delete
     */
    orderLineItemDelete: (
      apiRequest: MainStemAPIPlatformControllersPurchasingOrderLineItemDeleteAPIRequest,
      params: RequestParams = {}
    ) =>
      this.request<MainStemSDKModelsBaseResponse, any>({
        path: `/api/purchasing/order-line-item/delete`,
        method: 'POST',
        body: apiRequest,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags PurchasingOrderLineItemUpdate
     * @name OrderLineItemUpdate
     * @request POST:/api/purchasing/order-line-item/update
     */
    orderLineItemUpdate: (
      apiRequest: MainStemAPIPlatformControllersPurchasingOrderLineItemUpdateAPIRequest,
      params: RequestParams = {}
    ) =>
      this.request<MainStemSDKModelsBaseResponse, any>({
        path: `/api/purchasing/order-line-item/update`,
        method: 'POST',
        body: apiRequest,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags PurchasingOrdersApprovalApprove
     * @name OrdersApprovalApprove
     * @request POST:/api/purchasing/orders/approval/approve
     */
    ordersApprovalApprove: (
      apiRequest: MainStemAPIPlatformControllersPurchasingOrdersApprovalApproveAPIRequest,
      params: RequestParams = {}
    ) =>
      this.request<MainStemAPIPlatformControllersPurchasingOrdersApprovalApproveAPIResponse, any>({
        path: `/api/purchasing/orders/approval/approve`,
        method: 'POST',
        body: apiRequest,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags PurchasingOrdersApprovalReject
     * @name OrdersApprovalReject
     * @request POST:/api/purchasing/orders/approval/reject
     */
    ordersApprovalReject: (
      apiRequest: MainStemAPIPlatformControllersPurchasingOrdersApprovalRejectAPIRequest,
      params: RequestParams = {}
    ) =>
      this.request<MainStemAPIPlatformControllersPurchasingOrdersApprovalRejectAPIResponse, any>({
        path: `/api/purchasing/orders/approval/reject`,
        method: 'POST',
        body: apiRequest,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags PurchasingOrdersApprovalRevert
     * @name OrdersApprovalRevert
     * @request POST:/api/purchasing/orders/approval/revert
     */
    ordersApprovalRevert: (
      apiRequest: MainStemAPIPlatformControllersPurchasingOrdersApprovalRevertAPIRequest,
      params: RequestParams = {}
    ) =>
      this.request<MainStemAPIPlatformControllersPurchasingOrdersApprovalRevertAPIResponse, any>({
        path: `/api/purchasing/orders/approval/revert`,
        method: 'POST',
        body: apiRequest,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags PurchasingOrdersApprovalSubmitForApproval
     * @name OrdersApprovalSubmitForApproval
     * @request POST:/api/purchasing/orders/approval/submit-for-approval
     */
    ordersApprovalSubmitForApproval: (
      apiRequest: MainStemAPIPlatformControllersPurchasingOrdersApprovalSubmitForApprovalAPIRequest,
      params: RequestParams = {}
    ) =>
      this.request<MainStemAPIPlatformControllersPurchasingOrdersApprovalSubmitForApprovalAPIResponse, any>({
        path: `/api/purchasing/orders/approval/submit-for-approval`,
        method: 'POST',
        body: apiRequest,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags PurchasingOrdersCancel
     * @name OrdersCancel
     * @request POST:/api/purchasing/orders/cancel
     */
    ordersCancel: (
      apiRequest: MainStemAPIPlatformControllersPurchasingOrdersCancelAPIRequest,
      params: RequestParams = {}
    ) =>
      this.request<MainStemSDKModelsBaseResponse, any>({
        path: `/api/purchasing/orders/cancel`,
        method: 'POST',
        body: apiRequest,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags PurchasingOrdersCreate
     * @name OrdersCreate
     * @request POST:/api/purchasing/orders/create
     */
    ordersCreate: (
      apiRequest: MainStemAPIPlatformControllersPurchasingOrdersCreateAPIRequest,
      params: RequestParams = {}
    ) =>
      this.request<MainStemAPIPlatformControllersPurchasingOrdersCreateAPIResponse, any>({
        path: `/api/purchasing/orders/create`,
        method: 'POST',
        body: apiRequest,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags PurchasingOrdersDetails
     * @name OrdersDetails
     * @request POST:/api/purchasing/orders/details
     */
    ordersDetails: (
      apiRequest: MainStemAPIPlatformControllersPurchasingOrdersDetailsAPIRequest,
      params: RequestParams = {}
    ) =>
      this.request<MainStemAPIPlatformControllersPurchasingOrdersDetailsAPIResponse, any>({
        path: `/api/purchasing/orders/details`,
        method: 'POST',
        body: apiRequest,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags PurchasingOrdersDetailsIntegrationsDynamicsDetails
     * @name OrdersDetailsIntegrationsDynamicsDetails
     * @request POST:/api/purchasing/orders/details/integrations/dynamics/details
     */
    ordersDetailsIntegrationsDynamicsDetails: (
      apiRequest: MainStemAPIPlatformControllersPurchasingOrdersDetailsIntegrationsDynamicsDetailsAPIRequest,
      params: RequestParams = {}
    ) =>
      this.request<MainStemAPIPlatformControllersPurchasingOrdersDetailsIntegrationsDynamicsDetailsAPIResponse, any>({
        path: `/api/purchasing/orders/details/integrations/dynamics/details`,
        method: 'POST',
        body: apiRequest,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags PurchasingOrdersDetailsIntegrationsDynamicsOverview
     * @name OrdersDetailsIntegrationsDynamicsOverview
     * @request POST:/api/purchasing/orders/details/integrations/dynamics/overview
     */
    ordersDetailsIntegrationsDynamicsOverview: (
      apiRequest: MainStemAPIPlatformControllersPurchasingOrdersDetailsIntegrationsDynamicsOverviewAPIRequest,
      params: RequestParams = {}
    ) =>
      this.request<MainStemAPIPlatformControllersPurchasingOrdersDetailsIntegrationsDynamicsOverviewAPIResponse, any>({
        path: `/api/purchasing/orders/details/integrations/dynamics/overview`,
        method: 'POST',
        body: apiRequest,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags PurchasingOrdersDetailsIntegrationsQuantumLeafDetails
     * @name OrdersDetailsIntegrationsQuantumLeafDetails
     * @request POST:/api/purchasing/orders/details/integrations/quantum-leaf/details
     */
    ordersDetailsIntegrationsQuantumLeafDetails: (
      apiRequest: MainStemAPIPlatformControllersPurchasingOrdersDetailsIntegrationsQuantumLeafDetailsAPIRequest,
      params: RequestParams = {}
    ) =>
      this.request<MainStemAPIPlatformControllersPurchasingOrdersDetailsIntegrationsQuantumLeafDetailsAPIResponse, any>(
        {
          path: `/api/purchasing/orders/details/integrations/quantum-leaf/details`,
          method: 'POST',
          body: apiRequest,
          type: ContentType.Json,
          format: 'json',
          ...params
        }
      ),

    /**
     * No description
     *
     * @tags PurchasingOrdersDetailsIntegrationsQuantumLeafLogs
     * @name OrdersDetailsIntegrationsQuantumLeafLogs
     * @request POST:/api/purchasing/orders/details/integrations/quantum-leaf/logs
     */
    ordersDetailsIntegrationsQuantumLeafLogs: (
      apiRequest: MainStemAPIPlatformControllersPurchasingOrdersDetailsIntegrationsQuantumLeafLogsAPIRequest,
      params: RequestParams = {}
    ) =>
      this.request<MainStemAPIPlatformControllersPurchasingOrdersDetailsIntegrationsQuantumLeafLogsAPIResponse, any>({
        path: `/api/purchasing/orders/details/integrations/quantum-leaf/logs`,
        method: 'POST',
        body: apiRequest,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags PurchasingOrdersDetailsIntegrationsQuantumLeafOverview
     * @name OrdersDetailsIntegrationsQuantumLeafOverview
     * @request POST:/api/purchasing/orders/details/integrations/quantum-leaf/overview
     */
    ordersDetailsIntegrationsQuantumLeafOverview: (
      apiRequest: MainStemAPIPlatformControllersPurchasingOrdersDetailsIntegrationsQuantumLeafOverviewAPIRequest,
      params: RequestParams = {}
    ) =>
      this.request<
        MainStemAPIPlatformControllersPurchasingOrdersDetailsIntegrationsQuantumLeafOverviewAPIResponse,
        any
      >({
        path: `/api/purchasing/orders/details/integrations/quantum-leaf/overview`,
        method: 'POST',
        body: apiRequest,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags PurchasingOrdersDetailsIntegrationsQuickBooksDetails
     * @name OrdersDetailsIntegrationsQuickbooksDetails
     * @request POST:/api/purchasing/orders/details/integrations/quickbooks/details
     */
    ordersDetailsIntegrationsQuickbooksDetails: (
      apiRequest: MainStemAPIPlatformControllersPurchasingOrdersDetailsIntegrationsQuickbooksDetailsAPIRequest,
      params: RequestParams = {}
    ) =>
      this.request<MainStemAPIPlatformControllersPurchasingOrdersDetailsIntegrationsQuickbooksDetailsAPIResponse, any>({
        path: `/api/purchasing/orders/details/integrations/quickbooks/details`,
        method: 'POST',
        body: apiRequest,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags PurchasingOrdersDetailsIntegrationsQuickBooksOverview
     * @name OrdersDetailsIntegrationsQuickbooksOverview
     * @request POST:/api/purchasing/orders/details/integrations/quickbooks/overview
     */
    ordersDetailsIntegrationsQuickbooksOverview: (
      apiRequest: MainStemAPIPlatformControllersPurchasingOrdersDetailsIntegrationsQuickbooksOverviewAPIRequest,
      params: RequestParams = {}
    ) =>
      this.request<MainStemAPIPlatformControllersPurchasingOrdersDetailsIntegrationsQuickbooksOverviewAPIResponse, any>(
        {
          path: `/api/purchasing/orders/details/integrations/quickbooks/overview`,
          method: 'POST',
          body: apiRequest,
          type: ContentType.Json,
          format: 'json',
          ...params
        }
      ),

    /**
     * No description
     *
     * @tags PurchasingOrdersDetailsPayments
     * @name OrdersDetailsPayments
     * @request POST:/api/purchasing/orders/details/payments
     */
    ordersDetailsPayments: (
      apiRequest: MainStemAPIPlatformControllersPurchasingOrdersDetailsPaymentsAPIRequest,
      params: RequestParams = {}
    ) =>
      this.request<MainStemAPIPlatformControllersPurchasingOrdersDetailsPaymentsAPIResponse, any>({
        path: `/api/purchasing/orders/details/payments`,
        method: 'POST',
        body: apiRequest,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags PurchasingOrdersEmailLog
     * @name OrdersEmailLogs
     * @request POST:/api/purchasing/orders/email/logs
     */
    ordersEmailLogs: (
      apiRequest: MainStemAPIPlatformControllersPurchasingOrdersEmailLogsAPIRequest,
      params: RequestParams = {}
    ) =>
      this.request<MainStemAPIPlatformControllersPurchasingOrdersEmailLogsAPIResponse, any>({
        path: `/api/purchasing/orders/email/logs`,
        method: 'POST',
        body: apiRequest,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags PurchasingOrdersList
     * @name OrdersList
     * @request GET:/api/purchasing/orders/list
     */
    ordersList: (params: RequestParams = {}) =>
      this.request<MainStemAPIPlatformControllersPurchasingOrdersListAPIResponse, any>({
        path: `/api/purchasing/orders/list`,
        method: 'GET',
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags PurchasingOrdersPay
     * @name OrderPay
     * @request POST:/api/purchasing/order/pay
     */
    orderPay: (apiRequest: MainStemAPIPlatformControllersPurchasingOrdersPayAPIRequest, params: RequestParams = {}) =>
      this.request<MainStemSDKModelsBaseResponse, any>({
        path: `/api/purchasing/order/pay`,
        method: 'POST',
        body: apiRequest,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags PurchasingOrdersResendPrivateSupplierEmail
     * @name OrderResendPrivateSupplierEmail
     * @request POST:/api/purchasing/order/resend-private-supplier-email
     */
    orderResendPrivateSupplierEmail: (
      apiRequest: MainStemAPIPlatformControllersPurchasingOrdersResendPrivateSupplierEmailAPIRequest,
      params: RequestParams = {}
    ) =>
      this.request<MainStemAPIPlatformControllersPurchasingOrdersResendPrivateSupplierEmailAPIResponse, any>({
        path: `/api/purchasing/order/resend-private-supplier-email`,
        method: 'POST',
        body: apiRequest,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags PurchasingOrdersRevert
     * @name OrdersRevert
     * @request POST:/api/purchasing/orders/revert
     */
    ordersRevert: (
      apiRequest: MainStemAPIPlatformControllersPurchasingOrdersRevertAPIRequest,
      params: RequestParams = {}
    ) =>
      this.request<MainStemSDKModelsBaseResponse, any>({
        path: `/api/purchasing/orders/revert`,
        method: 'POST',
        body: apiRequest,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags PurchasingOrdersSubmitPaymentMethodsList
     * @name OrdersSubmitPaymentMethodsList
     * @request GET:/api/purchasing/orders/submit/paymentMethods/list
     */
    ordersSubmitPaymentMethodsList: (
      query?: {
        apiRequestOrderUuid?: string
      },
      params: RequestParams = {}
    ) =>
      this.request<MainStemAPIPlatformControllersPurchasingOrdersSubmitPaymentMethodsListAPIResponse, any>({
        path: `/api/purchasing/orders/submit/paymentMethods/list`,
        method: 'GET',
        query: query,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags PurchasingOrderTotalsOverview
     * @name OrdersOrderTotalsOverview
     * @request POST:/api/purchasing/orders/orderTotalsOverview
     */
    ordersOrderTotalsOverview: (
      apiRequest: MainStemAPIPlatformControllersPurchasingOrdersDetailsOrderTotalsOverviewAPIRequest,
      params: RequestParams = {}
    ) =>
      this.request<MainStemAPIPlatformControllersPurchasingOrdersDetailsOrderTotalsOverviewAPIResponse, any>({
        path: `/api/purchasing/orders/orderTotalsOverview`,
        method: 'POST',
        body: apiRequest,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags PurchasingOrderUpdate
     * @name OrdersUpdate
     * @request POST:/api/purchasing/orders/update
     */
    ordersUpdate: (
      apiRequest: MainStemAPIPlatformControllersPurchasingOrdersUpdateAPIRequest,
      params: RequestParams = {}
    ) =>
      this.request<MainStemSDKModelsBaseResponse, any>({
        path: `/api/purchasing/orders/update`,
        method: 'POST',
        body: apiRequest,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags PurchasingOrderUpdateAddress
     * @name OrdersUpdateAddress
     * @request POST:/api/purchasing/orders/updateAddress
     */
    ordersUpdateAddress: (
      apiRequest: MainStemAPIPlatformControllersPurchasingOrdersUpdateAddressAPIRequest,
      params: RequestParams = {}
    ) =>
      this.request<MainStemSDKModelsBaseResponse, any>({
        path: `/api/purchasing/orders/updateAddress`,
        method: 'POST',
        body: apiRequest,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags PurchasingPaymentMethodsCreateACH
     * @name PaymentMethodsCreateAch
     * @request POST:/api/purchasing/paymentMethods/create/ach
     */
    paymentMethodsCreateAch: (
      apiRequest: MainStemAPIPlatformControllersPurchasingPaymentMethodsCreateACHAPIRequest,
      params: RequestParams = {}
    ) =>
      this.request<MainStemAPIPlatformControllersPurchasingPaymentMethodsCreateACHAPIResponse, any>({
        path: `/api/purchasing/paymentMethods/create/ach`,
        method: 'POST',
        body: apiRequest,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags PurchasingPaymentMethodsCreateCreditCard
     * @name PaymentMethodsCreateCreditCard
     * @request POST:/api/purchasing/paymentMethods/create/creditCard
     */
    paymentMethodsCreateCreditCard: (
      apiRequest: MainStemAPIPlatformControllersPurchasingPaymentMethodsCreateCreditCardAPIRequest,
      params: RequestParams = {}
    ) =>
      this.request<MainStemAPIPlatformControllersPurchasingPaymentMethodsCreateCreditCardAPIResponse, any>({
        path: `/api/purchasing/paymentMethods/create/creditCard`,
        method: 'POST',
        body: apiRequest,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags PurchasingPaymentMethodsList
     * @name PaymentMethodsList
     * @request GET:/api/purchasing/paymentMethods/list
     */
    paymentMethodsList: (params: RequestParams = {}) =>
      this.request<MainStemAPIPlatformControllersPurchasingPaymentMethodsListAPIResponse, any>({
        path: `/api/purchasing/paymentMethods/list`,
        method: 'GET',
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags PurchasingPermissionGroupCreate
     * @name PermissionGroupCreate
     * @request POST:/api/purchasing/permission-group/create
     */
    permissionGroupCreate: (
      apiRequest: MainStemAPIPlatformControllersPurchasingPermissionGroupCreateAPIRequest,
      params: RequestParams = {}
    ) =>
      this.request<MainStemAPIPlatformControllersPurchasingPermissionGroupCreateAPIResponse, any>({
        path: `/api/purchasing/permission-group/create`,
        method: 'POST',
        body: apiRequest,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags PurchasingPermissionGroupDelete
     * @name PermissionGroupDelete
     * @request POST:/api/purchasing/permission-group/delete
     */
    permissionGroupDelete: (
      apiRequest: MainStemAPIPlatformControllersPurchasingPermissionGroupDeleteAPIRequest,
      params: RequestParams = {}
    ) =>
      this.request<MainStemAPIPlatformControllersPurchasingPermissionGroupDeleteAPIResponse, any>({
        path: `/api/purchasing/permission-group/delete`,
        method: 'POST',
        body: apiRequest,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags PurchasingPermissionGroupList
     * @name PermissionGroupList
     * @request GET:/api/purchasing/permission-group/list
     */
    permissionGroupList: (params: RequestParams = {}) =>
      this.request<MainStemAPIPlatformControllersPurchasingPermissionGroupListAPIResponse, any>({
        path: `/api/purchasing/permission-group/list`,
        method: 'GET',
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags PurchasingPermissionGroupUpdate
     * @name PermissionGroupUpdate
     * @request POST:/api/purchasing/permission-group/update
     */
    permissionGroupUpdate: (
      apiRequest: MainStemAPIPlatformControllersPurchasingPermissionGroupUpdateAPIRequest,
      params: RequestParams = {}
    ) =>
      this.request<MainStemAPIPlatformControllersPurchasingPermissionGroupUpdateAPIResponse, any>({
        path: `/api/purchasing/permission-group/update`,
        method: 'POST',
        body: apiRequest,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags PurchasingPermissionGroupUsersAdd
     * @name PermissionGroupAddUserToGroup
     * @request POST:/api/purchasing/permissionGroup/addUserToGroup
     */
    permissionGroupAddUserToGroup: (
      apiRequest: MainStemAPIPlatformControllersPurchasingPermissionGroupUsersAddAPIRequest,
      params: RequestParams = {}
    ) =>
      this.request<MainStemAPIPlatformControllersPurchasingPermissionGroupUsersAddAPIResponse, any>({
        path: `/api/purchasing/permissionGroup/addUserToGroup`,
        method: 'POST',
        body: apiRequest,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags PurchasingPermissionGroupUsersAdd
     * @name PermissionGroupUsersAdd
     * @request POST:/api/purchasing/permission-group/users/add
     */
    permissionGroupUsersAdd: (
      apiRequest: MainStemAPIPlatformControllersPurchasingPermissionGroupUsersAddAPIRequest,
      params: RequestParams = {}
    ) =>
      this.request<MainStemAPIPlatformControllersPurchasingPermissionGroupUsersAddAPIResponse, any>({
        path: `/api/purchasing/permission-group/users/add`,
        method: 'POST',
        body: apiRequest,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags PurchasingPermissionGroupUsersNotInGroup
     * @name PermissionGroupUsersNotInGroup
     * @request POST:/api/purchasing/permission-group/users/not-in-group
     */
    permissionGroupUsersNotInGroup: (
      apiRequest: MainStemAPIPlatformControllersPurchasingPermissionGroupUsersNotInGroupAPIRequest,
      params: RequestParams = {}
    ) =>
      this.request<MainStemAPIPlatformControllersPurchasingPermissionGroupUsersNotInGroupAPIResponse, any>({
        path: `/api/purchasing/permission-group/users/not-in-group`,
        method: 'POST',
        body: apiRequest,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags PurchasingPermissionGroupUsersRemove
     * @name PermissionGroupRemoveUserFromGroup
     * @request POST:/api/purchasing/permissionGroup/removeUserFromGroup
     */
    permissionGroupRemoveUserFromGroup: (
      apiRequest: MainStemAPIPlatformControllersPurchasingPermissionGroupUsersRemoveAPIRequest,
      params: RequestParams = {}
    ) =>
      this.request<MainStemAPIPlatformControllersPurchasingPermissionGroupUsersRemoveAPIResponse, any>({
        path: `/api/purchasing/permissionGroup/removeUserFromGroup`,
        method: 'POST',
        body: apiRequest,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags PurchasingPermissionGroupUsersRemove
     * @name PermissionGroupUsersRemove
     * @request POST:/api/purchasing/permission-group/users/remove
     */
    permissionGroupUsersRemove: (
      apiRequest: MainStemAPIPlatformControllersPurchasingPermissionGroupUsersRemoveAPIRequest,
      params: RequestParams = {}
    ) =>
      this.request<MainStemAPIPlatformControllersPurchasingPermissionGroupUsersRemoveAPIResponse, any>({
        path: `/api/purchasing/permission-group/users/remove`,
        method: 'POST',
        body: apiRequest,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags PurchasingPermissionGroupValueCreate
     * @name PermissionGroupValueCreate
     * @request POST:/api/purchasing/permission-group-value/create
     */
    permissionGroupValueCreate: (
      apiRequest: MainStemAPIPlatformControllersPurchasingPermissionGroupValueCreateAPIRequest,
      params: RequestParams = {}
    ) =>
      this.request<MainStemAPIPlatformControllersPurchasingPermissionGroupValueCreateAPIResponse, any>({
        path: `/api/purchasing/permission-group-value/create`,
        method: 'POST',
        body: apiRequest,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags PurchasingPermissionGroupValueDelete
     * @name PermissionGroupValueDelete
     * @request POST:/api/purchasing/permission-group-value/delete
     */
    permissionGroupValueDelete: (
      apiRequest: MainStemAPIPlatformControllersPurchasingPermissionGroupValueDeleteAPIRequest,
      params: RequestParams = {}
    ) =>
      this.request<MainStemAPIPlatformControllersPurchasingPermissionGroupValueDeleteAPIResponse, any>({
        path: `/api/purchasing/permission-group-value/delete`,
        method: 'POST',
        body: apiRequest,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags PurchasingPermissionGroupValueList
     * @name PermissionGroupValueList
     * @request POST:/api/purchasing/permission-group-value/list
     */
    permissionGroupValueList: (
      apiRequest: MainStemAPIPlatformControllersPurchasingPermissionGroupValueListAPIRequest,
      params: RequestParams = {}
    ) =>
      this.request<MainStemAPIPlatformControllersPurchasingPermissionGroupValueListAPIResponse, any>({
        path: `/api/purchasing/permission-group-value/list`,
        method: 'POST',
        body: apiRequest,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags PurchasingPermissionGroupValueUpdate
     * @name PermissionGroupValueUpdate
     * @request POST:/api/purchasing/permission-group-value/update
     */
    permissionGroupValueUpdate: (
      apiRequest: MainStemAPIPlatformControllersPurchasingPermissionGroupValueUpdateAPIRequest,
      params: RequestParams = {}
    ) =>
      this.request<MainStemAPIPlatformControllersPurchasingPermissionGroupValueUpdateAPIResponse, any>({
        path: `/api/purchasing/permission-group-value/update`,
        method: 'POST',
        body: apiRequest,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags PurchasingPermissionList
     * @name PermissionList
     * @request GET:/api/purchasing/permission/list
     */
    permissionList: (params: RequestParams = {}) =>
      this.request<MainStemAPIPlatformControllersPurchasingPermissionListAPIResponse, any>({
        path: `/api/purchasing/permission/list`,
        method: 'GET',
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags PurchasingPrivateProductAttributeValuesCreate
     * @name PrivateProductsAttributeValuesCreate
     * @request POST:/api/purchasing/privateProducts/attribute-values/create
     */
    privateProductsAttributeValuesCreate: (
      apiRequest: MainStemAPIPlatformControllersPurchasingPrivateProductAttributeValuesCreateAPIRequest,
      params: RequestParams = {}
    ) =>
      this.request<MainStemSDKModelsBaseResponse, any>({
        path: `/api/purchasing/privateProducts/attribute-values/create`,
        method: 'POST',
        body: apiRequest,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags PurchasingPrivateProductsAttributeValuesDelete
     * @name PrivateProductsAttributeValuesDelete
     * @request POST:/api/purchasing/privateProducts/attribute-values/delete
     */
    privateProductsAttributeValuesDelete: (
      apiRequest: MainStemAPIPlatformControllersPurchasingPrivateProductAttributeValuesDeleteAPIRequest,
      params: RequestParams = {}
    ) =>
      this.request<MainStemSDKModelsBaseResponse, any>({
        path: `/api/purchasing/privateProducts/attribute-values/delete`,
        method: 'POST',
        body: apiRequest,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags PurchasingPrivateProductVolumePricingCreate
     * @name PrivateProductsVolumePricingCreate
     * @request POST:/api/purchasing/private-products/volume-pricing/create
     */
    privateProductsVolumePricingCreate: (
      apiRequest: MainStemAPIPlatformControllersPurchasingPrivateProductVolumePricingCreateAPIRequest,
      params: RequestParams = {}
    ) =>
      this.request<MainStemSDKModelsBaseResponse, any>({
        path: `/api/purchasing/private-products/volume-pricing/create`,
        method: 'POST',
        body: apiRequest,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags PurchasingPrivateProductVolumePricingDelete
     * @name PrivateProductsVolumePricingDelete
     * @request POST:/api/purchasing/private-products/volume-pricing/delete
     */
    privateProductsVolumePricingDelete: (
      apiRequest: MainStemAPIPlatformControllersPurchasingPrivateProductVolumePricingDeleteAPIRequest,
      params: RequestParams = {}
    ) =>
      this.request<MainStemSDKModelsBaseResponse, any>({
        path: `/api/purchasing/private-products/volume-pricing/delete`,
        method: 'POST',
        body: apiRequest,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags PurchasingPrivateSupplierArchive
     * @name PrivateSupplierArchive
     * @request POST:/api/purchasing/private-supplier/archive
     */
    privateSupplierArchive: (
      apiRequest: MainStemAPIPlatformControllersPurchasingPrivateSuppliersArchiveAPIRequest,
      params: RequestParams = {}
    ) =>
      this.request<MainStemSDKModelsBaseResponse, any>({
        path: `/api/purchasing/private-supplier/archive`,
        method: 'POST',
        body: apiRequest,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags PurchasingPrivateSupplierCreate
     * @name PrivateSupplierCreate
     * @request POST:/api/purchasing/privateSupplier/create
     */
    privateSupplierCreate: (
      apiRequest: MainStemAPIPlatformControllersPurchasingPrivateSuppliersCreateAPIRequest,
      params: RequestParams = {}
    ) =>
      this.request<MainStemAPIPlatformControllersPurchasingPrivateSuppliersCreateAPIResponse, any>({
        path: `/api/purchasing/privateSupplier/create`,
        method: 'POST',
        body: apiRequest,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags PurchasingPrivateSupplierDelete
     * @name PrivateSupplierDelete
     * @request POST:/api/purchasing/privateSupplier/delete
     */
    privateSupplierDelete: (
      apiRequest: MainStemAPIPlatformControllersPurchasingPrivateSuppliersDeleteAPIRequest,
      params: RequestParams = {}
    ) =>
      this.request<MainStemSDKModelsBaseResponse, any>({
        path: `/api/purchasing/privateSupplier/delete`,
        method: 'POST',
        body: apiRequest,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags PurchasingPrivateSuppliers
     * @name SuppliersUpdate
     * @request POST:/api/purchasing/suppliers/update
     */
    suppliersUpdate: (
      apiRequest: MainStemAPIPlatformControllersPurchasingSuppliersUpdateAPIRequest,
      params: RequestParams = {}
    ) =>
      this.request<MainStemSDKModelsBaseResponse, any>({
        path: `/api/purchasing/suppliers/update`,
        method: 'POST',
        body: apiRequest,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags PurchasingPrivateSuppliersDuplicate
     * @name PrivateSuppliersDuplicate
     * @request POST:/api/purchasing/private-suppliers/duplicate
     */
    privateSuppliersDuplicate: (
      apiRequest: MainStemAPIPlatformControllersPurchasingPrivateSuppliersDuplicateAPIRequest,
      params: RequestParams = {}
    ) =>
      this.request<MainStemAPIPlatformControllersPurchasingPrivateSuppliersDuplicateAPIResponse, any>({
        path: `/api/purchasing/private-suppliers/duplicate`,
        method: 'POST',
        body: apiRequest,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags PurchasingPrivateSupplierUpdateHeader
     * @name PrivateSupplierUpdateHeader
     * @request POST:/api/purchasing/private-supplier/update-header
     */
    privateSupplierUpdateHeader: (
      query: {
        /** @format int32 */
        id: number
      },
      params: RequestParams = {}
    ) =>
      this.request<MainStemAPIPlatformControllersPurchasingBulkOrderCreateAPIRequest, any>({
        path: `/api/purchasing/private-supplier/update-header`,
        method: 'POST',
        query: query,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags PurchasingPrivateSupplierUpdateLogo
     * @name PrivateSupplierUpdateLogo
     * @request POST:/api/purchasing/privateSupplier/updateLogo
     */
    privateSupplierUpdateLogo: (
      query: {
        /** @format int32 */
        id: number
      },
      params: RequestParams = {}
    ) =>
      this.request<MainStemAPIPlatformControllersPurchasingBulkOrderCreateAPIRequest, any>({
        path: `/api/purchasing/privateSupplier/updateLogo`,
        method: 'POST',
        query: query,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags PurchasingProductsAllocationsList
     * @name ProductsAllocationsList
     * @request POST:/api/purchasing/products/allocations/list
     */
    productsAllocationsList: (
      apiRequest: MainStemAPIPlatformControllersPurchasingProductsAllocationsListAPIRequest,
      params: RequestParams = {}
    ) =>
      this.request<MainStemAPIPlatformControllersPurchasingProductsAllocationsListAPIResponse, any>({
        path: `/api/purchasing/products/allocations/list`,
        method: 'POST',
        body: apiRequest,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags PurchasingProductsArchive
     * @name ProductsArchive
     * @request POST:/api/purchasing/products/archive
     */
    productsArchive: (
      apiRequest: MainStemAPIPlatformControllersPurchasingProductsArchiveAPIRequest,
      params: RequestParams = {}
    ) =>
      this.request<MainStemAPIPlatformControllersPurchasingProductsArchiveAPIResponse, any>({
        path: `/api/purchasing/products/archive`,
        method: 'POST',
        body: apiRequest,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags PurchasingProductsAttributesList
     * @name ProductsAttributesList
     * @request POST:/api/purchasing/products/attributes/list
     */
    productsAttributesList: (
      apiRequest: MainStemAPIPlatformControllersPurchasingProductsAttributesListAPIRequest,
      params: RequestParams = {}
    ) =>
      this.request<MainStemAPIPlatformControllersPurchasingProductsAttributesListAPIResponse, any>({
        path: `/api/purchasing/products/attributes/list`,
        method: 'POST',
        body: apiRequest,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags PurchasingProductsCatalogsList
     * @name ProductsCatalogsList
     * @request POST:/api/purchasing/products/catalogs/list
     */
    productsCatalogsList: (
      apiRequest: MainStemAPIPlatformControllersPurchasingProductsCatalogsListAPIRequest,
      params: RequestParams = {}
    ) =>
      this.request<MainStemAPIPlatformControllersPurchasingProductsCatalogsListAPIResponse, any>({
        path: `/api/purchasing/products/catalogs/list`,
        method: 'POST',
        body: apiRequest,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags PurchasingProductsCreate
     * @name ProductsCreate
     * @request POST:/api/purchasing/products/create
     */
    productsCreate: (
      apiRequest: MainStemAPIPlatformControllersPurchasingProductsCreateAPIRequest,
      params: RequestParams = {}
    ) =>
      this.request<MainStemAPIPlatformControllersPurchasingProductsCreateAPIResponse, any>({
        path: `/api/purchasing/products/create`,
        method: 'POST',
        body: apiRequest,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags PurchasingProductsDetails
     * @name ProductsDetails
     * @request POST:/api/purchasing/products/details
     */
    productsDetails: (
      apiRequest: MainStemAPIPlatformControllersPurchasingProductsDetailsAPIRequest,
      params: RequestParams = {}
    ) =>
      this.request<MainStemAPIPlatformControllersPurchasingProductsDetailsAPIResponse, any>({
        path: `/api/purchasing/products/details`,
        method: 'POST',
        body: apiRequest,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags PurchasingProductsDuplicate
     * @name ProductsDuplicate
     * @request POST:/api/purchasing/products/duplicate
     */
    productsDuplicate: (
      apiRequest: MainStemAPIPlatformControllersPurchasingProductsDuplicateAPIRequest,
      params: RequestParams = {}
    ) =>
      this.request<MainStemAPIPlatformControllersPurchasingProductsDuplicateAPIResponse, any>({
        path: `/api/purchasing/products/duplicate`,
        method: 'POST',
        body: apiRequest,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags PurchasingProductsList
     * @name ProductsList
     * @request GET:/api/purchasing/products/list
     */
    productsList: (params: RequestParams = {}) =>
      this.request<MainStemAPIPlatformControllersPurchasingProductsListAPIResponse, any>({
        path: `/api/purchasing/products/list`,
        method: 'GET',
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags PurchasingProductsOrdersList
     * @name ProductsOrdersList
     * @request POST:/api/purchasing/products/orders/list
     */
    productsOrdersList: (
      apiRequest: MainStemAPIPlatformControllersPurchasingProductsOrdersListAPIRequest,
      params: RequestParams = {}
    ) =>
      this.request<MainStemAPIPlatformControllersPurchasingProductsOrdersListAPIResponse, any>({
        path: `/api/purchasing/products/orders/list`,
        method: 'POST',
        body: apiRequest,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags PurchasingProductsReceivingList
     * @name ProductsReceivingList
     * @request POST:/api/purchasing/products/receiving/list
     */
    productsReceivingList: (
      apiRequest: MainStemAPIPlatformControllersPurchasingProductsReceivingListAPIRequest,
      params: RequestParams = {}
    ) =>
      this.request<MainStemAPIPlatformControllersPurchasingProductsReceivingListAPIResponse, any>({
        path: `/api/purchasing/products/receiving/list`,
        method: 'POST',
        body: apiRequest,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags PurchasingProductsShipmentsList
     * @name ProductsShipmentsList
     * @request POST:/api/purchasing/products/shipments/list
     */
    productsShipmentsList: (
      apiRequest: MainStemAPIPlatformControllersPurchasingProductsShipmentsListAPIRequest,
      params: RequestParams = {}
    ) =>
      this.request<MainStemAPIPlatformControllersPurchasingProductsShipmentsListAPIResponse, any>({
        path: `/api/purchasing/products/shipments/list`,
        method: 'POST',
        body: apiRequest,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags PurchasingProductsUpdate
     * @name ProductsUpdate
     * @request POST:/api/purchasing/products/update
     */
    productsUpdate: (
      apiRequest: MainStemAPIPlatformControllersPurchasingProductsUpdateAPIRequest,
      params: RequestParams = {}
    ) =>
      this.request<MainStemAPIPlatformControllersPurchasingProductsUpdateAPIResponse, any>({
        path: `/api/purchasing/products/update`,
        method: 'POST',
        body: apiRequest,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags PurchasingProductsUpdateImage
     * @name ProductsUpdateImage
     * @request POST:/api/purchasing/products/update/image
     */
    productsUpdateImage: (
      query: {
        /** @format int32 */
        id: number
      },
      params: RequestParams = {}
    ) =>
      this.request<MainStemAPIPlatformControllersPurchasingBulkOrderCreateAPIRequest, any>({
        path: `/api/purchasing/products/update/image`,
        method: 'POST',
        query: query,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags PurchasingPunchoutRequestSession
     * @name PunchoutsSetup
     * @request POST:/api/purchasing/punchouts/setup
     */
    punchoutsSetup: (
      apiRequest: MainStemAPIPlatformControllersPurchasingPunchoutsRequestSessionAPIRequest,
      params: RequestParams = {}
    ) =>
      this.request<MainStemAPIPlatformControllersPurchasingPunchoutsRequestSessionAPIResponse, any>({
        path: `/api/purchasing/punchouts/setup`,
        method: 'POST',
        body: apiRequest,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags PurchasingPunchoutSettingsAddLocations
     * @name PunchoutsAddLocations
     * @request POST:/api/purchasing/punchouts/add-locations
     */
    punchoutsAddLocations: (
      apiRequest: MainStemAPIPlatformControllersPurchasingPunchoutsSettingsAddLocationsAPIRequest,
      params: RequestParams = {}
    ) =>
      this.request<MainStemSDKModelsBaseResponse, any>({
        path: `/api/purchasing/punchouts/add-locations`,
        method: 'POST',
        body: apiRequest,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags PurchasingPunchoutSettingsCreate
     * @name PunchoutsCreate
     * @request POST:/api/purchasing/punchouts/create
     */
    punchoutsCreate: (
      apiRequest: MainStemAPIPlatformControllersPurchasingPunchoutsSettingsCreatePunchoutAPIRequest,
      params: RequestParams = {}
    ) =>
      this.request<MainStemAPIPlatformControllersPurchasingPunchoutsSettingsCreatePunchoutAPIResponse, any>({
        path: `/api/purchasing/punchouts/create`,
        method: 'POST',
        body: apiRequest,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags PurchasingPunchoutSettingsDetails
     * @name PunchoutsDetails
     * @request POST:/api/purchasing/punchouts/details
     */
    punchoutsDetails: (
      apiRequest: MainStemAPIPlatformControllersPurchasingPunchoutsSettingsDetailsAPIRequest,
      params: RequestParams = {}
    ) =>
      this.request<MainStemAPIPlatformControllersPurchasingPunchoutsSettingsDetailsAPIResponse, any>({
        path: `/api/purchasing/punchouts/details`,
        method: 'POST',
        body: apiRequest,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags PurchasingPunchoutSettingsList
     * @name PunchoutsList
     * @request POST:/api/purchasing/punchouts/list
     */
    punchoutsList: (params: RequestParams = {}) =>
      this.request<MainStemAPIPlatformControllersPurchasingPunchoutsSettingsListAPIResponse, any>({
        path: `/api/purchasing/punchouts/list`,
        method: 'POST',
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags PurchasingPunchoutSettingsRemoveLocations
     * @name PunchoutsRemoveLocations
     * @request POST:/api/purchasing/punchouts/remove-locations
     */
    punchoutsRemoveLocations: (
      apiRequest: MainStemAPIPlatformControllersPurchasingPunchoutsSettingsRemoveLocationsAPIRequest,
      params: RequestParams = {}
    ) =>
      this.request<MainStemSDKModelsBaseResponse, any>({
        path: `/api/purchasing/punchouts/remove-locations`,
        method: 'POST',
        body: apiRequest,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags PurchasingPunchoutSettingsUpdate
     * @name PunchoutsUpdate
     * @request POST:/api/purchasing/punchouts/update
     */
    punchoutsUpdate: (
      apiRequest: MainStemAPIPlatformControllersPurchasingPunchoutsSettingsUpdateAPIRequest,
      params: RequestParams = {}
    ) =>
      this.request<MainStemSDKModelsBaseResponse, any>({
        path: `/api/purchasing/punchouts/update`,
        method: 'POST',
        body: apiRequest,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags PurchasingPunchoutsOrderComplete
     * @name PunchoutsOrderComplete
     * @request POST:/api/purchasing/punchouts/order-complete
     */
    punchoutsOrderComplete: (
      apiRequest: MainStemAPIPlatformControllersPurchasingPunchoutsOrderCompleteAPIRequest,
      params: RequestParams = {}
    ) =>
      this.request<MainStemAPIPlatformControllersPurchasingPunchoutsOrderCompleteAPIResponse, any>({
        path: `/api/purchasing/punchouts/order-complete`,
        method: 'POST',
        body: apiRequest,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags PurchasingPurchaseOrderDiscountsCreate
     * @name PurchaseOrdersDiscountsCreate
     * @request POST:/api/purchasing/purchase-orders/discounts/create
     */
    purchaseOrdersDiscountsCreate: (
      apiRequest: MainStemAPIPlatformControllersPurchasingPurchaseOrdersDiscountsCreateAPIRequest,
      params: RequestParams = {}
    ) =>
      this.request<MainStemAPIPlatformControllersPurchasingPurchaseOrdersDiscountsCreateAPIResponse, any>({
        path: `/api/purchasing/purchase-orders/discounts/create`,
        method: 'POST',
        body: apiRequest,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags PurchasingPurchaseOrderFeesCreate
     * @name PurchaseOrdersFeesCreate
     * @request POST:/api/purchasing/purchase-orders/fees/create
     */
    purchaseOrdersFeesCreate: (
      apiRequest: MainStemAPIPlatformControllersPurchasingPurchaseOrdersFeesCreateAPIRequest,
      params: RequestParams = {}
    ) =>
      this.request<MainStemAPIPlatformControllersPurchasingPurchaseOrdersFeesCreateAPIResponse, any>({
        path: `/api/purchasing/purchase-orders/fees/create`,
        method: 'POST',
        body: apiRequest,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags PurchasingPurchaseOrderFeesDelete
     * @name PurchaseOrdersFeesDelete
     * @request POST:/api/purchasing/purchase-orders/fees/delete
     */
    purchaseOrdersFeesDelete: (
      APIRequest: MainStemAPIPlatformControllersPurchasingPurchaseOrdersFeesDeleteAPIRequest,
      params: RequestParams = {}
    ) =>
      this.request<MainStemAPIPlatformControllersPurchasingPurchaseOrdersFeesDeleteAPIResponse, any>({
        path: `/api/purchasing/purchase-orders/fees/delete`,
        method: 'POST',
        body: APIRequest,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags PurchasingPurchaseOrdersAllocationsDelete
     * @name PurchaseOrdersAllocationsDelete
     * @request POST:/api/purchasing/purchase-orders/allocations/delete
     */
    purchaseOrdersAllocationsDelete: (
      apiRequest: MainStemAPIPlatformControllersPurchasingPurchaseOrdersAllocationsDeleteAPIRequest,
      params: RequestParams = {}
    ) =>
      this.request<MainStemAPIPlatformControllersPurchasingPurchaseOrdersAllocationsDeleteAPIResponse, any>({
        path: `/api/purchasing/purchase-orders/allocations/delete`,
        method: 'POST',
        body: apiRequest,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags PurchasingPurchaseOrdersAllocationsEnable
     * @name PurchaseOrdersAllocationsEnable
     * @request POST:/api/purchasing/purchase-orders/allocations/enable
     */
    purchaseOrdersAllocationsEnable: (
      apiRequest: MainStemAPIPlatformControllersPurchasingPurchaseOrdersAllocationsEnableAPIRequest,
      params: RequestParams = {}
    ) =>
      this.request<MainStemAPIPlatformControllersPurchasingPurchaseOrdersAllocationsEnableAPIResponse, any>({
        path: `/api/purchasing/purchase-orders/allocations/enable`,
        method: 'POST',
        body: apiRequest,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags PurchasingPurchaseOrdersAllocationsUpdate
     * @name PurchaseOrdersAllocationsUpdate
     * @request POST:/api/purchasing/purchase-orders/allocations/update
     */
    purchaseOrdersAllocationsUpdate: (
      apiRequest: MainStemAPIPlatformControllersPurchasingPurchaseOrdersAllocationsUpdateAPIRequest,
      params: RequestParams = {}
    ) =>
      this.request<MainStemAPIPlatformControllersPurchasingPurchaseOrdersAllocationsUpdateAPIResponse, any>({
        path: `/api/purchasing/purchase-orders/allocations/update`,
        method: 'POST',
        body: apiRequest,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags PurchasingPurchaseOrdersDetails
     * @name PurchaseOrdersDetails
     * @request POST:/api/purchasing/purchase-orders/details
     */
    purchaseOrdersDetails: (
      apiRequest: MainStemAPIPlatformControllersPurchasingPurchaseOrdersDetailsAPIRequest,
      params: RequestParams = {}
    ) =>
      this.request<MainStemAPIPlatformControllersPurchasingPurchaseOrdersDetailsAPIResponse, any>({
        path: `/api/purchasing/purchase-orders/details`,
        method: 'POST',
        body: apiRequest,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags PurchasingPurchaseOrdersList
     * @name PurchaseOrdersList
     * @request POST:/api/purchasing/purchase-orders/list
     */
    purchaseOrdersList: (params: RequestParams = {}) =>
      this.request<MainStemAPIPlatformControllersPurchasingPurchaseOrdersListAPIResponse, any>({
        path: `/api/purchasing/purchase-orders/list`,
        method: 'POST',
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags PurchasingPurchaseOrdersSalesTaxCalculate
     * @name PurchaseOrdersSalesTaxCalculate
     * @request POST:/api/purchasing/purchase-orders/sales-tax/calculate
     */
    purchaseOrdersSalesTaxCalculate: (
      apiRequest: MainStemAPIPlatformControllersPurchasingPurchaseOrdersSalesTaxCalculateAPIRequest,
      params: RequestParams = {}
    ) =>
      this.request<MainStemAPIPlatformControllersPurchasingPurchaseOrdersSalesTaxCalculateAPIResponse, any>({
        path: `/api/purchasing/purchase-orders/sales-tax/calculate`,
        method: 'POST',
        body: apiRequest,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags PurchasingPurchaseOrdersSalesTaxUpdate
     * @name PurchaseOrdersSalesTaxUpdate
     * @request POST:/api/purchasing/purchase-orders/sales-tax/update
     */
    purchaseOrdersSalesTaxUpdate: (
      apiRequest: MainStemAPIPlatformControllersPurchasingPurchaseOrdersSalesTaxUpdateAPIRequest,
      params: RequestParams = {}
    ) =>
      this.request<MainStemAPIPlatformControllersPurchasingPurchaseOrdersSalesTaxUpdateAPIResponse, any>({
        path: `/api/purchasing/purchase-orders/sales-tax/update`,
        method: 'POST',
        body: apiRequest,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags PurchasingPurchaseOrdersShippingCalculate
     * @name PurchaseOrdersShippingCalculate
     * @request POST:/api/purchasing/purchase-orders/shipping/calculate
     */
    purchaseOrdersShippingCalculate: (
      apiRequest: MainStemAPIPlatformControllersPurchasingPurchaseOrdersShippingCalculateAPIRequest,
      params: RequestParams = {}
    ) =>
      this.request<MainStemAPIPlatformControllersPurchasingPurchaseOrdersShippingCalculateAPIResponse, any>({
        path: `/api/purchasing/purchase-orders/shipping/calculate`,
        method: 'POST',
        body: apiRequest,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags PurchasingPurchaseOrdersShippingUpdate
     * @name PurchaseOrdersShippingUpdate
     * @request POST:/api/purchasing/purchase-orders/shipping/update
     */
    purchaseOrdersShippingUpdate: (
      apiRequest: MainStemAPIPlatformControllersPurchasingPurchaseOrdersShippingUpdateAPIRequest,
      params: RequestParams = {}
    ) =>
      this.request<MainStemAPIPlatformControllersPurchasingPurchaseOrdersShippingUpdateAPIResponse, any>({
        path: `/api/purchasing/purchase-orders/shipping/update`,
        method: 'POST',
        body: apiRequest,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags PurchasingQuickBooksCreateMany
     * @name IntegrationsQuickbooksItemsCreateMany
     * @request POST:/api/purchasing/integrations/quickbooks/items/create-many
     */
    integrationsQuickbooksItemsCreateMany: (
      apiRequest: MainStemAPIPlatformControllersPurchasingIntegrationQuickBooksItemsCreateManyAPIRequest,
      params: RequestParams = {}
    ) =>
      this.request<MainStemAPIPlatformControllersPurchasingIntegrationQuickBooksItemsCreateManyAPIResponse, any>({
        path: `/api/purchasing/integrations/quickbooks/items/create-many`,
        method: 'POST',
        body: apiRequest,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags PurchasingQuickBooksCustomerProducts
     * @name IntegrationsQuickbooksCustomerProducts
     * @request POST:/api/purchasing/integrations/quickbooks/customerProducts
     */
    integrationsQuickbooksCustomerProducts: (
      apiRequest: MainStemAPIPlatformControllersPurchasingIntegrationQuickBooksCustomerProductsAPIRequest,
      params: RequestParams = {}
    ) =>
      this.request<MainStemAPIPlatformControllersPurchasingIntegrationQuickBooksCustomerProductsAPIResponse, any>({
        path: `/api/purchasing/integrations/quickbooks/customerProducts`,
        method: 'POST',
        body: apiRequest,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags PurchasingQuickBooksUpdateItemLink
     * @name IntegrationsQuickbooksItemsUpdateLinks
     * @request POST:/api/purchasing/integrations/quickbooks/items/updateLinks
     */
    integrationsQuickbooksItemsUpdateLinks: (
      apiRequest: MainStemAPIPlatformControllersPurchasingIntegrationQuickBooksItemsUpdateItemLinksAPIRequest,
      params: RequestParams = {}
    ) =>
      this.request<MainStemAPIPlatformControllersPurchasingIntegrationQuickBooksItemsUpdateItemLinksAPIResponse, any>({
        path: `/api/purchasing/integrations/quickbooks/items/updateLinks`,
        method: 'POST',
        body: apiRequest,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags PurchasingReceiveDashboard
     * @name ReceivingDashboard
     * @request POST:/api/purchasing/receiving/dashboard
     */
    receivingDashboard: (params: RequestParams = {}) =>
      this.request<MainStemAPIPlatformControllersPurchasingReceivingDashboardAPIResponse, any>({
        path: `/api/purchasing/receiving/dashboard`,
        method: 'POST',
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags PurchasingReportsAccruals
     * @name ReportsAccruals
     * @request POST:/api/purchasing/reports/accruals
     */
    reportsAccruals: (
      apiRequest: MainStemAPIPlatformControllersPurchasingReportsAccrualsAPIRequest,
      params: RequestParams = {}
    ) =>
      this.request<MainStemAPIPlatformControllersPurchasingReportsAccrualsAPIResponse, any>({
        path: `/api/purchasing/reports/accruals`,
        method: 'POST',
        body: apiRequest,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags PurchasingReportsLineItem
     * @name ReportsLineItems
     * @request POST:/api/purchasing/reports/line-items
     */
    reportsLineItems: (
      apiRequest: MainStemAPIPlatformControllersPurchasingReportsLineItemAPIRequest,
      params: RequestParams = {}
    ) =>
      this.request<MainStemAPIPlatformControllersPurchasingReportsLineItemAPIResponse, any>({
        path: `/api/purchasing/reports/line-items`,
        method: 'POST',
        body: apiRequest,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags PurchasingReportsOpenOrders
     * @name ReportsOpenOrders
     * @request POST:/api/purchasing/reports/open-orders
     */
    reportsOpenOrders: (params: RequestParams = {}) =>
      this.request<MainStemAPIPlatformControllersPurchasingReportsOpenOrdersAPIResponse, any>({
        path: `/api/purchasing/reports/open-orders`,
        method: 'POST',
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags PurchasingReportsOrders
     * @name ReportsOrders
     * @request POST:/api/purchasing/reports/orders
     */
    reportsOrders: (
      apiRequest: MainStemAPIPlatformControllersPurchasingReportsOrdersAPIRequest,
      params: RequestParams = {}
    ) =>
      this.request<MainStemAPIPlatformControllersPurchasingReportsOrdersAPIResponse, any>({
        path: `/api/purchasing/reports/orders`,
        method: 'POST',
        body: apiRequest,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags PurchasingReportsPunchOuts
     * @name ReportsPunchOuts
     * @request POST:/api/purchasing/reports/punch-outs
     */
    reportsPunchOuts: (params: RequestParams = {}) =>
      this.request<MainStemAPIPlatformControllersPurchasingReportsPunchOutsAPIResponse, any>({
        path: `/api/purchasing/reports/punch-outs`,
        method: 'POST',
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags PurchasingRequisitionApproveDetails
     * @name RequisitionApproveDetails
     * @request POST:/api/purchasing/requisition/approve/details
     */
    requisitionApproveDetails: (
      request: MainStemAPIPlatformControllersPurchasingRequisitionApproveDetailsAPIRequest,
      params: RequestParams = {}
    ) =>
      this.request<MainStemAPIPlatformControllersPurchasingRequisitionApproveDetailsAPIResponse, any>({
        path: `/api/purchasing/requisition/approve/details`,
        method: 'POST',
        body: request,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags PurchasingRequisitionApproveSubmit
     * @name RequisitionApproveSubmit
     * @request POST:/api/purchasing/requisition/approve/submit
     */
    requisitionApproveSubmit: (
      apiRequest: MainStemAPIPlatformControllersPurchasingRequisitionApproveSubmitAPIRequest,
      params: RequestParams = {}
    ) =>
      this.request<MainStemAPIPlatformControllersPurchasingRequisitionApproveSubmitAPIResponse, any>({
        path: `/api/purchasing/requisition/approve/submit`,
        method: 'POST',
        body: apiRequest,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags PurchasingRequisitionCopy
     * @name RequisitionCopy
     * @request POST:/api/purchasing/requisition/copy
     */
    requisitionCopy: (
      APIRequest: MainStemAPIPlatformControllersPurchasingRequisitionCopyAPIRequest,
      params: RequestParams = {}
    ) =>
      this.request<MainStemAPIPlatformControllersPurchasingRequisitionCopyAPIResponse, any>({
        path: `/api/purchasing/requisition/copy`,
        method: 'POST',
        body: APIRequest,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags PurchasingRequisitionList
     * @name RequisitionList
     * @request POST:/api/purchasing/requisition/list
     */
    requisitionList: (
      apiRequest: MainStemAPIPlatformControllersPurchasingRequisitionListAPIRequest,
      params: RequestParams = {}
    ) =>
      this.request<MainStemAPIPlatformControllersPurchasingRequisitionListAPIResponse, any>({
        path: `/api/purchasing/requisition/list`,
        method: 'POST',
        body: apiRequest,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags PurchasingRequisitionOpen
     * @name RequisitionOpen
     * @request POST:/api/purchasing/requisition/open
     */
    requisitionOpen: (params: RequestParams = {}) =>
      this.request<MainStemAPIPlatformControllersPurchasingRequisitionOpenAPIResponse, any>({
        path: `/api/purchasing/requisition/open`,
        method: 'POST',
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags PurchasingRequisitionUpdate
     * @name RequisitionUpdate
     * @request POST:/api/purchasing/requisition/update
     */
    requisitionUpdate: (
      APIRequest: MainStemAPIPlatformControllersPurchasingRequisitionUpdateAPIRequest,
      params: RequestParams = {}
    ) =>
      this.request<MainStemAPIPlatformControllersPurchasingRequisitionUpdateAPIResponse, any>({
        path: `/api/purchasing/requisition/update`,
        method: 'POST',
        body: APIRequest,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags PurchasingRFQApprovalApprove
     * @name RfqApprovalsApprove
     * @request POST:/api/purchasing/rfq/approvals/approve
     */
    rfqApprovalsApprove: (
      apiRequest: MainStemAPIPlatformControllersPurchasingRFQApprovalsApproveAPIRequest,
      params: RequestParams = {}
    ) =>
      this.request<MainStemAPIPlatformControllersPurchasingRFQApprovalsApproveAPIResponse, any>({
        path: `/api/purchasing/rfq/approvals/approve`,
        method: 'POST',
        body: apiRequest,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags PurchasingRFQApprovalList
     * @name RfqApprovalsUserList
     * @request POST:/api/purchasing/rfq/approvals/user/list
     */
    rfqApprovalsUserList: (params: RequestParams = {}) =>
      this.request<MainStemAPIPlatformControllersPurchasingRFQApprovalsUserListAPIResponse, any>({
        path: `/api/purchasing/rfq/approvals/user/list`,
        method: 'POST',
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags PurchasingRFQApprovalUserAdd
     * @name RfqApprovalsUserAdd
     * @request POST:/api/purchasing/rfq/approvals/user/add
     */
    rfqApprovalsUserAdd: (
      APIRequest: MainStemAPIPlatformControllersPurchasingRFQApprovalsUserAddAPIRequest,
      params: RequestParams = {}
    ) =>
      this.request<MainStemAPIPlatformControllersPurchasingRFQApprovalsUserAddAPIResponse, any>({
        path: `/api/purchasing/rfq/approvals/user/add`,
        method: 'POST',
        body: APIRequest,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags PurchasingRFQApprovalUserRemove
     * @name RfqApprovalsUserRemove
     * @request POST:/api/purchasing/rfq/approvals/user/remove
     */
    rfqApprovalsUserRemove: (
      APIRequest: MainStemAPIPlatformControllersPurchasingRFQApprovalsUserRemoveAPIRequest,
      params: RequestParams = {}
    ) =>
      this.request<MainStemAPIPlatformControllersPurchasingRFQApprovalsUserRemoveAPIResponse, any>({
        path: `/api/purchasing/rfq/approvals/user/remove`,
        method: 'POST',
        body: APIRequest,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags PurchasingRFQAttachmentDelete
     * @name RfqAttachmentDelete
     * @request POST:/api/purchasing/rfq/attachment/delete
     */
    rfqAttachmentDelete: (
      apiRequest: MainStemAPIPlatformControllersPurchasingRFQAttachmentDeleteAPIRequest,
      params: RequestParams = {}
    ) =>
      this.request<MainStemAPIPlatformControllersPurchasingRFQAttachmentDeleteAPIResponse, any>({
        path: `/api/purchasing/rfq/attachment/delete`,
        method: 'POST',
        body: apiRequest,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags PurchasingRFQAttachmentUpload
     * @name RfqAttachmentUpload
     * @request POST:/api/purchasing/rfq/attachment/upload
     */
    rfqAttachmentUpload: (
      query: {
        /** @format int32 */
        rfqId: number
        description?: string
      },
      params: RequestParams = {}
    ) =>
      this.request<MainStemAPIPlatformControllersPurchasingRFQAttachmentUploadAPIResponse, any>({
        path: `/api/purchasing/rfq/attachment/upload`,
        method: 'POST',
        query: query,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags PurchasingRFQCommentCreate
     * @name RfqCommentCreate
     * @request POST:/api/purchasing/rfq/comment/create
     */
    rfqCommentCreate: (
      apiRequest: MainStemAPIPlatformControllersPurchasingRFQCommentCreateAPIRequest,
      params: RequestParams = {}
    ) =>
      this.request<MainStemAPIPlatformControllersPurchasingRFQCommentCreateAPIResponse, any>({
        path: `/api/purchasing/rfq/comment/create`,
        method: 'POST',
        body: apiRequest,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags PurchasingRFQCommentDelete
     * @name RfqCommentDelete
     * @request POST:/api/purchasing/rfq/comment/delete
     */
    rfqCommentDelete: (
      apiRequest: MainStemAPIPlatformControllersPurchasingRFQCommentDeleteAPIRequest,
      params: RequestParams = {}
    ) =>
      this.request<MainStemAPIPlatformControllersPurchasingRFQCommentDeleteAPIResponse, any>({
        path: `/api/purchasing/rfq/comment/delete`,
        method: 'POST',
        body: apiRequest,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags PurchasingRFQCommentUpdate
     * @name RfqCommentUpdate
     * @request POST:/api/purchasing/rfq/comment/update
     */
    rfqCommentUpdate: (
      apiRequest: MainStemAPIPlatformControllersPurchasingRFQCommentUpdateAPIRequest,
      params: RequestParams = {}
    ) =>
      this.request<MainStemAPIPlatformControllersPurchasingRFQCommentUpdateAPIResponse, any>({
        path: `/api/purchasing/rfq/comment/update`,
        method: 'POST',
        body: apiRequest,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags PurchasingRFQCreate
     * @name RfqCreate
     * @request POST:/api/purchasing/rfq/create
     */
    rfqCreate: (APIRequest: MainStemAPIPlatformControllersPurchasingRFQCreateAPIRequest, params: RequestParams = {}) =>
      this.request<MainStemAPIPlatformControllersPurchasingRFQCreateAPIResponse, any>({
        path: `/api/purchasing/rfq/create`,
        method: 'POST',
        body: APIRequest,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags PurchasingRFQDetails
     * @name RfqDetails
     * @request POST:/api/purchasing/rfq/details
     */
    rfqDetails: (
      APIRequest: MainStemAPIPlatformControllersPurchasingRFQDetailsAPIRequest,
      params: RequestParams = {}
    ) =>
      this.request<MainStemAPIPlatformControllersPurchasingRFQDetailsAPIResponse, any>({
        path: `/api/purchasing/rfq/details`,
        method: 'POST',
        body: APIRequest,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags PurchasingRFQLineItemCreate
     * @name RfqLineItemsCreate
     * @request POST:/api/purchasing/rfq/line-items/create
     */
    rfqLineItemsCreate: (
      apiRequest: MainStemAPIPlatformControllersPurchasingRFQLineItemsCreateAPIRequest,
      params: RequestParams = {}
    ) =>
      this.request<MainStemAPIPlatformControllersPurchasingRFQLineItemsCreateAPIResponse, any>({
        path: `/api/purchasing/rfq/line-items/create`,
        method: 'POST',
        body: apiRequest,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags PurchasingRFQLineItemDelete
     * @name RfqLineItemsDelete
     * @request POST:/api/purchasing/rfq/line-items/delete
     */
    rfqLineItemsDelete: (
      apiRequest: MainStemAPIPlatformControllersPurchasingRFQLineItemsDeleteAPIRequest,
      params: RequestParams = {}
    ) =>
      this.request<MainStemAPIPlatformControllersPurchasingRFQLineItemsDeleteAPIResponse, any>({
        path: `/api/purchasing/rfq/line-items/delete`,
        method: 'POST',
        body: apiRequest,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags PurchasingRFQLineItemsURLCreate
     * @name RfqLineItemsUrlCreate
     * @request POST:/api/purchasing/rfq/line-items/url/create
     */
    rfqLineItemsUrlCreate: (
      apiRequest: MainStemAPIPlatformControllersPurchasingRFQLineItemsURLCreateAPIRequest,
      params: RequestParams = {}
    ) =>
      this.request<MainStemAPIPlatformControllersPurchasingRFQLineItemsURLCreateAPIResponse, any>({
        path: `/api/purchasing/rfq/line-items/url/create`,
        method: 'POST',
        body: apiRequest,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags PurchasingRFQLineItemsURLDelete
     * @name RfqLineItemsUrlDelete
     * @request POST:/api/purchasing/rfq/line-items/url/delete
     */
    rfqLineItemsUrlDelete: (
      apiRequest: MainStemAPIPlatformControllersPurchasingRFQLineItemsURLDeleteAPIRequest,
      params: RequestParams = {}
    ) =>
      this.request<MainStemAPIPlatformControllersPurchasingRFQLineItemsURLDeleteAPIResponse, any>({
        path: `/api/purchasing/rfq/line-items/url/delete`,
        method: 'POST',
        body: apiRequest,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags PurchasingRFQLineItemsURLUpdate
     * @name RfqLineItemsUrlUpdate
     * @request POST:/api/purchasing/rfq/line-items/url/update
     */
    rfqLineItemsUrlUpdate: (
      apiRequest: MainStemAPIPlatformControllersPurchasingRFQLineItemsURLUpdateAPIRequest,
      params: RequestParams = {}
    ) =>
      this.request<MainStemAPIPlatformControllersPurchasingRFQLineItemsURLUpdateAPIResponse, any>({
        path: `/api/purchasing/rfq/line-items/url/update`,
        method: 'POST',
        body: apiRequest,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags PurchasingRFQLineItemUpdate
     * @name RfqLineItemsUpdate
     * @request POST:/api/purchasing/rfq/line-items/update
     */
    rfqLineItemsUpdate: (
      apiRequest: MainStemAPIPlatformControllersPurchasingRFQLineItemsUpdateAPIRequest,
      params: RequestParams = {}
    ) =>
      this.request<MainStemAPIPlatformControllersPurchasingRFQLineItemsUpdateAPIResponse, any>({
        path: `/api/purchasing/rfq/line-items/update`,
        method: 'POST',
        body: apiRequest,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags PurchasingRFQList
     * @name RfqList
     * @request POST:/api/purchasing/rfq/list
     */
    rfqList: (APIRequest: MainStemAPIPlatformControllersPurchasingRFQListAPIRequest, params: RequestParams = {}) =>
      this.request<MainStemAPIPlatformControllersPurchasingRFQListAPIResponse, any>({
        path: `/api/purchasing/rfq/list`,
        method: 'POST',
        body: APIRequest,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags PurchasingRFQSupplierInvite
     * @name RfqSupplierInvite
     * @request POST:/api/purchasing/rfq/supplier/invite
     */
    rfqSupplierInvite: (
      APIRequest: MainStemAPIPlatformControllersPurchasingRFQSupplierInviteAPIRequest,
      params: RequestParams = {}
    ) =>
      this.request<MainStemAPIPlatformControllersPurchasingRFQSupplierInviteAPIResponse, any>({
        path: `/api/purchasing/rfq/supplier/invite`,
        method: 'POST',
        body: APIRequest,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags PurchasingRFQUpdate
     * @name RfqUpdate
     * @request POST:/api/purchasing/rfq/update
     */
    rfqUpdate: (apiRequest: MainStemAPIPlatformControllersPurchasingRFQUpdateAPIRequest, params: RequestParams = {}) =>
      this.request<MainStemAPIPlatformControllersPurchasingRFQUpdateAPIResponse, any>({
        path: `/api/purchasing/rfq/update`,
        method: 'POST',
        body: apiRequest,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags PurchasingRTVCreate
     * @name RtvCreate
     * @request POST:/api/purchasing/rtv/create
     */
    rtvCreate: (apiRequest: MainStemAPIPlatformControllersPurchasingRTVCreateAPIRequest, params: RequestParams = {}) =>
      this.request<MainStemAPIPlatformControllersPurchasingRTVCreateAPIResponse, any>({
        path: `/api/purchasing/rtv/create`,
        method: 'POST',
        body: apiRequest,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags PurchasingRTVDetails
     * @name RtvDetails
     * @request POST:/api/purchasing/rtv/details
     */
    rtvDetails: (
      apiRequest: MainStemAPIPlatformControllersPurchasingRTVDetailsAPIRequest,
      params: RequestParams = {}
    ) =>
      this.request<MainStemAPIPlatformControllersPurchasingRTVDetailsAPIResponse, any>({
        path: `/api/purchasing/rtv/details`,
        method: 'POST',
        body: apiRequest,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags PurchasingRTVFileUpload
     * @name RtvFileUpload
     * @request POST:/api/purchasing/rtv/file/upload
     */
    rtvFileUpload: (
      query: {
        /** @format int32 */
        rtvId: number
      },
      params: RequestParams = {}
    ) =>
      this.request<MainStemAPIPlatformControllersPurchasingRTVFileUploadAPIResponse, any>({
        path: `/api/purchasing/rtv/file/upload`,
        method: 'POST',
        query: query,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags PurchasingRTVList
     * @name RtvList
     * @request POST:/api/purchasing/rtv/list
     */
    rtvList: (params: RequestParams = {}) =>
      this.request<MainStemAPIPlatformControllersPurchasingRTVListAPIResponse, any>({
        path: `/api/purchasing/rtv/list`,
        method: 'POST',
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags PurchasingRTVNoteCreate
     * @name RtvNoteCreate
     * @request POST:/api/purchasing/rtv/note/create
     */
    rtvNoteCreate: (
      apiRequest: MainStemAPIPlatformControllersPurchasingRTVNoteCreateAPIRequest,
      params: RequestParams = {}
    ) =>
      this.request<MainStemAPIPlatformControllersPurchasingRTVNoteCreateAPIResponse, any>({
        path: `/api/purchasing/rtv/note/create`,
        method: 'POST',
        body: apiRequest,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags PurchasingRTVOrderInfo
     * @name RtvOrderInfo
     * @request POST:/api/purchasing/rtv/order-info
     */
    rtvOrderInfo: (
      apiRequest: MainStemAPIPlatformControllersPurchasingRTVOrderInfoAPIRequest,
      params: RequestParams = {}
    ) =>
      this.request<MainStemAPIPlatformControllersPurchasingRTVOrderInfoAPIResponse, any>({
        path: `/api/purchasing/rtv/order-info`,
        method: 'POST',
        body: apiRequest,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags PurchasingSearch
     * @name Search
     * @request GET:/api/purchasing/search
     */
    search: (
      query?: {
        apiRequestQuery?: string
      },
      params: RequestParams = {}
    ) =>
      this.request<MainStemAPIPlatformControllersPurchasingSearchAPIResponse, any>({
        path: `/api/purchasing/search`,
        method: 'GET',
        query: query,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags PurchasingShipmentsDetails
     * @name ShipmentsDetails
     * @request POST:/api/purchasing/shipments/details
     */
    shipmentsDetails: (
      APIRequest: MainStemAPIPlatformControllersPurchasingShipmentsDetailsAPIRequest,
      params: RequestParams = {}
    ) =>
      this.request<MainStemAPIPlatformControllersPurchasingShipmentsDetailsAPIResponse, any>({
        path: `/api/purchasing/shipments/details`,
        method: 'POST',
        body: APIRequest,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags PurchasingShipmentsList
     * @name ShipmentsList
     * @request GET:/api/purchasing/shipments/list
     */
    shipmentsList: (params: RequestParams = {}) =>
      this.request<MainStemAPIPlatformControllersPurchasingShipmentsListAPIResponse, any>({
        path: `/api/purchasing/shipments/list`,
        method: 'GET',
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags PurchasingShopCatalogList
     * @name ShopCatalogList
     * @request POST:/api/purchasing/shop/catalog/list
     */
    shopCatalogList: (params: RequestParams = {}) =>
      this.request<MainStemAPIPlatformControllersPurchasingShopCatalogListAPIResponse, any>({
        path: `/api/purchasing/shop/catalog/list`,
        method: 'POST',
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags PurchasingShopMarketplaceAmazonSearch
     * @name ShopMarketplaceAmazonSearch
     * @request POST:/api/purchasing/shop/marketplace/amazon/search
     */
    shopMarketplaceAmazonSearch: (
      APIRequest: MainStemAPIPlatformControllersPurchasingShopMarketplaceAmazonSearchAPIRequest,
      params: RequestParams = {}
    ) =>
      this.request<MainStemAPIPlatformControllersPurchasingShopMarketplaceAmazonSearchAPIResponse, any>({
        path: `/api/purchasing/shop/marketplace/amazon/search`,
        method: 'POST',
        body: APIRequest,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags PurchasingShopMarketplaceApexTradingConnections
     * @name ShopMarketplaceApexTradingConnections
     * @request POST:/api/purchasing/shop/marketplace/apex-trading/connections
     */
    shopMarketplaceApexTradingConnections: (
      APIRequest: MainStemAPIPlatformControllersPurchasingShopMarketplaceApexTradingConnectionsAPIRequest,
      params: RequestParams = {}
    ) =>
      this.request<MainStemAPIPlatformControllersPurchasingShopMarketplaceApexTradingConnectionsAPIResponse, any>({
        path: `/api/purchasing/shop/marketplace/apex-trading/connections`,
        method: 'POST',
        body: APIRequest,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags PurchasingShopMarketplaceApexTradingDetails
     * @name ShopMarketplaceApexTradingDetails
     * @request POST:/api/purchasing/shop/marketplace/apex-trading/details
     */
    shopMarketplaceApexTradingDetails: (
      APIRequest: MainStemAPIPlatformControllersPurchasingShopMarketplaceApexTradingDetailsAPIRequest,
      params: RequestParams = {}
    ) =>
      this.request<MainStemAPIPlatformControllersPurchasingShopMarketplaceApexTradingDetailsAPIResponse, any>({
        path: `/api/purchasing/shop/marketplace/apex-trading/details`,
        method: 'POST',
        body: APIRequest,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags PurchasingShopMarketplaceApexTradingSearch
     * @name ShopMarketplaceApexTradingSearch
     * @request POST:/api/purchasing/shop/marketplace/apex-trading/search
     */
    shopMarketplaceApexTradingSearch: (
      APIRequest: MainStemAPIPlatformControllersPurchasingShopMarketplaceApexTradingSearchAPIRequest,
      params: RequestParams = {}
    ) =>
      this.request<MainStemAPIPlatformControllersPurchasingShopMarketplaceApexTradingSearchAPIResponse, any>({
        path: `/api/purchasing/shop/marketplace/apex-trading/search`,
        method: 'POST',
        body: APIRequest,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags PurchasingShopMarketplaceCannabisExpertsDetails
     * @name ShopMarketplaceCannabisExpertsDetails
     * @request POST:/api/purchasing/shop/marketplace/cannabis-experts/details
     */
    shopMarketplaceCannabisExpertsDetails: (
      apiRequest: MainStemAPIPlatformControllersPurchasingShopMarketplaceCannabisExpertsDetailsAPIRequest,
      params: RequestParams = {}
    ) =>
      this.request<MainStemAPIPlatformControllersPurchasingShopMarketplaceCannabisExpertsDetailsAPIResponse, any>({
        path: `/api/purchasing/shop/marketplace/cannabis-experts/details`,
        method: 'POST',
        body: apiRequest,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags PurchasingShopMarketplaceCannabisExpertsRFICreate
     * @name ShopMarketplaceCannabisExpertsRfiCreate
     * @request POST:/api/purchasing/shop/marketplace/cannabis-experts/rfi/create
     */
    shopMarketplaceCannabisExpertsRfiCreate: (
      apiRequest: MainStemAPIPlatformControllersPurchasingShopMarketplaceCannabisExpertsRFICreateAPIRequest,
      params: RequestParams = {}
    ) =>
      this.request<MainStemAPIPlatformControllersPurchasingShopMarketplaceCannabisExpertsRFICreateAPIResponse, any>({
        path: `/api/purchasing/shop/marketplace/cannabis-experts/rfi/create`,
        method: 'POST',
        body: apiRequest,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags PurchasingShopMarketplaceCannabisExpertsSearch
     * @name ShopMarketplaceCannabisExpertsSearch
     * @request POST:/api/purchasing/shop/marketplace/cannabis-experts/search
     */
    shopMarketplaceCannabisExpertsSearch: (
      apiRequest: MainStemAPIPlatformControllersPurchasingShopMarketplaceCannabisExpertsSearchAPIRequest,
      params: RequestParams = {}
    ) =>
      this.request<MainStemAPIPlatformControllersPurchasingShopMarketplaceCannabisExpertsSearchAPIResponse, any>({
        path: `/api/purchasing/shop/marketplace/cannabis-experts/search`,
        method: 'POST',
        body: apiRequest,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags PurchasingShopMarketplaceGiftCardsDetails
     * @name ShopMarketplaceGiftCardsDetails
     * @request POST:/api/purchasing/shop/marketplace/gift-cards/details
     */
    shopMarketplaceGiftCardsDetails: (
      APIRequest: MainStemAPIPlatformControllersPurchasingShopMarketplaceGiftCardsDetailsAPIRequest,
      params: RequestParams = {}
    ) =>
      this.request<MainStemAPIPlatformControllersPurchasingShopMarketplaceGiftCardsDetailsAPIResponse, any>({
        path: `/api/purchasing/shop/marketplace/gift-cards/details`,
        method: 'POST',
        body: APIRequest,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags PurchasingShopMarketplaceGiftCardsSearch
     * @name ShopMarketplaceGiftCardsSearch
     * @request POST:/api/purchasing/shop/marketplace/gift-cards/search
     */
    shopMarketplaceGiftCardsSearch: (
      APIRequest: MainStemAPIPlatformControllersPurchasingShopMarketplaceGiftCardsSearchAPIRequest,
      params: RequestParams = {}
    ) =>
      this.request<MainStemAPIPlatformControllersPurchasingShopMarketplaceGiftCardsSearchAPIResponse, any>({
        path: `/api/purchasing/shop/marketplace/gift-cards/search`,
        method: 'POST',
        body: APIRequest,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags PurchasingShopMarketplaceMainStemSearch
     * @name ShopMarketplaceMainstemSearch
     * @request POST:/api/purchasing/shop/marketplace/mainstem/search
     */
    shopMarketplaceMainstemSearch: (
      APIRequest: MainStemAPIPlatformControllersPurchasingShopMarketplaceMainStemSearchAPIRequest,
      params: RequestParams = {}
    ) =>
      this.request<MainStemAPIPlatformControllersPurchasingShopMarketplaceMainStemSearchAPIResponse, any>({
        path: `/api/purchasing/shop/marketplace/mainstem/search`,
        method: 'POST',
        body: APIRequest,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags PurchasingShopMarketplaceStaplesSearch
     * @name ShopMarketplaceStaplesSearch
     * @request POST:/api/purchasing/shop/marketplace/staples/search
     */
    shopMarketplaceStaplesSearch: (
      APIRequest: MainStemAPIPlatformControllersPurchasingShopMarketplaceStaplesSearchAPIRequest,
      params: RequestParams = {}
    ) =>
      this.request<MainStemAPIPlatformControllersPurchasingShopMarketplaceStaplesSearchAPIResponse, any>({
        path: `/api/purchasing/shop/marketplace/staples/search`,
        method: 'POST',
        body: APIRequest,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags PurchasingShopProductDetails
     * @name ShopProductDetails
     * @request POST:/api/purchasing/shop/product/details
     */
    shopProductDetails: (
      APIRequest: MainStemAPIPlatformControllersPurchasingShopProductDetailsAPIRequest,
      params: RequestParams = {}
    ) =>
      this.request<MainStemAPIPlatformControllersPurchasingShopProductDetailsAPIResponse, any>({
        path: `/api/purchasing/shop/product/details`,
        method: 'POST',
        body: APIRequest,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags PurchasingSuppliersDetails
     * @name SuppliersDetails
     * @request POST:/api/purchasing/suppliers/details
     */
    suppliersDetails: (
      APIRequest: MainStemAPIPlatformControllersPurchasingSuppliersDetailsAPIRequest,
      params: RequestParams = {}
    ) =>
      this.request<MainStemAPIPlatformControllersPurchasingSuppliersDetailsAPIResponse, any>({
        path: `/api/purchasing/suppliers/details`,
        method: 'POST',
        body: APIRequest,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags PurchasingSuppliersDetailsCatalogs
     * @name SuppliersDetailsCatalogs
     * @request POST:/api/purchasing/suppliers/details/catalogs
     */
    suppliersDetailsCatalogs: (
      apiRequest: MainStemAPIPlatformControllersPurchasingSuppliersDetailsCatalogsAPIRequest,
      params: RequestParams = {}
    ) =>
      this.request<MainStemAPIPlatformControllersPurchasingSuppliersDetailsCatalogsAPIResponse, any>({
        path: `/api/purchasing/suppliers/details/catalogs`,
        method: 'POST',
        body: apiRequest,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags PurchasingSuppliersDetailsOrders
     * @name SuppliersDetailsOrders
     * @request POST:/api/purchasing/suppliers/details/orders
     */
    suppliersDetailsOrders: (
      apiRequest: MainStemAPIPlatformControllersPurchasingSuppliersDetailsOrdersAPIRequest,
      params: RequestParams = {}
    ) =>
      this.request<MainStemAPIPlatformControllersPurchasingSuppliersDetailsOrdersAPIResponse, any>({
        path: `/api/purchasing/suppliers/details/orders`,
        method: 'POST',
        body: apiRequest,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags PurchasingSuppliersDetailsProducts
     * @name SuppliersDetailsProducts
     * @request POST:/api/purchasing/suppliers/details/products
     */
    suppliersDetailsProducts: (
      apiRequest: MainStemAPIPlatformControllersPurchasingSuppliersDetailsProductsAPIRequest,
      params: RequestParams = {}
    ) =>
      this.request<MainStemAPIPlatformControllersPurchasingSuppliersDetailsProductsAPIResponse, any>({
        path: `/api/purchasing/suppliers/details/products`,
        method: 'POST',
        body: apiRequest,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags PurchasingSuppliersDetailsProductsYouMayLike
     * @name VendorsDetailsProductsYouMayLike
     * @request GET:/api/purchasing/vendors/details/productsYouMayLike
     */
    vendorsDetailsProductsYouMayLike: (
      query?: {
        /** @format int32 */
        apiRequestVendorId?: number
      },
      params: RequestParams = {}
    ) =>
      this.request<MainStemAPIPlatformControllersPurchasingSuppliersDetailsProductsYouMayLikeAPIResponse, any>({
        path: `/api/purchasing/vendors/details/productsYouMayLike`,
        method: 'GET',
        query: query,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags PurchasingSuppliersDetailsShipments
     * @name SuppliersDetailsShipments
     * @request POST:/api/purchasing/suppliers/details/shipments
     */
    suppliersDetailsShipments: (
      APIRequest: MainStemAPIPlatformControllersPurchasingSuppliersDetailsShipmentsAPIRequest,
      params: RequestParams = {}
    ) =>
      this.request<MainStemAPIPlatformControllersPurchasingSuppliersDetailsShipmentsAPIResponse, any>({
        path: `/api/purchasing/suppliers/details/shipments`,
        method: 'POST',
        body: APIRequest,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags PurchasingSuppliersList
     * @name SuppliersList
     * @request POST:/api/purchasing/suppliers/list
     */
    suppliersList: (
      APIRequest: MainStemAPIPlatformControllersPurchasingSuppliersListAPIRequest,
      params: RequestParams = {}
    ) =>
      this.request<MainStemAPIPlatformControllersPurchasingSuppliersListAPIResponse, any>({
        path: `/api/purchasing/suppliers/list`,
        method: 'POST',
        body: APIRequest,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags PurchasingThreeWayMatchCreate
     * @name ThreeWayMatchCreate
     * @request POST:/api/purchasing/three-way-match/create
     */
    threeWayMatchCreate: (
      apiRequest: MainStemAPIPlatformControllersPurchasingThreeWayMatchesCreateAPIRequest,
      params: RequestParams = {}
    ) =>
      this.request<MainStemAPIPlatformControllersPurchasingThreeWayMatchesCreateAPIResponse, any>({
        path: `/api/purchasing/three-way-match/create`,
        method: 'POST',
        body: apiRequest,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags PurchasingThreeWayMatchDetails
     * @name ThreeWayMatchDetails
     * @request POST:/api/purchasing/three-way-match/details
     */
    threeWayMatchDetails: (
      apiRequest: MainStemAPIPlatformControllersPurchasingThreeWayMatchesDetailsAPIRequest,
      params: RequestParams = {}
    ) =>
      this.request<MainStemAPIPlatformControllersPurchasingThreeWayMatchesDetailsAPIResponse, any>({
        path: `/api/purchasing/three-way-match/details`,
        method: 'POST',
        body: apiRequest,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags PurchasingThreeWayMatchRecheck
     * @name ThreeWayMatchRecheck
     * @request POST:/api/purchasing/three-way-match/recheck
     */
    threeWayMatchRecheck: (
      apiRequest: MainStemAPIPlatformControllersPurchasingThreeWayMatchesRecheckAPIRequest,
      params: RequestParams = {}
    ) =>
      this.request<MainStemAPIPlatformControllersPurchasingThreeWayMatchesRecheckAPIResponse, any>({
        path: `/api/purchasing/three-way-match/recheck`,
        method: 'POST',
        body: apiRequest,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags PurchasingUserPermissionCreate
     * @name UserPermissionCreate
     * @request POST:/api/purchasing/userPermission/create
     */
    userPermissionCreate: (
      apiRequest: MainStemAPIPlatformControllersPurchasingUserPermissionsCreateAPIRequest,
      params: RequestParams = {}
    ) =>
      this.request<MainStemAPIPlatformControllersPurchasingUserPermissionsCreateAPIResponse, any>({
        path: `/api/purchasing/userPermission/create`,
        method: 'POST',
        body: apiRequest,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags PurchasingUserPermissionDelete
     * @name UserPermissionDelete
     * @request POST:/api/purchasing/userPermission/delete
     */
    userPermissionDelete: (
      apiRequest: MainStemAPIPlatformControllersPurchasingUserPermissionsDeleteAPIRequest,
      params: RequestParams = {}
    ) =>
      this.request<MainStemSDKModelsBaseResponse, any>({
        path: `/api/purchasing/userPermission/delete`,
        method: 'POST',
        body: apiRequest,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags PurchasingUserPermissionUpdate
     * @name UserPermissionUpdate
     * @request POST:/api/purchasing/userPermission/update
     */
    userPermissionUpdate: (
      apiRequest: MainStemAPIPlatformControllersPurchasingUserPermissionsUpdateAPIRequest,
      params: RequestParams = {}
    ) =>
      this.request<MainStemAPIPlatformControllersPurchasingUserPermissionsUpdateAPIResponse, any>({
        path: `/api/purchasing/userPermission/update`,
        method: 'POST',
        body: apiRequest,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags PurchasingUsersCatalogsList
     * @name UsersCatalogsList
     * @request POST:/api/purchasing/users/catalogs/list
     */
    usersCatalogsList: (
      APIRequest: MainStemAPIPlatformControllersPurchasingUsersCatalogsListAPIRequest,
      params: RequestParams = {}
    ) =>
      this.request<MainStemAPIPlatformControllersPurchasingUsersCatalogsListAPIResponse, any>({
        path: `/api/purchasing/users/catalogs/list`,
        method: 'POST',
        body: APIRequest,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags PurchasingUsersCreate
     * @name UsersCreate
     * @request POST:/api/purchasing/users/create
     */
    usersCreate: (
      apiRequest: MainStemAPIPlatformControllersPurchasingUsersCreateAPIRequest,
      params: RequestParams = {}
    ) =>
      this.request<MainStemAPIPlatformControllersPurchasingUsersCreateAPIResponse, any>({
        path: `/api/purchasing/users/create`,
        method: 'POST',
        body: apiRequest,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags PurchasingUsersDelete
     * @name UsersDelete
     * @request POST:/api/purchasing/users/delete
     */
    usersDelete: (
      apiRequest: MainStemAPIPlatformControllersPurchasingUsersDeleteAPIRequest,
      params: RequestParams = {}
    ) =>
      this.request<MainStemAPIPlatformControllersPurchasingUsersDeleteAPIResponse, any>({
        path: `/api/purchasing/users/delete`,
        method: 'POST',
        body: apiRequest,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags PurchasingUsersDetails
     * @name UsersDetails
     * @request POST:/api/purchasing/users/details
     */
    usersDetails: (
      APIRequest: MainStemAPIPlatformControllersPurchasingUsersDetailsAPIRequest,
      params: RequestParams = {}
    ) =>
      this.request<MainStemAPIPlatformControllersPurchasingUsersDetailsAPIResponse, any>({
        path: `/api/purchasing/users/details`,
        method: 'POST',
        body: APIRequest,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags PurchasingUsersDetailsOrders
     * @name UsersDetailsOrders
     * @request POST:/api/purchasing/users/details/orders
     */
    usersDetailsOrders: (
      query?: {
        apiRequestUuid?: string
      },
      params: RequestParams = {}
    ) =>
      this.request<MainStemAPIPlatformControllersPurchasingUsersDetailsOrdersAPIResponse, any>({
        path: `/api/purchasing/users/details/orders`,
        method: 'POST',
        query: query,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags PurchasingUsersDetailsProducts
     * @name UsersDetailsProducts
     * @request POST:/api/purchasing/users/details/products
     */
    usersDetailsProducts: (
      apiRequest: MainStemAPIPlatformControllersPurchasingUsersDetailsProductsAPIRequest,
      params: RequestParams = {}
    ) =>
      this.request<MainStemAPIPlatformControllersPurchasingUsersDetailsProductsAPIResponse, any>({
        path: `/api/purchasing/users/details/products`,
        method: 'POST',
        body: apiRequest,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags PurchasingUsersDetailsResetPassword
     * @name UsersDetailsResetPassword
     * @request POST:/api/purchasing/users/details/reset-password
     */
    usersDetailsResetPassword: (
      apiRequest: MainStemAPIPlatformControllersPurchasingUsersDetailsResetPasswordAPIRequest,
      params: RequestParams = {}
    ) =>
      this.request<MainStemAPIPlatformControllersPurchasingUsersDetailsResetPasswordAPIResponse, any>({
        path: `/api/purchasing/users/details/reset-password`,
        method: 'POST',
        body: apiRequest,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags PurchasingUsersDetailsVendors
     * @name UsersDetailsVendors
     * @request POST:/api/purchasing/users/details/vendors
     */
    usersDetailsVendors: (
      apiRequest: MainStemAPIPlatformControllersPurchasingUsersDetailsVendorsAPIRequest,
      params: RequestParams = {}
    ) =>
      this.request<MainStemAPIPlatformControllersPurchasingUsersDetailsVendorsAPIResponse, any>({
        path: `/api/purchasing/users/details/vendors`,
        method: 'POST',
        body: apiRequest,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags PurchasingUsersDuplicate
     * @name UsersDuplicate
     * @request POST:/api/purchasing/users/duplicate
     */
    usersDuplicate: (
      apiRequest: MainStemAPIPlatformControllersPurchasingUsersDuplicateAPIRequest,
      params: RequestParams = {}
    ) =>
      this.request<MainStemAPIPlatformControllersPurchasingUsersDuplicateAPIResponse, any>({
        path: `/api/purchasing/users/duplicate`,
        method: 'POST',
        body: apiRequest,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags PurchasingUsersList
     * @name UsersList
     * @request POST:/api/purchasing/users/list
     */
    usersList: (params: RequestParams = {}) =>
      this.request<MainStemAPIPlatformControllersPurchasingUsersListAPIResponse, any>({
        path: `/api/purchasing/users/list`,
        method: 'POST',
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags PurchasingUsersLocationsAdd
     * @name UsersLocationsAdd
     * @request POST:/api/purchasing/users/locations/add
     */
    usersLocationsAdd: (
      apiRequest: MainStemAPIPlatformControllersPurchasingUsersLocationsAddAPIRequest,
      params: RequestParams = {}
    ) =>
      this.request<MainStemAPIPlatformControllersPurchasingUsersLocationsAddAPIResponse, any>({
        path: `/api/purchasing/users/locations/add`,
        method: 'POST',
        body: apiRequest,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags PurchasingUsersLocationsRemove
     * @name UsersLocationsRemove
     * @request POST:/api/purchasing/users/locations/remove
     */
    usersLocationsRemove: (
      apiRequest: MainStemAPIPlatformControllersPurchasingUsersLocationsRemoveAPIRequest,
      params: RequestParams = {}
    ) =>
      this.request<MainStemSDKModelsBaseResponse, any>({
        path: `/api/purchasing/users/locations/remove`,
        method: 'POST',
        body: apiRequest,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags PurchasingUsersLocationsSetDefault
     * @name UsersLocationsSetDefault
     * @request POST:/api/purchasing/users/locations/set-default
     */
    usersLocationsSetDefault: (
      apiRequest: MainStemAPIPlatformControllersPurchasingUsersLocationsSetDefaultAPIRequest,
      params: RequestParams = {}
    ) =>
      this.request<MainStemSDKModelsBaseResponse, any>({
        path: `/api/purchasing/users/locations/set-default`,
        method: 'POST',
        body: apiRequest,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags PurchasingUsersUpdate
     * @name UsersUpdate
     * @request POST:/api/purchasing/users/update
     */
    usersUpdate: (
      apiRequest: MainStemAPIPlatformControllersPurchasingUsersUpdateAPIRequest,
      params: RequestParams = {}
    ) =>
      this.request<MainStemAPIPlatformControllersPurchasingUsersUpdateAPIResponse, any>({
        path: `/api/purchasing/users/update`,
        method: 'POST',
        body: apiRequest,
        type: ContentType.Json,
        format: 'json',
        ...params
      })
  }
}

export const MainStemApi = new Api()
